
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire32f6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire32f6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lNdKa", function(module, exports) {

var $fNJVo = parcelRequire("fNJVo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $fNJVo.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});
parcelRegister("fNJVo", function(module, exports) {

var $akAE7 = parcelRequire("akAE7");
/** Detect free variable `self`. */ var $b80f0e48878b795f$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b80f0e48878b795f$var$root = $akAE7 || $b80f0e48878b795f$var$freeSelf || Function("return this")();
module.exports = $b80f0e48878b795f$var$root;

});
parcelRegister("akAE7", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $785832ceab6d3c01$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $785832ceab6d3c01$var$freeGlobal;

});



parcelRegister("2W9As", function(module, exports) {

var $fNJVo = parcelRequire("fNJVo");

var $36p3q = parcelRequire("36p3q");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $fNJVo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $36p3q;
module.exports = isBuffer;

});
parcelRegister("36p3q", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $24255dde8fe21de3$var$stubFalse() {
    return false;
}
module.exports = $24255dde8fe21de3$var$stubFalse;

});


parcelRegister("74qZ6", function(module, exports) {

var $akAE7 = parcelRequire("akAE7");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $akAE7.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("lQT0x", function(module, exports) {



/**
  A javascript Bezier curve library by Pomax.

  Based on http://pomax.github.io/bezierinfo

  This code is MIT licensed.
**/ (function() {
    "use strict";
    // math-inlining.
    var abs = Math.abs, min = Math.min, max = Math.max, cos = Math.cos, sin = Math.sin, acos = Math.acos, sqrt = Math.sqrt, pi = Math.PI, // a zero coordinate, which is surprisingly useful
    ZERO = {
        x: 0,
        y: 0,
        z: 0
    };
    // quite needed
    var utils = (parcelRequire("asPPo"));
    // only used for outlines atm.
    var PolyBezier = (parcelRequire("9L27D"));
    /**
   * Bezier curve constructor. The constructor argument can be one of three things:
   *
   * 1. array/4 of {x:..., y:..., z:...}, z optional
   * 2. numerical array/8 ordered x1,y1,x2,y2,x3,y3,x4,y4
   * 3. numerical array/12 ordered x1,y1,z1,x2,y2,z2,x3,y3,z3,x4,y4,z4
   *
   */ var Bezier = function(coords) {
        var args = coords && coords.forEach ? coords : [].slice.call(arguments);
        var coordlen = false;
        if (typeof args[0] === "object") {
            coordlen = args.length;
            var newargs = [];
            args.forEach(function(point) {
                [
                    "x",
                    "y",
                    "z"
                ].forEach(function(d) {
                    if (typeof point[d] !== "undefined") newargs.push(point[d]);
                });
            });
            args = newargs;
        }
        var higher = false;
        var len = args.length;
        if (coordlen) {
            if (coordlen > 4) {
                if (arguments.length !== 1) throw new Error("Only new Bezier(point[]) is accepted for 4th and higher order curves");
                higher = true;
            }
        } else if (len !== 6 && len !== 8 && len !== 9 && len !== 12) {
            if (arguments.length !== 1) throw new Error("Only new Bezier(point[]) is accepted for 4th and higher order curves");
        }
        var _3d = !higher && (len === 9 || len === 12) || coords && coords[0] && typeof coords[0].z !== "undefined";
        this._3d = _3d;
        var points = [];
        for(var idx = 0, step = _3d ? 3 : 2; idx < len; idx += step){
            var point = {
                x: args[idx],
                y: args[idx + 1]
            };
            if (_3d) point.z = args[idx + 2];
            points.push(point);
        }
        this.order = points.length - 1;
        this.points = points;
        var dims = [
            "x",
            "y"
        ];
        if (_3d) dims.push("z");
        this.dims = dims;
        this.dimlen = dims.length;
        (function(curve) {
            var order = curve.order;
            var points = curve.points;
            var a = utils.align(points, {
                p1: points[0],
                p2: points[order]
            });
            for(var i = 0; i < a.length; i++)if (abs(a[i].y) > 0.0001) {
                curve._linear = false;
                return;
            }
            curve._linear = true;
        })(this);
        this._t1 = 0;
        this._t2 = 1;
        this.update();
    };
    var svgToBeziers = (parcelRequire("71caD"));
    /**
   * turn an svg <path> d attribute into a sequence of Bezier segments.
   */ Bezier.SVGtoBeziers = function(d) {
        return svgToBeziers(Bezier, d);
    };
    function getABC(n, S, B, E, t) {
        if (typeof t === "undefined") t = 0.5;
        var u = utils.projectionratio(t, n), um = 1 - u, C = {
            x: u * S.x + um * E.x,
            y: u * S.y + um * E.y
        }, s = utils.abcratio(t, n), A = {
            x: B.x + (B.x - C.x) / s,
            y: B.y + (B.y - C.y) / s
        };
        return {
            A: A,
            B: B,
            C: C
        };
    }
    Bezier.quadraticFromPoints = function(p1, p2, p3, t) {
        if (typeof t === "undefined") t = 0.5;
        // shortcuts, although they're really dumb
        if (t === 0) return new Bezier(p2, p2, p3);
        if (t === 1) return new Bezier(p1, p2, p2);
        // real fitting.
        var abc = getABC(2, p1, p2, p3, t);
        return new Bezier(p1, abc.A, p3);
    };
    Bezier.cubicFromPoints = function(S, B, E, t, d1) {
        if (typeof t === "undefined") t = 0.5;
        var abc = getABC(3, S, B, E, t);
        if (typeof d1 === "undefined") d1 = utils.dist(B, abc.C);
        var d2 = d1 * (1 - t) / t;
        var selen = utils.dist(S, E), lx = (E.x - S.x) / selen, ly = (E.y - S.y) / selen, bx1 = d1 * lx, by1 = d1 * ly, bx2 = d2 * lx, by2 = d2 * ly;
        // derivation of new hull coordinates
        var e1 = {
            x: B.x - bx1,
            y: B.y - by1
        }, e2 = {
            x: B.x + bx2,
            y: B.y + by2
        }, A = abc.A, v1 = {
            x: A.x + (e1.x - A.x) / (1 - t),
            y: A.y + (e1.y - A.y) / (1 - t)
        }, v2 = {
            x: A.x + (e2.x - A.x) / t,
            y: A.y + (e2.y - A.y) / t
        }, nc1 = {
            x: S.x + (v1.x - S.x) / t,
            y: S.y + (v1.y - S.y) / t
        }, nc2 = {
            x: E.x + (v2.x - E.x) / (1 - t),
            y: E.y + (v2.y - E.y) / (1 - t)
        };
        // ...done
        return new Bezier(S, nc1, nc2, E);
    };
    var getUtils = function() {
        return utils;
    };
    Bezier.getUtils = getUtils;
    Bezier.PolyBezier = PolyBezier;
    Bezier.prototype = {
        getUtils: getUtils,
        valueOf: function() {
            return this.toString();
        },
        toString: function() {
            return utils.pointsToString(this.points);
        },
        toSVG: function(relative) {
            if (this._3d) return false;
            var p = this.points, x = p[0].x, y = p[0].y, s = [
                "M",
                x,
                y,
                this.order === 2 ? "Q" : "C"
            ];
            for(var i = 1, last = p.length; i < last; i++){
                s.push(p[i].x);
                s.push(p[i].y);
            }
            return s.join(" ");
        },
        setRatios: function(ratios) {
            if (ratios.length !== this.points.length) throw new Error("incorrect number of ratio values");
            this.ratios = ratios;
            this._lut = []; //  invalidate any precomputed LUT
        },
        verify: function() {
            var print = this.coordDigest();
            if (print !== this._print) {
                this._print = print;
                this.update();
            }
        },
        coordDigest: function() {
            return this.points.map(function(c, pos) {
                return "" + pos + c.x + c.y + (c.z ? c.z : 0);
            }).join("");
        },
        update: function(newprint) {
            // invalidate any precomputed LUT
            this._lut = [];
            this.dpoints = utils.derive(this.points, this._3d);
            this.computedirection();
        },
        computedirection: function() {
            var points = this.points;
            var angle = utils.angle(points[0], points[this.order], points[1]);
            this.clockwise = angle > 0;
        },
        length: function() {
            return utils.length(this.derivative.bind(this));
        },
        _lut: [],
        getLUT: function(steps) {
            this.verify();
            steps = steps || 100;
            if (this._lut.length === steps) return this._lut;
            this._lut = [];
            // We want a range from 0 to 1 inclusive, so
            // we decrement and then use <= rather than <:
            steps--;
            for(var t = 0; t <= steps; t++)this._lut.push(this.compute(t / steps));
            return this._lut;
        },
        on: function(point, error) {
            error = error || 5;
            var lut = this.getLUT(), hits = [], c, t = 0;
            for(var i = 0; i < lut.length; i++){
                c = lut[i];
                if (utils.dist(c, point) < error) {
                    hits.push(c);
                    t += i / lut.length;
                }
            }
            if (!hits.length) return false;
            return t /= hits.length;
        },
        project: function(point) {
            // step 1: coarse check
            var LUT = this.getLUT(), l = LUT.length - 1, closest = utils.closest(LUT, point), mdist = closest.mdist, mpos = closest.mpos;
            // step 2: fine check
            var ft, t, p, d, t1 = (mpos - 1) / l, t2 = (mpos + 1) / l, step = 0.1 / l;
            mdist += 1;
            for(t = t1, ft = t; t < t2 + step; t += step){
                p = this.compute(t);
                d = utils.dist(point, p);
                if (d < mdist) {
                    mdist = d;
                    ft = t;
                }
            }
            p = this.compute(ft);
            p.t = ft;
            p.d = mdist;
            return p;
        },
        get: function(t) {
            return this.compute(t);
        },
        point: function(idx) {
            return this.points[idx];
        },
        compute: function(t) {
            if (this.ratios) return utils.computeWithRatios(t, this.points, this.ratios, this._3d);
            return utils.compute(t, this.points, this._3d, this.ratios);
        },
        raise: function() {
            var p = this.points, np = [
                p[0]
            ], i, k = p.length, pi, pim;
            for(var i = 1; i < k; i++){
                pi = p[i];
                pim = p[i - 1];
                np[i] = {
                    x: (k - i) / k * pi.x + i / k * pim.x,
                    y: (k - i) / k * pi.y + i / k * pim.y
                };
            }
            np[k] = p[k - 1];
            return new Bezier(np);
        },
        derivative: function(t) {
            var mt = 1 - t, a, b, c = 0, p = this.dpoints[0];
            if (this.order === 2) {
                p = [
                    p[0],
                    p[1],
                    ZERO
                ];
                a = mt;
                b = t;
            }
            if (this.order === 3) {
                a = mt * mt;
                b = mt * t * 2;
                c = t * t;
            }
            var ret = {
                x: a * p[0].x + b * p[1].x + c * p[2].x,
                y: a * p[0].y + b * p[1].y + c * p[2].y
            };
            if (this._3d) ret.z = a * p[0].z + b * p[1].z + c * p[2].z;
            return ret;
        },
        curvature: function(t) {
            return utils.curvature(t, this.points, this._3d);
        },
        inflections: function() {
            return utils.inflections(this.points);
        },
        normal: function(t) {
            return this._3d ? this.__normal3(t) : this.__normal2(t);
        },
        __normal2: function(t) {
            var d = this.derivative(t);
            var q = sqrt(d.x * d.x + d.y * d.y);
            return {
                x: -d.y / q,
                y: d.x / q
            };
        },
        __normal3: function(t) {
            // see http://stackoverflow.com/questions/25453159
            var r1 = this.derivative(t), r2 = this.derivative(t + 0.01), q1 = sqrt(r1.x * r1.x + r1.y * r1.y + r1.z * r1.z), q2 = sqrt(r2.x * r2.x + r2.y * r2.y + r2.z * r2.z);
            r1.x /= q1;
            r1.y /= q1;
            r1.z /= q1;
            r2.x /= q2;
            r2.y /= q2;
            r2.z /= q2;
            // cross product
            var c = {
                x: r2.y * r1.z - r2.z * r1.y,
                y: r2.z * r1.x - r2.x * r1.z,
                z: r2.x * r1.y - r2.y * r1.x
            };
            var m = sqrt(c.x * c.x + c.y * c.y + c.z * c.z);
            c.x /= m;
            c.y /= m;
            c.z /= m;
            // rotation matrix
            var R = [
                c.x * c.x,
                c.x * c.y - c.z,
                c.x * c.z + c.y,
                c.x * c.y + c.z,
                c.y * c.y,
                c.y * c.z - c.x,
                c.x * c.z - c.y,
                c.y * c.z + c.x,
                c.z * c.z
            ];
            // normal vector:
            var n = {
                x: R[0] * r1.x + R[1] * r1.y + R[2] * r1.z,
                y: R[3] * r1.x + R[4] * r1.y + R[5] * r1.z,
                z: R[6] * r1.x + R[7] * r1.y + R[8] * r1.z
            };
            return n;
        },
        hull: function(t) {
            var p = this.points, _p = [], pt, q = [], idx = 0, i = 0, l = 0;
            q[idx++] = p[0];
            q[idx++] = p[1];
            q[idx++] = p[2];
            if (this.order === 3) q[idx++] = p[3];
            // we lerp between all points at each iteration, until we have 1 point left.
            while(p.length > 1){
                _p = [];
                for(i = 0, l = p.length - 1; i < l; i++){
                    pt = utils.lerp(t, p[i], p[i + 1]);
                    q[idx++] = pt;
                    _p.push(pt);
                }
                p = _p;
            }
            return q;
        },
        split: function(t1, t2) {
            // shortcuts
            if (t1 === 0 && !!t2) return this.split(t2).left;
            if (t2 === 1) return this.split(t1).right;
            // no shortcut: use "de Casteljau" iteration.
            var q = this.hull(t1);
            var result = {
                left: this.order === 2 ? new Bezier([
                    q[0],
                    q[3],
                    q[5]
                ]) : new Bezier([
                    q[0],
                    q[4],
                    q[7],
                    q[9]
                ]),
                right: this.order === 2 ? new Bezier([
                    q[5],
                    q[4],
                    q[2]
                ]) : new Bezier([
                    q[9],
                    q[8],
                    q[6],
                    q[3]
                ]),
                span: q
            };
            // make sure we bind _t1/_t2 information!
            result.left._t1 = utils.map(0, 0, 1, this._t1, this._t2);
            result.left._t2 = utils.map(t1, 0, 1, this._t1, this._t2);
            result.right._t1 = utils.map(t1, 0, 1, this._t1, this._t2);
            result.right._t2 = utils.map(1, 0, 1, this._t1, this._t2);
            // if we have no t2, we're done
            if (!t2) return result;
            // if we have a t2, split again:
            t2 = utils.map(t2, t1, 1, 0, 1);
            var subsplit = result.right.split(t2);
            return subsplit.left;
        },
        extrema: function() {
            var dims = this.dims, result = {}, roots = [], p, mfn;
            dims.forEach((function(dim) {
                mfn = function(v) {
                    return v[dim];
                };
                p = this.dpoints[0].map(mfn);
                result[dim] = utils.droots(p);
                if (this.order === 3) {
                    p = this.dpoints[1].map(mfn);
                    result[dim] = result[dim].concat(utils.droots(p));
                }
                result[dim] = result[dim].filter(function(t) {
                    return t >= 0 && t <= 1;
                });
                roots = roots.concat(result[dim].sort(utils.numberSort));
            }).bind(this));
            roots = roots.sort(utils.numberSort).filter(function(v, idx) {
                return roots.indexOf(v) === idx;
            });
            result.values = roots;
            return result;
        },
        bbox: function() {
            var extrema = this.extrema(), result = {};
            this.dims.forEach((function(d) {
                result[d] = utils.getminmax(this, d, extrema[d]);
            }).bind(this));
            return result;
        },
        overlaps: function(curve) {
            var lbbox = this.bbox(), tbbox = curve.bbox();
            return utils.bboxoverlap(lbbox, tbbox);
        },
        offset: function(t, d) {
            if (typeof d !== "undefined") {
                var c = this.get(t);
                var n = this.normal(t);
                var ret = {
                    c: c,
                    n: n,
                    x: c.x + n.x * d,
                    y: c.y + n.y * d
                };
                if (this._3d) ret.z = c.z + n.z * d;
                return ret;
            }
            if (this._linear) {
                var nv = this.normal(0);
                var coords = this.points.map(function(p) {
                    var ret = {
                        x: p.x + t * nv.x,
                        y: p.y + t * nv.y
                    };
                    if (p.z && n.z) ret.z = p.z + t * nv.z;
                    return ret;
                });
                return [
                    new Bezier(coords)
                ];
            }
            var reduced = this.reduce();
            return reduced.map(function(s) {
                if (s._linear) return s.offset(t)[0];
                return s.scale(t);
            });
        },
        simple: function() {
            if (this.order === 3) {
                var a1 = utils.angle(this.points[0], this.points[3], this.points[1]);
                var a2 = utils.angle(this.points[0], this.points[3], this.points[2]);
                if (a1 > 0 && a2 < 0 || a1 < 0 && a2 > 0) return false;
            }
            var n1 = this.normal(0);
            var n2 = this.normal(1);
            var s = n1.x * n2.x + n1.y * n2.y;
            if (this._3d) s += n1.z * n2.z;
            var angle = abs(acos(s));
            return angle < pi / 3;
        },
        reduce: function() {
            var i, t1 = 0, t2 = 0, step = 0.01, segment, pass1 = [], pass2 = [];
            // first pass: split on extrema
            var extrema = this.extrema().values;
            if (extrema.indexOf(0) === -1) extrema = [
                0
            ].concat(extrema);
            if (extrema.indexOf(1) === -1) extrema.push(1);
            for(t1 = extrema[0], i = 1; i < extrema.length; i++){
                t2 = extrema[i];
                segment = this.split(t1, t2);
                segment._t1 = t1;
                segment._t2 = t2;
                pass1.push(segment);
                t1 = t2;
            }
            // second pass: further reduce these segments to simple segments
            pass1.forEach(function(p1) {
                t1 = 0;
                t2 = 0;
                while(t2 <= 1)for(t2 = t1 + step; t2 <= 1 + step; t2 += step){
                    segment = p1.split(t1, t2);
                    if (!segment.simple()) {
                        t2 -= step;
                        if (abs(t1 - t2) < step) // we can never form a reduction
                        return [];
                        segment = p1.split(t1, t2);
                        segment._t1 = utils.map(t1, 0, 1, p1._t1, p1._t2);
                        segment._t2 = utils.map(t2, 0, 1, p1._t1, p1._t2);
                        pass2.push(segment);
                        t1 = t2;
                        break;
                    }
                }
                if (t1 < 1) {
                    segment = p1.split(t1, 1);
                    segment._t1 = utils.map(t1, 0, 1, p1._t1, p1._t2);
                    segment._t2 = p1._t2;
                    pass2.push(segment);
                }
            });
            return pass2;
        },
        scale: function(d) {
            var order = this.order;
            var distanceFn = false;
            if (typeof d === "function") distanceFn = d;
            if (distanceFn && order === 2) return this.raise().scale(distanceFn);
            // TODO: add special handling for degenerate (=linear) curves.
            var clockwise = this.clockwise;
            var r1 = distanceFn ? distanceFn(0) : d;
            var r2 = distanceFn ? distanceFn(1) : d;
            var v = [
                this.offset(0, 10),
                this.offset(1, 10)
            ];
            var o = utils.lli4(v[0], v[0].c, v[1], v[1].c);
            if (!o) throw new Error("cannot scale this curve. Try reducing it first.");
            // move all points by distance 'd' wrt the origin 'o'
            var points = this.points, np = [];
            // move end points by fixed distance along normal.
            [
                0,
                1
            ].forEach((function(t) {
                var p = np[t * order] = utils.copy(points[t * order]);
                p.x += (t ? r2 : r1) * v[t].n.x;
                p.y += (t ? r2 : r1) * v[t].n.y;
            }).bind(this));
            if (!distanceFn) {
                // move control points to lie on the intersection of the offset
                // derivative vector, and the origin-through-control vector
                [
                    0,
                    1
                ].forEach((function(t) {
                    if (this.order === 2 && !!t) return;
                    var p = np[t * order];
                    var d = this.derivative(t);
                    var p2 = {
                        x: p.x + d.x,
                        y: p.y + d.y
                    };
                    np[t + 1] = utils.lli4(p, p2, o, points[t + 1]);
                }).bind(this));
                return new Bezier(np);
            }
            // move control points by "however much necessary to
            // ensure the correct tangent to endpoint".
            [
                0,
                1
            ].forEach((function(t) {
                if (this.order === 2 && !!t) return;
                var p = points[t + 1];
                var ov = {
                    x: p.x - o.x,
                    y: p.y - o.y
                };
                var rc = distanceFn ? distanceFn((t + 1) / order) : d;
                if (distanceFn && !clockwise) rc = -rc;
                var m = sqrt(ov.x * ov.x + ov.y * ov.y);
                ov.x /= m;
                ov.y /= m;
                np[t + 1] = {
                    x: p.x + rc * ov.x,
                    y: p.y + rc * ov.y
                };
            }).bind(this));
            return new Bezier(np);
        },
        outline: function(d1, d2, d3, d4) {
            d2 = typeof d2 === "undefined" ? d1 : d2;
            var reduced = this.reduce(), len = reduced.length, fcurves = [], bcurves = [], p, alen = 0, tlen = this.length();
            var graduated = typeof d3 !== "undefined" && typeof d4 !== "undefined";
            function linearDistanceFunction(s, e, tlen, alen, slen) {
                return function(v) {
                    var f1 = alen / tlen, f2 = (alen + slen) / tlen, d = e - s;
                    return utils.map(v, 0, 1, s + f1 * d, s + f2 * d);
                };
            }
            // form curve oulines
            reduced.forEach(function(segment) {
                slen = segment.length();
                if (graduated) {
                    fcurves.push(segment.scale(linearDistanceFunction(d1, d3, tlen, alen, slen)));
                    bcurves.push(segment.scale(linearDistanceFunction(-d2, -d4, tlen, alen, slen)));
                } else {
                    fcurves.push(segment.scale(d1));
                    bcurves.push(segment.scale(-d2));
                }
                alen += slen;
            });
            // reverse the "return" outline
            bcurves = bcurves.map(function(s) {
                p = s.points;
                if (p[3]) s.points = [
                    p[3],
                    p[2],
                    p[1],
                    p[0]
                ];
                else s.points = [
                    p[2],
                    p[1],
                    p[0]
                ];
                return s;
            }).reverse();
            // form the endcaps as lines
            var fs = fcurves[0].points[0], fe = fcurves[len - 1].points[fcurves[len - 1].points.length - 1], bs = bcurves[len - 1].points[bcurves[len - 1].points.length - 1], be = bcurves[0].points[0], ls = utils.makeline(bs, fs), le = utils.makeline(fe, be), segments = [
                ls
            ].concat(fcurves).concat([
                le
            ]).concat(bcurves), slen = segments.length;
            return new PolyBezier(segments);
        },
        outlineshapes: function(d1, d2, curveIntersectionThreshold) {
            d2 = d2 || d1;
            var outline = this.outline(d1, d2).curves;
            var shapes = [];
            for(var i = 1, len = outline.length; i < len / 2; i++){
                var shape = utils.makeshape(outline[i], outline[len - i], curveIntersectionThreshold);
                shape.startcap.virtual = i > 1;
                shape.endcap.virtual = i < len / 2 - 1;
                shapes.push(shape);
            }
            return shapes;
        },
        intersects: function(curve, curveIntersectionThreshold) {
            if (!curve) return this.selfintersects(curveIntersectionThreshold);
            if (curve.p1 && curve.p2) return this.lineIntersects(curve);
            if (curve instanceof Bezier) curve = curve.reduce();
            return this.curveintersects(this.reduce(), curve, curveIntersectionThreshold);
        },
        lineIntersects: function(line) {
            var mx = min(line.p1.x, line.p2.x), my = min(line.p1.y, line.p2.y), MX = max(line.p1.x, line.p2.x), MY = max(line.p1.y, line.p2.y), self = this;
            return utils.roots(this.points, line).filter(function(t) {
                var p = self.get(t);
                return utils.between(p.x, mx, MX) && utils.between(p.y, my, MY);
            });
        },
        selfintersects: function(curveIntersectionThreshold) {
            var reduced = this.reduce();
            // "simple" curves cannot intersect with their direct
            // neighbour, so for each segment X we check whether
            // it intersects [0:x-2][x+2:last].
            var i, len = reduced.length - 2, results = [], result, left, right;
            for(i = 0; i < len; i++){
                left = reduced.slice(i, i + 1);
                right = reduced.slice(i + 2);
                result = this.curveintersects(left, right, curveIntersectionThreshold);
                results = results.concat(result);
            }
            return results;
        },
        curveintersects: function(c1, c2, curveIntersectionThreshold) {
            var pairs = [];
            // step 1: pair off any overlapping segments
            c1.forEach(function(l) {
                c2.forEach(function(r) {
                    if (l.overlaps(r)) pairs.push({
                        left: l,
                        right: r
                    });
                });
            });
            // step 2: for each pairing, run through the convergence algorithm.
            var intersections = [];
            pairs.forEach(function(pair) {
                var result = utils.pairiteration(pair.left, pair.right, curveIntersectionThreshold);
                if (result.length > 0) intersections = intersections.concat(result);
            });
            return intersections;
        },
        arcs: function(errorThreshold) {
            errorThreshold = errorThreshold || 0.5;
            var circles = [];
            return this._iterate(errorThreshold, circles);
        },
        _error: function(pc, np1, s, e) {
            var q = (e - s) / 4, c1 = this.get(s + q), c2 = this.get(e - q), ref = utils.dist(pc, np1), d1 = utils.dist(pc, c1), d2 = utils.dist(pc, c2);
            return abs(d1 - ref) + abs(d2 - ref);
        },
        _iterate: function(errorThreshold, circles) {
            var t_s = 0, t_e = 1, safety;
            // we do a binary search to find the "good `t` closest to no-longer-good"
            do {
                safety = 0;
                // step 1: start with the maximum possible arc
                t_e = 1;
                // points:
                var np1 = this.get(t_s), np2, np3, arc, prev_arc;
                // booleans:
                var curr_good = false, prev_good = false, done;
                // numbers:
                var t_m = t_e, prev_e = 1, step = 0;
                // step 2: find the best possible arc
                do {
                    prev_good = curr_good;
                    prev_arc = arc;
                    t_m = (t_s + t_e) / 2;
                    step++;
                    np2 = this.get(t_m);
                    np3 = this.get(t_e);
                    arc = utils.getccenter(np1, np2, np3);
                    //also save the t values
                    arc.interval = {
                        start: t_s,
                        end: t_e
                    };
                    var error = this._error(arc, np1, t_s, t_e);
                    curr_good = error <= errorThreshold;
                    done = prev_good && !curr_good;
                    if (!done) prev_e = t_e;
                    // this arc is fine: we can move 'e' up to see if we can find a wider arc
                    if (curr_good) {
                        // if e is already at max, then we're done for this arc.
                        if (t_e >= 1) {
                            // make sure we cap at t=1
                            arc.interval.end = prev_e = 1;
                            prev_arc = arc;
                            // if we capped the arc segment to t=1 we also need to make sure that
                            // the arc's end angle is correct with respect to the bezier end point.
                            if (t_e > 1) {
                                var d = {
                                    x: arc.x + arc.r * cos(arc.e),
                                    y: arc.y + arc.r * sin(arc.e)
                                };
                                arc.e += utils.angle({
                                    x: arc.x,
                                    y: arc.y
                                }, d, this.get(1));
                            }
                            break;
                        }
                        // if not, move it up by half the iteration distance
                        t_e = t_e + (t_e - t_s) / 2;
                    } else // this is a bad arc: we need to move 'e' down to find a good arc
                    t_e = t_m;
                }while (!done && safety++ < 100);
                if (safety >= 100) break;
                // console.log("L835: [F] arc found", t_s, prev_e, prev_arc.x, prev_arc.y, prev_arc.s, prev_arc.e);
                prev_arc = prev_arc ? prev_arc : arc;
                circles.push(prev_arc);
                t_s = prev_e;
            }while (t_e < 1);
            return circles;
        }
    };
    module.exports = Bezier;
})();

});
parcelRegister("asPPo", function(module, exports) {

(function() {
    "use strict";
    // math-inlining.
    var abs = Math.abs, cos = Math.cos, sin = Math.sin, acos = Math.acos, atan2 = Math.atan2, sqrt = Math.sqrt, pow = Math.pow, // cube root function yielding real roots
    crt = function(v) {
        return v < 0 ? -pow(-v, 1 / 3) : pow(v, 1 / 3);
    }, // trig constants
    pi = Math.PI, tau = 2 * pi, quart = pi / 2, // float precision significant decimal
    epsilon = 0.000001, // extremas used in bbox calculation and similar algorithms
    nMax = Number.MAX_SAFE_INTEGER || 9007199254740991, nMin = Number.MIN_SAFE_INTEGER || -9007199254740991, // a zero coordinate, which is surprisingly useful
    ZERO = {
        x: 0,
        y: 0,
        z: 0
    };
    // Bezier utility functions
    var utils = {
        // Legendre-Gauss abscissae with n=24 (x_i values, defined at i=n as the roots of the nth order Legendre polynomial Pn(x))
        Tvalues: [
            -0.06405689286260563,
            0.0640568928626056260850430826247450385909,
            -0.1911188674736163,
            0.1911188674736163091586398207570696318404,
            -0.3150426796961634,
            0.3150426796961633743867932913198102407864,
            -0.4337935076260451,
            0.4337935076260451384870842319133497124524,
            -0.5454214713888396,
            0.5454214713888395356583756172183723700107,
            -0.6480936519369755,
            0.6480936519369755692524957869107476266696,
            -0.7401241915785544,
            0.7401241915785543642438281030999784255232,
            -0.820001985973903,
            0.8200019859739029219539498726697452080761,
            -0.8864155270044011,
            0.8864155270044010342131543419821967550873,
            -0.9382745520027328,
            0.9382745520027327585236490017087214496548,
            -0.9747285559713095,
            0.9747285559713094981983919930081690617411,
            -0.9951872199970213,
            0.9951872199970213601799974097007368118745
        ],
        // Legendre-Gauss weights with n=24 (w_i values, defined by a function linked to in the Bezier primer article)
        Cvalues: [
            0.1279381953467521569740561652246953718517,
            0.1279381953467521569740561652246953718517,
            0.1258374563468282961213753825111836887264,
            0.1258374563468282961213753825111836887264,
            0.121670472927803391204463153476262425607,
            0.121670472927803391204463153476262425607,
            0.1155056680537256013533444839067835598622,
            0.1155056680537256013533444839067835598622,
            0.1074442701159656347825773424466062227946,
            0.1074442701159656347825773424466062227946,
            0.0976186521041138882698806644642471544279,
            0.0976186521041138882698806644642471544279,
            0.086190161531953275917185202983742667185,
            0.086190161531953275917185202983742667185,
            0.0733464814110803057340336152531165181193,
            0.0733464814110803057340336152531165181193,
            0.0592985849154367807463677585001085845412,
            0.0592985849154367807463677585001085845412,
            0.0442774388174198061686027482113382288593,
            0.0442774388174198061686027482113382288593,
            0.0285313886289336631813078159518782864491,
            0.0285313886289336631813078159518782864491,
            0.0123412297999871995468056670700372915759,
            0.0123412297999871995468056670700372915759
        ],
        arcfn: function(t, derivativeFn) {
            var d = derivativeFn(t);
            var l = d.x * d.x + d.y * d.y;
            if (typeof d.z !== "undefined") l += d.z * d.z;
            return sqrt(l);
        },
        compute: function(t, points, _3d) {
            // shortcuts
            if (t === 0) return points[0];
            var order = points.length - 1;
            if (t === 1) return points[order];
            var p = points;
            var mt = 1 - t;
            // constant?
            if (order === 0) return points[0];
            // linear?
            if (order === 1) {
                ret = {
                    x: mt * p[0].x + t * p[1].x,
                    y: mt * p[0].y + t * p[1].y
                };
                if (_3d) ret.z = mt * p[0].z + t * p[1].z;
                return ret;
            }
            // quadratic/cubic curve?
            if (order < 4) {
                var mt2 = mt * mt, t2 = t * t, a, b, c, d = 0;
                if (order === 2) {
                    p = [
                        p[0],
                        p[1],
                        p[2],
                        ZERO
                    ];
                    a = mt2;
                    b = mt * t * 2;
                    c = t2;
                } else if (order === 3) {
                    a = mt2 * mt;
                    b = mt2 * t * 3;
                    c = mt * t2 * 3;
                    d = t * t2;
                }
                var ret = {
                    x: a * p[0].x + b * p[1].x + c * p[2].x + d * p[3].x,
                    y: a * p[0].y + b * p[1].y + c * p[2].y + d * p[3].y
                };
                if (_3d) ret.z = a * p[0].z + b * p[1].z + c * p[2].z + d * p[3].z;
                return ret;
            }
            // higher order curves: use de Casteljau's computation
            var dCpts = JSON.parse(JSON.stringify(points));
            while(dCpts.length > 1){
                for(var i = 0; i < dCpts.length - 1; i++){
                    dCpts[i] = {
                        x: dCpts[i].x + (dCpts[i + 1].x - dCpts[i].x) * t,
                        y: dCpts[i].y + (dCpts[i + 1].y - dCpts[i].y) * t
                    };
                    if (typeof dCpts[i].z !== "undefined") dCpts[i] = dCpts[i].z + (dCpts[i + 1].z - dCpts[i].z) * t;
                }
                dCpts.splice(dCpts.length - 1, 1);
            }
            return dCpts[0];
        },
        computeWithRatios: function(t, points, ratios, _3d) {
            var mt = 1 - t, r = ratios, p = points, d;
            var f1 = r[0], f2 = r[1], f3 = r[2], f4 = r[3];
            // spec for linear
            f1 *= mt;
            f2 *= t;
            if (p.length === 2) {
                d = f1 + f2;
                return {
                    x: (f1 * p[0].x + f2 * p[1].x) / d,
                    y: (f1 * p[0].y + f2 * p[1].y) / d,
                    z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z) / d
                };
            }
            // upgrade to quadratic
            f1 *= mt;
            f2 *= 2 * mt;
            f3 *= t * t;
            if (p.length === 3) {
                d = f1 + f2 + f3;
                return {
                    x: (f1 * p[0].x + f2 * p[1].x + f3 * p[2].x) / d,
                    y: (f1 * p[0].y + f2 * p[1].y + f3 * p[2].y) / d,
                    z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z + f3 * p[2].z) / d
                };
            }
            // upgrade to cubic
            f1 *= mt;
            f2 *= 1.5 * mt;
            f3 *= 3 * mt;
            f4 *= t * t * t;
            if (p.length === 4) {
                d = f1 + f2 + f3 + f4;
                return {
                    x: (f1 * p[0].x + f2 * p[1].x + f3 * p[2].x + f4 * p[3].x) / d,
                    y: (f1 * p[0].y + f2 * p[1].y + f3 * p[2].y + f4 * p[3].y) / d,
                    z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z + f3 * p[2].z + f4 * p[3].z) / d
                };
            }
        },
        derive: function(points, _3d) {
            var dpoints = [];
            for(var p = points, d = p.length, c = d - 1; d > 1; d--, c--){
                var list = [];
                for(var j = 0, dpt; j < c; j++){
                    dpt = {
                        x: c * (p[j + 1].x - p[j].x),
                        y: c * (p[j + 1].y - p[j].y)
                    };
                    if (_3d) dpt.z = c * (p[j + 1].z - p[j].z);
                    list.push(dpt);
                }
                dpoints.push(list);
                p = list;
            }
            return dpoints;
        },
        between: function(v, m, M) {
            return m <= v && v <= M || utils.approximately(v, m) || utils.approximately(v, M);
        },
        approximately: function(a, b, precision) {
            return abs(a - b) <= (precision || epsilon);
        },
        length: function(derivativeFn) {
            var z = 0.5, sum = 0, len = utils.Tvalues.length, i, t;
            for(i = 0; i < len; i++){
                t = z * utils.Tvalues[i] + z;
                sum += utils.Cvalues[i] * utils.arcfn(t, derivativeFn);
            }
            return z * sum;
        },
        map: function(v, ds, de, ts, te) {
            var d1 = de - ds, d2 = te - ts, v2 = v - ds, r = v2 / d1;
            return ts + d2 * r;
        },
        lerp: function(r, v1, v2) {
            var ret = {
                x: v1.x + r * (v2.x - v1.x),
                y: v1.y + r * (v2.y - v1.y)
            };
            if (!!v1.z && !!v2.z) ret.z = v1.z + r * (v2.z - v1.z);
            return ret;
        },
        pointToString: function(p) {
            var s = p.x + "/" + p.y;
            if (typeof p.z !== "undefined") s += "/" + p.z;
            return s;
        },
        pointsToString: function(points) {
            return "[" + points.map(utils.pointToString).join(", ") + "]";
        },
        copy: function(obj) {
            return JSON.parse(JSON.stringify(obj));
        },
        angle: function(o, v1, v2) {
            var dx1 = v1.x - o.x, dy1 = v1.y - o.y, dx2 = v2.x - o.x, dy2 = v2.y - o.y, cross = dx1 * dy2 - dy1 * dx2, dot = dx1 * dx2 + dy1 * dy2;
            return atan2(cross, dot);
        },
        // round as string, to avoid rounding errors
        round: function(v, d) {
            var s = "" + v;
            var pos = s.indexOf(".");
            return parseFloat(s.substring(0, pos + 1 + d));
        },
        dist: function(p1, p2) {
            var dx = p1.x - p2.x, dy = p1.y - p2.y;
            return sqrt(dx * dx + dy * dy);
        },
        closest: function(LUT, point) {
            var mdist = pow(2, 63), mpos, d;
            LUT.forEach(function(p, idx) {
                d = utils.dist(point, p);
                if (d < mdist) {
                    mdist = d;
                    mpos = idx;
                }
            });
            return {
                mdist: mdist,
                mpos: mpos
            };
        },
        abcratio: function(t, n) {
            // see ratio(t) note on http://pomax.github.io/bezierinfo/#abc
            if (n !== 2 && n !== 3) return false;
            if (typeof t === "undefined") t = 0.5;
            else if (t === 0 || t === 1) return t;
            var bottom = pow(t, n) + pow(1 - t, n), top = bottom - 1;
            return abs(top / bottom);
        },
        projectionratio: function(t, n) {
            // see u(t) note on http://pomax.github.io/bezierinfo/#abc
            if (n !== 2 && n !== 3) return false;
            if (typeof t === "undefined") t = 0.5;
            else if (t === 0 || t === 1) return t;
            var top = pow(1 - t, n), bottom = pow(t, n) + top;
            return top / bottom;
        },
        lli8: function(x1, y1, x2, y2, x3, y3, x4, y4) {
            var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4), ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4), d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
            if (d == 0) return false;
            return {
                x: nx / d,
                y: ny / d
            };
        },
        lli4: function(p1, p2, p3, p4) {
            var x1 = p1.x, y1 = p1.y, x2 = p2.x, y2 = p2.y, x3 = p3.x, y3 = p3.y, x4 = p4.x, y4 = p4.y;
            return utils.lli8(x1, y1, x2, y2, x3, y3, x4, y4);
        },
        lli: function(v1, v2) {
            return utils.lli4(v1, v1.c, v2, v2.c);
        },
        makeline: function(p1, p2) {
            var Bezier = (parcelRequire("lQT0x"));
            var x1 = p1.x, y1 = p1.y, x2 = p2.x, y2 = p2.y, dx = (x2 - x1) / 3, dy = (y2 - y1) / 3;
            return new Bezier(x1, y1, x1 + dx, y1 + dy, x1 + 2 * dx, y1 + 2 * dy, x2, y2);
        },
        findbbox: function(sections) {
            var mx = nMax, my = nMax, MX = nMin, MY = nMin;
            sections.forEach(function(s) {
                var bbox = s.bbox();
                if (mx > bbox.x.min) mx = bbox.x.min;
                if (my > bbox.y.min) my = bbox.y.min;
                if (MX < bbox.x.max) MX = bbox.x.max;
                if (MY < bbox.y.max) MY = bbox.y.max;
            });
            return {
                x: {
                    min: mx,
                    mid: (mx + MX) / 2,
                    max: MX,
                    size: MX - mx
                },
                y: {
                    min: my,
                    mid: (my + MY) / 2,
                    max: MY,
                    size: MY - my
                }
            };
        },
        shapeintersections: function(s1, bbox1, s2, bbox2, curveIntersectionThreshold) {
            if (!utils.bboxoverlap(bbox1, bbox2)) return [];
            var intersections = [];
            var a1 = [
                s1.startcap,
                s1.forward,
                s1.back,
                s1.endcap
            ];
            var a2 = [
                s2.startcap,
                s2.forward,
                s2.back,
                s2.endcap
            ];
            a1.forEach(function(l1) {
                if (l1.virtual) return;
                a2.forEach(function(l2) {
                    if (l2.virtual) return;
                    var iss = l1.intersects(l2, curveIntersectionThreshold);
                    if (iss.length > 0) {
                        iss.c1 = l1;
                        iss.c2 = l2;
                        iss.s1 = s1;
                        iss.s2 = s2;
                        intersections.push(iss);
                    }
                });
            });
            return intersections;
        },
        makeshape: function(forward, back, curveIntersectionThreshold) {
            var bpl = back.points.length;
            var fpl = forward.points.length;
            var start = utils.makeline(back.points[bpl - 1], forward.points[0]);
            var end = utils.makeline(forward.points[fpl - 1], back.points[0]);
            var shape = {
                startcap: start,
                forward: forward,
                back: back,
                endcap: end,
                bbox: utils.findbbox([
                    start,
                    forward,
                    back,
                    end
                ])
            };
            var self = utils;
            shape.intersections = function(s2) {
                return self.shapeintersections(shape, shape.bbox, s2, s2.bbox, curveIntersectionThreshold);
            };
            return shape;
        },
        getminmax: function(curve, d, list) {
            if (!list) return {
                min: 0,
                max: 0
            };
            var min = nMax, max = nMin, t, c;
            if (list.indexOf(0) === -1) list = [
                0
            ].concat(list);
            if (list.indexOf(1) === -1) list.push(1);
            for(var i = 0, len = list.length; i < len; i++){
                t = list[i];
                c = curve.get(t);
                if (c[d] < min) min = c[d];
                if (c[d] > max) max = c[d];
            }
            return {
                min: min,
                mid: (min + max) / 2,
                max: max,
                size: max - min
            };
        },
        align: function(points, line) {
            var tx = line.p1.x, ty = line.p1.y, a = -atan2(line.p2.y - ty, line.p2.x - tx), d = function(v) {
                return {
                    x: (v.x - tx) * cos(a) - (v.y - ty) * sin(a),
                    y: (v.x - tx) * sin(a) + (v.y - ty) * cos(a)
                };
            };
            return points.map(d);
        },
        roots: function(points, line) {
            line = line || {
                p1: {
                    x: 0,
                    y: 0
                },
                p2: {
                    x: 1,
                    y: 0
                }
            };
            var order = points.length - 1;
            var p = utils.align(points, line);
            var reduce = function(t) {
                return 0 <= t && t <= 1;
            };
            if (order === 2) {
                var a = p[0].y, b = p[1].y, c = p[2].y, d = a - 2 * b + c;
                if (d !== 0) {
                    var m1 = -sqrt(b * b - a * c), m2 = -a + b, v1 = -(m1 + m2) / d, v2 = -(-m1 + m2) / d;
                    return [
                        v1,
                        v2
                    ].filter(reduce);
                } else if (b !== c && d === 0) return [
                    (2 * b - c) / (2 * b - 2 * c)
                ].filter(reduce);
                return [];
            }
            // see http://www.trans4mind.com/personal_development/mathematics/polynomials/cubicAlgebra.htm
            var pa = p[0].y, pb = p[1].y, pc = p[2].y, pd = p[3].y, d = -pa + 3 * pb - 3 * pc + pd, a = 3 * pa - 6 * pb + 3 * pc, b = -3 * pa + 3 * pb, c = pa;
            if (utils.approximately(d, 0)) {
                // this is not a cubic curve.
                if (utils.approximately(a, 0)) {
                    // in fact, this is not a quadratic curve either.
                    if (utils.approximately(b, 0)) // in fact in fact, there are no solutions.
                    return [];
                    // linear solution:
                    return [
                        -c / b
                    ].filter(reduce);
                }
                // quadratic solution:
                var q = sqrt(b * b - 4 * a * c), a2 = 2 * a;
                return [
                    (q - b) / a2,
                    (-b - q) / a2
                ].filter(reduce);
            }
            // at this point, we know we need a cubic solution:
            a /= d;
            b /= d;
            c /= d;
            var p = (3 * b - a * a) / 3, p3 = p / 3, q = (2 * a * a * a - 9 * a * b + 27 * c) / 27, q2 = q / 2, discriminant = q2 * q2 + p3 * p3 * p3, u1, v1, x1, x2, x3;
            if (discriminant < 0) {
                var mp3 = -p / 3, mp33 = mp3 * mp3 * mp3, r = sqrt(mp33), t = -q / (2 * r), cosphi = t < -1 ? -1 : t > 1 ? 1 : t, phi = acos(cosphi), crtr = crt(r), t1 = 2 * crtr;
                x1 = t1 * cos(phi / 3) - a / 3;
                x2 = t1 * cos((phi + tau) / 3) - a / 3;
                x3 = t1 * cos((phi + 2 * tau) / 3) - a / 3;
                return [
                    x1,
                    x2,
                    x3
                ].filter(reduce);
            } else if (discriminant === 0) {
                u1 = q2 < 0 ? crt(-q2) : -crt(q2);
                x1 = 2 * u1 - a / 3;
                x2 = -u1 - a / 3;
                return [
                    x1,
                    x2
                ].filter(reduce);
            } else {
                var sd = sqrt(discriminant);
                u1 = crt(-q2 + sd);
                v1 = crt(q2 + sd);
                return [
                    u1 - v1 - a / 3
                ].filter(reduce);
            }
        },
        droots: function(p) {
            // quadratic roots are easy
            if (p.length === 3) {
                var a = p[0], b = p[1], c = p[2], d = a - 2 * b + c;
                if (d !== 0) {
                    var m1 = -sqrt(b * b - a * c), m2 = -a + b, v1 = -(m1 + m2) / d, v2 = -(-m1 + m2) / d;
                    return [
                        v1,
                        v2
                    ];
                } else if (b !== c && d === 0) return [
                    (2 * b - c) / (2 * (b - c))
                ];
                return [];
            }
            // linear roots are even easier
            if (p.length === 2) {
                var a = p[0], b = p[1];
                if (a !== b) return [
                    a / (a - b)
                ];
                return [];
            }
        },
        curvature: function(t, points, _3d, kOnly) {
            var dpoints = utils.derive(points);
            var d1 = dpoints[0];
            var d2 = dpoints[1];
            var num, dnm, adk, dk, k = 0, r = 0;
            //
            // We're using the following formula for curvature:
            //
            //              x'y" - y'x"
            //   k(t) = ------------------
            //           (x'² + y'²)^(3/2)
            //
            // from https://en.wikipedia.org/wiki/Radius_of_curvature#Definition
            //
            // With it corresponding 3D counterpart:
            //
            //          sqrt( (y'z" - y"z')² + (z'x" - z"x')² + (x'y" - x"y')²)
            //   k(t) = -------------------------------------------------------
            //                     (x'² + y'² + z'²)^(3/2)
            //
            var d = utils.compute(t, d1);
            var dd = utils.compute(t, d2);
            var qdsum = d.x * d.x + d.y * d.y;
            if (_3d) {
                num = sqrt(pow(d.y * dd.z - dd.y * d.z, 2) + pow(d.z * dd.x - dd.z * d.x, 2) + pow(d.x * dd.y - dd.x * d.y, 2));
                dnm = pow(qdsum + d.z * d.z, 1.5);
            } else {
                num = d.x * dd.y - d.y * dd.x;
                dnm = pow(qdsum, 1.5);
            }
            if (num === 0 || dnm === 0) return {
                k: 0,
                r: 0
            };
            k = num / dnm;
            r = dnm / num;
            // We're also computing the derivative of kappa, because
            // there is value in knowing the rate of change for the
            // curvature along the curve. And we're just going to
            // ballpark it based on an epsilon.
            if (!kOnly) {
                // compute k'(t) based on the interval before, and after it,
                // to at least try to not introduce forward/backward pass bias.
                var pk = utils.curvature(t - 0.001, points, _3d, true).k;
                var nk = utils.curvature(t + 0.001, points, _3d, true).k;
                dk = (nk - k + (k - pk)) / 2;
                adk = (abs(nk - k) + abs(k - pk)) / 2;
            }
            return {
                k: k,
                r: r,
                dk: dk,
                adk: adk
            };
        },
        inflections: function(points) {
            if (points.length < 4) return [];
            // FIXME: TODO: add in inflection abstraction for quartic+ curves?
            var p = utils.align(points, {
                p1: points[0],
                p2: points.slice(-1)[0]
            }), a = p[2].x * p[1].y, b = p[3].x * p[1].y, c = p[1].x * p[2].y, d = p[3].x * p[2].y, v1 = 18 * (-3 * a + 2 * b + 3 * c - d), v2 = 18 * (3 * a - b - 3 * c), v3 = 18 * (c - a);
            if (utils.approximately(v1, 0)) {
                if (!utils.approximately(v2, 0)) {
                    var t = -v3 / v2;
                    if (0 <= t && t <= 1) return [
                        t
                    ];
                }
                return [];
            }
            var trm = v2 * v2 - 4 * v1 * v3, sq = Math.sqrt(trm), d = 2 * v1;
            if (utils.approximately(d, 0)) return [];
            return [
                (sq - v2) / d,
                -(v2 + sq) / d
            ].filter(function(r) {
                return 0 <= r && r <= 1;
            });
        },
        bboxoverlap: function(b1, b2) {
            var dims = [
                "x",
                "y"
            ], len = dims.length, i, dim, l, t, d;
            for(i = 0; i < len; i++){
                dim = dims[i];
                l = b1[dim].mid;
                t = b2[dim].mid;
                d = (b1[dim].size + b2[dim].size) / 2;
                if (abs(l - t) >= d) return false;
            }
            return true;
        },
        expandbox: function(bbox, _bbox) {
            if (_bbox.x.min < bbox.x.min) bbox.x.min = _bbox.x.min;
            if (_bbox.y.min < bbox.y.min) bbox.y.min = _bbox.y.min;
            if (_bbox.z && _bbox.z.min < bbox.z.min) bbox.z.min = _bbox.z.min;
            if (_bbox.x.max > bbox.x.max) bbox.x.max = _bbox.x.max;
            if (_bbox.y.max > bbox.y.max) bbox.y.max = _bbox.y.max;
            if (_bbox.z && _bbox.z.max > bbox.z.max) bbox.z.max = _bbox.z.max;
            bbox.x.mid = (bbox.x.min + bbox.x.max) / 2;
            bbox.y.mid = (bbox.y.min + bbox.y.max) / 2;
            if (bbox.z) bbox.z.mid = (bbox.z.min + bbox.z.max) / 2;
            bbox.x.size = bbox.x.max - bbox.x.min;
            bbox.y.size = bbox.y.max - bbox.y.min;
            if (bbox.z) bbox.z.size = bbox.z.max - bbox.z.min;
        },
        pairiteration: function(c1, c2, curveIntersectionThreshold) {
            var c1b = c1.bbox(), c2b = c2.bbox(), r = 100000, threshold = curveIntersectionThreshold || 0.5;
            if (c1b.x.size + c1b.y.size < threshold && c2b.x.size + c2b.y.size < threshold) return [
                (r * (c1._t1 + c1._t2) / 2 | 0) / r + "/" + (r * (c2._t1 + c2._t2) / 2 | 0) / r
            ];
            var cc1 = c1.split(0.5), cc2 = c2.split(0.5), pairs = [
                {
                    left: cc1.left,
                    right: cc2.left
                },
                {
                    left: cc1.left,
                    right: cc2.right
                },
                {
                    left: cc1.right,
                    right: cc2.right
                },
                {
                    left: cc1.right,
                    right: cc2.left
                }
            ];
            pairs = pairs.filter(function(pair) {
                return utils.bboxoverlap(pair.left.bbox(), pair.right.bbox());
            });
            var results = [];
            if (pairs.length === 0) return results;
            pairs.forEach(function(pair) {
                results = results.concat(utils.pairiteration(pair.left, pair.right, threshold));
            });
            results = results.filter(function(v, i) {
                return results.indexOf(v) === i;
            });
            return results;
        },
        getccenter: function(p1, p2, p3) {
            var dx1 = p2.x - p1.x, dy1 = p2.y - p1.y, dx2 = p3.x - p2.x, dy2 = p3.y - p2.y;
            var dx1p = dx1 * cos(quart) - dy1 * sin(quart), dy1p = dx1 * sin(quart) + dy1 * cos(quart), dx2p = dx2 * cos(quart) - dy2 * sin(quart), dy2p = dx2 * sin(quart) + dy2 * cos(quart);
            // chord midpoints
            var mx1 = (p1.x + p2.x) / 2, my1 = (p1.y + p2.y) / 2, mx2 = (p2.x + p3.x) / 2, my2 = (p2.y + p3.y) / 2;
            // midpoint offsets
            var mx1n = mx1 + dx1p, my1n = my1 + dy1p, mx2n = mx2 + dx2p, my2n = my2 + dy2p;
            // intersection of these lines:
            var arc = utils.lli8(mx1, my1, mx1n, my1n, mx2, my2, mx2n, my2n), r = utils.dist(arc, p1), // arc start/end values, over mid point:
            s = atan2(p1.y - arc.y, p1.x - arc.x), m = atan2(p2.y - arc.y, p2.x - arc.x), e = atan2(p3.y - arc.y, p3.x - arc.x), _;
            // determine arc direction (cw/ccw correction)
            if (s < e) {
                // if s<m<e, arc(s, e)
                // if m<s<e, arc(e, s + tau)
                // if s<e<m, arc(e, s + tau)
                if (s > m || m > e) s += tau;
                if (s > e) {
                    _ = e;
                    e = s;
                    s = _;
                }
            } else // if e<m<s, arc(e, s)
            // if m<e<s, arc(s, e + tau)
            // if e<s<m, arc(s, e + tau)
            if (e < m && m < s) {
                _ = e;
                e = s;
                s = _;
            } else e += tau;
            // assign and done.
            arc.s = s;
            arc.e = e;
            arc.r = r;
            return arc;
        },
        numberSort: function(a, b) {
            return a - b;
        }
    };
    module.exports = utils;
})();

});

parcelRegister("9L27D", function(module, exports) {

(function() {
    "use strict";
    var utils = (parcelRequire("asPPo"));
    /**
   * Poly Bezier
   * @param {[type]} curves [description]
   */ var PolyBezier = function(curves) {
        this.curves = [];
        this._3d = false;
        if (!!curves) {
            this.curves = curves;
            this._3d = this.curves[0]._3d;
        }
    };
    PolyBezier.prototype = {
        valueOf: function() {
            return this.toString();
        },
        toString: function() {
            return "[" + this.curves.map(function(curve) {
                return utils.pointsToString(curve.points);
            }).join(", ") + "]";
        },
        addCurve: function(curve) {
            this.curves.push(curve);
            this._3d = this._3d || curve._3d;
        },
        length: function() {
            return this.curves.map(function(v) {
                return v.length();
            }).reduce(function(a, b) {
                return a + b;
            });
        },
        curve: function(idx) {
            return this.curves[idx];
        },
        bbox: function() {
            var c = this.curves;
            var bbox = c[0].bbox();
            for(var i = 1; i < c.length; i++)utils.expandbox(bbox, c[i].bbox());
            return bbox;
        },
        offset: function(d) {
            var offset = [];
            this.curves.forEach(function(v) {
                offset = offset.concat(v.offset(d));
            });
            return new PolyBezier(offset);
        }
    };
    module.exports = PolyBezier;
})();

});

parcelRegister("71caD", function(module, exports) {

var $krtaB = parcelRequire("krtaB");
var $51c2113a1bdfb840$var$M = {
    x: false,
    y: false
};
function $51c2113a1bdfb840$var$makeBezier(Bezier, term, values) {
    if (term === "Z") return;
    if (term === "M") {
        $51c2113a1bdfb840$var$M = {
            x: values[0],
            y: values[1]
        };
        return;
    }
    // ES7: new Bezier(M.x, M.y, ...values)
    var cvalues = [
        false,
        $51c2113a1bdfb840$var$M.x,
        $51c2113a1bdfb840$var$M.y
    ].concat(values);
    var PreboundConstructor = Bezier.bind.apply(Bezier, cvalues);
    var curve = new PreboundConstructor();
    var last = values.slice(-2);
    $51c2113a1bdfb840$var$M = {
        x: last[0],
        y: last[1]
    };
    return curve;
}
function $51c2113a1bdfb840$var$convertPath(Bezier, d) {
    var terms = $krtaB(d).split(" "), term, matcher = new RegExp("[MLCQZ]", ""), segment, values, segments = [], ARGS = {
        "C": 6,
        "Q": 4,
        "L": 2,
        "M": 2
    };
    while(terms.length){
        term = terms.splice(0, 1)[0];
        if (matcher.test(term)) {
            values = terms.splice(0, ARGS[term]).map(parseFloat);
            segment = $51c2113a1bdfb840$var$makeBezier(Bezier, term, values);
            if (segment) segments.push(segment);
        }
    }
    return new Bezier.PolyBezier(segments);
}
module.exports = $51c2113a1bdfb840$var$convertPath;

});
parcelRegister("krtaB", function(module, exports) {
/**
 * Normalise an SVG path to absolute coordinates
 * and full commands, rather than relative coordinates
 * and/or shortcut commands.
 */ function $ee1cf4d710da5d75$var$normalizePath(d) {
    // preprocess "d" so that we have spaces between values
    d = d.replace(/,/g, " ") // replace commas with spaces
    .replace(/-/g, " - ") // add spacing around minus signs
    .replace(/-\s+/g, "-") // remove spacing to the right of minus signs.
    .replace(/([a-zA-Z])/g, " $1 ");
    // set up the variables used in this function
    var instructions = d.replace(/([a-zA-Z])\s?/g, "|$1").split("|"), instructionLength = instructions.length, i, instruction, op, lop, args = [], alen, a, sx = 0, sy = 0, x = 0, y = 0, cx = 0, cy = 0, cx2 = 0, cy2 = 0, normalized = "";
    // we run through the instruction list starting at 1, not 0,
    // because we split up "|M x y ...." so the first element will
    // always be an empty string. By design.
    for(i = 1; i < instructionLength; i++){
        // which instruction is this?
        instruction = instructions[i];
        op = instruction.substring(0, 1);
        lop = op.toLowerCase();
        // what are the arguments? note that we need to convert
        // all strings into numbers, or + will do silly things.
        args = instruction.replace(op, "").trim().split(" ");
        args = args.filter(function(v) {
            return v !== "";
        }).map(parseFloat);
        alen = args.length;
        // we could use a switch, but elaborate code in a "case" with
        // fallthrough is just horrid to read. So let's use ifthen
        // statements instead.
        // moveto command (plus possible lineto)
        if (lop === "m") {
            normalized += "M ";
            if (op === "m") {
                x += args[0];
                y += args[1];
            } else {
                x = args[0];
                y = args[1];
            }
            // records start position, for dealing
            // with the shape close operator ('Z')
            sx = x;
            sy = y;
            normalized += x + " " + y + " ";
            if (alen > 2) for(a = 0; a < alen; a += 2){
                if (op === "m") {
                    x += args[a];
                    y += args[a + 1];
                } else {
                    x = args[a];
                    y = args[a + 1];
                }
                normalized += [
                    "L",
                    x,
                    y,
                    ""
                ].join(" ");
            }
        } else if (lop === "l") // lineto commands
        for(a = 0; a < alen; a += 2){
            if (op === "l") {
                x += args[a];
                y += args[a + 1];
            } else {
                x = args[a];
                y = args[a + 1];
            }
            normalized += [
                "L",
                x,
                y,
                ""
            ].join(" ");
        }
        else if (lop === "h") for(a = 0; a < alen; a++){
            if (op === "h") x += args[a];
            else x = args[a];
            normalized += [
                "L",
                x,
                y,
                ""
            ].join(" ");
        }
        else if (lop === "v") for(a = 0; a < alen; a++){
            if (op === "v") y += args[a];
            else y = args[a];
            normalized += [
                "L",
                x,
                y,
                ""
            ].join(" ");
        }
        else if (lop === "q") // quadratic curveto commands
        for(a = 0; a < alen; a += 4){
            if (op === "q") {
                cx = x + args[a];
                cy = y + args[a + 1];
                x += args[a + 2];
                y += args[a + 3];
            } else {
                cx = args[a];
                cy = args[a + 1];
                x = args[a + 2];
                y = args[a + 3];
            }
            normalized += [
                "Q",
                cx,
                cy,
                x,
                y,
                ""
            ].join(" ");
        }
        else if (lop === "t") for(a = 0; a < alen; a += 2){
            // reflect previous cx/cy over x/y
            cx = x + (x - cx);
            cy = y + (y - cy);
            // then get real end point
            if (op === "t") {
                x += args[a];
                y += args[a + 1];
            } else {
                x = args[a];
                y = args[a + 1];
            }
            normalized += [
                "Q",
                cx,
                cy,
                x,
                y,
                ""
            ].join(" ");
        }
        else if (lop === "c") // cubic curveto commands
        for(a = 0; a < alen; a += 6){
            if (op === "c") {
                cx = x + args[a];
                cy = y + args[a + 1];
                cx2 = x + args[a + 2];
                cy2 = y + args[a + 3];
                x += args[a + 4];
                y += args[a + 5];
            } else {
                cx = args[a];
                cy = args[a + 1];
                cx2 = args[a + 2];
                cy2 = args[a + 3];
                x = args[a + 4];
                y = args[a + 5];
            }
            normalized += [
                "C",
                cx,
                cy,
                cx2,
                cy2,
                x,
                y,
                ""
            ].join(" ");
        }
        else if (lop === "s") for(a = 0; a < alen; a += 4){
            // reflect previous cx2/cy2 over x/y
            cx = x + (x - cx2);
            cy = y + (y - cy2);
            // then get real control and end point
            if (op === "s") {
                cx2 = x + args[a];
                cy2 = y + args[a + 1];
                x += args[a + 2];
                y += args[a + 3];
            } else {
                cx2 = args[a];
                cy2 = args[a + 1];
                x = args[a + 2];
                y = args[a + 3];
            }
            normalized += [
                "C",
                cx,
                cy,
                cx2,
                cy2,
                x,
                y,
                ""
            ].join(" ");
        }
        else if (lop === "z") {
            normalized += "Z ";
            // not unimportant: path closing changes the current x/y coordinate
            x = sx;
            y = sy;
        }
    }
    return normalized.trim();
}
module.exports = $ee1cf4d710da5d75$var$normalizePath;

});



parcelRegister("eC5G7", function(module, exports) {

































(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("7fQSe")), (parcelRequire("5GuSz")), (parcelRequire("ccckY")), (parcelRequire("1U8gx")), (parcelRequire("3hao2")), (parcelRequire("2Rb5F")), (parcelRequire("26LSc")), (parcelRequire("bvCfA")), (parcelRequire("64OVg")), (parcelRequire("wSnak")), (parcelRequire("f03sF")), (parcelRequire("8r9ug")), (parcelRequire("9prXE")), (parcelRequire("76mdr")), (parcelRequire("hV8yC")), (parcelRequire("kQscY")), (parcelRequire("jaC0I")), (parcelRequire("3vMel")), (parcelRequire("3Sktt")), (parcelRequire("kS8xt")), (parcelRequire("f6kDn")), (parcelRequire("1mazW")), (parcelRequire("3tPMV")), (parcelRequire("3aI6Q")), (parcelRequire("aTgJv")), (parcelRequire("iAW5a")), (parcelRequire("dtinM")), (parcelRequire("em5MW")), (parcelRequire("i20n2")), (parcelRequire("aYkFf")), (parcelRequire("3X7Vr")), (parcelRequire("5Ux0b")));
})(this, function(CryptoJS) {
    return CryptoJS;
});

});
parcelRegister("cnNdL", function(module, exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        /*
	     * Local polyfil of Object.create
	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var i = 0; i < thatSigBytes; i += 4)thisWords[thisSigBytes + i >>> 2] = thatWords[i >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                var r = function(m_w) {
                    var m_w = m_w;
                    var m_z = 0x3ade68b1;
                    var mask = 0xffffffff;
                    return function() {
                        m_z = 0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10) & mask;
                        m_w = 0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10) & mask;
                        var result = (m_z << 0x10) + m_w & mask;
                        result /= 0x100000000;
                        result += 0.5;
                        return result * (Math1.random() > .5 ? 1 : -1);
                    };
                };
                for(var i = 0, rcache; i < nBytes; i += 4){
                    var _r = r((rcache || Math1.random()) * 0x100000000);
                    rcache = _r() * 0x3ade67b7;
                    words.push(_r() * 0x100000000 | 0);
                }
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    var processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("7fQSe", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});

parcelRegister("5GuSz", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("ccckY", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

});

parcelRegister("1U8gx", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                words[nBytes >>> 2] |= (bits1 | bits2) << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("3hao2", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working varialbes
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("2Rb5F", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("26LSc", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("bvCfA", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("26LSc")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

});

parcelRegister("64OVg", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("7fQSe")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        var Wih = Wi.high = M[offset + i * 2] | 0;
                        var Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        var Wil = gamma0l + Wi7l;
                        var Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        var Wil = Wil + gamma1l;
                        var Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        var Wil = Wil + Wi16l;
                        var Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

});

parcelRegister("wSnak", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("7fQSe")), (parcelRequire("64OVg")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

});

parcelRegister("f03sF", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("7fQSe")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            var tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            var tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            var tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            var tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});

parcelRegister("8r9ug", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRegister("9prXE", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});

parcelRegister("76mdr", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("2Rb5F")), (parcelRequire("9prXE")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA1 = C_algo.SHA1;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA1,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

});

parcelRegister("hV8yC", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("2Rb5F")), (parcelRequire("9prXE")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    var block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});

parcelRegister("kQscY", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("hV8yC")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    var block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else var block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) var modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    var modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    var finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    var finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) var wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else var wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    var salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});

parcelRegister("jaC0I", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                var keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else var keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

});

parcelRegister("3vMel", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

});

parcelRegister("3Sktt", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

});

parcelRegister("kS8xt", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

});

parcelRegister("f6kDn", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

});

parcelRegister("1mazW", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

});

parcelRegister("3tPMV", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

});

parcelRegister("3aI6Q", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

});

parcelRegister("aTgJv", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            while(!(dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff))i--;
            data.sigBytes = i + 1;
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

});

parcelRegister("iAW5a", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

});

parcelRegister("dtinM", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

});

parcelRegister("em5MW", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("1U8gx")), (parcelRequire("3hao2")), (parcelRequire("hV8yC")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    var t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});

parcelRegister("i20n2", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("1U8gx")), (parcelRequire("3hao2")), (parcelRequire("hV8yC")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
                this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
                this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

});

parcelRegister("aYkFf", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("1U8gx")), (parcelRequire("3hao2")), (parcelRequire("hV8yC")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

});

parcelRegister("3X7Vr", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("1U8gx")), (parcelRequire("3hao2")), (parcelRequire("hV8yC")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

});

parcelRegister("5Ux0b", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cnNdL")), (parcelRequire("1U8gx")), (parcelRequire("3hao2")), (parcelRequire("hV8yC")), (parcelRequire("kQscY")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

});


/**
 * craftyjs 0.8.0
 * http://craftyjs.com/
 *
 * Copyright 2018, Louis Stowasser
 * Licensed under the MIT license.
 */ (function e(t, n, r) {
    function s(o, u) {
        if (!n[o]) {
            if (!t[o]) {
                var a = undefined;
                if (!u && a) return a(o, !0);
                if (i) return i(o, !0);
                var f = new Error("Cannot find module '" + o + "'");
                throw f.code = "MODULE_NOT_FOUND", f;
            }
            var l = n[o] = {
                exports: {}
            };
            t[o][0].call(l.exports, function(e) {
                var n = t[o][1][e];
                return s(n ? n : e);
            }, l, l.exports, e, t, n, r);
        }
        return n[o].exports;
    }
    var i = undefined;
    for(var o = 0; o < r.length; o++)s(r[o]);
    return s;
})({
    1: [
        function(require1, module, exports) {
            // shim for using process in browser
            var process = module.exports = {};
            // cached from whatever global is present so that test runners that stub it
            // don't break things.  But we need to wrap it in a try catch in case it is
            // wrapped in strict mode code which doesn't define any globals.  It's inside a
            // function because try/catches deoptimize in certain engines.
            var cachedSetTimeout;
            var cachedClearTimeout;
            function defaultSetTimout() {
                throw new Error("setTimeout has not been defined");
            }
            function defaultClearTimeout() {
                throw new Error("clearTimeout has not been defined");
            }
            (function() {
                try {
                    if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
                    else cachedSetTimeout = defaultSetTimout;
                } catch (e) {
                    cachedSetTimeout = defaultSetTimout;
                }
                try {
                    if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
                    else cachedClearTimeout = defaultClearTimeout;
                } catch (e) {
                    cachedClearTimeout = defaultClearTimeout;
                }
            })();
            function runTimeout(fun) {
                if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                return setTimeout(fun, 0);
                // if setTimeout wasn't available but was latter defined
                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                    cachedSetTimeout = setTimeout;
                    return setTimeout(fun, 0);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedSetTimeout(fun, 0);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                        return cachedSetTimeout.call(null, fun, 0);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                        return cachedSetTimeout.call(this, fun, 0);
                    }
                }
            }
            function runClearTimeout(marker) {
                if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                return clearTimeout(marker);
                // if clearTimeout wasn't available but was latter defined
                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                    cachedClearTimeout = clearTimeout;
                    return clearTimeout(marker);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedClearTimeout(marker);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                        return cachedClearTimeout.call(null, marker);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                        return cachedClearTimeout.call(this, marker);
                    }
                }
            }
            var queue = [];
            var draining = false;
            var currentQueue;
            var queueIndex = -1;
            function cleanUpNextTick() {
                if (!draining || !currentQueue) return;
                draining = false;
                if (currentQueue.length) queue = currentQueue.concat(queue);
                else queueIndex = -1;
                if (queue.length) drainQueue();
            }
            function drainQueue() {
                if (draining) return;
                var timeout = runTimeout(cleanUpNextTick);
                draining = true;
                var len = queue.length;
                while(len){
                    currentQueue = queue;
                    queue = [];
                    while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                    queueIndex = -1;
                    len = queue.length;
                }
                currentQueue = null;
                draining = false;
                runClearTimeout(timeout);
            }
            process.nextTick = function(fun) {
                var args = new Array(arguments.length - 1);
                if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                queue.push(new Item(fun, args));
                if (queue.length === 1 && !draining) runTimeout(drainQueue);
            };
            // v8 likes predictible objects
            function Item(fun, array) {
                this.fun = fun;
                this.array = array;
            }
            Item.prototype.run = function() {
                this.fun.apply(null, this.array);
            };
            process.title = "browser";
            process.browser = true;
            process.env = {};
            process.argv = [];
            process.version = ""; // empty string to avoid regexp issues
            process.versions = {};
            function noop() {}
            process.on = noop;
            process.addListener = noop;
            process.once = noop;
            process.off = noop;
            process.removeListener = noop;
            process.removeAllListeners = noop;
            process.emit = noop;
            process.binding = function(name) {
                throw new Error("process.binding is not supported");
            };
            process.cwd = function() {
                return "/";
            };
            process.chdir = function(dir) {
                throw new Error("process.chdir is not supported");
            };
            process.umask = function() {
                return 0;
            };
        },
        {}
    ],
    2: [
        function(require1, module, exports) {
            function createDeprecatedAlias(oldObject, oldName, newObject, newName) {
                Object.defineProperty(oldObject, oldName, {
                    enumerable: false,
                    configurable: false,
                    get: function() {
                        return newObject[newName];
                    },
                    set: function(value) {
                        newObject[newName] = value;
                    }
                });
            }
            module.exports = {
                defineAliases: function defineAliases(Crafty) {
                    createDeprecatedAlias(Crafty, "image_whitelist", Crafty, "imageWhitelist");
                    createDeprecatedAlias(Crafty, "mouseDispatch", Crafty.s("Mouse"), "processEvent");
                    createDeprecatedAlias(Crafty, "mouseButtonsDown", Crafty.s("Mouse"), "_buttonDown");
                    createDeprecatedAlias(Crafty, "lastEvent", Crafty.s("Mouse"), "lastMouseEvent");
                    createDeprecatedAlias(Crafty, "mouseObjs", Crafty.s("Mouse"), "mouseObjs");
                    createDeprecatedAlias(Crafty, "keyboardDispatch", Crafty.s("Keyboard"), "processEvent");
                    createDeprecatedAlias(Crafty, "keydown", Crafty.s("Keyboard"), "_keyDown");
                    createDeprecatedAlias(Crafty, "resetKeyDown", Crafty.s("Keyboard"), "resetKeyDown");
                    createDeprecatedAlias(Crafty, "touchDispatch", Crafty, "_touchDispatch");
                    createDeprecatedAlias(Crafty, "touchObjs", Crafty.s("Touch"), "touchObjs");
                    Crafty.touchHandler = {};
                    createDeprecatedAlias(Crafty.touchHandler, "fingers", Crafty.s("Touch"), "touchPoints");
                }
            };
        },
        {}
    ],
    3: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            // ToggleInput contract
            // Must provide an isDown method which returns whether the input is down or not
            // May provide a destroy method which can be used for cleanup
            // MouseButtonToggleInput
            function MouseButtonToggleInput(button) {
                this.button = button;
            }
            MouseButtonToggleInput.prototype = {
                isDown: function() {
                    var mouseSystem = this.mouseSystem;
                    if (!mouseSystem) this.mouseSystem = mouseSystem = Crafty.s("Mouse");
                    return mouseSystem.isButtonDown(this.button);
                }
            };
            // KeyboardToggleInput
            function KeyboardToggleInput(key) {
                this.key = key;
            }
            KeyboardToggleInput.prototype = {
                isDown: function() {
                    var keyboardSystem = this.keyboardSystem;
                    if (!keyboardSystem) this.keyboardSystem = keyboardSystem = Crafty.s("Keyboard");
                    return keyboardSystem.isKeyDown(this.key);
                }
            };
            // ToggleInputGroup
            function ToggleInputGroup(inputs) {
                this.inputs = inputs;
            }
            // Handles a group of inputs that represent the same toggle state
            ToggleInputGroup.prototype = {
                timeDown: null,
                isActive: function() {
                    for(var i in this.inputs){
                        var input = this.inputs[i];
                        if (input.isDown()) {
                            if (!this.timeDown) this.timeDown = Date.now();
                            return true;
                        }
                    }
                    delete this.timeDown;
                    return false;
                },
                destroy: function() {
                    for(var i in this.inputs)if (typeof this.inputs[i].destroy === "function") this.inputs[i].destroy();
                }
            };
            // Provides abstractions for specific types of inputs:
            // - DirectionalInput: {x, y}
            // - TriggerInputDown/TriggerInputUp
            /**@
 * #Controls
 * @category Controls
 * @kind System
 *
 * A built-in system for linking specific inputs to general types of input events.
 *
 * @note The methods provided by this system are likely to change in future verisons of Crafty, as more input types are supported.
 *
 * @trigger TriggerInputDown - When a trigger group is activated - {name}
 * @trigger TriggerInputUp - When a trigger group is released - {name, downFor}
 * @trigger DirectionalInput - When a directional input changes - {name, x, y}
 *
 * @trigger ControlDefined - When a control input is defined - {type, name}
 * @trigger ControlDestroyed - When a control input is destroyed - {type, name}
 */ Crafty.s("Controls", {
                init: function() {
                    // internal object to store definitions
                    this._dpads = {};
                    this._triggers = {};
                    // listen to mouse events
                    Crafty.s("Mouse").bind("MouseDown", this.updateTriggers.bind(this));
                    Crafty.s("Mouse").bind("MouseUp", this.updateTriggers.bind(this));
                    Crafty.s("Mouse").bind("DoubleClick", this.updateTriggers.bind(this));
                    Crafty.s("Mouse").bind("Click", this.updateTriggers.bind(this));
                },
                events: {
                    EnterFrame: "runEvents",
                    KeyDown: "updateTriggers",
                    KeyUp: "updateTriggers"
                },
                // Runs through all triggers and updates their status
                updateTriggers: function(e) {
                    for(var t in this._triggers){
                        var trigger = this._triggers[t];
                        this.updateTriggerInput(trigger);
                    }
                },
                runEvents: function() {
                    // Trigger DirectionalInput events for dpads
                    for(var d in this._dpads){
                        var dpad = this._dpads[d];
                        dpad.oldX = dpad.x;
                        dpad.oldY = dpad.y;
                        this.updateDpadInput(dpad, dpad.multipleDirectionBehavior);
                        this.updateActiveDirection(dpad, dpad.normalize);
                        dpad.event.x = dpad.x;
                        dpad.event.y = dpad.y;
                        if (dpad.x !== dpad.oldX || dpad.y !== dpad.oldY) Crafty.trigger("DirectionalInput", dpad.event);
                    }
                },
                getDpad: function(name) {
                    return this._dpads[name];
                },
                isTriggerDown: function(name) {
                    return this._triggers[name].active;
                },
                /**@
     * #.defineTriggerGroup
     * @comp Controls
     * @kind Method
     *
     * @sign defineTriggerGroup(string name, obj definition)
     * @param name - a name for the trigger group
     * @param definition - an object which defines the inputs for the trigger
     *
     * A trigger group is a set of togglable inputs mapped to the same event.
     * If any of the inputs are down, the trigger is considered down.  If all are up, it is considered up.
     * When the trigger state changes, a `TriggerInputUp` or `TriggerInputDown` event is fired.
     *
     * The definition object lists the inputs that are mapped to the trigger:
     * - `keys`: An array of Crafty keycodes
     * - `mouseButtons`: An array of Crafty mouse button codes
     *
     * @example
     * ~~~
     * // Define a trigger group mapped to the left mouse button and the A and B keys.
     * Crafty.s("Controls").defineTriggerGroup("MyTrigger", {
     *   mouseButtons: [Crafty.mouseButtons.LEFT],
     *   keys: [Crafty.keys.A, Crafty.keys.B]
     * });
     * ~~~
     *
     * @see .destroyTriggerGroup
     * @see Crafty.mouseButtons
     * @see Crafty.keys
     * @see Controllable
     */ defineTriggerGroup: function(name, definition) {
                    var inputs;
                    if (Array.isArray(definition)) inputs = definition;
                    else {
                        inputs = [];
                        if (definition.mouseButtons) for(var b in definition.mouseButtons)inputs.push(new MouseButtonToggleInput(definition.mouseButtons[b]));
                        if (definition.keys) for(var k in definition.keys)inputs.push(new KeyboardToggleInput(definition.keys[k]));
                    }
                    this.destroyTriggerGroup(name);
                    this._triggers[name] = {
                        name: name,
                        input: new ToggleInputGroup(inputs),
                        downFor: 0,
                        active: false
                    };
                    Crafty.trigger("ControlDefined", {
                        type: "TriggerGroup",
                        name: name
                    });
                },
                /**@
     * #.destroyTriggerGroup
     * @comp Controls
     * @kind Method
     *
     * @sign destroyTriggerGroup(string name)
     * @param name - the name of the trigger group
     *
     * Destroys a previously defined trigger group.
     *
     * @see .defineTriggerGroup
     */ destroyTriggerGroup: function(name) {
                    if (this._triggers[name]) {
                        this._triggers[name].input.destroy();
                        delete this._triggers[name];
                        Crafty.trigger("ControlDestroyed", {
                            type: "TriggerGroup",
                            name: name
                        });
                    }
                },
                /**@
     * #.defineDpad
     * @comp Controls
     * @kind Method
     *
     * @sign defineDpad(string name, obj definition[, obj options])
     * @param name - a name for the dpad input
     * @param definition - an object which defines the inputs and directions for the dpad
     * @param options - a set of options for the dpad
     *
     * A dpad is a type of directional control which maps a set of triggers to a set of directions.
     *
     * The options object has two properties:
     * - `normalize` *(bool)*: If true, the directional input will be normalized to a unit vector.  Defaults to false.
     * - `multipleDirectionBehavior` *(string)*: How to behave when multiple directions are active at the same time.  Values are "first", "last", and "all".  Defaults to "all".
     *
     * @example
     * ~~~
     * // Define a two-direction dpad, with two keys each bound to the right and left directions
     * Crafty.s("Controls").defineDpad("MyDpad", {RIGHT_ARROW: 0, LEFT_ARROW: 180, D: 0, A: 180});
     * ~~~
     *
     * @see .destroyDpad
     * @see Crafty.keys
     * @see Controllable
     * @see Multiway
     */ defineDpad: function(name, definition, options) {
                    var directionDict = {};
                    for(var k in definition){
                        var direction = definition[k];
                        var keyCode = Crafty.keys[k] || k;
                        // create a mapping of directions to all associated keycodes
                        if (!directionDict[direction]) directionDict[direction] = [];
                        directionDict[direction].push(new KeyboardToggleInput(keyCode));
                    }
                    // Create a useful definition from the input format that tracks state
                    var parsedDefinition = {};
                    for(var d in directionDict)parsedDefinition[d] = {
                        input: new ToggleInputGroup(directionDict[d]),
                        active: false,
                        n: this.parseDirection(d)
                    };
                    if (typeof options === "undefined") options = {};
                    if (typeof options.normalize === "undefined") options.normalize = false;
                    if (typeof options.multipleDirectionBehavior === "undefined") options.multipleDirectionBehavior = "all";
                    // Create the fully realized dpad object
                    // Store the name/definition pair
                    this.destroyDpad(name);
                    this._dpads[name] = {
                        name: name,
                        directions: parsedDefinition,
                        x: 0,
                        y: 0,
                        oldX: 0,
                        oldY: 0,
                        event: {
                            x: 0,
                            y: 0,
                            name: name
                        },
                        normalize: options.normalize,
                        multipleDirectionBehavior: options.multipleDirectionBehavior
                    };
                    Crafty.trigger("ControlDefined", {
                        type: "Dpad",
                        name: name
                    });
                },
                /**@
     * #.destroyDpad
     * @comp Controls
     * @kind Method
     *
     * @sign destroyDpad(string name)
     * @param name - the name of the dpad input
     *
     * Destroys a previously defined dpad.
     *
     * @see .defineDpad
     */ destroyDpad: function(name) {
                    if (this._dpads[name]) {
                        for(var d in this._dpads[name].parsedDefinition)this._dpads[name].parsedDefinition[d].input.destroy();
                        delete this._dpads[name];
                        Crafty.trigger("ControlDestroyed", {
                            type: "Dpad",
                            name: name
                        });
                    }
                },
                // Takes an amount in degrees and converts it to an x/y object.
                // Clamps to avoid rounding issues with sin/cos
                parseDirection: function(direction) {
                    return {
                        x: Math.round(Math.cos(direction * (Math.PI / 180)) * 1000) / 1000,
                        y: Math.round(Math.sin(direction * (Math.PI / 180)) * 1000) / 1000
                    };
                },
                // dpad definition is a map of directions to keys array and active flag
                updateActiveDirection: function(dpad, normalize) {
                    var x = 0, y = 0;
                    // Sum up all active directions
                    for(var d in dpad.directions){
                        var dir = dpad.directions[d];
                        if (!dir.active) continue;
                        x += dir.n.x;
                        y += dir.n.y;
                    }
                    // Mitigate rounding errors when close to zero movement
                    x = -0.0000000001 < x && x < 1e-10 ? 0 : x;
                    y = -0.0000000001 < y && y < 1e-10 ? 0 : y;
                    // Normalize
                    if (normalize) {
                        var m = Math.sqrt(x * x + y * y);
                        if (m > 0) {
                            x /= m;
                            y /= m;
                        }
                    }
                    dpad.x = x;
                    dpad.y = y;
                },
                updateTriggerInput: function(trigger) {
                    if (!trigger.active) {
                        if (trigger.input.isActive()) {
                            trigger.downFor = Date.now() - trigger.input.timeDown;
                            trigger.active = true;
                            Crafty.trigger("TriggerInputDown", trigger);
                        }
                    } else if (!trigger.input.isActive()) {
                        trigger.active = false;
                        Crafty.trigger("TriggerInputUp", trigger);
                        trigger.downFor = 0;
                    }
                },
                // Has to handle three cases concerning multiple active input groups:
                // - "all": all directions are active
                // - "last": one direction at a time, new directions replace old ones
                // - "first": one direction at a time, new directions are ignored while old ones are still active
                updateDpadInput: function(dpad, multiBehavior) {
                    var d, dir;
                    var winner;
                    for(d in dpad.directions){
                        dir = dpad.directions[d];
                        dir.active = false;
                        if (dir.input.isActive()) {
                            if (multiBehavior === "all") dir.active = true;
                            else if (!winner) winner = dir;
                            else {
                                if (multiBehavior === "first") {
                                    if (winner.input.timeDown > dir.input.timeDown) winner = dir;
                                }
                                if (multiBehavior === "last") {
                                    if (winner.input.timeDown < dir.input.timeDown) winner = dir;
                                }
                            }
                        }
                    }
                    // If we picked a winner, set it active
                    if (winner) winner.active = true;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    4: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #Draggable
 * @category Controls
 * @kind Component
 * Enable drag and drop of the entity. Listens to events from `MouseDrag` and moves entity accordingly.
 *
 * @see MouseDrag
 */ Crafty.c("Draggable", {
                _origX: null,
                _origY: null,
                _oldX: null,
                _oldY: null,
                _dir: null,
                required: "MouseDrag",
                events: {
                    StartDrag: "_startDrag",
                    Dragging: "_drag"
                },
                /**@
     * #.enableDrag
     * @comp Draggable
     * @kind Method
     *
     * @sign public this .enableDrag(void)
     *
     * Reenable dragging of entity. Use if `.disableDrag` has been called.
     *
     * @see .disableDrag
     */ enableDrag: function() {
                    this.uniqueBind("Dragging", this._drag);
                    return this;
                },
                /**@
     * #.disableDrag
     * @comp Draggable
     * @kind Method
     *
     * @sign public this .disableDrag(void)
     *
     * Disables entity dragging. Reenable with `.enableDrag()`.
     *
     * @see .enableDrag
     */ disableDrag: function() {
                    this.unbind("Dragging", this._drag);
                    return this;
                },
                /**@
     * #.dragDirection
     * @comp Draggable
     * @kind Method
     *
     * Method used for modifying the drag direction.
     * If direction is set, the entity being dragged will only move along the specified direction.
     * If direction is not set, the entity being dragged will move along any direction.
     *
     * @sign public this .dragDirection()
     * Remove any previously specified direction.
     *
     * @sign public this .dragDirection(vector)
     * @param vector - Of the form of {x: valx, y: valy}, the vector (valx, valy) denotes the move direction.
     *
     * @sign public this .dragDirection(degree)
     * @param degree - A number, the degree (clockwise) of the move direction with respect to the x axis.
     *
     * Specify the dragging direction.
     *
     * @example
     * ~~~
     * this.dragDirection()
     * this.dragDirection({x:1, y:0}) //Horizontal
     * this.dragDirection({x:0, y:1}) //Vertical
     * // Note: because of the orientation of x and y axis,
     * // this is 45 degree clockwise with respect to the x axis.
     * this.dragDirection({x:1, y:1}) //45 degree.
     * this.dragDirection(60) //60 degree.
     * ~~~
     */ dragDirection: function(dir) {
                    if (typeof dir === "undefined") this._dir = null;
                    else if (+dir === dir) //dir is a number
                    this._dir = {
                        x: Math.cos(dir / 180 * Math.PI),
                        y: Math.sin(dir / 180 * Math.PI)
                    };
                    else if (dir.x === 0 && dir.y === 0) this._dir = {
                        x: 0,
                        y: 0
                    };
                    else {
                        var r = Math.sqrt(dir.x * dir.x + dir.y * dir.y);
                        this._dir = {
                            x: dir.x / r,
                            y: dir.y / r
                        };
                    }
                    return this;
                },
                _startDrag: function(e) {
                    this._origX = e.realX;
                    this._origY = e.realY;
                    this._oldX = this._x;
                    this._oldY = this._y;
                },
                //Note: the code is not tested with zoom, etc., that may distort the direction between the viewport and the coordinate on the canvas.
                _drag: function(e) {
                    if (this._dir) {
                        if (this._dir.x !== 0 || this._dir.y !== 0) {
                            var len = (e.realX - this._origX) * this._dir.x + (e.realY - this._origY) * this._dir.y;
                            this.x = this._oldX + len * this._dir.x;
                            this.y = this._oldY + len * this._dir.y;
                        }
                    } else {
                        this.x = this._oldX + (e.realX - this._origX);
                        this.y = this._oldY + (e.realY - this._origY);
                    }
                }
            });
            /**@
 * #Controllable
 * @category Controls
 * @kind Component
 *
 * Used to bind methods to generalized input events.
 *
 * Currently supports the events "DirectionalInput", "TriggerInputDown", and "TriggerInputUp".
 *
 */ Crafty.c("Controllable", {
                init: function() {
                    this._inputBindings = {
                        DirectionalInput: {},
                        TriggerInputDown: {},
                        TriggerInputUp: {}
                    };
                },
                events: {
                    // We don't want to use dot notation here for the property names
                    /* jshint -W069 */ DirectionalInput: function(e) {
                        if (this._inputBindings["DirectionalInput"][e.name]) this._inputBindings["DirectionalInput"][e.name].call(this, e);
                    },
                    TriggerInputDown: function(e) {
                        if (this._inputBindings["TriggerInputDown"][e.name]) this._inputBindings["TriggerInputDown"][e.name].call(this, e);
                    },
                    TriggerInputUp: function(e) {
                        if (this._inputBindings["TriggerInputUp"][e.name]) this._inputBindings["TriggerInputUp"][e.name].call(this, e);
                    }
                },
                /**@
     * #.linkInput
     * @comp Controllable
     * @kind Method
     *
     * @sign public this linkInput(string event, string name, function fn)
     * @param event - the name of the input event
     * @param name - the name of the input
     * @param fn - the function that will be called with the event object
     *
     * Binds the function to the particular named event trigger.
     *
     * Currently supports three types of input events.  Each event will have a `name` property.
     * - `DirectionalInput`: The event will have `x` and `y` properties representing the directional input vector, often normalized to a unit vector.  Triggered when the input changes.
     * - `TriggerInputDown`: Occurs when the input is triggered.
     * - `TriggerInputDown`: Occurs when the trigger is released.  The event will have a `downFor` property, indicating how long it had been active.
     *
     * @example
     * ~~~~
     * // Create a trigger bound to the `b` key
     * Crafty.s("Controls").defineTriggerGroup("BlushTrigger", {keys:['b']});
     * // Create a blue square that turns pink when the trigger is pressed
     * Crafty.e("2D, Canvas, Color, Controllable")
     *   .attr({x:10, y:10, h:10, w:10}).color("blue")
     *   .linkInput("TriggerInputDown", "BlushTrigger", function(){this.color('pink');});
     * ~~~
     *
     * @see .unlinkInput
     */ linkInput: function(event, name, fn) {
                    this._inputBindings[event][name] = fn;
                    return this;
                },
                /**@
     * #.unlinkInput
     * @comp Controllable
     * @kind Method
     *
     * @sign public this linkInput(string event, string name)
     * @param event - the name of the input event
     * @param name - the name of the input
     *
     * Removes a binding setup by linkInput
     *
     * @see .linkInput
     */ unlinkInput: function(event, name) {
                    delete this._inputBindings[event][name];
                    return this;
                },
                disableControls: false,
                /**@
     * #.enableControl
     * @comp Controllable
     * @kind Method
     *
     * @sign public this .enableControl()
     *
     * Enable the component to listen to input events.
     *
     * @example
     * ~~~
     * this.enableControl();
     * ~~~
     */ enableControl: function() {
                    this.disableControls = false;
                    return this;
                },
                /**@
     * #.disableControl
     * @comp Controllable
     * @kind Method
     *
     * @sign public this .disableControl()
     *
     * Disable the component from responding to input events.
     *
     * @example
     * ~~~
     * this.disableControl();
     * ~~~
     */ disableControl: function() {
                    this.disableControls = true;
                    return this;
                }
            });
            /**@
 * #Multiway
 * @category Controls
 * @kind Component
 *
 * Used to bind keys to directions and have the entity move accordingly.
 *
 * Multiway acts by listening to directional events, and then setting the velocity each frame based on the current direction and the current speed.
 *
 * If a speed is not defined for a particular axis (x or y), then the velocity along that axis will not be set.
 *
 * This behavior works in most cases, but can cause undesired behavior if you manipulate velocities by yourself while this component is in effect.
 * If you need to resolve collisions, it's advised to correct the position directly rather than to manipulate the velocity.
 * If you still need to reset the velocity once a collision happens, make sure to re-add the previous velocity once the collision is resolved.
 *
 * Additionally, this component provides the entity with `Motion` methods & events.
 *
 * @see Motion
 */ Crafty.c("Multiway", {
                _speed: null,
                init: function() {
                    this.requires("Motion, Controllable");
                    this._dpadName = "MultiwayDpad" + this[0];
                    this._speed = {
                        x: 150,
                        y: 150
                    };
                    this._direction = {
                        x: 0,
                        y: 0
                    };
                },
                remove: function() {
                    if (!this.disableControls) this.vx = this.vy = 0;
                    this.unlinkInput("DirectionalInput", this._dpadName);
                    Crafty.s("Controls").destroyDpad(this._dpadName);
                },
                events: {
                    UpdateFrame: function() {
                        if (!this.disableControls) {
                            if (typeof this._speed.x !== "undefined" && this._speed.x !== null) this.vx = this._speed.x * this._direction.x;
                            if (typeof this._speed.y !== "undefined" && this._speed.y !== null) this.vy = this._speed.y * this._direction.y;
                        }
                    }
                },
                // Rather than update the velocity directly in response to changing input, track the input direction separately
                // That makes it easier to enable/disable control
                _updateDirection: function(e) {
                    this._direction.x = e.x;
                    this._direction.y = e.y;
                },
                /**@
     * #.multiway
     * @comp Multiway
     * @kind Method
     *
     * @sign public this .multiway([Number speed,] Object keyBindings[, Object options])
     * @param speed - A speed in pixels per second
     * @param keyBindings - What keys should make the entity go in which direction. Direction is specified in degrees
     * @param options - An object with options for `normalize` and `multipleDirectionBehavior`.
     *
     * Constructor to initialize the speed and keyBindings.
     * Component will listen to key events and move the entity appropriately.
     * Can be called while a key is pressed to change direction & speed on the fly.
     *
     * The options parameter controls the behavior of the component, and has the following defaults:
     *
     *  - `"normalize": false`.  When set to true, the directional input always has a magnitude of 1
     *  - `"multipleDirectionBehavior": "all"` How to resolve multiple active directions.
     *     Set to "first" or "last" to allow only one active direction at a time.
     *
     *  @example
     * ~~~
     * this.multiway(150, {UP_ARROW: -90, DOWN_ARROW: 90, RIGHT_ARROW: 0, LEFT_ARROW: 180});
     * this.multiway({x:150,y:75}, {UP_ARROW: -90, DOWN_ARROW: 90, RIGHT_ARROW: 0, LEFT_ARROW: 180});
     * this.multiway({W: -90, S: 90, D: 0, A: 180});
     * ~~~
     *
     * @see Crafty.keys
     */ multiway: function(speed, keys, options) {
                    var inputSystem = Crafty.s("Controls");
                    if (keys) this.speed(speed);
                    else keys = speed;
                    inputSystem.defineDpad(this._dpadName, keys, options);
                    this.linkInput("DirectionalInput", this._dpadName, this._updateDirection);
                    return this;
                },
                /**@
     * #.speed
     * @comp Multiway
     * @kind Method
     *
     * @sign public this .speed(Object speed)
     * @param speed - New speed the entity has, for x and y axis.
     *
     * Change the speed that the entity moves with, in units of pixels per second.
     * Can be called while a key is pressed to change speed on the fly.
     *
     * If the passed object has only an x or y property, only the velocity along that axis will be controlled.
     *
     * @example
     * ~~~
     * this.speed({ x: 150, y: 50 });
     * ~~~
     */ speed: function(speed) {
                    if (typeof speed === "object") {
                        this._speed.x = speed.x;
                        this._speed.y = speed.y;
                    } else {
                        this._speed.x = speed;
                        this._speed.y = speed;
                    }
                    return this;
                }
            });
            /**@
 * #Jumper
 * @category Controls
 * @kind Component
 * @trigger CheckJumping - When entity is about to jump. This event is triggered with the object the entity is about to jump from (if it exists). Third parties can respond to this event and enable the entity to jump.
 *
 * Make the entity jump in response to key events.
 * Simulates jumping and falling when used with the `Gravity` component.
 *
 * Additionally, this component provides the entity with `Supportable`, `Motion` and `Keyboard` methods & events.
 *
 * @see Supportable, Motion, Keyboard, Gravity
 */ Crafty.c("Jumper", {
                _jumpSpeed: 300,
                /**@
     * #.canJump
     * @comp Jumper
     * @kind Method
     *
     * The canJump function determines if the entity is allowed to jump or not (e.g. perhaps the entity should be able to double jump).
     * The Jumper component will trigger a "CheckJumping" event.
     * Interested parties can listen to this event and enable the entity to jump by setting `canJump` to true.
     *
     * @example
     * ~~~
     * var player = Crafty.e("2D, Jumper");
     * player.hasDoubleJumpPowerUp = true; // allow player to double jump by granting him a powerup
     * player.bind("CheckJumping", function(ground) {
     *     if (!ground && player.hasDoubleJumpPowerUp) { // allow player to double jump by using up his double jump powerup
     *         player.canJump = true;
     *         player.hasDoubleJumpPowerUp = false;
     *     }
     * });
     * player.bind("LandedOnGround", function(ground) {
     *     player.hasDoubleJumpPowerUp = true; // give player new double jump powerup upon landing
     * });
     * ~~~
     */ canJump: true,
                init: function() {
                    this.requires("Supportable, Motion, Controllable");
                },
                remove: function() {
                    this.unlinkInput("TriggerInputDown", this._jumpTriggerName);
                    Crafty.s("Controls").destroyTriggerGroup(this._jumpTriggerName);
                },
                _keydown_jumper: function(e) {
                    if (this.disableControls) return;
                    this.jump();
                },
                /**@
     * #.jump
     * @comp Jumper
     * @kind Method
     *
     * @sign public this .jump()
     *
     * Directly trigger the entity to jump.
     *
     */ jump: function() {
                    var ground = this.ground;
                    this.canJump = !!ground;
                    this.trigger("CheckJumping", ground);
                    if (this.canJump) this.vy = -this._jumpSpeed;
                    return this;
                },
                /**@
     * #.jumper
     * @comp Jumper
     * @kind Method
     *
     * @sign public this .jumper([Number jumpSpeed,] Array jumpKeys)
     * @param jumpSpeed - Vertical jump speed in pixels per second
     * @param jumpKeys - Keys to listen for and make entity jump in response
     *
     * @sign public this .jumper([Number jumpSpeed,] Object jumpInputs)
     * @param jumpSpeed - Vertical jump speed in pixels per second
     * @param jumpInputs - An object with two properties, `keys` and `mouseButtons`.
     *
     * Constructor to initialize the power of jump and keys to listen to.
     * Component will listen for key events and make the entity jump appropriately.
     *
     * If second argument is an object, the properties `keys` and `mouseButtons` will be used as triggers.
     *
     * @example
     * ~~~
     * this.jumper(300, ['UP_ARROW', 'W']);
     * this.jumper(['UP_ARROW', 'W']);
     * ~~~
     *
     * @see Crafty.keys
     */ jumper: function(jumpSpeed, jumpKeys) {
                    if (jumpKeys) this._jumpSpeed = jumpSpeed;
                    else jumpKeys = jumpSpeed;
                    this._jumpTriggerName = "JumpTrigger" + this[0];
                    if (Array.isArray(jumpKeys)) {
                        var keys = [];
                        for(var i = 0; i < jumpKeys.length; ++i){
                            var key = jumpKeys[i];
                            var keyCode = Crafty.keys[key] || key;
                            keys.push(keyCode);
                        }
                        Crafty.s("Controls").defineTriggerGroup(this._jumpTriggerName, {
                            keys: keys
                        });
                    } else Crafty.s("Controls").defineTriggerGroup(this._jumpTriggerName, jumpKeys);
                    this.linkInput("TriggerInputDown", this._jumpTriggerName, this._keydown_jumper);
                    return this;
                },
                /**@
     * #.jumpSpeed
     * @comp Jumper
     * @kind Method
     *
     * @sign public this .jumpSpeed(Number jumpSpeed)
     * @param jumpSpeed - new vertical jump speed
     *
     * Change the vertical jump speed.
     *
     * @example
     * ~~~
     * this.jumpSpeed(300);
     * ~~~
     */ jumpSpeed: function(jumpSpeed) {
                    this._jumpSpeed = jumpSpeed;
                    return this;
                }
            });
            /**@
 * #Fourway
 * @category Controls
 * @kind Component
 *
 * Move an entity in four directions by using the
 * `Up Arrow`, `Left Arrow`, `Down Arrow`, `Right Arrow` keys or `W`, `A`, `S`, `D`.
 *
 * This component is a thin wrapper around the `Multiway` component and sets the appropriate key bindings.
 * It is a well suited for games with a top-down (birds-eye) perspective.
 *
 * @see Multiway
 * @see Motion
 */ Crafty.c("Fourway", {
                init: function() {
                    this.requires("Multiway");
                },
                /**@
     * #.fourway
     * @comp Fourway
     * @kind Method
     *
     * @sign public this .fourway([Number speed[, Object options]])
     * @param speed - The speed of motion in pixels per second.
     * @param options - A dictionary of options passed through to the underlying Multiway component
     *
     * Initialize the component with the given speed and options.  See the Multiway component for available options.
     *
     * @example
     * ~~~
     * Crafty.e("2D, Color, Fourway")
     *    .attr({x: 100, y: 100, w: 50, h:50})
     *    .color("green")
     *    .fourway(100, {normalize:true});
     * ~~~
     * Create a green square controlled by the arrow keys and WASD, with diagonal movement normalized to the given speed.
     *
     * The speed is in units of pixels per second.
     */ fourway: function(speed, options) {
                    this.multiway(speed || this._speed, {
                        UP_ARROW: -90,
                        DOWN_ARROW: 90,
                        RIGHT_ARROW: 0,
                        LEFT_ARROW: 180,
                        W: -90,
                        S: 90,
                        D: 0,
                        A: 180,
                        Z: -90,
                        Q: 180
                    }, options);
                    return this;
                }
            });
            /**@
 * #Twoway
 * @category Controls
 * @kind Component
 *
 * Move an entity left or right using the `Left Arrow`, `Right Arrow` keys or `D` and `A`
 * and make it jump using `Up Arrow` or `W`.
 * Simulates jumping and falling when used with the `Gravity` component.
 *
 * This component is a thin wrapper around the `Multiway` and `Jumper` components and sets the appropriate key bindings.
 * It is a well suited for side-scrolling platformer type games.
 *
 * @see Multiway, Jumper
 */ Crafty.c("Twoway", {
                init: function() {
                    this.requires("Multiway, Jumper");
                },
                /**@
     * #.twoway
     * @comp Twoway
     * @kind Method
     *
     * @sign public this .twoway([Number speed[, Number jumpSpeed]])
     * @param speed - A speed in pixels per second
     * @param jumpSpeed - Vertical jump speed in pixels per second
     *
     * Constructor to initialize the speed and power of jump.
     * Component will listen for key events and move the entity
     * in the respective direction by the speed passed in the argument.
     * Pressing the jump key will cause the entity to jump with the supplied power.
     */ twoway: function(speed, jumpSpeed) {
                    // Set multiway with horizontal speed only
                    var hSpeed = speed || this._speed;
                    this.multiway({
                        x: hSpeed
                    }, {
                        RIGHT_ARROW: 0,
                        LEFT_ARROW: 180,
                        D: 0,
                        A: 180,
                        Q: 180
                    });
                    this.jumper(jumpSpeed || speed * 2 || this._jumpSpeed, [
                        Crafty.keys.UP_ARROW,
                        Crafty.keys.W,
                        Crafty.keys.Z
                    ]);
                    return this;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    5: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #KeyboardState
 * @category Input
 * @kind Component
 *
 * Handles valid key related events and key states for the entity.
 * @note This is an internally used component, automatically included in the `KeyboardSystem`.
 *
 * @trigger KeyDown - when a key is pressed - KeyboardEvent
 * @trigger KeyUp - when a key is released - KeyboardEvent
 *
 * The standard Crafty `KeyboardEvent` object:
 * ~~~
 * // event name of key event
 * e.eventName
 *
 * // Normalized keyCode number according to `Crafty.keys`
 * e.key
 *
 * // Original keyboard event, containing additional native properties
 * e.originalEvent
 * ~~~
 *
 * In addition to binding to these events, the current state (pressed/released) of a key can also be queried using the `.isKeyDown` method.
 *
 * @see Keyboard, KeyboardSystem
 * @see Crafty.keys
 */ Crafty.__keyboardStateTemplate = {
                _keyDown: null,
                init: function() {
                    this._keyDown = {};
                    // use custom trigger method if specified
                    this.triggerKeyEvent = this.triggerKeyEvent || this.trigger;
                },
                /**@
     * #.isKeyDown
     * @comp KeyboardState
     * @kind Method
     *
     * @sign public Boolean isKeyDown(String keyName)
     * @param keyName - Name of the key to check. See `Crafty.keys`.
     * @returns The pressed state of the key
     *
     * @sign public Boolean isKeyDown(Number keyCode)
     * @param keyCode - Key code in `Crafty.keys`.
     * @returns The pressed state of the key
     *
     * Determine if a certain key is currently down.
     *
     * @example
     * ~~~
     * ent.bind('UpdateFrame', function() {
     *   if (Crafty.s('Keyboard').isKeyDown('SPACE'))
     *     this.y--;
     * });
     * ~~~
     *
     * @see .resetKeyDown
     * @see Crafty.keys
     */ isKeyDown: function(key) {
                    if (typeof key === "string") key = Crafty.keys[key];
                    return !!this._keyDown[key];
                },
                /**@
     * #.resetKeyDown
     * @comp KeyboardState
     * @kind Method
     *
     * @sign public this .resetKeyDown()
     *
     * Reset all currently pressed keys. Triggers appropriate "KeyUp" events.
     *
     * This method is called internally, but may be useful when running Crafty in headless mode.
     *
     * @see .isKeyDown
     * @see Crafty.keys
     */ resetKeyDown: function() {
                    var evt = {
                        key: -1,
                        eventName: "KeyUp"
                    };
                    // Tell all the keys they're no longer held down
                    var keyDown = this._keyDown;
                    for(var k in keyDown)if (keyDown[k] === true) {
                        evt.key = +k; // convert k propertyString to number!
                        this.triggerKey("KeyUp", evt);
                    }
                    return this;
                },
                /**@
     * #.triggerKey
     * @comp KeyboardState
     * @kind Method
     *
     * @sign public this triggerKey(String eventName, Object eventData)
     * @param eventName - Name of the key event to trigger ("KeyDown" or "KeyUp")
     * @param eventData - The key event to trigger
     *
     * Try to trigger a key event on this entity and persist the key state.
     * This method prevents inconsistent key state.
     * e.g. If this entity didn't receive a "KeyDown" previously, it won't fire a "KeyUp" event.
     *
     * This method is called internally, but may be useful when running Crafty in headless mode.
     *
     * @example
     * ~~~
     * var wasTriggered = false;
     *
     * ent.requires('KeyboardState')
     *    .bind('KeyUp', function(evt) {
     *       wasTriggered = true;
     *    })
     *    .triggerKey('KeyUp', { key: Crafty.keys.RIGHT_ARROW });
     *
     * Crafty.log(wasTriggered); // prints false
     * ~~~
     *
     * @see Crafty.keys
     */ triggerKey: function(eventName, eventData) {
                    // trigger event only if valid state
                    var key = eventData.key;
                    if (eventName === "KeyDown") // ignore KeyDown due to inconsistent state caused by loosing focus
                    {
                        if (this._keyDown[key] !== true) {
                            this._keyDown[key] = true;
                            this.triggerKeyEvent(eventName, eventData);
                        }
                    } else if (eventName === "KeyUp") // ignore KeyUp due to inconsistent state caused by loosing focus
                    {
                        if (this._keyDown[key] === true) {
                            this._keyDown[key] = false;
                            this.triggerKeyEvent(eventName, eventData);
                        }
                    } else // trigger the event otherwise
                    this.triggerKeyEvent(eventName, eventData);
                    return this;
                }
            };
            Crafty.c("KeyboardState", Crafty.__keyboardStateTemplate);
            // define a basic Keyboard system for headless mode
            // will be substituted with proper one in browser mode
            Crafty.s("Keyboard", Crafty.extend.call({
                // this method will be called by KeyboardState iff triggerKey event was valid
                triggerKeyEvent: function(eventName, e) {
                    Crafty.trigger(eventName, e);
                }
            }, Crafty.__keyboardStateTemplate), {}, false);
        },
        {
            "../core/core.js": 10
        }
    ],
    6: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            Crafty.extend({
                /**@
     * #Crafty.keys
     * @category Input
     * @kind Property
     *
     * Object of key names and the corresponding Unicode key code.
     *
     * ~~~
     * BACKSPACE: 8,
     * TAB: 9,
     * ENTER: 13,
     * PAUSE: 19,
     * CAPS: 20,
     * ESC: 27,
     * SPACE: 32,
     * PAGE_UP: 33,
     * PAGE_DOWN: 34,
     * END: 35,
     * HOME: 36,
     * LEFT_ARROW: 37,
     * UP_ARROW: 38,
     * RIGHT_ARROW: 39,
     * DOWN_ARROW: 40,
     * INSERT: 45,
     * DELETE: 46,
     * 0: 48,
     * 1: 49,
     * 2: 50,
     * 3: 51,
     * 4: 52,
     * 5: 53,
     * 6: 54,
     * 7: 55,
     * 8: 56,
     * 9: 57,
     * A: 65,
     * B: 66,
     * C: 67,
     * D: 68,
     * E: 69,
     * F: 70,
     * G: 71,
     * H: 72,
     * I: 73,
     * J: 74,
     * K: 75,
     * L: 76,
     * M: 77,
     * N: 78,
     * O: 79,
     * P: 80,
     * Q: 81,
     * R: 82,
     * S: 83,
     * T: 84,
     * U: 85,
     * V: 86,
     * W: 87,
     * X: 88,
     * Y: 89,
     * Z: 90,
     * NUMPAD_0: 96,
     * NUMPAD_1: 97,
     * NUMPAD_2: 98,
     * NUMPAD_3: 99,
     * NUMPAD_4: 100,
     * NUMPAD_5: 101,
     * NUMPAD_6: 102,
     * NUMPAD_7: 103,
     * NUMPAD_8: 104,
     * NUMPAD_9: 105,
     * MULTIPLY: 106,
     * ADD: 107,
     * SUBSTRACT: 109,
     * DECIMAL: 110,
     * DIVIDE: 111,
     * F1: 112,
     * F2: 113,
     * F3: 114,
     * F4: 115,
     * F5: 116,
     * F6: 117,
     * F7: 118,
     * F8: 119,
     * F9: 120,
     * F10: 121,
     * F11: 122,
     * F12: 123,
     * SHIFT: 16,
     * CTRL: 17,
     * ALT: 18,
     * PLUS: 187,
     * COMMA: 188,
     * MINUS: 189,
     * PERIOD: 190,
     * PULT_UP: 29460,
     * PULT_DOWN: 29461,
     * PULT_LEFT: 4,
     * PULT_RIGHT': 5
     * ~~~
     */ keys: {
                    BACKSPACE: 8,
                    TAB: 9,
                    ENTER: 13,
                    PAUSE: 19,
                    CAPS: 20,
                    ESC: 27,
                    SPACE: 32,
                    PAGE_UP: 33,
                    PAGE_DOWN: 34,
                    END: 35,
                    HOME: 36,
                    LEFT_ARROW: 37,
                    UP_ARROW: 38,
                    RIGHT_ARROW: 39,
                    DOWN_ARROW: 40,
                    INSERT: 45,
                    DELETE: 46,
                    "0": 48,
                    "1": 49,
                    "2": 50,
                    "3": 51,
                    "4": 52,
                    "5": 53,
                    "6": 54,
                    "7": 55,
                    "8": 56,
                    "9": 57,
                    A: 65,
                    B: 66,
                    C: 67,
                    D: 68,
                    E: 69,
                    F: 70,
                    G: 71,
                    H: 72,
                    I: 73,
                    J: 74,
                    K: 75,
                    L: 76,
                    M: 77,
                    N: 78,
                    O: 79,
                    P: 80,
                    Q: 81,
                    R: 82,
                    S: 83,
                    T: 84,
                    U: 85,
                    V: 86,
                    W: 87,
                    X: 88,
                    Y: 89,
                    Z: 90,
                    NUMPAD_0: 96,
                    NUMPAD_1: 97,
                    NUMPAD_2: 98,
                    NUMPAD_3: 99,
                    NUMPAD_4: 100,
                    NUMPAD_5: 101,
                    NUMPAD_6: 102,
                    NUMPAD_7: 103,
                    NUMPAD_8: 104,
                    NUMPAD_9: 105,
                    MULTIPLY: 106,
                    ADD: 107,
                    SUBSTRACT: 109,
                    DECIMAL: 110,
                    DIVIDE: 111,
                    F1: 112,
                    F2: 113,
                    F3: 114,
                    F4: 115,
                    F5: 116,
                    F6: 117,
                    F7: 118,
                    F8: 119,
                    F9: 120,
                    F10: 121,
                    F11: 122,
                    F12: 123,
                    SHIFT: 16,
                    CTRL: 17,
                    ALT: 18,
                    PLUS: 187,
                    COMMA: 188,
                    MINUS: 189,
                    PERIOD: 190,
                    PULT_UP: 29460,
                    PULT_DOWN: 29461,
                    PULT_LEFT: 4,
                    PULT_RIGHT: 5
                },
                /**@
     * #Crafty.mouseButtons
     * @category Input
     * @kind Property
     *
     * An object mapping mouseButton names to the corresponding button ID.
     * In all mouseEvents, we add the `e.mouseButton` property with a value normalized to match e.button of modern webkit browsers:
     *
     * ~~~
     * LEFT: 0,
     * MIDDLE: 1,
     * RIGHT: 2
     * ~~~
     */ mouseButtons: {
                    LEFT: 0,
                    MIDDLE: 1,
                    RIGHT: 2
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    7: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #MouseState
 * @category Input
 * @kind Component
 *
 * Handles valid mouse related events and button states for the entity.
 * @note This is an internally used component, automatically included in the `MouseSystem`.
 *
 * @trigger MouseDown - when a mouse button is pressed - MouseEvent
 * @trigger MouseMove - when the mouse moves - MouseEvent
 * @trigger MouseUp - when a mouse button is released - MouseEvent
 *
 * The standard Crafty `MouseEvent` object:
 * ~~~
 * // event name of mouse event
 * e.eventName
 *
 * // Normalized mouse button according to Crafty.mouseButtons:
 * // Crafty.mouseButtons.LEFT, Crafty.mouseButtons.RIGHT or Crafty.mouseButtons.MIDDLE
 * e.mouseButton
 *
 * // the closest (visible & Mouse-enhanced) entity to the source of the event (if available), otherwise null
 * e.target
 *
 * // (x,y) coordinates of mouse event in world (default viewport) space
 * e.realX
 * e.realY
 *
 * // Original mouse event, containing additional native properties
 * e.originalEvent
 * ~~~
 *
 * In addition to binding to these events, the current state (pressed/released) of a mouse button can also be queried using the `.isButtonDown` method.
 *
 * @see Mouse, MouseSystem
 * @see Crafty.mouseButtons
 */ Crafty.__mouseStateTemplate = {
                _buttonDown: null,
                /**@
     * #.lastMouseEvent
     * @comp MouseState
     * @kind Property
     *
     * Check which read-only mouse event occured most recently (useful for determining mouse position in every frame).
     *
     * @see Mouse, MouseSystem, Crafty.mouseButtons
     */ lastMouseEvent: null,
                init: function() {
                    this._buttonDown = {};
                    // use custom trigger method if specified
                    this.triggerMouseEvent = this.triggerMouseEvent || this.trigger;
                    this.lastMouseEvent = {
                        eventName: "",
                        mouseButton: -1,
                        target: null,
                        realX: 0,
                        realY: 0,
                        clientX: 0,
                        clientY: 0,
                        originalEvent: null
                    };
                },
                /**@
     * #.isButtonDown
     * @comp MouseState
     * @kind Method
     *
     * @sign public Boolean .isButtonDown(String mouseButtonName)
     * @param mouseButtonName - Name of the button to check. See `Crafty.mouseButtons`.
     * @returns The pressed state of the button
     *
     * @sign public Boolean .isButtonDown(Number buttonId)
     * @param buttonId - ButtonId in `Crafty.mouseButtons`.
     * @returns The pressed state of the button
     *
     * Determine if a certain mouse button is currently down.
     *
     * @example
     * ~~~
     * ent.bind('UpdateFrame', function() {
     *   if (Crafty.s('Mouse').isButtonDown('LEFT'))
     *     this.y--;
     * });
     * ~~~
     *
     * @see .resetButtonDown
     * @see Crafty.mouseButtons
     */ isButtonDown: function(button) {
                    if (typeof button === "string") button = Crafty.mouseButtons[button];
                    return !!this._buttonDown[button];
                },
                /**@
     * #.resetButtonDown
     * @comp MouseState
     * @kind Method
     *
     * @sign public this .resetButtonDown()
     *
     * Reset all currently pressed buttons. Triggers appropriate "MouseUp" events.
     *
     * This method is called internally, but may be useful when running Crafty in headless mode.
     *
     * @see .isButtonDown
     * @see Crafty.mouseButtons
     */ resetButtonDown: function() {
                    var lastEvent = this.lastMouseEvent;
                    // Tell all buttons they're no longer held down
                    var buttonsDown = this._buttonDown;
                    for(var button in buttonsDown)if (buttonsDown[button] === true) {
                        lastEvent.mouseButton = +button; // convert button propertyString to number!
                        lastEvent.eventName = "MouseUp";
                        this.triggerMouse("MouseUp", lastEvent);
                    }
                    return this;
                },
                /**@
     * #.triggerMouse
     * @comp MouseState
     * @kind Method
     *
     * @sign public this triggerMouse(String eventName, Object eventData)
     * @param eventName - Name of the mouse event to trigger ("MouseDown", "MouseUp", "MouseMove", ...)
     * @param eventData - The mouse event to trigger
     *
     * Try to trigger a mouse event on this entity and persist the button state.
     * This method prevents inconsistent button state.
     * e.g. If this entity didn't receive a "MouseDown" previously, it won't fire a "MouseUp" event.
     *
     * This method is called internally, but may be useful when running Crafty in headless mode.
     *
     * @example
     * ~~~
     * var wasTriggered = false;
     *
     * ent.requires('MouseState')
     *    .bind('MouseUp', function(evt) {
     *       wasTriggered = true;
     *    })
     *    .triggerMouse('MouseUp', { mouseButton: Crafty.mouseButtons.LEFT });
     *
     * Crafty.log(wasTriggered); // prints false
     * ~~~
     *
     * @see Crafty.mouseButtons
     */ triggerMouse: function(eventName, eventData) {
                    // copy newest event to lastEvent
                    var lastEvent = this.lastMouseEvent;
                    lastEvent.eventName = eventName;
                    lastEvent.mouseButton = eventData.mouseButton;
                    lastEvent.target = eventData.target;
                    lastEvent.realX = eventData.realX;
                    lastEvent.realY = eventData.realY;
                    lastEvent.clientX = eventData.clientX; // DEPRECATED: remove in upcoming release
                    lastEvent.clientY = eventData.clientY; // DEPRECATED: remove in upcoming release
                    lastEvent.originalEvent = eventData.originalEvent;
                    // trigger event only if valid state
                    var mouseButton = eventData.mouseButton;
                    if (eventName === "MouseDown") // ignore MouseDown due to inconsistent state caused by loosing focus
                    {
                        if (this._buttonDown[mouseButton] !== true) {
                            this._buttonDown[mouseButton] = true;
                            this.triggerMouseEvent(eventName, eventData);
                        }
                    } else if (eventName === "MouseUp") // ignore MouseUp due to inconsistent state caused by loosing focus
                    {
                        if (this._buttonDown[mouseButton] === true) {
                            this._buttonDown[mouseButton] = false;
                            this.triggerMouseEvent(eventName, eventData);
                        }
                    } else // trigger the event otherwise
                    this.triggerMouseEvent(eventName, eventData);
                    return this;
                }
            };
            Crafty.c("MouseState", Crafty.__mouseStateTemplate);
            // define a basic Mouse system for headless mode
            // will be substituted with proper one in browser mode
            Crafty.s("Mouse", Crafty.extend.call({
                // this method will be called by MouseState iff triggerMouse event was valid
                triggerMouseEvent: function(eventName, e) {
                    Crafty.trigger(eventName, e);
                }
            }, Crafty.__mouseStateTemplate), {}, false);
        },
        {
            "../core/core.js": 10
        }
    ],
    8: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #TouchState
 * @category Input
 * @kind Component
 *
 * Handles valid touch related events and touch points for the entity.
 * @note This is an internally used component, automatically included in the `TouchSystem`.
 *
 * @trigger TouchStart - when a finger is pressed - TouchPointEvent
 * @trigger TouchMove - when a pressed finger is moved - TouchPointEvent
 * @trigger TouchEnd - when a finger is raised - TouchPointEvent
 * @trigger TouchCancel - when a touch event has been disrupted in some way - TouchPointEvent
 *
 * The standard Crafty `TouchPointEvent` object:
 * ~~~
 * // event name of touch event
 * e.eventName
 *
 * // identifier for this touch point, unique over the duration the finger is on the touch surface
 * e.identifier
 *
 * // the closest (visible & Touch-enhanced) entity to the source of the event (if available), otherwise null
 * e.target
 *
 * // (x,y) coordinates of the touch point in world (default viewport) space
 * e.realX
 * e.realY
 *
 * // Original touch event, containing additional native properties
 * e.originalEvent
 * ~~~
 *
 * In addition to binding to these events, the current touch points can also be queried using the `.touchPoints` property.
 *
 * @see Touch, TouchSystem
 */ Crafty.__touchStateTemplate = {
                /**@
     * #.touchPoints
     * @comp TouchState
     * @kind Property
     *
     * Holds data of all currently pressed touch points (useful for determining positions of fingers in every frame).
     * Data of a touch point is lost when the respective finger is raised.
     *
     * @example
     * ~~~
     * var touchPoint, touchPoints = Crafty.s('Touch').touchPoints;
     * for (var i = 0, l = touchPoints.length; i < l; i++) {
     *   touchPoint = touchPoints[i];
     *   Crafty.log(touchPoint.realX, touchPoint.realY); // logs coordinates in Crafty's world space
     * }
     * ~~~
     *
     * @see .resetTouchPoints
     */ touchPoints: null,
                _touchPointsPool: null,
                init: function() {
                    this.touchPoints = [];
                    this._touchPointsPool = [];
                    // use custom trigger method if specified
                    this.triggerTouchEvent = this.triggerTouchEvent || this.trigger;
                },
                /**@
     * #.resetTouchPoints
     * @comp TouchState
     * @kind Method
     *
     * @sign public this .resetTouchPoints()
     *
     * Reset all current touch points. Triggers appropriate "TouchCancel" events.
     *
     * This method is called internally, but may be useful when running Crafty in headless mode.
     *
     * @see .touchPoints
     */ resetTouchPoints: function() {
                    // Tell all touch points they're no longer held down
                    var touchPoints = this.touchPoints, touchPoint, i = touchPoints.length;
                    while(i--){
                        // iterate backwards to avoid conflicts with removal of array elements
                        touchPoint = touchPoints[i];
                        touchPoint.eventName = "TouchCancel";
                        this.triggerTouch("TouchCancel", touchPoint);
                    }
                    return this;
                },
                /**@
     * #.triggerTouch
     * @comp TouchState
     * @kind Method
     *
     * @sign public this triggerTouch(String eventName, Object eventData)
     * @param eventName - Name of the touch event to trigger ("TouchStart", "TouchMove", "TouchEnd", "TouchCancel", ...)
     * @param eventData - The touch event to trigger
     *
     * Try to trigger a touch event on this entity and persist the touch point.
     * This method prevents inconsistent touch state.
     * e.g. If this entity didn't receive a "TouchStart" of a identifier previously, it won't fire a "TouchEnd" event for that identifier.
     *
     * This method is called internally, but may be useful when running Crafty in headless mode.
     *
     * @example
     * ~~~
     * var wasTriggered = false;
     *
     * ent.requires('TouchState')
     *    .bind('TouchEnd', function(evt) {
     *       wasTriggered = true;
     *    })
     *    .triggerTouch('TouchEnd', { identifier: 0 });
     *
     * Crafty.log(wasTriggered); // prints false
     * ~~~
     */ triggerTouch: function(eventName, eventData) {
                    switch(eventName){
                        case "TouchStart":
                            this._handleStart(eventData);
                            break;
                        case "TouchMove":
                            this._handleMove(eventData);
                            break;
                        case "TouchCancel":
                        case "TouchEnd":
                            this._handleEnd(eventData);
                            break;
                        default:
                            this.triggerTouchEvent(eventName, eventData); // trigger the event otherwise
                    }
                    return this;
                },
                _indexOfTouchPoint: function(identifier) {
                    var touchPoints = this.touchPoints;
                    for(var i = 0, l = touchPoints.length; i < l; i++){
                        if (touchPoints[i].identifier === identifier) return i;
                    }
                    return -1;
                },
                _setTouchPoint: function(touchPointDest, touchPointSrc) {
                    touchPointDest.eventName = touchPointSrc.eventName;
                    touchPointDest.identifier = touchPointSrc.identifier;
                    touchPointDest.target = touchPointSrc.target;
                    touchPointDest.entity = touchPointSrc.entity; // DEPRECATED: remove this in upcoming release
                    touchPointDest.realX = touchPointSrc.realX;
                    touchPointDest.realY = touchPointSrc.realY;
                    touchPointDest.originalEvent = touchPointSrc.originalEvent;
                },
                _handleStart: function(touchPoint) {
                    var oldIndex = this._indexOfTouchPoint(touchPoint.identifier), oldTouchPoint = oldIndex >= 0 ? this.touchPoints[oldIndex] : null;
                    if (!oldTouchPoint) {
                        // ignore TouchStart due to inconsistent state caused by loosing focus
                        // allocate touch point
                        var newTouchPoint = this._touchPointsPool.pop() || {};
                        this._setTouchPoint(newTouchPoint, touchPoint);
                        this.touchPoints.push(newTouchPoint);
                        this.triggerTouchEvent(newTouchPoint.eventName, newTouchPoint);
                    }
                },
                _handleMove: function(touchPoint) {
                    var oldIndex = this._indexOfTouchPoint(touchPoint.identifier), oldTouchPoint = oldIndex >= 0 ? this.touchPoints[oldIndex] : null;
                    if (oldTouchPoint) {
                        // ignore TouchMove due to inconsistent state caused by loosing focus
                        // update touch point
                        this._setTouchPoint(oldTouchPoint, touchPoint);
                        this.triggerTouchEvent(oldTouchPoint.eventName, oldTouchPoint);
                    }
                },
                _handleEnd: function(touchPoint) {
                    var oldIndex = this._indexOfTouchPoint(touchPoint.identifier), oldTouchPoint = oldIndex >= 0 ? this.touchPoints[oldIndex] : null;
                    if (oldTouchPoint) {
                        // ignore TouchEnd due to inconsistent state caused by loosing focus
                        this._setTouchPoint(oldTouchPoint, touchPoint);
                        this.triggerTouchEvent(oldTouchPoint.eventName, oldTouchPoint);
                        // free touch point
                        this.touchPoints.splice(oldIndex, 1);
                        oldTouchPoint.target = null; // release reference for possible GC
                        oldTouchPoint.entity = null; // DEPRECATED: remove this in upcoming release
                        oldTouchPoint.originalEvent = null; // release reference for possible GC
                        this._touchPointsPool.push(oldTouchPoint);
                    }
                }
            };
            Crafty.c("TouchState", Crafty.__touchStateTemplate);
            // define a basic Touch system for headless mode
            // will be substituted with proper one in browser mode
            Crafty.s("Touch", Crafty.extend.call({
                // this method will be called by TouchState iff triggerTouch event was valid
                triggerTouchEvent: function(eventName, e) {
                    Crafty.trigger(eventName, e);
                }
            }, Crafty.__touchStateTemplate), {}, false);
        },
        {
            "../core/core.js": 10
        }
    ],
    9: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #Crafty.easing
 * @category Animation
 * @kind Class
 *
 *
 * An object for tracking transitions.  Typically used indirectly through "SpriteAnimation", "Tween", or viewport animations.
 *
 * If a method allows you to specify the type of easing, you can do so by providing a custom function or a string corresponding to the name of a built-in method.
 *
 * Built-in easing functions are "linear", "smoothStep", "smootherStep", "easeInQuad", "easeOutQuad", and "easeInOutQuad".
 *
 * A custom function will be passed a parameter `t` which will vary between 0 and 1, and should return the progress of the animation between 0 and 1.
 * @example
 * Here is how you might use easing functions with the "Tween" component.
 * ~~~~
 * var e = Crafty.e("2D, Tween");
 * // Use built-in easing functions
 * e.tween({x:100}, 1000, "smoothStep");
 * e.tween({y:100}, 1000, "easeInQuad");
 * // Define a custom easing function: 2t^2 - t
 * e.tween({w:0}, 1000, function(t){return 2*t*t - t;});
 * ~~~
 * @see Tween, SpriteAnimation
 */ var easing = function(duration, easingFn) {
                this.timePerFrame = 1000 / Crafty.timer.FPS();
                this.duration = duration; //default duration given in ms
                if (typeof easingFn === "function") this.easing_function = easingFn;
                else if (typeof easingFn === "string" && this.standardEasingFunctions[easingFn]) this.easing_function = this.standardEasingFunctions[easingFn];
                else this.easing_function = this.standardEasingFunctions.linear;
                this.reset();
            };
            easing.prototype = {
                duration: 0,
                clock: 0,
                steps: null,
                complete: false,
                paused: false,
                // init values
                reset: function() {
                    this.loops = 1;
                    this.clock = 0;
                    this.complete = false;
                    this.paused = false;
                },
                repeat: function(loopCount) {
                    this.loops = loopCount;
                },
                setProgress: function(progress, loopCount) {
                    this.clock = this.duration * progress;
                    if (typeof loopCount !== "undefined") this.loops = loopCount;
                },
                pause: function() {
                    this.paused = true;
                },
                resume: function() {
                    this.paused = false;
                    this.complete = false;
                },
                // Increment the clock by some amount dt
                // Handles looping and sets a flag on completion
                tick: function(dt) {
                    if (this.paused || this.complete) return;
                    this.clock += dt;
                    this.frames = Math.floor(this.clock / this.timePerFrame);
                    while(this.clock >= this.duration && this.complete === false){
                        this.loops--;
                        if (this.loops > 0) this.clock -= this.duration;
                        else this.complete = true;
                    }
                },
                // same as value for now; with other time value functions would be more useful
                time: function() {
                    return Math.min(this.clock / this.duration, 1);
                },
                // Value is where along the tweening curve we are
                value: function() {
                    return this.easing_function(this.time());
                },
                // Easing functions, formulas taken from https://gist.github.com/gre/1650294
                //	and https://en.wikipedia.org/wiki/Smoothstep
                standardEasingFunctions: {
                    // no easing, no acceleration
                    linear: function(t) {
                        return t;
                    },
                    // smooth step; starts and ends with v=0
                    smoothStep: function(t) {
                        return (3 - 2 * t) * t * t;
                    },
                    // smootherstep; starts and ends with v, a=0
                    smootherStep: function(t) {
                        return (6 * t * t - 15 * t + 10) * t * t * t;
                    },
                    // quadratic curve; starts with v=0
                    easeInQuad: function(t) {
                        return t * t;
                    },
                    // quadratic curve; ends with v=0
                    easeOutQuad: function(t) {
                        return t * (2 - t);
                    },
                    // quadratic curve; starts and ends with v=0
                    easeInOutQuad: function(t) {
                        return t < 0.5 ? 2 * t * t : (4 - 2 * t) * t - 1;
                    }
                }
            };
            module.exports = easing;
        },
        {
            "../core/core.js": 10
        }
    ],
    10: [
        function(require1, module, exports) {
            var version = require1("./version");
            /**@
 * #Crafty
 * @category Core
 * @kind CoreObject
 *
 * `Crafty` is both an object, and a function for selecting entities.
 * Its many methods and properties are discussed individually.
 * Below is the documentation for use as a selector.
 *
 * @sign public EntitySelection Crafty( String selector)
 * @param selector - A string representing which entities to select
 *
 * @sign public Entity Crafty( Number selector )
 * @param selector - An entity's id
 *
 * Select a set of or single entities by components or an entity's ID.
 *
 * Crafty uses syntax similar to jQuery by having a selector engine to select entities by their components.
 *
 * If there is more than one match, the return value is an Array-like object listing the ID numbers of each matching entity. If there is exactly one match, the entity itself is returned. If you're not sure how many matches to expect, check the number of matches via Crafty(...).length. Alternatively, use Crafty(...).each(...), which works in all cases.
 *
 * @note You can treat an entity as if it was a selection of length 1 -- it implements all the same methods.
 *
 * @example
 * ~~~
 *    Crafty("MyComponent")
 *    Crafty("Hello 2D Component")
 *    Crafty("Hello, 2D, Component")
 * ~~~
 *
 * The first selector will return all entities that have the component `MyComponent`. The second will return all entities that have `Hello` and `2D` and `Component` whereas the last will return all entities that have at least one of those components (or).
 *
 * ~~~
 *   Crafty("*")
 * ~~~
 * Passing `*` will select all entities.
 *
 * ~~~
 *   Crafty(1)
 * ~~~
 * Passing an integer will select the entity with that `ID`.
 *
 * To work directly with an array of entities, use the `get()` method on a selection.
 * To call a function in the context of each entity, use the `.each()` method.
 *
 * The event related methods such as `bind` and `trigger` will work on selections of entities.
 *
 * @see Crafty Core#.get
 * @see Crafty Core#.each
 */ var Crafty = function(selector) {
                return new Crafty.fn.init(selector);
            };
            // Internal variables
            var GUID, frame, components, entities, handlers, onloads, compEntities, slice, rlist, rspace;
            components = {}; // Map of components and their functions
            slice = Array.prototype.slice;
            rlist = /\s*,\s*/;
            rspace = /\s+/;
            var initState = function() {
                GUID = 1; // GUID for entity IDs
                frame = 0;
                entities = {}; // Map of entities and their data
                compEntities = {}; // Map from componentName to (entityId -> entity)
                handlers = {}; // Global event handlers
                onloads = []; // Temporary storage of onload handlers
            };
            initState();
            /**@
 * #Crafty Core
 * @category Core
 * @kind CoreObject
 *
 * @trigger NewEntityName - After setting new name for entity - String - entity name
 * @trigger NewComponent - when a new component is added to the entity - String - Component
 * @trigger RemoveComponent - when a component is removed from the entity - String - Component
 * @trigger Remove - when the entity is removed by calling .destroy()
 *
 * A set of methods added to every single entity.
 */ Crafty.fn = Crafty.prototype = {
                init: function(selector) {
                    //select entities by component
                    if (typeof selector === "string") {
                        var elem = 0, e, and = false, or = false, del, comps, filteredCompEnts, compEnts, compEnts2, compEnt, i, l;
                        if (selector === "*") {
                            i = 0;
                            for(e in entities){
                                // entities is something like {2:entity2, 3:entity3, 11:entity11, ...}
                                // The for...in loop sets e to "2", "3", "11", ... i.e. all
                                // the entity ID numbers. e is a string, so +e converts to number type.
                                this[i] = +e;
                                i++;
                            }
                            this.length = i;
                            // if there's only one entity, return the actual entity
                            if (i === 1) return entities[this[0]];
                            return this;
                        }
                        //multiple components OR
                        if (selector.indexOf(",") !== -1) {
                            or = true;
                            del = rlist;
                        //deal with multiple components AND
                        } else if (selector.indexOf(" ") !== -1) {
                            and = true;
                            del = rspace;
                        }
                        if (or) {
                            comps = selector.split(del);
                            filteredCompEnts = {}; // populate object with union of keys from all sets
                            for(i = 0, l = comps.length; i < l; i++){
                                compEnts = compEntities[comps[i]];
                                for(compEnt in compEnts)filteredCompEnts[compEnt] = +compEnt; //convert to int
                            }
                            for(compEnt in filteredCompEnts)// add set elements to result
                            this[elem++] = filteredCompEnts[compEnt];
                        } else if (and) {
                            comps = selector.split(del);
                            filteredCompEnts = {}; // populate initial object with keys in common from first two sets
                            compEnts = compEntities[comps[0]];
                            compEnts2 = compEntities[comps[1]];
                            for(compEnt in compEnts)if (compEnts2[compEnt] !== undefined) filteredCompEnts[compEnt] = +compEnt; //convert to int
                            for(i = 2, l = comps.length; i < l; i++){
                                // strip initial object keys not in following sets
                                compEnts = compEntities[comps[i]];
                                for(compEnt in filteredCompEnts)if (compEnts[compEnt] === undefined) filteredCompEnts[compEnt] = -1;
                            }
                            for(compEnt in filteredCompEnts){
                                // add valid elements to result
                                i = filteredCompEnts[compEnt];
                                if (i >= 0) this[elem++] = i;
                            }
                        } else {
                            // single component selector
                            compEnts = compEntities[selector];
                            for(compEnt in compEnts)this[elem++] = +compEnt; //convert to int
                        }
                        this.length = elem; //length is the last index (already incremented)
                        // if there's only one entity, return the actual entity
                        if (elem === 1) return entities[this[elem - 1]];
                    } else {
                        //Select a specific entity
                        if (!selector) {
                            //nothin passed creates God entity
                            selector = 0;
                            if (!(selector in entities)) entities[selector] = this;
                        }
                        //if not exists, return undefined
                        if (!(selector in entities)) {
                            this.length = 0;
                            return this;
                        }
                        this[0] = selector;
                        this.length = 1;
                        //update from the cache
                        if (!this.__c) this.__c = {};
                        if (!this._callbacks) Crafty._addCallbackMethods(this);
                        //update to the cache if NULL
                        if (!entities[selector]) entities[selector] = this;
                        return entities[selector]; //return the cached selector
                    }
                    Crafty._addCallbackMethods(this);
                    return this;
                },
                /**@
     * #.setName
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .setName(String name)
     * @param name - A human readable name for debugging purposes.
     *
     * Set a human readable name for debugging purposes.
     *
     * @example
     * ~~~
     * var ent = Crafty.e().setName("Player");
     * ~~~
     *
     * @see Crafty Core#.getName
     */ setName: function(name) {
                    var entityName = String(name);
                    this._entityName = entityName;
                    this.trigger("NewEntityName", entityName);
                    return this;
                },
                /**@
     * #.getName
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .getName(String name)
     * @returns A human readable name for debugging purposes.
     *
     * Get the human readable name for debugging purposes.
     *
     * @example
     * ~~~
     * var ent = Crafty.e().setName("Player");
     * var name = ent.getName();
     * ~~~
     *
     * @see Crafty Core#.setName
     */ getName: function(name) {
                    return this._entityName;
                },
                /**@
     * #.addComponent
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .addComponent(String componentList)
     * @param componentList - A string of components to add separated by a comma `,`
     * @sign public this .addComponent(String Component1[, .., String ComponentN])
     * @param Component# - Component ID to add.
     *
     * Adds a component to the selected entities or entity.
     *
     * Components are used to extend the functionality of entities.
     * This means it will copy properties and assign methods to
     * augment the functionality of the entity.
     *
     * For adding multiple components, you can either pass a string with
     * all the component names (separated by commas), or pass each component name as
     * an argument.
     *
     * If the component has a function named `init` it will be called.
     *
     * If the entity already has the component, the component is skipped (nothing happens).
     *
     * @example
     * ~~~
     * this.addComponent("2D, Canvas");
     * this.addComponent("2D", "Canvas");
     * ~~~
     */ addComponent: function(id) {
                    var comps, compName, comp, c = 0;
                    //add multiple arguments
                    if (arguments.length === 1 && id.indexOf(",") !== -1) comps = id.split(rlist);
                    else comps = arguments;
                    //extend the components
                    for(; c < comps.length; c++){
                        compName = comps[c];
                        // If component already exists, continue
                        if (this.__c[compName] === true) continue;
                        this.__c[compName] = true;
                        // update map from component to (entityId -> entity)
                        (compEntities[compName] = compEntities[compName] || {})[this[0]] = this;
                        comp = components[compName];
                        // Copy all methods of the component
                        this.extend(comp);
                        // Add any required components
                        if (comp && "required" in comp) this.requires(comp.required);
                        // Define properties
                        if (comp && "properties" in comp) {
                            var props = comp.properties;
                            for(var propertyName in props)Object.defineProperty(this, propertyName, props[propertyName]);
                        }
                        // Bind events
                        if (comp && "events" in comp) {
                            var auto = comp.events;
                            for(var eventName in auto){
                                var fn = typeof auto[eventName] === "function" ? auto[eventName] : comp[auto[eventName]];
                                this.bind(eventName, fn);
                            }
                        }
                        // Call constructor function
                        if (comp && "init" in comp) comp.init.call(this);
                    }
                    this.trigger("NewComponent", comps);
                    return this;
                },
                /**@
     * #.toggleComponent
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .toggleComponent(String ComponentList)
     * @param ComponentList - A string of components to add or remove separated by a comma `,`
     * @sign public this .toggleComponent(String Component1[, .., String componentN])
     * @param Component# - Component ID to add or remove.
     *
     * Add or Remove Components from an entity.
     *
     * @example
     * ~~~
     * var e = Crafty.e("2D,DOM,Test");
     * e.toggleComponent("Test,Test2"); //Remove Test, add Test2
     * e.toggleComponent("Test,Test2"); //Add Test, remove Test2
     * ~~~
     *
     * ~~~
     * var e = Crafty.e("2D,DOM,Test");
     * e.toggleComponent("Test","Test2"); //Remove Test, add Test2
     * e.toggleComponent("Test","Test2"); //Add Test, remove Test2
     * e.toggleComponent("Test");         //Remove Test
     * ~~~
     */ toggleComponent: function(toggle) {
                    var i = 0, l, comps;
                    if (arguments.length > 1) {
                        l = arguments.length;
                        for(; i < l; i++)if (this.has(arguments[i])) this.removeComponent(arguments[i]);
                        else this.addComponent(arguments[i]);
                    //split components if contains comma
                    } else if (toggle.indexOf(",") !== -1) {
                        comps = toggle.split(rlist);
                        l = comps.length;
                        for(; i < l; i++)if (this.has(comps[i])) this.removeComponent(comps[i]);
                        else this.addComponent(comps[i]);
                    //single component passed
                    } else if (this.has(toggle)) this.removeComponent(toggle);
                    else this.addComponent(toggle);
                    return this;
                },
                /**@
     * #.requires
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .requires(String componentList)
     * @param componentList - List of components that must be added
     *
     * @sign public this .addComponent(String component1, String component2[, .. , ComponentN])
     * @param Component# - A component to add
     *
     * Makes sure the entity has the components listed. If the entity does not
     * have the component, it will add it.
     *
     * (In the current version of Crafty, this function behaves exactly the same
     * as `addComponent`. By convention, developers have used `requires` for
     * component dependencies -- i.e. to indicate specifically that one component
     * will only work properly if another component is present -- and used
     * `addComponent` in all other situations.)
     *
     * @see .addComponent
     */ requires: function() {
                    return this.addComponent.apply(this, arguments);
                },
                /**@
     * #.removeComponent
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .removeComponent(String Component[, soft])
     * @param component - Component to remove
     * @param soft - Whether to soft remove it (defaults to `true`)
     *
     * Removes a component from an entity. A soft remove (the default) will only
     * refrain `.has()` from returning true. Hard will remove all
     * associated properties and methods.
     *
     * @example
     * ~~~
     * var e = Crafty.e("2D,DOM,Test");
     * e.removeComponent("Test");        //Soft remove Test component
     * e.removeComponent("Test", false); //Hard remove Test component
     * ~~~
     */ removeComponent: function(id, soft) {
                    var comp = components[id];
                    this.trigger("RemoveComponent", id);
                    if (comp && "events" in comp) {
                        var auto = comp.events;
                        for(var eventName in auto){
                            var fn = typeof auto[eventName] === "function" ? auto[eventName] : comp[auto[eventName]];
                            this.unbind(eventName, fn);
                        }
                    }
                    if (comp && "remove" in comp) comp.remove.call(this, false);
                    if (soft === false && comp) for(var prop in comp)delete this[prop];
                    delete this.__c[id];
                    // update map from component to (entityId -> entity)
                    if (compEntities[id]) delete compEntities[id][this[0]];
                    return this;
                },
                /**@
     * #.getId
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public Number .getId(void)
     * @returns the ID of this entity.
     *
     * For better performance, simply use the this[0] property.
     *
     * @example
     * Finding out the `ID` of an entity can be done by returning the property `0`.
     * ~~~
     *    var ent = Crafty.e("2D");
     *    ent[0]; //ID
     *    ent.getId(); //also ID
     * ~~~
     */ getId: function() {
                    return this[0];
                },
                /**@
     * #.has
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public Boolean .has(String component)
     * @param component - The name of the component to check
     * @returns `true` or `false` depending on if the
     * entity has the given component.
     *
     * For better performance, simply use the `.__c` object
     * which will be `true` if the entity has the component or
     * will not exist (or be `false`).
     */ has: function(id) {
                    return !!this.__c[id];
                },
                /**@
     * #.attr
     * @comp Crafty Core
     * @kind Method
     *
     * @trigger Change - when properties change - {key: value}
     *
     * @sign public this .attr(String property, Any value[, Boolean silent[, Boolean recursive]])
     * @param property - Property of the entity to modify
     * @param value - Value to set the property to
     * @param silent - If you would like to supress events
     * @param recursive - If you would like merge recursively
     *
     * Use this method to set any property of the entity.
     *
     * @sign public this .attr(Object map[, Boolean silent[, Boolean recursive]])
     * @param map - Object where each key is the property to modify and the value as the property value
     * @param silent - If you would like to supress events
     * @param recursive - If you would like merge recursively
     *
     * Use this method to set multiple properties of the entity.
     *
     * Setter options:
     * - `silent`: If you want to prevent it from firing events.
     * - `recursive`: If you pass in an object you could overwrite sibling keys, this recursively merges instead of just merging it. This is `false` by default, unless you are using dot notation `name.first`.
     *
     * @sign public Any .attr(String property)
     * @param property - Property of the entity to modify
     * @returns Value - the value of the property
     *
     * Use this method to get any property of the entity. You can also retrieve the property using `this.property`.
     *
     *
     * @example
     * ~~~
     * this.attr({key: "value", prop: 5});
     * this.attr("key"); // returns "value"
     * this.attr("prop"); // returns 5
     * this.key; // "value"
     * this.prop; // 5
     *
     * this.attr("key", "newvalue");
     * this.attr("key"); // returns "newvalue"
     * this.key; // "newvalue"
     *
     * this.attr("parent.child", "newvalue");
     * this.parent; // {child: "newvalue"};
     * this.attr('parent.child'); // "newvalue"
     * ~~~
     */ attr: function(key, value, silent, recursive) {
                    if (arguments.length === 1 && typeof arguments[0] === "string") return this._attr_get(key);
                    else return this._attr_set(key, value, silent, recursive);
                },
                /**
     * Internal getter method for data on the entity. Called by `.attr`.
     *
     * example
     * ~~~
     * person._attr_get('name'); // Foxxy
     * person._attr_get('contact'); // {email: 'fox_at_example.com'}
     * person._attr_get('contact.email'); // fox_at_example.com
     * ~~~
     */ _attr_get: function(key, context) {
                    var first, keys, subkey;
                    if (typeof context === "undefined" || context === null) context = this;
                    if (key.indexOf(".") > -1) {
                        keys = key.split(".");
                        first = keys.shift();
                        subkey = keys.join(".");
                        return this._attr_get(keys.join("."), context[first]);
                    } else return context[key];
                },
                /**
     * Internal setter method for attributes on the component. Called by `.attr`.
     *
     * Options:
     *
     * `silent`: If you want to prevent it from firing events.
     *
     * `recursive`: If you pass in an object you could overwrite
     * sibling keys, this recursively merges instead of just
     * merging it. This is `false` by default, unless you are
     * using dot notation `name.first`.
     *
     * example
     * ~~~
     * person._attr_set('name', 'Foxxy', true);
     * person._attr_set('name', 'Foxxy');
     * person._attr_set({name: 'Foxxy'}, true);
     * person._attr_set({name: 'Foxxy'});
     * person._attr_set('name.first', 'Foxxy');
     * ~~~
     */ _attr_set: function() {
                    var data, silent, recursive;
                    if (typeof arguments[0] === "string") {
                        data = this._set_create_object(arguments[0], arguments[1]);
                        silent = !!arguments[2];
                        recursive = arguments[3] || arguments[0].indexOf(".") > -1;
                    } else {
                        data = arguments[0];
                        silent = !!arguments[1];
                        recursive = !!arguments[2];
                    }
                    if (!silent) this.trigger("Change", data);
                    if (recursive) this._recursive_extend(data, this);
                    else this.extend.call(this, data);
                    return this;
                },
                /**
     * If you are setting a key of 'foo.bar' or 'bar', this creates
     * the appropriate object for you to recursively merge with the
     * current attributes.
     */ _set_create_object: function(key, value) {
                    var data = {}, keys, first, subkey;
                    if (key.indexOf(".") > -1) {
                        keys = key.split(".");
                        first = keys.shift();
                        subkey = keys.join(".");
                        data[first] = this._set_create_object(subkey, value);
                    } else data[key] = value;
                    return data;
                },
                /**
     * Recursively puts `new_data` into `original_data`.
     */ _recursive_extend: function(new_data, original_data) {
                    var key;
                    for(key in new_data)if (new_data[key].constructor === Object) original_data[key] = this._recursive_extend(new_data[key], original_data[key]);
                    else original_data[key] = new_data[key];
                    return original_data;
                },
                /**@
     * #.toArray
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .toArray(void)
     *
     * This method will simply return the found entities as an array of ids.  To get an array of the actual entities, use `get()`.
     * @see .get
     */ toArray: function() {
                    return slice.call(this, 0);
                },
                /**@
    * #.timeout
    * @comp Crafty Core
    * @kind Method

    * @sign public this .timeout(Function callback, Number delay)
    * @param callback - Method to execute after given amount of milliseconds
    * @param delay - Amount of milliseconds to execute the method
    *
    * The delay method will execute a function after a given amount of time in milliseconds.
    *
    * Essentially a wrapper for `setTimeout`.
    *
    * @example
    * Destroy itself after 100 milliseconds
    * ~~~
    * this.timeout(function() {
         this.destroy();
    * }, 100);
    * ~~~
    */ timeout: function(callback, duration) {
                    this.each(function() {
                        var self = this;
                        setTimeout(function() {
                            callback.call(self);
                        }, duration);
                    });
                    return this;
                },
                /**@
     * #.bind
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .bind(String eventName, Function callback)
     * @param eventName - Name of the event to bind to
     * @param callback - Method to execute when the event is triggered
     *
     * Attach the current entity (or entities) to listen for an event.
     *
     * Callback will be invoked when an event with the event name passed
     * is triggered. Depending on the event, some data may be passed
     * via an argument to the callback function.
     *
     * The first argument is the event name (can be anything) whilst the
     * second argument is the callback. If the event has data, the
     * callback should have an argument.
     *
     * Events are arbitrary and provide communication between components.
     * You can trigger or bind an event even if it doesn't exist yet.
     *
     * Unlike DOM events, Crafty events are executed synchronously.
     *
     * @example
     * ~~~
     * this.attr("triggers", 0); //set a trigger count
     * this.bind("myevent", function() {
     *     this.triggers++; //whenever myevent is triggered, increment
     * });
     * this.bind("UpdateFrame", function() {
     *     this.trigger("myevent"); //trigger myevent on every frame
     * });
     * ~~~
     *
     * @see .trigger, .unbind
     */ bind: function(event, callback) {
                    //  To learn how the event system functions, see the comments for Crafty._callbackMethods
                    //optimization for 1 entity
                    if (this.length === 1) this._bindCallback(event, callback);
                    else for(var i = 0; i < this.length; i++){
                        var e = entities[this[i]];
                        if (e) e._bindCallback(event, callback);
                    }
                    return this;
                },
                /**@
     * #.uniqueBind
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public Number .uniqueBind(String eventName, Function callback)
     * @param eventName - Name of the event to bind to
     * @param callback - Method to execute upon event triggered
     * @returns ID of the current callback used to unbind
     *
     * Works like Crafty.bind, but prevents a callback from being bound multiple times.
     *
     * @see .bind
     */ uniqueBind: function(event, callback) {
                    this.unbind(event, callback);
                    this.bind(event, callback);
                },
                /**@
     * #.one
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public Number one(String eventName, Function callback)
     * @param eventName - Name of the event to bind to
     * @param callback - Method to execute upon event triggered
     * @returns ID of the current callback used to unbind
     *
     * Works like Crafty.bind, but will be unbound once the event triggers.
     *
     * @see .bind
     */ one: function(event, callback) {
                    var self = this;
                    var oneHandler = function(data) {
                        callback.call(self, data);
                        self.unbind(event, oneHandler);
                    };
                    return self.bind(event, oneHandler);
                },
                /**@
     * #.unbind
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .unbind(String eventName[, Function callback])
     * @param eventName - Name of the event to unbind
     * @param callback - Function to unbind
     *
     * Removes binding with an event from current entity.
     *
     * Passing an event name will remove all events bound to
     * that event. Passing a reference to the callback will
     * unbind only that callback.
     * @see .bind, .trigger
     */ unbind: function(event, callback) {
                    //  To learn how the event system functions, see the comments for Crafty._callbackMethods
                    var i, e;
                    for(i = 0; i < this.length; i++){
                        e = entities[this[i]];
                        if (e) e._unbindCallbacks(event, callback);
                    }
                    return this;
                },
                /**@
     * #.trigger
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .trigger(String eventName[, Object data])
     * @param eventName - Event to trigger
     * @param data - Arbitrary data that will be passed into every callback as an argument
     *
     * Trigger an event with arbitrary data. Will invoke all callbacks with
     * the context (value of `this`) of the current entity object.
     *
     * *Note: This will only execute callbacks within the current entity, no other entity.*
     *
     * The first argument is the event name to trigger and the optional
     * second argument is the arbitrary event data. This can be absolutely anything.
     *
     * Unlike DOM events, Crafty events are executed synchronously.
     */ trigger: function(event, data) {
                    //  To learn how the event system functions, see the comments for Crafty._callbackMethods
                    if (this.length === 1) //find the handlers assigned to the entity
                    this._runCallbacks(event, data);
                    else for(var i = 0; i < this.length; i++){
                        var e = entities[this[i]];
                        if (e) e._runCallbacks(event, data);
                    }
                    return this;
                },
                /**@
     * #.each
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .each(Function method)
     * @param method - Method to call on each iteration
     *
     * Iterates over found entities, calling a function for every entity.
     *
     * The function will be called for every entity and will pass the index
     * in the iteration as an argument. The context (value of `this`) of the
     * function will be the current entity in the iteration.
     *
     * @example
     * Destroy every second 2D entity
     * ~~~
     * Crafty("2D").each(function(i) {
     *     if(i % 2 === 0) {
     *         this.destroy();
     *     }
     * });
     * ~~~
     */ each: function(func) {
                    var i = 0, l = this.length;
                    for(; i < l; i++){
                        //skip if not exists
                        if (!entities[this[i]]) continue;
                        func.call(entities[this[i]], i);
                    }
                    return this;
                },
                /**@
     * #.get
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public Array .get()
     * @returns An array of entities corresponding to the active selector
     *
     * @sign public Entity .get(Number index)
     * @returns an entity belonging to the current selection
     * @param index - The index of the entity to return.  If negative, counts back from the end of the array.
     *
     *
     * @example
     * Get an array containing every "2D" entity
     * ~~~
     * var arr = Crafty("2D").get()
     * ~~~
     * Get the first entity matching the selector
     * ~~~
     * // equivalent to Crafty("2D").get()[0], but doesn't create a new array
     * var e = Crafty("2D").get(0)
     * ~~~
     * Get the last "2D" entity matching the selector
     * ~~~
     * var e = Crafty("2D").get(-1)
     * ~~~
     *
     */ get: function(index) {
                    var l = this.length;
                    if (typeof index !== "undefined") {
                        if (index >= l || index + l < 0) return undefined;
                        if (index >= 0) return entities[this[index]];
                        else return entities[this[index + l]];
                    } else {
                        var i = 0, result = [];
                        for(; i < l; i++){
                            //skip if not exists
                            if (!entities[this[i]]) continue;
                            result.push(entities[this[i]]);
                        }
                        return result;
                    }
                },
                /**@
     * #.clone
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public Entity .clone(void)
     * @returns Cloned entity of the current entity
     *
     * Method will create another entity with the exact same
     * properties, components and methods as the current entity.
     */ clone: function() {
                    var comps = this.__c, comp, prop, clone = Crafty.e();
                    for(comp in comps)clone.addComponent(comp);
                    for(prop in this)if (prop !== "0" && prop !== "_global" && prop !== "_changed" && typeof this[prop] !== "function" && typeof this[prop] !== "object") clone[prop] = this[prop];
                    return clone;
                },
                /**@
     * #.setter
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .setter(String property, Function callback)
     * @param property - Property to watch for modification
     * @param callback - Method to execute if the property is modified
     *
     * Will watch a property waiting for modification and will then invoke the
     * given callback when attempting to modify.
     *
     * This feature is deprecated; use .defineField() instead.
     * @see .defineField
     */ setter: function(prop, callback) {
                    return this.defineField(prop, function() {}, callback);
                },
                /**@
     * #.defineField
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .defineField(String property, Function getCallback, Function setCallback)
     * @param property - Property name to assign getter & setter to
     * @param getCallback - Method to execute if the property is accessed
     * @param setCallback - Method to execute if the property is mutated
     *
     * Assigns getters and setters to the property.
     * A getter will watch a property waiting for access and will then invoke the
     * given getCallback when attempting to retrieve.
     * A setter will watch a property waiting for mutation and will then invoke the
     * given setCallback when attempting to modify.
     *
     * @example
     * ~~~
     * var ent = Crafty.e("2D");
     * ent.defineField("customData", function() {
     *    return this._customData;
     * }, function(newValue) {
     *    this._customData = newValue;
     * });
     *
     * ent.customData = "2" // set customData to 2
     * Crafty.log(ent.customData) // prints 2
     * ~~~
     */ defineField: function(prop, getCallback, setCallback) {
                    Crafty.defineField(this, prop, getCallback, setCallback);
                    return this;
                },
                /**@
     * #.destroy
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .destroy(void)
     * Will remove all event listeners and delete all properties as well as removing from the stage
     */ destroy: function() {
                    //remove all event handlers, delete from entities
                    this.each(function() {
                        var comp;
                        this.trigger("Remove");
                        for(var compName in this.__c){
                            comp = components[compName];
                            if (comp && "remove" in comp) comp.remove.call(this, true);
                            // update map from component to (entityId -> entity)
                            delete compEntities[compName][this[0]];
                        }
                        this._unbindAll();
                        delete entities[this[0]];
                    });
                },
                /**@
     * #.freeze
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .freeze()
     *
     * @triggers Freeze - Directly before the entity is frozen
     *
     * Freezes the entity.  A frozen entity will not receive events or be displayed by graphics systems.
     * It is also removed from the spatial map, which means it will not be found by collisions,
     * raycasting, or similar functions.
     *
     * This method may be called upon a collection of entities.
     *
     * @note Because the entity no longer listens to events, modifying its properties can result in an inconsistent state.
     *
     * If custom components need to handle frozen entities, they can listen to the "Freeze" event, which will be triggered before the event system is disabled.
     *
     * @example
     *
     * ```
     * // Freeze all entities with the Dead component
     * Crafty("Dead").freeze();
     * ```
     *
     * @see .unfreeze
     */ freeze: function() {
                    if (this.length === 1 && !this.__frozen) {
                        this.trigger("Freeze", this);
                        this._freezeCallbacks();
                        this.__frozen = true;
                    } else for(var i = 0; i < this.length; i++){
                        var e = entities[this[i]];
                        if (e && !e.__frozen) {
                            e.trigger("Freeze", e);
                            e._freezeCallbacks();
                            // Set a frozen flag.  (This is distinct from the __callbackFrozen flag)
                            e.__frozen = true;
                        }
                    }
                    return this;
                },
                /**#
     * #.unfreeze
     * @comp Crafty Core
     * @kind Method
     *
     * @sign public this .unfreeze()
     *
     * @triggers Unfreeze - While the entity is being unfrozen
     *
     * Unfreezes the entity, allowing it to receive events, inserting it back into the spatial map,
     * and restoring it to its previous visibility.
     *
     * This method may be called upon a collection of entities.
     *
     * If a custom component needs to know when an entity is unfrozen, they can listen to the "Unfreeze"" event.
     *
     * @example
     * ```
     * // Bring the dead back to life!
     * Crafty("Dead").unfreeze().addComponent("Undead");
     * ```
     */ unfreeze: function() {
                    if (this.length === 1 && this.__frozen) {
                        this.__frozen = false;
                        this._unfreezeCallbacks();
                        this.trigger("Unfreeze", this);
                    } else for(var i = 0; i < this.length; i++){
                        var e = entities[this[i]];
                        if (e && e.__frozen) {
                            e.__frozen = false;
                            e._unfreezeCallbacks();
                            e.trigger("Unfreeze", e);
                        }
                    }
                    return this;
                }
            };
            //give the init instances the Crafty prototype
            Crafty.fn.init.prototype = Crafty.fn;
            /**@
 * #Crafty.extend
 * @category Core
 * @kind Method
 *
 * @sign public this Crafty.extend(Object obj)
 * @param obj - An object whose fields will be copied onto Crafty.  This is a shallow copy.
 *
 * Used to extend the Crafty namespace by passing in an object of properties and methods to add.
 *
 * @example
 * ~~~ *
 * Crafty.extend({
 *   isArray: function(arg){
 *     return Object.prototype.toString.call(arg) === '[object Array]'
 *   }
 * });
 *
 * Crafty.isArray([4, 5, 6]);  // returns true
 * Crafty.isArray('hi');       // returns false
 * ~~~
 */ Crafty.extend = Crafty.fn.extend = function(obj) {
                var target = this, key;
                //don't bother with nulls
                if (!obj) return target;
                for(key in obj){
                    if (target === obj[key]) continue; //handle circular reference
                    target[key] = obj[key];
                }
                return target;
            };
            // How Crafty handles events and callbacks
            // -----------------------------------------
            // Callbacks are stored in the global object `handlers`, which has properties for each event.
            // These properties point to an object which has a property for each entity listening to the event.
            // These in turn are arrays containing the callbacks to be triggered.
            //
            // Here is an example of what "handlers" can look like:
            //     handlers ===
            //         { Move:  {5:[fnA], 6:[fnB, fnC], global:[fnD]},
            //         Change: {6:[fnE]}
            //         }
            // In this example, when the 'Move' event is triggered on entity #6 (e.g.
            // entity6.trigger('Move')), it causes the execution of fnB() and fnC(). When
            // the Move event is triggered globally (i.e. Crafty.trigger('Move')), it
            // will execute fnA, fnB, fnC, fnD.
            //
            // In this example, "this" is bound to entity #6 whenever fnB() is executed, and
            // "this" is bound to Crafty whenever fnD() is executed.
            //
            // In other words, the structure of "handlers" is:
            //
            //     handlers[event][objID] === (Array of callback functions)
            //
            // In addition to the global object, each object participating in the event system has a `_callbacks` property
            // which lists the events that object is listening to.  It allows access to the object's callbacks like this:
            //     obj._callbacks[event] === (Array of callback functions)
            //
            // Objects, which can listen to events (or collections of such objects) have varying logic
            // on how the events are bound/triggered/unbound.  Since the underlying operations on the callback array are the same,
            // the single-object operations are implemented in the following object.
            // Calling `Crafty._addCallbackMethods(obj)` on an object will extend that object with these methods.
            Crafty._callbackMethods = {
                // Add a function to the list of callbacks for an event
                _bindCallback: function(event, fn) {
                    // Get handle to event, creating it if necessary
                    var callbacks = this._callbacks[event];
                    if (!callbacks) {
                        callbacks = this._callbacks[event] = (handlers[event] || (handlers[event] = {}))[this[0]] = [];
                        callbacks.context = this;
                        callbacks.depth = 0;
                    }
                    // Push to callback array
                    callbacks.push(fn);
                },
                // Process for running all callbacks for the given event
                _runCallbacks: function(event, data) {
                    if (!this._callbacks[event] || this.__callbacksFrozen) return;
                    var callbacks = this._callbacks[event];
                    // Callback loop; deletes dead callbacks, but only when it is safe to do so
                    var i, l = callbacks.length;
                    // callbacks.depth tracks whether this function was invoked in the middle of a previous iteration through the same callback array
                    callbacks.depth++;
                    for(i = 0; i < l; i++){
                        if (typeof callbacks[i] === "undefined") {
                            if (callbacks.depth <= 1) {
                                callbacks.splice(i, 1);
                                i--;
                                l--;
                                // Delete callbacks object if there are no remaining bound events
                                if (callbacks.length === 0) {
                                    delete this._callbacks[event];
                                    delete handlers[event][this[0]];
                                }
                            }
                        } else callbacks[i].call(this, data);
                    }
                    callbacks.depth--;
                },
                // Unbind callbacks for the given event
                // If fn is specified, only it will be removed; otherwise all callbacks will be
                _unbindCallbacks: function(event, fn) {
                    if (!this._callbacks[event]) return;
                    var callbacks = this._callbacks[event];
                    // Iterate through and delete the callback functions that match
                    // They are spliced out when _runCallbacks is invoked, not here
                    // (This function might be called in the middle of a callback, which complicates the logic)
                    for(var i = 0; i < callbacks.length; i++)if (!fn || callbacks[i] === fn) delete callbacks[i];
                },
                // Completely all callbacks for every event, such as on object destruction
                _unbindAll: function() {
                    if (!this._callbacks) return;
                    this.__callbacksFrozen = false;
                    for(var event in this._callbacks)if (this._callbacks[event]) {
                        // Remove the normal way, in case we've got a nested loop
                        this._unbindCallbacks(event);
                        // Also completely delete the registered callback from handlers
                        delete handlers[event][this[0]];
                    }
                },
                _freezeCallbacks: function() {
                    if (!this._callbacks) return;
                    for(var event in this._callbacks)if (this._callbacks[event]) // Remove the callbacks from the global list of handlers
                    delete handlers[event][this[0]];
                    // Mark this callback list as frozen
                    this.__callbacksFrozen = true;
                },
                _unfreezeCallbacks: function() {
                    if (!this._callbacks) return;
                    this.__callbacksFrozen = false;
                    for(var event in this._callbacks)if (this._callbacks[event]) // Add the callbacks back to the global list of handlers
                    handlers[event][this[0]] = this._callbacks[event];
                }
            };
            // Helper function to add the callback methods above to an object, as well as initializing the callbacks object
            // it provies the "low level" operations; bind, unbind, and trigger will still need to be implemented for that object
            Crafty._addCallbackMethods = function(context) {
                context.extend(Crafty._callbackMethods);
                context._callbacks = {};
            };
            Crafty._addCallbackMethods(Crafty);
            Crafty.extend({
                // Define Crafty's id
                0: "global",
                /**@
     * #Crafty.init
     * @category Core
     * @kind Method
     *
     * @trigger Load - Just after the viewport is initialised. Before the UpdateFrame loops is started
     * @sign public this Crafty.init([Number width, Number height, String stage_elem])
     * @sign public this Crafty.init([Number width, Number height, HTMLElement stage_elem])
     * @param Number width - Width of the stage
     * @param Number height - Height of the stage
     * @param String or HTMLElement stage_elem - the element to use for the stage
     *
     * Sets the element to use as the stage, creating it if necessary.  By default a div with id 'cr-stage' is used, but if the 'stage_elem' argument is provided that will be used instead.  (see `Crafty.viewport.init`)
     *
     * Starts the `UpdateFrame` interval. This will call the `UpdateFrame` event for every frame.
     *
     * Can pass width and height values for the stage otherwise will default to window size.
     *
     * All `Load` events will be executed.
     *
     * Uses `requestAnimationFrame` to sync the drawing with the browser but will default to `setInterval` if the browser does not support it.
     * @see Crafty.stop,  Crafty.viewport
     */ init: function(w, h, stage_elem) {
                    // If necessary, attach any event handlers registered before Crafty started
                    if (!this._preBindDone) for(var i = 0; i < this._bindOnInit.length; i++){
                        var preBind = this._bindOnInit[i];
                        Crafty.bind(preBind.event, preBind.handler);
                    }
                    // The viewport will init things like the default graphics layers as well
                    Crafty.viewport.init(w, h, stage_elem);
                    //call all arbitrary functions attached to onload
                    this.trigger("Load");
                    this.timer.init();
                    return this;
                },
                /**@
     * #Crafty.initAsync
     * @category Core
     * @kind Method
     *
     * @trigger Load - Just after the viewport is initialised. Before the UpdateFrame loops is started
     * @sign public this Crafty.initAsync([Array loaders], [Number width, Number height, String stage_elem])
     * @param Array loaders An array that can contain a mix of Promises, or functions that Promises
     * @param Number width - Width of the stage
     * @param Number height - Height of the stage
     * @param String or HTMLElement stage_elem - the element to use for the stage
     *
     * A version of Crafty.init that uses Promises to load any needed resources before initialization.
     *
     * The first argument is an array of either Promises, or functions that return promises.
     * In the second case, a Promise will be generated by invoking the function with the current Crafty instance as an argument.
     * (The array can be a mixture of the two types.)
     *
     * Once all promises are ready, and the document itself has loaded, Crafty.init will be invoked with the `w`, `h`, and `stage_elem` arguments.
     *
     * The method returns a Promise whose fufillment is an array of each passed promises fufillment,
     * and whose rejection is the rejection of the first promise to fail.  (Essentially the same as Promise.all)
     *
     * @see Crafty.init
     */ initAsync: function(loaders, w, h, stage_elem) {
                    // first argument is optional
                    if (typeof loaders !== "object") {
                        stage_elem = h;
                        h = w;
                        w = loaders;
                        loaders = [];
                    }
                    var promises = [];
                    for(var i in loaders)if (typeof loaders[i] === "function") promises.push(loaders[i](Crafty));
                    else promises.push(loaders[i]);
                    // wait for document loading if necessary
                    if (document.readyState !== "complete") var window_load = new Promise(function(resolve, reject) {
                        window.onload = resolve;
                        promises.push(window_load);
                    });
                    return Promise.all(promises).then(function(values) {
                        Crafty.init(w, h, stage_elem);
                        // Return results only for promises passed in with the loaders array
                        return values.slice(0, loaders.length);
                    });
                },
                // There are some events that need to be bound to Crafty when it's started/restarted, so store them here
                // Switching Crafty's internals to use the new system idiom should allow removing this hack
                _bindOnInit: [],
                _preBindDone: false,
                _preBind: function(event, handler) {
                    this._bindOnInit.push({
                        event: event,
                        handler: handler
                    });
                },
                /**@
     * #Crafty.getVersion
     * @category Core
     * @kind Method
     *
     * @sign public String Crafty.getVersion()
     * @returns Current version of Crafty as a string
     *
     * Return current version of crafty
     *
     * @example
     * ~~~
     * Crafty.getVersion(); //'0.5.2'
     * ~~~
     */ getVersion: function() {
                    return version;
                },
                /**@
     * #Crafty.stop
     * @category Core
     * @kind Method
     *
     * @trigger CraftyStop - when the game is stopped  - {bool clearState}
     * @sign public this Crafty.stop([bool clearState])
     * @param clearState - if true the stage and all game state is cleared.
     *
     * Stops the `UpdateFrame` interval and removes the stage element.
     *
     * To restart, use `Crafty.init()`.
     * @see Crafty.init
     */ stop: function(clearState) {
                    Crafty.trigger("CraftyStop", clearState);
                    this.timer.stop();
                    if (clearState) {
                        // Remove audio
                        Crafty.audio.remove();
                        //Destroy all systems
                        for(var s in Crafty._systems)Crafty._systems[s].destroy();
                        // Remove the stage element, and re-add a div with the same id
                        if (Crafty.stage && Crafty.stage.elem.parentNode) {
                            var newCrStage = document.createElement("div");
                            newCrStage.id = Crafty.stage.elem.id;
                            Crafty.stage.elem.parentNode.replaceChild(newCrStage, Crafty.stage.elem);
                        }
                        // reset callbacks, and indicate that prebound functions need to be bound on init again
                        Crafty._unbindAll();
                        Crafty._addCallbackMethods(Crafty);
                        this._preBindDone = false;
                        initState();
                    }
                    return this;
                },
                /**@
     * #Crafty.pause
     * @category Core
     * @kind Method
     *
     * @trigger Pause - when the game is paused
     * @trigger Unpause - when the game is unpaused
     * @sign public this Crafty.pause(void)
     *
     * Pauses the game by stopping the `UpdateFrame` event from firing. If the game is already paused it is unpaused.
     * You can pass a boolean parameter if you want to pause or unpause no matter what the current state is.
     * Modern browsers pauses the game when the page is not visible to the user. If you want the Pause event
     * to be triggered when that happens you can enable autoPause in `Crafty.settings`.
     *
     * @example
     * Have an entity pause the game when it is clicked.
     * ~~~
     * button.bind("click", function() {
     *     Crafty.pause();
     * });
     * ~~~
     */ pause: function(toggle) {
                    if (arguments.length === 1 ? toggle : !this._paused) {
                        this.trigger("Pause");
                        this._paused = true;
                        setTimeout(function() {
                            Crafty.timer.stop();
                        }, 0);
                    } else {
                        this.trigger("Unpause");
                        this._paused = false;
                        setTimeout(function() {
                            Crafty.timer.init();
                        }, 0);
                    }
                    return this;
                },
                /**@
     * #Crafty.isPaused
     * @category Core
     * @kind Method
     *
     * @sign public Boolean Crafty.isPaused()
     * @returns Whether the game is currently paused.
     *
     * @example
     * ~~~
     * Crafty.isPaused();
     * ~~~
     */ isPaused: function() {
                    return this._paused;
                },
                /**@
     * #Crafty.timer
     * @category Game Loop
     * @kind CoreObject
     *
     * Handles game ticks
     */ timer: function() {
                    /*
         * `window.requestAnimationFrame` or its variants is called for animation.
         * `.requestID` keeps a record of the return value previous `window.requestAnimationFrame` call.
         * This is an internal variable. Used to stop frame.
         */ var tick, requestID;
                    // Internal variables used to control the game loop.  Use Crafty.timer.steptype() to set these.
                    var mode = "fixed", maxFramesPerStep = 5, maxTimestep = 40;
                    // variables used by the game loop to track state
                    var endTime = 0, timeSlip = 0, gameTime;
                    // Controls the target rate of fixed mode loop.  Set these with the Crafty.timer.FPS function
                    var FPS = 50, milliSecPerFrame = 1000 / FPS;
                    return {
                        init: function() {
                            // When first called, set the  gametime one frame before now!
                            if (typeof gameTime === "undefined") gameTime = Date.now() - milliSecPerFrame;
                            var onFrame = typeof window !== "undefined" && (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || null);
                            if (onFrame) {
                                tick = function() {
                                    Crafty.timer.step();
                                    if (tick !== null) requestID = onFrame(tick);
                                //Crafty.log(requestID + ', ' + frame)
                                };
                                tick();
                            } else tick = setInterval(function() {
                                Crafty.timer.step();
                            }, 1000 / FPS);
                        },
                        stop: function() {
                            Crafty.trigger("CraftyStopTimer");
                            if (typeof tick !== "function") clearInterval(tick);
                            var onFrame = typeof window !== "undefined" && (window.cancelAnimationFrame || window.cancelRequestAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || null);
                            if (onFrame) onFrame(requestID);
                            tick = null;
                        },
                        /**@
             * #Crafty.timer.steptype
             * @comp Crafty.timer
             * @kind Method
             *
             * @trigger NewSteptype - when the current steptype changes - { mode, maxTimeStep } - New steptype
             *
             * Can be called to set the type of timestep the game loop uses.
             * @sign public void Crafty.timer.steptype(mode [, maxTimeStep])
             * @param mode - the type of time loop.  Allowed values are "fixed", "semifixed", and "variable".  Crafty defaults to "fixed".
             * @param maxTimeStep - For "fixed", sets the max number of frames per step.   For "variable" and "semifixed", sets the maximum time step allowed.
             *
             * Can be called to get the type of timestep the game loop uses.
             * @sign public Object Crafty.timer.steptype(void)
             * @returns Object containing the current timestep's properties { mode, maxTimeStep }
             *
             * * In "fixed" mode, each frame is sent the same value of `dt`, and to achieve the target game speed, mulitiple frame events are triggered before each render.
             * * In "variable" mode, there is only one frame triggered per render.  This recieves a value of `dt` equal to the actual elapsed time since the last frame.
             * * In "semifixed" mode, multiple frames per render are processed, and the total time since the last frame is divided evenly between them.
             *
             * @see Crafty.timer.FPS
             */ steptype: function(newmode, option) {
                            // setters
                            if (newmode === "variable" || newmode === "semifixed") {
                                mode = newmode;
                                if (option) maxTimestep = option;
                                Crafty.trigger("NewSteptype", {
                                    mode: mode,
                                    maxTimeStep: maxTimestep
                                });
                            } else if (newmode === "fixed") {
                                mode = "fixed";
                                if (option) maxFramesPerStep = option;
                                Crafty.trigger("NewSteptype", {
                                    mode: mode,
                                    maxTimeStep: maxFramesPerStep
                                });
                            } else if (newmode !== undefined) throw "Invalid step type specified";
                            else return {
                                mode: mode,
                                maxTimeStep: mode === "variable" || mode === "semifixed" ? maxTimestep : maxFramesPerStep
                            };
                        },
                        /**@
             * #Crafty.timer.step
             * @comp Crafty.timer
             * @kind Method
             *
             * @sign public void Crafty.timer.step()
             * @trigger EnterFrame - Triggered before each frame.  Passes the frame number, and the amount of time since the last frame.  If the time is greater than maxTimestep, that will be used instead.  (The default value of maxTimestep is 50 ms.) - { frame: Number, dt:Number }
             * @trigger UpdateFrame - Triggered on each frame.  Passes the frame number, and the amount of time since the last frame.  If the time is greater than maxTimestep, that will be used instead.  (The default value of maxTimestep is 50 ms.) - { frame: Number, dt:Number }
             * @trigger ExitFrame - Triggered after each frame.  Passes the frame number, and the amount of time since the last frame.  If the time is greater than maxTimestep, that will be used instead.  (The default value of maxTimestep is 50 ms.) - { frame: Number, dt:Number }
             * @trigger PreRender - Triggered every time immediately before a scene should be rendered
             * @trigger RenderScene - Triggered every time a scene should be rendered
             * @trigger PostRender - Triggered every time immediately after a scene should be rendered
             * @trigger MeasureWaitTime - Triggered at the beginning of each step after the first.  Passes the time the game loop waited between steps. - Number
             * @trigger MeasureFrameTime - Triggered after each frame.  Passes the time it took to advance one frame. - Number
             * @trigger MeasureRenderTime - Triggered after each render. Passes the time it took to render the scene - Number
             *
             * Advances the game by performing a step. A step consists of one/multiple frames followed by a render. The amount of frames depends on the timer's steptype.
             * Specifically it triggers `EnterFrame`, `UpdateFrame` & `ExitFrame` events for each frame and `PreRender`, `RenderScene` & `PostRender` events for each render.
             *
             * @see Crafty.timer.steptype
             * @see Crafty.timer.FPS
             */ step: function() {
                            var drawTimeStart, dt, lastFrameTime, loops = 0;
                            var currentTime = Date.now();
                            if (endTime > 0) Crafty.trigger("MeasureWaitTime", currentTime - endTime);
                            // If we're currently ahead of the current time, we need to wait until we're not!
                            if (gameTime + timeSlip >= currentTime) {
                                endTime = currentTime;
                                return;
                            }
                            var netTimeStep = currentTime - (gameTime + timeSlip);
                            // We try to keep up with the target FPS by processing multiple frames per render
                            // If we're hopelessly behind, stop trying to catch up.
                            if (netTimeStep > milliSecPerFrame * 20) {
                                //gameTime = currentTime - milliSecPerFrame;
                                timeSlip += netTimeStep - milliSecPerFrame;
                                netTimeStep = milliSecPerFrame;
                            }
                            // Set up how time is incremented
                            if (mode === "fixed") {
                                loops = Math.ceil(netTimeStep / milliSecPerFrame);
                                // maxFramesPerStep adjusts how willing we are to delay drawing in order to keep at the target FPS
                                loops = Math.min(loops, maxFramesPerStep);
                                dt = milliSecPerFrame;
                            } else if (mode === "variable") {
                                loops = 1;
                                dt = netTimeStep;
                                // maxTimestep is the maximum time to be processed in a frame.  (Large dt => unstable physics)
                                dt = Math.min(dt, maxTimestep);
                            } else if (mode === "semifixed") {
                                loops = Math.ceil(netTimeStep / maxTimestep);
                                dt = netTimeStep / loops;
                            }
                            // Process frames, incrementing the game clock with each frame.
                            // dt is determined by the mode
                            for(var i = 0; i < loops; i++){
                                lastFrameTime = currentTime;
                                var frameData = {
                                    frame: frame++,
                                    dt: dt,
                                    gameTime: gameTime
                                };
                                // Event that happens before "UpdateFrame",
                                // e.g. for setting-up movement in response to user input for the next "UpdateFrame" event
                                Crafty.trigger("EnterFrame", frameData);
                                // Everything that changes over time hooks into this event
                                Crafty.trigger("UpdateFrame", frameData);
                                // Event that happens after "UpdateFrame",
                                // e.g. for resolivng collisions applied through movement during "UpdateFrame" events
                                Crafty.trigger("ExitFrame", frameData);
                                gameTime += dt;
                                currentTime = Date.now();
                                Crafty.trigger("MeasureFrameTime", currentTime - lastFrameTime);
                            }
                            //If any frames were processed, render the results
                            if (loops > 0) {
                                drawTimeStart = currentTime;
                                Crafty.trigger("PreRender"); // Pre-render setup opportunity
                                Crafty.trigger("RenderScene");
                                Crafty.trigger("PostRender"); // Post-render cleanup opportunity
                                currentTime = Date.now();
                                Crafty.trigger("MeasureRenderTime", currentTime - drawTimeStart);
                            }
                            endTime = currentTime;
                        },
                        /**@
             * #Crafty.timer.FPS
             * @comp Crafty.timer
             * @kind Method
             *
             * @sign public void Crafty.timer.FPS()
             * Returns the target frames per second. This is not an actual frame rate.
             * @sign public void Crafty.timer.FPS(Number value)
             * @param value - the target rate
             * @trigger FPSChange - Triggered when the target FPS is changed by user - Number - new target FPS
             *
             * Sets the target frames per second. This is not an actual frame rate.
             * The default rate is 50.
             *
             * @see Crafty.timer.steptype
             */ FPS: function(value) {
                            if (typeof value === "undefined") return FPS;
                            else {
                                FPS = value;
                                milliSecPerFrame = 1000 / FPS;
                                Crafty.trigger("FPSChange", value);
                            }
                        },
                        /**@
             * #Crafty.timer.simulateFrames
             * @comp Crafty.timer
             * @kind Method
             *
             * @sign public this Crafty.timer.simulateFrames(Number frames[, Number timestep])
             * Advances the game state by a number of frames and draws the resulting stage at the end. Useful for tests and debugging.
             * @param frames - number of frames to simulate
             * @param timestep - the duration to pass each frame.  Defaults to milliSecPerFrame (20 ms) if not specified.
             */ simulateFrames: function(frames, timestep) {
                            timestep = timestep || milliSecPerFrame;
                            while(frames-- > 0){
                                var frameData = {
                                    frame: frame++,
                                    dt: timestep
                                };
                                Crafty.trigger("EnterFrame", frameData);
                                Crafty.trigger("UpdateFrame", frameData);
                                Crafty.trigger("ExitFrame", frameData);
                            }
                            Crafty.trigger("PreRender");
                            Crafty.trigger("RenderScene");
                            Crafty.trigger("PostRender");
                        }
                    };
                }(),
                /**@
     * #Crafty.e
     * @category Core
     * @kind Method
     *
     * @trigger NewEntity - When the entity is created and all components are added - { id:Number }
     * @sign public Entity Crafty.e(String componentList)
     * @param componentList - List of components to assign to new entity
     * @sign public Entity Crafty.e(String component1[, .., String componentN])
     * @param component# - Component to add
     *
     * Creates an entity. Any arguments will be applied in the same
     * way `.addComponent()` is applied as a quick way to add components.
     *
     * Any component added will augment the functionality of
     * the created entity by assigning the properties and methods from the component to the entity.
     *
     * @example
     * ~~~
     * var myEntity = Crafty.e("2D, DOM, Color");
     * ~~~
     *
     * @see Crafty.c
     */ e: function() {
                    var id = UID();
                    entities[id] = null;
                    entities[id] = Crafty(id);
                    if (arguments.length > 0) entities[id].addComponent.apply(entities[id], arguments);
                    entities[id].setName("Entity #" + id); //set default entity human readable name
                    entities[id].addComponent("obj"); //every entity automatically assumes obj
                    Crafty.trigger("NewEntity", {
                        id: id
                    });
                    return entities[id];
                },
                /**@
     * #Crafty.c
     * @category Core
     * @kind Method
     *
     * @sign public void Crafty.c(String name, Object component)
     * @param name - Name of the component
     * @param component - Object with the component's properties and methods
     *
     * Creates a component where the first argument is the ID and the second
     * is the object that will be inherited by entities.
     *
     * Specifically, each time a component is added to an entity, the component properties are copied over to the entity.
     * * In the case of primitive datatypes (booleans, numbers, strings) the property is copied by value.
     * * In the case of complex datatypes (objects, arrays, functions) the property is copied by reference and will thus reference the components' original property.
     * * (See the two examples below for further explanation)
     * Note that when a component method gets called, the `this` keyword will refer to the current entity the component was added to.
     *
     * A handful of methods or properties are treated specially. They are invoked in partiular contexts, and (in those contexts) cannot be overridden by other components.
     *
     * - `required`: A string listing required components, which will be added to the component before `init()` runs.
     * - `init`: A function to be called when the component is added to an entity
     * - `remove`: A function which will be called just before a component is removed, or before an entity is destroyed. It is passed a single boolean parameter that is `true` if the entity is being destroyed.
     * - `events`: An object whose properties represent functions bound to events equivalent to the property names.  (See the example below.)  The binding occurs directly after the call to `init`, and will be removed directly before `remove` is called.
     * - `properties`: A dictionary of properties which will be defined using Object.defineProperty.  Typically used to add setters and getters.
     *
     * In addition to these hardcoded special methods, there are some conventions for writing components.
     *
     * - Properties or methods that start with an underscore are considered private.
     * - A method with the same name as the component is considered to be a constructor
     * and is generally used when you need to pass configuration data to the component on a per entity basis.
     *
     * @example
     * ~~~
     * Crafty.c("Annoying", {
     *     _message: "HiHi",
     *     init: function() {
     *         this.bind("UpdateFrame", function() { alert(this.message); });
     *     },
     *     annoying: function(message) { this.message = message; }
     * });
     *
     * Crafty.e("Annoying").annoying("I'm an orange...");
     * ~~~
     * To attach to the "UpdateFrame" event using the `events` property instead:
     * ~~~
     * Crafty.c("Annoying", {
     *     _message: "HiHi",
     *     events: {
     *         "UpdateFrame": function(){alert(this.message);}
     *     }
     *     annoying: function(message) { this.message = message; }
     * });
     * ~~~
     *
     *
     * @warning In the examples above the field _message is local to the entity.
     * That is, if you create many entities with the Annoying component, they can all have different values for _message.
     * That is because it is a simple value, and simple values are copied by value.
     * If however the field had been an object or array,
     * the value would have been shared by all entities with the component,
     * because complex types are copied by reference in javascript.
     * This is probably not what you want and the following example demonstrates how to work around it.
     *
     * ~~~
     * Crafty.c("MyComponent", {
     *     _iAmShared: { a: 3, b: 4 },
     *     init: function() {
     *         this._iAmNotShared = { a: 3, b: 4 };
     *     },
     * });
     * ~~~
     *
     * @see Crafty.e
     */ c: function(compName, component) {
                    components[compName] = component;
                },
                /**@
     * #Crafty.trigger
     * @category Core, Events
     * @kind Method
     *
     * @sign public void Crafty.trigger(String eventName, * data)
     * @param eventName - Name of the event to trigger
     * @param data - Arbitrary data to pass into the callback as an argument
     *
     * This method will trigger every single callback attached to the event name. This means
     * every global event and every entity that has a callback.
     *
     * @see Crafty.bind
     */ trigger: function(event, data) {
                    //  To learn how the event system functions, see the comments for Crafty._callbackMethods
                    var hdl = handlers[event] || (handlers[event] = {}), h, callbacks;
                    //loop over every object bound
                    for(h in hdl){
                        // Check whether h needs to be processed
                        if (!hdl.hasOwnProperty(h)) continue;
                        callbacks = hdl[h];
                        if (!callbacks || callbacks.length === 0) continue;
                        callbacks.context._runCallbacks(event, data);
                    }
                },
                /**@
     * #Crafty.bind
     * @category Core, Events
     * @kind Method
     *
     * @sign public Function bind(String eventName, Function callback)
     * @param eventName - Name of the event to bind to
     * @param callback - Method to execute upon event triggered
     * @returns callback function which can be used for unbind
     *
     * Binds to a global event. Method will be executed when `Crafty.trigger` is used
     * with the event name.
     *
     * @see Crafty.trigger, Crafty.unbind
     */ bind: function(event, callback) {
                    // To learn how the event system functions, see the comments for Crafty._callbackMethods
                    this._bindCallback(event, callback);
                    return callback;
                },
                /**@
     * #Crafty.uniqueBind
     * @category Core, Events
     * @kind Method
     *
     * @sign public Function uniqueBind(String eventName, Function callback)
     * @param eventName - Name of the event to bind to
     * @param callback - Method to execute upon event triggered
     * @returns callback function which can be used for unbind
     *
     * Works like Crafty.bind, but prevents a callback from being bound multiple times.
     *
     * @see Crafty.bind
     */ uniqueBind: function(event, callback) {
                    this.unbind(event, callback);
                    return this.bind(event, callback);
                },
                /**@
     * #Crafty.one
     * @category Core, Events
     * @kind Method
     *
     * @sign public Function one(String eventName, Function callback)
     * @param eventName - Name of the event to bind to
     * @param callback - Method to execute upon event triggered
     * @returns callback function which can be used for unbind
     *
     * Works like Crafty.bind, but will be unbound once the event triggers.
     *
     * @see Crafty.bind
     */ one: function(event, callback) {
                    var self = this;
                    var oneHandler = function(data) {
                        callback.call(self, data);
                        self.unbind(event, oneHandler);
                    };
                    return self.bind(event, oneHandler);
                },
                /**@
     * #Crafty.unbind
     * @category Core, Events
     * @kind Method
     *
     * @sign public Boolean Crafty.unbind(String eventName, Function callback)
     * @param eventName - Name of the event to unbind
     * @param callback - Function to unbind
     * @example
     * ~~~
     *    var play_gameover_sound = function () {...};
     *    Crafty.bind('GameOver', play_gameover_sound);
     *    ...
     *    Crafty.unbind('GameOver', play_gameover_sound);
     * ~~~
     *
     * The first line defines a callback function. The second line binds that
     * function so that `Crafty.trigger('GameOver')` causes that function to
     * run. The third line unbinds that function.
     *
     * ~~~
     *    Crafty.unbind('GameOver');
     * ~~~
     *
     * This unbinds ALL global callbacks for the event 'GameOver'. That
     * includes all callbacks attached by `Crafty.bind('GameOver', ...)`, but
     * none of the callbacks attached by `some_entity.bind('GameOver', ...)`.
     */ unbind: function(event, callback) {
                    //  To learn how the event system functions, see the comments for Crafty._callbackMethods
                    this._unbindCallbacks(event, callback);
                },
                /**@
     * #Crafty.frame
     * @category Core
     * @kind Method
     *
     * @sign public Number Crafty.frame(void)
     * @returns the current frame number
     */ frame: function() {
                    return frame;
                },
                entities: function() {
                    return entities;
                },
                components: function() {
                    return components;
                },
                isComp: function(comp) {
                    return comp in components;
                },
                debug: function(str) {
                    // access internal variables - handlers or entities
                    if (str === "handlers") return handlers;
                    return entities;
                },
                /**@
     * #Crafty.settings
     * @category Core
     * @kind CoreObject
     *
     * Modify the inner workings of Crafty through the settings.
     */ settings: function() {
                    var states = {}, callbacks = {};
                    return {
                        /**@
             * #Crafty.settings.register
             * @comp Crafty.settings
             * @kind Method
             *
             * @sign public void Crafty.settings.register(String settingName, Function callback)
             * @param settingName - Name of the setting
             * @param callback - Function to execute when use modifies setting
             *
             * Use this to register custom settings. Callback will be executed when `Crafty.settings.modify` is used.
             *
             * @see Crafty.settings.modify
             */ register: function(setting, callback) {
                            callbacks[setting] = callback;
                        },
                        /**@
             * #Crafty.settings.modify
             * @comp Crafty.settings
             * @kind Method
             *
             * @sign public void Crafty.settings.modify(String settingName, * value)
             * @param settingName - Name of the setting
             * @param value - Value to set the setting to
             *
             * Modify settings through this method.
             *
             * @see Crafty.settings.register, Crafty.settings.get
             */ modify: function(setting, value) {
                            if (!callbacks[setting]) return;
                            callbacks[setting].call(states[setting], value);
                            states[setting] = value;
                        },
                        /**@
             * #Crafty.settings.get
             * @comp Crafty.settings
             * @kind Method
             *
             * @sign public * Crafty.settings.get(String settingName)
             * @param settingName - Name of the setting
             * @returns Current value of the setting
             *
             * Returns the current value of the setting.
             *
             * @see Crafty.settings.register, Crafty.settings.get
             */ get: function(setting) {
                            return states[setting];
                        }
                    };
                }(),
                /**@
     * #Crafty.defineField
     * @category Core
     * @kind Method
     *
     * @sign public void Crafty.defineField(Object object, String property, Function getCallback, Function setCallback)
     * @param object - Object to define property on
     * @param property - Property name to assign getter & setter to
     * @param getCallback - Method to execute if the property is accessed
     * @param setCallback - Method to execute if the property is mutated
     *
     * Assigns getters and setters to the property in the given object.
     * A getter will watch a property waiting for access and will then invoke the
     * given getCallback when attempting to retrieve.
     * A setter will watch a property waiting for mutation and will then invoke the
     * given setCallback when attempting to modify.
     *
     * @example
     * ~~~
     * var ent = Crafty.e("2D");
     * Crafty.defineField(ent, "customData", function() {
     *    return this._customData;
     * }, function(newValue) {
     *    this._customData = newValue;
     * });
     *
     * ent.customData = "2" // set customData to 2
     * Crafty.log(ent.customData) // prints 2
     * ~~~
     * @see Crafty Core#.defineField
     */ defineField: function(obj, prop, getCallback, setCallback) {
                    Object.defineProperty(obj, prop, {
                        get: getCallback,
                        set: setCallback,
                        configurable: false,
                        enumerable: true
                    });
                },
                clone: clone
            });
            /**
 * Return a unique ID
 */ function UID() {
                var id = GUID++;
                //if GUID is not unique
                if (id in entities) return UID(); //recurse until it is unique
                return id;
            }
            /**@
 * #Crafty.clone
 * @category Core
 * @kind Method
 *
 * @sign public Object .clone(Object obj)
 * @param obj - an object
 *
 * Deep copy (a.k.a clone) of an object.
 * @note This function should be used for plain objects with no cyclic references. To clone an entity use its `.clone` method instead.
 *
 * @example
 * ~~~
 * // Null or Primitive types
 * Crafty.clone(null); // returns null
 * Crafty.clone(4);    // returns 4
 *
 * // Objects
 * var globalCount = 0;
 * var obj1 = {
 *   count: 0,
 *   inc: function(){
 *      this.count++;
 *      globalCount++;
 *   },
 *   log: function(){
 *     console.log(this.count + '/' + globalCount);
 *   }
 * };
 *
 * obj1.inc();
 * obj1.log(); // prints "1/1" to the log
 *
 * var obj2 = Crafty.clone(obj1);
 * obj2.log(); // prints "1/1" to the log
 *
 * obj1.inc();
 * obj1.log(); // prints "2/2" to the log
 * obj2.log(); // prints "1/2" to the log
 * ~~~
 *
 * @see Crafty Core#.clone
 */ function clone(obj) {
                if (obj === null || typeof obj !== "object") return obj;
                var temp = obj.constructor(); // changed
                for(var key in obj)temp[key] = clone(obj[key]);
                return temp;
            }
            // export Crafty
            if (typeof define === "function") // AMD
            // jshint ignore:start
            define("crafty", [], function() {
                return Crafty;
            });
            module.exports = Crafty;
        },
        {
            "./version": 20
        }
    ],
    11: [
        function(require1, module, exports) {
            (function(process) {
                var Crafty = require1("../core/core.js");
                var document1 = typeof window !== "undefined" && window.document;
                /**@
 * #Crafty.support
 * @category Misc, Core
 * @kind CoreObject
 *
 * Determines feature support for what Crafty can do.
 */ (function testSupport() {
                    var support = Crafty.support = {}, ua = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase() || typeof process !== "undefined" && process.version, match = /(webkit)[ \/]([\w.]+)/.exec(ua) || /(o)pera(?:.*version)?[ \/]([\w.]+)/.exec(ua) || /(ms)ie ([\w.]+)/.exec(ua) || /(moz)illa(?:.*? rv:([\w.]+))?/.exec(ua) || /(v)\d+\.(\d+)/.exec(ua) || [], mobile = /iPad|iPod|iPhone|Android|webOS|IEMobile/i.exec(ua);
                    /**@
     * #Crafty.mobile
     * @comp Crafty.device
     * @kind Property
     *
     * Determines if Crafty is running on mobile device.
     *
     * If Crafty.mobile is equal true Crafty does some things under hood:
     * ~~~
     * - set viewport on max device width and height
     * - set Crafty.stage.fullscreen on true
     * - hide window scrollbars
     * ~~~
     *
     * @see Crafty.viewport
     */ if (mobile) Crafty.mobile = mobile[0];
                    /**@
     * #Crafty.support.defineProperty
     * @comp Crafty.support
     * @kind Property
     *
     * Is `Object.defineProperty` supported?
     */ support.defineProperty = function() {
                        if (!("defineProperty" in Object)) return false;
                        try {
                            Object.defineProperty({}, "x", {});
                        } catch (e) {
                            return false;
                        }
                        return true;
                    }();
                    /**@
     * #Crafty.support.audio
     * @comp Crafty.support
     * @kind Property
     *
     * Is HTML5 `Audio` supported?
     */ support.audio = typeof window !== "undefined" && "canPlayType" in document1.createElement("audio");
                    /**@
     * #Crafty.support.prefix
     * @comp Crafty.support
     * @kind Property
     *
     * Returns the browser specific prefix (`Moz`, `O`, `ms`, `webkit`, `node`).
     */ support.prefix = match[1] || match[0];
                    //browser specific quirks
                    if (support.prefix === "moz") support.prefix = "Moz";
                    if (support.prefix === "o") support.prefix = "O";
                    if (support.prefix === "v") support.prefix = "node";
                    if (match[2]) {
                        /**@
         * #Crafty.support.versionName
         * @comp Crafty.support
         * @kind Property
         *
         * Version of the browser
         */ support.versionName = match[2];
                        /**@
         * #Crafty.support.version
         * @comp Crafty.support
         * @kind Property
         *
         * Version number of the browser as an Integer (first number)
         */ support.version = +match[2].split(".")[0];
                    }
                    /**@
     * #Crafty.support.canvas
     * @comp Crafty.support
     * @kind Property
     *
     * Is the `canvas` element supported?
     */ support.canvas = typeof window !== "undefined" && "getContext" in document1.createElement("canvas");
                    /**@
     * #Crafty.support.webgl
     * @comp Crafty.support
     * @kind Property
     *
     * Is WebGL supported on the canvas element?
     */ if (support.canvas) {
                        var gl;
                        try {
                            var c = document1.createElement("canvas");
                            gl = c.getContext("webgl") || c.getContext("experimental-webgl");
                            gl.viewportWidth = support.canvas.width;
                            gl.viewportHeight = support.canvas.height;
                        } catch (e) {}
                        support.webgl = !!gl;
                    } else support.webgl = false;
                    /**@
     * #Crafty.support.css3dtransform
     * @comp Crafty.support
     * @kind Property
     *
     * Is css3Dtransform supported by browser.
     */ support.css3dtransform = typeof window !== "undefined" && (typeof document1.createElement("div").style.Perspective !== "undefined" || typeof document1.createElement("div").style[support.prefix + "Perspective"] !== "undefined");
                    /**@
     * #Crafty.support.deviceorientation
     * @comp Crafty.support
     * @kind Property
     * Is deviceorientation event supported by browser.
     */ support.deviceorientation = typeof window !== "undefined" && (typeof window.DeviceOrientationEvent !== "undefined" || typeof window.OrientationEvent !== "undefined");
                    /**@
     * #Crafty.support.devicemotion
     * @comp Crafty.support
     * @kind Property
     *
     * Is devicemotion event supported by browser.
     */ support.devicemotion = typeof window !== "undefined" && typeof window.DeviceMotionEvent !== "undefined";
                })();
            }).call(this, require1("_process"));
        },
        {
            "../core/core.js": 10,
            "_process": 1
        }
    ],
    12: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js"), Utility = require1("./utility");
            module.exports = {
                /**@
     * #Crafty.assets
     * @category Assets
     * @kind Property
     *
     * An object containing every asset used in the current Crafty game.
     * The key is the URL and the value is the `Audio` or `Image` object.
     *
     * If loading an asset, check that it is in this object first to avoid loading twice.
     *
     * @example
     * ~~~
     * var isLoaded = !!Crafty.assets["images/sprite.png"];
     * ~~~
     * @see Crafty.load
     */ assets: {},
                __paths: {
                    audio: "",
                    images: ""
                },
                /**@
     * #Crafty.paths
     * @category Assets
     * @kind Method
     *
     * @sign public void Crafty.paths([Object paths])
     * @param paths - Object containing paths for audio and images folders
     *
     * Function to define custom folder for audio and images. You should use
     * this function to avoid typing the same paths again and again when
     * loading assets with the Crafty.load() function.
     *
     * If you do not give a object you get the current paths for both audio
     * and images back.
     *
     * You do not have to define paths.
     *
     * @example
     *
     *
     * Setting folders:
     * ~~~
     * Crafty.paths({ audio: "custom/audio/path/", images: "custom/images/path/" });
     *
     * Crafty.load({
     *   "audio": {
     *     "ray": ['ray.mp3'] // This loads ray.mp3 from custom/audio/path/ray.mp3
     *   }
     * }, function() {
     *   Crafty.log('loaded');
     * });
     * ~~~
     *
     * @see Crafty.load
     */ paths: function(p) {
                    if (typeof p === "undefined") return this.__paths;
                    else {
                        if (p.audio) this.__paths.audio = p.audio;
                        if (p.images) this.__paths.images = p.images;
                    }
                },
                /**@
     * #Crafty.asset
     * @category Assets
     * @kind Method
     *
     * @trigger NewAsset - After setting new asset - Object - key and value of new added asset.
     * @sign public void Crafty.asset(String key, Object asset)
     * @param key - asset url.
     * @param asset - `Audio` or `Image` object.
     *
     * Add new asset to assets object.
     *
     * @sign public void Crafty.asset(String key)
     * @param key - asset url.
     *
     *
     * Get asset from assets object.
     *
     * @example
     * ~~~
     * Crafty.asset(key, value);
     * var asset = Crafty.asset(key); //object with key and value fields
     * ~~~
     *
     * @see Crafty.assets
     */ asset: function(key, value) {
                    if (arguments.length === 1) return Crafty.assets[key];
                    if (!Crafty.assets[key]) {
                        Crafty.assets[key] = value;
                        this.trigger("NewAsset", {
                            key: key,
                            value: value
                        });
                        return value;
                    }
                },
                /**@
     * #Crafty.imageWhitelist
     * @category Assets
     * @kind Method
     *
     * A list of file extensions that can be loaded as images by Crafty.load
     *
     * @example
     * ~~~
     * // add tif extension to list of supported image files
     * Crafty.imageWhitelist.push("tif");
     *
     * var assets = {
     *     "sprites": {
     *         "sprite.tif": {   //set a tif sprite
     *            "tile": 64,
     *            "tileh": 32,
     *            "map": { "sprite_car": [0, 0] }
     *         }
     *     },
     *     "audio": {
     *         "jump": "jump.mp3";
     *     }
     * };
     *
     * Crafty.load( assets, // preload the assets
     *     function() {     //when loaded
     *         Crafty.audio.play("jump"); //Play the audio file
     *         Crafty.e('2D, DOM, sprite_car'); // create entity with sprite
     *     },
     *
     *     function(e) { //progress
     *     },
     *
     *     function(e) { //uh oh, error loading
     *     }
     * );
     * ~~~
     *
     * @see Crafty.asset
     * @see Crafty.load
     */ imageWhitelist: [
                    "jpg",
                    "jpeg",
                    "gif",
                    "png",
                    "svg"
                ],
                /**@
     * #Crafty.load
     * @category Assets
     * @kind Method
     *
     * @sign public void Crafty.load(Object assets, Function onLoad[, Function onProgress[, Function onError]])
     * @param assets - Object JSON formatted (or JSON string), with assets to load (accepts sounds, images and sprites)
     * @param onLoad - Callback when the assets are loaded
     * @param onProgress - Callback when an asset is loaded. Contains information about assets loaded
     * @param onError - Callback when an asset fails to load
     *
     * Preloader for all assets. Takes a JSON formatted object (or JSON string) of files and adds them to the
     * `Crafty.assets` object, as well as setting sprites accordingly.
     *
     * Format must follow the pattern shown in the example below, but it's not required to pass all "audio",
     * "images" and "sprites" properties, only those you'll need. For example, if you don't need to preload
     * sprites, you can omit that property.
     *
     * By default, Crafty will assume all files are in the current path.  For changing these,
     * use the function `Crafty.paths`.
     *
     * Files with suffixes in `imageWhitelist` (case insensitive) will be loaded.
     *
     * It's possible to pass the full file path(including protocol), instead of just the filename.ext, in case
     * you want some asset to be loaded from another domain.
     *
     * If `Crafty.support.audio` is `true`, files with the following suffixes `mp3`, `wav`, `ogg` and
     * `mp4` (case insensitive) can be loaded.
     *
     * The `onProgress` function will be passed on object with information about
     * the progress including how many assets loaded, total of all the assets to
     * load and a percentage of the progress.
     * ~~~
     * { loaded: j, total: total, percent: (j / total * 100), src:src }
     * ~~~
     *
     * `onError` will be passed with the asset that couldn't load.
     *
     * When `onError` is not provided, the onLoad is loaded even when some assets are not successfully loaded.
     * Otherwise, onLoad will be called no matter whether there are errors or not.
     *
     * @example
     * ~~~
     * var assetsObj = {
     *     "audio": {
     *         "beep": ["beep.wav", "beep.mp3", "beep.ogg"],
     *         "boop": "boop.wav",
     *         "slash": "slash.wav"
     *     },
     *     "images": ["badguy.bmp", "goodguy.png"],
     *     "sprites": {
     *         "animals.png": {
     *             "tile": 50,
     *             "tileh": 40,
     *             "map": { "ladybug": [0,0], "lazycat": [0,1], "ferociousdog": [0,2] }
     *             "paddingX": 5,
     *             "paddingY": 5,
     *             "paddingAroundBorder": 10
     *         },
     *         "vehicles.png": {
     *             "tile": 150,
     *             "tileh": 75,
     *             "map": { "car": [0,0], "truck": [0,1] }
     *         }
     *     },
     * };
     *
     * Crafty.load(assetsObj, // preload assets
     *     function() { //when loaded
     *         Crafty.scene("main"); //go to main scene
     *         Crafty.audio.play("boop"); //Play the audio file
     *         Crafty.e('2D, DOM, lazycat'); // create entity with sprite
     *     },
     *
     *     function(e) { //progress
     *     },
     *
     *     function(e) { //uh oh, error loading
     *     }
     * );
     * ~~~
     *
     * @see Crafty.paths
     * @see Crafty.assets
     * @see Crafty.imageWhitelist
     * @see Crafty.removeAssets
     */ load: function(data, oncomplete, onprogress, onerror) {
                    if (Array.isArray(data)) {
                        Crafty.log("Calling Crafty.load with an array of assets no longer works; see the docs for more details.");
                        return;
                    }
                    data = typeof data === "string" ? JSON.parse(data) : data;
                    var j = 0, total = (data.audio ? Object.keys(data.audio).length : 0) + (data.images ? Object.keys(data.images).length : 0) + (data.sprites ? Object.keys(data.sprites).length : 0), current, fileUrl, obj, type, asset, paths = Crafty.paths(), getFilePath = function(type, f) {
                        return f.search("://") === -1 ? type === "audio" ? paths.audio + f : paths.images + f : f;
                    }, // returns null if 'a' is not already a loaded asset, obj otherwise
                    isAsset = function(a) {
                        return Crafty.asset(a) || null;
                    }, isSupportedAudio = function(f) {
                        return Crafty.support.audio && Crafty.audio.supports(Utility.fileTypeOf(f).type);
                    }, isValidImage = function(f) {
                        return -1 < Crafty.imageWhitelist.indexOf(Utility.fileTypeOf(f).type);
                    }, shortURLOf = function(URI) {
                        return Utility.fileTypeOf(URI).schema === "data" ? URL.createObjectURL(Utility.toBlob(URI)) : URI;
                    }, onImgLoad = function(obj, url) {
                        obj.onload = pro;
                        if (Crafty.support.prefix === "webkit") obj.src = ""; // workaround for webkit bug
                        obj.src = url;
                    };
                    //Progress function
                    function pro() {
                        var src = this.src;
                        //Remove events cause audio trigger this event more than once(depends on browser)
                        if (this.removeEventListener) this.removeEventListener("canplaythrough", pro, false);
                        j++;
                        //if progress callback, give information of assets loaded, total and percent
                        if (onprogress) onprogress({
                            loaded: j,
                            total: total,
                            percent: j / total * 100,
                            src: src
                        });
                        if (j === total && oncomplete) oncomplete();
                    }
                    //Error function
                    function err() {
                        var src = this.src;
                        if (onerror) onerror({
                            loaded: j,
                            total: total,
                            percent: j / total * 100,
                            src: src
                        });
                        j++;
                        if (j === total && oncomplete) oncomplete();
                    }
                    for(type in data)for(asset in data[type]){
                        if (!data[type].hasOwnProperty(asset)) continue; // maintain compatibility to other frameworks while iterating array
                        current = data[type][asset];
                        obj = null;
                        if (type === "audio") {
                            current = typeof current === "object" ? current : {
                                "": current + ""
                            };
                            // Disable (Don't make functions in a loop) warning
                            // jshint -W083
                            var files = Object.keys(current).filter(function(key) {
                                var fileUrl = getFilePath(type, current[key]);
                                if (!isAsset(fileUrl) && isSupportedAudio(current[key]) && !Crafty.audio.sounds[asset]) return shortURLOf(fileUrl);
                            });
                            // jshint +W083
                            if (files[0]) obj = Crafty.audio.add(asset, files);
                            //extract actual audio obj if audio creation was successfull
                            if (obj) obj = obj.obj;
                            //addEventListener is supported on IE9 , Audio as well
                            if (obj && obj.addEventListener) obj.addEventListener("canplaythrough", pro, false);
                        } else {
                            asset = type === "sprites" ? asset : current;
                            fileUrl = getFilePath(type, asset);
                            if (!isAsset(fileUrl) && isValidImage(asset)) {
                                obj = new Image();
                                fileUrl = shortURLOf(fileUrl);
                                if (type === "sprites") Crafty.sprite(current.tile, current.tileh, fileUrl, current.map, current.paddingX, current.paddingY, current.paddingAroundBorder);
                                Crafty.asset(fileUrl, obj);
                                onImgLoad(obj, fileUrl);
                            }
                        }
                        if (obj) obj.onerror = err;
                        else err.call({
                            src: fileUrl
                        });
                    }
                    // If we aren't trying to handle *any* of the files, that's as complete as it gets!
                    if (total === 0 && oncomplete) oncomplete();
                },
                /**@
     * #Crafty.removeAssets
     * @category Assets
     * @kind Method
     *
     * @sign public void Crafty.removeAssets(Object assets)
     * @param data - Object JSON formatted (or JSON string), with assets to remove (accepts sounds, images and sprites)
     *
     * Removes assets (audio, images, sprites - and related sprite components) in order to allow the browser
     * to free memory.
     *
     * Recieves a JSON fomatted object (or JSON string) containing 'audio', 'images' and/or 'sprites'
     * properties with assets to be deleted. Follows a similar format as Crafty.load 'data' argument. If
     * you pass the exact same object passed to Crafty.load, that will delete everything loaded that way.
     * For sprites, if you want to keep some specific component, just don't pass that component's name in
     * the sprite 'map'.
     *
     * Note that in order to remove the sprite components related to a given sprite, it's required to
     * pass the 'map' property of that sprite, and although its own properties's values (the properties refer
     * to sprite components) are not used in the removing process, omitting them will cause an error (since
     * 'map' is an object, thus it's properties can NOT omitted - however, they can be null, or undefined).
     * It will work as long as the 'map' objects' properties have any value. Or if you define 'map' itself
     * as an array, like:
     * "map": [ "car", "truck" ] instead of "map": { "car": [0,0], "truck": [0,1] }.
     * This is examplified below ("animals.png" VS. "vehicles.png" sprites).
     *
     * @example
     * ~~~
     * var assetsToRemoveObj = {
     *     "audio": {
     *         "beep": ["beep.wav", "beep.mp3", "beep.ogg"],
     *         "boop": "boop.wav"
     *     },
     *     "images": ["badguy.bmp", "goodguy.png"],
     *     "sprites": {
     *         "animals.png": {
     *             "map": { "ladybug": [0,0], "lazycat": [0,1] },
     *         },
     *         "vehicles.png": {
     *             "map": [ "car", "truck" ]
     *         }
     *     }
     * }
     *
     * Crafty.removeAssets(assetsToRemoveObj);
     * ~~~
     *
     * @see Crafty.load
     */ removeAssets: function(data) {
                    data = typeof data === "string" ? JSON.parse(data) : data;
                    var current, fileUrl, type, asset, paths = Crafty.paths(), getFilePath = function(type, f) {
                        return f.search("://") === -1 ? type === "audio" ? paths.audio + f : paths.images + f : f;
                    };
                    for(type in data)for(asset in data[type]){
                        if (!data[type].hasOwnProperty(asset)) continue; // maintain compatibility to other frameworks while iterating array
                        current = data[type][asset];
                        if (type === "audio") {
                            if (typeof current === "object") for(var i in current){
                                fileUrl = getFilePath(type, current[i]);
                                if (Crafty.asset(fileUrl)) Crafty.audio.remove(asset);
                            }
                            else if (typeof current === "string") {
                                fileUrl = getFilePath(type, current);
                                if (Crafty.asset(fileUrl)) Crafty.audio.remove(asset);
                            }
                        } else {
                            asset = type === "sprites" ? asset : current;
                            fileUrl = getFilePath(type, asset);
                            if (Crafty.asset(fileUrl)) {
                                if (type === "sprites") for(var comp in current.map)delete Crafty.components()[comp];
                                delete Crafty.assets[fileUrl];
                            }
                        }
                    }
                }
            };
        },
        {
            "../core/core.js": 10,
            "./utility": 19
        }
    ],
    13: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #Model
 * @category Model
 * @kind Component
 *
 * Model is a component that offers new features for isolating business
 * logic in your application. It offers default values, dirty values,
 * and deep events on your data.
 *
 * All data should be accessed via the appropriate methods `.get`, `.set`,
 * and `.data` for the proper events to be triggered. It is not encouraged
 * to access them directly.
 *
 * Dirty values make it simple to inspect a model and see what values have changed.
 *
 * Deep events allow you to bind to specific fields, like `name` or even deep fields
 * like `contact.email` and get notified when those specific fields are updated.
 *
 * @trigger Change - When any data on the model has changed.
 * @trigger Change[key] - When the specific key on the model has changed.
 * @trigger Change[key.key] - The nested key value has changed.
 * @example
 * ~~~
 * Crafty.c('Person', {
 *   name: 'Fox',
 *   init: function() { this.requires('Model'); }
 * });
 * person = Crafty.e('Person').attr({name: 'blaine'});
 * person.bind('Change[name]', function() {
 *   Crafty.log('name changed!');
 * });
 * person.attr('name', 'blainesch'); // Triggers event
 * person.is_dirty('name'); // true
 * person.changed // name
 * ~~~
 */ module.exports = {
                init: function() {
                    this.changed = [];
                    this.bind("Change", this._changed_attributes);
                    this.bind("Change", this._changed_triggers);
                },
                /**
     * Fires more specific `Change` events.
     *
     * For instance a `Change[name]` may get fired when you
     * update the name data attribute on the model.
     */ _changed_triggers: function(data, options) {
                    var key;
                    options = Crafty.extend.call({
                        pre: ""
                    }, options);
                    for(key in data){
                        this.trigger("Change[" + options.pre + key + "]", data[key]);
                        if (data[key].constructor === Object) this._changed_triggers(data[key], {
                            pre: options.pre + key + "."
                        });
                    }
                },
                /**
     * Pushes all top-levle changed attribute names to the
     * changed array.
     */ _changed_attributes: function(data) {
                    var key;
                    for(key in data)this.changed.push(key);
                    return this;
                },
                /**@
     * #.is_dirty
     * @comp Model
     * @kind Method
     *
     * Helps determine when data or the entire component is "dirty" or has changed attributes.
     *
     * @example
     * ~~~
     * person = Crafty.e('Person').attr({name: 'Fox', age: 24})
     * person.is_dirty() // false
     * person.is_dirty('name') // false
     *
     * person.attr('name', 'Lucky');
     * person.is_dirty(); // true
     * person.is_dirty('name'); // true
     * person.is_dirty('age'); // false
     * person.changed; // ['name']
     * ~~~
     */ is_dirty: function(key) {
                    if (arguments.length === 0) return !!this.changed.length;
                    else return this.changed.indexOf(key) > -1;
                }
            };
        },
        {
            "../core/core.js": 10
        }
    ],
    14: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            module.exports = {
                _scenes: {},
                _current: null,
                /**@
     * #Crafty.scene
     * @category Scenes, Stage
     * @kind Method
     *
     * @trigger SceneChange - just before a new scene is initialized - { oldScene:String, newScene:String }
     * @trigger SceneDestroy - just before the current scene is destroyed - { newScene:String  }
     *
     * @sign public void Crafty.scene(String sceneName, Function init[, Function uninit])
     * @param sceneName - Name of the scene to add
     * @param init - Function to execute when scene is played
     * @param uninit - Function to execute before next scene is played, after entities with `2D` are destroyed
     *
     * This is equivalent to calling `Crafty.defineScene`.
     *
     * @sign public void Crafty.scene(String sceneName[, Data])
     * @param sceneName - Name of scene to play
     * @param Data - The init function of the scene will be called with this data as its parameter.  Can be of any type other than a function.
     *
     * This is equivalent to calling `Crafty.enterScene`.
     *
     * Method to create scenes on the stage. Pass an ID and function to register a scene.
     *
     * To play a scene, just pass the ID. When a scene is played, all
     * previously-created entities with the `2D` component are destroyed. The
     * viewport is also reset.
     *
     * You can optionally specify an arugment that will be passed to the scene's init function.
     *
     * If you want some entities to persist over scenes (as in, not be destroyed)
     * simply add the component `Persist`.
     *
     * @example
     * ~~~
     * Crafty.defineScene("loading", function() {
     *     Crafty.background("#000");
     *     Crafty.e("2D, DOM, Text")
     *           .attr({ w: 100, h: 20, x: 150, y: 120 })
     *           .text("Loading")
     *           .textAlign("center")
     *           .textColor("#FFFFFF");
     * });
     *
     * Crafty.defineScene("UFO_dance",
     *              function() {Crafty.background("#444"); Crafty.e("UFO");},
     *              function() {...send message to server...});
     *
     * // An example of an init function which accepts arguments, in this case an object.
     * Crafty.defineScene("square", function(attributes) {
     *     Crafty.background("#000");
     *     Crafty.e("2D, DOM, Color")
     *           .attr(attributes)
     *           .color("red");
     *
     * });
     *
     * ~~~
     * This defines (but does not play) two scenes as discussed below.
     * ~~~
     * Crafty.enterScene("loading");
     * ~~~
     * This command will clear the stage by destroying all `2D` entities (except
     * those with the `Persist` component). Then it will set the background to
     * black and display the text "Loading".
     * ~~~
     * Crafty.enterScene("UFO_dance");
     * ~~~
     * This command will clear the stage by destroying all `2D` entities (except
     * those with the `Persist` component). Then it will set the background to
     * gray and create a UFO entity. Finally, the next time the game encounters
     * another command of the form `Crafty.scene(scene_name)` (if ever), then the
     * game will send a message to the server.
     * ~~~
     * Crafty.enterScene("square", {x:10, y:10, w:20, h:20});
     * ~~~
     * This will clear the stage, set the background black, and create a red square with the specified position and dimensions.
     * ~~~
     */ scene: function(name, intro, outro) {
                    // If there's one argument, or the second argument isn't a function, play the scene
                    if (arguments.length === 1 || typeof arguments[1] !== "function") {
                        Crafty.enterScene(name, arguments[1]);
                        return;
                    }
                    // Otherwise, this is a call to create a scene
                    Crafty.defineScene(name, intro, outro);
                },
                /* 
     * #Crafty.defineScene
     * @category Scenes, Stage
     * @kind Method
     *
     * @sign public void Crafty.enterScene(String name[, Data])
     * @param name - Name of the scene to run.
     * @param Data - The init function of the scene will be called with this data as its parameter.  Can be of any type other than a function.
     *
     * @see Crafty.enterScene
     * @see Crafty.scene
     */ defineScene: function(name, init, uninit) {
                    if (typeof init !== "function") throw "Init function is the wrong type.";
                    this._scenes[name] = {};
                    this._scenes[name].initialize = init;
                    if (typeof uninit !== "undefined") this._scenes[name].uninitialize = uninit;
                    return;
                },
                /* 
     * #Crafty.enterScene
     * @category Scenes, Stage
     * @kind Method
     * 
     * @trigger SceneChange - just before a new scene is initialized - { oldScene:String, newScene:String }
     * @trigger SceneDestroy - just before the current scene is destroyed - { newScene:String  }
     *
     * @sign public void Crafty.enterScene(String name[, Data])
     * @param name - Name of the scene to run.
     * @param Data - The init function of the scene will be called with this data as its parameter.  Can be of any type other than a function.
     * 
     * @see Crafty.defineScene
     * @see Crafty.scene
     */ enterScene: function(name, data) {
                    if (typeof data === "function") throw "Scene data cannot be a function";
                    // ---FYI---
                    // this._current is the name (ID) of the scene in progress.
                    // this._scenes is an object like the following:
                    // {'Opening scene': {'initialize': fnA, 'uninitialize': fnB},
                    //  'Another scene': {'initialize': fnC, 'uninitialize': fnD}}
                    Crafty.trigger("SceneDestroy", {
                        newScene: name
                    });
                    Crafty.viewport.reset();
                    Crafty("2D").each(function() {
                        if (!this.has("Persist")) this.destroy();
                    });
                    // uninitialize previous scene
                    if (this._current !== null && "uninitialize" in this._scenes[this._current]) this._scenes[this._current].uninitialize.call(this);
                    // initialize next scene
                    var oldScene = this._current;
                    this._current = name;
                    Crafty.trigger("SceneChange", {
                        oldScene: oldScene,
                        newScene: name
                    });
                    if (this._scenes.hasOwnProperty(name)) this._scenes[name].initialize.call(this, data);
                    else Crafty.error('The scene "' + name + '" does not exist');
                    return;
                }
            };
        },
        {
            "../core/core.js": 10
        }
    ],
    15: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            try {
                var storage = typeof window !== "undefined" && window.localStorage || new require1("node-localstorage").LocalStorage("./localStorage");
            } catch (e) {
                var storage = null;
            }
            /**@
 * #Storage
 * @category Utilities
 * @kind Property
 *
 * Very simple way to get and set values, which will persist when the browser is closed also.
 * Storage wraps around HTML5 Web Storage, which is well-supported across browsers and platforms, but limited to 5MB total storage per domain.
 * Storage is also available for node, which is permanently persisted to the `./localStorage` folder - take care of removing entries. Note that multiple Crafty instances use the same storage, so care has to be taken not to overwrite existing entries.
 */ /**@
 * #Crafty.storage
 * @comp Storage
 * @kind Method
 *
 * @sign Crafty.storage(String key)
 * @param key - a key you would like to get from the storage.
 * @returns The stored value, or `null` if none saved under that key exists
 *
 * @sign Crafty.storage(String key, String value)
 * @param key - the key you would like to save the data under.
 * @param value - the value you would like to save.
 *
 * @sign Crafty.storage(String key, [Object value, Array value, Boolean value])
 * @param key - the key you would like to save the data under.
 * @param value - the value you would like to save, can be an Object or an Array.
 *
 * `Crafty.storage` is used synchronously to either get or set values.
 *
 * You can store booleans, strings, objects and arrays.
 *
 * @note Because the underlying method is synchronous, it can cause slowdowns if used frequently during gameplay.
 * You should aim to load or save data at reasonable times such as on level load,
 * or in response to specific user actions.
 *
 * @note If used in a cross-domain context, the localStorage might not be accessible.
 *
 * @example
 * Get an already stored value
 * ~~~
 * var playername = Crafty.storage('playername');
 * ~~~
 *
 * @example
 * Save a value
 * ~~~
 * Crafty.storage('playername', 'Hero');
 * ~~~
 *
 * @example
 * Test to see if a value is already there.
 * ~~~
 * var heroname = Crafty.storage('name');
 * if(!heroname){
 *   // Maybe ask the player what their name is here
 *   heroname = 'Guest';
 * }
 * // Do something with heroname
 * ~~~
 */ var store = function(key, value) {
                var _value = value;
                if (!storage) {
                    Crafty.error("Local storage is not accessible.  (Perhaps you are including crafty.js cross-domain?)");
                    return false;
                }
                if (arguments.length === 1) try {
                    return JSON.parse(storage.getItem(key));
                } catch (e) {
                    return storage.getItem(key);
                }
                else {
                    if (typeof value === "object") _value = JSON.stringify(value);
                    storage.setItem(key, _value);
                }
            };
            /**@
 * #Crafty.storage.remove
 * @comp Storage
 * @kind Method
 *
 * @sign Crafty.storage.remove(String key)
 * @param key - a key where you will like to delete the value of.
 *
 * Generally you do not need to remove values from localStorage, but if you do
 * store large amount of text, or want to unset something you can do that with
 * this function.
 *
 * @example
 * Get an already stored value
 * ~~~
 * Crafty.storage.remove('playername');
 * ~~~
 *
 */ store.remove = function(key) {
                if (!storage) {
                    Crafty.error("Local storage is not accessible.  (Perhaps you are including crafty.js cross-domain?)");
                    return;
                }
                storage.removeItem(key);
            };
            module.exports = store;
        },
        {
            "../core/core.js": 10
        }
    ],
    16: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            // Dictionary of existing systems
            Crafty._systems = {};
            /**@
 * #Crafty.s
 * @category Core
 * @kind Method
 *
 * Registers a system.
 *
 * @trigger SystemLoaded - When the system has initialized itself - obj - system object
 * @trigger SystemDestroyed - Right before the system is destroyed - obj - system object
 *
 * @sign void Crafty.s(String name, Obj template[, Obj options][, Boolean lazy])
 * Register a system
 * @param name - The name of the system
 * @param template - an object whose methods and properties will be copied to the new system
 * @param options - an object whose properties will be deep copied to the new system's options property
 * @param lazy - a flag that indicates whether the system should be initialized right away or the first time it is referenced
 *
 * @sign System Crafty.s(String name)
 * Access the named system
 * @param name - The system to return
 * @returns The referenced system.  If the system has not been initialized, it will be before it is returned.
 *
 * Objects which handle entities might want to subscribe to the event system without being entities themselves.
 * When you declare a system with a template object, all the methods and properties of that template are copied to a new object.
 * This new system will automatically have the following event related methods, which function like those of components:
 * `.bind()`, `unbind()`, `trigger()`, `one()`, `uniqueBind()`, `destroy()`.
 * Much like components, you can also provide `init()` and `remove()` methods,
 * a `properties` dictionary which will be used to define properties with Object.defineProperty,
 * as well as an `events` parameter for automatically binding to events.
 *
 * @note The `init()` method is for setting up the internal state of the system,
 * if you create entities in it that then reference the system, that'll create an infinite loop.
 */ Crafty.s = function(name, obj, options, lazy) {
                if (obj) {
                    if (typeof options === "boolean") {
                        lazy = options;
                        options = null;
                    }
                    if (lazy === false) {
                        Crafty._systems[name] = new Crafty.CraftySystem(name, obj, options);
                        Crafty.trigger("SystemLoaded", name);
                    } else Crafty._registerLazySystem(name, obj, options);
                } else return Crafty._systems[name];
            };
            function optionMerge(defaults, specific) {
                var options = {};
                // Copy all the specified keys, then all the default keys that aren't specified
                for(var key in specific)options[key] = specific[key];
                for(key in defaults)if (!(key in specific)) options[key] = defaults[key];
                return options;
            }
            Crafty._registerLazySystem = function(name, obj, options) {
                // This is a bit of magic to only init a system if it's requested at least once.
                // We define a getter for _systems[name] that will first initialize the system,
                // and then redefine _systems[name] to remove that getter.
                Object.defineProperty(Crafty._systems, name, {
                    get: function() {
                        Object.defineProperty(Crafty._systems, name, {
                            value: new Crafty.CraftySystem(name, obj, options),
                            writable: true,
                            enumerable: true,
                            configurable: true
                        });
                        Crafty.trigger("SystemLoaded", name);
                        return Crafty._systems[name];
                    },
                    configurable: true
                });
            };
            // Each system has its properties and methods copied onto an object of this type
            Crafty.CraftySystem = function() {
                var systemID = 1;
                return function(name, template, options) {
                    this.name = name;
                    if (!template) return this;
                    this._systemTemplate = template;
                    this.extend(template);
                    // Overwrite any default options with the passed options object
                    // This does a deep copy on the objects, and treats null as a specified value
                    this.options = optionMerge(this.options, options);
                    // Add the "low leveL" callback methods
                    Crafty._addCallbackMethods(this);
                    // Give this object a global ID.  Used for event handlers.
                    this[0] = "system" + systemID++;
                    // Define properties
                    if ("properties" in template) {
                        var props = template.properties;
                        for(var propertyName in props)Object.defineProperty(this, propertyName, props[propertyName]);
                    }
                    // If an events object is provided, bind the listed event handlers
                    if ("events" in template) {
                        var auto = template.events;
                        for(var eventName in auto){
                            var fn = typeof auto[eventName] === "function" ? auto[eventName] : template[auto[eventName]];
                            this.bind(eventName, fn);
                        }
                    }
                    // Run any instantiation code
                    if (typeof this.init === "function") this.init(name);
                };
            }();
            Crafty.CraftySystem.prototype = {
                extend: function(obj) {
                    // Copy properties and methods of obj
                    for(var key in obj)if (typeof this[key] === "undefined") this[key] = obj[key];
                },
                // Event methods
                bind: function(event, callback) {
                    this._bindCallback(event, callback);
                    return this;
                },
                trigger: function(event, data) {
                    this._runCallbacks(event, data);
                    return this;
                },
                unbind: function(event, callback) {
                    this._unbindCallbacks(event, callback);
                    return this;
                },
                one: function(event, callback) {
                    var self = this;
                    var oneHandler = function(data) {
                        callback.call(self, data);
                        self.unbind(event, oneHandler);
                    };
                    return self.bind(event, oneHandler);
                },
                uniqueBind: function(event, callback) {
                    this.unbind(event, callback);
                    return this.bind(event, callback);
                },
                destroy: function() {
                    Crafty.trigger("SystemDestroyed", this);
                    // Check the template itself
                    if (typeof this.remove === "function") this.remove();
                    this._unbindAll();
                    delete Crafty._systems[this.name];
                }
            };
        },
        {
            "../core/core.js": 10
        }
    ],
    17: [
        function(require1, module, exports) {
            /**@
 * #Delay
 * @category Utilities
 * @kind Component
 *
 * A component for triggering functions after a given amount of time.
 *
 * This syncs with Crafty's internal clock, and so should generally be preferred to using methods such as `setTimeout`.
 */ module.exports = {
                /**@
     * #.delaySpeed
     * @comp Delay
     *
     * The rate of the delay. This property defaults to 1.
     * When setting delaySpeed to 0.5, delays will take twice as long,
     * setting it to 2.0 will make them twice as short
     */ delaySpeed: 1,
                init: function() {
                    this._delays = [];
                    this._delaysPaused = false;
                    this.bind("UpdateFrame", function(frameData) {
                        if (this._delaysPaused) return;
                        var index = this._delays.length;
                        while(--index >= 0){
                            var item = this._delays[index];
                            if (item === false) // remove canceled item from array
                            this._delays.splice(index, 1);
                            else {
                                item.accumulator += frameData.dt * this.delaySpeed;
                                // The while loop handles the (pathological) case where dt>delay
                                while(item.accumulator >= item.delay && item.repeat >= 0){
                                    item.accumulator -= item.delay;
                                    item.repeat--;
                                    item.callback.call(this);
                                }
                                // remove finished item from array
                                if (item.repeat < 0) {
                                    this._delays.splice(index, 1);
                                    if (typeof item.callbackOff === "function") item.callbackOff.call(this);
                                }
                            }
                        }
                    });
                },
                /**@
     * #.delay
     * @comp Delay
     * @kind Method
     * @sign public this.delay(Function callback, Number delay[, Number repeat[, Function callbackOff]])
     * @param callback - Method to execute after given amount of milliseconds. If reference of a
     * method is passed, there's possibility to cancel the delay.
     * @param delay - Amount of milliseconds to execute the method.
     * @param repeat - (optional) How often to repeat the delayed function. A value of 0 triggers the delayed
     * function exactly once. A value n > 0 triggers the delayed function exactly n+1 times. A
     * value of -1 triggers the delayed function indefinitely. Defaults to one execution.
     * @param callbackOff - (optional) Method to execute after delay ends(after all iterations are executed).
     * If repeat value equals -1, callbackOff will never be triggered.
     *
     * The delay method will execute a function after a given amount of time in milliseconds.
     *
     * It is not a wrapper for `setTimeout`.
     *
     * If Crafty is paused, the delay is interrupted with the pause and then resume when unpaused
     *
     * If the entity is destroyed, the delay is also destroyed and will not have effect.
     *
     * @example
     *
     * The simplest delay
     * ~~~
     * Crafty.log("start");
     * Crafty.e("Delay").delay(function() {
     *   Crafty.log("100ms later");
     * }, 100, 0);
     * ~~~
     *
     * Delay with callbackOff to be executed after all delay iterations
     * ~~~
     * Crafty.log("start");
     * Crafty.e("Delay").delay(function() {
     *   Crafty.log("100ms later");
     * }, 100, 3, function() {
     *   Crafty.log("delay finished");
     * });
     * ~~~
     *
     */ delay: function(callback, delay, repeat, callbackOff) {
                    this._delays.push({
                        accumulator: 0,
                        callback: callback,
                        callbackOff: callbackOff,
                        delay: delay,
                        repeat: (repeat < 0 ? Infinity : repeat) || 0
                    });
                    return this;
                },
                /**@
     * #.cancelDelay
     * @comp Delay
     * @kind Method
     *
     * @sign public this.cancelDelay(Function callback)
     * @param callback - Method reference passed to .delay
     *
     * The cancelDelay method will cancel a delay set previously.
     *
     * @example
     * ~~~
     * var doSomething = function(){
     *   Crafty.log("doing something");
     * };
     *
     * // execute doSomething each 100 miliseconds indefinetely
     * var ent = Crafty.e("Delay").delay(doSomething, 100, -1);
     *
     * // and some time later, cancel further execution of doSomething
     * ent.cancelDelay(doSomething);
     * ~~~
     */ cancelDelay: function(callback) {
                    var index = this._delays.length;
                    while(--index >= 0){
                        var item = this._delays[index];
                        if (item && item.callback === callback) this._delays[index] = false;
                    }
                    return this;
                },
                /**@
     * #.pauseDelays
     * @comp Delay
     * @kind Method
     *
     * @sign public this.pauseDelays()
     *
     * The pauseDelays method will pause all delays of this
     * entity until resumed.
     *
     * @example
     * ~~~
     * var doSomething = function(){
     *   Crafty.log("doing something");
     * };
     *
     * // execute doSomething each 100 miliseconds indefinetely
     * var ent = Crafty.e("Delay").delay(doSomething, 100, -1);
     *
     * // and some time later, the gameplay is paused
     * ent.pauseDelays();
     * ~~~
     */ pauseDelays: function() {
                    this._delaysPaused = true;
                },
                /**@
     * #.resumeDelays
     * @comp Delay
     * @kind Method
     *
     * @sign public this.resumeDelays()
     *
     * The resumeDelays method will resume earlier paused delays for this
     * entity
     *
     * @example
     * ~~~
     * var doSomething = function(){
     *   Crafty.log("doing something");
     * };
     *
     * // execute doSomething each 100 miliseconds indefinetely
     * var ent = Crafty.e("Delay").delay(doSomething, 100, -1);
     *
     * // and some time later, the gameplay is paused (or only
     * // a part of it is frozen)
     * ent.pauseDelays();
     *
     * // the player resumes gameplay
     * ent.resumeDelays();
     * ~~~
     */ resumeDelays: function() {
                    this._delaysPaused = false;
                }
            };
        },
        {}
    ],
    18: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #Tween
 * @category Animation
 * @kind Component
 *
 * @trigger TweenEnd - when a tween finishes - Object - an object containing the properties that finished tweening
 *
 * Component to animate the change in 2D properties over time.
 */ module.exports = {
                /**@
     * #.tweenSpeed
     * @comp Tween
     *
     * The rate of the tween. This property defaults to 1.
     * When setting tweenSpeed to 0.5, tweens will take twice as long,
     * setting it to 2.0 will make them twice as short
     */ tweenSpeed: 1,
                init: function() {
                    this.tweenGroup = {};
                    this.tweenStart = {};
                    this.tweens = [];
                    this.uniqueBind("UpdateFrame", this._tweenTick);
                },
                _tweenTick: function(frameData) {
                    var tween, v, i;
                    for(i = this.tweens.length - 1; i >= 0; i--){
                        tween = this.tweens[i];
                        tween.easing.tick(frameData.dt * this.tweenSpeed);
                        v = tween.easing.value();
                        this._doTween(tween.props, v);
                        if (tween.easing.complete) {
                            this.tweens.splice(i, 1);
                            this._endTween(tween.props);
                        }
                    }
                },
                _doTween: function(props, v) {
                    for(var name in props)this[name] = (1 - v) * this.tweenStart[name] + v * props[name];
                },
                /**@
     * #.tween
     * @comp Tween
     * @kind Method
     *
     * @sign public this .tween(Object properties, Number duration[, String|function easingFn])
     * @param properties - Object of numeric properties and what they should animate to
     * @param duration - Duration to animate the properties over, in milliseconds.
     * @param easingFn - A string or custom function specifying an easing.  (Defaults to linear behavior.)  See Crafty.easing for more information.
     *
     * This method will animate numeric properties over the specified duration.
     * These include `x`, `y`, `w`, `h`, `alpha` and `rotation`.
     *
     * The object passed should have the properties as keys and the value should be the resulting
     * values of the properties.  The passed object might be modified if later calls to tween animate the same properties.
     *
     * @example
     * Move an object to 100,100 and fade out over 200 ms.
     * ~~~
     * Crafty.e("2D, Tween")
     *    .attr({alpha: 1.0, x: 0, y: 0})
     *    .tween({alpha: 0.0, x: 100, y: 100}, 200)
     * ~~~
     * @example
     * Rotate an object over 2 seconds, using the "smootherStep" easing function.
     * ~~~
     * Crafty.e("2D, Tween")
     *    .attr({rotation:0})
     *    .tween({rotation:180}, 2000, "smootherStep")
     * ~~~
     *
     * @see Crafty.easing
     *
     */ tween: function(props, duration, easingFn) {
                    var tween = {
                        props: props,
                        easing: new Crafty.easing(duration, easingFn)
                    };
                    // Tweens are grouped together by the original function call.
                    // Individual properties must belong to only a single group
                    // When a new tween starts, if it already belongs to a group, move it to the new one
                    // Record the group it currently belongs to, as well as its starting coordinate.
                    for(var propname in props){
                        if (typeof this.tweenGroup[propname] !== "undefined") this.cancelTween(propname);
                        this.tweenStart[propname] = this[propname];
                        this.tweenGroup[propname] = props;
                    }
                    this.tweens.push(tween);
                    return this;
                },
                /**@
     * #.cancelTween
     * @comp Tween
     * @kind Method
     *
     * @sign public this .cancelTween(String target)
     * @param target - The property to cancel
     *
     * @sign public this .cancelTween(Object target)
     * @param target - An object containing the properties to cancel.
     *
     * Stops tweening the specified property or properties.
     * Passing the object used to start the tween might be a typical use of the second signature.
     */ cancelTween: function(target) {
                    if (typeof target === "string") {
                        if (typeof this.tweenGroup[target] === "object") delete this.tweenGroup[target][target];
                    } else if (typeof target === "object") for(var propname in target)this.cancelTween(propname);
                    return this;
                },
                /**@
     * #.pauseTweens
     * @comp Tween
     * @kind Method
     *
     * @sign public this .pauseTweens()
     *
     * Pauses all tweens associated with the entity
     */ pauseTweens: function() {
                    this.tweens.map(function(e) {
                        e.easing.pause();
                    });
                },
                /**@
     * #.resumeTweens
     * @comp Tween
     * @kind Method
     *
     * @sign public this .resumeTweens()
     *
     * Resumes all paused tweens associated with the entity
     */ resumeTweens: function() {
                    this.tweens.map(function(e) {
                        e.easing.resume();
                    });
                },
                /*
  * Stops tweening the specified group of properties, and fires the "TweenEnd" event.
  */ _endTween: function(properties) {
                    var notEmpty = false;
                    for(var propname in properties){
                        notEmpty = true;
                        delete this.tweenGroup[propname];
                    }
                    if (notEmpty) this.trigger("TweenEnd", properties);
                }
            };
        },
        {
            "../core/core.js": 10
        }
    ],
    19: [
        function(require1, module, exports) {
            exports.blobOf = function blobOf(URI) {
                var XHR = new XMLHttpRequest();
                XHR.responseType = "blob";
                XHR.open("GET", URI);
                return new Promise(function(resolve, reject) {
                    XHR.onload = function() {
                        resolve(this.response);
                    };
                    XHR.onerror = reject;
                    XHR.send();
                });
            };
            var DataURI = /^data:(.+?\/(.+?))?(;base64)?,(\S+)/;
            exports.fileTypeOf = function fileTypeOf(URI) {
                var schema = /^(?:(\w+):)?.+?(?:\.(\w+))?$/.exec(URI);
                switch(schema[1]){
                    case "data":
                        return {
                            schema: "data",
                            type: DataURI.exec(URI)[2]
                        };
                    case "blob":
                        return exports.blobOf(URI).then(function(blob) {
                            return {
                                schema: "blob",
                                type: blob.type
                            };
                        });
                    default:
                        return {
                            schema: schema[1],
                            type: schema[2]
                        };
                }
            };
            var BlobBuilder = window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            exports.toBlob = function toBlob(dataURI) {
                dataURI = DataURI.exec(dataURI);
                var type = dataURI[1], base64 = dataURI[3], data = dataURI[4];
                data = base64 ? window.atob(data) : data;
                var aBuffer = new ArrayBuffer(data.length);
                var uBuffer = new Uint8Array(aBuffer);
                for(var i = 0; data[i]; i++)uBuffer[i] = data.charCodeAt(i);
                if (!BlobBuilder) return new window.Blob([
                    aBuffer
                ], {
                    type: type
                });
                var builder = new BlobBuilder();
                builder.append(aBuffer);
                return builder.getBlob(type);
            };
        },
        {}
    ],
    20: [
        function(require1, module, exports) {
            module.exports = "0.8.0";
        },
        {}
    ],
    21: [
        function(require1, module, exports) {
            // Define common features available in both browser and node
            module.exports = function(requireNew) {
                if (requireNew) require1 = requireNew; // jshint ignore:line
                var Crafty = require1("./core/core");
                require1("./core/extensions");
                Crafty.easing = require1("./core/animation");
                Crafty.c("Model", require1("./core/model"));
                Crafty.extend(require1("./core/scenes"));
                Crafty.storage = require1("./core/storage");
                Crafty.c("Delay", require1("./core/time"));
                Crafty.c("Tween", require1("./core/tween"));
                var HashMap = require1("./spatial/spatial-grid");
                Crafty.HashMap = HashMap;
                Crafty.map = new HashMap();
                require1("./core/systems");
                require1("./spatial/2d");
                require1("./spatial/motion");
                require1("./spatial/platform");
                require1("./spatial/collision");
                require1("./spatial/rect-manager");
                require1("./spatial/math");
                require1("./controls/controls-system");
                require1("./controls/controls");
                require1("./controls/keyboard");
                require1("./controls/keycodes");
                require1("./controls/mouse");
                require1("./controls/touch");
                require1("./debug/logging");
                return Crafty;
            };
        },
        {
            "./controls/controls": 4,
            "./controls/controls-system": 3,
            "./controls/keyboard": 5,
            "./controls/keycodes": 6,
            "./controls/mouse": 7,
            "./controls/touch": 8,
            "./core/animation": 9,
            "./core/core": 10,
            "./core/extensions": 11,
            "./core/model": 13,
            "./core/scenes": 14,
            "./core/storage": 15,
            "./core/systems": 16,
            "./core/time": 17,
            "./core/tween": 18,
            "./debug/logging": 24,
            "./spatial/2d": 55,
            "./spatial/collision": 56,
            "./spatial/math": 57,
            "./spatial/motion": 58,
            "./spatial/platform": 59,
            "./spatial/rect-manager": 60,
            "./spatial/spatial-grid": 61
        }
    ],
    22: [
        function(require1, module, exports) {
            // Define common features
            var Crafty = require1("./crafty-common.js")();
            // Define features only available in browser environment
            Crafty.extend(require1("./core/loader"));
            Crafty.extend(require1("./inputs/dom-events"));
            // Needs to be required before any specific layers are
            require1("./graphics/layers");
            require1("./graphics/canvas");
            require1("./graphics/canvas-layer");
            require1("./graphics/webgl");
            require1("./graphics/webgl-layer");
            require1("./graphics/color");
            require1("./graphics/dom");
            require1("./graphics/dom-helper");
            require1("./graphics/dom-layer");
            require1("./graphics/drawing");
            require1("./graphics/gl-textures");
            require1("./graphics/renderable");
            require1("./graphics/html");
            require1("./graphics/image");
            require1("./graphics/particles");
            require1("./graphics/sprite-animation");
            require1("./graphics/sprite");
            require1("./graphics/text");
            require1("./graphics/viewport");
            require1("./isometric/diamond-iso");
            require1("./isometric/isometric");
            // Needs to be required before any specific inputs are
            require1("./inputs/util");
            require1("./inputs/device");
            require1("./inputs/keyboard");
            require1("./inputs/lifecycle");
            require1("./inputs/mouse");
            require1("./inputs/pointer");
            require1("./inputs/touch");
            require1("./sound/sound");
            require1("./debug/debug-layer");
            // Define some aliases for renamed properties
            require1("./aliases").defineAliases(Crafty);
            if (window) window.Crafty = Crafty;
            module.exports = Crafty;
        },
        {
            "./aliases": 2,
            "./core/loader": 12,
            "./crafty-common.js": 21,
            "./debug/debug-layer": 23,
            "./graphics/canvas": 26,
            "./graphics/canvas-layer": 25,
            "./graphics/color": 27,
            "./graphics/dom": 30,
            "./graphics/dom-helper": 28,
            "./graphics/dom-layer": 29,
            "./graphics/drawing": 31,
            "./graphics/gl-textures": 32,
            "./graphics/html": 33,
            "./graphics/image": 34,
            "./graphics/layers": 35,
            "./graphics/particles": 36,
            "./graphics/renderable": 37,
            "./graphics/sprite": 39,
            "./graphics/sprite-animation": 38,
            "./graphics/text": 40,
            "./graphics/viewport": 41,
            "./graphics/webgl": 43,
            "./graphics/webgl-layer": 42,
            "./inputs/device": 44,
            "./inputs/dom-events": 45,
            "./inputs/keyboard": 46,
            "./inputs/lifecycle": 47,
            "./inputs/mouse": 48,
            "./inputs/pointer": 49,
            "./inputs/touch": 50,
            "./inputs/util": 51,
            "./isometric/diamond-iso": 52,
            "./isometric/isometric": 53,
            "./sound/sound": 54
        }
    ],
    23: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js"), document1 = window.document;
            /**@
 * #DebugCanvas
 * @category Debug
 * @kind Component
 *
 * @trigger DebugDraw - when the entity is ready to be drawn to the stage
 * @trigger NoCanvas - if the browser does not support canvas
 *
 * When this component is added to an entity it will be drawn by the DebugCanvas layer.
 *
 * Crafty.debugCanvas.init() will be automatically called if it is not called already to initialize the canvas element.
 *
 * To visualise an object's MBR, use "WiredMBR" or "SolidMBR".
 * To visualise a "Collision" object's hitbox, use "WiredHitBox" or "SolidHitBox".
 * To visualize an entity's click area, use "WiredAreaMap" or "SolidAreaMap".
 *
 * @see DebugPolygon,  DebugRectangle
 */ Crafty.c("DebugCanvas", {
                init: function() {
                    this.requires("2D");
                    if (!Crafty.DebugCanvas.context) Crafty.DebugCanvas.init();
                    Crafty.DebugCanvas.add(this);
                    this._debug = {
                        alpha: 1.0,
                        lineWidth: 1
                    };
                    this.bind("RemoveComponent", this.onDebugRemove);
                    this.bind("Remove", this.onDebugDestroy);
                },
                // When component is removed
                onDebugRemove: function(id) {
                    if (id === "DebugCanvas") Crafty.DebugCanvas.remove(this);
                },
                //When entity is destroyed
                onDebugDestroy: function(id) {
                    Crafty.DebugCanvas.remove(this);
                },
                /**@
     * #.debugAlpha
     * @comp DebugCanvas
     * @kind Method
     *
     * @sign public  .debugAlpha(Number alpha)
     * @param alpha - The alpha level the component will be drawn with
     */ debugAlpha: function(alpha) {
                    this._debug.alpha = alpha;
                    return this;
                },
                /**@
     * #.debugFill
     * @comp DebugCanvas
     * @kind Method
     *
     * @sign public  .debugFill([String fillStyle])
     * @param fillStyle - The color the component will be filled with.  Defaults to "red". Pass the boolean false to turn off filling.
     * @example
     * ~~~
     * var myEntity = Crafty.e("2D, Collision, SolidHitBox ").debugFill("purple")
     * ~~~
     */ debugFill: function(fillStyle) {
                    if (typeof fillStyle === "undefined") fillStyle = "red";
                    this._debug.fillStyle = fillStyle;
                    return this;
                },
                /**@
     * #.debugStroke
     * @comp DebugCanvas
     * @kind Method
     *
     * @sign public  .debugStroke([String strokeStyle])
     * @param strokeStyle - The color the component will be outlined with.  Defaults to "red".  Pass the boolean false to turn this off.
     * @example
     * ~~~
     * var myEntity = Crafty.e("2D, Collision, WiredHitBox ").debugStroke("white")
     * ~~~
     */ debugStroke: function(strokeStyle) {
                    if (typeof strokeStyle === "undefined") strokeStyle = "red";
                    this._debug.strokeStyle = strokeStyle;
                    return this;
                },
                debugDraw: function(ctx) {
                    var ga = ctx.globalAlpha;
                    var props = this._debug;
                    if (props.alpha) ctx.globalAlpha = this._debug.alpha;
                    if (props.strokeStyle) ctx.strokeStyle = props.strokeStyle;
                    if (props.lineWidth) ctx.lineWidth = props.lineWidth;
                    if (props.fillStyle) ctx.fillStyle = props.fillStyle;
                    this.trigger("DebugDraw", ctx);
                    ctx.globalAlpha = ga;
                }
            });
            /**@
 * #DebugRectangle
 * @category Debug
 * @kind Component
 *
 * A component for rendering an object with a position and dimensions to the debug canvas.
 *
 *
 * ~~~
 * var myEntity = Crafty.e("2D, DebugRectangle")
 *                      .attr({x: 13, y: 37, w: 42, h: 42})
 *                      .debugStroke("green");
 * myEntity.debugRectangle(myEntity)
 *~~~
 * @see DebugCanvas
 */ Crafty.c("DebugRectangle", {
                init: function() {
                    this.requires("2D, DebugCanvas");
                },
                /**@
     * #.debugRectangle
     * @comp DebugRectangle
     * @kind Method
     *
     * @sign public  .debugRectangle(Object rect)
     * @param rect - an object with _x, _y, _w, and _h to draw
     *
     * Sets the rectangle that this component draws to the debug canvas.
     *
     */ debugRectangle: function(rect) {
                    this.debugRect = rect;
                    this.unbind("DebugDraw", this.drawDebugRect);
                    this.bind("DebugDraw", this.drawDebugRect);
                    return this;
                },
                drawDebugRect: function(ctx) {
                    var rect = this.debugRect;
                    if (rect === null || rect === undefined) return;
                    if (rect._h && rect._w) {
                        if (this._debug.fillStyle) ctx.fillRect(rect._x, rect._y, rect._w, rect._h);
                        if (this._debug.strokeStyle) ctx.strokeRect(rect._x, rect._y, rect._w, rect._h);
                    }
                }
            });
            /**@
 * #WiredMBR
 * @category Debug
 * @kind Component
 *
 * Adding this component to an entity will cause its MBR to be drawn to the debug canvas as an outline.
 *
 * The methods of DebugCanvas can be used to control this component's appearance.
 *
 * @see 2D, DebugRectangle, DebugCanvas
 */ Crafty.c("WiredMBR", {
                init: function() {
                    this.requires("DebugRectangle").debugStroke("purple");
                },
                events: {
                    PreRender: function() {
                        // Internal method for updating the MBR drawn.
                        this.debugRectangle(this._mbr || this);
                    }
                }
            });
            /**@
 * #SolidMBR
 * @category Debug
 * @kind Component
 *
 * Adding this component to an entity will cause its MBR to be drawn to the debug canvas.
 *
 * The methods of DebugCanvas can be used to control this component's appearance.
 *
 * @see 2D, DebugRectangle, DebugCanvas
 */ var solidMBR = {
                init: function() {
                    this.requires("DebugRectangle").debugFill("pink");
                },
                events: {
                    PreRender: function() {
                        // Internal method for updating the MBR drawn.
                        this.debugRectangle(this._mbr || this);
                    }
                }
            };
            Crafty.c("SolidMBR", solidMBR);
            // DEPRECATED: remove this in an upcoming release
            Crafty.c("VisibleMBR", solidMBR);
            /**@
 * #DebugPolygon
 * @category Debug
 * @kind Component
 *
 * For drawing a polygon to the debug canvas
 *
 * The methods of DebugCanvas can be used to control this component's appearance -- by default it is neither filled nor outlined
 *
 * @see DebugCanvas
 */ Crafty.c("DebugPolygon", {
                init: function() {
                    this.requires("2D, DebugCanvas");
                },
                /**@
     * #.debugPolygon
     * @comp DebugPolygon
     * @kind Method
     *
     * @sign public  .debugPolygon(Polygon poly)
     * @param poly - a polygon to render
     *
     * Sets the polygon that this component renders to the debug canvas.
     *
     */ debugPolygon: function(poly) {
                    this.polygon = poly;
                    this.unbind("DebugDraw", this.drawDebugPolygon);
                    this.bind("DebugDraw", this.drawDebugPolygon);
                    return this;
                },
                drawDebugPolygon: function(ctx) {
                    if (typeof this.polygon === "undefined") return;
                    ctx.beginPath();
                    var p = this.polygon.points, l = p.length;
                    for(var i = 0; i < l; i += 2)ctx.lineTo(p[i], p[i + 1]);
                    ctx.closePath();
                    if (this._debug.fillStyle) ctx.fill();
                    if (this._debug.strokeStyle) ctx.stroke();
                }
            });
            /**@
 * #WiredHitBox
 * @category Debug
 * @kind Component
 *
 * Adding this component to an entity with a Collision component will cause its collision polygon to be drawn to the debug canvas as an outline
 *
 * The methods of DebugCanvas can be used to control this component's appearance.
 * @see DebugPolygon, DebugCanvas
 */ Crafty.c("WiredHitBox", {
                init: function() {
                    this.requires("DebugPolygon").debugStroke("red").matchHitBox();
                    this.bind("NewHitbox", this.matchHitBox);
                },
                matchHitBox: function() {
                    this.debugPolygon(this.map);
                }
            });
            /**@
 * #SolidHitBox
 * @category Debug
 * @kind Component
 *
 * Adding this component to an entity with a Collision component will cause its collision polygon to be drawn to the debug canvas, with a default alpha level of 0.7.
 *
 * The methods of DebugCanvas can be used to control this component's appearance.
 * @see DebugPolygon, DebugCanvas
 */ Crafty.c("SolidHitBox", {
                init: function() {
                    this.requires("Collision, DebugPolygon").debugFill("orange").debugAlpha(0.7).matchHitBox();
                    this.bind("NewHitbox", this.matchHitBox);
                },
                matchHitBox: function() {
                    this.debugPolygon(this.map);
                }
            });
            /**@
 * #WiredAreaMap
 * @category Debug
 * @kind Component
 *
 * Adding this component to an entity with an AreaMap component will cause its click polygon to be drawn to the debug canvas as an outline.
 * Following click areas exist for an entity (in decreasing order of priority): AreaMap, Hitbox, MBR. Use the appropriate debug components to display them.
 *
 * The methods of DebugCanvas can be used to control this component's appearance.
 * @see DebugPolygon, DebugCanvas
 */ Crafty.c("WiredAreaMap", {
                init: function() {
                    this.requires("DebugPolygon").debugStroke("green").matchAreaMap();
                    this.bind("NewAreaMap", this.matchAreaMap);
                },
                matchAreaMap: function() {
                    this.debugPolygon(this.mapArea);
                }
            });
            /**@
 * #SolidAreaMap
 * @category Debug
 * @kind Component
 *
 * Adding this component to an entity with an AreaMap component will cause its click polygon to be drawn to the debug canvas, with a default alpha level of 0.7.
 * Following click areas exist for an entity (in decreasing order of priority): AreaMap, Hitbox, MBR. Use the appropriate debug components to display them.
 *
 * The methods of DebugCanvas can be used to control this component's appearance.
 * @see DebugPolygon, DebugCanvas
 */ Crafty.c("SolidAreaMap", {
                init: function() {
                    this.requires("DebugPolygon").debugFill("lime").debugAlpha(0.7).matchAreaMap();
                    this.bind("NewAreaMap", this.matchAreaMap);
                },
                matchAreaMap: function() {
                    this.debugPolygon(this.mapArea);
                }
            });
            Crafty.DebugCanvas = {
                context: null,
                entities: [],
                onetimeEntities: [],
                add: function(ent) {
                    this.entities.push(ent);
                },
                remove: function(ent) {
                    var list = this.entities;
                    for(var i = list.length - 1; i >= 0; i--)if (list[i] === ent) list.splice(i, 1);
                },
                // Mostly copied from canvas.init()
                // Called the first time a "DebugCanvas" component is added to an entity
                // We should consider how to abstract the idea of multiple canvases
                init: function() {
                    if (!Crafty.DebugCanvas.context) {
                        //check if canvas is supported
                        if (!Crafty.support.canvas) {
                            Crafty.trigger("NoCanvas");
                            Crafty.stop();
                            return;
                        }
                        //create an empty canvas element
                        var c;
                        c = document1.createElement("canvas");
                        c.width = Crafty.viewport.width;
                        c.height = Crafty.viewport.height;
                        c.style.position = "absolute";
                        c.style.left = "0px";
                        c.style.top = "0px";
                        c.id = "debug-canvas";
                        // The debug canvas should be on the very top; the highest a regular zindex can get is ~10000
                        c.style.zIndex = 100000;
                        Crafty.stage.elem.appendChild(c);
                        Crafty.DebugCanvas.context = c.getContext("2d");
                        Crafty.DebugCanvas._canvas = c;
                    }
                    //Bind rendering of canvas context (see drawing.js)
                    Crafty.unbind("RenderScene", Crafty.DebugCanvas.renderScene);
                    Crafty.bind("RenderScene", Crafty.DebugCanvas.renderScene);
                },
                // copied from drawAll()
                renderScene: function(rect) {
                    rect = rect || Crafty.viewport.rect();
                    var q = Crafty.DebugCanvas.entities, i = 0, l = q.length, ctx = Crafty.DebugCanvas.context, current;
                    var view = Crafty.viewport;
                    ctx.setTransform(view._scale, 0, 0, view._scale, Math.round(view._x * view._scale), Math.round(view._y * view._scale));
                    ctx.clearRect(rect._x, rect._y, rect._w, rect._h);
                    var lastLayer = null;
                    for(; i < l; i++){
                        current = q[i];
                        // If necessary, update the view transform to match the current entities layer
                        // If the current entity has no layer, switch back to the viewport's transform
                        if (lastLayer !== current._drawLayer) {
                            if (current._drawLayer) {
                                view = current._drawLayer._viewportRect();
                                ctx.setTransform(view._scale, 0, 0, view._scale, Math.round(-view._x * view._scale), Math.round(-view._y * view._scale));
                            } else {
                                view = Crafty.viewport;
                                ctx.setTransform(view._scale, 0, 0, view._scale, Math.round(view._x * view._scale), Math.round(view._y * view._scale));
                            }
                            lastLayer = current._drawLayer;
                        }
                        current.debugDraw(ctx);
                    }
                }
            };
        },
        {
            "../core/core.js": 10
        }
    ],
    24: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #Crafty.log
 * @category Debug
 * @kind Method
 *
 * @sign Crafty.log( arguments )
 * @param arguments - arguments which are passed to `console.log`
 *
 * This is a simple wrapper for `console.log`.  You can disable logging messages by setting `Crafty.loggingEnabled` to false.
 * It is recommended to use `Crafty.log`, as `console.log` can crash on IE9.
 */ /**@
 * #Crafty.error
 * @category Debug
 * @kind Method
 *
 * @sign Crafty.error( arguments )
 * @param arguments - arguments which are passed to `console.error`
 *
 * This is a simple wrapper for `console.error`.  You can disable logging messages by setting `Crafty.loggingEnabled` to false.
 * It is recommended to use `Crafty.error`, as `console.error` can crash on IE9.
 */ Crafty.extend({
                // Allow logging to be disabled
                loggingEnabled: true,
                // In some cases console.log doesn't exist, so provide a wrapper for it
                log: function() {
                    if (Crafty.loggingEnabled && (typeof window !== "undefined" ? window.console : console) && console.log) console.log.apply(console, arguments);
                },
                error: function() {
                    if (Crafty.loggingEnabled && (typeof window !== "undefined" ? window.console : console) && console.error) console.error.apply(console, arguments);
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    25: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #CanvasLayer
 * @category Graphics
 * @kind System
 *
 * An object for creating the canvas layer system.
 *
 * Mostly contains private methods to draw entities on a canvas element.
 */ Crafty._registerLayerTemplate("Canvas", {
                type: "Canvas",
                layerCount: 0,
                _changedObjs: null,
                _dirtyRects: null,
                _dirtyCells: null,
                _viewKeys: null,
                __tempRect: null,
                __tempSearchRect: null,
                __tempScreenRect: null,
                /**@
     * #.dirty
     * @comp CanvasLayer
     * @kind Method
     * @private
     *
     * @sign public .dirty(ent)
     * @param ent - The entity to add
     *
     * Add an entity to the list of Canvas objects that need redrawing
     */ dirty: function dirty(ent) {
                    this._changedObjs.push(ent);
                },
                /**@
     * #.attach
     * @comp CanvasLayer
     * @kind Method
     * @private
     *
     * @sign public .attach(ent)
     * @param ent - The entity to add
     *
     * Sets the entity's draw context to this layer
     */ attach: function attach(ent) {
                    ent._drawContext = this.context;
                    //increment the number of canvas objs
                    this.layerCount++;
                },
                /**@
     * #.detach
     * @comp CanvasLayer
     * @kind Method
     * @private
     *
     * @sign public .detach(ent)
     * @param ent - The entity to detach
     *
     * Removes an entity to the list of Canvas objects to draw
     */ detach: function detach(ent) {
                    this.dirty(ent);
                    ent._drawContext = null;
                    //decrement the number of canvas objs
                    this.layerCount--;
                },
                /**@
     * #.context
     * @comp CanvasLayer
     * @kind Property
     *
     * This will return the 2D context associated with the canvas layer's canvas element.
     */ context: null,
                /**@
     * #._canvas
     * @comp CanvasLayer
     * @kind Property
     * @private
     *
     * The canvas element associated with the canvas layer.
     */ _canvas: null,
                events: {
                    // Respond to init & remove events
                    LayerInit: "layerInit",
                    LayerRemove: "layerRemove",
                    // Bind scene rendering (see drawing.js)
                    RenderScene: "_render",
                    // Listen for pixelart changes
                    PixelartSet: "_setPixelart",
                    // Handle viewport modifications
                    ViewportResize: "_resize"
                },
                // When the system is first created, create the necessary canvas element and initial state
                // Bind to the necessary events
                layerInit: function() {
                    //check if canvas is supported
                    if (!Crafty.support.canvas) {
                        Crafty.trigger("NoCanvas");
                        Crafty.stop();
                        return;
                    }
                    // set referenced objects to initial values -- necessary to avoid shared state between systems
                    this._changedObjs = [];
                    this._dirtyRects = [];
                    this._dirtyCells = {};
                    this._viewKeys = {
                        x1: 0,
                        y1: 0,
                        x2: 0,
                        y2: 0
                    };
                    this.__tempRect = {
                        _x: 0,
                        _y: 0,
                        _w: 0,
                        _h: 0
                    };
                    this.__tempSearchRect = {
                        _x: 0,
                        _y: 0,
                        _w: 0,
                        _h: 0
                    };
                    this.__tempScreenRect = {
                        _x: 0,
                        _y: 0,
                        _w: 0,
                        _h: 0
                    };
                    //create an empty canvas element
                    var c;
                    c = document.createElement("canvas");
                    c.width = Crafty.viewport.width;
                    c.height = Crafty.viewport.height;
                    c.style.position = "absolute";
                    c.style.left = "0px";
                    c.style.top = "0px";
                    c.style.zIndex = this.options.z;
                    Crafty.stage.elem.appendChild(c);
                    this.context = c.getContext("2d");
                    this._canvas = c;
                    //Set any existing transformations
                    var zoom = Crafty.viewport._scale;
                    if (zoom !== 1) this.context.scale(zoom, zoom);
                },
                // When the system is destroyed, remove related resources
                layerRemove: function() {
                    this._canvas.parentNode.removeChild(this._canvas);
                },
                _render: function() {
                    var dirtyViewport = this._dirtyViewport, l = this._changedObjs.length, ctx = this.context;
                    if (!l && !dirtyViewport) return;
                    // Set the camera transforms from the combination of the current viewport parameters and this layers
                    var cameraOptions = this.options;
                    if (dirtyViewport && cameraOptions) {
                        var view = this._viewportRect();
                        var scale = view._scale;
                        var dx = -view._x * scale;
                        var dy = -view._y * scale;
                        ctx.setTransform(scale, 0, 0, scale, Math.round(dx), Math.round(dy));
                    }
                    // TODO: check if these conditions really make that much sense!
                    // if the amount of changed objects is over 60% of the total objects, do the naive method redrawing
                    if (l / this.layerCount > 0.6 || dirtyViewport) this._drawAll();
                    else this._drawDirtyCells();
                    //Clean up lists etc
                    this._clean();
                },
                /**@
     * #._drawDirtyCells
     * @comp CanvasLayer
     * @kind Method
     * @private
     *
     * @sign public ._drawDirtyCells([Object rect])
     * @param rect - a rectangular region {_x: x_val, _y: y_val, _w: w_val, _h: h_val}
     *
     * - If rect is omitted, redraw within the viewport
     * - If rect is provided, redraw within the rect.
     *
     * - Triggered by the "RenderScene" event
     * - This method is invoked if the number of rects is under 60% of the total number of objects
     *  and the total number of objects is greater than 16.
     * - Clear the dirty spatial grid cells, and redraw entities overlapping the dirty spatial grid cells.
     *
     * @see Canvas#.draw
     */ _drawDirtyCells: function(view) {
                    var viewportRect = this._viewportRect(), rect = this.__tempRect, dirtyRects = this._dirtyRects, integerBounds = Crafty.rectManager.integerBounds, ctx = this.context;
                    var i, l;
                    // Canvas works better with integral coordinates where possible
                    view = integerBounds(view || viewportRect);
                    // Calculate dirty spatial map cells from all changed objects
                    // Don't include cells outside rect to be drawn (e.g. viewport)
                    this._createDirtyCells(view);
                    // Afterwards, calculate dirty rectangles from dirty spatial map cells
                    this._createDirtyRects();
                    // For each dirty rectangle, find entities near it, and draw the overlapping ones
                    for(i = 0, l = dirtyRects.length; i < l; i += 4){
                        //loop over every dirty rect
                        rect._x = dirtyRects[i + 0];
                        rect._y = dirtyRects[i + 1];
                        rect._w = dirtyRects[i + 2];
                        rect._h = dirtyRects[i + 3];
                        // Draw the rectangle
                        this._drawRect(rect);
                    }
                    // Draw dirty rectangles for debugging, if that flag is set
                    if (this.debugDirty === true) {
                        var frame = Crafty.frame(), r = (6 * frame + 0) % 255, g = (6 * frame + 85) % 255, b = (6 * frame + 170) % 255;
                        ctx.strokeStyle = "rgb(" + r + ", " + g + ", " + b + ")";
                        for(i = 0, l = dirtyRects.length; i < l; i += 4)ctx.strokeRect(dirtyRects[i + 0], dirtyRects[i + 1], dirtyRects[i + 2], dirtyRects[i + 3]);
                    }
                },
                /**@
     * #._drawAll
     * @comp CanvasLayer
     * @kind Method
     * @private
     *
     * @sign public ._drawAll([Object rect])
     * @param rect - a rectangular region {_x: x_val, _y: y_val, _w: w_val, _h: h_val}
     *
     * - If rect is omitted, redraw within the viewport
     * - If rect is provided, redraw within the rect.
     *
     * - Triggered by the "RenderScene" event
     * - This method is invoked if the number of rects is over 60% of the total number of objects.
     * - Clear the whole viewport, and redraw entities overlapping it by default.
     *
     * @see Canvas#.draw
     */ _drawAll: function(view) {
                    var viewportRect = this._viewportRect(); // this updates the viewportRect for later cached use
                    // Draw the whole layer rectangle
                    this._drawRect(view || viewportRect);
                },
                _drawRect: function(rect) {
                    var i, l, q, obj, previousGlobalZ, integerBounds = Crafty.rectManager.integerBounds, ctx = this.context, searchRect = this.__tempSearchRect, screenRect = this.__tempScreenRect;
                    // Compute the final screen coordinates for the rectangle
                    screenRect = this._viewTransformRect(rect, screenRect, true); // use cached viewportRect
                    // Find the smallest rectangle with integer coordinates that encloses screenRect
                    screenRect = integerBounds(screenRect);
                    // Find the smallest rectangle with integer coordinates that encloses rect
                    rect = integerBounds(rect);
                    // Search for ents under dirty rect.
                    //
                    // Don't need to search for full entity dimensions!
                    // If coordinates are integers, the search area with default _w and _h is (1 px - Number.Epsilon px) too big.
                    // Thus trim the search area accordingly.
                    // Otherwise unecessary neighboring grid cells would be searched for entities,
                    // these additional entities would later be removed because of failing condition rectManager.overlap
                    // This is a performance optimization for dirty cell drawing, to only search one grid cell for each rect,
                    // else three additional cells would be searched unnecessarily.
                    searchRect._x = rect._x;
                    searchRect._y = rect._y;
                    searchRect._w = rect._w - 1;
                    searchRect._h = rect._h - 1;
                    q = Crafty.map.search(searchRect);
                    // Sort objects by z level, duplicate objs will be ordered next to each other due to same _globalZ
                    q.sort(this._sort);
                    // save context before drawing, saves e.g. infinite clip region
                    ctx.save();
                    // Clip and clear works best with default identity transform,
                    // but do the actual clipping after restoring viewport transform,
                    // as the clipping region would be disgarded otherwise
                    ctx.save();
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    // Clip drawing region to dirty rectangle
                    ctx.beginPath();
                    ctx.rect(screenRect._x, screenRect._y, screenRect._w, screenRect._h);
                    // Clear the rect from the main canvas
                    ctx.clearRect(screenRect._x, screenRect._y, screenRect._w, screenRect._h);
                    ctx.restore();
                    ctx.clip();
                    // Then draw each visible canvas object from this layer in that order, avoiding duplicates
                    // No need to check for overlap with drawing area, as it's a single grid cell or the entire viewport
                    // -> in both cases all entities returned from collision search overlap that drawing area
                    previousGlobalZ = -Infinity;
                    for(i = 0, l = q.length; i < l; ++i){
                        obj = q[i];
                        if (obj._globalZ > previousGlobalZ && obj._visible && obj._drawLayer === this) {
                            obj.draw(ctx);
                            obj._changed = false;
                            previousGlobalZ = obj._globalZ;
                        }
                    }
                    // restore context after drawing, restores e.g. clip regions
                    ctx.restore();
                },
                debug: function() {
                    Crafty.log(this._changedObjs);
                },
                /** cleans up current dirty state, stores stale state for future passes */ _clean: function() {
                    var dirtyKeys, staleKeys, obj, i, l;
                    var changed = this._changedObjs;
                    for(i = 0, l = changed.length; i < l; i++){
                        obj = changed[i];
                        // we need to keep track of all stale states, because drawing method can change dynamically
                        // track stale grid cell keys for dirty grid cell drawing
                        dirtyKeys = obj._entry.keys; // cached computation of Crafty.HashMap.key(obj)
                        staleKeys = obj.staleKeys;
                        if (staleKeys === undefined) obj.staleKeys = staleKeys = {
                            x1: 0,
                            y1: 0,
                            x2: 0,
                            y2: 0
                        };
                        staleKeys.x1 = dirtyKeys.x1;
                        staleKeys.y1 = dirtyKeys.y1;
                        staleKeys.x2 = dirtyKeys.x2;
                        staleKeys.y2 = dirtyKeys.y2;
                        obj._changed = false;
                    }
                    changed.length = 0;
                    this._dirtyCells = {};
                    this._dirtyRects.length = 0;
                    this._dirtyViewport = false;
                },
                // Takes the current and previous position of changed objects and
                // adds the dirty spatial map cells they are contained in to a set.
                //
                // If a dirty cell doesn't overlap with the area to be drawn (e.g. viewport),
                // don't include it
                //
                _createDirtyCells: function(view) {
                    var changed = this._changedObjs, dirtyCells = this._dirtyCells;
                    var viewKeys = Crafty.HashMap.key(view, this._viewKeys);
                    var i, l, j, k, obj, keys;
                    for(i = 0, l = changed.length; i < l; i++){
                        obj = changed[i];
                        // if object was previously drawn it's old position needs to be redrawn (cleared)
                        if (keys = obj.staleKeys) // cached computation of stale keys
                        for(j = keys.x1; j <= keys.x2; j++){
                            for(k = keys.y1; k <= keys.y2; k++)// if stale cell is inside area to be drawn
                            if (viewKeys.x1 <= j && j <= viewKeys.x2 && viewKeys.y1 <= k && k <= viewKeys.y2) // combine two 16 bit unsigned numbers into a unique 32 bit unsigned number
                            dirtyCells[j << 16 ^ k] = true;
                        }
                        keys = obj._entry.keys; // cached computation of Crafty.HashMap.key(obj)
                        for(j = keys.x1; j <= keys.x2; j++){
                            for(k = keys.y1; k <= keys.y2; k++)// if dirty cell is inside area to be drawn
                            if (viewKeys.x1 <= j && j <= viewKeys.x2 && viewKeys.y1 <= k && k <= viewKeys.y2) // combine two 16 bit unsigned numbers into a unique 32 bit unsigned number
                            dirtyCells[j << 16 ^ k] = true;
                        }
                    }
                },
                // Takes all dirty spatial map cells and
                // pushes the corresponding dirty rectangles onto the stack.
                //
                _createDirtyRects: function() {
                    var cellsize = Crafty.HashMap.cellsize(), dirtyCells = this._dirtyCells, dirtyRects = this._dirtyRects;
                    var hash, j, k;
                    for(var strHash in dirtyCells){
                        hash = +strHash;
                        // deconstruct a 32 bit unsigned number into a unique pair of 16 bit unsigned numbers
                        k = hash << 16 >> 16;
                        j = k < 0 ? ~(hash >> 16) : hash >> 16;
                        dirtyRects.push(j * cellsize, k * cellsize, cellsize, cellsize);
                    }
                },
                // Resize the canvas element to the current viewport
                _resize: function() {
                    var c = this._canvas;
                    c.width = Crafty.viewport.width;
                    c.height = Crafty.viewport.height;
                },
                _setPixelart: function(enabled) {
                    var context = this.context;
                    context.imageSmoothingEnabled = !enabled;
                    context.mozImageSmoothingEnabled = !enabled;
                    context.webkitImageSmoothingEnabled = !enabled;
                    context.oImageSmoothingEnabled = !enabled;
                    context.msImageSmoothingEnabled = !enabled;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    26: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #Canvas
 * @category Graphics
 * @kind Component
 *
 * @trigger Draw - when the entity is ready to be drawn to the stage - {type: "canvas", pos, co, ctx}
 * @trigger NoCanvas - if the browser does not support canvas
 *
 * When this component is added to an entity it will be drawn to the global canvas element. The canvas element (and hence all Canvas entities) is always rendered below any DOM entities.
 *
 * The canvas layer will be automatically initialized if it has not been created yet.
 *
 * Create a canvas entity like this
 * ~~~
 * var myEntity = Crafty.e("2D, Canvas, Color")
 *      .color("green")
 *      .attr({x: 13, y: 37, w: 42, h: 42});
 *~~~
 */ Crafty.c("Canvas", {
                init: function() {
                    this.requires("Renderable");
                    //Allocate an object to hold this components current region
                    this.currentRect = {};
                    // Add the default canvas layer if we aren't attached to a custom one
                    if (!this._customLayer) this._attachToLayer(Crafty.s("DefaultCanvasLayer"));
                },
                remove: function() {
                    this._detachFromLayer();
                },
                /**@
     * #.draw
     * @comp Canvas
     * @kind Method
     *
     * @sign public this .draw([Context ctx, Number x, Number y, Number w, Number h])
     * @param ctx - Canvas 2D context if drawing on another canvas is required
     * @param x - X offset for drawing a segment
     * @param y - Y offset for drawing a segment
     * @param w - Width of the segment to draw
     * @param h - Height of the segment to draw
     *
     * Method to draw the entity on the canvas element. Can pass rect values for redrawing a segment of the entity.
     */ // Cache the various objects and arrays used in draw:
                drawVars: {
                    type: "canvas",
                    pos: {},
                    ctx: null,
                    coord: [
                        0,
                        0,
                        0,
                        0
                    ],
                    co: {
                        x: 0,
                        y: 0,
                        w: 0,
                        h: 0
                    }
                },
                draw: function(ctx, x, y, w, h) {
                    if (!this.ready) return;
                    var pos = this.drawVars.pos;
                    pos._x = this._x + (x || 0);
                    pos._y = this._y + (y || 0);
                    pos._w = w || this._w;
                    pos._h = h || this._h;
                    var context = ctx || this._drawContext;
                    var coord = this.__coord || [
                        0,
                        0,
                        0,
                        0
                    ];
                    var co = this.drawVars.co;
                    co.x = coord[0] + (x || 0);
                    co.y = coord[1] + (y || 0);
                    co.w = w || coord[2];
                    co.h = h || coord[3];
                    // If we are going to perform any entity-specific changes to the current context, save the current state
                    if (this._flipX || this._flipY || this._rotation) context.save();
                    // rotate the context about this entity's origin
                    if (this._rotation !== 0) {
                        context.translate(this._origin.x + this._x, this._origin.y + this._y);
                        pos._x = -this._origin.x;
                        pos._y = -this._origin.y;
                        context.rotate(this._rotation % 360 * (Math.PI / 180));
                    }
                    // We realize a flipped entity by scaling the context in the opposite direction, then adjusting the position coordinates to match
                    if (this._flipX || this._flipY) {
                        context.scale(this._flipX ? -1 : 1, this._flipY ? -1 : 1);
                        if (this._flipX) pos._x = -(pos._x + pos._w);
                        if (this._flipY) pos._y = -(pos._y + pos._h);
                    }
                    var globalpha;
                    //draw with alpha
                    if (this._alpha < 1.0) {
                        globalpha = context.globalAlpha;
                        context.globalAlpha = this._alpha;
                    }
                    this.drawVars.ctx = context;
                    this.trigger("Draw", this.drawVars);
                    // If necessary, restore context
                    if (this._rotation !== 0 || this._flipX || this._flipY) context.restore();
                    if (globalpha) context.globalAlpha = globalpha;
                    return this;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    27: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js"), document1 = window.document;
            /**@
 * #Crafty.assignColor
 * @category Graphics
 * @kind Method
 *
 * Maps a wide vareity of color representations to a set of simple rgb(a) properties.
 *
 * @sign Crafty.assignColor(color[, assignee])
 * @param color - a string represenation of the color to assign, in any valid HTML format
 * @param assignee - an object to use instead of creating one from scratch
 * @returns  An object with `_red`, `_green`, and `_blue` properties assigned.
 *           Potentially with `_strength` representing the alpha channel.
 *           If the assignee parameter is passed, that object will be assigned those values and returned.
 */ Crafty.extend({
                assignColor: function() {
                    // Create phantom element to assess color
                    var element = document1.createElement("div");
                    element.style.display = "none";
                    // Can't attach it til later on, so we need a flag!
                    var element_attached = false;
                    var dictionary = {
                        aqua: "#00ffff",
                        black: "#000000",
                        blue: "#0000ff",
                        fuchsia: "#ff00ff",
                        gray: "#808080",
                        green: "#00ff00",
                        lime: "#00ff00",
                        maroon: "#800000",
                        navy: "#000080",
                        olive: "#808000",
                        orange: "#ffa500",
                        purple: "#800080",
                        red: "#ff0000",
                        silver: "#c0c0c0",
                        teal: "#008080",
                        white: "#ffffff",
                        yellow: "#ffff00"
                    };
                    function default_value(c) {
                        c._red = c._blue = c._green = 0;
                        return c;
                    }
                    function hexComponent(component) {
                        var hex = component.toString(16);
                        if (hex.length === 1) hex = "0" + hex;
                        return hex;
                    }
                    function rgbToHex(r, g, b) {
                        return "#" + hexComponent(r) + hexComponent(g) + hexComponent(b);
                    }
                    function parseHexString(hex, c) {
                        var r, g, b, l = hex.length;
                        if (l === 7) {
                            r = hex.substr(1, 2);
                            g = hex.substr(3, 2);
                            b = hex.substr(5, 2);
                        } else if (l === 4) {
                            r = hex.substr(1, 1);
                            r += r;
                            g = hex.substr(2, 1);
                            g += g;
                            b = hex.substr(3, 1);
                            b += b;
                        } else return default_value(c);
                        c._red = parseInt(r, 16);
                        c._green = parseInt(g, 16);
                        c._blue = parseInt(b, 16);
                        return c;
                    }
                    var rgb_regex = /rgba?\s*\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,?\s*([0-9.]+)?\)/;
                    function parseRgbString(rgb, c) {
                        var values = rgb_regex.exec(rgb);
                        if (values === null || values.length !== 4 && values.length !== 5) return default_value(c); // return bad result?
                        c._red = Math.round(parseFloat(values[1]));
                        c._green = Math.round(parseFloat(values[2]));
                        c._blue = Math.round(parseFloat(values[3]));
                        if (values[4]) c._strength = parseFloat(values[4]);
                        return c;
                    }
                    function parseColorName(key, c) {
                        if (typeof dictionary[key] === "undefined") {
                            if (element_attached === false) {
                                window.document.body.appendChild(element);
                                element_attached = true;
                            }
                            element.style.color = key;
                            var rgb = window.getComputedStyle(element).color;
                            parseRgbString(rgb, c);
                            dictionary[key] = rgbToHex(c._red, c._green, c._blue);
                        //window.document.body.removeChild(element);
                        } else parseHexString(dictionary[key], c);
                        return c;
                    }
                    function rgbaString(c) {
                        return "rgba(" + c._red + ", " + c._green + ", " + c._blue + ", " + c._strength + ")";
                    }
                    // The actual assignColor function
                    return function(color, c) {
                        c = c || {};
                        color = color.trim().toLowerCase();
                        var ret = null;
                        if (color[0] === "#") ret = parseHexString(color, c);
                        else if (color[0] === "r" && color[1] === "g" && color[2] === "b") ret = parseRgbString(color, c);
                        else ret = parseColorName(color, c);
                        c._strength = c._strength || 1.0;
                        c._color = rgbaString(c);
                    };
                }()
            });
            // Define some variables required for webgl
            Crafty.defaultShader("Color", new Crafty.WebGLShader("attribute vec2 aPosition;\nattribute vec3 aOrientation;\nattribute vec2 aLayer;\nattribute vec4 aColor;\n\nvarying lowp vec4 vColor;\n\nuniform  vec4 uViewport;\n\nmat4 viewportScale = mat4(2.0 / uViewport.z, 0, 0, 0,    0, -2.0 / uViewport.w, 0,0,    0, 0,1,0,    -1,+1,0,1);\nvec4 viewportTranslation = vec4(uViewport.xy, 0, 0);\n\nvoid main() {\n  vec2 pos = aPosition;\n  vec2 entityOrigin = aOrientation.xy;\n  mat2 entityRotationMatrix = mat2(cos(aOrientation.z), sin(aOrientation.z), -sin(aOrientation.z), cos(aOrientation.z));\n\n  pos = entityRotationMatrix * (pos - entityOrigin) + entityOrigin;\n  gl_Position = viewportScale * (viewportTranslation + vec4(pos, 1.0/(1.0+exp(aLayer.x) ), 1) );\n  vColor = vec4(aColor.rgb*aColor.a*aLayer.y, aColor.a*aLayer.y);\n}", "precision mediump float;\nvarying lowp vec4 vColor;\nvoid main(void) {\n	gl_FragColor = vColor;\n}", [
                {
                    name: "aPosition",
                    width: 2
                },
                {
                    name: "aOrientation",
                    width: 3
                },
                {
                    name: "aLayer",
                    width: 2
                },
                {
                    name: "aColor",
                    width: 4
                }
            ], function(e, entity) {
                e.program.writeVector("aColor", entity._red / 255, entity._green / 255, entity._blue / 255, entity._strength);
            }));
            /**@
 * #Color
 * @category Graphics
 * @kind Component
 *
 * Draw a colored rectangle.
 */ Crafty.c("Color", {
                _red: 0,
                _green: 0,
                _blue: 0,
                _strength: 1.0,
                _color: "",
                ready: true,
                init: function() {
                    // Necessary for some rendering layers
                    this.__coord = this.__coord || [
                        0,
                        0,
                        0,
                        0
                    ];
                    this.bind("Draw", this._drawColor);
                    if (this._drawLayer) this._setupColor(this._drawLayer);
                    this.trigger("Invalidate");
                },
                events: {
                    LayerAttached: "_setupColor"
                },
                remove: function() {
                    this.unbind("Draw", this._drawColor);
                    if (this.has("DOM")) this._element.style.backgroundColor = "transparent";
                    this.trigger("Invalidate");
                },
                _setupColor: function(layer) {
                    if (layer.type === "WebGL") this._establishShader("Color", Crafty.defaultShader("Color"));
                },
                // draw function for "Color"
                _drawColor: function(e) {
                    if (!this._color) return;
                    if (e.type === "DOM") {
                        e.style.backgroundColor = this._color;
                        e.style.lineHeight = 0;
                    } else if (e.type === "canvas") {
                        e.ctx.fillStyle = this._color;
                        e.ctx.fillRect(e.pos._x, e.pos._y, e.pos._w, e.pos._h);
                    } else if (e.type === "webgl") e.program.draw(e, this);
                },
                /**@
     * #.color
     * @comp Color
     * @kind Method
     *
     * @trigger Invalidate - when the color changes
     *
     * Will assign the color and opacity, either through a string shorthand, or through explicit rgb values.
     * @sign public this .color(String color[, Float strength])
     * @param color - Color of the rectangle
     * @param strength - the opacity of the rectangle
     *
     * @sign public this .color(r, g, b[, strength])
     * @param r - value for the red channel
     * @param g - value for the green channel
     * @param b - value for the blue channel
     * @param strength - the opacity of the rectangle
     *
     * @sign public String .color()
     * @return A string representing the current color as a CSS property.
     *
     * @example
     * ```
     * var c = Crafty.e("2D, DOM, Color");
     * c.color("#FF0000");
     * c.color("red");
     * c.color(255, 0, 0);
     * c.color("rgb(255, 0, 0)");
     * ```
     * Three different ways of assign the color red.
     * ```
     * var c = Crafty.e("2D, DOM, Color");
     * c.color("#00FF00", 0.5);
     * c.color("rgba(0, 255, 0, 0.5)");
     * ```
     * Two ways of assigning a transparent green color.
     */ color: function(color) {
                    if (arguments.length === 0) return this._color;
                    else if (arguments.length >= 3) {
                        this._red = arguments[0];
                        this._green = arguments[1];
                        this._blue = arguments[2];
                        if (typeof arguments[3] === "number") this._strength = arguments[3];
                    } else {
                        // First argument is color name
                        Crafty.assignColor(color, this);
                        // Second argument, if present, is strength of color
                        // Note that assignColor will give a default strength of 1.0 if none exists.
                        if (typeof arguments[1] === "number") this._strength = arguments[1];
                    }
                    this._color = "rgba(" + this._red + ", " + this._green + ", " + this._blue + ", " + this._strength + ")";
                    this.trigger("Invalidate");
                    return this;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    28: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js"), document1 = window.document;
            Crafty.extend({
                /**@
     * #Crafty.domHelper
     * @kind Property
     * @category Graphics
     *
     * Collection of utilities for using the DOM.
     */ domHelper: {
                    /**@
         * #Crafty.domHelper.innerPosition
         * @comp Crafty.domHelper
         * @sign public Object Crafty.domHelper.innerPosition(HTMLElement obj[, Object out])
         * @param obj - HTML element to calculate the position
         * @param out - optional object to save result in
         * @returns Object with `x` key being the `x` position, `y` being the `y` position
         *
         * Find a DOM elements position including
         * padding and border.
         */ innerPosition: function(obj, out) {
                        out = out || {};
                        var rect = obj.getBoundingClientRect(), x = rect.left + (window.pageXOffset ? window.pageXOffset : document1.body.scrollLeft), y = rect.top + (window.pageYOffset ? window.pageYOffset : document1.body.scrollTop), //border left
                        borderX = parseInt(this.getStyle(obj, "border-left-width") || 0, 10) || parseInt(this.getStyle(obj, "borderLeftWidth") || 0, 10) || 0, borderY = parseInt(this.getStyle(obj, "border-top-width") || 0, 10) || parseInt(this.getStyle(obj, "borderTopWidth") || 0, 10) || 0;
                        out.x = x + borderX;
                        out.y = y + borderY;
                        return out;
                    },
                    /**@
         * #Crafty.domHelper.getStyle
         * @comp Crafty.domHelper
         * @kind Method
         *
         * @sign public Object Crafty.domHelper.getStyle(HTMLElement obj, String property)
         * @param obj - HTML element to find the style
         * @param property - Style to return
         *
         * Determine the value of a style on an HTML element. Notation can be
         * in either CSS or JS.
         */ getStyle: function(obj, prop) {
                        var result;
                        if (obj.currentStyle) result = obj.currentStyle[this.camelize(prop)];
                        else if (window.getComputedStyle) result = document1.defaultView.getComputedStyle(obj, null).getPropertyValue(this.csselize(prop));
                        return result;
                    },
                    /**
         * Used in the Zepto framework
         *
         * Converts CSS notation to JS notation
         */ camelize: function(str) {
                        return str.replace(/-+(.)?/g, function(match, chr) {
                            return chr ? chr.toUpperCase() : "";
                        });
                    },
                    /**
         * Converts JS notation to CSS notation
         */ csselize: function(str) {
                        return str.replace(/[A-Z]/g, function(chr) {
                            return chr ? "-" + chr.toLowerCase() : "";
                        });
                    },
                    /**@
         * #Crafty.domHelper.translate
         * @comp Crafty.domHelper
         * @kind Method
         *
         * @sign public Object Crafty.domHelper.translate(Number clientX, Number clientY[, DrawLayer layer[, Object out]])
         * @param clientX - clientX position in the browser screen
         * @param clientY - clientY position in the browser screen
         * @param layer - a Crafty draw layer
         * @param out - an optional object to save result in
         * @return Object `{x: ..., y: ...}` with Crafty coordinates.
         *
         * The parameters clientX and clientY are pixel coordinates within the visible
         * browser window. This function translates those to Crafty coordinates (i.e.,
         * the coordinates that you might apply to an entity), by taking into account
         * where the stage is within the screen, what the current viewport is, etc.
         *
         * If a draw layer is specified, the returned object will take into account any special scaling rules for that object.
         */ translate: function(clientX, clientY, layer, out) {
                        out = out || {};
                        var doc = document1.documentElement;
                        var body = document1.body;
                        var view;
                        // The branch here is to deal with the fact that the viewport position is the distance TO the origin, not from
                        // But the _viewportRect is the opposite -- it uses the same convention as a rectangle that matches the viewport in that layer
                        // At some point this should be simplified, probably by altering the viewport to use the more intuitive coordinates
                        if (layer) {
                            view = layer._viewportRect();
                            out.x = (clientX - Crafty.stage.x + (doc && doc.scrollLeft || body && body.scrollLeft || 0)) / view._scale + view._x;
                            out.y = (clientY - Crafty.stage.y + (doc && doc.scrollTop || body && body.scrollTop || 0)) / view._scale + view._y;
                        } else {
                            view = Crafty.viewport;
                            out.x = (clientX - Crafty.stage.x + (doc && doc.scrollLeft || body && body.scrollLeft || 0)) / view._scale - view._x;
                            out.y = (clientY - Crafty.stage.y + (doc && doc.scrollTop || body && body.scrollTop || 0)) / view._scale - view._y;
                        }
                        return out;
                    }
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    29: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js"), document1 = window.document;
            /**@
 * #DomLayer
 * @category Graphics
 * @kind System
 *
 * Collection of mostly private methods to represent entities using the DOM.
 */ Crafty._registerLayerTemplate("DOM", {
                type: "DOM",
                _changedObjs: [],
                /**@
     * #._div
     * @comp DomLayer
     * @kind Property
     * @private
     *
     * A div inside the `#cr-stage` div that holds all DOM entities.
     */ _div: null,
                events: {
                    // Respond to init & remove events
                    LayerInit: "layerInit",
                    LayerRemove: "layerRemove",
                    // Bind scene rendering (see drawing.js)
                    RenderScene: "_render",
                    // Listen for pixelart changes
                    PixelartSet: "_setPixelart"
                },
                layerInit: function() {
                    // Avoid shared state between systems
                    this._changedObjs = [];
                    // Create the div that will contain DOM elements
                    var div = this._div = document1.createElement("div");
                    Crafty.stage.elem.appendChild(div);
                    div.style.position = "absolute";
                    div.style.zIndex = this.options.z;
                    div.style.transformStyle = "preserve-3d"; // Seems necessary for Firefox to preserve zIndexes?
                },
                // Cleanup the DOM when the layer is destroyed
                layerRemove: function() {
                    this._div.parentNode.removeChild(this._div);
                },
                // Handle whether images should be smoothed or not
                _setPixelArt: function(enabled) {
                    var style = this._div.style;
                    var camelize = Crafty.domHelper.camelize;
                    if (enabled) {
                        style[camelize("image-rendering")] = "optimizeSpeed"; /* legacy */ 
                        style[camelize("image-rendering")] = "-moz-crisp-edges"; /* Firefox */ 
                        style[camelize("image-rendering")] = "-o-crisp-edges"; /* Opera */ 
                        style[camelize("image-rendering")] = "-webkit-optimize-contrast"; /* Webkit (Chrome & Safari) */ 
                        style[camelize("-ms-interpolation-mode")] = "nearest-neighbor"; /* IE */ 
                        style[camelize("image-rendering")] = "optimize-contrast"; /* CSS3 proposed */ 
                        style[camelize("image-rendering")] = "pixelated"; /* CSS4 proposed */ 
                        style[camelize("image-rendering")] = "crisp-edges"; /* CSS4 proposed */ 
                    } else {
                        style[camelize("image-rendering")] = "optimizeQuality"; /* legacy */ 
                        style[camelize("-ms-interpolation-mode")] = "bicubic"; /* IE */ 
                        style[camelize("image-rendering")] = "auto"; /* CSS3 */ 
                    }
                },
                /**@
     * #.debug
     * @comp DomLayer
     * @kind Method
     *
     * @sign public .debug()
     *
     * Logs the current list of entities that have been invalidated in this layer.
     */ debug: function() {
                    Crafty.log(this._changedObjs);
                },
                /**@
     * #._render
     * @comp DomLayer
     * @kind Method
     * @private
     *
     * @sign public .render()
     *
     * When "RenderScene" is triggered, draws all DOM entities that have been flagged
     *
     * @see DOM#.draw
     */ _render: function() {
                    var changed = this._changedObjs;
                    // Adjust the viewport
                    if (this._dirtyViewport) {
                        this._setViewport();
                        this._dirtyViewport = false;
                    }
                    //if no objects have been changed, stop
                    if (!changed.length) return;
                    var i = 0, k = changed.length;
                    //loop over all DOM elements needing updating
                    for(; i < k; ++i)changed[i].draw()._changed = false;
                    //reset DOM array
                    changed.length = 0;
                },
                /**@
     * #.dirty
     * @comp DomLayer
     * @kind Method
     * @private
     *
     * @sign public .dirty(ent)
     * @param ent - The entity to mark as dirty
     *
     * Add an entity to the list of DOM object to draw
     */ dirty: function add(ent) {
                    this._changedObjs.push(ent);
                },
                /**@
     * #.attach
     * @comp DomLayer
     * @kind Method
     * @private
     *
     * @sign public .attach(ent)
     * @param ent - The entity to add
     *
     * Add an entity to the layer
     */ attach: function attach(ent) {
                    ent._drawContext = this.context;
                    // attach the entity's div element to the dom layer
                    this._div.appendChild(ent._element);
                    // set position style and entity id
                    ent._element.style.position = "absolute";
                    ent._element.id = "ent" + ent[0];
                },
                /**@
     * #.detach
     * @comp DomLayer
     * @kind Method
     * @private
     *
     * @sign public .detach(ent)
     * @param ent - The entity to remove
     *
     * Removes an entity from the layer
     */ detach: function detach(ent) {
                    this._div.removeChild(ent._element);
                },
                // Sets the viewport position and scale
                // Called by render when the dirtyViewport flag is set
                _setViewport: function() {
                    var style = this._div.style, view = this._viewportRect();
                    var scale = view._scale;
                    var dx = -view._x * scale;
                    var dy = -view._y * scale;
                    style.transform = style[Crafty.support.prefix + "Transform"] = "scale(" + scale + ", " + scale + ")";
                    style.left = Math.round(dx) + "px";
                    style.top = Math.round(dy) + "px";
                    style.zIndex = this.options.z;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    30: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js"), document1 = window.document;
            /**@
 * #DOM
 * @category Graphics
 * @kind Component
 *
 * A component which renders entities as DOM nodes, specifically `<div>`s.
 */ Crafty.c("DOM", {
                /**@
     * #._element
     * @comp DOM
     * @kind Property
     * The DOM element used to represent the entity.
     */ _element: null,
                //holds current styles, so we can check if there are changes to be written to the DOM
                _cssStyles: null,
                /**@
     * #.avoidCss3dTransforms
     * @comp DOM
     * @kind Property
     *
     * Avoids using of CSS 3D Transform for positioning when true. Default value is false.
     */ avoidCss3dTransforms: false,
                init: function() {
                    this.requires("Renderable");
                    this._cssStyles = {
                        visibility: "",
                        left: "",
                        top: "",
                        width: "",
                        height: "",
                        zIndex: "",
                        opacity: "",
                        transformOrigin: "",
                        transform: ""
                    };
                    this._element = document1.createElement("div");
                    // Attach the entity to the dom layer
                    if (!this._customLayer) this._attachToLayer(Crafty.s("DefaultDOMLayer"));
                    this.bind("NewComponent", this._updateClass);
                    this.bind("RemoveComponent", this._removeClass);
                },
                remove: function() {
                    this._detachFromLayer();
                    this.unbind("NewComponent", this._updateClass);
                    this.unbind("RemoveComponent", this._removeClass);
                },
                /**@
     * #.getDomId
     * @comp DOM
     * @kind Method
     *
     * @sign public this .getDomId()
     *
     * Get the Id of the DOM element used to represent the entity.
     */ getDomId: function() {
                    return this._element.id;
                },
                // removes a component on RemoveComponent events
                _removeClass: function(removedComponent) {
                    var comp, c = this.__c, str = "";
                    for(comp in c)if (comp !== removedComponent) str += " " + comp;
                    str = str.substr(1);
                    this._element.className = str;
                },
                // adds a class on NewComponent events
                _updateClass: function() {
                    var comp, c = this.__c, str = "";
                    for(comp in c)str += " " + comp;
                    str = str.substr(1);
                    this._element.className = str;
                },
                /**@
     * #.DOM
     * @comp DOM
     * @kind Method
     *
     * @trigger Draw - when the entity is ready to be drawn to the stage - { style:String, type:"DOM", co}
     * @sign public this .DOM(HTMLElement elem)
     * @param elem - HTML element that will replace the dynamically created one
     *
     * Pass a DOM element to use rather than one created. Will set `._element` to this value. Removes the old element.
     *
     * Will reattach the entity to the current draw layer
     */ DOM: function(elem) {
                    if (elem && elem.nodeType) {
                        var layer = this._drawLayer;
                        this._detachFromLayer();
                        this._element = elem;
                        this._attachToLayer(layer);
                    }
                    return this;
                },
                /**@
     * #.draw
     * @comp DOM
     * @kind Method
     * @private
     *
     * @sign public this .draw(void)
     *
     * Updates the CSS properties of the node to draw on the stage.
     */ draw: function() {
                    var style = this._element.style, coord = this.__coord || [
                        0,
                        0,
                        0,
                        0
                    ], co = {
                        x: coord[0],
                        y: coord[1],
                        w: coord[2],
                        h: coord[3]
                    }, prefix = Crafty.support.prefix, trans = [];
                    if (this._cssStyles.visibility !== this._visible) {
                        this._cssStyles.visibility = this._visible;
                        if (!this._visible) style.visibility = "hidden";
                        else style.visibility = "visible";
                    }
                    //utilize CSS3 if supported
                    if (Crafty.support.css3dtransform && !this.avoidCss3dTransforms) trans.push("translate3d(" + ~~this._x + "px," + ~~this._y + "px,0)");
                    else {
                        if (this._cssStyles.left !== this._x) {
                            this._cssStyles.left = this._x;
                            style.left = ~~this._x + "px";
                        }
                        if (this._cssStyles.top !== this._y) {
                            this._cssStyles.top = this._y;
                            style.top = ~~this._y + "px";
                        }
                    }
                    if (this._cssStyles.width !== this._w) {
                        this._cssStyles.width = this._w;
                        style.width = ~~this._w + "px";
                    }
                    if (this._cssStyles.height !== this._h) {
                        this._cssStyles.height = this._h;
                        style.height = ~~this._h + "px";
                    }
                    if (this._cssStyles.zIndex !== this._z) {
                        this._cssStyles.zIndex = this._z;
                        style.zIndex = this._z;
                    }
                    if (this._cssStyles.opacity !== this._alpha) {
                        this._cssStyles.opacity = this._alpha;
                        style.opacity = this._alpha;
                        style[prefix + "Opacity"] = this._alpha;
                    }
                    if (this._mbr) {
                        var origin = this._origin.x + "px " + this._origin.y + "px";
                        style.transformOrigin = origin;
                        style[prefix + "TransformOrigin"] = origin;
                        if (Crafty.support.css3dtransform) trans.push("rotateZ(" + this._rotation + "deg)");
                        else trans.push("rotate(" + this._rotation + "deg)");
                    }
                    if (this._flipX) trans.push("scaleX(-1)");
                    if (this._flipY) trans.push("scaleY(-1)");
                    if (this._cssStyles.transform !== trans.join(" ")) {
                        this._cssStyles.transform = trans.join(" ");
                        style.transform = this._cssStyles.transform;
                        style[prefix + "Transform"] = this._cssStyles.transform;
                    }
                    this.trigger("Draw", {
                        style: style,
                        type: "DOM",
                        co: co
                    });
                    return this;
                },
                _setCssProperty: function(style, key, val) {
                    key = Crafty.domHelper.camelize(key);
                    if (typeof val === "number") val += "px";
                    style[key] = val;
                    this.trigger("SetStyle", key);
                },
                /**@
     * #.css
     * @comp DOM
     * @kind Method
     * @trigger SetStyle - for each style that is set - string - propertyName
     *
     * @sign public css(String property, String value)
     * @param property - CSS property to modify
     * @param value - Value to give the CSS property
     *
     * @sign public  css(Object map)
     * @param map - Object where the key is the CSS property and the value is CSS value
     *
     * Apply CSS styles to the element.
     *
     * Can pass an object where the key is the style property and the value is style value.
     *
     * For setting one style, simply pass the style as the first argument and the value as the second.
     *
     * The notation can be CSS or JS (e.g. `border-radius` or `borderRadius`).
     *
     * To return a value, pass the property.
     *
     * Note: For entities with "Text" component, some css properties are controlled by separate functions
     * `.textFont()`, `.textAlign()` and `.textColor()`.  When possible, prefer text-specific methods, since
     * they will work for non-DOM text.
     * See the Text component for details.
     *
     * @example
     * ~~~
     * this.css({'border': '1px solid black', 'text-decoration': 'line-through'});
     * this.css("textDecoration", "line-through");
     * this.css("text-Decoration"); //returns line-through
     * ~~~
     */ css: function(obj, value) {
                    var key, elem = this._element, val, style = elem.style;
                    //if an object passed
                    if (typeof obj === "object") for(key in obj){
                        if (!obj.hasOwnProperty(key)) continue;
                        val = obj[key];
                        this._setCssProperty(style, key, val);
                    }
                    else {
                        //if a value is passed, set the property
                        if (value) this._setCssProperty(style, obj, value);
                        else //otherwise return the computed property
                        return Crafty.domHelper.getStyle(elem, obj);
                    }
                    this.trigger("Invalidate");
                    return this;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    31: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            Crafty.extend({
                /**@
     * #Crafty.background
     * @category Graphics, Stage
     * @kind Method
     *
     * @sign public void Crafty.background(String style)
     * @param style - Modify the background with a color or image
     *
     * This method is a shortcut for adding a background
     * style to the stage element, i.e.
     * `Crafty.stage.elem.style.background = ...`
     *
     * For example, if you want the background to be white,
     * with an image in the center, you might use:
     * ~~~
     * Crafty.background('#FFFFFF url(landscape.png) no-repeat center center');
     * ~~~
     */ background: function(style) {
                    Crafty.stage.elem.style.background = style;
                },
                /**@
     * #Crafty.pixelart
     * @category Graphics
     * @kind Method
     *
     * @sign public void Crafty.pixelart(Boolean enabled)
     * @param enabled - whether to preserve sharp edges when rendering images
     *
     * Sets the image smoothing for drawing images (for all layer types).
     *
     * Setting this to true disables smoothing for images, which is the preferred
     * way for drawing pixel art. Defaults to false.
     *
     * This feature is experimental and you should be careful with cross-browser compatibility.
     * The best way to disable image smoothing is to use the Canvas render method and the Sprite component for drawing your entities.
     *
     * If you want to switch modes in the middle of a scene,
     * be aware that canvas entities won't be drawn in the new style until something else invalidates them.
     * (You can manually invalidate all canvas entities with `Crafty("Canvas").trigger("Invalidate");`)
     *
     * @note Firefox_26 currently has a [bug](https://bugzilla.mozilla.org/show_bug.cgi?id=696630)
     * which prevents disabling image smoothing for Canvas entities that use the Image component. Use the Sprite
     * component instead.
     *
     * @note Webkit (Chrome & Safari) currently has a bug [link1](http://code.google.com/p/chromium/issues/detail?id=134040)
     * [link2](http://code.google.com/p/chromium/issues/detail?id=106662) that prevents disabling image smoothing
     * for DOM entities.
     *
     * @example
     * This is the preferred way to draw pixel art with the best cross-browser compatibility.
     * ~~~
     * Crafty.pixelart(true);
     *
     * Crafty.sprite(imgWidth, imgHeight, "spriteMap.png", {sprite1:[0,0]});
     * Crafty.e("2D, Canvas, sprite1");
     * ~~~
     */ _pixelartEnabled: false,
                pixelart: function(enabled) {
                    Crafty._pixelartEnabled = enabled;
                    Crafty.trigger("PixelartSet", enabled);
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    32: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            // An object for wrangling textures
            // An assumption here is that doing anything with textures is fairly expensive, so the code should be expressive rather than performant
            Crafty.TextureManager = TextureManager;
            function TextureManager(gl, webgl) {
                this.gl = gl;
                this.webgl = webgl;
                // The maximum number of units the environment says it supports
                this.max_units = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
                // An array of textures bound to a texture unit; position corresponds to the unit in question
                this.bound_textures = [];
                // A dictionary of registered textures, so that multiple copies of the same texture aren't generated
                this.registered_textures = {};
                // Try to track which texture is active
                this.active = null;
            }
            TextureManager.prototype = {
                // Clear out the bound textures and other existing state
                reset: function() {
                    var t;
                    for(var i = 0; i < this.bound_textures.length; i++){
                        t = this.bound_textures[i];
                        t.unbind();
                    }
                    this.bound_textures = [];
                    this.active = null;
                },
                // creates a texture out of the given image and repeating state
                // The url is just used to generate a unique id for the texture
                makeTexture: function(url, image, repeating) {
                    // gl is the context, webgl is the Crafty object containing prefs/etc
                    // var gl = this.gl;
                    var webgl = this.webgl;
                    // Check whether a texture that matches the one requested already exists
                    var id = "texture-(r:" + repeating + ")-" + url;
                    if (typeof this.registered_textures[id] !== "undefined") return this.registered_textures[id];
                    // Create a texture, bind it to the next available unit
                    var t = new TextureWrapper(this, id);
                    this.registered_textures[id] = t;
                    this.bindTexture(t);
                    // Set the properties of the texture
                    t.setImage(image);
                    t.setFilter(webgl.texture_filter);
                    t.setRepeat(repeating);
                    return t;
                },
                // Returns the bound texture of smallest size
                // If we have more textures than available units, we should preferentially leave the larger textures bound?
                smallest: function() {
                    var min_size = Infinity;
                    var index = null;
                    for(var i = 0; i < this.bound_textures.length; i++){
                        var t = this.bound_textures[i];
                        if (t.size < min_size) {
                            min_size = t.size;
                            index = i;
                        }
                    }
                    return index;
                },
                // Returns either the first empty unit, or the unit of the smallest bound texture
                getAvailableUnit: function() {
                    if (this.bound_textures.length < this.max_units) return this.bound_textures.length;
                    else return this.smallest();
                },
                // takes a texture object and, if it isn't associated with a unit, binds it to one
                bindTexture: function(t) {
                    // return if the texture is already bound
                    if (t.unit !== null) return;
                    var i = this.getAvailableUnit();
                    if (this.bound_textures[i]) this.unbindTexture(this.bound_textures[i]);
                    this.bound_textures[i] = t;
                    t.bind(i);
                },
                // We don't actually "unbind" the texture -- we just set it's bound state to null
                // This is called before another texture is bound
                unbindTexture: function(t) {
                    t.unbind();
                },
                setActiveTexture: function(t) {
                    if (this.active === t.id) return;
                    this.gl.activeTexture(this.gl[t.name]);
                    this.active = t.unit;
                }
            };
            // An object for abstracting out the gl calls associated with textures
            Crafty.TextureWrapper = TextureWrapper;
            function TextureWrapper(manager, id) {
                this.manager = manager;
                this.gl = manager.gl;
                this.glTexture = this.gl.createTexture();
                this.id = id;
                this.active = false;
                this.unit = null;
                this.powerOfTwo = false;
            }
            TextureWrapper.prototype = {
                // Given a number, binds to the corresponding texture unit
                bind: function(unit) {
                    var gl = this.gl;
                    this.unit = unit;
                    this.name = "TEXTURE" + unit;
                    this.manager.setActiveTexture(this);
                    gl.bindTexture(gl.TEXTURE_2D, this.glTexture);
                },
                // Check whether this texture is active (important for setting properties)
                isActive: function() {
                    return this.manager.active === this.unit;
                },
                // Since gl doesn't require unbinding, just clears the metadata
                unbind: function() {
                    this.unit = null;
                    this.name = null;
                    if (this.isActive()) this.manager.active = null;
                },
                // actually loads an image into the texture object; sets the appropriate metadata
                setImage: function(image) {
                    if (!this.isActive()) throw "Trying to set image of texture that isn't active";
                    this.width = image.width;
                    this.height = image.height;
                    this.size = image.width * image.height;
                    this.powerOfTwo = !(Math.log(image.width) / Math.LN2 !== Math.floor(Math.log(image.width) / Math.LN2) || Math.log(image.height) / Math.LN2 !== Math.floor(Math.log(image.height) / Math.LN2));
                    var gl = this.gl;
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
                },
                // Sets the min/mag filters
                setFilter: function(filter) {
                    if (!this.isActive()) throw "Trying to set filter of texture that isn't active";
                    var gl = this.gl;
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filter);
                },
                // set image wrapping
                setRepeat: function(repeat) {
                    if (!this.isActive()) throw "Trying to set repeat property of texture that isn't active";
                    if (repeat && !this.powerOfTwo) throw "Can't create a repeating image whose dimensions aren't a power of 2 in WebGL contexts";
                    var gl = this.gl;
                    this.repeatMode = repeat ? gl.REPEAT : gl.CLAMP_TO_EDGE;
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, this.repeatMode);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, this.repeatMode);
                },
                // given a shader and pair of uniform names, sets the sampler and dimensions to be used by this texture
                setToProgram: function(shader, sampler_name, dimension_name) {
                    if (this.unit === null) throw "Trying to use texture not set to a texture unit.";
                    var gl = this.gl;
                    gl.useProgram(shader);
                    // Set the texture buffer to use
                    gl.uniform1i(gl.getUniformLocation(shader, sampler_name), this.unit);
                    // Set the image dimensions
                    gl.uniform2f(gl.getUniformLocation(shader, dimension_name), this.width, this.height);
                }
            };
        },
        {
            "../core/core.js": 10
        }
    ],
    33: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #HTML
 * @category Graphics
 * @kind Component
 *
 * A component which allows for the insertion of arbitrary HTML into a DOM entity.
 *
 * Adding this to an entity will automatically add the `DOM` component.
 */ Crafty.c("HTML", {
                inner: "",
                init: function() {
                    this.requires("2D, DOM");
                },
                /**@
     * #.replace
     * @comp HTML
     * @kind Method
     *
     * @sign public this .replace(String html)
     * @param html - arbitrary html
     *
     * This method will replace the content of this entity with the supplied html
     *
     * @example
     * Create a link
     * ~~~
     * Crafty.e("HTML")
     *    .attr({x:20, y:20, w:100, h:100})
     *    .replace("<a href='index.html'>Index</a>");
     * ~~~
     */ replace: function(new_html) {
                    this.inner = new_html;
                    this._element.innerHTML = new_html;
                    return this;
                },
                /**@
     * #.append
     * @comp HTML
     * @kind Method
     *
     * @sign public this .append(String html)
     * @param html - arbitrary html
     *
     * This method will add the supplied html in the end of the entity
     *
     * @example
     * Create a link
     * ~~~
     * Crafty.e("HTML")
     *    .attr({x:20, y:20, w:100, h:100})
     *    .append("<a href='index.html'>Index</a>");
     * ~~~
     */ append: function(new_html) {
                    this.inner += new_html;
                    this._element.innerHTML += new_html;
                    return this;
                },
                /**@
     * #.prepend
     * @comp HTML
     * @kind Method
     *
     * @sign public this .prepend(String html)
     * @param html - arbitrary html
     *
     * This method will add the supplied html in the beginning of the entity
     *
     * @example
     * Create a link
     * ~~~
     * Crafty.e("HTML")
     *    .attr({x:20, y:20, w:100, h:100})
     *    .prepend("<a href='index.html'>Index</a>");
     * ~~~
     */ prepend: function(new_html) {
                    this.inner = new_html + this.inner;
                    this._element.innerHTML = new_html + this.inner;
                    return this;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    34: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            //
            // Define some variables required for webgl
            Crafty.defaultShader("Image", new Crafty.WebGLShader("attribute vec2 aPosition;\nattribute vec3 aOrientation;\nattribute vec2 aLayer;\nattribute vec2 aTextureCoord;\n\nvarying mediump vec3 vTextureCoord;\n\nuniform vec4 uViewport;\nuniform mediump vec2 uTextureDimensions;\n\nmat4 viewportScale = mat4(2.0 / uViewport.z, 0, 0, 0,    0, -2.0 / uViewport.w, 0,0,    0, 0,1,0,    -1,+1,0,1);\nvec4 viewportTranslation = vec4(uViewport.xy, 0, 0);\n\nvoid main() {\n  vec2 pos = aPosition;\n  vec2 entityOrigin = aOrientation.xy;\n  mat2 entityRotationMatrix = mat2(cos(aOrientation.z), sin(aOrientation.z), -sin(aOrientation.z), cos(aOrientation.z));\n  \n  pos = entityRotationMatrix * (pos - entityOrigin) + entityOrigin ;\n  gl_Position = viewportScale * (viewportTranslation + vec4(pos, 1.0/(1.0+exp(aLayer.x) ), 1) );\n  vTextureCoord = vec3(aTextureCoord, aLayer.y);\n}", "varying mediump vec3 vTextureCoord;\n  \nuniform sampler2D uSampler;\nuniform mediump vec2 uTextureDimensions;\n\nvoid main(void) {\n  highp vec2 coord =   vTextureCoord.xy / uTextureDimensions;\n  mediump vec4 base_color = texture2D(uSampler, coord);\n  gl_FragColor = vec4(base_color.rgb*base_color.a*vTextureCoord.z, base_color.a*vTextureCoord.z);\n}", [
                {
                    name: "aPosition",
                    width: 2
                },
                {
                    name: "aOrientation",
                    width: 3
                },
                {
                    name: "aLayer",
                    width: 2
                },
                {
                    name: "aTextureCoord",
                    width: 2
                }
            ], function(e, _entity) {
                var pos = e.pos;
                // Write texture coordinates
                e.program.writeVector("aTextureCoord", 0, 0, 0, pos._h, pos._w, 0, pos._w, pos._h);
            }));
            /**@
 * #Image
 * @category Graphics
 * @kind Component
 *
 * Draw an image with or without repeating (tiling).
 *
 * If the entity's width and height are smaller than the width and height of the image source, the image will appear cropped.
 * If the entity's dimensions are larger than the dimensions of the image source, the exact appearance of the remaining space will depend on what renderer (WebGL, DOM, or Canvas) is used.
 * However, if tiling is enabled, the remaining space will be filled by a repeating pattern of the image.
 *
 * @note Image scaling is not supported by this component. Use a spritesheet, defined by `Crafty.sprite`, consisting of a single `Sprite` instead.
 *
 * @see Sprite, Crafty.sprite
 */ Crafty.c("Image", {
                _repeat: "repeat",
                ready: false,
                init: function() {
                    this.bind("Draw", this._drawImage);
                    this.bind("LayerAttached", this._setupImage);
                },
                remove: function() {
                    this.unbind("LayerAttached", this._setupImage);
                    this.unbind("Draw", this._drawImage);
                },
                /**@
     * #.image
     * @comp Image
     * @kind Method
     *
     * @trigger Invalidate - when the image is loaded
     * @sign public this .image(String url[, String repeat])
     * @param url - URL of the image
     * @param repeat - If the image should be repeated to fill the entity.  This follows CSS syntax: (`"no-repeat", "repeat", "repeat-x", "repeat-y"`), but defaults to `no-repeat`.
     *
     * Draw the specified image.
     *
     * @note The default value of repeat is `no-repeat`, which is different than the standard CSS default
     *
     * If the width and height are `0` and repeat is set to `no-repeat` the width and
     * height will automatically assume that of the image. This is an
     * easy way to create an image without needing sprites.
     *
     * If set to `no-repeat` and given dimensions larger than that of the image,
     * the exact appearance will depend on what renderer (WebGL, DOM, or Canvas) is used.
     *
     * @example
     * Will default to no-repeat. Entity width and height will be set to the images width and height
     * ~~~
     * var ent = Crafty.e("2D, DOM, Image").image("myimage.png");
     * ~~~
     * Create a repeating background.
     * ~~~
     * var bg = Crafty.e("2D, DOM, Image")
     *              .attr({w: Crafty.viewport.width, h: Crafty.viewport.height})
     *              .image("bg.png", "repeat");
     * ~~~
     *
     * @see Crafty.sprite
     */ image: function(url, repeat) {
                    this.__image = url;
                    this._repeat = repeat || "no-repeat";
                    this.img = Crafty.asset(url);
                    if (!this.img) {
                        this.img = new Image();
                        Crafty.asset(url, this.img);
                        this.img.src = url;
                        var self = this;
                        this.img.onload = function() {
                            self._setupImage(self._drawLayer);
                        };
                    } else this._setupImage(this._drawLayer);
                    this.trigger("Invalidate");
                    return this;
                },
                // called on image change or layer attachment
                _setupImage: function(layer) {
                    if (!this.img || !layer) return;
                    if (layer.type === "Canvas") this._pattern = this._drawContext.createPattern(this.img, this._repeat);
                    else if (layer.type === "WebGL") {
                        this._establishShader("image:" + this.__image, Crafty.defaultShader("Image"));
                        this.program.setTexture(this._drawLayer.makeTexture(this.__image, this.img, this._repeat !== "no-repeat"));
                    }
                    if (this._repeat === "no-repeat") {
                        this.w = this.w || this.img.width;
                        this.h = this.h || this.img.height;
                    }
                    this.ready = true;
                    this.trigger("Invalidate");
                },
                _drawImage: function(e) {
                    if (e.type === "canvas") {
                        //skip if no image
                        if (!this.ready || !this._pattern) return;
                        var context = e.ctx;
                        context.fillStyle = this._pattern;
                        context.save();
                        context.translate(e.pos._x, e.pos._y);
                        context.fillRect(0, 0, e.pos._w, e.pos._h);
                        context.restore();
                    } else if (e.type === "DOM") {
                        if (this.__image) {
                            e.style.backgroundImage = "url(" + this.__image + ")";
                            e.style.backgroundRepeat = this._repeat;
                        }
                    } else if (e.type === "webgl") e.program.draw(e, this);
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    35: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            Crafty.extend({
                _drawLayerTemplates: {},
                _drawLayers: [],
                _addDrawLayerInstance: function(layer) {
                    Crafty._drawLayers.push(layer);
                    this._drawLayers.sort(function(a, b) {
                        return a.options.z - b.options.z;
                    });
                },
                _removeDrawLayerInstance: function(layer) {
                    var i = this._drawLayers.indexOf(layer);
                    if (i >= 0) this._drawLayers.splice(i, 1);
                    this._drawLayers.sort(function(a, b) {
                        return a.options.z - b.options.z;
                    });
                },
                _registerLayerTemplate: function(type, layerTemplate) {
                    this._drawLayerTemplates[type] = layerTemplate;
                    var common = this._commonLayerProperties;
                    // add common properties, don't overwrite existing ones
                    for(var key in common){
                        if (layerTemplate[key]) continue;
                        layerTemplate[key] = common[key];
                    }
                },
                _commonLayerProperties: {
                    // Layer options
                    options: {
                        xResponse: 1,
                        yResponse: 1,
                        scaleResponse: 1,
                        z: 0
                    },
                    // A tracker for whether any elements in this layer need to listen to mouse/touch events
                    _pointerEntities: 0,
                    // Track dirty viewport state - render code should uncheck flag once finished handling it
                    _dirtyViewport: false,
                    // A cached version of the viewport rect
                    _cachedViewportRect: null,
                    init: function() {
                        this._cachedViewportRect = {};
                        // Trigger layer-specific init code
                        this.trigger("LayerInit");
                        // Handle viewport invalidation
                        this.uniqueBind("InvalidateViewport", function() {
                            this._dirtyViewport = true;
                        });
                        // Set pixelart to current status
                        this.trigger("PixelartSet", Crafty._pixelartEnabled);
                        Crafty._addDrawLayerInstance(this);
                    },
                    remove: function() {
                        // Trigger layer-specific remove code
                        this.trigger("LayerRemove");
                        Crafty._removeDrawLayerInstance(this);
                    },
                    // Sort function for rendering in the correct order
                    // Sort by globalZ
                    _sort: function(a, b) {
                        return a._globalZ - b._globalZ;
                    },
                    // Based on the camera options, find the Crafty coordinates
                    // corresponding to the layer's position in the viewport
                    _viewportRect: function(useCached) {
                        var rect = this._cachedViewportRect;
                        if (useCached) return rect;
                        // total transform is viewport transform combined with this layer's transform
                        var viewport = Crafty.viewport;
                        var options = this.options;
                        var scale = Math.pow(viewport._scale, options.scaleResponse);
                        rect._scale = scale;
                        rect._w = viewport._width / scale;
                        rect._h = viewport._height / scale;
                        // This particular transformation is designed such that,
                        // if a combination pan/scale keeps the center of the screen fixed for a layer with x/y response of 1,
                        // then it will also be fixed for layers with other values for x/y response
                        // (note that the second term vanishes when either the response or scale are 1)
                        rect._x = options.xResponse * -viewport._x - 0.5 * (options.xResponse - 1) * (1 - 1 / scale) * viewport._width;
                        rect._y = options.yResponse * -viewport._y - 0.5 * (options.yResponse - 1) * (1 - 1 / scale) * viewport._height;
                        return rect;
                    },
                    // transform a given rect to view space, depending on this layers' total transform
                    _viewTransformRect: function(rect, outRect, useCached) {
                        var view = this._viewportRect(useCached), scale = view._scale;
                        outRect = outRect || {};
                        outRect._x = rect._x * scale + Math.round(-view._x * scale);
                        outRect._y = rect._y * scale + Math.round(-view._y * scale);
                        outRect._w = rect._w * scale;
                        outRect._h = rect._h * scale;
                        return outRect;
                    }
                },
                /**@
     * #Crafty.createLayer
     * @kind Method
     * @category Graphics
     *
     * @sign public void Crafty.createLayer(string name, string type[, object options])
     * @param name - the name that will refer to the layer
     * @param type - the type of the draw layer to create ('DOM', 'Canvas', or 'WebGL')
     * @param options - this will override the default values of each layer
     *
     * Creates a new system which implements the specified type of layer.  The options (and their default values) are
     *
     * ```
     * {
     *   xResponse: 1,  // How the layer will pan in response to the viewport x position
     *   yResponse: 1,  // How the layer will pan in response to the viewport y position
     *   scaleResponse: 1, // How the layer will scale in response to the viewport scale.  (Layer scale will be scale^scaleResponse.)
     *   z: 0 // The zIndex of the layer relative to other layers
     * }
     * ```
     *
     * Crafty will automatically define three built-in layers: "DefaultDOMLayer", DefaultCanvasLayer",  and "DefaultWebGLLayer".
     * They will have `z` values of `30`, `20`, and `10` respectively, and will be initialized if a "DOM", "Canvas" or "WebGL" component
     * is used with an entity not attached to any user-specified layer.
     *
     * @note Layers are implemented as systems, so the layer name must be distinct from other systems.
     *
     * @note By default, layers will persist across scene changes.  You can manually clean up a layer by removing all it's entities and then destroying it.
     *
     * @example
     * ```
     * Crafty.createLayer("MyCanvasLayer", "Canvas")
     * Crafty.e("2D, MyCanvasLayer, Color");
     * ```
     * Define a custom canvas layer, then create an entity that uses the custom layer to render.
     *
     * @example
     * ```
     * Crafty.createLayer("UILayer", "DOM", {scaleResponse: 0, xResponse: 0, yResponse: 0})
     * Crafty.e("2D, UILayer, Text");
     * ```
     * Define a custom DOM layer that will not move with the camera.  (Useful for static UI elements!)
     *
     * @example
     * ```
     * Crafty.createLayer("MyCanvasLayer", "Canvas");
     * Crafty.s("MyCanvasLayer").one("RenderScene", function(){ this.everRendered = true; });
     * ```
     * Create a custom layer, and then bind a method to run the first time it renders.
     * * @example
     * ```
     * Crafty("MyCanvasLayer").destroy();
     * Crafty.s("MyCanvasLayer").destroy();
     * ```
     * For a previously defined "MyCanvasLayer", destroy it and all the entities rendered by it.
     */ createLayer: function createLayer(name, type, options) {
                    var layerTemplate = this._drawLayerTemplates[type];
                    Crafty.s(name, layerTemplate, options);
                    Crafty.c(name, {
                        init: function() {
                            this.requires("Renderable");
                            // Flag to indicate that the base component doesn't need to attach a layer
                            this._customLayer = true;
                            this.requires(layerTemplate.type);
                            this._attachToLayer(Crafty.s(name));
                        },
                        remove: function() {
                            this._detachFromLayer();
                        }
                    });
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    36: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            //////////////////////////////////////////////////////////////////////////////////////////////////////
            // Particles are based on Parcycle by Mr. Speaker, licensed under the MIT, Ported by Leo Koppelkamm //
            //////////////////////////////////////////////////////////////////////////////////////////////////////
            /**@
 * #Particles
 * @category Graphics
 * @kind Component
 *
 * @trigger ParticleStart - when the particle animation has started
 * @trigger ParticleEnd - when the particle animation has finished
 *
 * Create particle effects.
 *
 * Particles won't be drawn outside the entity's bounds. Make sure to adjust the entity's dimensions accordingly.
 *
 * @note Particles effects currently work exclusively with the Canvas render backend.
 * Particles won't be drawn if the browser doesn't support this!
 *
 * @see .particles
 */ Crafty.c("Particles", {
                required: "Renderable",
                ready: true,
                _particlesPaused: false,
                init: function() {
                    // We need to clone particle handler object to avoid shared object trap
                    this._Particles = Crafty.clone(this._Particles);
                    // Add default options
                    this._Particles.init();
                    this._Particles.parentEntity = this;
                },
                events: {
                    UpdateFrame: function() {
                        // don't update if paused or no particle fx active
                        if (this._particlesPaused || !this._Particles.active) return;
                        // This updates all particle colors & positions
                        this._Particles.update();
                        // Request redraw from render backend, as appearance has changed
                        this.trigger("Invalidate");
                    },
                    Draw: function(e) {
                        // don't render if no particle fx active, but do redraw paused particles
                        if (!this._Particles.active) return;
                        if (e.type === "canvas") // This renders the updated particles
                        this._Particles.render(e);
                    }
                },
                /**@
     * #.particles
     * @comp Particles
     * @kind Method
     *
     * @sign public this .particles([Object options])
     * @param options - Map of options that specify the behavior and look of the particles.
     *
     * Create a new particle animation.
     *
     * If the `options` object is missing a property, the default will be used.
     * Default options are listed in the example below.
     *
     * Invoking this method without an `options` object will restart the particle animation
     * with the previously used options, or the default options otherwise.
     *
     * @example
     * ~~~
     * var options = {
     *   maxParticles: 150,
     *   size: 18,
     *   sizeRandom: 4,
     *   speed: 1,
     *   speedRandom: 1.2,
     *   // Lifespan in frames
     *   lifeSpan: 29,
     *   lifeSpanRandom: 7,
     *   // Angle is calculated clockwise: 12pm is 0deg, 3pm is 90deg etc.
     *   angle: 65,
     *   angleRandom: 34,
     *   startColour: [255, 131, 0, 1],
     *   startColourRandom: [48, 50, 45, 0],
     *   endColour: [245, 35, 0, 0],
     *   endColourRandom: [60, 60, 60, 0],
     *   // Only applies when fastMode is off, specifies how sharp the gradients are drawn
     *   sharpness: 20,
     *   sharpnessRandom: 10,
     *   // Random spread from origin
     *   spread: 10,
     *   // How many frames should this last
     *   duration: -1,
     *   // Will draw squares instead of circle gradients
     *   fastMode: false,
     *   gravity: { x: 0, y: 0.1 },
     *   // sensible values are 0-3
     *   jitter: 0,
     *   // Offset for the origin of the particles
     *   originOffset: {x: 0, y: 0}
     * };
     *
     * Crafty.e("2D, Canvas, Particles")
     *     .attr({ w: 200, h: 200 })
     *     // debug entity's bounds while developing
     *     // make sure particles fit into entity's bounds
     *     .addComponent('WiredMBR')
     *     // init particle animation
     *     .particles(options);
     * ~~~
     */ particles: function(options) {
                    // Overwrite default options
                    this._Particles.config(options);
                    // Start animation
                    this._Particles.start();
                    return this;
                },
                _Particles: {
                    presets: {
                        maxParticles: 150,
                        size: 18,
                        sizeRandom: 4,
                        speed: 1,
                        speedRandom: 1.2,
                        // Lifespan in frames
                        lifeSpan: 29,
                        lifeSpanRandom: 7,
                        // Angle is calculated clockwise: 12pm is 0deg, 3pm is 90deg etc.
                        angle: 65,
                        angleRandom: 34,
                        startColour: [
                            255,
                            131,
                            0,
                            1
                        ],
                        startColourRandom: [
                            48,
                            50,
                            45,
                            0
                        ],
                        endColour: [
                            245,
                            35,
                            0,
                            0
                        ],
                        endColourRandom: [
                            60,
                            60,
                            60,
                            0
                        ],
                        // Only applies when fastMode is off, specifies how sharp the gradients are drawn
                        sharpness: 20,
                        sharpnessRandom: 10,
                        // Random spread from origin
                        spread: 10,
                        // How many frames should this last
                        duration: -1,
                        // Will draw squares instead of circle gradients
                        fastMode: false,
                        gravity: {
                            x: 0,
                            y: 0.1
                        },
                        // sensible values are 0-3
                        jitter: 0,
                        // offset of particles from origin
                        originOffset: {
                            x: 0,
                            y: 0
                        }
                    },
                    emissionRate: 0,
                    elapsedFrames: 0,
                    emitCounter: 0,
                    active: true,
                    particles: [],
                    init: function() {
                        // Create initial config by adding presets.
                        for(var key in this.presets)this[key] = this.presets[key];
                    },
                    config: function(options) {
                        options = options || {};
                        // Create current config by merging in given options.
                        for(var key in options)this[key] = options[key];
                        this.emissionRate = this.maxParticles / this.lifeSpan;
                        // Create a new pool of particles, if it doesn't match existing one
                        if (this.particles.length !== this.maxParticles) {
                            this.particles.length = 0;
                            for(var i = 0, l = this.maxParticles; i < l; ++i)this.particles.push(new this.Particle());
                        }
                    },
                    start: function() {
                        // (re)set active state
                        this.active = true;
                        this.elapsedFrames = 0;
                        this.emitCounter = 0;
                        // reset particle pool state between multiple animations, make sure timeToLive === 0
                        var particles = this.particles;
                        for(var i = 0, l = particles.length; i < l; ++i)particles[i].timeToLive = 0;
                        this.parentEntity.trigger("ParticleStart");
                    },
                    stop: function() {
                        // set disabled state
                        this.active = false;
                        this.parentEntity.trigger("ParticleEnd");
                    },
                    initParticle: function(particle) {
                        var angle, speed, size, timeToLive, sharpness, c, startR, startG, startB, startA, endR, endG, endB, endA;
                        particle.timeToLive = timeToLive = this.lifeSpan + this.lifeSpanRandom * this.RANDM1TO1();
                        // TODO default to entity origin instead, deprecate originOffset
                        // TODO subtract size/2 from position
                        particle.positionX = this.originOffset.x + this.spread * this.RANDM1TO1();
                        particle.positionY = this.originOffset.y + this.spread * this.RANDM1TO1();
                        angle = (this.angle + this.angleRandom * this.RANDM1TO1()) * (Math.PI / 180); // convert to radians
                        speed = this.speed + this.speedRandom * this.RANDM1TO1();
                        // Could move to lookup for speed
                        particle.directionX = Math.sin(angle) * speed;
                        particle.directionY = -Math.cos(angle) * speed;
                        size = this.size + this.sizeRandom * this.RANDM1TO1();
                        particle.size = size = size < 0 ? 0 : ~~size;
                        sharpness = this.sharpness + this.sharpnessRandom * this.RANDM1TO1();
                        particle.sharpness = sharpness = sharpness > 100 ? 100 : sharpness < 0 ? 0 : sharpness;
                        // internal circle gradient size - affects the sharpness of the radial gradient
                        particle.sizeSmall = ~~(size / 200 * sharpness); //(size/2/100)
                        c = startR = this.startColour[0] + this.startColourRandom[0] * this.RANDM1TO1();
                        particle.colourR = c > 255 ? 255 : c < 0 ? 0 : ~~c;
                        c = startG = this.startColour[1] + this.startColourRandom[1] * this.RANDM1TO1();
                        particle.colourG = c > 255 ? 255 : c < 0 ? 0 : ~~c;
                        c = startB = this.startColour[2] + this.startColourRandom[2] * this.RANDM1TO1();
                        particle.colourB = c > 255 ? 255 : c < 0 ? 0 : ~~c;
                        c = startA = this.startColour[3] + this.startColourRandom[3] * this.RANDM1TO1();
                        particle.colourA = c > 1 ? 1 : c < 0 ? 0 : ~~(c * 100) / 100;
                        endR = this.endColour[0] + this.endColourRandom[0] * this.RANDM1TO1();
                        endG = this.endColour[1] + this.endColourRandom[1] * this.RANDM1TO1();
                        endB = this.endColour[2] + this.endColourRandom[2] * this.RANDM1TO1();
                        endA = this.endColour[3] + this.endColourRandom[3] * this.RANDM1TO1();
                        particle.deltaColourR = (endR - startR) / timeToLive;
                        particle.deltaColourG = (endG - startG) / timeToLive;
                        particle.deltaColourB = (endB - startB) / timeToLive;
                        particle.deltaColourA = (endA - startA) / timeToLive;
                    },
                    update: function() {
                        var RANDM1TO1 = this.RANDM1TO1;
                        var gravityX = this.gravity.x, gravityY = this.gravity.y;
                        var jitter = this.jitter;
                        // stop if duration elapsed
                        this.elapsedFrames++;
                        if (this.duration >= 0 && this.duration < this.elapsedFrames) this.stop();
                        // update emission logic
                        var rate = this.emissionRate > 0 ? 1 / this.emissionRate : Infinity;
                        this.emitCounter++;
                        // update all particles
                        var c, particle, particles = this.particles;
                        for(var i = 0, l = particles.length; i < l; ++i){
                            particle = particles[i];
                            // If the current particle is alive then update it
                            if (particle.timeToLive > 0) {
                                // Calculate the new position based on gravity
                                particle.directionX += gravityX;
                                particle.directionY += gravityY;
                                particle.positionX += particle.directionX;
                                particle.positionY += particle.directionY;
                                if (jitter) {
                                    particle.positionX += jitter * RANDM1TO1();
                                    particle.positionY += jitter * RANDM1TO1();
                                }
                                // Update colours
                                c = particle.colourR + particle.deltaColourR;
                                particle.colourR = c > 255 ? 255 : c < 0 ? 0 : ~~c;
                                c = particle.colourG + particle.deltaColourG;
                                particle.colourG = c > 255 ? 255 : c < 0 ? 0 : ~~c;
                                c = particle.colourB + particle.deltaColourB;
                                particle.colourB = c > 255 ? 255 : c < 0 ? 0 : ~~c;
                                c = particle.colourA + particle.deltaColourA;
                                particle.colourA = c > 1 ? 1 : c < 0 ? 0 : ~~(c * 100) / 100;
                                // Decrease particle's lifespan
                                particle.timeToLive--;
                            // Else reinitialize particle if within emission rate
                            } else if (this.emitCounter > rate) {
                                this.initParticle(particle);
                                this.emitCounter -= rate;
                            }
                        }
                    },
                    render: function(e) {
                        var context = e.ctx;
                        var delim = ",";
                        var particle, particles = this.particles;
                        for(var i = 0, l = particles.length; i < l; i++){
                            particle = particles[i];
                            var size = particle.size;
                            var halfSize = size >> 1;
                            if (particle.positionX < 0 || particle.positionX + size > e.pos._w || particle.positionY < 0 || particle.positionY + size > e.pos._h) continue;
                            var x = ~~(e.pos._x + particle.positionX);
                            var y = ~~(e.pos._y + particle.positionY);
                            var r = particle.colourR, g = particle.colourG, b = particle.colourB, a = particle.colourA;
                            // Calculate the rgba string to draw.
                            var drawColour = "rgba(" + r + delim + g + delim + b + delim + a + ")";
                            if (this.fastMode) context.fillStyle = drawColour;
                            else {
                                var drawColourEnd = "rgba(" + r + delim + g + delim + b + delim + "0)";
                                var radgrad = context.createRadialGradient(x + halfSize, y + halfSize, particle.sizeSmall, x + halfSize, y + halfSize, halfSize);
                                radgrad.addColorStop(0, drawColour);
                                //0.9 to avoid visible boxing
                                radgrad.addColorStop(0.9, drawColourEnd);
                                context.fillStyle = radgrad;
                            }
                            context.fillRect(x, y, size, size);
                        }
                    },
                    Particle: function() {
                        this.positionX = 0;
                        this.positionY = 0;
                        this.directionX = 0;
                        this.directionY = 0;
                        this.size = 0;
                        this.sizeSmall = 0;
                        this.timeToLive = 0;
                        this.colourR = 0;
                        this.colourG = 0;
                        this.colourB = 0;
                        this.colourA = 0;
                        this.deltaColourR = 0;
                        this.deltaColourG = 0;
                        this.deltaColourB = 0;
                        this.deltaColourA = 0;
                        this.sharpness = 0;
                    },
                    RANDM1TO1: function() {
                        return Math.random() * 2 - 1;
                    }
                },
                /**@
     * #.pauseParticles
     * @comp Particles
     * @kind Method
     *
     * @sign public this.pauseParticles()
     *
     * The pauseParticles will freeze these particles in execution.
     *
     * @example
     * ~~~
     * // start particle animation
     * var ent = Crafty.e("Particles").particles(someParticleConfig);
     *
     * // and some time later, the gameplay is paused (or only
     * // a part of it is frozen)
     * ent.pauseParticles();
     * ~~~
     */ pauseParticles: function() {
                    this._particlesPaused = true;
                },
                /**@
     * #.resumeParticles
     * @comp Particles
     * @kind Method
     *
     * @sign public this.resumeParticles()
     *
     * The resumeParticles will resume earlier paused particles
     *
     * @example
     * ~~~
     * // start particle animation
     * var ent = Crafty.e("Particles").particles(someParticleConfig);
     *
     * // and some time later, the gameplay is paused (or only
     * // a part of it is frozen)
     * ent.pauseParticles();
     *
     * // and we resume the particles again
     * ent.resumeParticles();
     * ~~~
     */ resumeParticles: function() {
                    this._particlesPaused = false;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    37: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #Renderable
 * @category Graphics
 * @kind Component
 *
 * Component for any entity that has a position on the stage.
 * @trigger Invalidate - when the entity needs to be redrawn
 */ Crafty.c("Renderable", {
                // Flag for tracking whether the entity is dirty or not
                _changed: false,
                /**@
     * #.alpha
     * @comp Renderable
     * @kind Property
     *
     * Transparency of an entity. Must be a decimal value between 0.0 being fully transparent to 1.0 being fully opaque.
     */ _alpha: 1.0,
                /**@
     * #.visible
     * @comp Renderable
     * @kind Property
     *
     * If the entity is visible or not. Accepts a true or false value.
     * Can be used for optimization by setting an entities visibility to false when not needed to be drawn.
     *
     * The entity will still exist and can be collided with but just won't be drawn.
     */ _visible: true,
                _setterRenderable: function(name, value) {
                    if (this[name] === value) return;
                    //everything will assume the value
                    this[name] = value;
                    // flag for redraw
                    this.trigger("Invalidate");
                },
                // Setup all the properties that we need to define
                properties: {
                    alpha: {
                        set: function(v) {
                            this._setterRenderable("_alpha", v);
                        },
                        get: function() {
                            return this._alpha;
                        },
                        configurable: true,
                        enumerable: true
                    },
                    _alpha: {
                        enumerable: false
                    },
                    visible: {
                        set: function(v) {
                            this._setterRenderable("_visible", v);
                        },
                        get: function() {
                            return this._visible;
                        },
                        configurable: true,
                        enumerable: true
                    },
                    _visible: {
                        enumerable: false
                    }
                },
                init: function() {},
                // Need to store visibility before being frozen
                _hideOnUnfreeze: false,
                events: {
                    Freeze: function() {
                        this._hideOnUnfreeze = !this._visible;
                        this._visible = false;
                        this.trigger("Invalidate");
                    },
                    Unfreeze: function() {
                        this._visible = !this._hideOnUnfreeze;
                        this.trigger("Invalidate");
                    }
                },
                // Renderable assumes that a draw layer has 3 important methods: attach, detach, and dirty
                // Dirty the entity when it's invalidated
                _invalidateRenderable: function() {
                    //flag if changed
                    if (this._changed === false) {
                        this._changed = true;
                        this._drawLayer.dirty(this);
                    }
                },
                // Attach the entity to a layer to be rendered
                _attachToLayer: function(layer) {
                    if (this._drawLayer) this._detachFromLayer();
                    this._drawLayer = layer;
                    layer.attach(this);
                    this.bind("Invalidate", this._invalidateRenderable);
                    this.trigger("LayerAttached", layer);
                    this.trigger("Invalidate");
                },
                // Detach the entity from a layer
                _detachFromLayer: function() {
                    if (!this._drawLayer) return;
                    this._drawLayer.detach(this);
                    this.unbind("Invalidate", this._invalidateRenderable);
                    this.trigger("LayerDetached", this._drawLayer);
                    delete this._drawLayer;
                },
                /**@
     * #.flip
     * @comp Renderable
     * @kind Method
     *
     * @trigger Invalidate - when the entity has flipped
     * @sign public this .flip(String dir)
     * @param dir - Flip direction
     *
     * Flip entity on passed direction
     *
     * @example
     * ~~~
     * this.flip("X")
     * ~~~
     */ flip: function(dir) {
                    dir = dir || "X";
                    if (!this["_flip" + dir]) {
                        this["_flip" + dir] = true;
                        this.trigger("Invalidate");
                    }
                    return this;
                },
                /**@
     * #.unflip
     * @comp Renderable
     * @kind Method
     *
     * @trigger Invalidate - when the entity has unflipped
     * @sign public this .unflip(String dir)
     * @param dir - Unflip direction
     *
     * Unflip entity on passed direction (if it's flipped)
     *
     * @example
     * ~~~
     * this.unflip("X")
     * ~~~
     */ unflip: function(dir) {
                    dir = dir || "X";
                    if (this["_flip" + dir]) {
                        this["_flip" + dir] = false;
                        this.trigger("Invalidate");
                    }
                    return this;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    38: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #SpriteAnimation
 * @category Animation
 * @kind Component
 *
 * @trigger StartAnimation - When an animation starts playing, or is resumed from the paused state - {Reel}
 * @trigger AnimationEnd - When the animation finishes - { Reel }
 * @trigger FrameChange - Each time the frame of the current reel changes - { Reel }
 * @trigger ReelChange - When the reel changes - { Reel }
 *
 * Used to animate sprites by treating a sprite map as a set of animation frames.
 * Must be applied to an entity that has a sprite-map component.
 *
 * To define an animation, see the `reel` method.  To play an animation, see the `animate` method.
 *
 * A reel is an object that contains the animation frames and current state for an animation.  The reel object has the following properties:
 * @param id: (String) - the name of the reel
 * @param frames: (Array) - A list of frames in the format [xpos, ypos]
 * @param currentFrame: (Number) - The index of the current frame
 * @param easing: (Crafty.easing object) - The object that handles the internal progress of the animation.
 * @param duration: (Number) - The duration in milliseconds.
 *
 * Many animation related events pass a reel object as data.  As typical with events, this should be treated as read only data that might be later altered by the entity.  If you wish to preserve the data, make a copy of it.
 *
 * @see Crafty.sprite
 */ Crafty.c("SpriteAnimation", {
                /*
     * A map in which the keys are the names assigned to animations defined using
     * the component (also known as reelIDs), and the values are objects describing
     * the animation and its state.
     */ _reels: null,
                /*
     * The reelID of the currently active reel (which is one of the elements in `this._reels`).
     * This value is `null` if no reel is active. Some of the component's actions can be invoked
     * without specifying a reel, in which case they will work on the active reel.
     */ _currentReelId: null,
                /*
     * The currently active reel.
     * This value is `null` if no reel is active.
     */ _currentReel: null,
                /*
     * Whether or not an animation is currently playing.
     */ _isPlaying: false,
                /**@
     * #.animationSpeed
     * @comp SpriteAnimation
     *
     * The playback rate of the animation.  This property defaults to 1.
     */ animationSpeed: 1,
                init: function() {
                    this._reels = {};
                },
                /**@
     * #.reel
     * @comp SpriteAnimation
     * @kind Method
     *
     * Used to define reels, to change the active reel, and to fetch the id of the active reel.
     *
     * @sign public this .reel(String reelId, Duration duration, Number fromX, Number fromY, Number frameCount[, Number rowLength])
     * Defines a reel by starting and ending position on the sprite sheet.
     * @param reelId - ID of the animation reel being created
     * @param duration - The length of the animation in milliseconds.
     * @param fromX - Starting `x` position on the sprite map (x's unit is the horizontal size of the sprite in the sprite map).
     * @param fromY - `y` position on the sprite map (y's unit is the horizontal size of the sprite in the sprite map). Remains constant through the animation.
     * @param frameCount - The number of sequential frames in the animation.  If negative, the animation will play backwards.
     * @param rowLength - The number of frames in a sprite sheet row.
     *                    The sequential frames will auto-wrap to a new row when they reach the end of the current row.
     *                    This is an optional argument that defaults to `Infinity`.
     *
     * @sign public this .reel(String reelId, Duration duration, Array frames)
     * Defines a reel by an explicit list of frames
     * @param reelId - ID of the animation reel being created
     * @param duration - The length of the animation in milliseconds.
     * @param frames - An array of arrays containing the `x` and `y` values of successive frames: [[x1,y1],[x2,y2],...] (the values are in the unit of the sprite map's width/height respectively).
     *
     * @sign public this .reel(String reelId, Duration duration, Array frames)
     * Defines a reel by an explicit list of frames with sprite names
     * @param reelId - ID of the animation reel being created
     * @param duration - The length of the animation in milliseconds.
     * @param frames - An array of strings containing the sprite names of successive frames: ['spriteName1','spriteName2',...].
     *
     * @sign public this .reel(String reelId)
     * Switches to the specified reel.  The sprite will be updated to that reel's current frame
     * @param reelID - the ID to switch to
     *
     * @sign public Reel .reel()
     * @return The id of the current reel
     *
     *
     * A method to handle animation reels.  Only works for sprites built with the Crafty.sprite methods.
     * See the Tween component for animation of 2D properties.
     *
     * To setup an animation reel, pass the name of the reel (used to identify the reel later), and either an
     * array of absolute sprite positions or the start x on the sprite map, the y on the sprite map and then the end x on the sprite map.
     *
     *
     * @example
     * ~~~
     * // Define a sprite-map component
     * Crafty.sprite(16, "images/sprite.png", {
     *     PlayerSprite: [0,0],
     *     PlayerIdle1: [0,1],
     *     PlayerLeftFootForward: [1,1],
     *     PlayerIdle2: [2,1],
     *     PlayerRightFootForward: [3,1]
     * });
     *
     * // Define an animation on the second row of the sprite map (fromY = 1)
     * // from the left most sprite (fromX = 0) to the fourth sprite
     * // on that row (frameCount = 4), with a duration of 1 second
     * Crafty.e("2D, DOM, SpriteAnimation, PlayerSprite").reel('PlayerRunning', 1000, 0, 1, 4);
     *
     * // This is the same animation definition, but using the alternative method
     * Crafty.e("2D, DOM, SpriteAnimation, PlayerSprite").reel('PlayerRunning', 1000, [[0, 1], [1, 1], [2, 1], [3, 1]]);
     *
     * // This is the same animation definition, but uses sprite names instead of numbers
     * Crafty.e("2D, DOM, SpriteAnimation, PlayerSprite")
     *       .reel('PlayerRunning', 1000, ['PlayerIdle1', 'PlayerLeftFootForward', 'PlayerIdle2', 'PlayerRightFootForward']);
     * ~~~
     */ reel: function(reelId, duration, fromX, fromY, frameCount, rowLength) {
                    // @sign public this .reel()
                    if (arguments.length === 0) return this._currentReelId;
                    // @sign public this .reel(String reelID)
                    if (arguments.length === 1 && typeof reelId === "string") {
                        if (typeof this._reels[reelId] === "undefined") throw "The specified reel " + reelId + " is undefined.";
                        this.pauseAnimation();
                        if (this._currentReelId !== reelId) {
                            this._currentReelId = reelId;
                            this._currentReel = this._reels[reelId];
                            // Change the visible sprite
                            this._updateSprite();
                            // Trigger event
                            this.trigger("ReelChange", this._currentReel);
                        }
                        return this;
                    }
                    var reel, i;
                    reel = {
                        id: reelId,
                        frames: [],
                        currentFrame: 0,
                        easing: new Crafty.easing(duration),
                        defaultLoops: 1
                    };
                    reel.duration = reel.easing.duration;
                    // @sign public this .reel(String reelId, Number duration, Number fromX, Number fromY, Number frameDuration)
                    if (typeof fromX === "number") {
                        rowLength = rowLength || Infinity;
                        if (frameCount >= 0) // forward animation
                        for(i = 0; i < frameCount; ++i){
                            reel.frames.push([
                                fromX,
                                fromY
                            ]);
                            if (++fromX >= rowLength) {
                                fromX = 0;
                                fromY++;
                            }
                        }
                        else // backward animation
                        for(i = 0; i > frameCount; --i){
                            reel.frames.push([
                                fromX,
                                fromY
                            ]);
                            if (--fromX < 0) {
                                fromX = rowLength - 1;
                                fromY--;
                            }
                        }
                    } else if (arguments.length === 3 && typeof fromX === "object") // @sign public this .reel(String reelId, Number duration, Array frames)
                    reel.frames = fromX;
                    else throw "Unrecognized arguments. Please see the documentation for 'reel(...)'.";
                    this._reels[reelId] = reel;
                    return this;
                },
                /**@
     * #.animate
     * @comp SpriteAnimation
     * @kind Method
     *
     * @sign public this .animate([String reelId] [, Number loopCount])
     * @param reelId - ID of the animation reel to play.  Defaults to the current reel if none is specified.
     * @param loopCount - Number of times to repeat the animation. Use -1 to repeat indefinitely.  Defaults to 1.
     *
     * Play one of the reels previously defined through `.reel(...)`. Simply pass the name of the reel. If you wish the
     * animation to play multiple times in succession, pass in the amount of times as an additional parameter.
     * To have the animation repeat indefinitely, pass in `-1`.
     *
     * If another animation is currently playing, it will be paused.
     *
     * This will always play an animation from the beginning.  If you wish to resume from the current state of a reel, use `resumeAnimation()`.
     *
     * Once an animation ends, it will remain at its last frame.
     *
     *
     * @example
     * ~~~
     * // Define a sprite-map component
     * Crafty.sprite(16, "images/sprite.png", {
     *     PlayerSprite: [0,0]
     * });
     *
     * // Play the animation across 20 frames (so each sprite in the 4 sprite animation should be seen for 5 frames) and repeat indefinitely
     * Crafty.e("2D, DOM, SpriteAnimation, PlayerSprite")
     *     .reel('PlayerRunning', 20, 0, 0, 3) // setup animation
     *     .animate('PlayerRunning', -1); // start animation
     * ~~~
     */ animate: function(reelId, loopCount) {
                    // switch to the specified reel if necessary
                    if (typeof reelId === "string") this.reel(reelId);
                    var currentReel = this._currentReel;
                    if (typeof currentReel === "undefined" || currentReel === null) throw "No reel is specified, and there is no currently active reel.";
                    this.pauseAnimation(); // This will pause the current animation, if one is playing
                    // Handle repeats; if loopCount is undefined and reelID is a number, calling with that signature
                    if (typeof loopCount === "undefined") {
                        if (typeof reelId === "number") loopCount = reelId;
                        else loopCount = 1;
                    }
                    // set the animation to the beginning
                    currentReel.easing.reset();
                    // user provided loop count.
                    this.loops(loopCount);
                    // trigger the necessary events and switch to the first frame
                    this._setFrame(0);
                    // Start the anim
                    this.bind("UpdateFrame", this._animationTick);
                    this._isPlaying = true;
                    this.trigger("StartAnimation", currentReel);
                    return this;
                },
                /**@
     * #.resumeAnimation
     * @comp SpriteAnimation
     * @kind Method
     *
     * @sign public this .resumeAnimation()
     *
     * This will resume animation of the current reel from its current state.
     * If a reel is already playing, or there is no current reel, there will be no effect.
     */ resumeAnimation: function() {
                    if (this._isPlaying === false && this._currentReel !== null) {
                        this.bind("UpdateFrame", this._animationTick);
                        this._isPlaying = true;
                        this._currentReel.easing.resume();
                        this.trigger("StartAnimation", this._currentReel);
                    }
                    return this;
                },
                /**@
     * #.pauseAnimation
     * @comp SpriteAnimation
     * @kind Method
     *
     * @sign public this .pauseAnimation(void)
     *
     * Pauses the currently playing animation, or does nothing if no animation is playing.
     */ pauseAnimation: function() {
                    if (this._isPlaying === true) {
                        this.unbind("UpdateFrame", this._animationTick);
                        this._isPlaying = false;
                        this._reels[this._currentReelId].easing.pause();
                    }
                    return this;
                },
                /**@
     * #.resetAnimation
     * @comp SpriteAnimation
     * @kind Method
     *
     * @sign public this .resetAnimation()
     *
     * Resets the current animation to its initial state.  Resets the number of loops to the last specified value, which defaults to 1.
     *
     * Neither pauses nor resumes the current animation.
     */ resetAnimation: function() {
                    var currentReel = this._currentReel;
                    if (currentReel === null) throw "No active reel to reset.";
                    this.reelPosition(0);
                    currentReel.easing.repeat(currentReel.defaultLoops);
                    return this;
                },
                /**@
     * #.loops
     * @comp SpriteAnimation
     * @kind Method
     *
     * @sign public this .loops(Number loopCount)
     * @param loopCount - The number of times to play the animation
     *
     * Sets the number of times the animation will loop for.
     * If called while an animation is in progress, the current state will be considered the first loop.
     *
     * @sign public Number .loops()
     * @returns The number of loops left.  Returns 0 if no reel is active.
     */ loops: function(loopCount) {
                    if (arguments.length === 0) {
                        if (this._currentReel !== null) return this._currentReel.easing.loops;
                        else return 0;
                    }
                    if (this._currentReel !== null) {
                        if (loopCount < 0) loopCount = Infinity;
                        this._currentReel.easing.repeat(loopCount);
                        this._currentReel.defaultLoops = loopCount;
                    }
                    return this;
                },
                /**@
     * #.reelPosition
     * @kind Method
     *
     * @comp SpriteAnimation
     *
     * @sign public this .reelPosition(Integer position)
     * Sets the position of the current reel by frame number.
     * @param position - the frame to jump to.  This is zero-indexed.  A negative values counts back from the last frame.
     *
     * @sign public this .reelPosition(Number position)
     * Sets the position of the current reel by percent progress.
     * @param position - a non-integer number between 0 and 1
     *
     * @sign public this .reelPosition(String position)
     * Jumps to the specified position.  The only currently accepted value is "end", which will jump to the end of the reel.
     *
     * @sign public Number .reelPosition()
     * @returns The current frame number
     *
     */ reelPosition: function(position) {
                    if (this._currentReel === null) throw "No active reel.";
                    if (arguments.length === 0) return this._currentReel.currentFrame;
                    var progress, l = this._currentReel.frames.length;
                    if (position === "end") position = l - 1;
                    if (position < 1 && position > 0) {
                        progress = position;
                        position = Math.floor(l * progress);
                    } else {
                        if (position !== Math.floor(position)) throw "Position " + position + " is invalid.";
                        if (position < 0) position = l - 1 + position;
                        progress = position / l;
                    }
                    // cap to last frame
                    position = Math.min(position, l - 1);
                    position = Math.max(position, 0);
                    this._setProgress(progress);
                    this._setFrame(position);
                    return this;
                },
                /**@
     * #.reelFrame
     * @kind Method
     *
     * @comp SpriteAnimation
     *
     * @sign public this .reelFrame(String frameName)
     * Sets the position of the current reel by frame name.
     * @param frameName - Name in the sprite map.
     *
     * Jumps to specifed frame if the reel was created with sprite names.
     *
     */ reelFrame: function(frameName) {
                    if (this._currentReel === null) throw "No active reel.";
                    var index = this._currentReel.frames.indexOf(frameName);
                    if (index === -1) throw "Frame name " + frameName + " is invalid.";
                    this.reelPosition(index);
                    return this;
                },
                // Bound to "UpdateFrame".  Progresses the animation by dt, changing the frame if necessary.
                // dt is multiplied by the animationSpeed property
                _animationTick: function(frameData) {
                    var currentReel = this._reels[this._currentReelId];
                    currentReel.easing.tick(frameData.dt * this.animationSpeed);
                    var progress = currentReel.easing.value();
                    var frameNumber = Math.min(Math.floor(currentReel.frames.length * progress), currentReel.frames.length - 1);
                    this._setFrame(frameNumber);
                    if (currentReel.easing.complete === true) {
                        this.pauseAnimation();
                        this.trigger("AnimationEnd", this._currentReel);
                    }
                },
                // Set the current frame and update the displayed sprite
                // The actual progress for the animation must be set seperately.
                _setFrame: function(frameNumber) {
                    var currentReel = this._currentReel;
                    if (frameNumber === currentReel.currentFrame) return;
                    currentReel.currentFrame = frameNumber;
                    this._updateSprite();
                    this.trigger("FrameChange", currentReel);
                },
                // Update the displayed sprite.
                _updateSprite: function() {
                    var currentReel = this._currentReel;
                    var frame = currentReel.frames[currentReel.currentFrame];
                    // .sprite will trigger redraw
                    if (typeof frame === "string") this.sprite(frame);
                    else this.sprite(frame[0], frame[1]);
                },
                // Sets the internal state of the current reel's easing object
                _setProgress: function(progress, repeats) {
                    this._currentReel.easing.setProgress(progress, repeats);
                },
                /**@
     * #.isPlaying
     * @comp SpriteAnimation
     * @kind Method
     *
     * @sign public Boolean .isPlaying([String reelId])
     * @param reelId - The reelId of the reel we wish to examine
     * @returns The current animation state
     *
     * Determines if the specified animation is currently playing. If no reelId is specified,
     * checks if any animation is playing.
     *
     * @example
     * ~~~
     * myEntity.isPlaying() // is any animation playing
     * myEntity.isPlaying('PlayerRunning') // is the PlayerRunning animation playing
     * ~~~
     */ isPlaying: function(reelId) {
                    if (!this._isPlaying) return false;
                    if (!reelId) return !!this._currentReelId;
                    return this._currentReelId === reelId;
                },
                /**@
     * #.getReel
     * @comp SpriteAnimation
     * @kind Method
     *
     * @sign public Reel .getReel()
     * @returns The current reel, or null if there is no active reel
     *
     * @sign public Reel .getReel(reelId)
     * @param reelId - The id of the reel to fetch.
     * @returns The specified reel, or `undefined` if no such reel exists.
     *
     */ getReel: function(reelId) {
                    if (arguments.length === 0) {
                        if (!this._currentReelId) return null;
                        reelId = this._currentReelId;
                    }
                    return this._reels[reelId];
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    39: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            // Define some variables required for webgl
            Crafty.defaultShader("Sprite", new Crafty.WebGLShader("attribute vec2 aPosition;\nattribute vec3 aOrientation;\nattribute vec2 aLayer;\nattribute vec2 aTextureCoord;\n\nvarying mediump vec3 vTextureCoord;\n\nuniform vec4 uViewport;\nuniform mediump vec2 uTextureDimensions;\n\nmat4 viewportScale = mat4(2.0 / uViewport.z, 0, 0, 0,    0, -2.0 / uViewport.w, 0,0,    0, 0,1,0,    -1,+1,0,1);\nvec4 viewportTranslation = vec4(uViewport.xy, 0, 0);\n\nvoid main() {\n  vec2 pos = aPosition;\n  vec2 entityOrigin = aOrientation.xy;\n  mat2 entityRotationMatrix = mat2(cos(aOrientation.z), sin(aOrientation.z), -sin(aOrientation.z), cos(aOrientation.z));\n  \n  pos = entityRotationMatrix * (pos - entityOrigin) + entityOrigin ;\n  gl_Position = viewportScale * (viewportTranslation + vec4(pos, 1.0/(1.0+exp(aLayer.x) ), 1) );\n  vTextureCoord = vec3(aTextureCoord, aLayer.y);\n}", "varying mediump vec3 vTextureCoord;\n  \nuniform sampler2D uSampler;\nuniform mediump vec2 uTextureDimensions;\n\nvoid main(void) {\n  highp vec2 coord =   vTextureCoord.xy / uTextureDimensions;\n  mediump vec4 base_color = texture2D(uSampler, coord);\n  gl_FragColor = vec4(base_color.rgb*base_color.a*vTextureCoord.z, base_color.a*vTextureCoord.z);\n}", [
                {
                    name: "aPosition",
                    width: 2
                },
                {
                    name: "aOrientation",
                    width: 3
                },
                {
                    name: "aLayer",
                    width: 2
                },
                {
                    name: "aTextureCoord",
                    width: 2
                }
            ], function(e, _entity) {
                var co = e.co;
                // Write texture coordinates
                e.program.writeVector("aTextureCoord", co.x, co.y, co.x, co.y + co.h, co.x + co.w, co.y, co.x + co.w, co.y + co.h);
            }));
            Crafty.extend({
                /**@
     * #Crafty.sprite
     * @kind Method
     *
     * @category Graphics
     * @sign public this Crafty.sprite([Number tile, [Number tileh]], String url, Object map[, Number paddingX[, Number paddingY[, Boolean paddingAroundBorder]]])
     * @param tile - Tile size of the sprite map, defaults to 1
     * @param tileh - Height of the tile; if provided, tile is interpreted as the width
     * @param url - URL of the sprite image
     * @param map - Object where the key is what becomes a new component and the value points to a position on the sprite map
     * @param paddingX - Horizontal space in between tiles. Defaults to 0.
     * @param paddingY - Vertical space in between tiles. Defaults to paddingX.
     * @param paddingAroundBorder - If padding should be applied around the border of the sprite sheet. If enabled the first tile starts at (paddingX,paddingY) instead of (0,0). Defaults to false.
     *
     * Generates components based on positions in a sprite image to be applied to entities.
     *
     * Accepts a tile size, URL and map for the name of the sprite and its position.
     *
     * The position must be an array containing the position of the sprite where index `0`
     * is the `x` position, `1` is the `y` position and optionally `2` is the width and `3`
     * is the height. If the sprite map has padding, pass the values for the `x` padding
     * or `y` padding. If they are the same, just add one value.
     *
     * If the sprite image has no consistent tile size, `1` or no argument need be
     * passed for tile size.
     *
     * Entities that add the generated components are also given the `2D` component, and
     * a component called `Sprite`.
     *
     * @example
     * ~~~
     * Crafty.sprite("imgs/spritemap6.png", {flower:[0,0,20,30]});
     * var flower_entity = Crafty.e("2D, DOM, flower");
     * ~~~
     * The first line creates a component called `flower` associated with the sub-image of
     * spritemap6.png with top-left corner (0,0), width 20 pixels, and height 30 pixels.
     * The second line creates an entity with that image. (Note: The `2D` is not really
     * necessary here, because adding the `flower` component automatically also adds the
     * `2D` component.)
     * ~~~
     * Crafty.sprite(50, "imgs/spritemap6.png", {flower:[0,0], grass:[0,1,3,1]});
     * ~~~
     * In this case, the `flower` component is pixels 0 <= x < 50, 0 <= y < 50, and the
     * `grass` component is pixels 0 <= x < 150, 50 <= y < 100. (The `3` means grass has a
     * width of 3 tiles, i.e. 150 pixels.)
     * ~~~
     * Crafty.sprite(50, 100, "imgs/spritemap6.png", {flower:[0,0], grass:[0,1]}, 10);
     * ~~~
     * In this case, each tile is 50x100, and there is a spacing of 10 pixels between
     * consecutive tiles. So `flower` is pixels 0 <= x < 50, 0 <= y < 100, and `grass` is
     * pixels 0 <= x < 50, 110 <= y < 210.
     *
     * @see Sprite
     */ sprite: function(tile, tileh, url, map, paddingX, paddingY, paddingAroundBorder) {
                    var spriteName, temp, img;
                    //if no tile value, default to 1.
                    //(if the first passed argument is a string, it must be the url.)
                    if (typeof tile === "string") {
                        paddingY = paddingX;
                        paddingX = map;
                        map = tileh;
                        url = tile;
                        tile = 1;
                        tileh = 1;
                    }
                    if (typeof tileh === "string") {
                        paddingY = paddingX;
                        paddingX = map;
                        map = url;
                        url = tileh;
                        tileh = tile;
                    }
                    //if no paddingY, use paddingX
                    if (!paddingY && paddingX) paddingY = paddingX;
                    paddingX = parseInt(paddingX || 0, 10); //just incase
                    paddingY = parseInt(paddingY || 0, 10);
                    var markSpritesReady = function() {
                        this.ready = true;
                        this.trigger("Invalidate");
                    };
                    img = Crafty.asset(url);
                    if (!img) {
                        img = new Image();
                        img.src = url;
                        Crafty.asset(url, img);
                        img.onload = function() {
                            //all components with this img are now ready
                            for(var spriteName in map)Crafty(spriteName).each(markSpritesReady);
                        };
                    }
                    var sharedSpriteInit = function() {
                        this.requires("2D, Sprite");
                        this.__trim = [
                            0,
                            0,
                            0,
                            0
                        ];
                        this.__image = url;
                        this.__map = map;
                        this.__coord = [
                            this.__coord[0],
                            this.__coord[1],
                            this.__coord[2],
                            this.__coord[3]
                        ];
                        this.__tile = tile;
                        this.__tileh = tileh;
                        this.__padding = [
                            paddingX,
                            paddingY
                        ];
                        this.__padBorder = paddingAroundBorder;
                        this.sprite(this.__coord[0], this.__coord[1], this.__coord[2], this.__coord[3]);
                        this.img = img;
                        //draw now
                        if (this.img.complete && this.img.width > 0) {
                            this.ready = true;
                            this.trigger("Invalidate");
                        }
                        //set the width and height to the sprite size
                        this.w = this.__coord[2];
                        this.h = this.__coord[3];
                        this._setupSpriteImage(this._drawLayer);
                    };
                    for(spriteName in map){
                        if (!map.hasOwnProperty(spriteName)) continue;
                        temp = map[spriteName];
                        //generates sprite components for each tile in the map
                        Crafty.c(spriteName, {
                            ready: false,
                            __coord: [
                                temp[0],
                                temp[1],
                                temp[2] || 1,
                                temp[3] || 1
                            ],
                            init: sharedSpriteInit
                        });
                    }
                    return this;
                }
            });
            /**@
 * #Sprite
 * @category Graphics
 * @kind Component
 *
 * @trigger Invalidate - when the sprites change
 *
 * A component for using tiles in a sprite map.
 *
 * This is automatically added to entities which use the components created by `Crafty.sprite` or `Crafty.load`.
 * Since these are also used to define tile size, you'll rarely need to use this components methods directly.
 *
 * @see Crafty.sprite, Crafty.load
 */ Crafty.c("Sprite", {
                __image: "",
                /*
     * #.__tile
     * @comp Sprite
     *
     * Horizontal sprite tile size.
     */ __tile: 0,
                /*
     * #.__tileh
     * @comp Sprite
     *
     * Vertical sprite tile size.
     */ __tileh: 0,
                __padding: null,
                __trim: null,
                img: null,
                //ready is changed to true in Crafty.sprite
                ready: false,
                init: function() {
                    this.__trim = [
                        0,
                        0,
                        0,
                        0
                    ];
                    this.bind("Draw", this._drawSprite);
                    this.bind("LayerAttached", this._setupSpriteImage);
                },
                remove: function() {
                    this.unbind("Draw", this._drawSprite);
                    this.unbind("LayerAttached", this._setupSpriteImage);
                },
                _setupSpriteImage: function(layer) {
                    if (!this.__image || !this.img || !layer) return;
                    if (layer.type === "WebGL") {
                        this._establishShader(this.__image, Crafty.defaultShader("Sprite"));
                        this.program.setTexture(layer.makeTexture(this.__image, this.img, false));
                    }
                },
                _drawSprite: function(e) {
                    var co = e.co, pos = e.pos, context = e.ctx;
                    if (e.type === "canvas") //draw the image on the canvas element
                    context.drawImage(this.img, co.x, co.y, co.w, co.h, pos._x, pos._y, pos._w, pos._h //height on canvas
                    );
                    else if (e.type === "DOM") {
                        // Get scale (ratio of entity dimensions to sprite's dimensions)
                        // If needed, we will scale up the entire sprite sheet, and then modify the position accordingly
                        var vscale = this._h / co.h, hscale = this._w / co.w, style = this._element.style, bgColor = style.backgroundColor;
                        if (bgColor === "initial") bgColor = "";
                        // Don't change background if it's not necessary -- this can cause some browsers to reload the image
                        // See [this chrome issue](https://code.google.com/p/chromium/issues/detail?id=102706)
                        var newBackground = bgColor + " url('" + this.__image + "') no-repeat";
                        if (newBackground !== style.background) style.background = newBackground;
                        style.backgroundPosition = "-" + co.x * hscale + "px -" + co.y * vscale + "px";
                        // style.backgroundSize must be set AFTER style.background!
                        if (vscale !== 1 || hscale !== 1) style.backgroundSize = this.img.width * hscale + "px" + " " + this.img.height * vscale + "px";
                    } else if (e.type === "webgl") // Write texture coordinates
                    e.program.draw(e, this);
                },
                /**@
     * #.sprite
     * @comp Sprite
     * @kind Method
     *
     * @sign public this .sprite(Number x, Number y[, Number w, Number h])
     * @param x - X cell position
     * @param y - Y cell position
     * @param w - Width in cells. Optional.
     * @param h - Height in cells. Optional.
     *
     * Uses a new location on the sprite map as its sprite.
     * If w or h are ommitted, the width and height are not changed.
     * Values should be in tiles or cells (not pixels).
     *
     * @sign public this .sprite(String tileName)
     * @param tileName - the name of a tile specified in the sprite map
     *
     * Uses a new location on the sprite map as its sprite.
     * The location is retrieved by name from the previously supplied sprite map.
     * An invalid name will be silently ignored.
     *
     * @example
     * ~~~
     * Crafty.e("2D, DOM, Sprite")
     *   .sprite(0, 0, 2, 2);
     *
     * Crafty.e("2D, DOM, flower")
     *   .sprite('grass');
     * ~~~
     */ /**@
     * #.__coord
     * @comp Sprite
     * @kind Property
     *
     * The coordinate of the slide within the sprite in the format of [x, y, w, h].
     */ sprite: function(x, y, w, h) {
                    if (typeof x === "string") {
                        // retrieve location from sprite map by name
                        var temp = this.__map[x];
                        if (!temp) return this;
                        x = temp[0];
                        y = temp[1];
                        w = temp[2] || 1;
                        h = temp[3] || 1;
                    }
                    this.__coord = this.__coord || [
                        0,
                        0,
                        0,
                        0
                    ];
                    this.__coord[0] = x * (this.__tile + this.__padding[0]) + (this.__padBorder ? this.__padding[0] : 0) + this.__trim[0];
                    this.__coord[1] = y * (this.__tileh + this.__padding[1]) + (this.__padBorder ? this.__padding[1] : 0) + this.__trim[1];
                    if (typeof w !== "undefined" && typeof h !== "undefined") {
                        this.__coord[2] = this.__trim[2] || w * this.__tile || this.__tile;
                        this.__coord[3] = this.__trim[3] || h * this.__tileh || this.__tileh;
                    }
                    this.trigger("Invalidate");
                    return this;
                },
                /**@
     * #.crop
     * @comp Sprite
     * @kind Method
     *
     * @sign public this .crop(Number x, Number y, Number w, Number h)
     * @param x - Offset x position
     * @param y - Offset y position
     * @param w - New width
     * @param h - New height
     *
     * If the entity needs to be smaller than the tile size, use this method to crop it.
     *
     * The values should be in pixels rather than tiles.
     *
     * @example
     * ~~~
     * Crafty.e("2D, DOM, Sprite")
     *   .crop(40, 40, 22, 23);
     * ~~~
     */ crop: function(x, y, w, h) {
                    var old = this._mbr || this.pos();
                    this.__trim = [];
                    this.__trim[0] = x;
                    this.__trim[1] = y;
                    this.__trim[2] = w;
                    this.__trim[3] = h;
                    this.__coord[0] += x;
                    this.__coord[1] += y;
                    this.__coord[2] = w;
                    this.__coord[3] = h;
                    this._w = w;
                    this._h = h;
                    this.trigger("Invalidate", old);
                    return this;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    40: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #Text
 * @category Graphics
 * @kind Component
 *
 * @trigger Invalidate - when the text is changed
 * @requires Canvas or DOM
 * Component to make a text entity.
 *
 * By default, text will have the style "10px sans-serif".
 *
 * @note An entity with the text component is just text! If you want to write text
 * inside an image, you need one entity for the text and another entity for the image.
 * More tips for writing text inside an image: (1) Use the z-index (from 2D component)
 * to ensure that the text is on top of the image, not the other way around; (2)
 * use .attach() (from 2D component) to glue the text to the image so they move and
 * rotate together.
 *
 * @note For DOM (but not canvas) text entities, various font settings (such as
 * text-decoration) can be set using `.css()` (see DOM component). If you
 * use `.css()` to set the *individual* properties which are controlled by `.textFont()`,
 *  `.textColor()`, or `.textAlign()`, the text component will set these properties internally as well.
 * However, if you use `.css()` to set shorthand properties such as `font`, these will be ignored by the text component.
 *
 * @note If you use canvas text with glyphs that are taller than standard letters, portions of the glyphs might be cut off.
 */ Crafty.c("Text", {
                _text: "",
                defaultSize: "10px",
                defaultFamily: "sans-serif",
                defaultVariant: "normal",
                defaultLineHeight: "normal",
                defaultTextAlign: "left",
                ready: true,
                init: function() {
                    this.requires("2D");
                    this._textFont = {
                        type: "",
                        weight: "",
                        size: this.defaultSize,
                        lineHeight: this.defaultLineHeight,
                        family: this.defaultFamily,
                        variant: this.defaultVariant
                    };
                    this._textAlign = this.defaultTextAlign;
                },
                events: {
                    Draw: function(e) {
                        var font = this._fontString();
                        if (e.type === "DOM") {
                            var el = this._element, style = el.style;
                            style.color = this._textColor;
                            style.font = font;
                            style.textAlign = this._textAlign;
                            el.innerHTML = this._text;
                        } else if (e.type === "canvas") {
                            var context = e.ctx;
                            context.save();
                            context.textBaseline = "top";
                            context.fillStyle = this._textColor || "rgb(0,0,0)";
                            context.font = font;
                            context.textAlign = this._textAlign;
                            context.fillText(this._text, e.pos._x, e.pos._y);
                            context.restore();
                        }
                    },
                    // type, weight, size, family, lineHeight, and variant.
                    // For a few hardcoded css properties, set the internal definitions
                    SetStyle: function(propertyName) {
                        // could check for DOM component, but this event should only be fired by such an entity!
                        // Rather than triggering Invalidate on each of these, we rely on css() triggering that event
                        switch(propertyName){
                            case "textAlign":
                                this._textAlign = this._element.style.textAlign;
                                break;
                            case "color":
                                // Need to set individual color components, so use method
                                this.textColor(this._element.style.color);
                                break;
                            case "fontType":
                                this._textFont.type = this._element.style.fontType;
                                break;
                            case "fontWeight":
                                this._textFont.weight = this._element.style.fontWeight;
                                break;
                            case "fontSize":
                                this._textFont.size = this._element.style.fontSize;
                                break;
                            case "fontFamily":
                                this._textFont.family = this._element.style.fontFamily;
                                break;
                            case "fontVariant":
                                this._textFont.variant = this._element.style.fontVariant;
                                break;
                            case "lineHeight":
                                this._textFont.lineHeight = this._element.style.lineHeight;
                                break;
                        }
                    }
                },
                remove: function() {
                    // Clean up the dynamic text update
                    this.unbind(this._textUpdateEvent, this._dynamicTextUpdate);
                },
                // takes a CSS font-size string and gets the height of the resulting font in px
                _getFontHeight: function() {
                    // regex for grabbing the first string of letters
                    var re = /([a-zA-Z]+)\b/;
                    // From the CSS spec.  "em" and "ex" are undefined on a canvas.
                    var multipliers = {
                        px: 1,
                        pt: 4 / 3,
                        pc: 16,
                        cm: 96 / 2.54,
                        mm: 96 / 25.4,
                        in: 96,
                        em: undefined,
                        ex: undefined
                    };
                    return function(font) {
                        var number = parseFloat(font);
                        var match = re.exec(font);
                        var unit = match ? match[1] : "px";
                        if (multipliers[unit] !== undefined) return Math.ceil(number * multipliers[unit]);
                        else return Math.ceil(number);
                    };
                }(),
                /**@
     * #.text
     * @comp Text
     * @kind Method
     *
     * @sign public this .text(String text)
     * @param text - String of text that will be inserted into the DOM or Canvas element.
     *
     * @sign public this .text(Function textGenerator[, Any eventData])
     * @param textGenerator - A function that returns a string.
     *        It will be immediately invoked with the optional eventData in the context of the entity,
     *        with the result used as the text to display.
     * @param [eventData] - Optional parameter to invoke the function with.
     *
     * This method will update the text inside the entity.
     *
     * If you need to reference attributes on the entity itself you can pass a function instead of a string.
     *
     * If dynamic text generation is turned on, the function will then be reevaluated as necessary.
     *
     * @see .dynamicTextGeneration
     *
     * @example
     * ~~~
     * Crafty.e("2D, DOM, Text").attr({ x: 100, y: 100 }).text("Look at me!!");
     *
     * Crafty.e("2D, DOM, Text").attr({ x: 100, y: 100 })
     *     .text(function () { return "My position is " + this._x });
     *
     * Crafty.e("2D, Canvas, Text").attr({ x: 100, y: 100 }).text("Look at me!!");
     *
     * Crafty.e("2D, Canvas, Text").attr({ x: 100, y: 100 })
     *     .text(function () { return "My position is " + this._x });
     * ~~~
     */ _textGenerator: null,
                text: function(text, eventData) {
                    if (!(typeof text !== "undefined" && text !== null)) return this._text;
                    if (typeof text === "function") {
                        this._text = text.call(this, eventData);
                        this._textGenerator = text;
                    } else {
                        this._text = text;
                        this._textGenerator = null;
                    }
                    if (this.has("Canvas")) this._resizeForCanvas();
                    this.trigger("Invalidate");
                    return this;
                },
                /**@
     * #.dynamicTextGeneration
     * @comp Text
     * @kind Method
     *
     * @sign public this .dynamicTextGeneration(bool dynamicTextOn[, string textUpdateEvent])
     * @param dynamicTextOn - A flag that indicates whether dyanamic text should be on or off.
     * @param textUpdateEvent - The name of the event which will trigger text to be updated.  Defaults to "UpdateFrame".  (This parameter does nothing if dynamicTextOn is false.)
     *
     * Turns on (or off) dynamic text generation for this entity.  While dynamic text generation is on,
     * if the `.text()` method is called with a text generating function, the text will be updated each frame.
     *
     * If textUpdateEvent is provided, text generation will be bound to that event instead of "UpdateFrame".
     *
     * The text generating function is invoked with the event object parameter, which the event was triggered with.
     *
     * @note Dynamic text generation could cause performance issues when the entity is attached to a Canvas layer.
     *
     * @example
     * ~~~
     * Crafty.e("2D, DOM, Text, Motion").attr({ x: 100, y: 100, vx: 10 })
     *     .text(function () { return "My position is " + this._x })
     *     .dynamicTextGeneration(true)
     * ~~~
     * The above example will update the text with the entities position as it changes.
     */ _dynamicTextOn: false,
                _textUpdateEvent: null,
                _dynamicTextUpdate: function(eventData) {
                    if (!this._textGenerator) return;
                    this.text(this._textGenerator, eventData);
                },
                dynamicTextGeneration: function(dynamicTextOn, textUpdateEvent) {
                    this.unbind(this._textUpdateEvent, this._dynamicTextUpdate);
                    if (dynamicTextOn) {
                        this._textUpdateEvent = textUpdateEvent || "UpdateFrame";
                        this.bind(this._textUpdateEvent, this._dynamicTextUpdate);
                    }
                    return this;
                },
                // Calculates the height and width of text on the canvas
                // Width is found by using the canvas measureText function
                // Height is only estimated -- it calculates the font size in pixels, and sets the height to 110% of that.
                _resizeForCanvas: function() {
                    var ctx = this._drawContext;
                    ctx.font = this._fontString();
                    this.w = ctx.measureText(this._text).width;
                    var size = this._textFont.size || this.defaultSize;
                    this.h = 1.1 * this._getFontHeight(size);
                    /* Offset the MBR for text alignment*/ if (this._textAlign === "left" || this._textAlign === "start") this.offsetBoundary(0, 0, 0, 0);
                    else if (this._textAlign === "center") this.offsetBoundary(this.w / 2, 0, -this.w / 2, 0);
                    else if (this._textAlign === "end" || this._textAlign === "right") this.offsetBoundary(this.w, 0, -this.w, 0);
                },
                // Returns the font string to use
                _fontString: function() {
                    return this._textFont.type + " " + this._textFont.variant + " " + this._textFont.weight + " " + this._textFont.size + " / " + this._textFont.lineHeight + " " + this._textFont.family;
                },
                /**@
     * #.textColor
     * @comp Text
     * @kind Method
     *
     * @sign public this .textColor(String color)
     * @param color - The color in name, hex, rgb or rgba
     *
     * Change the color of the text. You can use HEX, rgb and rgba colors.
     *
     * If you want the text to be transparent, you should use rgba where you can define alphaChannel.
     *
     * @example
     * ~~~
     * Crafty.e("2D, DOM, Text").attr({ x: 100, y: 100 }).text("Look at me!!")
     *   .textColor('#FF0000');
     *
     * Crafty.e("2D, Canvas, Text").attr({ x: 100, y: 100 }).text('Look at me!!')
     *   .textColor('rgba(0, 255, 0, 0.5)');
     *
     * Crafty.e("2D, Canvas, Text").attr({ x: 100, y: 100 }).text('Look at me!!')
     *   .textColor('white');
     * ~~~
     * @see Crafty.assignColor
     */ textColor: function(color) {
                    Crafty.assignColor(color, this);
                    this._textColor = "rgba(" + this._red + ", " + this._green + ", " + this._blue + ", " + this._strength + ")";
                    this.trigger("Invalidate");
                    return this;
                },
                /**@
     * #.textAlign
     * @comp Text
     * @kind Method
     *
     * @sign public this .textAlign(String alignment)
     * @param alignment - The new alignment of the text.
     *
     * Change the alignment of the text. Valid values are 'start', 'end, 'left', 'center', or 'right'.
     */ textAlign: function(alignment) {
                    this._textAlign = alignment;
                    if (this.has("Canvas")) this._resizeForCanvas();
                    this.trigger("Invalidate");
                    return this;
                },
                /**@
     * #.textFont
     * @comp Text
     * @kind Method
     *
     * @triggers Invalidate
     * @sign public this .textFont(String key, * value)
     * @param key - Property of the entity to modify
     * @param value - Value to set the property to
     *
     * @sign public this .textFont(Object map)
     * @param map - Object where the key is the property to modify and the value as the property value
     *
     * Use this method to set font property of the text entity.  Possible values are: type, weight, size, family, lineHeight, and variant.
     *
     * When rendered by the canvas, lineHeight and variant will be ignored.
     *
     * @example
     * ~~~
     * Crafty.e("2D, DOM, Text").textFont({ type: 'italic', family: 'Arial' });
     * Crafty.e("2D, Canvas, Text").textFont({ size: '20px', weight: 'bold' });
     *
     * Crafty.e("2D, Canvas, Text").textFont("type", "italic");
     * Crafty.e("2D, Canvas, Text").textFont("type"); // italic
     * ~~~
     */ textFont: function(key, value) {
                    if (arguments.length === 1) {
                        //if just the key, return the value
                        if (typeof key === "string") return this._textFont[key];
                        if (typeof key === "object") {
                            for(var propertyKey in key)if (propertyKey === "family") this._textFont[propertyKey] = "'" + key[propertyKey] + "'";
                            else this._textFont[propertyKey] = key[propertyKey];
                        }
                    } else this._textFont[key] = value;
                    if (this.has("Canvas")) this._resizeForCanvas();
                    this.trigger("Invalidate");
                    return this;
                },
                /**@
     * #.unselectable
     * @comp Text
     * @kind Method
     *
     * @triggers Invalidate
     * @sign public this .unselectable()
     *
     * This method sets the text so that it cannot be selected (highlighted) by dragging.
     * (Canvas text can never be highlighted, so this only matters for DOM text.)
     * Works by changing the css property "user-select" and its variants.
     *
     * Likewise, this sets the mouseover cursor to be "default" (arrow), not "text" (I-beam)
     *
     * @example
     * ~~~
     * Crafty.e("2D, DOM, Text").text('This text cannot be highlighted!').unselectable();
     * ~~~
     */ unselectable: function() {
                    // http://stackoverflow.com/questions/826782/css-rule-to-disable-text-selection-highlighting
                    if (this.has("DOM")) {
                        this.css({
                            "-webkit-touch-callout": "none",
                            "-webkit-user-select": "none",
                            "-khtml-user-select": "none",
                            "-moz-user-select": "none",
                            "-ms-user-select": "none",
                            "user-select": "none",
                            cursor: "default"
                        });
                        this.trigger("Invalidate");
                    }
                    return this;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    41: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js"), document1 = window.document;
            Crafty.extend({
                /**@
     * #Crafty.viewport
     * @category Stage
     * @kind Property
     *
     * @trigger ViewportScroll - when the viewport's x or y coordinates change
     * @trigger ViewportScale - when the viewport's scale changes
     * @trigger ViewportResize - when the viewport's dimension's change
     * @trigger InvalidateViewport - when the viewport changes
     * @trigger StopCamera - when any camera animations should stop, such as at the start of a new animation.
     * @trigger CameraAnimationDone - when a camera animation reaches completion
     *
     * Viewport is essentially a 2D camera looking at the stage. Can be moved or zoomed, which
     * in turn will react just like a camera moving in that direction.
     *
     * There are multiple camera animation methods available - these are the viewport methods with an animation time parameter and the `follow` method.
     * Only one animation can run at a time. Starting a new animation will cancel the previous one and the appropriate events will be fired.
     *
     * Tip: At any given moment, the stuff that you can see is...
     *
     * `x` between `(-Crafty.viewport._x)` and `(-Crafty.viewport._x + (Crafty.viewport._width / Crafty.viewport._scale))`
     *
     * `y` between `(-Crafty.viewport._y)` and `(-Crafty.viewport._y + (Crafty.viewport._height / Crafty.viewport._scale))`
     *
     *
     * @example
     * Prevent viewport from adjusting itself when outside the game world.
     * Scale the viewport so that entities appear twice as large.
     * Then center the viewport on an entity over the duration of 3 seconds.
     * After that animation finishes, start following the entity.
     * ~~~
     * var ent = Crafty.e('2D, DOM').attr({x: 250, y: 250, w: 100, h: 100});
     *
     * Crafty.viewport.clampToEntities = false;
     * Crafty.viewport.scale(2);
     * Crafty.one("CameraAnimationDone", function() {
     *     Crafty.viewport.follow(ent, 0, 0);
     * });
     * Crafty.viewport.centerOn(ent, 3000);
     * ~~~
     */ viewport: {
                    /**@
         * #Crafty.viewport.clampToEntities
         * @comp Crafty.viewport
         * @kind Property
         *
         * Decides if the viewport functions should clamp to game entities.
         * When set to `true` functions such as Crafty.viewport.mouselook() will not allow you to move the
         * viewport over areas of the game that has no entities.
         * For development it can be useful to set this to false.
         */ clampToEntities: true,
                    _width: 0,
                    _height: 0,
                    /**@
         * #Crafty.viewport.x
         * @comp Crafty.viewport
         * @kind Property
         *
         * Will move the stage and therefore every visible entity along the `x`
         * axis in the opposite direction.
         *
         * When this value is set, it will shift the entire stage. This means that entity
         * positions are not exactly where they are on screen. To get the exact position,
         * simply add `Crafty.viewport.x` onto the entities `x` position.
         */ _x: 0,
                    /**@
         * #Crafty.viewport.y
         * @comp Crafty.viewport
         * @kind Property
         *
         * Will move the stage and therefore every visible entity along the `y`
         * axis in the opposite direction.
         *
         * When this value is set, it will shift the entire stage. This means that entity
         * positions are not exactly where they are on screen. To get the exact position,
         * simply add `Crafty.viewport.y` onto the entities `y` position.
         */ _y: 0,
                    /**@
         * #Crafty.viewport._scale
         * @comp Crafty.viewport
         * @kind Property
         *
         * This value is the current scale (zoom) of the viewport. When the value is bigger than 1, everything
         * looks bigger (zoomed in). When the value is less than 1, everything looks smaller (zoomed out). This
         * does not alter the size of the stage itself, just the magnification of what it shows.
         *
         * This is a read-only property: Do not set it directly. Instead, use `Crafty.viewport.scale(...)`
         * or `Crafty.viewport.zoom(...)`
         */ _scale: 1,
                    /**@
         * #Crafty.viewport.bounds
         * @comp Crafty.viewport
         * @kind Property
         *
         * A rectangle which defines the bounds of the viewport.
         * It should be an object with two properties, `max` and `min`,
         * which are each an object with `x` and `y` properties.
         *
         * If this property is null, Crafty uses the bounding box of all the items
         * on the stage.  This is the initial value.  (To prevent this behavior, set `Crafty.viewport.clampToEntities` to `false`)
         *
         * If you wish to bound the viewport along one axis but not the other, you can use `-Infinity` and `+Infinity` as bounds.
         *
         * @see Crafty.viewport.clampToEntities
         *
         * @example
         * Set the bounds to a 500 by 500 square:
         *
         * ~~~
         * Crafty.viewport.bounds = {min:{x:0, y:0}, max:{x:500, y:500}};
         * ~~~
         */ bounds: null,
                    /**@
         * #Crafty.viewport.scroll
         * @comp Crafty.viewport
         * @kind Method
         *
         * @sign Crafty.viewport.scroll(String axis, Number val)
         * @param axis - 'x' or 'y'
         * @param val - The new absolute position on the axis
         *
         * Will move the viewport to the position given on the specified axis
         *
         * @example
         * Will move the camera 500 pixels right of its initial position, in effect
         * shifting everything in the viewport 500 pixels to the left.
         *
         * ~~~
         * Crafty.viewport.scroll('_x', 500);
         * ~~~
         */ scroll: function(axis, val) {
                        this[axis] = val;
                        Crafty.trigger("ViewportScroll");
                        Crafty.trigger("InvalidateViewport");
                    },
                    rect_object: {
                        _x: 0,
                        _y: 0,
                        _w: 0,
                        _h: 0
                    },
                    /**@
         * #Crafty.viewport.rect
         * @comp Crafty.viewport
         * @kind Method
         *
         * @sign public Object Crafty.viewport.rect([Object out])
         * @param Object out - an optional Object to write the `rect` to
         * @return a rectangle encompassing the currently visible viewport region.
         *         Contains the `_x`,`_y`,`_w`,`_h` properties.
         *
         * Convenience method which returns a `rect` of the currently visible viewport region.
         * With no supplied `out` parameter, this method returns an internally reused object across invocations.
         * If you want to save the viewport region for later use, pass an `out` argument instead, where the region will be written to.
         *
         * @example
         * The `rect` is equivalent to the following properties:
         * ~~~
         * var rect = Crafty.viewport.rect();
         *
         * rect._x === -Crafty.viewport._x
         * rect._y === -Crafty.viewport._y
         * rect._w === Crafty.viewport._width / Crafty.viewport._scale
         * rect._h === Crafty.viewport._height / Crafty.viewport._scale
         * ~~~
         */ rect: function(out) {
                        out = out || this.rect_object;
                        out._x = -this._x;
                        out._y = -this._y;
                        out._w = this._width / this._scale;
                        out._h = this._height / this._scale;
                        return out;
                    },
                    /**@ 

         * #Crafty.viewport.pan
         * @comp Crafty.viewport
         * @kind Method
         * 
         * @sign public void Crafty.viewport.pan(Number dx, Number dy, Number time[, String|function easingFn])
         * @param Number dx - The distance along the x axis
         * @param Number dy - The distance along the y axis
         * @param Number time - The duration in ms for the entire camera movement
         * @param easingFn - A string or custom function specifying an easing.  (Defaults to linear behavior.)  See Crafty.easing for more information.
         *
         * Pans the camera a given number of pixels over the specified time
         *
         * @example
         * ~~~
         * // pan the camera 100 px right and down over the duration of 2 seconds using linear easing behaviour
         * Crafty.viewport.pan(100, 100, 2000);
         * ~~~
         */ pan: function() {
                        var targetX, targetY, startingX, startingY, easing;
                        function updateFrame(e) {
                            easing.tick(e.dt);
                            var v = easing.value();
                            Crafty.viewport.x = (1 - v) * startingX + v * targetX;
                            Crafty.viewport.y = (1 - v) * startingY + v * targetY;
                            Crafty.viewport._clamp();
                            if (easing.complete) {
                                stopPan();
                                Crafty.trigger("CameraAnimationDone");
                            }
                        }
                        function stopPan() {
                            Crafty.unbind("UpdateFrame", updateFrame);
                        }
                        Crafty._preBind("StopCamera", stopPan);
                        return function(dx, dy, time, easingFn) {
                            // Cancel any current camera control
                            Crafty.trigger("StopCamera");
                            // Handle request to reset
                            if (dx === "reset") return;
                            startingX = Crafty.viewport._x;
                            startingY = Crafty.viewport._y;
                            targetX = startingX - dx;
                            targetY = startingY - dy;
                            easing = new Crafty.easing(time, easingFn);
                            // bind to event, using uniqueBind prevents multiple copies from being bound
                            Crafty.uniqueBind("UpdateFrame", updateFrame);
                        };
                    }(),
                    /**@
         * #Crafty.viewport.follow
         * @comp Crafty.viewport
         * @kind Method
         *
         * @sign public void Crafty.viewport.follow(Object target, Number offsetx, Number offsety)
         * @param Object target - An entity with the 2D component
         * @param Number offsetx - Follow target's center should be offsetx pixels away from viewport's center. Positive values puts target to the right of the screen.
         * @param Number offsety - Follow target's center should be offsety pixels away from viewport's center. Positive values puts target to the bottom of the screen.
         *
         * Follows a given entity with the 2D component. If following target will take a portion of
         * the viewport out of bounds of the world, following will stop until the target moves away.
         *
         * @example
         * ~~~
         * var ent = Crafty.e('2D, DOM').attr({w: 100, h: 100});
         * Crafty.viewport.follow(ent, 0, 0);
         * ~~~
         */ follow: function() {
                        var oldTarget, offx, offy;
                        function change() {
                            var scale = Crafty.viewport._scale;
                            Crafty.viewport.scroll("_x", -(this.x + this.w / 2 - Crafty.viewport.width / 2 / scale - offx * scale));
                            Crafty.viewport.scroll("_y", -(this.y + this.h / 2 - Crafty.viewport.height / 2 / scale - offy * scale));
                            Crafty.viewport._clamp();
                        }
                        function stopFollow() {
                            if (oldTarget) {
                                oldTarget.unbind("Move", change);
                                oldTarget.unbind("ViewportScale", change);
                                oldTarget.unbind("ViewportResize", change);
                            }
                        }
                        Crafty._preBind("StopCamera", stopFollow);
                        return function(target, offsetx, offsety) {
                            if (!target || !target.has("2D")) return;
                            Crafty.trigger("StopCamera");
                            oldTarget = target;
                            offx = typeof offsetx !== "undefined" ? offsetx : 0;
                            offy = typeof offsety !== "undefined" ? offsety : 0;
                            target.bind("Move", change);
                            target.bind("ViewportScale", change);
                            target.bind("ViewportResize", change);
                            change.call(target);
                        };
                    }(),
                    /**@
         * #Crafty.viewport.centerOn
         * @comp Crafty.viewport
         * @kind Method
         *
         * @sign public void Crafty.viewport.centerOn(Object target, Number time)
         * @param Object target - An entity with the 2D component
         * @param Number time - The duration in ms of the camera motion
         *
         * Centers the viewport on the given entity.
         *
         * @example
         * ~~~
         * var ent = Crafty.e('2D, DOM').attr({x: 250, y: 250, w: 100, h: 100});
         * Crafty.viewport.centerOn(ent, 3000);
         * ~~~
         */ centerOn: function(targ, time) {
                        var x = targ.x + Crafty.viewport.x, y = targ.y + Crafty.viewport.y, mid_x = targ.w / 2, mid_y = targ.h / 2, cent_x = Crafty.viewport.width / 2 / Crafty.viewport._scale, cent_y = Crafty.viewport.height / 2 / Crafty.viewport._scale, new_x = x + mid_x - cent_x, new_y = y + mid_y - cent_y;
                        Crafty.viewport.pan(new_x, new_y, time);
                    },
                    /**@
         * #Crafty.viewport.zoom
         * @comp Crafty.viewport
         * @kind Method
         *
         * @sign public void Crafty.viewport.zoom(Number amt, Number cent_x, Number cent_y, Number time[, String|function easingFn])
         * @param Number amt - amount to zoom in on the target by (eg. 2, 4, 0.5)
         * @param Number cent_x - the center to zoom on
         * @param Number cent_y - the center to zoom on
         * @param Number time - the duration in ms of the entire zoom operation
         * @param easingFn - A string or custom function specifying an easing.  (Defaults to linear behavior.)  See Crafty.easing for more information.
         *
         * Zooms the camera in on a given point. amt > 1 will bring the camera closer to the subject
         * amt < 1 will bring it farther away. amt = 0 will reset to the default zoom level
         * Zooming is multiplicative. To reset the zoom amount, pass 0.
         *
         * @example
         * ~~~
         * // Make the entities appear twice as large by zooming in on the specified coordinates over the duration of 3 seconds using linear easing behavior
         * Crafty.viewport.zoom(2, 100, 100, 3000);
         * ~~~
         */ zoom: function() {
                        function stopZoom() {
                            Crafty.unbind("UpdateFrame", updateFrame);
                        }
                        Crafty._preBind("StopCamera", stopZoom);
                        var startingZoom, finalZoom, finalAmount, startingX, finalX, startingY, finalY, easing;
                        function updateFrame(e) {
                            var amount, v;
                            easing.tick(e.dt);
                            // The scaling should happen smoothly -- start at 1, end at finalAmount, and at half way scaling should be by finalAmount^(1/2)
                            // Since value goes smoothly from 0 to 1, this fufills those requirements
                            amount = Math.pow(finalAmount, easing.value());
                            // The viewport should move in such a way that no point reverses
                            // If a and b are the top left/bottom right of the viewport, then the below can be derived from
                            //      (a_0-b_0)/(a-b) = amount,
                            // and the assumption that both a and b have the same form
                            //      a = a_0 * (1-v) + a_f * v,
                            //      b = b_0 * (1-v) + b_f * v.
                            // This is just an arbitrary parameterization of the only sensible path for the viewport corners to take.
                            // And by symmetry they should be parameterized in the same way!  So not much choice here.
                            if (finalAmount === 1) v = easing.value();
                            else v = (1 / amount - 1) / (1 / finalAmount - 1);
                            // Set new scale and viewport position
                            Crafty.viewport.scale(amount * startingZoom);
                            Crafty.viewport.scroll("_x", startingX * (1 - v) + finalX * v);
                            Crafty.viewport.scroll("_y", startingY * (1 - v) + finalY * v);
                            Crafty.viewport._clamp();
                            if (easing.complete) {
                                stopZoom();
                                Crafty.trigger("CameraAnimationDone");
                            }
                        }
                        return function(amt, cent_x, cent_y, time, easingFn) {
                            if (!amt) {
                                // we're resetting to defaults
                                Crafty.viewport.scale(1);
                                return;
                            }
                            if (arguments.length <= 2) {
                                time = cent_x;
                                cent_x = Crafty.viewport.x - Crafty.viewport.width;
                                cent_y = Crafty.viewport.y - Crafty.viewport.height;
                            }
                            Crafty.trigger("StopCamera");
                            startingZoom = Crafty.viewport._scale;
                            finalAmount = amt;
                            finalZoom = startingZoom * finalAmount;
                            startingX = Crafty.viewport.x;
                            startingY = Crafty.viewport.y;
                            finalX = -(cent_x - Crafty.viewport.width / (2 * finalZoom));
                            finalY = -(cent_y - Crafty.viewport.height / (2 * finalZoom));
                            easing = new Crafty.easing(time, easingFn);
                            Crafty.uniqueBind("UpdateFrame", updateFrame);
                        };
                    }(),
                    /**@
         * #Crafty.viewport.scale
         * @comp Crafty.viewport
         * @kind Method
         *
         * @sign public void Crafty.viewport.scale(Number amt)
         * @param Number amt - amount to zoom/scale in on the elements
         *
         * Adjusts the scale (zoom). When `amt` is 1, it is set to the normal scale,
         * e.g. an entity with `this.w == 20` would appear exactly 20 pixels wide.
         * When `amt` is 10, that same entity would appear 200 pixels wide (i.e., zoomed in
         * by a factor of 10), and when `amt` is 0.1, that same entity would be 2 pixels wide
         * (i.e., zoomed out by a factor of `(1 / 0.1)`).
         *
         * If you pass an `amt` of 0, it is treated the same as passing 1, i.e. the scale is reset.
         *
         * This method sets the absolute scale, while `Crafty.viewport.zoom` sets the scale relative to the existing value.
         * @see Crafty.viewport.zoom
         *
         * @example
         * ~~~
         * Crafty.viewport.scale(2); // Zoom in -- all entities will appear twice as large.
         * ~~~
         */ scale: function() {
                        return function(amt) {
                            this._scale = amt ? amt : 1;
                            Crafty.trigger("InvalidateViewport");
                            Crafty.trigger("ViewportScale");
                        };
                    }(),
                    /**@
         * #Crafty.viewport.mouselook
         * @comp Crafty.viewport
         * @kind Method
         *
         * @sign public void Crafty.viewport.mouselook(Boolean active)
         * @param Boolean active - Activate or deactivate mouselook
         *
         * Toggle mouselook on the current viewport.
         * Simply call this function and the user will be able to
         * drag the viewport around.
         *
         * If the user starts a drag, "StopCamera" will be triggered, which will cancel any existing camera animations.
         */ mouselook: function() {
                        var mouseSystem;
                        var active = false, dragging = false, lastMouse = {
                            x: 0,
                            y: 0
                        }, diff = {
                            x: 0,
                            y: 0
                        };
                        function startFn(e) {
                            if (dragging || e.target) return;
                            Crafty.trigger("StopCamera");
                            // DEPRECATED: switch computation to use e.realX, e.realY
                            lastMouse.x = e.clientX;
                            lastMouse.y = e.clientY;
                            dragging = true;
                        }
                        function moveFn(e) {
                            if (!dragging) return;
                            diff.x = e.clientX - lastMouse.x;
                            diff.y = e.clientY - lastMouse.y;
                            lastMouse.x = e.clientX;
                            lastMouse.y = e.clientY;
                            var viewport = Crafty.viewport;
                            viewport.x += diff.x / viewport._scale;
                            viewport.y += diff.y / viewport._scale;
                            viewport._clamp();
                        }
                        function stopFn(e) {
                            if (!dragging) return;
                            dragging = false;
                        }
                        return function(op) {
                            // TODO: lock pointer events on controls system in future
                            mouseSystem = Crafty.s("Mouse");
                            if (op && !active) {
                                mouseSystem.bind("MouseDown", startFn);
                                mouseSystem.bind("MouseMove", moveFn);
                                mouseSystem.bind("MouseUp", stopFn);
                                active = op;
                            } else if (!op && active) {
                                mouseSystem.unbind("MouseDown", startFn);
                                mouseSystem.unbind("MouseMove", moveFn);
                                mouseSystem.unbind("MouseUp", stopFn);
                                active = op;
                            }
                        };
                    }(),
                    _clamp: function() {
                        // clamps the viewport to the viewable area
                        // under no circumstances should the viewport see something outside the boundary of the 'world'
                        if (!this.clampToEntities) return;
                        var bound = Crafty.clone(this.bounds) || Crafty.map.boundaries();
                        bound.max.x *= this._scale;
                        bound.min.x *= this._scale;
                        bound.max.y *= this._scale;
                        bound.min.y *= this._scale;
                        if (bound.max.x - bound.min.x > Crafty.viewport.width) {
                            if (Crafty.viewport.x < (-bound.max.x + Crafty.viewport.width) / this._scale) Crafty.viewport.x = (-bound.max.x + Crafty.viewport.width) / this._scale;
                            else if (Crafty.viewport.x > -bound.min.x) Crafty.viewport.x = -bound.min.x;
                        } else Crafty.viewport.x = -1 * (bound.min.x + (bound.max.x - bound.min.x) / 2 - Crafty.viewport.width / 2);
                        if (bound.max.y - bound.min.y > Crafty.viewport.height) {
                            if (Crafty.viewport.y < (-bound.max.y + Crafty.viewport.height) / this._scale) Crafty.viewport.y = (-bound.max.y + Crafty.viewport.height) / this._scale;
                            else if (Crafty.viewport.y > -bound.min.y) Crafty.viewport.y = -bound.min.y;
                        } else Crafty.viewport.y = -1 * (bound.min.y + (bound.max.y - bound.min.y) / 2 - Crafty.viewport.height / 2);
                    },
                    /**@
         * #Crafty.viewport.init
         * @comp Crafty.stage
         * @kind Method
         *
         * @sign public void Crafty.viewport.init([Number width, Number height][, String stage_elem])
         * @sign public void Crafty.viewport.init([Number width, Number height][, HTMLElement stage_elem])
         * @param Number width - Width of the viewport
         * @param Number height - Height of the viewport
         * @param String or HTMLElement stage_elem - the element to use as the stage (either its id or the actual element).
         *
         * Initialize the viewport.
         * If the arguments 'width' or 'height' are missing, use `window.innerWidth` and `window.innerHeight` (full screen model).
         * The argument 'stage_elem' is used to specify a stage element other than the default, and can be either a string or an HTMLElement.  If a string is provided, it will look for an element with that id and, if none exists, create a div.  If an HTMLElement is provided, that is used directly.  Omitting this argument is the same as passing an id of 'cr-stage'.
         *
         * Usually you don't have to initialize the viewport by yourself, it's automatically initialized by calling `Crafty.init()`. Multiple `init`s will create redundant stage elements. Use `Crafty.viewport.width`, `Crafty.viewport.height` or `Crafty.viewport.reload` to adjust the current viewport's dimensions.
         *
         * @see Crafty.device, Crafty.domHelper, Crafty.stage, Crafty.viewport.reload
         */ init: function(w, h, stage_elem) {
                        // Handle specifying stage_elem without w & h
                        if (typeof stage_elem === "undefined" && typeof h === "undefined" && typeof w !== "undefined" && typeof w !== "number") {
                            stage_elem = w;
                            w = window.innerWidth;
                            h = window.innerHeight;
                        }
                        // Define default graphics layers with default z-layers
                        Crafty.createLayer("DefaultCanvasLayer", "Canvas", {
                            z: 20
                        });
                        Crafty.createLayer("DefaultDOMLayer", "DOM", {
                            z: 30
                        });
                        Crafty.createLayer("DefaultWebGLLayer", "WebGL", {
                            z: 10
                        });
                        // setters+getters for the viewport
                        this._defineViewportProperties();
                        // Set initial values -- necessary on restart
                        this._x = 0;
                        this._y = 0;
                        this._scale = 1;
                        this.bounds = null;
                        // If no width or height is defined, the width and height is set to fullscreen
                        this._width = w || window.innerWidth;
                        this._height = h || window.innerHeight;
                        //check if stage exists
                        if (typeof stage_elem === "undefined") stage_elem = "cr-stage";
                        var crstage;
                        if (typeof stage_elem === "string") crstage = document1.getElementById(stage_elem);
                        else if (typeof HTMLElement !== "undefined" ? stage_elem instanceof HTMLElement : stage_elem instanceof Element) crstage = stage_elem;
                        else throw new TypeError("stage_elem must be a string or an HTMLElement");
                        /**@
             * #Crafty.stage
             * @category Core
             * @kind CoreObject
             *
             * The stage where all the DOM entities will be placed.
             */ /**@
             * #Crafty.stage.elem
             * @comp Crafty.stage
             * @kind Property
             *
             * The `#cr-stage` div element.
             */ //create stage div to contain everything
                        Crafty.stage = {
                            x: 0,
                            y: 0,
                            fullscreen: false,
                            elem: crstage ? crstage : document1.createElement("div")
                        };
                        //fullscreen, stop scrollbars
                        if (!w && !h) {
                            document1.body.style.overflow = "hidden";
                            Crafty.stage.fullscreen = true;
                        }
                        Crafty.addEvent(this, window, "resize", Crafty.viewport.reload);
                        Crafty.addEvent(this, window, "blur", function() {
                            if (Crafty.settings.get("autoPause")) {
                                if (!Crafty._paused) Crafty.pause();
                            }
                        });
                        Crafty.addEvent(this, window, "focus", function() {
                            if (Crafty._paused && Crafty.settings.get("autoPause")) Crafty.pause();
                        });
                        //make the stage unselectable
                        Crafty.settings.register("stageSelectable", function(v) {
                            Crafty.stage.elem.onselectstart = v ? function() {
                                return true;
                            } : function() {
                                return false;
                            };
                        });
                        Crafty.settings.modify("stageSelectable", false);
                        //make the stage have no context menu
                        Crafty.settings.register("stageContextMenu", function(v) {
                            Crafty.stage.elem.oncontextmenu = v ? function() {
                                return true;
                            } : function() {
                                return false;
                            };
                        });
                        Crafty.settings.modify("stageContextMenu", false);
                        Crafty.settings.register("autoPause", function() {});
                        Crafty.settings.modify("autoPause", false);
                        //add to the body and give it an ID if not exists
                        if (!crstage) {
                            document1.body.appendChild(Crafty.stage.elem);
                            Crafty.stage.elem.id = stage_elem;
                        }
                        var elem = Crafty.stage.elem.style, offset;
                        //css style
                        elem.width = this.width + "px";
                        elem.height = this.height + "px";
                        elem.overflow = "hidden";
                        // resize events
                        Crafty.bind("ViewportResize", function() {
                            Crafty.trigger("InvalidateViewport");
                        });
                        if (Crafty.mobile) {
                            // remove default gray highlighting after touch
                            elem.webkitTapHighlightColor;
                            elem.webkitTapHighlightColor = "rgba(0,0,0,0)";
                            var meta = document1.createElement("meta"), head = document1.getElementsByTagName("head")[0];
                            //hide the address bar
                            meta = document1.createElement("meta");
                            meta.setAttribute("name", "apple-mobile-web-app-capable");
                            meta.setAttribute("content", "yes");
                            head.appendChild(meta);
                            Crafty.addEvent(this, Crafty.stage.elem, "touchmove", function(e) {
                                e.preventDefault();
                            });
                        }
                        elem.position = "relative";
                        //find out the offset position of the stage
                        offset = Crafty.domHelper.innerPosition(Crafty.stage.elem);
                        Crafty.stage.x = offset.x;
                        Crafty.stage.y = offset.y;
                        Crafty.uniqueBind("ViewportResize", this._resize);
                    },
                    _resize: function() {
                        Crafty.stage.elem.style.width = Crafty.viewport.width + "px";
                        Crafty.stage.elem.style.height = Crafty.viewport.height + "px";
                    },
                    // Create setters/getters for x, y, width, height
                    _defineViewportProperties: function() {
                        Object.defineProperty(this, "x", {
                            set: function(v) {
                                this.scroll("_x", v);
                            },
                            get: function() {
                                return this._x;
                            },
                            configurable: true
                        });
                        Object.defineProperty(this, "y", {
                            set: function(v) {
                                this.scroll("_y", v);
                            },
                            get: function() {
                                return this._y;
                            },
                            configurable: true
                        });
                        Object.defineProperty(this, "width", {
                            set: function(v) {
                                this._width = v;
                                Crafty.trigger("ViewportResize");
                            },
                            get: function() {
                                return this._width;
                            },
                            configurable: true
                        });
                        Object.defineProperty(this, "height", {
                            set: function(v) {
                                this._height = v;
                                Crafty.trigger("ViewportResize");
                            },
                            get: function() {
                                return this._height;
                            },
                            configurable: true
                        });
                    },
                    /**@
         * #Crafty.viewport.reload
         * @comp Crafty.stage
         * @kind Method
         *
         * @sign public Crafty.viewport.reload()
         *
         * Recalculate and reload stage width, height and position.
         * Useful when browser return wrong results on init (like safari on Ipad2).
         * You should also call this method if you insert custom DOM elements that affect Crafty's stage offset.
         *
         */ reload: function() {
                        var w = window.innerWidth, h = window.innerHeight, offset;
                        if (Crafty.stage.fullscreen) {
                            this._width = w;
                            this._height = h;
                            Crafty.trigger("ViewportResize");
                        }
                        offset = Crafty.domHelper.innerPosition(Crafty.stage.elem);
                        Crafty.stage.x = offset.x;
                        Crafty.stage.y = offset.y;
                    },
                    /**@
         * #Crafty.viewport.reset
         * @comp Crafty.stage
         * @kind Method
         *
         * @trigger StopCamera - called to cancel camera animations
         *
         * @sign public Crafty.viewport.reset()
         *
         * Resets the viewport to starting values, and cancels any existing camera animations.
         * Called when scene() is run.
         */ reset: function() {
                        Crafty.viewport.mouselook(false);
                        Crafty.trigger("StopCamera");
                        // Reset viewport position and scale
                        Crafty.viewport.scroll("_x", 0);
                        Crafty.viewport.scroll("_y", 0);
                        Crafty.viewport.scale(1);
                    },
                    /**@
         * #Crafty.viewport.onScreen
         * @comp Crafty.viewport
         * @kind Method
         *
         * @sign public Crafty.viewport.onScreen(Object rect)
         * @param rect - A rectangle with field {_x: x_val, _y: y_val, _w: w_val, _h: h_val}
         *
         * Test if a rectangle is completely in viewport
         */ onScreen: function(rect) {
                        return Crafty.viewport._x + rect._x + rect._w > 0 && Crafty.viewport._y + rect._y + rect._h > 0 && Crafty.viewport._x + rect._x < Crafty.viewport.width && Crafty.viewport._y + rect._y < Crafty.viewport.height;
                    }
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    42: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js"), document1 = window.document;
            // Object for abstracting out all the gl calls to handle rendering entities with a particular program
            function RenderProgramWrapper(layer, shader) {
                this.shader = shader;
                this.layer = layer;
                this.context = layer.context;
                this.draw = function() {};
                this.array_size = 16;
                this.max_size = 1024;
                this._indexArray = new Uint16Array(6 * this.array_size);
                this._indexBuffer = layer.context.createBuffer();
            }
            RenderProgramWrapper.prototype = {
                // Takes an array of attributes; see WebGLLayer's getProgramWrapper method
                initAttributes: function(attributes) {
                    this.attributes = attributes;
                    this._attribute_table = {};
                    var offset = 0;
                    for(var i = 0; i < attributes.length; i++){
                        var a = attributes[i];
                        this._attribute_table[a.name] = a;
                        a.bytes = a.bytes || Float32Array.BYTES_PER_ELEMENT;
                        a.type = a.type || this.context.FLOAT;
                        a.offset = offset;
                        a.location = this.context.getAttribLocation(this.shader, a.name);
                        this.context.enableVertexAttribArray(a.location);
                        offset += a.width;
                    }
                    // Stride is the full width including the last set
                    this.stride = offset;
                    // Create attribute array of correct size to hold max elements
                    this._attributeArray = new Float32Array(this.array_size * 4 * this.stride);
                    this._attributeBuffer = this.context.createBuffer();
                    this._registryHoles = [];
                    this._registrySize = 0;
                },
                // increase the size of the typed arrays
                // does so by creating a new array of that size and copying the existing one into it
                growArrays: function(size) {
                    if (this.array_size >= this.max_size) return;
                    var newsize = Math.min(size, this.max_size);
                    var newAttributeArray = new Float32Array(newsize * 4 * this.stride);
                    var newIndexArray = new Uint16Array(6 * newsize);
                    newAttributeArray.set(this._attributeArray);
                    newIndexArray.set(this._indexArray);
                    this._attributeArray = newAttributeArray;
                    this._indexArray = newIndexArray;
                    this.array_size = newsize;
                },
                // Add an entity that needs to be rendered by this program
                // Needs to be assigned an index in the buffer
                registerEntity: function(e) {
                    if (this._registryHoles.length === 0) {
                        if (this._registrySize >= this.max_size) throw "Number of entities exceeds maximum limit.";
                        else if (this._registrySize >= this.array_size) this.growArrays(2 * this.array_size);
                        e._glBufferIndex = this._registrySize;
                        this._registrySize++;
                    } else e._glBufferIndex = this._registryHoles.pop();
                },
                // remove an entity; allow its buffer index to be reused
                unregisterEntity: function(e) {
                    if (typeof e._glBufferIndex === "number") this._registryHoles.push(e._glBufferIndex);
                    e._glBufferIndex = null;
                },
                resetRegistry: function() {
                    this._maxElement = 0;
                    this._registryHoles.length = 0;
                },
                setCurrentEntity: function(ent) {
                    // offset is 4 * buffer index, because each entity has 4 vertices
                    this.ent_offset = ent._glBufferIndex * 4;
                    this.ent = ent;
                },
                // Called before a batch of entities is prepped for rendering
                switchTo: function() {
                    var gl = this.context;
                    gl.useProgram(this.shader);
                    gl.bindBuffer(gl.ARRAY_BUFFER, this._attributeBuffer);
                    var a, attributes = this.attributes;
                    // Process every attribute
                    for(var i = 0; i < attributes.length; i++){
                        a = attributes[i];
                        gl.vertexAttribPointer(a.location, a.width, a.type, false, this.stride * a.bytes, a.offset * a.bytes);
                    }
                    // For now, special case the need for texture objects
                    var t = this.texture_obj;
                    if (t && t.unit === null) this.layer.texture_manager.bindTexture(t);
                    this.index_pointer = 0;
                },
                // Sets a texture
                setTexture: function(texture_obj) {
                    // Only needs to be done once
                    if (this.texture_obj !== undefined) return;
                    // Set the texture buffer to use
                    texture_obj.setToProgram(this.shader, "uSampler", "uTextureDimensions");
                    this.texture_obj = texture_obj;
                },
                // adds a set of 6 indices to the index array
                // Corresponds to 2 triangles that make up a rectangle
                addIndices: function(offset) {
                    var index = this._indexArray, l = this.index_pointer;
                    index[0 + l] = 0 + offset;
                    index[1 + l] = 1 + offset;
                    index[2 + l] = 2 + offset;
                    index[3 + l] = 1 + offset;
                    index[4 + l] = 2 + offset;
                    index[5 + l] = 3 + offset;
                    this.index_pointer += 6;
                },
                // Writes data from the attribute and index arrays to the appropriate buffers, and then calls drawElements.
                renderBatch: function() {
                    var gl = this.context;
                    gl.bindBuffer(gl.ARRAY_BUFFER, this._attributeBuffer);
                    gl.bufferData(gl.ARRAY_BUFFER, this._attributeArray, gl.STATIC_DRAW);
                    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._indexBuffer);
                    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this._indexArray, gl.STATIC_DRAW);
                    gl.drawElements(gl.TRIANGLES, this.index_pointer, gl.UNSIGNED_SHORT, 0);
                },
                setViewportUniforms: function(viewport, cameraOptions) {
                    var gl = this.context;
                    gl.useProgram(this.shader);
                    gl.uniform4f(this.shader.viewport, -viewport._x, -viewport._y, viewport._w, viewport._h);
                },
                // Fill in the attribute with the given arguments, cycling through the data if necessary
                // If the arguments provided match the width of the attribute, that means it'll fill the same values for each of the four vertices.
                // TODO determine if this abstraction is a performance hit!
                writeVector: function(name, x, y) {
                    var a = this._attribute_table[name];
                    var stride = this.stride, offset = a.offset + this.ent_offset * stride, w = a.width;
                    var l = arguments.length - 1;
                    var data = this._attributeArray;
                    for(var r = 0; r < 4; r++)for(var c = 0; c < w; c++)data[offset + stride * r + c] = arguments[(w * r + c) % l + 1];
                }
            };
            /**@
 * #WebGLLayer
 * @category Graphics
 * @kind System
 *
 * A collection of methods to handle webgl contexts.
 */ Crafty._registerLayerTemplate("WebGL", {
                type: "WebGL",
                /**@
     * #.context
     * @comp WebGLLayer
     * @kind Property
     *
     * This will return the context of the webgl canvas element.
     */ context: null,
                // Create a vertex or fragment shader, given the source and type
                _compileShader: function(src, type) {
                    var gl = this.context;
                    var shader = gl.createShader(type);
                    gl.shaderSource(shader, src);
                    gl.compileShader(shader);
                    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw gl.getShaderInfoLog(shader);
                    return shader;
                },
                // Create and return a complete, linked shader program, given the source for the fragment and vertex shaders.
                // Will compile the two shaders and then link them together
                _makeProgram: function(shader) {
                    var gl = this.context;
                    var fragmentShader = this._compileShader(shader.fragmentCode, gl.FRAGMENT_SHADER);
                    var vertexShader = this._compileShader(shader.vertexCode, gl.VERTEX_SHADER);
                    var shaderProgram = gl.createProgram();
                    gl.attachShader(shaderProgram, vertexShader);
                    gl.attachShader(shaderProgram, fragmentShader);
                    gl.linkProgram(shaderProgram);
                    if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) throw "Could not initialise shaders";
                    shaderProgram.viewport = gl.getUniformLocation(shaderProgram, "uViewport");
                    return shaderProgram;
                },
                // Will create and return a RenderProgramWrapper for a shader program.
                // name is a unique id, attributes an array of attribute names with their metadata.
                // Each attribute needs at least a `name`  and `width` property:
                // ~~~
                //   [
                //      {name:"aPosition", width: 2},
                //      {name:"aOrientation", width: 3},
                //      {name:"aLayer", width:2},
                //      {name:"aColor",  width: 4}
                //   ]
                // ~~~
                // The "aPositon", "aOrientation", and "aLayer" attributes should be the same for any webgl entity,
                // since they support the basic 2D properties
                getProgramWrapper: function(name, shader) {
                    if (this.programs[name] === undefined) {
                        var compiledShader = this._makeProgram(shader);
                        var program = new RenderProgramWrapper(this, compiledShader);
                        program.name = name;
                        program.initAttributes(shader.attributeList);
                        program.draw = shader.drawCallback;
                        program.setViewportUniforms(this._viewportRect(), this.options);
                        this.programs[name] = program;
                    }
                    return this.programs[name];
                },
                // Make a texture out of the given image element
                // The url is just used as a unique ID
                makeTexture: function(url, image, repeating) {
                    return this.texture_manager.makeTexture(url, image, repeating);
                },
                events: {
                    // Respond to init & remove events
                    LayerInit: "layerInit",
                    LayerRemove: "layerRemove",
                    // Bind scene rendering (see drawing.js)
                    RenderScene: "_render",
                    // Listen for pixelart changes
                    PixelartSet: "_setPixelart",
                    // Handle viewport modifications
                    ViewportResize: "_resize"
                },
                layerInit: function() {
                    //check if we support webgl is supported
                    if (!Crafty.support.webgl) {
                        Crafty.trigger("NoWebGL");
                        Crafty.stop();
                        return;
                    }
                    // Avoid shared state between systems
                    this.programs = {};
                    //create an empty canvas element
                    var c;
                    c = document1.createElement("canvas");
                    c.width = Crafty.viewport.width;
                    c.height = Crafty.viewport.height;
                    c.style.position = "absolute";
                    c.style.left = "0px";
                    c.style.top = "0px";
                    c.style.zIndex = this.options.z;
                    Crafty.stage.elem.appendChild(c);
                    // Try to get a webgl context
                    var gl;
                    try {
                        gl = c.getContext("webgl", {
                            premultipliedalpha: true
                        }) || c.getContext("experimental-webgl", {
                            premultipliedalpha: true
                        });
                        gl.viewportWidth = c.width;
                        gl.viewportHeight = c.height;
                    } catch (e) {
                        Crafty.trigger("NoWebGL");
                        Crafty.stop();
                        return;
                    }
                    // assign to this renderer
                    this.context = gl;
                    this._canvas = c;
                    gl.clearColor(0.0, 0.0, 0.0, 0.0);
                    // These commands allow partial transparency, but require drawing in z-order
                    gl.disable(gl.DEPTH_TEST);
                    // This particular blend function requires the shader programs to output pre-multiplied alpha
                    // This is necessary to match the blending of canvas/dom entities against the background color
                    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                    gl.enable(gl.BLEND);
                    this.texture_manager = new Crafty.TextureManager(gl, this);
                    this._dirtyViewport = true;
                },
                // Cleanup the DOM when the system is destroyed
                layerRemove: function() {
                    this._canvas.parentNode.removeChild(this._canvas);
                },
                // Called when the viewport resizes
                _resize: function() {
                    var c = this._canvas;
                    c.width = Crafty.viewport.width;
                    c.height = Crafty.viewport.height;
                    var gl = this.context;
                    gl.viewportWidth = c.width;
                    gl.viewportHeight = c.height;
                },
                // TODO consider shifting to texturemanager
                _setPixelart: function(enabled) {
                    var gl = this.context;
                    if (enabled) this.texture_filter = gl.NEAREST;
                    else this.texture_filter = gl.LINEAR;
                },
                // Hold an array ref to avoid garbage
                visible_gl: [],
                // Render any entities associated with this context; called in response to a draw event
                _render: function(rect) {
                    rect = rect || this._viewportRect();
                    var gl = this.context;
                    // Set viewport and clear it
                    gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
                    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
                    //Set the viewport uniform variables used by each registered program
                    var programs = this.programs;
                    if (this._dirtyViewport) {
                        var view = this._viewportRect();
                        for(var comp in programs)programs[comp].setViewportUniforms(view, this.options);
                        this._dirtyViewport = false;
                    }
                    // Search for any entities in the given area (viewport unless otherwise specified)
                    var q = Crafty.map.search(rect), i = 0, l = q.length, current;
                    //From all potential candidates, build a list of visible entities, then sort by zorder
                    var visible_gl = this.visible_gl;
                    visible_gl.length = 0;
                    for(i = 0; i < l; i++){
                        current = q[i];
                        if (current._visible && current.program && current._drawLayer === this) visible_gl.push(current);
                    }
                    visible_gl.sort(this._sort);
                    l = visible_gl.length;
                    // Now iterate through the z-sorted entities to be rendered
                    // Each entity writes it's data into a typed array
                    // The entities are rendered in batches, where the entire array is copied to a buffer in one operation
                    // A batch is rendered whenever the next element needs to use a different type of program
                    // Therefore, you get better performance by grouping programs by z-order if possible.
                    // (Each sprite sheet will use a different program, but multiple sprites on the same sheet can be rendered in one batch)
                    var shaderProgram = null;
                    for(i = 0; i < l; i++){
                        current = visible_gl[i];
                        if (shaderProgram !== current.program) {
                            if (shaderProgram !== null) shaderProgram.renderBatch();
                            shaderProgram = current.program;
                            shaderProgram.index_pointer = 0;
                            shaderProgram.switchTo();
                        }
                        current.draw();
                        current._changed = false;
                    }
                    if (shaderProgram !== null) shaderProgram.renderBatch();
                },
                /**@
     * #.dirty
     * @comp WebGLLayer
     * @kind Method
     * @private
     *
     * @sign public .dirty(ent)
     * @param ent - The entity to mark as dirty
     *
     * Add an entity to the list of DOM object to draw
     */ dirty: function dirty(ent) {
                // WebGL doens't need to do any special tracking of changed objects
                },
                /**@
     * #.attach
     * @comp WebGLLayer
     * @kind Method
     * @private
     *
     * @sign public .attach(ent)
     * @param ent - The entity to add
     *
     * Add an entity to the layer
     */ attach: function attach(ent) {
                    // WebGL entities really need to be added to a specific program, which is handled in the LayerAttached event by components
                    ent._drawContext = this.context;
                },
                /**@
     * #.detach
     * @comp WebGLLayer
     * @kind Method
     * @private
     *
     * @sign public .detach(ent)
     * @param ent - The entity to remove
     *
     * Removes an entity from the layer
     */ detach: function detach(ent) {
                    // This could, like attach, be handled by components
                    // We instead handle it in a central place for now
                    if (ent.program) ent.program.unregisterEntity(ent);
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    43: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #WebGL
 * @category Graphics
 * @kind Component
 *
 * @trigger Draw - when the entity is ready to be drawn to the stage - {type: "canvas", pos, co, ctx}
 * @trigger NoCanvas - if the browser does not support canvas
 *
 * When this component is added to an entity it will be drawn to the global webgl canvas element. Its canvas element (and hence any WebGL entity) is always rendered below any DOM entities.
 *
 * Sprite, Image, SpriteAnimation, and Color all support WebGL rendering.  Text entities will need to use DOM or Canvas for now.
 *
 * If a webgl context does not yet exist, a WebGL entity will automatically create one.
 *
 * @note For better performance, minimize the number of spritesheets used, and try to arrange it so that entities with different spritesheets are on different z-levels.  This is because entities are rendered in z order, and only entities sharing the same texture can be efficiently batched.
 *
 * Create a webgl entity like this
 * ~~~
 * var myEntity = Crafty.e("2D, WebGL, Color")
 *      .color(1, 1, 0, 0.5)
 *      .attr({x: 13, y: 37, w: 42, h: 42});
 *~~~
 */ Crafty.extend({
                /**@
     * #Crafty.WebGLShader
     * @category Graphics
     * @kind Method
     *
     * @sign public Crafty.WebGLShader Crafty.WebGLShader(String vertexShaderCode, String fragmentShaderCode, Array attributeList, Function drawCallback(e, entity))
     * @param vertexShaderCode - GLSL code for the vertex shader
     * @param fragmentShaderCode - GLSL code for the fragment shader
     * @param attributeList - List of variable names with their vertex length
     * @param drawCallback - Function that pushes all attribute values to WebGL.
     *
     * Assigns or fetches a default shader for a component.
     *
     * This allows the default shader for a component to be overridden, and therefor allows
     * developers to override the default shader behaviour with more complex shaders.
     *
     * @example
     * Let's say we want to extend sprite to draw the images in grayscale when we
     * set a `grayscale: true` attribute.
     * ~~~
     * var recoloredSprite = new Crafty.WebGLShader(
     *   // The vertex shader
     *   "attribute vec2 aPosition;\n" +
     *   "attribute vec3 aOrientation;\n" +
     *   "attribute vec2 aLayer;\n" +
     *   "attribute vec2 aTextureCoord;\n" +
     *   "attribute vec2 aGrayscale;\n" + // Addition of our grayscale
     *   "varying mediump vec3 vTextureCoord;\n" +
     *   "varying mediump vec2 vGrayscale;\n" + // passing attribute to fragment shader
     *   "uniform vec4 uViewport;\n" +
     *   "uniform mediump vec2 uTextureDimensions;\n" +
     *   "mat4 viewportScale = mat4(2.0 / uViewport.z, 0, 0, 0,    0, -2.0 / uViewport.w, 0,0,    0, 0,1,0,    -1,+1,0,1);\n" +
     *   "vec4 viewportTranslation = vec4(uViewport.xy, 0, 0);\n" +
     *   "void main() {\n" +
     *   "  vec2 pos = aPosition;\n" +
     *   "  vec2 entityOrigin = aOrientation.xy;\n" +
     *   "  mat2 entityRotationMatrix = mat2(cos(aOrientation.z), sin(aOrientation.z), -sin(aOrientation.z), cos(aOrientation.z));\n" +
     *   "  pos = entityRotationMatrix * (pos - entityOrigin) + entityOrigin ;\n" +
     *   "  gl_Position = viewportScale * (viewportTranslation + vec4(pos, 1.0/(1.0+exp(aLayer.x) ), 1) );\n" +
     *   "  vTextureCoord = vec3(aTextureCoord, aLayer.y);\n" +
     *   "  vGrayscale = aGrayscale;\n" + // Assigning the grayscale for fragment shader
     *   "}",
     *   // The fragment shader
     *   "precision mediump float;\n" +
     *   "varying mediump vec3 vTextureCoord;\n" +
     *   "varying mediump vec2 vGrayscale;\n" +
     *   "uniform sampler2D uSampler;\n " +
     *   "uniform mediump vec2 uTextureDimensions;\n" +
     *   "void main() {\n" +
     *   "  highp vec2 coord =   vTextureCoord.xy / uTextureDimensions;\n" +
     *   "  mediump vec4 base_color = texture2D(uSampler, coord);\n" +
     *   "  if (vGrayscale.x == 1.0) {\n" +
     *   "    mediump float lightness = (0.2126*base_color.r + 0.7152*base_color.g + 0.0722*base_color.b);\n" +
     *   "    lightness *= base_color.a * vTextureCoord.z; // Premultiply alpha\n" +
     *   "    gl_FragColor = vec4(lightness, lightness, lightness, base_color.a*vTextureCoord.z);\n" +
     *   "  } else {\n" +
     *   "    gl_FragColor = vec4(base_color.rgb*base_color.a*vTextureCoord.z, base_color.a*vTextureCoord.z);\n" +
     *   "  }\n" +
     *   "}",
     *   [
     *     { name: "aPosition",     width: 2 },
     *     { name: "aOrientation",  width: 3 },
     *     { name: "aLayer",        width: 2 },
     *     { name: "aTextureCoord", width: 2 },
     *     { name: "aGrayscale",    width: 2 }
     *   ],
     *   function(e, entity) {
     *     var co = e.co;
     *     // Write texture coordinates
     *     e.program.writeVector("aTextureCoord",
     *       co.x, co.y,
     *       co.x, co.y + co.h,
     *       co.x + co.w, co.y,
     *       co.x + co.w, co.y + co.h
     *     );
     *     // Write our grayscale attribute
     *     e.program.writeVector("aGrayscale",
     *       entity.grayscale ? 1.0 : 0.0,
     *       0.0
     *     );
     *   }
     * );
     * ~~~
     *
     * It seems like a lot of work, but most of the above code is the default Crafty shader code.
     * When you get the hang of it, it is really easy to extend for your own effects. And remember
     * you only need to write it once, and suddenly all sprite entities have extra effects available.
     *
     * @see Crafty.defaultShader
     * @see Sprite
     * @see Image
     * @see Color
     * @see WebGL
     */ WebGLShader: function(vertexCode, fragmentCode, attributeList, drawCallback) {
                    this.vertexCode = vertexCode;
                    this.fragmentCode = fragmentCode;
                    this.attributeList = attributeList;
                    this.drawCallback = drawCallback;
                },
                /**@
     * #Crafty.defaultShader
     * @category Graphics
     * @kind Method
     *
     * @sign public Crafty.WebGLShader Crafty.defaultShader(String component[, Crafty.WebGLShader shader])
     * @param component - Name of the component to assign a default shader to
     * @param shader - New default shader to assign to a component
     *
     * Assigns or fetches a default shader for a component.
     *
     * This allows the default shader for a component to be overridden, and therefor allows
     * developers to override the default shader behaviour with more complex shaders.
     *
     * @example
     * Let's say we want to set the grayscale enabled shader from the example of the WebGLShader
     * as default for sprites:
     * ~~~
     * Crafty.defaultShader("Sprite", recoloredSprite);
     * ~~~
     *
     * @see Crafty.WebGLShader
     * @see Sprite
     * @see Image
     * @see Color
     * @see WebGL
     */ defaultShader: function(component, shader) {
                    this._defaultShaders = this._defaultShaders || {};
                    if (arguments.length === 1) return this._defaultShaders[component];
                    this._defaultShaders[component] = shader;
                }
            });
            Crafty.c("WebGL", {
                /**@
     * #.context
     * @comp WebGL
     * @kind Property
     *
     * The webgl context this entity will be rendered to.
     */ init: function() {
                    this.requires("Renderable");
                    // Attach to webgl layer
                    if (!this._customLayer) this._attachToLayer(Crafty.s("DefaultWebGLLayer"));
                },
                remove: function() {
                    this._detachFromLayer();
                },
                // Cache the various objects and arrays used in draw
                drawVars: {
                    type: "webgl",
                    pos: {},
                    ctx: null,
                    coord: [
                        0,
                        0,
                        0,
                        0
                    ],
                    co: {
                        x: 0,
                        y: 0,
                        w: 0,
                        h: 0
                    }
                },
                /**@
     * #.draw
     * @comp WebGL
     * @kind Method
     * @private
     *
     * @sign public this .draw()
     *
     * An internal method to draw the entity on the webgl canvas element. Rather then rendering directly, it writes relevent information into a buffer to allow batch rendering.
     */ draw: function() {
                    if (!this.ready) return;
                    var pos = this.drawVars.pos;
                    pos._x = this._x;
                    pos._y = this._y;
                    pos._w = this._w;
                    pos._h = this._h;
                    var coord = this.__coord || [
                        0,
                        0,
                        0,
                        0
                    ];
                    var co = this.drawVars.co;
                    co.x = coord[0];
                    co.y = coord[1];
                    co.w = coord[2];
                    co.h = coord[3];
                    // Handle flipX, flipY
                    // (Just swap the positions of e.g. x and x+w)
                    if (this._flipX) {
                        co.x = co.x + co.w;
                        co.w = -co.w;
                    }
                    if (this._flipY) {
                        co.y = co.y + co.h;
                        co.h = -co.h;
                    }
                    //Draw entity
                    var gl = this._drawContext;
                    this.drawVars.gl = gl;
                    var prog = this.drawVars.program = this.program;
                    // The program might need to refer to the current element's index
                    prog.setCurrentEntity(this);
                    // Write position; x, y, w, h
                    prog.writeVector("aPosition", this._x, this._y, this._x, this._y + this._h, this._x + this._w, this._y, this._x + this._w, this._y + this._h);
                    // Write orientation
                    prog.writeVector("aOrientation", this._origin.x + this._x, this._origin.y + this._y, this._rotation * Math.PI / 180);
                    // Write z, alpha
                    prog.writeVector("aLayer", this._globalZ, this._alpha);
                    // This should only need to handle *specific* attributes!
                    this.trigger("Draw", this.drawVars);
                    // Register the vertex groups to be drawn, referring to this entities position in the big buffer
                    prog.addIndices(prog.ent_offset);
                    return this;
                },
                // v_src is optional, there's a default vertex shader that works for regular rectangular entities
                _establishShader: function(compName, shader) {
                    this.program = this._drawLayer.getProgramWrapper(compName, shader);
                    // Needs to know where in the big array we are!
                    this.program.registerEntity(this);
                    // Shader program means ready
                    this.ready = true;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    44: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            Crafty.extend({
                /**@
     * #Crafty.device
     * @category Misc
     * @kind Property
     *
     * Methods relating to devices such as tablets or phones
     */ device: {
                    _deviceOrientationCallback: false,
                    _deviceMotionCallback: false,
                    /**
         * The HTML5 DeviceOrientation event returns three pieces of data:
         *  * alpha the direction the device is facing according to the compass
         *  * beta the angle in degrees the device is tilted front-to-back
         *  * gamma the angle in degrees the device is tilted left-to-right.
         *  * The angles values increase as you tilt the device to the right or towards you.
         *
         * Since Firefox uses the MozOrientationEvent which returns similar data but
         * using different parameters and a different measurement system, we want to
         * normalize that before we pass it to our _deviceOrientationCallback function.
         *
         * @param eventData HTML5 DeviceOrientation event
         */ _normalizeDeviceOrientation: function(eventData) {
                        var data;
                        if (window.DeviceOrientationEvent) data = {
                            // gamma is the left-to-right tilt in degrees, where right is positive
                            tiltLR: eventData.gamma,
                            // beta is the front-to-back tilt in degrees, where front is positive
                            tiltFB: eventData.beta,
                            // alpha is the compass direction the device is facing in degrees
                            dir: eventData.alpha,
                            // deviceorientation does not provide this data
                            motUD: null
                        };
                        else if (window.OrientationEvent) data = {
                            // x is the left-to-right tilt from -1 to +1, so we need to convert to degrees
                            tiltLR: eventData.x * 90,
                            // y is the front-to-back tilt from -1 to +1, so we need to convert to degrees
                            // We also need to invert the value so tilting the device towards us (forward)
                            // results in a positive value.
                            tiltFB: eventData.y * -90,
                            // MozOrientation does not provide this data
                            dir: null,
                            // z is the vertical acceleration of the device
                            motUD: eventData.z
                        };
                        Crafty.device._deviceOrientationCallback(data);
                    },
                    /**
         * @param eventData HTML5 DeviceMotion event
         */ _normalizeDeviceMotion: function(eventData) {
                        var acceleration = eventData.accelerationIncludingGravity, facingUp = acceleration.z > 0 ? 1 : -1;
                        var data = {
                            // Grab the acceleration including gravity from the results
                            acceleration: acceleration,
                            rawAcceleration: "[" + Math.round(acceleration.x) + ", " + Math.round(acceleration.y) + ", " + Math.round(acceleration.z) + "]",
                            // Z is the acceleration in the Z axis, and if the device is facing up or down
                            facingUp: facingUp,
                            // Convert the value from acceleration to degrees acceleration.x|y is the
                            // acceleration according to gravity, we'll assume we're on Earth and divide
                            // by 9.81 (earth gravity) to get a percentage value, and then multiply that
                            // by 90 to convert to degrees.
                            tiltLR: Math.round(acceleration.x / 9.81 * -90),
                            tiltFB: Math.round((acceleration.y + 9.81) / 9.81 * 90 * facingUp)
                        };
                        Crafty.device._deviceMotionCallback(data);
                    },
                    /**@
         * #Crafty.device.deviceOrientation
         * @comp Crafty.device
         * @kind Method
         *
         * @sign public Crafty.device.deviceOrientation(Function callback)
         * @param callback - Callback method executed once as soon as device orientation is change
         *
         * Do something with normalized device orientation data:
         * ~~~
         * {
         *   tiltLR    :   'gamma -- the angle in degrees the device is tilted left-to-right.',
         *   tiltFB    :   'beta -- the angle in degrees the device is tilted front-to-back',
         *   dir       :   'alpha -- the direction the device is facing according to the compass',
         *   motUD     :   'The angle's values increase as you tilt the device to the right or towards you.'
         * }
         * ~~~
         *
         * @example
         * ~~~
         * // Get DeviceOrientation event normalized data.
         * Crafty.device.deviceOrientation(function(data){
         *     Crafty.log('data.tiltLR : '+Math.round(data.tiltLR)+', data.tiltFB : '+Math.round(data.tiltFB)+', data.dir : '+Math.round(data.dir)+', data.motUD : '+data.motUD+'');
         * });
         * ~~~
         *
         * See browser support at http://caniuse.com/#search=device orientation.
         */ deviceOrientation: function(func) {
                        this._deviceOrientationCallback = func;
                        if (Crafty.support.deviceorientation) {
                            if (window.DeviceOrientationEvent) // Listen for the deviceorientation event and handle DeviceOrientationEvent object
                            Crafty.addEvent(this, window, "deviceorientation", this._normalizeDeviceOrientation);
                            else if (window.OrientationEvent) // Listen for the MozOrientation event and handle OrientationData object
                            Crafty.addEvent(this, window, "MozOrientation", this._normalizeDeviceOrientation);
                        }
                    },
                    /**@
         * #Crafty.device.deviceMotion
         * @comp Crafty.device
         * @kind Method
         *
         * @sign public Crafty.device.deviceMotion(Function callback)
         * @param callback - Callback method executed once as soon as device motion is change
         *
         * Do something with normalized device motion data:
         * ~~~
         * {
         *     acceleration : 'Grab the acceleration including gravity from the results',
         *     rawAcceleration : 'Display the raw acceleration data',
         *     facingUp : 'Z is the acceleration in the Z axis, and if the device is facing up or down',
         *     tiltLR : 'Convert the value from acceleration to degrees. acceleration.x is the acceleration according to gravity, we'll assume we're on Earth and divide by 9.81 (earth gravity) to get a percentage value, and then multiply that by 90 to convert to degrees.',
         *     tiltFB : 'Convert the value from acceleration to degrees.'
         * }
         * ~~~
         *
         * @example
         * ~~~
         * // Get DeviceMotion event normalized data.
         * Crafty.device.deviceMotion(function(data){
         *     Crafty.log('data.moAccel : '+data.rawAcceleration+', data.moCalcTiltLR : '+Math.round(data.tiltLR)+', data.moCalcTiltFB : '+Math.round(data.tiltFB)+'');
         * });
         * ~~~
         *
         * See browser support at http://caniuse.com/#search=motion.
         */ deviceMotion: function(func) {
                        this._deviceMotionCallback = func;
                        if (Crafty.support.devicemotion) {
                            if (window.DeviceMotionEvent) // Listen for the devicemotion event and handle DeviceMotionEvent object
                            Crafty.addEvent(this, window, "devicemotion", this._normalizeDeviceMotion);
                        }
                    }
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    45: [
        function(require1, module, exports) {
            module.exports = {
                _events: {},
                /**@
     * #Crafty.addEvent
     * @category Events, Misc
     * @kind Method
     *
     * @sign public this Crafty.addEvent(Object ctx, HTMLElement obj, String event, Function callback)
     * @param ctx - Context of the callback or the value of `this`
     * @param obj - Element to add the DOM event to
     * @param event - Event name to bind to
     * @param callback - Method to execute when triggered
     *
     * Adds DOM level 3 events to elements. The arguments it accepts are the call
     * context (the value of `this`), the DOM element to attach the event to,
     * the event name (without `on` (`click` rather than `onclick`)) and
     * finally the callback method.
     *
     * If no element is passed, the default element will be `window.document`.
     *
     * Callbacks are passed with event data.
     *
     * @note This is related to DOM events only,  not Crafty's own event system.
     * Of course, you can trigger Crafty events in the callback function!
     *
     * @example
     * Normally you'd use Crafty's built-in mouse component, but for the sake of an example let's pretend that doesn't exist.
     * The following code will add a stage-wide MouseDown event listener to the player, and log both which button was pressed
     * and the (x,y) coordinates in viewport/world/game space.
     * ~~~
     * var player = Crafty.e("2D");
     *     player.onMouseDown = function(e) {
     *         Crafty.log(e.mouseButton, e.realX, e.realY);
     *     };
     * Crafty.addEvent(player, Crafty.stage.elem, "mousedown", player.onMouseDown);
     * ~~~
     * @see Crafty.removeEvent
     */ addEvent: function(ctx, obj, type, callback) {
                    if (arguments.length === 3) {
                        callback = type;
                        type = obj;
                        obj = window.document;
                    }
                    //save anonymous function to be able to remove
                    var id = ctx[0] || "", afn = function(e) {
                        callback.call(ctx, e);
                    };
                    if (!this._events[id + obj + type + callback]) this._events[id + obj + type + callback] = afn;
                    else return;
                    obj.addEventListener(type, afn, false);
                },
                /**@
     * #Crafty.removeEvent
     * @category Events, Misc
     * @kind Method
     *
     * @sign public this Crafty.removeEvent(Object ctx, HTMLElement obj, String event, Function callback)
     * @param ctx - Context of the callback or the value of `this`
     * @param obj - Element the event is on
     * @param event - Name of the event
     * @param callback - Method executed when triggered
     *
     * Removes events attached by `Crafty.addEvent()`. All parameters must
     * be the same that were used to attach the event including a reference
     * to the callback method.
     *
     * @see Crafty.addEvent
     */ removeEvent: function(ctx, obj, type, callback) {
                    if (arguments.length === 3) {
                        callback = type;
                        type = obj;
                        obj = window.document;
                    }
                    //retrieve anonymous function
                    var id = ctx[0] || "", afn = this._events[id + obj + type + callback];
                    if (afn) {
                        obj.removeEventListener(type, afn, false);
                        delete this._events[id + obj + type + callback];
                    }
                }
            };
        },
        {}
    ],
    46: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #KeyboardSystem
 * @category Input
 * @kind System
 *
 * Provides access to key events.
 * @note Events and methods are inherited from the `KeyboardState` component.
 *
 * The event callbacks are triggered with a native [`KeyboardEvent`](https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent)
 * received by `window.document`, which is wrapped in a standard Crafty event object (as described in `KeyboardState`).
 *
 * These key events are triggered globally, thus on the global Crafty instance, every entity and system.
 *
 * @example
 * Move viewport by arrow keys.
 * ~~~
 * Crafty.bind('KeyDown', function(e) {
 *     if (e.key === Crafty.keys.LEFT_ARROW) {
 *         Crafty.viewport.x++;
 *     } else if (e.key === Crafty.keys.RIGHT_ARROW) {
 *         Crafty.viewport.x--;
 *     } else if (e.key === Crafty.keys.UP_ARROW) {
 *         Crafty.viewport.y++;
 *     } else if (e.key === Crafty.keys.DOWN_ARROW) {
 *         Crafty.viewport.y--;
 *     }
 * });
 * ~~~
 * @see KeyboardState, Keyboard
 */ Crafty.s("Keyboard", Crafty.extend.call(Crafty.extend.call(new Crafty.__eventDispatcher(), {
                _evt: {
                    // evt object to reuse
                    eventName: "",
                    key: 0,
                    which: 0,
                    originalEvent: null
                },
                prepareEvent: function(e) {
                    var evt = this._evt;
                    // Normalize event name
                    var type = e.type;
                    evt.eventName = type === "keydown" ? "KeyDown" : type === "keyup" ? "KeyUp" : type;
                    // Normalize key to avoid cross-browser issues
                    evt.which = e.charCode !== null ? e.charCode : e.keyCode;
                    evt.key = e.keyCode || e.which;
                    // wrap original event into standard Crafty event object
                    // as original key event's properties are read-only
                    evt.originalEvent = e;
                    return evt;
                },
                // this method will be called by KeyboardState iff triggerKey event was valid
                triggerKeyEvent: function(eventName, e) {
                    Crafty.trigger(eventName, e);
                },
                dispatchEvent: function(e) {
                    var evt = this.prepareEvent(e);
                    this.triggerKey(evt.eventName, evt);
                }
            }), Crafty.__keyboardStateTemplate), {}, false);
            /**@
 * #Keyboard
 * @category Input
 * @kind Component
 *
 * Provides the entity with keyboard events.
 * Keyboard events get dispatched to all entities that have the Keyboard component.
 * @note If you do not add this component, key events will not be triggered on the entity.
 *
 * Triggers all events described in the `KeyboardState` component, these are:
 * @trigger KeyDown - when a key is pressed - KeyboardEvent
 * @trigger KeyUp - when a key is released - KeyboardEvent
 *
 * @example
 * ~~~
 * Crafty.e("2D, DOM, Color, Keyboard")
 *   .attr({x: 100, y: 100, w: 50, h: 50})
 *   .color("red")
 *   .bind('KeyDown', function(e) {
 *     if (e.key == Crafty.keys.LEFT_ARROW) {
 *       this.x -= 1;
 *     } else if (e.key == Crafty.keys.RIGHT_ARROW) {
 *       this.x += 1;
 *     } else if (e.key == Crafty.keys.UP_ARROW) {
 *       this.y -= 1;
 *     } else if (e.key == Crafty.keys.DOWN_ARROW) {
 *       this.y += 1;
 *     }
 *   });
 * ~~~
 *
 * @see KeyboardState, KeyboardSystem
 */ Crafty.c("Keyboard", {
                // DEPRECATED: remove in an upcoming release
                isDown: function(key) {
                    return Crafty.s("Keyboard").isKeyDown(key);
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    47: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js"), document1 = window.document;
            // figure out which eventName to listen to for mousewheel events
            var mouseWheelEvent = typeof document1.onwheel !== "undefined" ? "wheel" // modern browsers
             : typeof document1.onmousewheel !== "undefined" ? "mousewheel" // old Webkit and IE
             : "DOMMouseScroll"; // old Firefox
            //initialize the input events onload
            Crafty._preBind("Load", function() {
                Crafty.addEvent(this, document1.body, "mouseup", Crafty.detectBlur);
                Crafty.addEvent(Crafty.s("Keyboard"), window, "blur", Crafty.s("Keyboard").resetKeyDown);
                Crafty.addEvent(Crafty.s("Mouse"), window, "mouseup", Crafty.s("Mouse").resetButtonDown);
                Crafty.addEvent(Crafty.s("Touch"), window, "touchend", Crafty.s("Touch").resetTouchPoints);
                Crafty.addEvent(Crafty.s("Touch"), window, "touchcancel", Crafty.s("Touch").resetTouchPoints);
                Crafty.addEvent(Crafty.s("Keyboard"), "keydown", Crafty.s("Keyboard").processEvent);
                Crafty.addEvent(Crafty.s("Keyboard"), "keyup", Crafty.s("Keyboard").processEvent);
                Crafty.addEvent(Crafty.s("Mouse"), Crafty.stage.elem, "mousedown", Crafty.s("Mouse").processEvent);
                Crafty.addEvent(Crafty.s("Mouse"), Crafty.stage.elem, "mouseup", Crafty.s("Mouse").processEvent);
                Crafty.addEvent(Crafty.s("Mouse"), Crafty.stage.elem, "mousemove", Crafty.s("Mouse").processEvent);
                Crafty.addEvent(Crafty.s("Mouse"), Crafty.stage.elem, "click", Crafty.s("Mouse").processEvent);
                Crafty.addEvent(Crafty.s("Mouse"), Crafty.stage.elem, "dblclick", Crafty.s("Mouse").processEvent);
                Crafty.addEvent(this, Crafty.stage.elem, "touchstart", this._touchDispatch);
                Crafty.addEvent(this, Crafty.stage.elem, "touchmove", this._touchDispatch);
                Crafty.addEvent(this, Crafty.stage.elem, "touchend", this._touchDispatch);
                Crafty.addEvent(this, Crafty.stage.elem, "touchcancel", this._touchDispatch);
                Crafty.addEvent(this, Crafty.stage.elem, "touchleave", this._touchDispatch);
                Crafty.addEvent(Crafty.s("MouseWheel"), Crafty.stage.elem, mouseWheelEvent, Crafty.s("MouseWheel").processEvent);
            });
            Crafty.bind("Pause", function() {
                // Reset pressed keys and buttons
                Crafty.s("Keyboard").resetKeyDown();
                Crafty.s("Mouse").resetButtonDown();
            });
            Crafty._preBind("CraftyStop", function() {
                // Reset pressed keys and buttons
                Crafty.s("Keyboard").resetKeyDown();
                Crafty.s("Mouse").resetButtonDown();
            });
            Crafty._preBind("CraftyStop", function() {
                Crafty.removeEvent(this, document1.body, "mouseup", Crafty.detectBlur);
                Crafty.removeEvent(Crafty.s("Keyboard"), window, "blur", Crafty.s("Keyboard").resetKeyDown);
                Crafty.removeEvent(Crafty.s("Mouse"), window, "mouseup", Crafty.s("Mouse").resetButtonDown);
                Crafty.removeEvent(Crafty.s("Touch"), window, "touchend", Crafty.s("Touch").resetTouchPoints);
                Crafty.removeEvent(Crafty.s("Touch"), window, "touchcancel", Crafty.s("Touch").resetTouchPoints);
                Crafty.removeEvent(Crafty.s("Keyboard"), "keydown", Crafty.s("Keyboard").processEvent);
                Crafty.removeEvent(Crafty.s("Keyboard"), "keyup", Crafty.s("Keyboard").processEvent);
                if (Crafty.stage) {
                    Crafty.removeEvent(Crafty.s("Mouse"), Crafty.stage.elem, "mousedown", Crafty.s("Mouse").processEvent);
                    Crafty.removeEvent(Crafty.s("Mouse"), Crafty.stage.elem, "mouseup", Crafty.s("Mouse").processEvent);
                    Crafty.removeEvent(Crafty.s("Mouse"), Crafty.stage.elem, "mousemove", Crafty.s("Mouse").processEvent);
                    Crafty.removeEvent(Crafty.s("Mouse"), Crafty.stage.elem, "click", Crafty.s("Mouse").processEvent);
                    Crafty.removeEvent(Crafty.s("Mouse"), Crafty.stage.elem, "dblclick", Crafty.s("Mouse").processEvent);
                    Crafty.removeEvent(this, Crafty.stage.elem, "touchstart", this._touchDispatch);
                    Crafty.removeEvent(this, Crafty.stage.elem, "touchmove", this._touchDispatch);
                    Crafty.removeEvent(this, Crafty.stage.elem, "touchend", this._touchDispatch);
                    Crafty.removeEvent(this, Crafty.stage.elem, "touchcancel", this._touchDispatch);
                    Crafty.removeEvent(this, Crafty.stage.elem, "touchleave", this._touchDispatch);
                    Crafty.removeEvent(Crafty.s("MouseWheel"), Crafty.stage.elem, mouseWheelEvent, Crafty.s("MouseWheel").processEvent);
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    48: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #MouseWheel
 * @category Input
 * @kind System
 *
 * System which dispatches mouse wheel events received by Crafty.
 * @trigger MouseWheelScroll - when mouse is scrolled - MouseWheelEvent
 *
 * The event callback is triggered with a native [`wheel` event](https://developer.mozilla.org/en-US/docs/Web/Events/wheel) (all newer browsers),
 * a native [`mousewheel` event](https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel) (old IE and WebKit browsers) or
 * a native [`DOMMouseScroll` event](https://developer.mozilla.org/en-US/docs/Web/Events/DOMMouseScroll) (old Firefox browsers)
 * received by Crafty's stage (`Crafty.stage.elem`), which is wrapped in a standard Crafty event object (see below).
 *
 * These MouseWheel events are triggered on the global Crafty object and thus on every entity and system.
 *
 * The standard `MouseWheelEvent` object:
 * ~~~
 * // event name of mouse wheel event - "MouseWheelScroll"
 * e.eventName
 *
 * // the direction the wheel was scrolled, +1 if wheel was scrolled up, -1 if wheel was scrolled down
 * e.direction
 *
 * // the closest (visible & Mouse-enhanced) entity to the source of the event (if available), otherwise null
 * e.target
 *
 * // (x,y) coordinates of mouse event in world (default viewport) space
 * e.realX
 * e.realY
 *
 * // Original mouse wheel event, containing additional native properties
 * e.originalEvent
 * ~~~
 *
 * @example
 * Zoom the viewport (camera) in response to mouse scroll events.
 * ~~~
 * Crafty.bind("MouseWheelScroll", function(evt) {
 *     Crafty.viewport.scale(Crafty.viewport._scale * (1 + evt.direction * 0.1));
 * });
 * ~~~
 *
 * For more details see [mdn article on wheel events](https://developer.mozilla.org/en-US/docs/Web/Events/wheel#Listening_to_this_event_across_browser).
 * @note The wheel delta properties of the event vary in magnitude across browsers, thus it is recommended to check for `.direction` instead.
 * The `.direction` equals `+1` if wheel was scrolled up, `-1` if wheel was scrolled down
 * (see [details](http://stackoverflow.com/questions/5527601/normalizing-mousewheel-speed-across-browsers)).
 *
 * @example
 * Interactive, map-like zooming of the viewport (camera) in response to mouse scroll events.
 * ~~~
 * // sign public void zoomTowards(Number amt, Number posX, Number posY, Number time[, String|function easingFn])
 * // param Number amt - amount to zoom in on the target by (eg. `2`, `4`, `0.5`)
 * // param Number posX - the x coordinate to zoom towards
 * // param Number posY - the y coordinate to zoom towards
 * // param Number time - the duration in ms of the entire zoom operation
 * // param easingFn - A string or custom function specifying an easing.
 * //                   (Defaults to linear behavior.)
 * //                   See `Crafty.easing` for more information.
 * //
 * // Zooms the camera towards a given point, preserving the current center.
 * // `amt > 1` will bring the camera closer to the subject,
 * // `amt < 1` will bring it farther away,
 * // `amt = 0` will reset to the default zoom level.
 * // Zooming is multiplicative. To reset the zoom amount, pass `0`.
 * //
 * // <example>
 * // // Make the entities appear twice as large by zooming in towards (100,100) over the duration of 3 seconds using linear easing behavior
 * // zoomTowards(2, 100, 100, 3000);
 * // </example>
 * //
 * function zoomTowards (amt, posX, posY, time, easingFn) {
 *     var scale = Crafty.viewport._scale,
 *         // current viewport center
 *         centX = -Crafty.viewport._x + Crafty.viewport._width / 2 / scale,
 *         centY = -Crafty.viewport._y + Crafty.viewport._height / 2 / scale,
 *         // direction vector from viewport center to position
 *         deltaX = posX - centX,
 *         deltaY = posY - centY;
 *     var f = amt - 1;
 *
 *     Crafty.viewport.zoom(amt, centX + deltaX * f, centY + deltaY * f, time, easingFn);
 * }
 *
 * // don't restrict panning of viewport in any way
 * Crafty.viewport.clampToEntities = false;
 *
 * // enable panning of viewport by dragging the mouse
 * Crafty.viewport.mouselook(true);
 *
 * // enable interactive map-like zooming by scrolling the mouse
 * Crafty.bind("MouseWheelScroll", function (evt) {
 *     zoomTowards(1 + evt.direction/10, evt.realX, evt.realY, 5);
 * });
 * ~~~
 */ Crafty.s("MouseWheel", Crafty.extend.call(new Crafty.__eventDispatcher(), {
                _evt: {
                    // evt object to reuse
                    eventName: "",
                    direction: 0,
                    target: null,
                    clientX: 0,
                    clientY: 0,
                    realX: 0,
                    realY: 0,
                    originalEvent: null
                },
                _mouseSystem: null,
                prepareEvent: function(e) {
                    var mouseSystem = this._mouseSystem;
                    if (!mouseSystem) this._mouseSystem = mouseSystem = Crafty.s("Mouse");
                    var evt = this._evt;
                    // normalize eventName
                    evt.eventName = "MouseWheelScroll";
                    // normalize direction
                    evt.direction = e.detail < 0 || e.wheelDelta > 0 || e.deltaY < 0 ? 1 : -1;
                    // copy screen coordinates
                    // only browsers supporting `wheel` event contain mouse coordinates
                    // DEPRECATED: remove in upcoming release
                    evt.clientX = e.clientX !== undefined ? e.clientX : mouseSystem.lastMouseEvent.clientX;
                    evt.clientY = e.clientY !== undefined ? e.clientY : mouseSystem.lastMouseEvent.clientY;
                    // augment mouse event with real coordinates
                    Crafty.translatePointerEventCoordinates(e, evt);
                    // augment mouse event with target entity
                    evt.target = mouseSystem.mouseObjs ? Crafty.findPointerEventTargetByComponent("Mouse", e) : null;
                    // wrap original event into standard Crafty event object
                    evt.originalEvent = e;
                    return evt;
                },
                dispatchEvent: function(e) {
                    var evt = this.prepareEvent(e);
                    // trigger event
                    Crafty.trigger("MouseWheelScroll", evt);
                }
            }), {}, false);
            /**@
 * #MouseSystem
 * @category Input
 * @kind System
 *
 * Provides access to mouse events.
 * @note Additional events and methods are inherited from the `MouseState` component.
 *
 * @trigger MouseOver - when the mouse enters an entity - MouseEvent
 * @trigger MouseOut - when the mouse leaves an entity - MouseEvent
 * @trigger Click - when the user clicks - MouseEvent
 * @trigger DoubleClick - when the user double clicks - MouseEvent
 *
 * The event callbacks are triggered with a native [`MouseEvent`](https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent)
 * received by Crafty's stage (`Crafty.stage.elem`), which is wrapped in a standard Crafty event object (as described in `MouseState`).
 *
 * These mouse events are triggered on the MouseSystem itself.
 * Additionally, they are dispatched to the closest (visible & `Mouse`-enhanced) entity to the source of the event (if available).
 *
 * @note If you're targeting mobile, you should know that by default Crafty turns touch events into mouse events,
 * making mouse dependent components work with touch. However, if you need multitouch, you'll have
 * to make use of the Touch component instead, which can break compatibility with things which directly interact with the Mouse component.
 *
 * @example
 * Log the current position of the mouse.
 * ~~~
 * Crafty.s('Mouse').bind('MouseMove', function(e) {
 *     Crafty.log('Mouse pos: <' + e.realX.toFixed(2) + ', ' + e.realY.toFixed(2) + '>');
 * });
 * ~~~
 *
 * @see MouseState, Mouse
 * @see Crafty.multitouch
 */ Crafty.s("Mouse", Crafty.extend.call(Crafty.extend.call(new Crafty.__eventDispatcher(), {
                normedEventNames: {
                    mousedown: "MouseDown",
                    mouseup: "MouseUp",
                    dblclick: "DoubleClick",
                    click: "Click",
                    mousemove: "MouseMove"
                },
                _evt: {
                    // evt object to reuse
                    eventName: "",
                    mouseButton: -1,
                    target: null,
                    clientX: 0,
                    clientY: 0,
                    realX: 0,
                    realY: 0,
                    originalEvent: null
                },
                // Indicates how many entities have the Mouse component, for performance optimization
                // Mouse events are still routed to Crafty.s('Mouse') even if there are no entities with Mouse component
                mouseObjs: 0,
                // current entity that is moused over
                over: null,
                prepareEvent: function(e) {
                    var evt = this._evt;
                    // Normalize event name
                    var type = e.type;
                    evt.eventName = this.normedEventNames[type] || type;
                    // Normalize button according to http://unixpapa.com/js/mouse.html
                    if (typeof e.which === "undefined") evt.mouseButton = e.button < 2 ? Crafty.mouseButtons.LEFT : e.button === 4 ? Crafty.mouseButtons.MIDDLE : Crafty.mouseButtons.RIGHT;
                    else evt.mouseButton = e.which < 2 ? Crafty.mouseButtons.LEFT : e.which === 2 ? Crafty.mouseButtons.MIDDLE : Crafty.mouseButtons.RIGHT;
                    // copy screen coordinates
                    // DEPRECATED: remove in upcoming release
                    evt.clientX = e.clientX;
                    evt.clientY = e.clientY;
                    // augment mouse event with real coordinates
                    Crafty.translatePointerEventCoordinates(e, evt);
                    // augment mouse event with target entity
                    evt.target = this.mouseObjs ? Crafty.findPointerEventTargetByComponent("Mouse", e) : null;
                    // wrap original event into standard Crafty event object
                    evt.originalEvent = e;
                    return evt;
                },
                // this method will be called by MouseState iff triggerMouse event was valid
                triggerMouseEvent: function(eventName, e) {
                    // trigger event on MouseSystem itself
                    this.trigger(eventName, e);
                    // special case: MouseOver & MouseOut
                    var over = this.over, closest = e.target;
                    if (eventName === "MouseMove" && over !== closest) {
                        // MouseOver target changed
                        // if old MouseOver target wasn't null, send MouseOut
                        if (over) {
                            e.eventName = "MouseOut";
                            e.target = over;
                            over.trigger("MouseOut", e);
                            e.eventName = "MouseMove";
                            e.target = closest;
                        }
                        // save new over entity
                        this.over = closest;
                        // if new MouseOver target isn't null, send MouseOver
                        if (closest) {
                            e.eventName = "MouseOver";
                            closest.trigger("MouseOver", e);
                            e.eventName = "MouseMove";
                        }
                    }
                    // TODO: move routing of events in future to controls system, make it similar to KeyboardSystem
                    // try to find closest element that will also receive mouse event, whatever the event is
                    if (closest) closest.trigger(eventName, e);
                },
                dispatchEvent: function(e) {
                    var evt = this.prepareEvent(e);
                    this.triggerMouse(evt.eventName, evt);
                }
            }), Crafty.__mouseStateTemplate), {}, false);
            /**@
 * #Mouse
 * @category Input
 * @kind Component
 *
 * Provides the entity with mouse events.
 * Mouse events get dispatched to the closest (visible & `Mouse`-enhanced) entity to the source of the event (if available).
 * @note If you do not add this component, mouse events will not be triggered on the entity.
 *
 * Triggers all events described in `MouseSystem` and `MouseState`, these are:
 * @trigger MouseOver - when the mouse enters the entity - MouseEvent
 * @trigger MouseMove - when the mouse is over the entity and moves - MouseEvent
 * @trigger MouseOut - when the mouse leaves the entity - MouseEvent
 * @trigger MouseDown - when a mouse button is pressed on the entity - MouseEvent
 * @trigger MouseUp - when a mouse button is released on the entity - MouseEvent
 * @trigger Click - when the user clicks on the entity - MouseEvent
 * @trigger DoubleClick - when the user double clicks on the entity - MouseEvent
 *
 * @note If you're targeting mobile, you should know that by default Crafty turns touch events into mouse events,
 * making mouse dependent components work with touch. However, if you need multitouch, you'll have
 * to make use of the Touch component instead, which can break compatibility with things which directly interact with the Mouse component.
 *
 * @example
 * ~~~
 * var myEntity = Crafty.e('2D, Canvas, Color, Mouse')
 * .attr({x: 10, y: 10, w: 40, h: 40})
 * .color('red')
 * .bind('Click', function(MouseEvent){
 *   alert('clicked', MouseEvent);
 * });
 *
 * myEntity.bind('MouseUp', function(e) {
 *    if( e.mouseButton == Crafty.mouseButtons.RIGHT )
 *        Crafty.log("Clicked right button");
 * })
 * ~~~
 *
 * @see MouseState, MouseSystem
 * @see Crafty.multitouch
 */ Crafty.c("Mouse", {
                required: "AreaMap",
                init: function() {
                    Crafty.s("Mouse").mouseObjs++;
                },
                remove: function() {
                    Crafty.s("Mouse").mouseObjs--;
                }
            });
            /**@
 * #MouseDrag
 * @category Input
 * @kind Component
 *
 * Provides the entity with drag and drop mouse events.
 * @trigger Dragging - is triggered each frame the entity is being dragged - MouseEvent
 * @trigger StartDrag - is triggered when dragging begins - MouseEvent
 * @trigger StopDrag - is triggered when dragging ends - MouseEvent
 *
 * @see Mouse
 */ Crafty.c("MouseDrag", {
                _dragging: false,
                required: "Mouse",
                events: {
                    MouseDown: "_ondown"
                },
                init: function() {
                    // TODO: remove this and instead lock on pointer control events in future
                    // bind the this object for listeners called with the MouseSystem as the this object
                    this._ondown = this._ondown.bind(this);
                    this._ondrag = this._ondrag.bind(this);
                    this._onup = this._onup.bind(this);
                },
                // When dragging is enabled, this method is bound to the MouseDown crafty event
                _ondown: function(e) {
                    if (e.mouseButton !== Crafty.mouseButtons.LEFT) return;
                    this.startDrag(e);
                },
                // While a drag is occurring, this method is bound to the mousemove DOM event
                _ondrag: function(e) {
                    // ignore invalid 0 position - strange problem on ipad
                    if (!this._dragging || e.realX === 0 || e.realY === 0) return false;
                    this.trigger("Dragging", e);
                },
                // While a drag is occurring, this method is bound to mouseup DOM event
                _onup: function(e) {
                    if (e.mouseButton !== Crafty.mouseButtons.LEFT) return;
                    this.stopDrag(e);
                },
                /**@
     * #.startDrag
     * @comp MouseDrag
     * @kind Method
     *
     * @sign public this .startDrag(void)
     *
     * Make the entity produce drag events, essentially making the entity follow the mouse positions.
     *
     * @see .stopDrag
     */ startDrag: function(e) {
                    if (this._dragging) return;
                    this._dragging = true;
                    // TODO: remove this and instead lock on pointer control events in future
                    Crafty.s("Mouse").bind("MouseMove", this._ondrag);
                    Crafty.s("Mouse").bind("MouseUp", this._onup);
                    // if event undefined, use the last known position of the mouse
                    this.trigger("StartDrag", e || Crafty.s("Mouse").lastMouseEvent);
                    return this;
                },
                /**@
     * #.stopDrag
     * @comp MouseDrag
     * @kind Method
     *
     * @sign public this .stopDrag(void)
     *
     * Stop the entity from producing drag events, essentially reproducing the drop.
     *
     * @see .startDrag
     */ stopDrag: function(e) {
                    if (!this._dragging) return;
                    this._dragging = false;
                    // TODO: remove this and instead lock on pointer control events in future
                    Crafty.s("Mouse").unbind("MouseMove", this._ondrag);
                    Crafty.s("Mouse").unbind("MouseUp", this._onup);
                    // if event undefined, use the last known position of the mouse
                    this.trigger("StopDrag", e || Crafty.s("Mouse").lastMouseEvent);
                    return this;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    49: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            Crafty.extend({
                /**@
     * #Crafty.findPointerEventTargetByComponent
     * @category Input
     * @kind Method
     *
     * @sign public Object .findPointerEventTargetByComponent(String comp, Number clientX, Number clientY)
     * Finds closest entity with certain component at a given position.
     * @param comp - Component name
     * @param clientX - x coordinate in client space, usually taken from a pointer event
     * @param clientY - y coordinate in client space, usually taken from a pointer event
     * @returns The found entity, or null if no entity was found.
     *
     * @sign public Object .findPointerEventTargetByComponent(String comp, Event e)
     * Finds closest entity with certain component at a given event.
     * @param comp - Component name
     * @param e - The pointer event, containing the target and the required properties `clientX` & `clientY`, which will be used as the query point
     * @returns The found entity, or null if no entity was found.
     *
     * This method is used internally by the .mouseDispatch and .touchDispatch methods, but can be used otherwise for
     * Canvas entities.
     *
     * Finds the top most entity (with the highest z) with a given component at a given point (x, y).
     * For having a detection area specified for the enity, add the AreaMap component to the entity expected to be found.
     *
     */ findPointerEventTargetByComponent: function(comp, x, y) {
                    var tar = x.target || x.srcElement || Crafty.stage.elem;
                    y = typeof y !== "undefined" ? y : x.clientY;
                    x = typeof x.clientX !== "undefined" ? x.clientX : x;
                    var closest = null, current, q, l, i, pos, maxz = -Infinity;
                    //if it's a DOM element with component we are done
                    if (tar.nodeName !== "CANVAS") {
                        while(typeof tar.id !== "string" && tar.id.indexOf("ent") === -1)tar = tar.parentNode;
                        var ent = Crafty(parseInt(tar.id.replace("ent", ""), 10));
                        pos = Crafty.domHelper.translate(x, y, ent._drawLayer);
                        if (ent.__c[comp] && ent.isAt(pos.x, pos.y)) closest = ent;
                    }
                    //else we search for an entity with component
                    if (!closest) // Loop through each layer
                    for(var layerIndex in Crafty._drawLayers){
                        var layer = Crafty._drawLayers[layerIndex];
                        // Skip a layer if it has no entities listening for pointer events
                        if (layer._pointerEntities <= 0) continue;
                        // Get the position in this layer
                        pos = Crafty.domHelper.translate(x, y, layer);
                        q = Crafty.map.unfilteredSearch({
                            _x: pos.x,
                            _y: pos.y,
                            _w: 1,
                            _h: 1
                        });
                        for(i = 0, l = q.length; i < l; ++i){
                            current = q[i];
                            if (current._visible && current._drawLayer === layer && current._globalZ > maxz && current.__c[comp] && current.isAt(pos.x, pos.y)) {
                                maxz = current._globalZ;
                                closest = current;
                            }
                        }
                    }
                    return closest;
                },
                /**@
     * #Crafty.translatePointerEventCoordinates
     * @category Input
     * @kind Method
     *
     * @sign public Object .translatePointerEventCoordinates(PointerEvent e[, PointerEvent out])
     * @param e - Any pointer event with `clientX` and `clientY` properties, usually a `MouseEvent` or `Touch` object
     * @param out - Optional pointer event to augment with coordinates instead
     * @returns The pointer event, augmented with additional `realX` and `realY` properties
     *
     * Updates the passed event object to have two additional properties, `realX` and `realY`,
     * which correspond to the point in actual world space the event happened.
     *
     * This method is used internally by the .mouseDispatch and .touchDispatch methods,
     * but may be used for custom events.
     *
     * @see Crafty.domHelper#Crafty.domHelper.translate
     */ translatePointerEventCoordinates: function(e, out) {
                    out = out || e;
                    // Find the Crafty position in the default coordinate set,
                    // disregard the fact that the pointer event was related to a specific layer.
                    var pos = Crafty.domHelper.translate(e.clientX, e.clientY, undefined, this.__pointerPos);
                    // Set the mouse position based on standard viewport coordinates
                    out.realX = pos.x;
                    out.realY = pos.y;
                },
                __pointerPos: {
                    x: 0,
                    y: 0
                } // object to reuse
            });
            /**@
 * #AreaMap
 * @category Input
 * @kind Component
 *
 * Component used by Mouse and Touch.
 * Can be added to other entities for use with the Crafty.findPointerEventTargetByComponent method.
 *
 * @see Button
 * @see Crafty.polygon
 * @see Crafty.findPointerEventTargetByComponent
 */ Crafty.c("AreaMap", {
                init: function() {
                    if (this.has("Renderable") && this._drawLayer) this._drawLayer._pointerEntities++;
                },
                remove: function(isDestruction) {
                    if (!isDestruction && this.has("Renderable") && this._drawLayer) this._drawLayer._pointerEntities--;
                },
                events: {
                    LayerAttached: function(layer) {
                        layer._pointerEntities++;
                    },
                    LayerDetached: function(layer) {
                        layer._pointerEntities--;
                    }
                },
                /**@
     * #.areaMap
     * @comp AreaMap
     * @kind Method
     *
     * @trigger NewAreaMap - when a new areaMap is assigned - Crafty.polygon
     *
     * @sign public this .areaMap(Crafty.polygon polygon)
     * @param polygon - Instance of Crafty.polygon used to check if the mouse coordinates are inside this region
     *
     * @sign public this .areaMap(Array coordinatePairs)
     * @param coordinatePairs - Array of `x`, `y` coordinate pairs to generate a polygon
     *
     * @sign public this .areaMap(x1, y1,.., xN, yN)
     * @param point# - List of `x`, `y` coordinate pairs to generate a polygon
     *
     * Assign a polygon to the entity so that pointer (mouse or touch) events will only be triggered if
     * the coordinates are inside the given polygon.
     *
     * @example
     * ~~~
     * Crafty.e("2D, DOM, Color, Mouse")
     *     .color("red")
     *     .attr({ w: 100, h: 100 })
     *     .bind('MouseOver', function() {Crafty.log("over")})
     *     .areaMap(0, 0, 50, 0, 50, 50, 0, 50);
     *
     * Crafty.e("2D, Mouse")
     *     .areaMap([0, 0, 50, 0, 50, 50, 0, 50]);
     *
     * Crafty.e("2D, Mouse").areaMap(
     *     new Crafty.polygon([0, 0, 50, 0, 50, 50, 0, 50])
     * );
     * ~~~
     *
     * @see Crafty.polygon
     */ areaMap: function(poly) {
                    //create polygon
                    if (arguments.length > 1) {
                        //convert args to array to create polygon
                        var args = Array.prototype.slice.call(arguments, 0);
                        poly = new Crafty.polygon(args);
                    } else if (poly.constructor === Array) poly = new Crafty.polygon(poly.slice());
                    else poly = poly.clone();
                    poly.shift(this._x, this._y);
                    this.mapArea = poly;
                    this.attach(this.mapArea);
                    this.trigger("NewAreaMap", poly);
                    return this;
                }
            });
            /**@
 * #Button
 * @category Input
 * @kind Component
 *
 * Provides the entity with touch or mouse functionality, depending on whether this is a pc
 * or mobile device, and also on multitouch configuration.
 *
 * @see Mouse
 * @see Touch
 * @see Crafty.multitouch
 */ Crafty.c("Button", {
                init: function() {
                    var req = !Crafty.mobile || Crafty.mobile && !Crafty.multitouch() ? "Mouse" : "Touch";
                    this.requires(req);
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    50: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            Crafty.extend({
                /**@
     * #Crafty.multitouch
     * @category Input
     * @kind Method
     *
     * Enables/disables support for multitouch feature.
     * @sign public this .multitouch(Boolean bool)
     * @param bool - Turns multitouch on and off.  The initial state is off (false).
     *
     * Query whether multitouch is on or off.
     * @sign public Boolean .multitouch()
     * @returns Whether multitouch is currently enabled
     *
     * By default, touch events are treated as mouse events and are handled by the `MouseSystem`.
     * To change this behaviour and handle events by the `TouchSystem`, enable multitouch.
     *
     * If this is set to true, it is expected that your entities have the `Touch` component instead of the `Mouse` component.
     * If false (default), then only entities with the Mouse component will respond to touch.
     * For simple use cases, tt's recommended to add the `Button` component instead, which requires the proper component depending on this feature.
     *
     * @note The multitouch feature is currently incompatible with the `Draggable` component and `Crafty.viewport.mouselook`.
     * @note When multitouch is not enabled, Crafty will cancel touch events when forwarding them to the mouse system.
     *
     * @example
     * ~~~
     * Crafty.multitouch(true);
     * Crafty.log("multitouch is " + Crafty.multitouch());
     *
     * Crafty.e('2D, Canvas, Color, Button')
     *    .attr({ x: 100, y: 100, w:200, h:200, z:1 })
     *    .color('black')
     *    .bind('TouchStart', function(e) { this.color('green'); });
     * ~~~
     * @see TouchSystem
     * @see MouseSystem
     * @see Button
     * @see Touch
     * @see Mouse
     */ multitouch: function(bool) {
                    if (typeof bool !== "boolean") return this._multitouch;
                    this._multitouch = bool;
                    return this;
                },
                _multitouch: false,
                _touchDispatch: function() {
                    var touchSystem;
                    var startX = 0, startY = 0; // keeps track of start touch location
                    function mimicMouse(e) {
                        var type, first;
                        if (e.type === "touchstart") type = "mousedown";
                        else if (e.type === "touchmove") type = "mousemove";
                        else if (e.type === "touchend") type = "mouseup";
                        else if (e.type === "touchcancel") type = "mouseup";
                        else if (e.type === "touchleave") type = "mouseup";
                        if (e.touches && e.touches.length) first = e.touches[0];
                        else if (e.changedTouches && e.changedTouches.length) first = e.changedTouches[0];
                        var simulatedEvent = document.createEvent("MouseEvent");
                        simulatedEvent.initMouseEvent(type, true, true, window, 1, first.screenX, first.screenY, first.clientX, first.clientY, false, false, false, false, 0, e.relatedTarget);
                        first.target.dispatchEvent(simulatedEvent);
                        // trigger click when it should be triggered
                        if (type === "mousedown") {
                            startX = first.clientX;
                            startY = first.clientY;
                        } else if (type === "mouseup") {
                            var diffX = first.clientX - startX, diffY = first.clientY - startY;
                            // make sure that distance between touchstart and touchend smaller than some threshold,
                            // e.g. <= 16 px
                            if (diffX * diffX + diffY * diffY <= 256) {
                                type = "click";
                                simulatedEvent = document.createEvent("MouseEvent");
                                simulatedEvent.initMouseEvent(type, true, true, window, 1, first.screenX, first.screenY, first.clientX, first.clientY, false, false, false, false, 0, e.relatedTarget);
                                first.target.dispatchEvent(simulatedEvent);
                            }
                        }
                        e.preventDefault();
                    }
                    return function(e) {
                        // either dispatch real touch events
                        if (Crafty._multitouch) {
                            if (!touchSystem) touchSystem = Crafty.s("Touch");
                            touchSystem.processEvent(e);
                        // or mimic mouse events
                        } else mimicMouse(e);
                    };
                }()
            });
            /**@
 * #TouchSystem
 * @category Input
 * @kind System
 *
 * Provides access to touch point events.
 * @note Additional events and methods are inherited from the `TouchState` component.
 *
 * @trigger TouchOver - when a finger enters an entity - TouchPointEvent
 * @trigger TouchOut - when a finger leaves an entity - TouchPointEvent
 *
 * The event callbacks are triggered with the native [`TouchEvent`](https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent)
 * received by Crafty's stage (`Crafty.stage.elem`), which is wrapped in a standard Crafty event object (see `TouchState`).
 * Note that for each changed [`Touch` point](https://developer.mozilla.org/en-US/docs/Web/API/Touch)) a separate
 * Crafty TouchPointEvent event is triggered.
 *
 * These touch point events are triggered on the TouchSystem itself.
 * Additionally, they are dispatched to the closest (visible & `Touch`-enhanced) entity to the source of the event (if available).
 *
 * @note By default, touch events are treated as mouse events and are not triggered by this system.
 * To change this behaviour (and enable multitouch) use `Crafty.multitouch`.
 *
 * @see TouchState, Touch
 * @see Crafty.multitouch
 */ Crafty.s("Touch", Crafty.extend.call(Crafty.extend.call(new Crafty.__eventDispatcher(), {
                normedEventNames: {
                    touchstart: "TouchStart",
                    touchmove: "TouchMove",
                    touchend: "TouchEnd",
                    touchcancel: "TouchCancel" // touchcancel is treated as touchend, but triggers a TouchCancel event
                },
                _evt: {
                    // evt object to reuse
                    eventName: "",
                    identifier: -1,
                    target: null,
                    entity: null,
                    realX: 0,
                    realY: 0,
                    originalEvent: null
                },
                // Indicates how many entities have the Touch component, for performance optimization
                // Touch events are still routed to Crafty.s('Touch') even if there are no entities with Touch component
                touchObjs: 0,
                // current entites that are pointed at
                overs: {},
                prepareEvent: function(e, type) {
                    var evt = this._evt;
                    // Normalize event name
                    evt.eventName = this.normedEventNames[type] || type;
                    // copy identifier
                    evt.identifier = e.identifier;
                    // augment touch event with real coordinates
                    Crafty.translatePointerEventCoordinates(e, evt);
                    // augment touch event with target entity
                    evt.target = this.touchObjs ? Crafty.findPointerEventTargetByComponent("Touch", e) : null;
                    // DEPRECATED: remove this in upcoming release
                    evt.entity = evt.target;
                    return evt;
                },
                // this method will be called by TouchState iff triggerTouch event was valid
                triggerTouchEvent: function(eventName, e) {
                    // trigger event on TouchSystem itself
                    this.trigger(eventName, e);
                    var identifier = e.identifier, closest = e.target, over = this.overs[identifier];
                    if (over) // if old TouchOver target wasn't null, send TouchOut
                    {
                        if (eventName === "TouchMove" && over !== closest || // if TouchOver target changed
                        eventName === "TouchEnd" || eventName === "TouchCancel") {
                            // or TouchEnd occurred
                            e.eventName = "TouchOut";
                            e.target = over;
                            e.entity = over; // DEPRECATED: remove this in upcoming release
                            over.trigger("TouchOut", e);
                            e.eventName = eventName;
                            e.target = closest;
                            e.entity = closest; // DEPRECATED: remove this in upcoming release
                            // delete old over entity
                            delete this.overs[identifier];
                        }
                    }
                    // TODO: move routing of events in future to controls system, make it similar to KeyboardSystem
                    // try to find closest element that will also receive touch event, whatever the event is
                    if (closest) closest.trigger(eventName, e);
                    if (closest) // if new TouchOver target isn't null, send TouchOver
                    {
                        if (eventName === "TouchStart" || // if TouchStart occurred
                        eventName === "TouchMove" && over !== closest) {
                            // or TouchOver target changed
                            e.eventName = "TouchOver";
                            closest.trigger("TouchOver", e);
                            e.eventName = eventName;
                            // save new over entity
                            this.overs[identifier] = closest;
                        }
                    }
                },
                dispatchEvent: function(e) {
                    var evt, touches = e.changedTouches;
                    for(var i = 0, l = touches.length; i < l; i++){
                        evt = this.prepareEvent(touches[i], e.type);
                        // wrap original event into standard Crafty event object
                        evt.originalEvent = e;
                        this.triggerTouch(evt.eventName, evt);
                    }
                }
            }), Crafty.__touchStateTemplate), {}, false);
            /**@
 * #Touch
 * @category Input
 * @kind Component
 *
 * Provides the entity with touch point events.
 * Touch point events get dispatched to the closest (visible & `Touch`-enhanced) entity to the source of the event (if available).
 * @note If you do not add this component, touch events will not be triggered on the entity.
 *
 * Triggers all events described in `TouchSystem` and `TouchState`, these are:
 * @trigger TouchOver - when a finger enters the entity - TouchPointEvent
 * @trigger TouchMove - when a finger is over the entity and moves - TouchPointEvent
 * @trigger TouchOut - when a finger leaves the entity - TouchPointEvent
 * @trigger TouchStart - when a finger is pressed on the entity - TouchPointEvent
 * @trigger TouchEnd - when a finger is raised over the entity - TouchPointEvent
 * @trigger TouchCancel - when a touch event has been disrupted in some way whilst over the entity - TouchPointEvent
 *
 * @note By default, touch events are treated as mouse events and are not triggered by this component.
 * To change this behaviour (and enable multitouch) use `Crafty.multitouch`.
 *
 * @example
 * ~~~
 * Crafty.multitouch(true);
 *
 * Crafty.e('2D, Canvas, Color, Touch')
 *   .attr({x: 10, y: 10, w: 40, h: 40})
 *   .color('green')
 *   .bind('TouchOver', function(TouchPoint){
 *     Crafty.log('A finger is over the entity', TouchPoint.identifier);
 *   })
 *   .bind('TouchMove', function(TouchPoint) {
 *     Crafty.log('A finger moves over the entity at { x: ' + TouchPoint.realX + ', y: ' + TouchPoint.realY + ' } coordinates.');
 *   })
 *   .bind('TouchOut', function(TouchPoint){
 *     Crafty.log('A finger is no longer over the entity', TouchPoint.identifier);
 *   });
 * ~~~
 *
 * @example
 * ~~~
 * Crafty.multitouch(true);
 *
 * var myEntity1 = Crafty.e('2D, Canvas, Color, Touch')
 *    .attr({x: 100, y: 100, w:200, h:200, z:1 })
 *    .color('black')
 *    .bind('TouchStart',function(e){ alert('big black box was touched', e); }),
 *  myEntity2 = Crafty.e('2D, Canvas, Color, Touch')
 *    .attr({x: 40, y: 150, w:90, h:300, z:2 })
 *    .color('green')
 *    .bind('TouchStart',function(e){ alert('big green box was touched', e); });
 * ~~~
 *
 * @see TouchState, TouchSystem
 * @see Crafty.multitouch
 */ Crafty.c("Touch", {
                required: "AreaMap",
                init: function() {
                    Crafty.s("Touch").touchObjs++;
                },
                remove: function() {
                    Crafty.s("Touch").touchObjs--;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    51: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            // common base functionality for all EventDispatchers
            Crafty.__eventDispatcher = function EventDispatcher() {};
            Crafty.__eventDispatcher.prototype = {
                // this method should be setup as the entry callback for DOM events
                processEvent: function(e) {
                    this.dispatchEvent(e);
                    return this.preventBubbling(e);
                },
                // main method that handles logic of incoming DOM events
                // to be implemented by instances
                dispatchEvent: function(e) {
                // normalize the event and prepare it for dispatching to Crafty, a system or entities
                // set e.eventName to proper event to be triggered
                // dispatch the element to Crafty, the proper system or entities
                // find the entity to dispatch to (e.g. mouse events) or dispatch it globally (e.g. key events)
                },
                // prevents interaction with page (e.g. scrolling of page), if DOM events target Crafty's stage
                // automatically called for all incoming DOM events
                preventBubbling: function(e) {
                    // only prevent something if DOM event targets Crafty's stage
                    // prevent bubbling up for all events except key events backspace and F1-F12.
                    // prevent default actions for all events except key events backspace and F1-F12 and except actions on INPUT and TEXTAREA.
                    // Among others this prevent the arrow keys from scrolling the parent page of an iframe hosting the game
                    if (Crafty.selected && !(e.key === 8 || e.key >= 112 && e.key <= 135)) {
                        if (e.stopPropagation) e.stopPropagation();
                        else e.cancelBubble = true;
                        // Don't prevent default actions if target node is input or textarea.
                        if (!e.target || e.target.nodeName !== "INPUT" && e.target.nodeName !== "TEXTAREA") {
                            if (e.preventDefault) e.preventDefault();
                            else e.returnValue = false;
                            return false;
                        }
                        return true;
                    }
                }
            };
            Crafty.extend({
                /**@
     * #Crafty.selected
     * @category Input
     * @kind Property
     * @trigger CraftyFocus - is triggered when Crafty's stage gets selected
     * @trigger CraftyBlur - is triggered when Crafty's stage is no longer selected
     *
     * Check whether Crafty's stage (`Crafty.stage.elem`) is currently selected.
     *
     * After a click occurs inside Crafty's stage, this property is set to `true`.
     * After a click occurs outside Crafty's stage, this property is set to `false`.
     *
     * Defaults to true.
     *
     * @see Crafty.stage#Crafty.stage.elem
     */ selected: true,
                detectBlur: function(e) {
                    var selected = e.clientX > Crafty.stage.x && e.clientX < Crafty.stage.x + Crafty.viewport.width && e.clientY > Crafty.stage.y && e.clientY < Crafty.stage.y + Crafty.viewport.height;
                    if (!Crafty.selected && selected) Crafty.trigger("CraftyFocus");
                    if (Crafty.selected && !selected) Crafty.trigger("CraftyBlur");
                    Crafty.selected = selected;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    52: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            Crafty.extend({
                /**@
     * #Crafty.diamondIso
     * @category 2D
     * @kind CoreObject
     *
     * Place entities in a 45deg diamond isometric fashion. It is similar to isometric but has another grid locations
     * In this mode, the x axis and y axis are aligned to the edges of tiles with x increasing being down and to the
     * right and y being down and to the left.
     */ diamondIso: {
                    _tile: {
                        width: 0,
                        height: 0
                    },
                    getTileDimensions: function() {
                        return {
                            w: this._tile.width,
                            h: this._tile.height
                        };
                    },
                    _map: {
                        width: 0,
                        height: 0
                    },
                    _origin: {
                        x: 0,
                        y: 0
                    },
                    _tiles: [],
                    getTile: function(x, y, z) {
                        return this._tiles[x][y][z];
                    },
                    /**@
         * #Crafty.diamondIso.init
         * @comp Crafty.diamondIso
         * @kind Method
         *
         * @sign public this Crafty.diamondIso.init(Number tileWidth,Number tileHeight,Number mapWidth,Number mapHeight)
         * @param tileWidth - The size of base tile width's grid space in Pixel
         * @param tileHeight - The size of base tile height grid space in Pixel
         * @param mapWidth - The width of whole map in Tiles
         * @param mapHeight - The height of whole map in Tiles
         * @param x - the x coordinate of the TOP corner of the 0,0 tile
         * @param y - the y coordinate of the TOP corner of the 0,0, tile
         *
         * Method used to initialize the size of the isometric placement.
         * Recommended to use a size alues in the power of `2` (128, 64 or 32).
         * This makes it easy to calculate positions and implement zooming.
         *
         * @example
         * ~~~
         * var iso = Crafty.diamondIso.init(64,128,20,20);
         * ~~~
         *
         * @see Crafty.diamondIso.place
         */ init: function(tw, th, mw, mh, x, y) {
                        this._tile.width = parseInt(tw, 10);
                        this._tile.height = parseInt(th, 10) || parseInt(tw, 10) / 2;
                        this._tile.r = this._tile.width / this._tile.height;
                        this._map.width = parseInt(mw, 10);
                        this._map.height = parseInt(mh, 10) || parseInt(mw, 10);
                        for(var i = 0; i < mw; i++){
                            this._tiles[i] = Array();
                            for(var j = 0; j < mh; j++)this._tiles[i][j] = Array();
                        }
                        this.x = parseInt(x, 10) || 0;
                        this.y = parseInt(y, 10) || 0;
                        this.layerZLevel = mw + mh + 1;
                        return this;
                    },
                    /**@
         * #Crafty.diamondIso.place
         * @comp Crafty.diamondIso
         * @kind Method
         *
         * @sign public this Crafty.diamondIso.place(Entity tile,Number x, Number y, Number layer)
         * @param x - The `x` position to place the tile
         * @param y - The `y` position to place the tile
         * @param layer - The `z` position to place the tile
         * @param tile - The entity that should be position in the isometric fashion
         *
         * Use this method to place an entity in an isometric grid.
         *
         * @example
         * ~~~
         * var iso = Crafty.diamondIso.init(64,128,20,20);
         * isos.place(Crafty.e('2D, DOM, Color').color('red').attr({w:128, h:128}),1,1,2);
         * ~~~
         *
         * @see Crafty.diamondIso.size
         */ place: function(obj, x, y, layer) {
                        var pos = this.pos2px(x, y);
                        //this calculation is weird because tile sprites are h*2
                        //for tiles of size h in isometric
                        var spriteHeight = obj.h / this._tile.height;
                        obj.x = pos.x;
                        obj.y = pos.y - (spriteHeight - 2) * this._tile.height - this._tile.height * layer;
                        obj.z = this.getZAtLoc(x, y, layer);
                        for(var i = 0; i <= spriteHeight - 2; i++){
                            var prevTile = this._tiles[x][y][layer + i];
                            if (prevTile && prevTile !== obj) prevTile.destroy();
                            this._tiles[x][y][layer + i] = obj;
                        }
                        return this;
                    },
                    detachTile: function(obj) {
                        for(var _x = 0; _x < this._map.width; _x++)for(var _y = 0; _y < this._map.height; _y++){
                            var len = this._tiles[_x][_y].length;
                            for(var _z = 0; _z < len; _z++)if (this._tiles[_x][_y][_z] && obj === this._tiles[_x][_y][_z]) {
                                var tHeight = obj.h / this._tile.height;
                                for(var i = 0; i < tHeight; i++)this._tiles[_x][_y][_z + i] = undefined;
                                return {
                                    x: _x,
                                    y: _y,
                                    z: _z
                                };
                            }
                        }
                        return false;
                    },
                    centerAt: function(x, y) {
                        var pos = this.pos2px(x, y);
                        Crafty.viewport.x = -pos.x + Crafty.viewport.width / 2 - this._tile.width;
                        Crafty.viewport.y = -pos.y + Crafty.viewport.height / 2;
                    },
                    getZAtLoc: function(x, y, layer) {
                        return this.layerZLevel * layer + x + y;
                    },
                    pos2px: function(x, y) {
                        /* This returns the correct coordinates to place the 
        object's top and left to fit inside the grid, which is
        NOT inside of the tile for an isometric grid.  IF you
        want the top corner of the diamond add tile width/2 */ return {
                            x: this.x + (x - y - 1) * this._tile.width / 2,
                            y: this.y + (x + y) * this._tile.height / 2
                        };
                    },
                    px2pos: function(left, top) {
                        /* This returns the x/y coordinates on z level 0.
        @TODO add a specifying z level
        */ var v1 = (top - this.y) / this._tile.height;
                        var v2 = (left - this.x) / this._tile.width;
                        var x = v1 + v2;
                        var y = v1 - v2;
                        var inX = x > 0 && x < this._map.width;
                        var inY = y > 0 && y < this._map.height;
                        if (!inX || !inY) return undefined;
                        return {
                            x: ~~x,
                            y: ~~y
                        };
                    },
                    getOverlappingTiles: function(x, y) {
                        /* This will find all of the tiles that might be at a given x/y in pixels */ var pos = this.px2pos(x, y);
                        var tiles = [];
                        var _x = ~~pos.x;
                        var _y = ~~pos.y;
                        var maxX = this._map.width - _x;
                        var maxY = this._map.height - _y;
                        var furthest = Math.min(maxX, maxY);
                        var obj = this._tiles[_x][_y][1];
                        if (obj) tiles.push(obj);
                        for(var i = 1; i < furthest; i++){
                            var _obj = this._tiles[_x + i][_y + i][i];
                            if (_obj) tiles.push(_obj);
                        }
                        return tiles;
                    },
                    polygon: function(obj) {
                        /*I don't know what this is trying to do...*/ obj.requires("Collision");
                        var marginX = 0, marginY = 0;
                        var points = [
                            marginX - 0,
                            obj.h - marginY - this._tile.height / 2,
                            marginX - this._tile.width / 2,
                            obj.h - marginY - 0,
                            marginX - this._tile.width,
                            obj.h - marginY - this._tile.height / 2,
                            marginX - this._tile.width / 2,
                            obj.h - marginY - this._tile.height
                        ];
                        var poly = new Crafty.polygon(points);
                        return poly;
                    }
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    53: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            Crafty.extend({
                /**@
     * #Crafty.isometric
     * @category 2D
     * @kind CoreObject
     *
     * Place entities in a 45deg isometric fashion. The alignment of this
     * grid's axes for tile placement is 90 degrees.  If you are looking
     * to have the grid of tile indicies for this.place aligned to the tiles
     * themselves, use DiamondIso instead.
     */ isometric: {
                    _tile: {
                        width: 0,
                        height: 0
                    },
                    _elements: {},
                    _pos: {
                        x: 0,
                        y: 0
                    },
                    _z: 0,
                    /**@
         * #Crafty.isometric.size
         * @comp Crafty.isometric
         * @kind Method
         *
         * @sign public this Crafty.isometric.size(Number tileSize)
         * @param tileSize - The size of the tiles to place.
         *
         * Method used to initialize the size of the isometric placement.
         * Recommended to use a size values in the power of `2` (128, 64 or 32).
         * This makes it easy to calculate positions and implement zooming.
         *
         * @example
         * ~~~
         * var iso = Crafty.isometric.size(128);
         * ~~~
         *
         * @see Crafty.isometric.place
         */ size: function(width, height) {
                        this._tile.width = width;
                        this._tile.height = height > 0 ? height : width / 2; //Setup width/2 if height isn't set
                        return this;
                    },
                    /**@
         * #Crafty.isometric.place
         * @comp Crafty.isometric
         * @kind Method
         *
         * @sign public this Crafty.isometric.place(Number x, Number y, Number z, Entity tile)
         * @param x - The `x` position to place the tile
         * @param y - The `y` position to place the tile
         * @param z - The `z` position or height to place the tile
         * @param tile - The entity that should be position in the isometric fashion
         *
         * Use this method to place an entity in an isometric grid.
         *
         * @example
         * ~~~
         * var iso = Crafty.isometric.size(128);
         * iso.place(2, 1, 0, Crafty.e('2D, DOM, Color').color('red').attr({w:128, h:128}));
         * ~~~
         *
         * @see Crafty.isometric.size
         */ place: function(x, y, z, obj) {
                        var pos = this.pos2px(x, y);
                        pos.top -= z * (this._tile.height / 2);
                        obj.x = pos.left + Crafty.viewport._x;
                        obj.y = pos.top + Crafty.viewport._y;
                        obj.z += z;
                        return this;
                    },
                    /**@
         * #Crafty.isometric.pos2px
         * @comp Crafty.isometric
         * @kind Method
         *
         * @sign public Object Crafty.isometric.pos2px(Number x,Number y)
         * @param x - A position along the x axis
         * @param y - A position along the y axis
         * @return An object with `left` and `top` fields {left Number,top Number}
         *
         * This method converts a position in x and y coordinates to one in pixels
         *
         * @example
         * ~~~
         * var iso = Crafty.isometric.size(128,96);
         * var position = iso.pos2px(100,100); //Object { left=12800, top=4800}
         * ~~~
         */ pos2px: function(x, y) {
                        return {
                            left: x * this._tile.width + (y & 1) * (this._tile.width / 2),
                            top: y * this._tile.height / 2
                        };
                    },
                    /**@
         * #Crafty.isometric.px2pos
         * @comp Crafty.isometric
         * @kind Method
         *
         * @sign public Object Crafty.isometric.px2pos(Number left,Number top)
         * @param top - Offset from the top in pixels
         * @param left - Offset from the left in pixels
         * @return An object with `x` and `y` fields representing the position
         *
         * This method converts a position in pixels to x,y coordinates
         *
         * @example
         * ~~~
         * var iso = Crafty.isometric.size(128,96);
         * var px = iso.pos2px(12800,4800);
         * Crafty.log(px); //Object { x=100, y=100}
         * ~~~
         */ px2pos: function(left, top) {
                        return {
                            x: -Math.ceil(-left / this._tile.width - (top & 1) * 0.5),
                            y: top / this._tile.height * 2
                        };
                    },
                    /**@
         * #Crafty.isometric.centerAt
         * @comp Crafty.isometric
         * @kind Method
         *
         * @sign public Obect Crafty.isometric.centerAt()
         * @returns An object with `top` and `left` fields represneting the viewport's current center
         *
         * @sign public this Crafty.isometric.centerAt(Number x, Number y)
         * @param x - The x position to center at
         * @param y - The y position to center at
         *
         * This method centers the Viewport at an `x,y` location or gives the current centerpoint of the viewport
         *
         * @example
         * ~~~
         * var iso = Crafty.isometric.size(128,96).centerAt(10,10); //Viewport is now moved
         * //After moving the viewport by another event you can get the new center point
         * Crafty.log(iso.centerAt());
         * ~~~
         */ centerAt: function(x, y) {
                        if (typeof x === "number" && typeof y === "number") {
                            var center = this.pos2px(x, y);
                            Crafty.viewport._x = -center.left + Crafty.viewport.width / 2 - this._tile.width / 2;
                            Crafty.viewport._y = -center.top + Crafty.viewport.height / 2 - this._tile.height / 2;
                            return this;
                        } else return {
                            top: -Crafty.viewport._y + Crafty.viewport.height / 2 - this._tile.height / 2,
                            left: -Crafty.viewport._x + Crafty.viewport.width / 2 - this._tile.width / 2
                        };
                    },
                    /**@
         * #Crafty.isometric.area
         * @comp Crafty.isometric
         * @kind Method
         *
         * @sign public Object Crafty.isometric.area()
         * @return An obect with `x` and `y` fields, each of which have a start and end field.
         * In other words, the object has this structure: `{x:{start Number,end Number},y:{start Number,end Number}}`
         *
         * This method returns an object representing the bounds of the viewport
         *
         * @example
         * ~~~
         * var iso = Crafty.isometric.size(128,96).centerAt(10,10); //Viewport is now moved
         * var area = iso.area(); //get the area
         * for(var y = area.y.start;y <= area.y.end;y++){
         *   for(var x = area.x.start ;x <= area.x.end;x++){
         *       iso.place(x,y,0,Crafty.e("2D,DOM,gras")); //Display tiles in the Screen
         *   }
         * }
         * ~~~
         */ area: function() {
                        //Get the center Point in the viewport
                        var center = this.centerAt();
                        var start = this.px2pos(-center.left + Crafty.viewport.width / 2, -center.top + Crafty.viewport.height / 2);
                        var end = this.px2pos(-center.left - Crafty.viewport.width / 2, -center.top - Crafty.viewport.height / 2);
                        return {
                            x: {
                                start: start.x,
                                end: end.x
                            },
                            y: {
                                start: start.y,
                                end: end.y
                            }
                        };
                    }
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    54: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js"), document1 = window.document;
            Crafty.extend({
                /**@
     * #Crafty.audio
     * @category Audio
     * @kind CoreObject
     *
     * Add sound files and play them. Chooses best format for browser support.
     * Due to the nature of HTML5 audio, three types of audio files will be
     * required for cross-browser capabilities. These formats are MP3, Ogg and WAV.
     * When sound was not muted on before pause, sound will be unmuted after unpause.
     * When sound is muted Crafty.pause() does not have any effect on sound
     *
     * The maximum number of sounds that can be played simultaneously is defined by Crafty.audio.maxChannels.  The default value is 7.
     */ audio: {
                    sounds: {},
                    supported: null,
                    codecs: {
                        // Chart from jPlayer
                        ogg: 'audio/ogg; codecs="vorbis"',
                        wav: 'audio/wav; codecs="1"',
                        webma: 'audio/webm; codecs="vorbis"',
                        mp3: 'audio/mpeg; codecs="mp3"',
                        m4a: 'audio/mp4; codecs="mp4a.40.2"' // AAC / MP4
                    },
                    volume: 1,
                    muted: false,
                    paused: false,
                    playCheck: null,
                    /**
         * Function to setup supported formats
         **/ _canPlay: function() {
                        this.supported = {};
                        // Without support, no formats are supported
                        if (!Crafty.support.audio) return;
                        var audio = this.audioElement(), canplay;
                        for(var i in this.codecs){
                            canplay = audio.canPlayType(this.codecs[i]);
                            if (canplay !== "" && canplay !== "no") this.supported[i] = true;
                            else this.supported[i] = false;
                        }
                    },
                    /**@
         * #Crafty.audio.supports
         * @comp Crafty.audio
         * @kind Method
         *
         * @sign public this Crafty.audio.supports(String extension)
         * @param extension - A file extension to check audio support for
         *
         * Return true if the browser thinks it can play the given file type, otherwise false
         */ supports: function(extension) {
                        // Build cache of supported formats, if necessary
                        if (this.supported === null) this._canPlay();
                        if (this.supported[extension]) return true;
                        else return false;
                    },
                    /**
         * Function to get an Audio Element
         **/ audioElement: function() {
                        //IE does not support Audio Object
                        return typeof Audio !== "undefined" ? new Audio("") : document1.createElement("audio");
                    },
                    /**@
         * #Crafty.audio.create
         * @comp Crafty.audio
         * @kind Method
         * @private
         *
         * @sign public this Crafty.audio.create(String id, String url)
         * @param id - A string to refer to sounds
         * @param url - A string pointing to the sound file
         *
         * Creates an audio asset with the given id and resource.  `Crafty.audio.add` is a more flexible interface that allows cross-browser compatibility.
         *
         * If the sound file extension is not supported, returns false; otherwise, returns the audio asset.
         */ create: function(id, path) {
                        //check extension, return if not supported
                        var ext = path.substr(path.lastIndexOf(".") + 1).toLowerCase();
                        if (!this.supports(ext)) return false;
                        //initiate the audio element
                        var audio = this.audioElement();
                        audio.id = id;
                        audio.preload = "auto";
                        audio.volume = Crafty.audio.volume;
                        audio.src = path;
                        //create an asset and metadata for the audio element
                        Crafty.asset(path, audio);
                        this.sounds[id] = {
                            obj: audio,
                            played: 0,
                            volume: Crafty.audio.volume
                        };
                        return this.sounds[id];
                    },
                    /**@
         * #Crafty.audio.add
         * @comp Crafty.audio
         * @kind Method
         *
         * @sign public this Crafty.audio.add(String id, String url)
         * @param id - A string to refer to sounds
         * @param url - A string pointing to the sound file
         * @sign public this Crafty.audio.add(String id, Array urls)
         * @param urls - Array of urls pointing to different format of the same sound, selecting the first that is playable
         * @sign public this Crafty.audio.add(Object map)
         * @param map - key-value pairs where the key is the `id` and the value is either a `url` or `urls`
         *
         * Loads a sound to be played. Due to the nature of HTML5 audio,
         * three types of audio files will be required for cross-browser capabilities.
         * These formats are MP3, Ogg and WAV.
         *
         * Passing an array of URLs will determine which format the browser can play and select it over any other.
         *
         * Accepts an object where the key is the audio name and
         * either a URL or an Array of URLs (to determine which type to use).
         *
         * The ID you use will be how you refer to that sound when using `Crafty.audio.play`.
         *
         * @example
         * ~~~
         * //adding audio from an object
         * Crafty.audio.add({
         *   shoot: ["sounds/shoot.wav",
         *           "sounds/shoot.mp3",
         *           "sounds/shoot.ogg"]
         * });
         *
         * //adding a single sound
         * Crafty.audio.add("walk", [
         * "sounds/walk.mp3",
         * "sounds/walk.ogg",
         * "sounds/walk.wav"
         * ]);
         *
         * //only one format
         * Crafty.audio.add("jump", "sounds/jump.mp3");
         * ~~~
         */ add: function(id, url) {
                        if (!Crafty.support.audio) return;
                        var src, a;
                        if (arguments.length === 1 && typeof id === "object") {
                            for(var i in id)for(src in id[i]){
                                a = Crafty.audio.create(i, id[i][src]);
                                if (a) break;
                            }
                        }
                        if (typeof id === "string") {
                            if (typeof url === "string") a = Crafty.audio.create(id, url);
                            if (typeof url === "object") for(src in url){
                                a = Crafty.audio.create(id, url[src]);
                                if (a) break;
                            }
                        }
                        return a;
                    },
                    /**@
         * #Crafty.audio.play
         * @comp Crafty.audio
         * @kind Method
         * 
         * @sign public this Crafty.audio.play(String id)
         * @sign public this Crafty.audio.play(String id, Number repeatCount)
         * @sign public this Crafty.audio.play(String id, Number repeatCount, Number volume)
         * @param id - A string to refer to sounds
         * @param repeatCount - Repeat count for the file, where -1 stands for repeat forever.
         * @param volume - volume can be a number between 0.0 and 1.0
         * @returns The audio element used to play the sound.  Null if the call failed due to a lack of open channels.
         *
         * Will play a sound previously added by using the ID that was used in `Crafty.audio.add`.
         * Has a default maximum of 5 channels so that the same sound can play simultaneously unless all of the channels are playing.

         * *Note that the implementation of HTML5 Audio is buggy at best.*
         *
         * @example
         * ~~~
         * Crafty.audio.play("walk");
         *
         * //play and repeat forever
         * Crafty.audio.play("backgroundMusic", -1);
         * Crafty.audio.play("explosion",1,0.5); //play sound once with volume of 50%
         * ~~~
         */ play: function(id, repeat, volume) {
                        if (repeat === 0 || !Crafty.support.audio || !this.sounds[id]) return;
                        var s = this.sounds[id];
                        var c = this.getOpenChannel();
                        if (!c) return null;
                        c.id = id;
                        c.repeat = repeat;
                        var a = c.obj;
                        c.volume = s.volume = s.obj.volume = volume || Crafty.audio.volume;
                        a.volume = s.volume;
                        a.src = s.obj.src;
                        if (this.muted) a.volume = 0;
                        a.play();
                        s.played++;
                        c.onEnd = function() {
                            if (s.played < c.repeat || c.repeat === -1) {
                                if (this.currentTime) this.currentTime = 0;
                                this.play();
                                s.played++;
                            } else {
                                c.active = false;
                                this.pause();
                                this.removeEventListener("ended", c.onEnd, true);
                                this.currentTime = 0;
                                Crafty.trigger("SoundComplete", {
                                    id: c.id
                                });
                            }
                        };
                        a.addEventListener("ended", c.onEnd, true);
                        return a;
                    },
                    /**@
         * #Crafty.audio.setChannels
         * @comp Crafty.audio
         * @kind Method
         *
         * @sign public this Crafty.audio.setChannels(Number n)
         * @param n - The maximum number of channels
         */ maxChannels: 7,
                    setChannels: function(n) {
                        this.maxChannels = n;
                        if (n < this.channels.length) this.channels.length = n;
                    },
                    channels: [],
                    // Finds an unused audio element, marks it as in use, and return it.
                    getOpenChannel: function() {
                        for(var i = 0; i < this.channels.length; i++){
                            var chan = this.channels[i];
                            /*
                   * Second test looks for stuff that's out of use,
                   * but fallen foul of Chromium bug 280417
                   */ if (chan.active === false || chan.obj.ended && chan.repeat <= this.sounds[chan.id].played) {
                                chan.active = true;
                                return chan;
                            }
                        }
                        // If necessary, create a new element, unless we've already reached the max limit
                        if (i < this.maxChannels) {
                            var c = {
                                obj: this.audioElement(),
                                active: true,
                                // Checks that the channel is being used to play sound id
                                _is: function(id) {
                                    return this.id === id && this.active;
                                }
                            };
                            this.channels.push(c);
                            return c;
                        }
                        // In that case, return null
                        return null;
                    },
                    /**@
         * #Crafty.audio.remove
         * @comp Crafty.audio
         * @kind Method
         *
         * @sign public this Crafty.audio.remove([String id])
         * @param id - A string to refer to sounds
         *
         * Will stop the sound and remove all references to the audio object allowing the browser to free the memory.
         * If no id is given, all sounds will be removed.
         *
         * This function uses audio path set in Crafty.path in order to remove sound from the assets object.
         *
         * @example
         * ~~~
         * Crafty.audio.remove("walk");
         * ~~~
         */ remove: function(id) {
                        if (!Crafty.support.audio) return;
                        var s, filename, audioFolder = Crafty.paths().audio;
                        if (!id) {
                            for(var i in this.sounds){
                                s = this.sounds[i];
                                filename = s.obj.src.split("/").pop();
                                Crafty.audio.stop(id);
                                delete Crafty.assets[audioFolder + filename];
                                delete Crafty.assets[s.obj.src];
                                delete Crafty.audio.sounds[id];
                            }
                            return;
                        }
                        if (!this.sounds[id]) return;
                        s = this.sounds[id];
                        filename = s.obj.src.split("/").pop();
                        Crafty.audio.stop(id);
                        delete Crafty.assets[audioFolder + filename];
                        delete Crafty.assets[s.obj.src];
                        delete Crafty.audio.sounds[id];
                    },
                    /**@
         * #Crafty.audio.stop
         * @comp Crafty.audio
         * @kind Method
         *
         * @sign public this Crafty.audio.stop([Number ID])
         *
         * Stops any playing sound. if id is not set, stop all sounds which are playing
         *
         * @example
         * ~~~
         * //all sounds stopped playing now
         * Crafty.audio.stop();
         *
         * ~~~
         */ stop: function(id) {
                        if (!Crafty.support.audio) return;
                        var c;
                        for(var i in this.channels){
                            c = this.channels[i];
                            if (!id && c.active || c._is(id)) {
                                c.active = false;
                                c.obj.pause();
                            }
                        }
                        return;
                    },
                    /**
         * #Crafty.audio._mute
         * @comp Crafty.audio
         * @kind Method
         * @kind private
         *
         * @sign public this Crafty.audio._mute([Boolean mute])
         *
         * Mute or unmute every Audio instance that is playing.
         */ _mute: function(mute) {
                        if (!Crafty.support.audio) return;
                        var c;
                        for(var i in this.channels){
                            c = this.channels[i];
                            c.obj.volume = mute ? 0 : c.volume;
                        }
                        this.muted = mute;
                    },
                    /**@
         * #Crafty.audio.toggleMute
         * @comp Crafty.audio
         * @kind Method
         *
         * @sign public this Crafty.audio.toggleMute()
         *
         * Mute or unmute every Audio instance that is playing. Toggles between
         * pausing or playing depending on the state.
         *
         * @example
         * ~~~
         * //toggle mute and unmute depending on current state
         * Crafty.audio.toggleMute();
         * ~~~
         */ toggleMute: function() {
                        if (!this.muted) this._mute(true);
                        else this._mute(false);
                    },
                    /**@
         * #Crafty.audio.mute
         * @comp Crafty.audio
         * @kind Method
         *
         * @sign public this Crafty.audio.mute()
         *
         * Mute every Audio instance that is playing.
         *
         * @example
         * ~~~
         * Crafty.audio.mute();
         * ~~~
         */ mute: function() {
                        this._mute(true);
                    },
                    /**@
         * #Crafty.audio.unmute
         * @comp Crafty.audio
         * @kind Method
         *
         * @sign public this Crafty.audio.unmute()
         *
         * Unmute every Audio instance that is playing.
         *
         * @example
         * ~~~
         * Crafty.audio.unmute();
         * ~~~
         */ unmute: function() {
                        this._mute(false);
                    },
                    /**@
         * #Crafty.audio.pause
         * @comp Crafty.audio
         * @kind Method
         *
         * @sign public this Crafty.audio.pause(string ID)
         * @param {string} id - The id of the audio object to pause
         *
         * Pause the Audio instance specified by id param.
         *
         * @example
         * ~~~
         * Crafty.audio.pause('music');
         * ~~~
         *
         */ pause: function(id) {
                        if (!Crafty.support.audio || !id || !this.sounds[id]) return;
                        var c;
                        for(var i in this.channels){
                            c = this.channels[i];
                            if (c._is(id) && !c.obj.paused) c.obj.pause();
                        }
                    },
                    /**@
         * #Crafty.audio.unpause
         * @comp Crafty.audio
         * @kind Method
         *
         * @sign public this Crafty.audio.unpause(string ID)
         * @param {string} id - The id of the audio object to unpause
         *
         * Resume playing the Audio instance specified by id param.
         *
         * @example
         * ~~~
         * Crafty.audio.unpause('music');
         * ~~~
         *
         */ unpause: function(id) {
                        if (!Crafty.support.audio || !id || !this.sounds[id]) return;
                        var c;
                        for(var i in this.channels){
                            c = this.channels[i];
                            if (c._is(id) && c.obj.paused) c.obj.play();
                        }
                    },
                    /**@
         * #Crafty.audio.togglePause
         * @comp Crafty.audio
         * @kind Method
         *
         * @sign public this Crafty.audio.togglePause(string ID)
         * @param {string} id - The id of the audio object to pause/
         *
         * Toggle the pause status of the Audio instance specified by id param.
         *
         * @example
         * ~~~
         * Crafty.audio.togglePause('music');
         * ~~~
         *
         */ togglePause: function(id) {
                        if (!Crafty.support.audio || !id || !this.sounds[id]) return;
                        var c;
                        for(var i in this.channels){
                            c = this.channels[i];
                            if (c._is(id)) {
                                if (c.obj.paused) c.obj.play();
                                else c.obj.pause();
                            }
                        }
                    },
                    /**@
         * #Crafty.audio.isPlaying
         * @comp Crafty.audio
         * @kind Method
         *
         * @sign public Boolean Crafty.audio.isPlaying(string ID)
         * @param {string} id - The id of the audio object
         * @return a Boolean indicating whether the audio is playing or not
         *
         * Check if audio with the given ID is playing or not (on at least one channel).
         *
         * @example
         * ~~~
         * var isPlaying = Crafty.audio.isPlaying('music');
         * ~~~
         *
         */ isPlaying: function(id) {
                        if (!Crafty.support.audio) return false;
                        for(var i in this.channels){
                            if (this.channels[i]._is(id)) return true;
                        }
                        return false;
                    }
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    55: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            var M = Math, //Mc = M.cos,
            //Ms = M.sin,
            PI = M.PI, DEG_TO_RAD = PI / 180;
            // These versions of cos and sin ensure that rotations very close to 0 return 0.
            // This avoids some problems where entities are not quite aligned with the grid.
            var rounded_cos = function(drad) {
                var cos = Math.cos(drad);
                cos = -0.0000000001 < cos && cos < 1e-10 ? 0 : cos;
                return cos;
            };
            var rounded_sin = function(drad) {
                var sin = Math.sin(drad);
                sin = -0.0000000001 < sin && sin < 1e-10 ? 0 : sin;
                return sin;
            };
            /**@
 * #2D
 * @category 2D
 * @kind Component
 *
 * Component for any entity that has a position on the stage.
 * @trigger Move - when the entity has moved - { _x:Number, _y:Number, _w:Number, _h:Number } - Old position
 * @trigger Invalidate - when the entity needs to be redrawn
 * @trigger Rotate - when the entity is rotated - { rotation:Number} - Rotation in degrees
 * @trigger Reorder - when the entity's z index has changed
 * @trigger Resize - when the entity's dimensions have changed - { axis: 'w' | 'h', amount: Number }
 */ Crafty.c("2D", {
                /**@
     * #.x
     * @comp 2D
     * @kind Property
     *
     * The `x` position on the stage. When modified, will automatically be redrawn.
     * Is actually a getter/setter so when using this value for calculations and not modifying it,
     * use the `._x` property.
     * @see ._setter2d
     */ _x: 0,
                /**@
     * #.y
     * @kind Property
     *
     * @comp 2D
     * The `y` position on the stage. When modified, will automatically be redrawn.
     * Is actually a getter/setter so when using this value for calculations and not modifying it,
     * use the `._y` property.
     * @see ._setter2d
     */ _y: 0,
                /**@
     * #.w
     * @comp 2D
     * @kind Property
     *
     * The width of the entity. When modified, will automatically be redrawn.
     * Is actually a getter/setter so when using this value for calculations and not modifying it,
     * use the `._w` property.
     *
     * Changing this value is not recommended as canvas has terrible resize quality and DOM will just clip the image.
     * @see ._setter2d
     */ _w: 0,
                /**@
     * #.h
     * @comp 2D
     * @kind Property
     *
     * The height of the entity. When modified, will automatically be redrawn.
     * Is actually a getter/setter so when using this value for calculations and not modifying it,
     * use the `._h` property.
     *
     * Changing this value is not recommended as canvas has terrible resize quality and DOM will just clip the image.
     * @see ._setter2d
     */ _h: 0,
                /**@
     * #.z
     * @comp 2D
     * @kind Property
     *
     * The `z` index on the stage. When modified, will automatically be redrawn.
     * Is actually a getter/setter so when using this value for calculations and not modifying it,
     * use the `._z` property.
     *
     * A higher `z` value will be closer to the front of the stage. A smaller `z` value will be closer to the back.
     * A global Z index is produced based on its `z` value as well as the GID (which entity was created first).
     * Therefore entities will naturally maintain order depending on when it was created if same z value.
     *
     * `z` is required to be an integer, e.g. `z=11.2` is not allowed.
     * @see ._attr
     */ _z: 0,
                /**@
     * #._globalZ
     * @comp 2D
     * @kind Property
     *
     * When two entities overlap, the one with the larger `_globalZ` will be on top of the other.
     */ _globalZ: null,
                /**@
     * #.rotation
     * @comp 2D
     * @kind Property
     *
     * The rotation state of the entity, in clockwise degrees.
     * `this.rotation = 0` sets it to its original orientation; `this.rotation = 10`
     * sets it to 10 degrees clockwise from its original orientation;
     * `this.rotation = -10` sets it to 10 degrees counterclockwise from its
     * original orientation, etc.
     *
     * When modified, will automatically be redrawn. Is actually a getter/setter
     * so when using this value for calculations and not modifying it,
     * use the `._rotation` property.
     *
     * `this.rotation = 0` does the same thing as `this.rotation = 360` or `720` or
     * `-360` or `36000` etc. So you can keep increasing or decreasing the angle for continuous
     * rotation. (Numerical errors do not occur until you get to millions of degrees.)
     *
     * The default is to rotate the entity around its (initial) top-left corner; use
     * `.origin()` to change that.
     *
     * @see ._setter2d, .origin
     */ _rotation: 0,
                _origin: null,
                _mbr: null,
                _entry: null,
                _children: null,
                _parent: null,
                // Setup all the properties that we need to define
                properties: {
                    x: {
                        set: function(v) {
                            this._setter2d("_x", v);
                        },
                        get: function() {
                            return this._x;
                        },
                        configurable: true,
                        enumerable: true
                    },
                    _x: {
                        enumerable: false
                    },
                    y: {
                        set: function(v) {
                            this._setter2d("_y", v);
                        },
                        get: function() {
                            return this._y;
                        },
                        configurable: true,
                        enumerable: true
                    },
                    _y: {
                        enumerable: false
                    },
                    w: {
                        set: function(v) {
                            this._setter2d("_w", v);
                        },
                        get: function() {
                            return this._w;
                        },
                        configurable: true,
                        enumerable: true
                    },
                    _w: {
                        enumerable: false
                    },
                    h: {
                        set: function(v) {
                            this._setter2d("_h", v);
                        },
                        get: function() {
                            return this._h;
                        },
                        configurable: true,
                        enumerable: true
                    },
                    _h: {
                        enumerable: false
                    },
                    z: {
                        set: function(v) {
                            this._setter2d("_z", v);
                        },
                        get: function() {
                            return this._z;
                        },
                        configurable: true,
                        enumerable: true
                    },
                    _z: {
                        enumerable: false
                    },
                    rotation: {
                        set: function(v) {
                            this._setter2d("_rotation", v);
                        },
                        get: function() {
                            return this._rotation;
                        },
                        configurable: true,
                        enumerable: true
                    },
                    _rotation: {
                        enumerable: false
                    },
                    /**@
         * #.ox
         * @comp 2D
         * @kind Property
         *
         * The `x` position on the stage of the origin. When modified, will set the underlying `x` value of the entity.
         *
         * @see .origin
         */ ox: {
                        set: function(v) {
                            var x = v - this._origin.x;
                            this._setter2d("_x", x);
                        },
                        get: function() {
                            return this._x + this._origin.x;
                        },
                        configurable: true,
                        enumerable: true
                    },
                    /**@
         * #.oy
         * @comp 2D
         * @kind Property
         *
         * The `y` position on the stage of the origin. When modified, will set the underlying `y` value of the entity.
         *
         * @see .origin
         */ oy: {
                        set: function(v) {
                            var y = v - this._origin.y;
                            this._setter2d("_y", y);
                        },
                        get: function() {
                            return this._y + this._origin.y;
                        },
                        configurable: true,
                        enumerable: true
                    }
                },
                init: function() {
                    this._globalZ = this[0];
                    this._origin = {
                        x: 0,
                        y: 0
                    };
                    // offsets for the basic bounding box
                    this._bx1 = 0;
                    this._bx2 = 0;
                    this._by1 = 0;
                    this._by2 = 0;
                    this._children = [];
                    //insert self into the HashMap
                    this._entry = Crafty.map.insert(this);
                    //when object changes, update HashMap
                    this.bind("Move", function(e) {
                        // Choose the largest bounding region that exists
                        var area = this._cbr || this._mbr || this;
                        this._entry.update(area);
                        // Move children (if any) by the same amount
                        if (this._children.length > 0) this._cascade(e);
                    });
                    this.bind("Rotate", function(e) {
                        // Choose the largest bounding region that exists
                        var old = this._cbr || this._mbr || this;
                        this._entry.update(old);
                        // Rotate children (if any) by the same amount
                        if (this._children.length > 0) this._cascadeRotation(e);
                    });
                    //when object is removed, remove from HashMap and destroy attached children
                    this.bind("Remove", function() {
                        if (this._children) {
                            for(var i = 0; i < this._children.length; i++){
                                // delete the child's _parent link, or else the child will splice itself out of
                                // this._children while destroying itself (which messes up this for-loop iteration).
                                delete this._children[i]._parent;
                                // Destroy child if possible (It's not always possible, e.g. the polygon attached
                                // by areaMap has no .destroy(), it will just get garbage-collected.)
                                if (this._children[i].destroy) this._children[i].destroy();
                            }
                            this._children = [];
                        }
                        if (this._parent) this._parent.detach(this);
                        Crafty.map.remove(this._entry);
                        this.detach();
                    });
                },
                events: {
                    Freeze: function() {
                        Crafty.map.remove(this._entry);
                    },
                    Unfreeze: function() {
                        this._entry = Crafty.map.insert(this, this._entry);
                    }
                },
                /**@
     * #.offsetBoundary
     * @comp 2D
     * @kind Method
     *
     * Extends the MBR of the entity by a specified amount.
     *
     * @trigger BoundaryOffset - when the MBR offset changes
     * @sign public this .offsetBoundary(Number dx1, Number dy1, Number dx2, Number dy2)
     * @param dx1 - Extends the MBR to the left by this amount
     * @param dy1 - Extends the MBR upward by this amount
     * @param dx2 - Extends the MBR to the right by this amount
     * @param dy2 - Extends the MBR downward by this amount
     *
     * @sign public this .offsetBoundary(Number offset)
     * @param offset - Extend the MBR in all directions by this amount
     *
     * You would most likely use this function to ensure that custom canvas rendering beyond the extent of the entity's normal bounds is not clipped.
     */ offsetBoundary: function(x1, y1, x2, y2) {
                    if (arguments.length === 1) y1 = x2 = y2 = x1;
                    this._bx1 = x1;
                    this._bx2 = x2;
                    this._by1 = y1;
                    this._by2 = y2;
                    this.trigger("BoundaryOffset");
                    this._calculateMBR();
                    return this;
                },
                /**
     * Calculates the MBR when rotated some number of radians about an origin point o.
     * Necessary on a rotation, or a resize
     */ _calculateMBR: function() {
                    var ox = this._origin.x + this._x, oy = this._origin.y + this._y, rad = -this._rotation * DEG_TO_RAD;
                    // axis-aligned (unrotated) coordinates, relative to the origin point
                    var dx1 = this._x - this._bx1 - ox, dx2 = this._x + this._w + this._bx2 - ox, dy1 = this._y - this._by1 - oy, dy2 = this._y + this._h + this._by2 - oy;
                    var ct = rounded_cos(rad), st = rounded_sin(rad);
                    // Calculate the new points relative to the origin, then find the new (absolute) bounding coordinates!
                    var x0 = dx1 * ct + dy1 * st, y0 = -dx1 * st + dy1 * ct, x1 = dx2 * ct + dy1 * st, y1 = -dx2 * st + dy1 * ct, x2 = dx2 * ct + dy2 * st, y2 = -dx2 * st + dy2 * ct, x3 = dx1 * ct + dy2 * st, y3 = -dx1 * st + dy2 * ct, minx = Math.floor(Math.min(x0, x1, x2, x3) + ox), miny = Math.floor(Math.min(y0, y1, y2, y3) + oy), maxx = Math.ceil(Math.max(x0, x1, x2, x3) + ox), maxy = Math.ceil(Math.max(y0, y1, y2, y3) + oy);
                    if (!this._mbr) this._mbr = {
                        _x: minx,
                        _y: miny,
                        _w: maxx - minx,
                        _h: maxy - miny
                    };
                    else {
                        this._mbr._x = minx;
                        this._mbr._y = miny;
                        this._mbr._w = maxx - minx;
                        this._mbr._h = maxy - miny;
                    }
                    // If a collision hitbox exists AND sits outside the entity, find a bounding box for both.
                    // `_cbr` contains information about a bounding circle of the hitbox.
                    // The bounds of `_cbr` will be the union of the `_mbr` and the bounding box of that circle.
                    // This will not be a minimal region, but since it's only used for the broad phase pass it's good enough.
                    //
                    // cbr is calculated by the `_checkBounds` method of the "Collision" component
                    if (this._cbr) {
                        var cbr = this._cbr;
                        var cx = cbr.cx, cy = cbr.cy, r = cbr.r;
                        var cx2 = ox + (cx + this._x - ox) * ct + (cy + this._y - oy) * st;
                        var cy2 = oy - (cx + this._x - ox) * st + (cy + this._y - oy) * ct;
                        cbr._x = Math.min(cx2 - r, minx);
                        cbr._y = Math.min(cy2 - r, miny);
                        cbr._w = Math.max(cx2 + r, maxx) - cbr._x;
                        cbr._h = Math.max(cy2 + r, maxy) - cbr._y;
                    }
                },
                /**
     * Handle changes that need to happen on a rotation
     */ _rotate: function(v) {
                    //var theta = -1 * (v % 360); //angle always between 0 and 359
                    var difference = this._rotation - v;
                    // skip if there's no rotation!
                    if (difference === 0) return;
                    else this._rotation = v;
                    this._calculateMBR();
                    this.trigger("Rotate", difference);
                },
                /**@
     * #.area
     * @comp 2D
     * @kind Method
     *
     * @sign public Number .area(void)
     * Calculates the area of the entity
     */ area: function() {
                    return this._w * this._h;
                },
                /**@
     * #.intersect
     * @comp 2D
     * @kind Method
     *
     * @sign public Boolean .intersect(Number x, Number y, Number w, Number h)
     * @param x - X position of the rect
     * @param y - Y position of the rect
     * @param w - Width of the rect
     * @param h - Height of the rect
     * @sign public Boolean .intersect(Object rect)
     * @param rect - An object that must have the `_x, _y, _w, _h` values as properties
     *
     * Determines if this entity intersects a rectangle.  If the entity is rotated, its MBR is used for the test.
     */ intersect: function(x, y, w, h) {
                    var rect, mbr = this._mbr || this;
                    if (typeof x === "object") rect = x;
                    else rect = {
                        _x: x,
                        _y: y,
                        _w: w,
                        _h: h
                    };
                    return mbr._x < rect._x + rect._w && mbr._x + mbr._w > rect._x && mbr._y < rect._y + rect._h && mbr._y + mbr._h > rect._y;
                },
                /**@
     * #.within
     * @comp 2D
     * @kind Method
     *
     * @sign public Boolean .within(Number x, Number y, Number w, Number h)
     * @param x - X position of the rect
     * @param y - Y position of the rect
     * @param w - Width of the rect
     * @param h - Height of the rect
     * @sign public Boolean .within(Object rect)
     * @param rect - An object that must have the `_x, _y, _w, _h` values as properties
     *
     * Determines if this current entity is within another rectangle.
     */ within: function(x, y, w, h) {
                    var rect, mbr = this._mbr || this;
                    if (typeof x === "object") rect = x;
                    else rect = {
                        _x: x,
                        _y: y,
                        _w: w,
                        _h: h
                    };
                    return rect._x <= mbr._x && rect._x + rect._w >= mbr._x + mbr._w && rect._y <= mbr._y && rect._y + rect._h >= mbr._y + mbr._h;
                },
                /**@
     * #.contains
     * @comp 2D
     * @kind Method
     *
     * @sign public Boolean .contains(Number x, Number y, Number w, Number h)
     * @param x - X position of the rect
     * @param y - Y position of the rect
     * @param w - Width of the rect
     * @param h - Height of the rect
     * @sign public Boolean .contains(Object rect)
     * @param rect - An object that must have the `_x, _y, _w, _h` values as properties.
     *
     * Determines if the rectangle is within the current entity.  If the entity is rotated, its MBR is used for the test.
     */ contains: function(x, y, w, h) {
                    var rect, mbr = this._mbr || this;
                    if (typeof x === "object") rect = x;
                    else rect = {
                        _x: x,
                        _y: y,
                        _w: w,
                        _h: h
                    };
                    return rect._x >= mbr._x && rect._x + rect._w <= mbr._x + mbr._w && rect._y >= mbr._y && rect._y + rect._h <= mbr._y + mbr._h;
                },
                /**@
     * #.pos
     * @comp 2D
     * @kind Method
     *
     * @sign public Object .pos([Object pos])
     * @param pos - an object to use as output
     * @returns an object with `_x`, `_y`, `_w`, and `_h` properties; if an object is passed in, it will be reused rather than creating a new object.
     *
     * Return an object containing a copy of this entity's bounds (`_x`, `_y`, `_w`, and `_h` values).
     *
     * @note The keys have an underscore prefix. This is due to the x, y, w, h properties
     * being setters and getters that wrap the underlying properties with an underscore (_x, _y, _w, _h).
     */ pos: function(pos) {
                    pos = pos || {};
                    pos._x = this._x;
                    pos._y = this._y;
                    pos._w = this._w;
                    pos._h = this._h;
                    return pos;
                },
                /**@
     * #.mbr
     * @comp 2D
     * @kind Method
     *
     * @sign public Object .mbr([Object mbr])
     * @param mbr - an object to use as output
     * @returns an object with `_x`, `_y`, `_w`, and `_h` properties; if an object is passed in, it will be reused rather than creating a new object.
     *
     * Return an object containing a copy of this entity's minimum bounding rectangle.
     * The MBR encompasses a rotated entity's bounds.
     * If there is no rotation on the entity it will return its bounds (`.pos()`) instead.
     *
     * @note The keys have an underscore prefix. This is due to the x, y, w, h properties
     * being setters and getters that wrap the underlying properties with an underscore (_x, _y, _w, _h).
     *
     * @see .pos
     */ mbr: function(mbr) {
                    mbr = mbr || {};
                    if (!this._mbr) return this.pos(mbr);
                    else {
                        mbr._x = this._mbr._x;
                        mbr._y = this._mbr._y;
                        mbr._w = this._mbr._w;
                        mbr._h = this._mbr._h;
                        return mbr;
                    }
                },
                /**@
     * #.isAt
     * @comp 2D
     * @kind Method
     *
     * @sign public Boolean .isAt(Number x, Number y)
     * @param x - X position of the point
     * @param y - Y position of the point
     *
     * Determines whether a point is contained by the entity. Unlike other methods,
     * an object can't be passed. The arguments require the x and y value.
     *
     * The given point is tested against the first of the following that exists: a mapArea associated with "Mouse", the hitarea associated with "Collision", or the object's MBR.
     */ isAt: function(x, y) {
                    if (this.mapArea) return this.mapArea.containsPoint(x, y);
                    else if (this.map) return this.map.containsPoint(x, y);
                    var mbr = this._mbr || this;
                    return mbr._x <= x && mbr._x + mbr._w >= x && mbr._y <= y && mbr._y + mbr._h >= y;
                },
                /**@
     * #.move
     * @comp 2D
     * @kind Method
     *
     * @sign public this .move(String dir, Number by)
     * @param dir - Direction to move (n,s,e,w,ne,nw,se,sw)
     * @param by - Amount to move in the specified direction
     *
     * Quick method to move the entity in a direction (n, s, e, w, ne, nw, se, sw) by an amount of pixels.
     */ move: function(dir, by) {
                    if (dir.charAt(0) === "n") this.y -= by;
                    if (dir.charAt(0) === "s") this.y += by;
                    if (dir === "e" || dir.charAt(1) === "e") this.x += by;
                    if (dir === "w" || dir.charAt(1) === "w") this.x -= by;
                    return this;
                },
                /**@
     * #.shift
     * @comp 2D
     * @kind Method
     *
     * @sign public this .shift(Number x, Number y, Number w, Number h)
     * @param x - Amount to move X
     * @param y - Amount to move Y
     * @param w - Amount to widen
     * @param h - Amount to increase height
     *
     * Shift or move the entity by an amount. Use negative values
     * for an opposite direction.
     */ shift: function(x, y, w, h) {
                    if (x || y) this._setPosition(this._x + x, this._y + y);
                    if (w) this.w += w;
                    if (h) this.h += h;
                    return this;
                },
                /**@
     * #._cascade
     * @comp 2D
     * @kind Method
     * @private
     *
     * @sign public void ._cascade(e)
     * @param e - An object describing the motion
     *
     * Move the entity's children according to a certain motion.
     * This method is part of a function bound to "Move": It is used
     * internally for ensuring that when a parent moves, the child also
     * moves in the same way.
     */ _cascade: function(e) {
                    if (!e) return;
                    //use current position
                    var dx = this._x - e._x, dy = this._y - e._y, dw = this._w - e._w, dh = this._h - e._h;
                    this._cascadeInner(dx, dy, dw, dh);
                },
                _cascadeInner: function(dx, dy, dw, dh) {
                    var i = 0, children = this._children, l = children.length, obj;
                    for(; i < l; ++i){
                        obj = children[i];
                        if (obj.__frozen) continue;
                        obj.shift(dx, dy, dw, dh);
                    }
                },
                /**@
     * #._cascadeRotation
     * @comp 2D
     * @kind Method
     * @private
     *
     * @sign public void ._cascade(deg)
     * @param deg - The amount of rotation in degrees
     *
     * Move the entity's children the specified amount
     * This method is part of a function bound to "Move": It is used
     * internally for ensuring that when a parent moves, the child also
     * moves in the same way.
     */ _cascadeRotation: function(deg) {
                    if (!deg) return;
                    var i = 0, children = this._children, l = children.length, obj;
                    // precalculate rotation info
                    var drad = deg * DEG_TO_RAD;
                    var cos = rounded_cos(drad);
                    var sin = rounded_sin(drad);
                    var ox = this._origin.x + this._x;
                    var oy = this._origin.y + this._y;
                    for(; i < l; ++i){
                        obj = children[i];
                        if (obj.__frozen) continue;
                        if ("rotate" in obj) obj.rotate(deg, ox, oy, cos, sin);
                    }
                },
                /**@
     * #.attach
     * @comp 2D
     * @kind Method
     *
     * @sign public this .attach(Entity obj[, .., Entity objN])
     * @param obj - Child entity(s) to attach
     *
     * Sets one or more entities to be children, with the current entity (`this`)
     * as the parent. When the parent moves or rotates, its children move or
     * rotate by the same amount. (But not vice-versa: If you move a child, it
     * will not move the parent.) When the parent is destroyed, its children are
     * destroyed.
     *
     * For any entity, `this._children` is the array of its children entity
     * objects (if any), and `this._parent` is its parent entity object (if any).
     *
     * As many objects as wanted can be attached, and a hierarchy of objects is
     * possible by attaching.
     */ attach: function() {
                    var i = 0, arg = arguments, l = arguments.length, obj;
                    for(; i < l; ++i){
                        obj = arg[i];
                        if (obj._parent) obj._parent.detach(obj);
                        obj._parent = this;
                        this._children.push(obj);
                    }
                    return this;
                },
                /**@
     * #.detach
     * @comp 2D
     * @kind Method
     *
     * @sign public this .detach([Entity obj])
     * @param obj - The entity to detach. Left blank will remove all attached entities
     *
     * Stop an entity from following the current entity. Passing no arguments will stop
     * every entity attached.
     */ detach: function(obj) {
                    var i;
                    //if nothing passed, remove all attached objects
                    if (!obj) {
                        for(i = 0; i < this._children.length; i++)this._children[i]._parent = null;
                        this._children = [];
                        return this;
                    }
                    //if obj passed, find the handler and unbind
                    for(i = 0; i < this._children.length; i++)if (this._children[i] === obj) this._children.splice(i, 1);
                    obj._parent = null;
                    return this;
                },
                /**@
     * #.origin
     * @comp 2D
     * @kind Method
     *
     * @sign public this .origin(Number x, Number y)
     * @param x - Pixel value of origin offset on the X axis
     * @param y - Pixel value of origin offset on the Y axis
     *
     * @sign public this .origin(String offset)
     * @param offset - Alignment identifier, which is a combination of center, top, bottom, middle, left and right
     *
     * Set the origin point of an entity for it to rotate around.
     *
     * The properties `ox` and `oy` map to the coordinates of the origin on the stage; setting them moves the entity.
     * In contrast, this method sets the origin relative to the entity itself.
     *
     * @triggers OriginChanged -- after the new origin is assigned
     *
     * @example
     * ~~~
     * this.origin("top left")
     * this.origin("center")
     * this.origin("bottom right")
     * this.origin("middle right")
     * ~~~
     *
     * The origin should be set before changing the `rotation`,
     * since it does not apply retroactively.
     * Additionally, setting the origin via an alignment identifier works only
     * after the entity's dimensions have been set.
     * These points are shown in the following example:
     *
     * @example
     * ~~~
     * Crafty.e("2D")
     *       .attr({w: 100, h: 100})
     *       .origin('center')
     *       .attr({x: 25, y: 25, rotation: 180});
     * ~~~
     *
     * @see .rotation, .ox, .oy
     */ origin: function(x, y) {
                    //text based origin
                    if (typeof x === "string") {
                        if (x === "centre" || x === "center" || x.indexOf(" ") === -1) {
                            x = this._w / 2;
                            y = this._h / 2;
                        } else {
                            var cmd = x.split(" ");
                            if (cmd[0] === "top") y = 0;
                            else if (cmd[0] === "bottom") y = this._h;
                            else if (cmd[0] === "middle" || cmd[1] === "center" || cmd[1] === "centre") y = this._h / 2;
                            if (cmd[1] === "center" || cmd[1] === "centre" || cmd[1] === "middle") x = this._w / 2;
                            else if (cmd[1] === "left") x = 0;
                            else if (cmd[1] === "right") x = this._w;
                        }
                    }
                    // When entity is rotated, we'll need to shift attached entities on origin change
                    // The below transformation is equivalent to unrotating, shifting the origin,
                    // and then rotating around this new origin
                    if (this.rotation) {
                        var rad = -this._rotation * DEG_TO_RAD;
                        var d_ox = x - this._origin.x;
                        var d_oy = y - this._origin.y;
                        var cos = rounded_cos(rad);
                        var sin = rounded_sin(rad);
                        var dx = d_ox * (1 - cos) - d_oy * sin;
                        var dy = d_oy * (1 - cos) + d_ox * sin;
                        this._cascadeInner(dx, dy, 0, 0);
                    }
                    this._origin.x = x;
                    this._origin.y = y;
                    if (this._mbr) this._calculateMBR();
                    // Update position in spatial map
                    this._entry.update(this._cbr || this._mbr || this);
                    this.trigger("OriginChanged");
                    this.trigger("Invalidate");
                    return this;
                },
                /**
     * Method for rotation rather than through a setter
     *
     * Pass in degree amount, origin coordinate and precalculated cos/sin
     */ rotate: function(deg, ox, oy, cos, sin) {
                    var x2, y2;
                    x2 = (this._x + this._origin.x - ox) * cos + (this._y + this._origin.y - oy) * sin + (ox - this._origin.x);
                    y2 = (this._y + this._origin.y - oy) * cos - (this._x + this._origin.x - ox) * sin + (oy - this._origin.y);
                    this._setter2d("_rotation", this._rotation - deg);
                    this._setter2d("_x", x2);
                    this._setter2d("_y", y2);
                },
                // A separate setter for the common case of moving an entity along both axes
                _setPosition: function(x, y) {
                    if (x === this._x && y === this._y) return;
                    var old = Crafty.rectManager._pool.copy(this);
                    var mbr = this._mbr;
                    if (mbr) {
                        mbr._x -= this._x - x;
                        mbr._y -= this._y - y;
                        // cbr is a non-minimal bounding rectangle that contains both hitbox and mbr
                        // It will exist only when the collision hitbox sits outside the entity
                        if (this._cbr) {
                            this._cbr._x -= this._x - x;
                            this._cbr._y -= this._y - y;
                        }
                    }
                    this._x = x;
                    this._y = y;
                    this.trigger("Move", old);
                    this.trigger("Invalidate");
                    Crafty.rectManager._pool.recycle(old);
                },
                // This is a setter method for all 2D properties including
                // x, y, w, h, and rotation.
                _setter2d: function(name, value) {
                    // Return if there is no change
                    if (this[name] === value) return;
                    //keep a reference of the old positions
                    var old = Crafty.rectManager._pool.copy(this);
                    var mbr;
                    //if rotation, use the rotate method
                    if (name === "_rotation") this._rotate(value); // _rotate triggers "Rotate"
                    else if (name === "_x" || name === "_y") {
                        // mbr is the minimal bounding rectangle of the entity
                        mbr = this._mbr;
                        if (mbr) {
                            mbr[name] -= this[name] - value;
                            // cbr is a non-minimal bounding rectangle that contains both hitbox and mbr
                            // It will exist only when the collision hitbox sits outside the entity
                            if (this._cbr) this._cbr[name] -= this[name] - value;
                        }
                        this[name] = value;
                        this.trigger("Move", old);
                    } else if (name === "_h" || name === "_w") {
                        mbr = this._mbr;
                        var oldValue = this[name];
                        this[name] = value;
                        if (mbr) this._calculateMBR();
                        if (name === "_w") this.trigger("Resize", {
                            axis: "w",
                            amount: value - oldValue
                        });
                        else if (name === "_h") this.trigger("Resize", {
                            axis: "h",
                            amount: value - oldValue
                        });
                        this.trigger("Move", old);
                    } else if (name === "_z") {
                        var intValue = value << 0;
                        value = value === intValue ? intValue : intValue + 1;
                        this._globalZ = value * 100000 + this[0]; //magic number 10^5 is the max num of entities
                        this[name] = value;
                        this.trigger("Reorder");
                    }
                    //everything will assume the value
                    this[name] = value;
                    // flag for redraw
                    this.trigger("Invalidate");
                    Crafty.rectManager._pool.recycle(old);
                }
            });
            /**@
 * #Crafty.polygon
 * @category 2D
 * @kind Class
 *
 * The constructor for a polygon object used for hitboxes and click maps. Takes a set of points as an
 * argument, giving alternately the x and y coordinates of the polygon's vertices in order.
 *
 * For a polygon of `n` edges exactly `n` vertex coordinate pairs should be passed to the constructor.
 * It is advised to pass the vertices in a clockwise order.
 *
 * The constructor accepts the coordinates as either a single array or as a set of individual arguments.
 * If passed an array, the current implementation will use that array internally -- do not attempt to reuse it.
 *
 * When creating a polygon for an entity, each point should be offset or relative from the entities `x` and `y`
 * (don't include the absolute values as it will automatically calculate this).
 *
 *
 * @example
 * Two ways to create a triangle with vertices at `(50, 0)`, `(100, 100)` and `(0, 100)`.
 * ~~~
 * new Crafty.polygon([50, 0, 100, 100, 0, 100]);
 * new Crafty.polygon(50, 0, 100, 100, 0, 100);
 * ~~~
 */ Crafty.polygon = function(poly) {
                if (arguments.length > 1) poly = Array.prototype.slice.call(arguments, 0);
                this.points = poly;
            };
            Crafty.polygon.prototype = {
                /**@
     * #.containsPoint
     * @comp Crafty.polygon
     * @kind Method
     *
     * @sign public Boolean .containsPoint(Number x, Number y)
     * @param x - X position of the point
     * @param y - Y position of the point
     *
     * Method is used to determine if a given point is contained by the polygon.
     *
     * @example
     * ~~~
     * var poly = new Crafty.polygon([50, 0, 100, 100, 0, 100]);
     * poly.containsPoint(50, 50); //TRUE
     * poly.containsPoint(0, 0); //FALSE
     * ~~~
     */ containsPoint: function(x, y) {
                    var p = this.points, l = p.length / 2, i, j, c = false;
                    for(i = 0, j = l - 1; i < l; j = i++)if (p[2 * i + 1] > y !== p[2 * j + 1] > y && x < (p[2 * j] - p[2 * i]) * (y - p[2 * i + 1]) / (p[2 * j + 1] - p[2 * i + 1]) + p[2 * i]) c = !c;
                    return c;
                },
                /**@
     * #.shift
     * @comp Crafty.polygon
     * @kind Method
     *
     * @sign public void .shift(Number x, Number y)
     * @param x - Amount to shift the `x` axis
     * @param y - Amount to shift the `y` axis
     *
     * Shifts every single point in the polygon by the specified amount.
     *
     * @example
     * ~~~
     * var poly = new Crafty.polygon([50, 0, 100, 100, 0, 100]);
     * poly.shift(5,5);
     * //[[55, 5, 105, 5, 5, 105];
     * ~~~
     */ shift: function(x, y) {
                    var i = 0, p = this.points, l = p.length;
                    for(; i < l; i += 2){
                        p[i] += x;
                        p[i + 1] += y;
                    }
                },
                /**@
     * #.clone
     * @comp Crafty.polygon
     * @kind Method
     *
     * @sign public void .clone()
     *
     * Returns a clone of the polygon.
     *
     * @example
     * ~~~
     * var poly = new Crafty.polygon([50, 0, 100, 100, 0, 100]);
     * var shiftedpoly = poly.clone().shift(5,5);
     * //[55, 5, 105, 5, 5, 105], but the original polygon is unchanged
     * ~~~
     */ clone: function() {
                    //Shallow clone, but points should be full of Number primitives that are copied
                    return new Crafty.polygon(this.points.slice(0));
                },
                rotate: function(deg, ox, oy, cos, sin) {
                    var i = 0, p = this.points, l = p.length, x, y;
                    for(; i < l; i += 2){
                        x = ox + (p[i] - ox) * cos + (p[i + 1] - oy) * sin;
                        y = oy - (p[i] - ox) * sin + (p[i + 1] - oy) * cos;
                        p[i] = x;
                        p[i + 1] = y;
                    }
                },
                /**@
     * #.intersectRay
     * @comp Crafty.polygon
     * @kind Method
     *
     * @sign public Number .intersectRay(Object origin, Object direction)
     * @param origin - the point of origin from which the ray will be cast. The object must contain the properties `_x` and `_y`.
     * @param direction - the direction the ray will be cast. It must be normalized. The object must contain the properties `x` and `y`.
     * @returns a Number indicating the distance from the ray's origin to the closest intersection point of the polygon.
     *          Returns `Infinity` if there is no intersection.
     *
     * Find the distance to the closest intersection point of the supplied ray with any of this polygon's segments.
     *
     * @example
     * ~~~
     * var poly = new Crafty.polygon([0,0, 50,0, 50,50, 0,50]);
     *
     * var origin = {_x: -1, _y: 25};
     * var direction = new Crafty.math.Vector2D(1, 0).normalize();;
     *
     * var distance = poly.intersectRay(origin, direction);
     * Crafty.log('Distance from origin to closest intersection point', distance); // logs '1'
     * ~~~
     */ // Note that for the algorithm to work, the points of the polygon have to be defined
                // either clock-wise or counter-clock-wise
                //
                // Segment-segment intersection is described here: http://stackoverflow.com/a/565282/3041008
                // see dot projection: http://www.wildbunny.co.uk/blog/vector-maths-a-primer-for-games-programmers/vector/#Projection
                //
                // origin = {_x, _y}
                // direction = {x, y}, must be normalized
                // edge = end - start (of segment)
                //
                //
                // # Segment - segment intersection equation
                // origin + d * direction = start + e * edge
                //
                // ## Solving for d
                // (origin + d * direction) x edge = (start + e * edge) x edge
                // edge x edge == 0
                // d = (start − origin) × edge / (direction × edge)
                // d_nominator = (start - origin) x edge =
                //      (start.x - origin.x, start.y - origin.y) x (edge.x, edge.y) =
                //      (start.x - origin.x) * edge.y - (start.y - origin.y) * edge.x
                // d_denominator = direction x edge =
                //      (direction.x, direction.y) x (edge.x, edge.y) =
                //      direction.x * edge.y - direction.y * edge.x
                //
                // ## Solving for e
                // (origin + d * direction) x direction = (start + e * edge) x direction
                // direction x direction == 0
                // edge factor must be in interval [0, 1]
                // e = (start − origin) × direction / (direction × edge)
                // e_nominator = (start − origin) × direction =
                //      (start.x - origin.x) * direction.y - (start.y - origin.y) * direction.x
                // e_denominator = d_denominator
                //
                //
                // # If segments are colinear (both nominator and denominator == 0),
                //    then minDistance is min(d0, d1) >= 0,
                //    get d0, d1 by doing dot projection onto normalized direction vector
                //
                // origin + d0*direction = start
                // d0*direction = (start - origin)
                // -> d0 = (start - origin) • direction =
                //      (start.x - origin.x, start.y - origin.y) • (direction.x, direction.y) =
                //      (start.x - origin.x) * direction.x + (start.y - origin.y) * direction.y
                //
                // origin + d1*direction = end
                // d1*direction = end - origin
                // -> d1 = (end - origin) • direction =
                //      (end.x - origin.x, end.y - origin.y) • (direction.x, direction.y) =
                //      (end.x - origin.x) * direction.x + (end.y - origin.y) * direction.y
                intersectRay: function(origin, direction) {
                    var points = this.points, minDistance = Infinity;
                    var d, d_nom, e, e_nom, denom;
                    var originX = origin._x, directionX = direction.x, originY = origin._y, directionY = direction.y;
                    var i = 0, l = points.length;
                    var startX = points[l - 2], endX, edgeX, startY = points[l - 1], endY, edgeY;
                    for(; i < l; i += 2){
                        endX = points[i];
                        endY = points[i + 1];
                        edgeX = endX - startX;
                        edgeY = endY - startY;
                        d_nom = (startX - originX) * edgeY - (startY - originY) * edgeX;
                        e_nom = (startX - originX) * directionY - (startY - originY) * directionX;
                        denom = directionX * edgeY - directionY * edgeX;
                        if (denom !== 0) {
                            d = d_nom / denom;
                            e = e_nom / denom;
                            if (e >= 0 && e <= 1 && d >= 0 && d < minDistance) minDistance = d;
                        } else if (d_nom === 0 || e_nom === 0) {
                            d = (startX - originX) * directionX + (startY - originY) * directionY;
                            if (d >= 0 && d < minDistance) minDistance = d;
                            d = (endX - originX) * directionX + (endY - originY) * directionY;
                            if (d >= 0 && d < minDistance) minDistance = d;
                        }
                        startX = endX;
                        startY = endY;
                    }
                    return minDistance;
                }
            };
            /**@
 * #Crafty.circle
 * @category 2D
 * @kind Class
 *
 * Circle object used for hitboxes and click maps. Must pass a `x`, a `y` and a `radius` value.
 *
 *@example
 * ~~~
 * var centerX = 5,
 *     centerY = 10,
 *     radius = 25;
 *
 * new Crafty.circle(centerX, centerY, radius);
 * ~~~
 *
 * When creating a circle for an entity, each point should be offset or relative from the entities `x` and `y`
 * (don't include the absolute values as it will automatically calculate this).
 */ Crafty.circle = function(x, y, radius) {
                this.x = x;
                this.y = y;
                this.radius = radius;
                // Creates an octagon that approximate the circle for backward compatibility.
                this.points = [];
                var theta;
                for(var i = 0; i < 16; i += 2){
                    theta = i * Math.PI / 8;
                    this.points[i] = this.x + Math.sin(theta) * radius;
                    this.points[i + 1] = this.y + Math.cos(theta) * radius;
                }
            };
            Crafty.circle.prototype = {
                /**@
     * #.containsPoint
     * @comp Crafty.circle
     * @kind Method
     *
     * @sign public Boolean .containsPoint(Number x, Number y)
     * @param x - X position of the point
     * @param y - Y position of the point
     *
     * Method is used to determine if a given point is contained by the circle.
     *
     * @example
     * ~~~
     * var circle = new Crafty.circle(0, 0, 10);
     * circle.containsPoint(0, 0); //TRUE
     * circle.containsPoint(50, 50); //FALSE
     * ~~~
     */ containsPoint: function(x, y) {
                    var radius = this.radius, deltaX = this.x - x, deltaY = this.y - y;
                    return deltaX * deltaX + deltaY * deltaY < radius * radius;
                },
                /**@
     * #.shift
     * @comp Crafty.circle
     * @kind Method
     *
     * @sign public void .shift(Number x, Number y)
     * @param x - Amount to shift the `x` axis
     * @param y - Amount to shift the `y` axis
     *
     * Shifts the circle by the specified amount.
     *
     * @example
     * ~~~
     * var circle = new Crafty.circle(0, 0, 10);
     * circle.shift(5,5);
     * //{x: 5, y: 5, radius: 10};
     * ~~~
     */ shift: function(x, y) {
                    this.x += x;
                    this.y += y;
                    var i = 0, p = this.points, l = p.length;
                    for(; i < l; i += 2){
                        p[i] += x;
                        p[i + 1] += y;
                    }
                },
                rotate: function() {
                // We are a circle, we don't have to rotate :)
                }
            };
            Crafty.matrix = function(m) {
                this.mtx = m;
                this.width = m[0].length;
                this.height = m.length;
            };
            Crafty.matrix.prototype = {
                x: function(other) {
                    if (this.width !== other.height) return;
                    var result = [];
                    for(var i = 0; i < this.height; i++){
                        result[i] = [];
                        for(var j = 0; j < other.width; j++){
                            var sum = 0;
                            for(var k = 0; k < this.width; k++)sum += this.mtx[i][k] * other.mtx[k][j];
                            result[i][j] = sum;
                        }
                    }
                    return new Crafty.matrix(result);
                },
                e: function(row, col) {
                    //test if out of bounds
                    if (row < 1 || row > this.mtx.length || col < 1 || col > this.mtx[0].length) return null;
                    return this.mtx[row - 1][col - 1];
                }
            };
        },
        {
            "../core/core.js": 10
        }
    ],
    56: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js"), DEG_TO_RAD = Math.PI / 180, EPSILON = 1e-6;
            Crafty.extend({
                /**@
     * #Crafty.raycast
     * @category 2D
     * @kind Method
     *
     * @sign public Array .raycast(Object origin, Object direction[, Number maxDistance][, String comp][, Boolean sort])
     * @param origin - the point of origin from which the ray will be cast. The object must contain the properties `_x` and `_y`.
     * @param direction - the direction the ray will be cast. It must be normalized. The object must contain the properties `x` and `y`.
     * @param maxDistance - the maximum distance up to which intersections will be found.
     *                      This is an optional parameter defaulting to `Infinity`.
     *                      If it's `Infinity` find all intersections.
     *                      If it's negative find only first intersection (if there is one).
     *                      If it's positive find all intersections up to that distance.
     * @param comp - check for intersection with entities that have this component applied to them.
     *               This is an optional parameter that is disabled by default.
     * @param sort - whether to sort the returned array by increasing distance.
     *               May be disabled to slightly improve performance if sorted results are not needed.
     *               Defaults to `true`.
     * @returns an array of raycast-results that may be empty, if no intersection has been found.
     *          Otherwise, each raycast-result looks like `{obj: Entity, distance: Number, x: Number, y: Number}`,
     *          describing which `obj` entity has intersected the ray at intersection point `x`,`y`, `distance` px away from `origin`.
     *
     * Cast a ray from its `origin` in the `direction` and
     * report entities that intersect with it, given the parameter constraints.
     *
     * Raycasting only reports entities, that have the `Collision` component applied to them.
     *
     * @example
     * ~~~
     * Crafty.e("2D, Collision")
     *       .setName('First entity')
     *       .attr({x: 0, y: 0, w: 10, h: 10});
     *
     * Crafty.e("2D, Collision")
     *       .setName('Second entity')
     *       .attr({x: 20, y: 20, w: 10, h: 10});
     *
     * var origin = {_x: -25, _y: -25};
     * var direction = new Crafty.math.Vector2D(1, 1).normalize();
     *
     * var results = Crafty.raycast(origin, direction, -1); // find only 1st intersection
     * Crafty.log('Intersections found', results.length); // logs '1'
     *
     * var result = results[0];
     * Crafty.log('1st intersection:');
     * Crafty.log('Entity name:', result.obj.getName()); // logs 'First entity'
     * Crafty.log('Distance from origin to intersection point', result.distance); // logs '25 * Math.sqrt(2)'
     * Crafty.log('Intersection point:', result.x, result.y); // logs '0' '0'
     * ~~~
     *
     * @see Crafty.polygon#.intersectRay
     * @see Crafty.map#Crafty.map.traverseRay
     */ // origin = {_x, _y}
                // direction = {x, y}, must be normalized
                //
                // Add approximate ray intersection with bounding rectangle,
                // before doing exact ray intersection if needed in future.
                // https://gist.github.com/mucaho/77846e9fc0cd3c8b600c
                raycast: function(origin, direction) {
                    // default parameters
                    var comp = "obj", maxDistance = Infinity, sort = true;
                    // optional arguments
                    var argument, type;
                    for(var i = 2, l = arguments.length; i < l; ++i){
                        argument = arguments[i];
                        type = typeof argument;
                        if (type === "number") maxDistance = argument + EPSILON;
                        else if (type === "string") // make it inclusive
                        comp = argument;
                        else if (type === "boolean") sort = argument;
                    }
                    var ox = origin._x, oy = origin._y, dx = direction.x, dy = direction.y;
                    var alreadyChecked = {}, results = [];
                    if (maxDistance < 0) {
                        // find first intersection
                        var closestObj = null, minDistance = Infinity;
                        // traverse map
                        Crafty.map.traverseRay(origin, direction, function(obj, previousCellDistance) {
                            // check if we advanced to next cell
                            //      then report closest object from previous cell
                            //          if intersection point is in previous cell
                            if (closestObj && minDistance < previousCellDistance) {
                                results.push({
                                    obj: closestObj,
                                    distance: minDistance,
                                    x: ox + minDistance * dx,
                                    y: oy + minDistance * dy
                                });
                                closestObj = null;
                                minDistance = Infinity;
                                return true;
                            }
                            // object must contain polygon hitbox, the specified component and must not already be checked
                            if (!obj.map || !obj.__c[comp] || alreadyChecked[obj[0]]) return;
                            alreadyChecked[obj[0]] = true;
                            // do exact intersection test
                            var distance = obj.map.intersectRay(origin, direction);
                            if (distance < minDistance) {
                                closestObj = obj;
                                minDistance = distance;
                            }
                        });
                        // in case traversal ended and we haven't yet pushed nearest intersecting object
                        if (closestObj) results.push({
                            obj: closestObj,
                            distance: minDistance,
                            x: ox + minDistance * dx,
                            y: oy + minDistance * dy
                        });
                    } else // find intersections up to max distance
                    // traverse map
                    Crafty.map.traverseRay(origin, direction, function(obj, previousCellDistance) {
                        // check if we advanced to next cell
                        //      then cancel traversal if previousCellDistance > maxDistance
                        if (previousCellDistance > maxDistance) return true;
                        // object must contain polygon hitbox, the specified component and must not already be checked
                        if (!obj.map || !obj.__c[comp] || alreadyChecked[obj[0]]) return;
                        alreadyChecked[obj[0]] = true;
                        // do exact intersection test
                        var distance = obj.map.intersectRay(origin, direction);
                        if (distance < maxDistance) results.push({
                            obj: obj,
                            distance: distance,
                            x: ox + distance * dx,
                            y: oy + distance * dy
                        });
                    });
                    if (sort) results.sort(function(a, b) {
                        return a.distance - b.distance;
                    });
                    return results;
                }
            });
            /**@
 * #Collision
 * @category 2D
 * @kind Component
 *
 * @trigger HitOn - Triggered when collisions occur. Will not trigger again until collisions of this type cease, or an event is requested once more (using `resetHitChecks(component)`). - { hitData }
 * @trigger HitOff - Triggered when collision with a specific component type ceases - String - componentName
 *
 * Component to detect collision between any two convex polygons.
 *
 * If collision checks are registered for multiple component and collisions with
 * multiple types occur simultaniously, each collision will cause an individual
 * event to fire.
 *
 * @note All data received from events is only valid for the duration of the event's callback.
 * If you wish to preserve the data, make a copy of it.
 *
 * For a description of collision event data (hitData above), see the documentation for
 * `.hit()`.
 *
 * @see 2D
 */ Crafty.c("Collision", {
                init: function() {
                    this.requires("2D");
                    this._collisionData = {};
                    this.collision();
                },
                // Run by Crafty when the component is removed
                remove: function() {
                    this._cbr = null;
                    this.unbind("Resize", this._resizeMap);
                    this.unbind("Resize", this._checkBounds);
                },
                /**@
     * #.collision
     * @comp Collision
     * @kind Method
     *
     * @trigger NewHitbox - when a new hitbox is assigned - Crafty.polygon
     *
     * @sign public this .collision([Crafty.polygon polygon])
     * @param polygon - Optional Crafty.polygon object that will act as the hit area.
     *
     * @sign public this .collision([Array coordinatePairs])
     * @param coordinatePairs - Optional array of x, y coordinate pairs to generate a hit area polygon.
     *
     * @sign public this .collision([x1, y1,.., xN, yN])
     * @param point# - Optional list of x, y coordinate pairs to generate a hit area polygon.
     *
     * Constructor that takes a polygon, an array of points or a list of points to use as the hit area,
     * with points being relative to the object's position in its unrotated state.
     *
     * The hit area must be a convex shape and not concave for collision detection to work properly.
     *
     * If no parameter is passed, the x, y, w, h properties of the entity will be used, and the hitbox will be resized when the entity is.
     *
     * If a hitbox is set that is outside of the bounds of the entity itself, there will be a small performance penalty as it is tracked separately.
     *
     * In order for your custom hitbox to have any effect, you have to add the `Collision` component to all other entities this entity needs to collide with using this custom hitbox.
     * On the contrary the collisions will be resolved using the default hitbox. See `.hit()` - `MBR` represents default hitbox collision, `SAT` represents custom hitbox collision.
     *
     * @example
     * ~~~
     * Crafty.e("2D, Collision").collision(
     *     new Crafty.polygon([50, 0,  100, 100,  0, 100])
     * );
     *
     * Crafty.e("2D, Collision").collision([50, 0,  100, 100,  0, 100]);
     *
     * Crafty.e("2D, Collision").collision(50, 0,  100, 100,  0, 100);
     * ~~~
     *
     * @see Crafty.polygon
     */ collision: function(polygon) {
                    // Unbind anything bound to "Resize"
                    this.unbind("Resize", this._resizeMap);
                    this.unbind("Resize", this._checkBounds);
                    if (!polygon) {
                        // If no polygon is specified, then a polygon is created that matches the bounds of the entity
                        // It will be adjusted on a "Resize" event
                        polygon = new Crafty.polygon([
                            0,
                            0,
                            this._w,
                            0,
                            this._w,
                            this._h,
                            0,
                            this._h
                        ]);
                        this.bind("Resize", this._resizeMap);
                        this._cbr = null;
                    } else {
                        // Otherwise, we set the specified hitbox, converting from a list of arguments to a polygon if necessary
                        if (arguments.length > 1) {
                            //convert args to array to create polygon
                            var args = Array.prototype.slice.call(arguments, 0);
                            polygon = new Crafty.polygon(args);
                        // Otherwise, we set the specified hitbox, converting from an array of points to a polygon if necessary
                        } else if (polygon.constructor === Array) //Clone the array so we don't modify it for anything else that might be using it
                        polygon = new Crafty.polygon(polygon.slice());
                        else //Clone the polygon so we don't modify it for anything else that might be using it
                        polygon = polygon.clone();
                        // Check to see if the polygon sits outside the entity, and set _cbr appropriately
                        // On resize, the new bounds will be checked if necessary
                        this._findBounds(polygon.points);
                    }
                    // If the entity is currently rotated, the points in the hitbox must also be rotated
                    if (this.rotation) polygon.rotate(this.rotation, this._origin.x, this._origin.y, Math.cos(-this.rotation * DEG_TO_RAD), Math.sin(-this.rotation * DEG_TO_RAD));
                    // Finally, assign the hitbox, and attach it to the "Collision" entity
                    this.map = polygon;
                    this.attach(this.map);
                    this.map.shift(this._x, this._y);
                    this.trigger("NewHitbox", polygon);
                    return this;
                },
                /**@
     * #.cbr
     * @comp Collision
     * @kind Method
     *
     * @sign public Object .cbr([Object cbr])
     * @param cbr - an object to use as output
     * @returns an object with `_x`, `_y`, `_w`, and `_h` properties; if an object is passed in, it will be reused rather than creating a new object.
     *
     * Return an object containing a copy of this entity's collision bounding rectangle.
     * The CBR encompasses both the entity's custom collision hitbox and its MBR.
     * If the custom collision hitbox does not sit outside the entity it will return the entity's minimum bounding rectangle (`.mbr()`) instead.
     *
     * @note The keys have an underscore prefix. This is due to the x, y, w, h properties
     * being setters and getters that wrap the underlying properties with an underscore (_x, _y, _w, _h).
     *
     * @see 2D#.mbr
     */ cbr: function(cbr) {
                    cbr = cbr || {};
                    if (!this._cbr) return this.mbr(cbr);
                    else {
                        cbr._x = this._cbr._x;
                        cbr._y = this._cbr._y;
                        cbr._w = this._cbr._w;
                        cbr._h = this._cbr._h;
                        return cbr;
                    }
                },
                // If the hitbox is set by hand, it might extend beyond the entity.
                // In such a case, we need to track this separately.
                // This function finds a (non-minimal) bounding circle around the hitbox.
                //
                // It uses a pretty naive algorithm to do so, for more complicated options see [wikipedia](http://en.wikipedia.org/wiki/Bounding_sphere).
                _findBounds: function(points) {
                    var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
                    var l = points.length;
                    // Calculate the MBR of the points by finding the min/max x and y
                    for(var i = 0; i < l; i += 2){
                        if (points[i] < minX) minX = points[i];
                        if (points[i] > maxX) maxX = points[i];
                        if (points[i + 1] < minY) minY = points[i + 1];
                        if (points[i + 1] > maxY) maxY = points[i + 1];
                    }
                    // This describes a circle centered on the MBR of the points, with a diameter equal to its diagonal
                    // It will be used to find a rough bounding box round the points, even if they've been rotated
                    var cbr = {
                        cx: (minX + maxX) / 2,
                        cy: (minY + maxY) / 2,
                        r: Math.sqrt((maxX - minX) * (maxX - minX) + (maxY - minY) * (maxY - minY)) / 2
                    };
                    // We need to worry about resizing, but only if resizing could possibly change whether the hitbox is in or out of bounds
                    // Thus if the upper-left corner is out of bounds, then there's no need to recheck on resize
                    if (minX >= 0 && minY >= 0) {
                        this._checkBounds = function() {
                            if (this._cbr === null && this._w < maxX || this._h < maxY) {
                                this._cbr = cbr;
                                this._calculateMBR();
                            } else if (this._cbr) {
                                this._cbr = null;
                                this._calculateMBR();
                            }
                        };
                        this.bind("Resize", this._checkBounds);
                    }
                    // If the hitbox is within the entity, _cbr is null
                    // Otherwise, set it, and immediately calculate the bounding box.
                    if (minX >= 0 && minY >= 0 && maxX <= this._w && maxY <= this._h) {
                        this._cbr = null;
                        return false;
                    } else {
                        this._cbr = cbr;
                        this._calculateMBR();
                        return true;
                    }
                },
                // The default behavior is to match the hitbox to the entity.
                // This function will change the hitbox when a "Resize" event triggers.
                _resizeMap: function(e) {
                    var dx, dy, rot = this.rotation * DEG_TO_RAD, points = this.map.points;
                    // Depending on the change of axis, move the corners of the rectangle appropriately
                    if (e.axis === "w") {
                        if (rot) {
                            dx = e.amount * Math.cos(rot);
                            dy = e.amount * Math.sin(rot);
                        } else {
                            dx = e.amount;
                            dy = 0;
                        }
                        // "top right" point shifts on change of w
                        points[2] += dx;
                        points[3] += dy;
                    } else {
                        if (rot) {
                            dy = e.amount * Math.cos(rot);
                            dx = -e.amount * Math.sin(rot);
                        } else {
                            dx = 0;
                            dy = e.amount;
                        }
                        // "bottom left" point shifts on change of h
                        points[6] += dx;
                        points[7] += dy;
                    }
                    // "bottom right" point shifts on either change
                    points[4] += dx;
                    points[5] += dy;
                },
                /**@
     * #.hit
     * @comp Collision
     * @kind Method
     *
     * @sign public Array .hit(String component[, Array results])
     * @param component - Check collision with entities that have this component
     * applied to them.
     * @param results - If a results array is supplied, any collisions will be appended to it
     * @return `null` if there is no collision. If a collision is detected,
     * returns an Array of collision data objects (see below).
     * If the results parameter was passed, it will be used as the return value.
     *
     * Tests for collisions with entities that have the specified component applied to them.
     * If a collision is detected, data regarding the collision will be present in the array
     * returned by this method. If no collisions occur, this method returns `null`.
     *
     * When testing for collisions, if both entities have the `Collision` component, then
     * the collision test will use the Separating Axis Theorem (SAT), and provide more detailed
     * information about the collision.  Otherwise, it will be a simple test of whether the
     * minimal bounding rectangles (MBR) overlap.
     *
     * Following is a description of a collision data object that this method may
     * return: The returned collision data will be an Array of Objects with the
     * type of collision used, the object collided and if the type used was SAT (a polygon was used as the hitbox) then an amount of overlap.
     * ~~~
     * [{
     *    obj: [entity],
     *    type: ["MBR" or "SAT"],
     *    overlap: [number],
     *    nx: [number],
     *    ny: [number]
     * }]
     * ~~~
     *
     * All collision results will have these properties:
     * - **obj:** The entity with which the collision occured.
     * - **type:** Collision detection method used. One of:
     *   - *MBR:* Standard axis aligned rectangle intersection (`.intersect` in the 2D component).
     *   - *SAT:* Collision between any two convex polygons. Used when both colliding entities have the `Collision` component applied to them.
     *
     * If the collision result type is **SAT** then there will be three additional properties, which
     * represent the minimum translation vector (MTV) -- the direction and distance of the minimal translation
     * that will result in non-overlapping entities.
     * - **overlap:** The magnitude of the translation vector.
     * - **nx:** The x component of the MTV.
     * - **ny:** The y component of the MTV.
     *
     * These additional properties (returned only when both entities have the "Collision" component)
     * are useful when providing more natural collision resolution.
     *
     * If you want more fine-grained control consider using `Crafty.map.search()`.
     *
     * @example
     * Resolving collisions with static colliders (walls) for moving entity (player).
     * ~~~
     * Crafty.e("2D, Fourway, Collision, player")
     *       .attr({x: 32, y: 32, w: 32, h: 32})
     *       .collision([0, 16, 16, 0, 32, 16, 16, 32])
     *       .fourway()
     *       .bind('Move', function(evt) { // after player moved
     *         var hitDatas, hitData;
     *         if ((hitDatas = this.hit('wall'))) { // check for collision with walls
     *           hitData = hitDatas[0]; // resolving collision for just one collider
     *           if (hitData.type === 'SAT') { // SAT, advanced collision resolution
     *             // move player back by amount of overlap
     *             this.x -= hitData.overlap * hitData.nx;
     *             this.y -= hitData.overlap * hitData.ny;
     *           } else { // MBR, simple collision resolution
     *             // move player to previous position
     *             this.x = evt._x;
     *             this.y = evt._y;
     *           }
     *         }
     *       });
     * ~~~
     *
     * @see Crafty.map#Crafty.map.search
     */ _collisionHitDupes: [],
                _collisionHitResults: [],
                hit: function(component, results) {
                    var area = this._cbr || this._mbr || this;
                    var searchResults = this._collisionHitResults;
                    searchResults.length = 0;
                    searchResults = Crafty.map.unfilteredSearch(area, searchResults);
                    var l = searchResults.length;
                    if (!l) return null;
                    var i = 0, dupes = this._collisionHitDupes, id, obj;
                    results = results || [];
                    dupes.length = 0;
                    for(; i < l; ++i){
                        obj = searchResults[i];
                        if (!obj) continue;
                        id = obj[0];
                        //check if not added to hash and that actually intersects
                        if (!dupes[id] && this[0] !== id && obj.__c[component]) {
                            dupes[id] = obj;
                            if (obj.map) {
                                var SAT = this._SAT(this.map, obj.map);
                                if (SAT) {
                                    results.push(SAT);
                                    SAT.obj = obj;
                                    SAT.type = "SAT";
                                }
                            } else if (Crafty.rectManager.overlap(area, obj._cbr || obj._mbr || obj)) results.push({
                                obj: obj,
                                type: "MBR"
                            });
                        }
                    }
                    if (!results.length) return null;
                    return results;
                },
                /**@
     * #.onHit
     * @comp Collision
     * @kind Method
     *
     * @sign public this .onHit(String component, Function callbackOn[, Function callbackOff])
     * @param component - Component to check collisions for.
     * @param callbackOn - Callback method to execute upon collision with the component.
     *                     The first argument passed  will be the results of the collision check in the same format documented for `hit()`.
     *                     The second argument passed will be a Boolean indicating whether the collision with a component occurs for the first time.
     * @param callbackOff - Callback method executed once as soon as collision stops.  No arguments are passed.
     *
     * Creates an `UpdateFrame` event calling `.hit()` each frame.  When a collision is detected the `callbackOn` will be invoked.
     *
     * Note that the `callbackOn` will be invoked every frame the collision is active, not just the first time the collision occurs.
     * Use the second argument passed to `callbackOn` to differentiate that, which will be `true` if it's the first time the collision occurs.
     *
     * If you want more fine-grained control consider using `.checkHits()`, `.hit()` or even `Crafty.map.search()`.
     *
     * @example
     * Respond to collisions between player and bullets.
     * ~~~
     * Crafty.e("2D, Collision, player")
     *       .attr({ health: 100 })
     *       .onHit('bullet', function(hitDatas) { // on collision with bullets
     *         for (var i = 0, l = hitDatas.length; i < l; ++i) { // for each bullet hit
     *           hitDatas[i].obj.destroy(); // destroy the bullet
     *           this.health -= 25; // player looses health
     *           if (this.health <= 0) // once player's health depletes
     *             this.destroy(); // player dies
     *         }
     *       });
     * ~~~
     *
     * @see .checkHits
     * @see .hit
     * @see Crafty.map#Crafty.map.search
     */ onHit: function(component, callbackOn, callbackOff) {
                    var justHit = false;
                    this.bind("UpdateFrame", function() {
                        var hitData = this.hit(component);
                        if (hitData) {
                            callbackOn.call(this, hitData, !justHit);
                            justHit = true;
                        } else if (justHit) {
                            if (typeof callbackOff === "function") callbackOff.call(this);
                            justHit = false;
                        }
                    });
                    return this;
                },
                /**
     * This is a helper method for creating collisions handlers set up by `checkHits`. Do not call this directly.
     *
     * @param {String} component - The name of the component for which this handler checks for collisions.
     * @param {Object} collisionData - Collision data object used to track collisions with the specified component.
     *
     * @see .checkHits
     */ _createCollisionHandler: function(component, collisionData) {
                    return function() {
                        var hitData = this.hit(component);
                        if (collisionData.occurring === true) {
                            if (hitData !== null) // The collision is still in progress
                            return;
                            collisionData.occurring = false;
                            this.trigger("HitOff", component);
                        } else if (hitData !== null) {
                            collisionData.occurring = true;
                            this.trigger("HitOn", hitData);
                        }
                    };
                },
                /**@
     * #.checkHits
     * @comp Collision
     * @kind Method
     *
     * @sign public this .checkHits(String componentList)
     * @param componentList - A comma seperated list of components to check for collisions with.
     * @sign public this .checkHits(String component1[, .., String componentN])
     * @param component# - A component to check for collisions with.
     *
     * Performs collision checks against all entities that have at least one of
     * the components specified when calling this method. If collisions occur,
     * a "HitOn" event containing the collision information will be fired for the
     * entity on which this method was invoked. See the documentation for `.hit()`
     * for a description of collision data contained in the event.
     * When a collision that was reported ends, a corresponding "HitOff" event
     * will be fired.
     *
     * Calling this method more than once for the same component type will not
     * cause redundant hit checks.
     *
     * If you want more fine-grained control consider using `.hit()` or even `Crafty.map.search()`.
     *
     * @note Hit checks are performed on each new frame (using
     * the *UpdateFrame* event). It is entirely possible for object to move in
     * said frame after the checks were performed (even if the more is the
     * result of *UpdateFrame*, as handlers run in no particular order). In such
     * a case, the hit events will not fire until the next check is performed in
     * the following frame.
     *
     * @example
     * ~~~
     * Crafty.e("2D, Collision")
     *     .checkHits('Solid') // check for collisions with entities that have the Solid component in each frame
     *     .bind("HitOn", function(hitData) {
     *         Crafty.log("Collision with Solid entity occurred for the first time.");
     *     })
     *     .bind("HitOff", function(comp) {
     *         Crafty.log("Collision with Solid entity ended.");
     *     });
     * ~~~
     *
     * @see .hit
     * @see Crafty.map#Crafty.map.search
     */ checkHits: function() {
                    var components = arguments;
                    var i = 0;
                    if (components.length === 1) components = components[0].split(/\s*,\s*/);
                    for(; i < components.length; ++i){
                        var component = components[i];
                        var collisionData = this._collisionData[component];
                        if (collisionData !== undefined) continue;
                        this._collisionData[component] = collisionData = {
                            occurring: false,
                            handler: null
                        };
                        collisionData.handler = this._createCollisionHandler(component, collisionData);
                        this.bind("UpdateFrame", collisionData.handler);
                    }
                    return this;
                },
                /**@
     * #.ignoreHits
     * @comp Collision
     * @kind Method
     *
     * @sign public this .ignoreHits()
     *
     * @sign public this .ignoreHits(String componentList)
     * @param componentList - A comma separated list of components to stop checking
     * for collisions with.
     *
     * @sign public this .ignoreHits(String component1[, .., String componentN])
     * @param component# - A component to stop checking for collisions with.
     *
     * Stops checking for collisions with all, or certain, components. If called
     * without arguments, this method will cause all collision checks on the
     * entity to cease. To disable checks for collisions with specific
     * components, specify the components as a comma separated string or as
     * a set of arguments.
     *
     * Calling this method with component names for which there are no collision
     * checks has no effect.
     *
     * @example
     * ~~~
     * Crafty.e("2D, Collision")
     *     .checkHits('Solid')
     *     ...
     *     .ignoreHits('Solid'); // stop checking for collisions with entities that have the Solid component
     * ~~~
     */ ignoreHits: function() {
                    var components = arguments;
                    var i = 0;
                    var collisionData;
                    if (components.length === 0) {
                        for(collisionData in this._collisionData)this.unbind("UpdateFrame", collisionData.handler);
                        this._collisionData = {};
                    }
                    if (components.length === 1) components = components[0].split(/\s*,\s*/);
                    for(; i < components.length; ++i){
                        var component = components[i];
                        collisionData = this._collisionData[component];
                        if (collisionData === undefined) continue;
                        this.unbind("UpdateFrame", collisionData.handler);
                        delete this._collisionData[component];
                    }
                    return this;
                },
                /**@
     * #.resetHitChecks
     * @comp Collision
     * @kind Method
     *
     * @sign public this .resetHitChecks()
     * @sign public this .resetHitChecks(String componentList)
     * @param componentList - A comma seperated list of components to re-check
     * for collisions with.
     * @sign public this .resetHitChecks(String component1[, .., String componentN])
     * @param component# - A component to re-check for collisions with.
     *
     * Causes collision events to be received for collisions that are already
     * taking place (normally, an additional event would not fire before said
     * collisions cease and happen another time).
     * If called without arguments, this method will cause all collision checks on the
     * entity to fire events once more. To re-check for collisions with specific
     * components, specify the components as a comma separated string or as
     * a set of arguments.
     *
     * Calling this method with component names for which there are no collision
     * checks has no effect.
     *
     * @example
     * ~~~
     * // this example fires the HitOn event each frame the collision with the Solid entity is active, instead of just the first time the collision occurs.
     * Crafty.e("2D, Collision")
     *     .checkHits('Solid')
     *     .bind("HitOn", function(hitData) {
     *         Crafty.log("Collision with Solid entity was reported in this frame again!");
     *         this.resetHitChecks('Solid'); // fire the HitOn event in the next frame also, if the collision is still active.
     *     })
     * ~~~
     */ resetHitChecks: function() {
                    var components = arguments;
                    var i = 0;
                    var collisionData;
                    if (components.length === 0) for(collisionData in this._collisionData)this._collisionData[collisionData].occurring = false;
                    if (components.length === 1) components = components[0].split(/\s*,\s*/);
                    for(; i < components.length; ++i){
                        var component = components[i];
                        collisionData = this._collisionData[component];
                        if (collisionData === undefined) continue;
                        collisionData.occurring = false;
                    }
                    return this;
                },
                _SAT: function(poly1, poly2) {
                    var i = 0, points1 = poly1.points, points2 = poly2.points, l = points1.length / 2, j, k = points2.length / 2, nx = 0, ny = 0, length, min1, min2, max1, max2, interval, MTV = -Infinity, MNx = null, MNy = null, dot, np;
                    //loop through the edges of Polygon 1
                    for(; i < l; i++){
                        np = i === l - 1 ? 0 : i + 1;
                        //generate the normal for the current edge
                        nx = -(points1[2 * i + 1] - points1[2 * np + 1]);
                        ny = points1[2 * i] - points1[2 * np];
                        //normalize the vector
                        length = Math.sqrt(nx * nx + ny * ny);
                        nx /= length;
                        ny /= length;
                        //default min max
                        min1 = min2 = Infinity;
                        max1 = max2 = -Infinity;
                        //project all vertices from poly1 onto axis
                        for(j = 0; j < l; ++j){
                            dot = points1[2 * j] * nx + points1[2 * j + 1] * ny;
                            if (dot > max1) max1 = dot;
                            if (dot < min1) min1 = dot;
                        }
                        //project all vertices from poly2 onto axis
                        for(j = 0; j < k; ++j){
                            dot = points2[2 * j] * nx + points2[2 * j + 1] * ny;
                            if (dot > max2) max2 = dot;
                            if (dot < min2) min2 = dot;
                        }
                        //calculate the minimum translation vector should be negative
                        if (min1 < min2) {
                            interval = min2 - max1;
                            nx = -nx;
                            ny = -ny;
                        } else interval = min1 - max2;
                        //exit early if positive
                        if (interval >= 0) return false;
                        if (interval > MTV) {
                            MTV = interval;
                            MNx = nx;
                            MNy = ny;
                        }
                    }
                    //loop through the edges of Polygon 2
                    for(i = 0; i < k; i++){
                        np = i === k - 1 ? 0 : i + 1;
                        //generate the normal for the current edge
                        nx = -(points2[2 * i + 1] - points2[2 * np + 1]);
                        ny = points2[2 * i] - points2[2 * np];
                        //normalize the vector
                        length = Math.sqrt(nx * nx + ny * ny);
                        nx /= length;
                        ny /= length;
                        //default min max
                        min1 = min2 = Infinity;
                        max1 = max2 = -Infinity;
                        //project all vertices from poly1 onto axis
                        for(j = 0; j < l; ++j){
                            dot = points1[2 * j] * nx + points1[2 * j + 1] * ny;
                            if (dot > max1) max1 = dot;
                            if (dot < min1) min1 = dot;
                        }
                        //project all vertices from poly2 onto axis
                        for(j = 0; j < k; ++j){
                            dot = points2[2 * j] * nx + points2[2 * j + 1] * ny;
                            if (dot > max2) max2 = dot;
                            if (dot < min2) min2 = dot;
                        }
                        //calculate the minimum translation vector should be negative
                        if (min1 < min2) {
                            interval = min2 - max1;
                            nx = -nx;
                            ny = -ny;
                        } else interval = min1 - max2;
                        //exit early if positive
                        if (interval >= 0) return false;
                        if (interval > MTV) {
                            MTV = interval;
                            MNx = nx;
                            MNy = ny;
                        }
                    }
                    return {
                        overlap: MTV,
                        nx: MNx,
                        ny: MNy
                    };
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    57: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #Crafty.math
 * @category Utilities
 * @kind CoreObj
 *
 * A set of utility functions for common (and not so common) operations.
 */ Crafty.math = {
                /**@
     * #Crafty.math.abs
     * @comp Crafty.math
     * @kind Method
     *
     * @sign public this Crafty.math.abs(Number n)
     * @param n - Some value.
     * @return Absolute value.
     *
     * Returns the absolute value.
     */ abs: function(x) {
                    return x < 0 ? -x : x;
                },
                /**@
     * #Crafty.math.amountOf
     * @comp Crafty.math
     * @kind Method
     *
     * @sign public Number Crafty.math.amountOf(Number checkValue, Number minValue, Number maxValue)
     * @param checkValue - Value that should checked with minimum and maximum.
     * @param minValue - Bottom of the range
     * @param maxValue - Top of the range
     * @return The position of the checked value in a coordinate system normalized such that `minValue` is 0 and `maxValue` is 1.
     *
     * If checkValue is within the range, this will return a number between 0 and 1.
     */ amountOf: function(checkValue, minValue, maxValue) {
                    if (minValue < maxValue) return (checkValue - minValue) / (maxValue - minValue);
                    else return (checkValue - maxValue) / (minValue - maxValue);
                },
                /**@
     * #Crafty.math.clamp
     * @comp Crafty.math
     * @kind Method
     *
     * @sign public Number Crafty.math.clamp(Number value, Number min, Number max)
     * @param value - A value.
     * @param max - Maximum that value can be.
     * @param min - Minimum that value can be.
     * @return The value between minimum and maximum.
     *
     * Restricts a value to be within a specified range.
     */ clamp: function(value, min, max) {
                    if (value > max) return max;
                    else if (value < min) return min;
                    else return value;
                },
                /**@
     * #Crafty.math.degToRad
     * Converts angle from degree to radian.
     * @comp Crafty.math
     * @kind Method
     *
     * @sign public Number degToRad(angleInDeg)
     * @param angleInDeg - The angle in degrees.
     * @return The angle in radians.
     */ degToRad: function(angleInDeg) {
                    return angleInDeg * Math.PI / 180;
                },
                /**@
     * #Crafty.math.distance
     * @comp Crafty.math
     * @kind Method
     *
     * @sign public Number Crafty.math.distance(Number x1, Number y1, Number x2, Number y2)
     * @param x1 - First x coordinate.
     * @param y1 - First y coordinate.
     * @param x2 - Second x coordinate.
     * @param y2 - Second y coordinate.
     * @return The distance between the two points.
     *
     * Distance between two points.
     */ distance: function(x1, y1, x2, y2) {
                    var squaredDistance = Crafty.math.squaredDistance(x1, y1, x2, y2);
                    return Math.sqrt(parseFloat(squaredDistance));
                },
                /**@
     * #Crafty.math.lerp
     * @comp Crafty.math
     * @kind Method
     *
     * @sign public Number Crafty.math.lerp(Number value1, Number value2, Number amount)
     * @param value1 - One value.
     * @param value2 - Another value.
     * @param amount - Amount of value2 to value1.
     * @return Linear interpolated value.
     *
     * Linear interpolation. Passing amount with a value of 0 will cause value1 to be returned,
     * a value of 1 will cause value2 to be returned.
     */ lerp: function(value1, value2, amount) {
                    return value1 + (value2 - value1) * amount;
                },
                /**@
     * #Crafty.math.negate
     * @comp Crafty.math
     * @kind Method
     *
     * @sign public Number Crafty.math.negate(Number percent)
     * @param percent - The probability of returning `-1`
     * @return 1 or -1.
     *
     * Returns `1` or `-1` randomly.
     */ negate: function(percent) {
                    if (Math.random() < percent) return -1;
                    else return 1;
                },
                /**@
     * #Crafty.math.radToDeg
     * @comp Crafty.math
     * @kind Method
     *
     * @sign public Number Crafty.math.radToDeg(Number angle)
     * @param angleInRad - The angle in radian.
     * @return The angle in degree.
     *
     * Converts angle from radian to degree.
     */ radToDeg: function(angleInRad) {
                    return angleInRad * 180 / Math.PI;
                },
                /**@
     * #Crafty.math.randomElementOfArray
     * @comp Crafty.math
     * @kind Method
     *
     * @sign public Object Crafty.math.randomElementOfArray(Array array)
     * @param array - A specific array.
     * @return A random element of a specific array.
     *
     * Returns a random element of a specific array.
     */ randomElementOfArray: function(array) {
                    return array[Math.floor(array.length * Math.random())];
                },
                /**@
     * #Crafty.math.randomInt
     * @comp Crafty.math
     * @kind Method
     *
     * @sign public Number Crafty.math.randomInt(Number start, Number end)
     * @param start - Smallest int value that can be returned.
     * @param end - Biggest int value that can be returned.
     * @return A random int.
     *
     * Returns a random int within a specific range.
     */ randomInt: function(start, end) {
                    return start + Math.floor((1 + end - start) * Math.random());
                },
                /**@
     * #Crafty.math.randomNumber
     * @comp Crafty.math
     * @kind Method
     *
     * @sign public Number Crafty.math.randomNumber(Number start, Number end)
     * @param start - Smallest number value that can be returned.
     * @param end - Biggest number value that can be returned.
     * @return A random number.
     *
     * Returns a random number in within a specific range.
     */ randomNumber: function(start, end) {
                    return start + (end - start) * Math.random();
                },
                /**@
     * #Crafty.math.squaredDistance
     * @comp Crafty.math
     * @kind Method
     *
     * @sign public Number Crafty.math.squaredDistance(Number x1, Number y1, Number x2, Number y2)
     * @param x1 - First x coordinate.
     * @param y1 - First y coordinate.
     * @param x2 - Second x coordinate.
     * @param y2 - Second y coordinate.
     * @return The squared distance between the two points.
     *
     * Squared distance between two points.
     */ squaredDistance: function(x1, y1, x2, y2) {
                    return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
                },
                /**@
     * #Crafty.math.withinRange
     * @comp Crafty.math
     * @kind Method
     *
     * @sign public Boolean Crafty.math.withinRange(Number value, Number min, Number max)
     * @param value - The specific value.
     * @param min - Minimum value.
     * @param max - Maximum value.
     * @return Returns true if value is within a specific range.
     *
     * Check if a value is within a specific range.
     */ withinRange: function(value, min, max) {
                    return value >= min && value <= max;
                }
            };
            Crafty.math.Vector2D = function() {
                /**@
     * #Crafty.math.Vector2D
     * @category 2D
     * @kind Class
     * @public
     *
     * @class This is a general purpose 2D vector class
     *
     * Vector2D has the following constructors:
     *
     * @sign public {Vector2D} new Vector2D();
     * @returns {Vector2D} A new vector with x and y equal to 0
     *
     * @sign public {Vector2D} new Vector2D(Number x, Number y);
     * @param {Number} x - The initial x value
     * @param {Number} y - The initial y value
     * @returns {Vector2D} - A new vector with the given x and y values
     *
     * @sign public {Vector2D} new Vector2D(Vector2D vector);
     * @param {Vector2D} vector - A vector to copy
     * @returns {Vector2D} A new vector with the copied x and y values
     *
     * @example
     * ```
     * var v1 = new Crafty.math.Vector2D(3, 5);
     * var v2 = new Crafty.math.Vector2D(v1);
     * ```
     *
     */ function Vector2D(x, y) {
                    if (x instanceof Vector2D) {
                        this.x = x.x;
                        this.y = x.y;
                    } else if (arguments.length === 2) {
                        this.x = x;
                        this.y = y;
                    } else if (arguments.length > 0) throw "Unexpected number of arguments for Vector2D()";
                } // class Vector2D
                Vector2D.prototype.x = 0;
                Vector2D.prototype.y = 0;
                /**@
     * #.add
     * @comp Crafty.math.Vector2D
     * @kind Method
     * @public
     *
     * Adds the passed vector to this vector
     *
     * @sign public {Vector2D} add(Vector2D vecRH);
     * @param {Vector2D} vecRH - The vector to add
     * @returns {Vector2D} The resulting modified vector
     */ Vector2D.prototype.add = function(vecRH) {
                    this.x += vecRH.x;
                    this.y += vecRH.y;
                    return this;
                }; // add
                /**@
     * #.angleBetween
     * @comp Crafty.math.Vector2D
     * @kind Method
     * @public
     *
     * Calculates the angle between the passed vector and this vector, using <0,0> as the point of reference.
     * Angles returned have the range (−π, π].
     *
     * @sign public {Number} angleBetween(Vector2D vecRH);
     * @param {Vector2D} vecRH - The vector to compare
     * @returns {Number} the angle between the two vectors in radians
     */ Vector2D.prototype.angleBetween = function(vecRH) {
                    return Math.atan2(this.x * vecRH.y - this.y * vecRH.x, this.x * vecRH.x + this.y * vecRH.y);
                };
                /**@
     * #.angleTo
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Calculates the angle to the passed vector from this vector, using this vector as the point of reference.
     *
     * @public
     * @sign public {Number} angleTo(Vector2D vecRH);
     * @param {Vector2D} vecRH - The vector to compare
     * @returns {Number} the angle to the passed vector in radians
     */ Vector2D.prototype.angleTo = function(vecRH) {
                    return Math.atan2(vecRH.y - this.y, vecRH.x - this.x);
                };
                /**@
     * #.clone
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     *
     * Creates and exact, numeric copy of this vector
     *
     * @public
     * @sign public {Vector2D} clone();
     * @returns {Vector2D} the new vector
     */ Vector2D.prototype.clone = function() {
                    return new Vector2D(this);
                }; // clone
                /**@
     * #.distance
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     *
     * Calculates the distance from this vector to the passed vector.
     *
     * @public
     * @sign public {Number} distance(Vector2D vecRH);
     * @param {Vector2D} vecRH - The passed vector
     * @returns {Number} the distance between the two vectors
     */ Vector2D.prototype.distance = function(vecRH) {
                    return Math.sqrt((vecRH.x - this.x) * (vecRH.x - this.x) + (vecRH.y - this.y) * (vecRH.y - this.y));
                }; // distance
                /**@
     * #.distanceSq
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     *
     * Calculates the squared distance from this vector to the passed vector.
     * This function avoids calculating the square root, thus being slightly faster than .distance( ).
     *
     * @public
     * @sign public {Number} distanceSq(Vector2D vecRH);
     * @param {Vector2D} vecRH - The passed vector
     * @returns {Number} the squared distance between the two vectors
     *
     * @see .distance
     */ Vector2D.prototype.distanceSq = function(vecRH) {
                    return (vecRH.x - this.x) * (vecRH.x - this.x) + (vecRH.y - this.y) * (vecRH.y - this.y);
                }; // distanceSq
                /**@
     * #.divide
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     *
     * Divides this vector by the passed vector.
     *
     * @public
     * @sign public {Vector2D} divide(Vector2D vecRH);
     * @param {Vector2D} vecRH - The passed vector
     * @returns {Vector2D} this vector after dividing
     */ Vector2D.prototype.divide = function(vecRH) {
                    this.x /= vecRH.x;
                    this.y /= vecRH.y;
                    return this;
                }; // divide
                /**@
     * #.dotProduct
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     *
     * Calculates the dot product of this and the passed vectors
     *
     * @public
     * @sign public {Number} dotProduct(Vector2D vecRH);
     * @param {Vector2D} vecRH - The passed vector
     * @returns {Number} the resultant dot product
     */ Vector2D.prototype.dotProduct = function(vecRH) {
                    return this.x * vecRH.x + this.y * vecRH.y;
                }; // dotProduct
                /**@
     * #.crossProduct
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     *
     * Calculates the z component of the cross product of the two vectors augmented to 3D.
     *
     * @public
     * @sign public {Number} crossProduct(Vector2D vecRH);
     * @param {Vector2D} vecRH - The passed vector
     * @returns {Number} the resultant cross product
     */ Vector2D.prototype.crossProduct = function(vecRH) {
                    return this.x * vecRH.y - this.y * vecRH.x;
                }; // crossProduct
                /**@
     * #.equals
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     *
     * Determines if this vector is numerically equivalent to the passed vector.
     *
     * @public
     * @sign public {Boolean} equals(Vector2D vecRH);
     * @param {Vector2D} vecRH - The passed vector
     * @returns {Boolean} true if the vectors are equivalent
     */ Vector2D.prototype.equals = function(vecRH) {
                    return vecRH instanceof Vector2D && this.x === vecRH.x && this.y === vecRH.y;
                }; // equals
                /**@
     * #.perpendicular
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     *
     * Calculates a new vector that is perpendicular to this vector.
     * The perpendicular vector has the same magnitude as this vector and is obtained by a counter-clockwise rotation of 90° of this vector.
     *
     * @public
     * @sign public {Vector2D} perpendicular([Vector2D result]);
     * @param {Vector2D} [result] - An optional parameter to save the result in
     * @returns {Vector2D} the perpendicular vector
     */ Vector2D.prototype.perpendicular = function(result) {
                    result = result || new Vector2D();
                    return result.setValues(-this.y, this.x);
                }; // perpendicular
                /**@
     * #.getNormal
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Calculates a new right-handed unit vector that is perpendicular to the line created by this and the passed vector.
     *
     * @public
     * @sign public {Vector2D} getNormal(Vector2D vecRH[, Vector2D result]);
     * @param {Vector2D} vecRH - The passed vector
     * @param {Vector2D} [result] - An optional parameter to save the result in
     * @returns {Vector2D} the new normal vector
     */ Vector2D.prototype.getNormal = function(vecRH, result) {
                    result = result || new Vector2D();
                    return result.setValues(vecRH.y - this.y, this.x - vecRH.x).normalize();
                }; // getNormal
                /**@
     * #.isZero
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     *
     * Determines if this vector is equal to <0,0>
     *
     * @public
     * @sign public {Boolean} isZero();
     * @returns {Boolean} true if this vector is equal to <0,0>
     */ Vector2D.prototype.isZero = function() {
                    return this.x === 0 && this.y === 0;
                }; // isZero
                /**@
     * #.magnitude
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Calculates the magnitude of this vector.
     * Note: Function objects in JavaScript already have a 'length' member, hence the use of magnitude instead.
     *
     * @public
     * @sign public {Number} magnitude();
     * @returns {Number} the magnitude of this vector
     */ Vector2D.prototype.magnitude = function() {
                    return Math.sqrt(this.x * this.x + this.y * this.y);
                }; // magnitude
                /**@
     * #.magnitudeSq
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Calculates the square of the magnitude of this vector.
     * This function avoids calculating the square root, thus being slightly faster than .magnitude( ).
     *
     * @public
     * @sign public {Number} magnitudeSq();
     * @returns {Number} the square of the magnitude of this vector
     * @see .magnitude
     */ Vector2D.prototype.magnitudeSq = function() {
                    return this.x * this.x + this.y * this.y;
                }; // magnitudeSq
                /**@
     * #.multiply
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Multiplies this vector by the passed vector, using component-wise multiplciation
     *
     * @public
     * @sign public {Vector2D} multiply(Vector2D vecRH);
     * @param {Vector2D} vecRH - The passed vector
     * @returns {Vector2D} this vector after multiplying
     */ Vector2D.prototype.multiply = function(vecRH) {
                    this.x *= vecRH.x;
                    this.y *= vecRH.y;
                    return this;
                }; // multiply
                /**@
     * #.negate
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Negates this vector (ie. <-x,-y>)
     *
     * @public
     * @sign public {Vector2D} negate();
     * @returns {Vector2D} this vector after negation
     */ Vector2D.prototype.negate = function() {
                    this.x = -this.x;
                    this.y = -this.y;
                    return this;
                }; // negate
                /**@
     * #.normalize
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Normalizes this vector (scales the vector so that its new magnitude is 1)
     * For vectors where magnitude is 0, <1,0> is returned.
     *
     * @public
     * @sign public {Vector2D} normalize();
     * @returns {Vector2D} this vector after normalization
     */ Vector2D.prototype.normalize = function() {
                    var lng = Math.sqrt(this.x * this.x + this.y * this.y);
                    if (lng === 0) {
                        // default due East
                        this.x = 1;
                        this.y = 0;
                    } else {
                        this.x /= lng;
                        this.y /= lng;
                    } // else
                    return this;
                }; // normalize
                /**@
     * #.scale
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Scales this vector by the passed amount(s)
     *
     * @public
     * @sign public {Vector2D} scale(Number scale);
     * @param {Number} scale - The amount to scale by
     * @returns {Vector2D} this after scaling
     *
     * @sign public {Vector2D} scale(Number scalarX, Number scalarY);
     * @param {Number} scalarX - The amount to scale x by
     * @param {Number} [scalarY] - The amount to scale y by
     * @returns {Vector2D} this after scaling
     */ Vector2D.prototype.scale = function(scalarX, scalarY) {
                    if (scalarY === undefined) scalarY = scalarX;
                    this.x *= scalarX;
                    this.y *= scalarY;
                    return this;
                }; // scale
                /**@
     * #.scaleToMagnitude
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Scales this vector such that its new magnitude is equal to the passed value.
     *
     * @public
     * @sign public {Vector2D} scaleToMagnitude(Number mag);
     * @param {Number} mag - The desired magnitude
     * @returns {Vector2D} this vector after scaling
     */ Vector2D.prototype.scaleToMagnitude = function(mag) {
                    var k = mag / this.magnitude();
                    this.x *= k;
                    this.y *= k;
                    return this;
                }; // scaleToMagnitude
                /**@
     * #.setValues
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Sets the values of this vector using a passed vector or pair of numbers.
     *
     * @public
     * @sign public {Vector2D} setValues(Vector2D vector);
     * @param {Vector2D} vector - a vector to copy
     * @returns {Vector2D} this vector after copying the values
     *
     * @sign public {Vector2D} setValues(Number x, Number y);
     * @param {Number} x - The x value to set
     * @param {Number} y - The y value to set
     * @returns {Vector2D} this vector after setting the values
     */ Vector2D.prototype.setValues = function(x, y) {
                    if (x instanceof Vector2D) {
                        this.x = x.x;
                        this.y = x.y;
                    } else {
                        this.x = x;
                        this.y = y;
                    } // else
                    return this;
                }; // setValues
                /**@
     * #.subtract
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Subtracts the passed vector from this vector.
     *
     * @public
     * @sign public {Vector2D} subtract(Vector2D vecRH);
     * @param {Vector2D} vecRH - the passed vector to subtract
     * @returns {vector2D} this vector after subtracting
     */ Vector2D.prototype.subtract = function(vecRH) {
                    this.x -= vecRH.x;
                    this.y -= vecRH.y;
                    return this;
                }; // subtract
                /**@
     * #.toString
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Returns a string representation of this vector.
     *
     * @public
     * @sign public {String} toString();
     * @returns {String} A representation like "Vector2D(4, 7)"
     */ Vector2D.prototype.toString = function() {
                    return "Vector2D(" + this.x + ", " + this.y + ")";
                }; // toString
                /**@
     * #.translate
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Translates (moves) this vector by the passed amounts.
     * If dy is omitted, dx is used for both axes.
     *
     * @public
     * @sign public {Vector2D} translate(Number dx[, Number dy]);
     * @param {Number} dx - The amount to shift by
     * @param {Number} [dy] - The amount to shift along the y axis
     * @returns {Vector2D} this vector after translating
     */ Vector2D.prototype.translate = function(dx, dy) {
                    if (dy === undefined) dy = dx;
                    this.x += dx;
                    this.y += dy;
                    return this;
                }; // translate
                /**@
     * #.tripleProduct
     * @comp Crafty.math.Vector2D
     * @kind Method
     *
     * Calculates the triple product of three vectors.
     * triple vector product = b(a•c) - a(b•c)
     *
     * @public
     * @static
     * @sign public {Vector2D} tripleProduct(Vector2D a, Vector2D b, Vector2D c, [Vector2D result]);
     * @param {Vector2D} a - The first vector
     * @param {Vector2D} b - The second vector
     * @param {Vector2D} c - The third vector
     * @param {Vector2D} [result] - An optional parameter to save the result in
     * @return {Vector2D} the triple product as a new vector
     */ Vector2D.tripleProduct = function(a, b, c, result) {
                    result = result || new Crafty.math.Vector2D();
                    var ac = a.dotProduct(c);
                    var bc = b.dotProduct(c);
                    return result.setValues(b.x * ac - a.x * bc, b.y * ac - a.y * bc);
                };
                return Vector2D;
            }();
            Crafty.math.Matrix2D = function() {
                /**@
     * #Crafty.math.Matrix2D
     * @category 2D
     * @kind Class
     *
     * @class This is a 2D Matrix2D class. It is 3x3 to allow for affine transformations in 2D space.
     * The third row is always assumed to be [0, 0, 1].
     *
     * Matrix2D uses the following form, as per the whatwg.org specifications for canvas.transform():
     * [a, c, e]
     * [b, d, f]
     * [0, 0, 1]
     *
     * @public
     * @sign public {Matrix2D} new Matrix2D();
     * @returns {Matrix2D} A new identity matrix
     *
     * @sign public {Matrix2D} new Matrix2D(Matrix2D matrix);
     * @param {Matrix2D} matrix - a matrix to copy
     * @returns {Matrix2D} A new instance whose entries are copied from the passed matrix
     *
     * @sign public {Matrix2D} new Matrix2D(Number a, Number b, Number c, Number d, Number e, Number f);
     * @param {Number=1} a - (m11) Horizontal scale
     * @param {Number=0} b - (m12) Horizontal skew
     * @param {Number=0} c - (m21) Vertical skew
     * @param {Number=1} d - (m22) Vertical scale
     * @param {Number=0} e - (dx) Horizontal translation
     * @param {Number=0} f - (dy) Vertical translation
     * @returns {Matrix2D} A new instance whose entries are set from the passed arguments
     *
     * @example
     * ```
     * // Create the following translation matrix:
     * // [1, 0, 5]
     * // [0, 1, 7]
     * // [0, 0, 1]
     * var m = new Crafty.math.Matrix2D(1, 0, 0, 1, 5, 7);
     * ```
     */ function Matrix2D(a, b, c, d, e, f) {
                    if (a instanceof Matrix2D) {
                        this.a = a.a;
                        this.b = a.b;
                        this.c = a.c;
                        this.d = a.d;
                        this.e = a.e;
                        this.f = a.f;
                    } else if (arguments.length === 6) {
                        this.a = a;
                        this.b = b;
                        this.c = c;
                        this.d = d;
                        this.e = e;
                        this.f = f;
                    } else if (arguments.length > 0) throw "Unexpected number of arguments for Matrix2D()";
                } // class Matrix2D
                Matrix2D.prototype.a = 1;
                Matrix2D.prototype.b = 0;
                Matrix2D.prototype.c = 0;
                Matrix2D.prototype.d = 1;
                Matrix2D.prototype.e = 0;
                Matrix2D.prototype.f = 0;
                /**@
     * #.apply
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Applies the matrix transformations to the passed object
     *
     * @public
     * @sign public {Vector2D} apply(Vector2D vecRH);
     * @param {Vector2D} vecRH - vector to be transformed
     * @returns {Vector2D} the passed vector object after transforming
     */ Matrix2D.prototype.apply = function(vecRH) {
                    // I'm not sure of the best way for this function to be implemented. Ideally
                    // support for other objects (rectangles, polygons, etc) should be easily
                    // addable in the future. Maybe a function (apply) is not the best way to do
                    // this...?
                    var tmpX = vecRH.x;
                    vecRH.x = tmpX * this.a + vecRH.y * this.c + this.e;
                    vecRH.y = tmpX * this.b + vecRH.y * this.d + this.f;
                    // no need to homogenize since the third row is always [0, 0, 1]
                    return vecRH;
                }; // apply
                /**@
     * #.clone
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Creates an exact, numeric copy of the current matrix
     *
     * @public
     * @sign public {Matrix2D} clone();
     * @returns {Matrix2D} The cloned matrix
     */ Matrix2D.prototype.clone = function() {
                    return new Matrix2D(this);
                }; // clone
                /**@
     * #.combine
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Multiplies this matrix with another, overriding the values of this matrix.
     * The passed matrix is assumed to be on the right-hand side.
     *
     * @public
     * @sign public {Matrix2D} combine(Matrix2D mtrxRH);
     * @param {Matrix2D} mtrxRH - The passed matrix
     * @returns {Matrix2D} this matrix after combination
     */ Matrix2D.prototype.combine = function(mtrxRH) {
                    var tmp = this.a;
                    this.a = tmp * mtrxRH.a + this.b * mtrxRH.c;
                    this.b = tmp * mtrxRH.b + this.b * mtrxRH.d;
                    tmp = this.c;
                    this.c = tmp * mtrxRH.a + this.d * mtrxRH.c;
                    this.d = tmp * mtrxRH.b + this.d * mtrxRH.d;
                    tmp = this.e;
                    this.e = tmp * mtrxRH.a + this.f * mtrxRH.c + mtrxRH.e;
                    this.f = tmp * mtrxRH.b + this.f * mtrxRH.d + mtrxRH.f;
                    return this;
                }; // combine
                /**@
     * #.equals
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Checks for the numeric element-wise equality of this matrix versus another.
     *
     * @public
     * @sign public {Boolean} equals(Matrix2D mtrxRH);
     * @param {Matrix2D} mtrxRH - The matrix to check equality with
     * @returns {Boolean} true if the two matrices are numerically equal
     */ Matrix2D.prototype.equals = function(mtrxRH) {
                    return mtrxRH instanceof Matrix2D && this.a === mtrxRH.a && this.b === mtrxRH.b && this.c === mtrxRH.c && this.d === mtrxRH.d && this.e === mtrxRH.e && this.f === mtrxRH.f;
                }; // equals
                /**@
     * #.determinant
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Calculates the determinant of this matrix
     *
     * @public
     * @sign public {Number} determinant();
     * @returns {Number} det(this matrix)
     */ Matrix2D.prototype.determinant = function() {
                    return this.a * this.d - this.b * this.c;
                }; // determinant
                /**@
     * #.invert
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Inverts this matrix if possible
     *
     * @public
     * @sign public {Matrix2D} invert();
     * @returns {Matrix2D} this inverted matrix or the original matrix on failure
     * @see .isInvertible
     */ Matrix2D.prototype.invert = function() {
                    var det = this.determinant();
                    // matrix is invertible if its determinant is non-zero
                    if (det !== 0) {
                        var old = {
                            a: this.a,
                            b: this.b,
                            c: this.c,
                            d: this.d,
                            e: this.e,
                            f: this.f
                        };
                        this.a = old.d / det;
                        this.b = -old.b / det;
                        this.c = -old.c / det;
                        this.d = old.a / det;
                        this.e = (old.c * old.f - old.e * old.d) / det;
                        this.f = (old.e * old.b - old.a * old.f) / det;
                    } // if
                    return this;
                }; // invert
                /**@
     * #.isIdentity
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Returns true if this matrix is the identity matrix
     *
     * @public
     * @sign public {Boolean} isIdentity();
     * @returns {Boolean} true if this matrix is an identity matrix
     */ Matrix2D.prototype.isIdentity = function() {
                    return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.e === 0 && this.f === 0;
                }; // isIdentity
                /**@
     * #.isInvertible
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Determines is this matrix is invertible.
     *
     * @public
     * @sign public {Boolean} isInvertible();
     * @returns {Boolean} true if this matrix is invertible
     * @see .invert
     */ Matrix2D.prototype.isInvertible = function() {
                    return this.determinant() !== 0;
                }; // isInvertible
                /**@
     * #.preRotate
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Applies a counter-clockwise pre-rotation to this matrix
     *
     * @public
     * @sign public {Matrix2D} preRotate(Number rads);
     * @param {number} rads - angle to rotate in radians
     * @returns {Matrix2D} this matrix after pre-rotation
     */ Matrix2D.prototype.preRotate = function(rads) {
                    var nCos = Math.cos(rads);
                    var nSin = Math.sin(rads);
                    var tmp = this.a;
                    this.a = nCos * tmp - nSin * this.b;
                    this.b = nSin * tmp + nCos * this.b;
                    tmp = this.c;
                    this.c = nCos * tmp - nSin * this.d;
                    this.d = nSin * tmp + nCos * this.d;
                    return this;
                }; // preRotate
                /**@
     * #.preScale
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Applies a pre-scaling to this matrix, applied to the a, b, c, and d elements.
     *
     * If two arguments are supplied, a and c are multiplied by scalarX, b, and d by scalarY.
     *
     * @public
     * @sign public {Matrix2D} preScale(Number scalarX[, Number scalarY]);
     * @param {Number} scalarX - The amount to scale
     * @param {Number} [scalarY] - scalarX is used if scalarY is undefined
     * @returns {Matrix2D} this after pre-scaling
     */ Matrix2D.prototype.preScale = function(scalarX, scalarY) {
                    if (scalarY === undefined) scalarY = scalarX;
                    this.a *= scalarX;
                    this.b *= scalarY;
                    this.c *= scalarX;
                    this.d *= scalarY;
                    return this;
                }; // preScale
                /**@
     * #.preTranslate
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Applies a pre-translation to this matrix
     *
     * @public
     * @sign public {Matrix2D} preTranslate(Number dx, Number dy);
     * @param {Number} dx - The amount to shift the e component
     * @param {Number} dy - The amount to shift the f component
     * @returns {Matrix2D} this matrix after pre-translation
     *
     * @sign public {Matrix2D} preTranslate(Vector2D vector);
     * @param {Vector2D} vector - The vector to shift (e, f) by.
     * @returns {Matrix2D} this matrix after pre-translation
     */ Matrix2D.prototype.preTranslate = function(dx, dy) {
                    if (typeof dx === "number") {
                        this.e += dx;
                        this.f += dy;
                    } else {
                        this.e += dx.x;
                        this.f += dx.y;
                    } // else
                    return this;
                }; // preTranslate
                /**@
     * #.rotate
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Applies a counter-clockwise post-rotation to this matrix
     *
     * @public
     * @sign public {Matrix2D} rotate(Number rads);
     * @param {Number} rads - angle to rotate in radians
     * @returns {Matrix2D} this matrix after rotation
     */ Matrix2D.prototype.rotate = function(rads) {
                    var nCos = Math.cos(rads);
                    var nSin = Math.sin(rads);
                    var tmp = this.a;
                    this.a = nCos * tmp - nSin * this.b;
                    this.b = nSin * tmp + nCos * this.b;
                    tmp = this.c;
                    this.c = nCos * tmp - nSin * this.d;
                    this.d = nSin * tmp + nCos * this.d;
                    tmp = this.e;
                    this.e = nCos * tmp - nSin * this.f;
                    this.f = nSin * tmp + nCos * this.f;
                    return this;
                }; // rotate
                /**@
     * #.scale
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Applies a post-scaling to this matrix, modifying components a-f.
     *
     * If two arguments are passed, scalarX is used for components a, c, and e; scalarY for b, d, and f.
     *
     * @public
     * @sign public {Matrix2D} scale(Number scalarX[, Number scalarY]);
     * @param {Number} scalarX The amount to scale by along the x axis
     * @param {Number} [scalarY] scalarX is used if scalarY is undefined
     * @returns {Matrix2D} this after post-scaling
     */ Matrix2D.prototype.scale = function(scalarX, scalarY) {
                    if (scalarY === undefined) scalarY = scalarX;
                    this.a *= scalarX;
                    this.b *= scalarY;
                    this.c *= scalarX;
                    this.d *= scalarY;
                    this.e *= scalarX;
                    this.f *= scalarY;
                    return this;
                }; // scale
                /**@
     * #.setValues
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Sets the values of this matrix.
     *
     * @public
     * @sign public {Matrix2D} setValues(Matrix2D matrix);
     * @param {Matrix2D} matrix - A matrix to copy the values from
     * @returns {Matrix2D} This matrix after copying the values
     *
     * @sign public {Matrix2D} setValues(Number a, Number b, Number c, Number d, Number e, Number f);
     * When used as a translation matrix, the 6 elements have particular meanings.
     * @param {Number} a - (m11) Horizontal scale
     * @param {Number} b - (m12) Horizontal skew
     * @param {Number} c - (m21) Vertical skew
     * @param {Number} d - (m22) Vertical scale
     * @param {Number} e - (dx) Horizontal translation
     * @param {Number} f - (dy) Vertical translation
     * @returns {Matrix2D} this matrix containing the new values
     */ Matrix2D.prototype.setValues = function(a, b, c, d, e, f) {
                    if (a instanceof Matrix2D) {
                        this.a = a.a;
                        this.b = a.b;
                        this.c = a.c;
                        this.d = a.d;
                        this.e = a.e;
                        this.f = a.f;
                    } else {
                        this.a = a;
                        this.b = b;
                        this.c = c;
                        this.d = d;
                        this.e = e;
                        this.f = f;
                    } // else
                    return this;
                }; // setValues
                /**@
     * #.toString
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Returns the string representation of this matrix.
     *
     * @public
     * @sign public {String} toString();
     * @returns {String} A string representation like "Matrix2D([a, c, e], [b, d, f], [0, 0, 1])"
     */ Matrix2D.prototype.toString = function() {
                    return "Matrix2D([" + this.a + ", " + this.c + ", " + this.e + "] [" + this.b + ", " + this.d + ", " + this.f + "] [0, 0, 1])";
                }; // toString
                /**@
     * #.translate
     * @comp Crafty.math.Matrix2D
     * @kind Method
     *
     * Applies a post-translation to this matrix
     *
     * @public
     * @sign public {Matrix2D} translate(Vector2D vector);
     * @param {Vector2D} vector - the vector to translate by
     * @returns {Matrix2D} this matrix after post-translation
     *
     * @sign public {Matrix2D} translate(Number dx, Number dy);
     * @param {Number} dx - The shift along the x-axis
     * @param {Number} dy - The shift along the y-axis
     * @returns {Matrix2D} this matrix after post-translation
     */ Matrix2D.prototype.translate = function(dx, dy) {
                    if (typeof dx === "number") {
                        this.e += this.a * dx + this.c * dy;
                        this.f += this.b * dx + this.d * dy;
                    } else {
                        this.e += this.a * dx.x + this.c * dx.y;
                        this.f += this.b * dx.x + this.d * dx.y;
                    } // else
                    return this;
                }; // translate
                return Matrix2D;
            }();
        },
        {
            "../core/core.js": 10
        }
    ],
    58: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            // This is used to define getters and setters for Motion properties
            // For instance
            //      __motionProp(entity, "a", "x", true)
            // will define a getter for `ax` which accesses an underlying private property `_ax`
            // If the `setter` property is false, setting a value will be a null-op
            var __motionProp = function(self, prefix, prop, setter) {
                var publicProp = prefix + prop;
                var privateProp = "_" + publicProp;
                var motionEvent = {
                    key: "",
                    oldValue: 0
                };
                // getters & setters for public property
                if (setter) Crafty.defineField(self, publicProp, function() {
                    return this[privateProp];
                }, function(newValue) {
                    var oldValue = this[privateProp];
                    if (newValue !== oldValue) {
                        this[privateProp] = newValue;
                        motionEvent.key = publicProp;
                        motionEvent.oldValue = oldValue;
                        this.trigger("MotionChange", motionEvent);
                    }
                });
                else Crafty.defineField(self, publicProp, function() {
                    return this[privateProp];
                }, function(newValue) {});
                // hide private property
                Object.defineProperty(self, privateProp, {
                    value: 0,
                    writable: true,
                    enumerable: false,
                    configurable: false
                });
            };
            // This defines an alias for a pair of underlying properties which represent the components of a vector
            // It takes an object with vector methods, and redefines its x/y properties as getters and setters to properties of self
            // This allows you to use the vector's special methods to manipulate the entity's properties,
            // while still allowing you to manipulate those properties directly if performance matters
            var __motionVector = function(self, prefix, setter, vector) {
                var publicX = prefix + "x", publicY = prefix + "y", privateX = "_" + publicX, privateY = "_" + publicY;
                if (setter) {
                    Crafty.defineField(vector, "x", function() {
                        return self[privateX];
                    }, function(v) {
                        self[publicX] = v;
                    });
                    Crafty.defineField(vector, "y", function() {
                        return self[privateY];
                    }, function(v) {
                        self[publicY] = v;
                    });
                } else {
                    Crafty.defineField(vector, "x", function() {
                        return self[privateX];
                    }, function(v) {});
                    Crafty.defineField(vector, "y", function() {
                        return self[privateY];
                    }, function(v) {});
                }
                if (Object.seal) Object.seal(vector);
                return vector;
            };
            /**@
 * #AngularMotion
 * @category 2D
 * @kind Component
 *
 * @trigger Rotated - When entity has rotated due to angular velocity/acceleration a Rotated event is triggered. - Number - Old rotation
 * @trigger NewRotationDirection - When entity has changed rotational direction due to rotational velocity a NewRotationDirection event is triggered. The event is triggered once, if direction is different from last frame. - -1 | 0 | 1 - New direction
 * @trigger MotionChange - When a motion property has changed a MotionChange event is triggered. - { key: String, oldValue: Number } - Motion property name and old value
 *
 * Component that allows rotating an entity by applying angular velocity and acceleration.
 * All angular motion values are expressed in degrees per second (e.g. an entity with `vrotation` of 10 will rotate 10 degrees each second).
 */ Crafty.c("AngularMotion", {
                /**@
     * #.vrotation
     * @comp AngularMotion
     * @kind Property
     *
     * A property for accessing/modifying the angular(rotational) velocity.
     * The velocity remains constant over time, unless the acceleration increases the velocity.
     *
     * @example
     * ~~~
     * var ent = Crafty.e("2D, AngularMotion");
     *
     * var vrotation = ent.vrotation; // retrieve the angular velocity
     * ent.vrotation += 1; // increase the angular velocity
     * ent.vrotation = 0; // reset the angular velocity
     * ~~~
     */ _vrotation: 0,
                /**@
     * #.arotation
     * @comp AngularMotion
     * @kind Property
     *
     * A property for accessing/modifying the angular(rotational) acceleration.
     * The acceleration increases the velocity over time, resulting in ever increasing speed.
     *
     * @example
     * ~~~
     * var ent = Crafty.e("2D, AngularMotion");
     *
     * var arotation = ent.arotation; // retrieve the angular acceleration
     * ent.arotation += 1; // increase the angular acceleration
     * ent.arotation = 0; // reset the angular acceleration
     * ~~~
     */ _arotation: 0,
                /**@
     * #.drotation
     * @comp AngularMotion
     * @kind Property
     *
     * A number that reflects the change in rotation (difference between the old & new rotation) that was applied in the last frame.
     *
     * @example
     * ~~~
     * var ent = Crafty.e("2D, AngularMotion");
     *
     * var drotation = ent.drotation; // the change of rotation in the last frame
     * ~~~
     */ _drotation: 0,
                init: function() {
                    this.requires("2D");
                    __motionProp(this, "v", "rotation", true);
                    __motionProp(this, "a", "rotation", true);
                    __motionProp(this, "d", "rotation", false);
                    this.__oldRotationDirection = 0;
                    this.bind("UpdateFrame", this._angularMotionTick);
                },
                remove: function(destroyed) {
                    this.unbind("UpdateFrame", this._angularMotionTick);
                },
                /**@
     * #.resetAngularMotion
     * @comp AngularMotion
     * @kind Method
     *
     * @sign public this .resetAngularMotion()
     *
     * Reset all motion (resets velocity, acceleration, motionDelta).
     */ resetAngularMotion: function() {
                    this._drotation = 0;
                    this.vrotation = 0;
                    this.arotation = 0;
                    return this;
                },
                /*
     * s += v * Δt + (0.5 * a) * Δt * Δt
     * v += a * Δt
     */ _angularMotionTick: function(frameData) {
                    var dt = frameData.dt / 1000; // Time in s
                    var oldR = this._rotation, vr = this._vrotation, ar = this._arotation;
                    // s += v * Δt + (0.5 * a) * Δt * Δt
                    var newR = oldR + vr * dt + 0.5 * ar * dt * dt;
                    // v += a * Δt
                    this.vrotation = vr + ar * dt;
                    // Check if direction of velocity has changed
                    var _vr = this._vrotation, dvr = _vr ? _vr < 0 ? -1 : 1 : 0; // Quick implementation of Math.sign
                    if (this.__oldRotationDirection !== dvr) {
                        this.__oldRotationDirection = dvr;
                        this.trigger("NewRotationDirection", dvr);
                    }
                    // Check if velocity has changed
                    // Δs = s[t] - s[t-1]
                    this._drotation = newR - oldR;
                    if (this._drotation !== 0) {
                        this.rotation = newR;
                        this.trigger("Rotated", oldR);
                    }
                }
            });
            /**@
 * #Motion
 * @category 2D
 * @kind Component
 *
 * @trigger NewDirection - When entity has changed direction due to velocity on either x or y axis a NewDirection event is triggered. The event is triggered once, if direction is different from last frame. - { x: -1 | 0 | 1, y: -1 | 0 | 1 } - New direction
 * @trigger MotionChange - When a motion property has changed a MotionChange event is triggered. - { key: String, oldValue: Number } - Motion property name and old value
 *
 * Component that allows moving an entity by applying linear velocity and acceleration.
 * All linear motion values are expressed in pixels per second (e.g. an entity with `vx` of 1 will move 1px on the x axis each second).
 *
 * @note Several methods return Vector2D objects that dynamically reflect the entity's underlying properties.  If you want a static copy instead, use the vector's `clone()` method.
 */ Crafty.c("Motion", {
                /**@
     * #.vx
     * @comp Motion
     * @kind Property
     *
     * A property for accessing/modifying the linear velocity in the x axis.
     * The velocity remains constant over time, unless the acceleration changes the velocity.
     *
     * @example
     * ~~~
     * var ent = Crafty.e("2D, Motion");
     *
     * var vx = ent.vx; // retrieve the linear velocity in the x axis
     * ent.vx += 1; // increase the linear velocity in the x axis
     * ent.vx = 0; // reset the linear velocity in the x axis
     * ~~~
     */ _vx: 0,
                /**@
     * #.vy
     * @comp Motion
     * @kind Property
     *
     * A property for accessing/modifying the linear velocity in the y axis.
     * The velocity remains constant over time, unless the acceleration changes the velocity.
     *
     * @example
     * ~~~
     * var ent = Crafty.e("2D, Motion");
     *
     * var vy = ent.vy; // retrieve the linear velocity in the y axis
     * ent.vy += 1; // increase the linear velocity in the y axis
     * ent.vy = 0; // reset the linear velocity in the y axis
     * ~~~
     */ _vy: 0,
                /**@
     * #.ax
     * @comp Motion
     * @kind Property
     *
     * A property for accessing/modifying the linear acceleration in the x axis.
     * The acceleration changes the velocity over time.
     *
     * @example
     * ~~~
     * var ent = Crafty.e("2D, Motion");
     *
     * var ax = ent.ax; // retrieve the linear acceleration in the x axis
     * ent.ax += 1; // increase the linear acceleration in the x axis
     * ent.ax = 0; // reset the linear acceleration in the x axis
     * ~~~
     */ _ax: 0,
                /**@
     * #.ay
     * @comp Motion
     * @kind Property
     *
     * A property for accessing/modifying the linear acceleration in the y axis.
     * The acceleration changes the velocity over time.
     *
     * @example
     * ~~~
     * var ent = Crafty.e("2D, Motion");
     *
     * var ay = ent.ay; // retrieve the linear acceleration in the y axis
     * ent.ay += 1; // increase the linear acceleration in the y axis
     * ent.ay = 0; // reset the linear acceleration in the y axis
     * ~~~
     */ _ay: 0,
                /**@
     * #.dx
     * @comp Motion
     * @kind Property
     *
     * A number that reflects the change in x (difference between the old & new x) that was applied in the last frame.
     *
     * @example
     * ~~~
     * var ent = Crafty.e("2D, Motion");
     *
     * var dx = ent.dx; // the change of x in the last frame
     * ~~~
     */ _dx: 0,
                /**@
     * #.dy
     * @comp Motion
     * @kind Property
     *
     * A number that reflects the change in y (difference between the old & new y) that was applied in the last frame.
     *
     * @example
     * ~~~
     * var ent = Crafty.e("2D, Motion");
     *
     * var dy = ent.dy; // the change of y in the last frame
     * ~~~
     */ _dy: 0,
                init: function() {
                    this.requires("2D");
                    __motionProp(this, "v", "x", true);
                    __motionProp(this, "v", "y", true);
                    this._velocity = __motionVector(this, "v", true, new Crafty.math.Vector2D());
                    __motionProp(this, "a", "x", true);
                    __motionProp(this, "a", "y", true);
                    this._acceleration = __motionVector(this, "a", true, new Crafty.math.Vector2D());
                    __motionProp(this, "d", "x", false);
                    __motionProp(this, "d", "y", false);
                    this._motionDelta = __motionVector(this, "d", false, new Crafty.math.Vector2D());
                    this.__oldDirection = {
                        x: 0,
                        y: 0
                    };
                    this.bind("UpdateFrame", this._linearMotionTick);
                },
                remove: function(destroyed) {
                    this.unbind("UpdateFrame", this._linearMotionTick);
                },
                /**@
     * #.resetMotion
     * @comp Motion
     * @kind Method
     *
     * @sign public this .resetMotion()
     * @return this
     *
     * Reset all linear motion (resets velocity, acceleration, motionDelta).
     */ resetMotion: function() {
                    this.vx = 0;
                    this.vy = 0;
                    this.ax = 0;
                    this.ay = 0;
                    this._dx = 0;
                    this._dy = 0;
                    return this;
                },
                /**@
     * #.motionDelta
     * @comp Motion
     * @kind Method
     *
     * @sign public Vector2D .motionDelta()
     * @return A Vector2D with the properties {x, y} that reflect the change in x & y.
     *
     * Returns the difference between the old & new position that was applied in the last frame.
     *
     * @example
     * ~~~
     * var ent = Crafty.e("2D, Motion");
     *
     * var deltaY = ent.motionDelta().y; // the change of y in the last frame
     * ~~~
     * @see Crafty.math.Vector2D
     */ motionDelta: function() {
                    return this._motionDelta;
                },
                /**@
     * #.velocity
     * @comp Motion
     * @kind Method
     * 
     * Method for accessing/modifying the linear(x,y) velocity. 
     * The velocity remains constant over time, unless the acceleration increases the velocity.
     *
     * @sign public Vector2D .velocity()
     * @return The velocity Vector2D with the properties {x, y} that reflect the velocities in the <x, y> direction of the entity.
     *
     * Returns the current velocity. You can access/modify the properties in order to retrieve/change the velocity.

     * @example
     * ~~~
     * var ent = Crafty.e("2D, Motion");
     *
     * var vel = ent.velocity(); //returns the velocity vector
     * vel.x;       // retrieve the velocity in the x direction
     * vel.x = 0;   // set the velocity in the x direction
     * vel.x += 4   // add to the velocity in the x direction
     * ~~~
     * @see Crafty.math.Vector2D
     */ velocity: function() {
                    return this._velocity;
                },
                /**@
     * #.acceleration
     * @comp Motion
     * @kind Method
     *
     * Method for accessing/modifying the linear(x,y) acceleration.
     * The acceleration increases the velocity over time, resulting in ever increasing speed.
     *
     * @sign public Vector2D .acceleration()
     * @return The acceleration Vector2D with the properties {x, y} that reflects the acceleration in the <x, y> direction of the entity.
     *
     * Returns the current acceleration. You can access/modify the properties in order to retrieve/change the acceleration.
     *
     * @example
     * ~~~
     * var ent = Crafty.e("2D, Motion");
     *
     * var acc = ent.acceleration(); //returns the acceleration object
     * acc.x;       // retrieve the acceleration in the x direction
     * acc.x = 0;   // set the acceleration in the x direction
     * acc.x += 4   // add to the acceleration in the x direction
     * ~~~
     * @see Crafty.math.Vector2D
     */ acceleration: function() {
                    return this._acceleration;
                },
                /**@
     * #.ccdbr
     * @comp Motion
     * @kind Method
     *
     * @sign public Object .ccdbr([Object ccdbr])
     * @param ccdbr - an object to use as output
     * @returns an object with `_x`, `_y`, `_w`, and `_h` properties; if an object is passed in, it will be reused rather than creating a new object.
     *
     * Return an object containing the entity's continuous collision detection bounding rectangle.
     * The CCDBR encompasses the motion delta of the entity's bounding rectangle since last frame.
     * The CCDBR is minimal if the entity moved on only one axis since last frame, however it encompasses a non-minimal region if it moved on both axis.
     * For further details, refer to [FAQ#Tunneling](https://github.com/craftyjs/Crafty/wiki/Crafty-FAQ-%28draft%29#why-are-my-bullets-passing-through-other-entities-without-registering-hits).
     *
     * @note The keys have an underscore prefix. This is due to the x, y, w, h properties
     * being setters and getters that wrap the underlying properties with an underscore (_x, _y, _w, _h).
     *
     * @see .motionDelta, Collision#.cbr
     */ ccdbr: function(ccdbr) {
                    var pos = this._cbr || this._mbr || this, dx = this._dx, dy = this._dy, ccdX = 0, ccdY = 0, ccdW = dx > 0 ? ccdX = dx : -dx, ccdH = dy > 0 ? ccdY = dy : -dy;
                    ccdbr = ccdbr || {};
                    ccdbr._x = pos._x - ccdX;
                    ccdbr._y = pos._y - ccdY;
                    ccdbr._w = pos._w + ccdW;
                    ccdbr._h = pos._h + ccdH;
                    return ccdbr;
                },
                /*
     * s += v * Δt + (0.5 * a) * Δt * Δt
     * v += a * Δt
     */ _linearMotionTick: function(frameData) {
                    var dt = frameData.dt / 1000; // time in s
                    var vx = this._vx, ax = this._ax, vy = this._vy, ay = this._ay;
                    // s += v * Δt + (0.5 * a) * Δt * Δt
                    var dx = vx * dt + 0.5 * ax * dt * dt;
                    var dy = vy * dt + 0.5 * ay * dt * dt;
                    // v += a * Δt
                    this.vx = vx + ax * dt;
                    this.vy = vy + ay * dt;
                    // Check if direction of velocity has changed
                    var oldDirection = this.__oldDirection, _vx = this._vx, dvx = _vx ? _vx < 0 ? -1 : 1 : 0, _vy = this._vy, dvy = _vy ? _vy < 0 ? -1 : 1 : 0;
                    if (oldDirection.x !== dvx || oldDirection.y !== dvy) {
                        oldDirection.x = dvx;
                        oldDirection.y = dvy;
                        this.trigger("NewDirection", oldDirection);
                    }
                    this._dx = dx;
                    this._dy = dy;
                    // Set the position using the optimized _setPosition method
                    this._setPosition(this._x + dx, this._y + dy);
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    59: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #Supportable
 * @category 2D
 * @kind Component
 *
 * @trigger LandedOnGround - When entity has landed. This event is triggered with the object the entity landed on.
 * @trigger LiftedOffGround - When entity has lifted off. This event is triggered with the object the entity stood on before lift-off.
 * @trigger CheckLanding - When entity is about to land. This event is triggered with the object the entity is about to land on. Third parties can respond to this event and prevent the entity from being able to land.
 *
 * Component that detects if the entity collides with the ground. This component is automatically added and managed by the Gravity component.
 * The appropriate events are fired when the entity state changes (lands on ground / lifts off ground). The current ground entity can also be accessed with `.ground`.
 */ Crafty.c("Supportable", {
                /**@
     * #.ground
     * @comp Supportable
     * @kind Property
     *
     * Access the ground entity (which may be the actual ground entity if it exists, or `null` if it doesn't exist) and thus whether this entity is currently on the ground or not.
     * The ground entity is also available through the events, when the ground entity changes.
     */ _ground: null,
                _groundComp: null,
                _preventGroundTunneling: false,
                /**@
     * #.canLand
     * @comp Supportable
     * @kind Property
     *
     * The canLand boolean determines if the entity is allowed to land or not (e.g. perhaps the entity should not land if it's not falling).
     * The Supportable component will trigger a "CheckLanding" event.
     * Interested parties can listen to this event and prevent the entity from landing by setting `canLand` to false.
     *
     * @example
     * ~~~
     * var player = Crafty.e("2D, Gravity");
     * player.bind("CheckLanding", function(ground) {
     *     if (player.y + player.h > ground.y + player.dy) { // forbid landing, if player's feet are not above ground
     *         player.canLand = false;
     *     }
     * });
     * ~~~
     */ canLand: true,
                init: function() {
                    this.requires("2D");
                    this.__area = {
                        _x: 0,
                        _y: 0,
                        _w: 0,
                        _h: 0
                    };
                    this.defineField("ground", function() {
                        return this._ground;
                    }, function(newValue) {});
                },
                remove: function(destroyed) {
                    this.unbind("UpdateFrame", this._detectGroundTick);
                },
                /*@
     * #.startGroundDetection
     * @comp Supportable
     * @kind Method
     * 
     * @sign private this .startGroundDetection([comp])
     * @param comp - The name of a component that will be treated as ground
     *
     * This method is automatically called by the Gravity component and should not be called by the user.
     *
     * Enable ground detection for this entity no matter whether comp parameter is specified or not.
     * If comp parameter is specified all entities with that component will stop this entity from falling.
     * For a player entity in a platform game this would be a component that is added to all entities
     * that the player should be able to walk on.
     * 
     * @example
     * ~~~
     * Crafty.e("2D, DOM, Color, Gravity")
     *   .color("red")
     *   .attr({ w: 100, h: 100 })
     *   .gravity("platform");
     * ~~~
     *
     * @see Gravity
     */ startGroundDetection: function(ground) {
                    if (ground) this._groundComp = ground;
                    this.uniqueBind("UpdateFrame", this._detectGroundTick);
                    return this;
                },
                /*@
     * #.stopGroundDetection
     * @comp Supportable
     * @kind Method
     * 
     * @sign private this .stopGroundDetection()
     *
     * This method is automatically called by the Gravity component and should not be called by the user.
     *
     * Disable ground detection for this component. It can be reenabled by calling .startGroundDetection()
     */ stopGroundDetection: function() {
                    this.unbind("UpdateFrame", this._detectGroundTick);
                    return this;
                },
                /**@
     * #.preventGroundTunneling
     * @comp Supportable
     * @kind Method
     *
     * @sign this .preventGroundTunneling([Boolean enable])
     * @param enable - Boolean indicating whether to enable continous collision detection or not; if omitted defaults to true
     *
     * Prevent entity from falling through thin ground entities at high speeds. This setting is disabled by default.
     * This is performed by approximating continous collision detection, which may impact performance negatively.
     * For further details, refer to [FAQ#Tunneling](https://github.com/craftyjs/Crafty/wiki/Crafty-FAQ-%28draft%29#why-are-my-bullets-passing-through-other-entities-without-registering-hits).
     *
     * @see Motion#.ccdbr
     */ preventGroundTunneling: function(enable) {
                    if (typeof enable === "undefined") enable = true;
                    if (enable) this.requires("Motion");
                    this._preventGroundTunneling = enable;
                    return this;
                },
                _detectGroundTick: function() {
                    var groundComp = this._groundComp, ground = this._ground, overlap = Crafty.rectManager.overlap, area;
                    if (!this._preventGroundTunneling) {
                        var pos = this._cbr || this._mbr || this;
                        area = this.__area;
                        area._x = pos._x;
                        area._y = pos._y;
                        area._w = pos._w;
                        area._h = pos._h;
                    } else area = this.ccdbr(this.__area);
                    area._h++; // Increase by 1 to make sure map.search() finds the floor
                    // Decrease width by 1px from left and 1px from right, to fall more gracefully
                    // area._x++; area._w--;
                    // check if we lift-off
                    if (ground) {
                        var garea = ground._cbr || ground._mbr || ground;
                        if (!(ground.__c[groundComp] && Crafty(ground[0]) === ground && overlap(garea, area))) {
                            this._ground = null;
                            this.trigger("LiftedOffGround", ground); // no collision with ground was detected for first time
                            ground = null;
                        }
                    }
                    // check if we land (also possible to land on other ground object in same frame after lift-off from current ground object)
                    if (!ground) {
                        var obj, oarea, results = Crafty.map.unfilteredSearch(area), i = 0, l = results.length;
                        for(; i < l; ++i){
                            obj = results[i];
                            oarea = obj._cbr || obj._mbr || obj;
                            // check for an intersection with the player
                            if (obj !== this && obj.__c[groundComp] && overlap(oarea, area)) {
                                this.canLand = true;
                                this.trigger("CheckLanding", obj); // is entity allowed to land?
                                if (this.canLand) {
                                    this._ground = ground = obj;
                                    // snap entity to ground object
                                    this.y = ground._y - this._h;
                                    if (this._x > ground._x + ground._w) this.x = ground._x + ground._w - 1;
                                    else if (this._x + this._w < ground._x) this.x = ground._x - this._w + 1;
                                    this.trigger("LandedOnGround", ground); // collision with ground was detected for first time
                                    break;
                                }
                            }
                        }
                    }
                }
            });
            /**@
 * #GroundAttacher
 * @category 2D
 * @kind Component
 *
 * Attach the entity to the ground when it lands. Useful for platformers with moving platforms.
 * Remove the component to disable the functionality.
 *
 * Additionally, this component provides the entity with `Supportable` methods & events.
 *
 * @example
 * ~~~
 * Crafty.e("2D, Gravity, GroundAttacher")
 *     .gravity("Platform"); // entity will land on and move with entites that have the "Platform" component
 * ~~~
 *
 * @see Supportable, Gravity
 */ Crafty.c("GroundAttacher", {
                _groundAttach: function(ground) {
                    ground.attach(this);
                },
                _groundDetach: function(ground) {
                    ground.detach(this);
                },
                init: function() {
                    this.requires("Supportable");
                    this.bind("LandedOnGround", this._groundAttach);
                    this.bind("LiftedOffGround", this._groundDetach);
                },
                remove: function(destroyed) {
                    this.unbind("LandedOnGround", this._groundAttach);
                    this.unbind("LiftedOffGround", this._groundDetach);
                }
            });
            /**@
 * #Gravity
 * @category 2D
 * @kind Component
 *
 * Adds gravitational pull to the entity.
 *
 * Additionally, this component provides the entity with `Supportable` and `Motion` methods & events.
 *
 * Simulates jumping and falling when used with the `Twoway` component and is thus well suited for side-scrolling platformer type games.
 * This component should not be used alongside `Fourway` or `Multiway`.
 *
 * @see Supportable, Motion
 */ Crafty.c("Gravity", {
                _gravityConst: 500,
                _gravityActive: false,
                init: function() {
                    this.requires("2D, Supportable, Motion");
                    this.bind("LiftedOffGround", this._startGravity); // start gravity if we are off ground
                    this.bind("LandedOnGround", this._stopGravity); // stop gravity once landed
                },
                remove: function(destroyed) {
                    this.unbind("LiftedOffGround", this._startGravity);
                    this.unbind("LandedOnGround", this._stopGravity);
                },
                _gravityCheckLanding: function(ground) {
                    if (this._dy < 0) this.canLand = false;
                },
                /**@
     * #.gravity
     * @comp Gravity
     * @kind Method
     *
     * @sign public this .gravity([comp])
     * @param comp - The name of a component that will stop this entity from falling
     *
     * Enable gravity for this entity no matter whether comp parameter is specified or not.
     * If comp parameter is specified all entities with that component will stop this entity from falling.
     * For a player entity in a platform game this would be a component that is added to all entities
     * that the player should be able to walk on.
     *
     * @example
     * ~~~
     * Crafty.e("2D, DOM, Color, Gravity")
     *   .color("red")
     *   .attr({ w: 100, h: 100 })
     *   .gravity("platform");
     * ~~~
     */ gravity: function(comp) {
                    this.uniqueBind("CheckLanding", this._gravityCheckLanding);
                    this.startGroundDetection(comp);
                    this._startGravity();
                    return this;
                },
                /**@
     * #.antigravity
     * @comp Gravity
     * @kind Method
     *
     * @sign public this .antigravity()
     * Disable gravity for this component. It can be reenabled by calling .gravity()
     */ antigravity: function() {
                    this._stopGravity();
                    this.stopGroundDetection();
                    this.unbind("CheckLanding", this._gravityCheckLanding);
                    return this;
                },
                /**@
     * #.gravityConst
     * @comp Gravity
     * @kind Method
     *
     * @sign public this .gravityConst(g)
     * @param g - gravitational constant in pixels per second squared
     *
     * Set the gravitational constant to g for this entity. The default is 500. The greater g, the stronger the downwards acceleration.
     *
     * @example
     * ~~~
     * Crafty.e("2D, DOM, Color, Gravity")
     *   .color("red")
     *   .attr({ w: 100, h: 100 })
     *   .gravityConst(750)
     *   .gravity("platform");
     * ~~~
     */ gravityConst: function(g) {
                    if (this._gravityActive) {
                        // gravity active, change acceleration
                        this.ay -= this._gravityConst;
                        this.ay += g;
                    }
                    this._gravityConst = g;
                    return this;
                },
                _startGravity: function() {
                    if (this._gravityActive) return;
                    this._gravityActive = true;
                    this.ay += this._gravityConst;
                },
                _stopGravity: function() {
                    if (!this._gravityActive) return;
                    this._gravityActive = false;
                    this.ay = 0;
                    this.vy = 0;
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    60: [
        function(require1, module, exports) {
            var Crafty = require1("../core/core.js");
            /**@
 * #Crafty.rectManager
 * @category 2D
 * @kind CoreObj
 *
 * Collection of methods for handling rectangles
 */ Crafty.extend({
                /** recManager: an object for managing dirty rectangles. */ rectManager: {
                    /** Finds smallest rectangles that overlaps a and b, merges them into target */ merge: function(a, b, target) {
                        if (typeof target === "undefined") target = {};
                        // Doing it in this order means we can use either a or b as the target, with no conflict
                        target._h = Math.max(a._y + a._h, b._y + b._h);
                        target._w = Math.max(a._x + a._w, b._x + b._w);
                        target._x = Math.min(a._x, b._x);
                        target._y = Math.min(a._y, b._y);
                        target._w -= target._x;
                        target._h -= target._y;
                        return target;
                    },
                    /**@
         * #Crafty.rectManager.overlap
         * @comp Crafty.rectManager
         * @kind Method
         *
         * @sign public Boolean Crafty.rectManager.overlap(Object rectA, Object rectA)
         * @param rectA - An object that must have the `_x, _y, _w, _h` values as properties
         * @param rectB - An object that must have the `_x, _y, _w, _h` values as properties
         * @return true if the rectangles overlap; false otherwise
         *
         * Checks whether two rectangles overlap.
         */ overlap: function(rectA, rectB) {
                        return rectA._x < rectB._x + rectB._w && rectA._x + rectA._w > rectB._x && rectA._y < rectB._y + rectB._h && rectA._y + rectA._h > rectB._y;
                    },
                    /**@
         * #Crafty.rectManager.integerBounds
         * @comp Crafty.rectManager
         * @kind Method
         *
         * @sign public Boolean Crafty.rectManager.integerBounds(Object rect)
         * @param rect - An object that must have the `_x, _y, _w, _h` values as properties
         * @return An enclosing rectangle with integer coordinates
         *
         * Calculate the smallest rectangle with integer coordinates that encloses the specified rectangle,
         * modifying the passed object to have those bounds.
         */ integerBounds: function(rect) {
                        // Truncate to next, lower integer, but don't modify if already integer
                        rect._x = Math.floor(rect._x);
                        rect._y = Math.floor(rect._y);
                        // Ceil to next, higher integer, but don't modify if already integer
                        rect._w = Math.ceil(rect._w);
                        rect._h = Math.ceil(rect._h);
                        return rect;
                    },
                    /**@
         * #Crafty.rectManager.mergeSet
         * @comp Crafty.rectManager
         * @kind Method
         *
         * @sign public Object Crafty.rectManager.mergeSet(Object set)
         * @param set - an array of rectangular regions
         *
         * Merge any consecutive, overlapping rects into each other.
         * Its an optimization for the redraw regions.
         *
         * The order of set isn't strictly meaningful,
         * but overlapping objects will often cause each other to change,
         * and so might be consecutive.
         */ mergeSet: function(set) {
                        if (set.length < 2) return set;
                        var i = set.length - 1;
                        while(i--)// If current and next overlap, merge them together into the first, removing the second
                        if (this.overlap(set[i], set[i + 1])) {
                            this.merge(set[i], set[i + 1], set[i]);
                            set.splice(i + 1, 1);
                        }
                        return set;
                    },
                    /**@
         * #Crafty.rectManager.boundingRect
         * @comp Crafty.rectManager
         * @kind Method
         *
         * @sign public Crafty.rectManager.boundingRect(set)
         * @param set - An array of rectangles
         *
         * - Calculate the common bounding rect of multiple canvas entities.
         * - Returns coords
         */ boundingRect: function(set) {
                        if (!set || !set.length) return;
                        var i = 1, l = set.length, current, master = set[0], tmp;
                        master = [
                            master._x,
                            master._y,
                            master._x + master._w,
                            master._y + master._h
                        ];
                        while(i < l){
                            current = set[i];
                            tmp = [
                                current._x,
                                current._y,
                                current._x + current._w,
                                current._y + current._h
                            ];
                            if (tmp[0] < master[0]) master[0] = tmp[0];
                            if (tmp[1] < master[1]) master[1] = tmp[1];
                            if (tmp[2] > master[2]) master[2] = tmp[2];
                            if (tmp[3] > master[3]) master[3] = tmp[3];
                            i++;
                        }
                        tmp = master;
                        master = {
                            _x: tmp[0],
                            _y: tmp[1],
                            _w: tmp[2] - tmp[0],
                            _h: tmp[3] - tmp[1]
                        };
                        return master;
                    },
                    // Crafty.rectManager._rectPool
                    //
                    // This is a private object used internally by 2D methods
                    // Cascade and _attr need to keep track of an entity's old position,
                    // but we want to avoid creating temp objects every time an attribute is set.
                    // The solution is to have a pool of objects that can be reused.
                    //
                    // The current implementation makes a BIG ASSUMPTION:  that if multiple rectangles are requested,
                    // the later one is recycled before any preceding ones.  This matches how they are used in the code.
                    // Each rect is created by a triggered event, and will be recycled by the time the event is complete.
                    _pool: function() {
                        var pool = [], pointer = 0;
                        return {
                            get: function(x, y, w, h) {
                                if (pool.length <= pointer) pool.push({});
                                var r = pool[pointer++];
                                r._x = x;
                                r._y = y;
                                r._w = w;
                                r._h = h;
                                return r;
                            },
                            copy: function(o) {
                                if (pool.length <= pointer) pool.push({});
                                var r = pool[pointer++];
                                r._x = o._x;
                                r._y = o._y;
                                r._w = o._w;
                                r._h = o._h;
                                return r;
                            },
                            recycle: function(o) {
                                pointer--;
                            }
                        };
                    }()
                }
            });
        },
        {
            "../core/core.js": 10
        }
    ],
    61: [
        function(require1, module, exports) {
            /**
 * Spatial HashMap for broad phase collision
 *
 * @author Louis Stowasser
 */ /**@
 * #Crafty.HashMap
 * @category 2D
 * @kind Class
 *
 * Broad-phase collision detection engine. See background information at
 *
 * - [N Tutorial B - Broad-Phase Collision](http://www.metanetsoftware.com/technique/tutorialB.html)
 * - [Broad-Phase Collision Detection with CUDA](http://http.developer.nvidia.com/GPUGems3/gpugems3_ch32.html)
 * @see Crafty.map
 */ var cellsize, SPACE = " ", keyHolder = {}; // temp object for reuse
            /**@
 * #Crafty.HashMap.constructor
 * @comp Crafty.HashMap
 * @kind Class
 *
 * @sign public void Crafty.HashMap([cellsize])
 * @param cellsize - the cell size. If omitted, `cellsize` is 64.
 *
 * Set `cellsize`.
 * And create `this.map`.
 */ var HashMap = function(cell) {
                cellsize = cell || 64;
                this.map = {};
                this.boundsDirty = false;
                this.coordBoundsDirty = false;
                this.boundsHash = {
                    maxX: -Infinity,
                    maxY: -Infinity,
                    minX: Infinity,
                    minY: Infinity
                };
                this.boundsCoords = {
                    maxX: -Infinity,
                    maxY: -Infinity,
                    minX: Infinity,
                    minY: Infinity
                };
            };
            /**@
 * #Crafty.HashMap.key
 * @comp Crafty.HashMap
 * @kind Method
 *
 * @sign public Object Crafty.HashMap.key(Object obj[, Object keys])
 * @param obj - an Object that has .cbr(), .mbr() or _x, _y, _w and _h.
 * @param [keys] - optional object to reuse for the saving result in
 * @returns an object describing the region in grid cells the given object is located in - { x1: start col index, y1: start row index, x2: end col index, y2: end row index}
 *
 * Get the rectangular region (in terms of the grid, with grid size `cellsize`), where the object may fall in. This region is determined by the object's bounding box.
 * The `cellsize` is 64 by default.
 *
 * @see Crafty.HashMap.constructor
 */ HashMap.key = function(obj, keys) {
                obj = obj._cbr || obj._mbr || obj;
                keys = keys || {};
                keys.x1 = Math.floor(obj._x / cellsize);
                keys.y1 = Math.floor(obj._y / cellsize);
                keys.x2 = Math.floor((obj._w + obj._x) / cellsize);
                keys.y2 = Math.floor((obj._h + obj._y) / cellsize);
                return keys;
            };
            HashMap.hash = function(keys) {
                return keys.x1 + SPACE + keys.y1 + SPACE + keys.x2 + SPACE + keys.y2;
            };
            // TODO make this an instance property getter
            HashMap.cellsize = function() {
                return cellsize;
            };
            /**@
 * #Crafty.map
 * @category 2D
 * @kind CoreObject
 *
 * Functions related with querying entities.
 * @see Crafty.HashMap
 */ HashMap.prototype = {
                /**@
     * #Crafty.map.insert
     * @comp Crafty.map
     * @kind Method
     *
     * @sign public Object Crafty.map.insert(Object obj[, Object entry])
     * @param obj - An entity to be inserted.
     * @param entry - An existing entry object to reuse.  (Optional)
     * @returns An object representing this object's entry in the HashMap
     *
     * `obj` is inserted in '.map' of the corresponding broad phase cells. An object of the following fields is returned.
     * ~~~
     * {
     *   keys: the object that keep track of cells
     *   obj: The inserted object
     *   map: the HashMap object
     * }
     * ~~~
     */ insert: function(obj, entry) {
                    var i, j, hash;
                    var keys = HashMap.key(obj, entry && entry.keys);
                    entry = entry || new Entry(keys, obj, this);
                    //insert into all x buckets
                    for(i = keys.x1; i <= keys.x2; i++)//insert into all y buckets
                    for(j = keys.y1; j <= keys.y2; j++){
                        hash = i << 16 ^ j;
                        if (!this.map[hash]) this.map[hash] = [];
                        this.map[hash].push(obj);
                    }
                    //mark map boundaries as dirty
                    this.boundsDirty = true;
                    return entry;
                },
                /**@
     * #Crafty.map.search
     * @comp Crafty.map
     * @kind Method
     *
     * @sign public Array Crafty.map.search(Object rect[, Array results])
     * @param rect - the rectangular region to search for entities.
     *               This object must contain the properties `_x`,`_y`,`_w`,`_h`.
     * @param results - If passed, entities found will be appended to this array.
     * @return a (possibly empty) array of entities that have been found in the given region
     *
     * Do a search for entities in the given region.  Returned entities are guaranteed
     * to overlap with the given region.
     *
     * The easier usage is with `filter == true`. For performance reason, you may use `filter == false`, and filter the result yourself. See examples in drawing.js and collision.js.
     *
     * @example
     * ~~~
     * // search for entities located in the current visible region of the viewport
     * var results = Crafty.map.search(Crafty.viewport.rect());
     * // iterate over all those entities
     * var ent;
     * for (var i = 0, l = results.length; i < l; ++i) {
     *     // do something with an entity
     *     ent = results[i];
     *     Crafty.log('Found entity with id', ent.getId());
     * }
     * ~~~
     */ _searchHolder: [],
                search: function(rect, results) {
                    var keys = HashMap.key(rect, keyHolder), i, j, k, cell, previouslyChecked = this._searchHolder;
                    results = results || [];
                    previouslyChecked.length = 0;
                    var obj;
                    //search in all x buckets
                    for(i = keys.x1; i <= keys.x2; i++)//insert into all y buckets
                    for(j = keys.y1; j <= keys.y2; j++){
                        if (cell = this.map[i << 16 ^ j]) for(k = 0; k < cell.length; k++){
                            if (previouslyChecked[cell[k][0]]) continue;
                            obj = previouslyChecked[cell[k][0]] = cell[k];
                            obj = obj._cbr || obj._mbr || obj;
                            if (obj._x < rect._x + rect._w && obj._x + obj._w > rect._x && obj._y < rect._y + rect._h && obj._y + obj._h > rect._y) results.push(cell[k]);
                        }
                    }
                    return results;
                },
                /**@
     * #Crafty.map.unfilteredSearch
     * @comp Crafty.map
     * @kind Method
     *
     * @sign public Array Crafty.map.search(Object rect[, Array results])
     * @param rect - the rectangular region to search for entities.
     *               This object must contain the properties `_x`,`_y`,`_w`,`_h`.
     * @param results - If passed, entities found will be appended to this array.
     * @return a (possibly empty) array of entities that have been found in the given region
     *
     * Do a search for entities in the given region.  Returned entities are **not** guaranteed
     * to overlap with the given region, and the results may contain duplicates.
     *
     * This method is intended to be used as the first step of a more complex search.
     * More common use cases should use Crafty.map.search, which filters the results.
     *
     * @see Crafty.map.search
     */ unfilteredSearch: function(rect, results) {
                    var keys = HashMap.key(rect, keyHolder), i, j, k, cell;
                    results = results || [];
                    //search in all x buckets
                    for(i = keys.x1; i <= keys.x2; i++)//insert into all y buckets
                    for(j = keys.y1; j <= keys.y2; j++){
                        if (cell = this.map[i << 16 ^ j]) for(k = 0; k < cell.length; k++)results.push(cell[k]);
                    }
                    return results;
                },
                /**@
     * #Crafty.map.remove
     * @comp Crafty.map
     * @kind Method
     *
     * @sign public void Crafty.map.remove(Entry entry)
     * @param entry - An entry to remove from the hashmap
     *
     * Remove an entry from the broad phase map.
     *
     * @example
     * ~~~
     * Crafty.map.remove(e);
     * ~~~
     */ remove: function(entry) {
                    var keys = entry.keys;
                    var obj = entry.obj;
                    var i = 0, j, hash;
                    //search in all x buckets
                    for(i = keys.x1; i <= keys.x2; i++)//insert into all y buckets
                    for(j = keys.y1; j <= keys.y2; j++){
                        hash = i << 16 ^ j;
                        if (this.map[hash]) {
                            var cell = this.map[hash], m, n = cell.length;
                            //loop over objs in cell and delete
                            for(m = 0; m < n; m++)if (cell[m] && cell[m][0] === obj[0]) cell.splice(m, 1);
                        }
                    }
                    //mark map boundaries as dirty
                    this.boundsDirty = true;
                },
                /**@
     * #Crafty.map.refresh
     * @comp Crafty.map
     * @kind Method
     *
     * @sign public void Crafty.map.refresh(Entry entry)
     * @param entry - An entry to update
     *
     * Update an entry's keys, and its position in the broad phrase map.
     *
     * @example
     * ~~~
     * Crafty.map.refresh(e);
     * ~~~
     */ refresh: function(entry) {
                    var keys = entry.keys;
                    var obj = entry.obj;
                    var cell, i, j, m, n;
                    //First delete current object from appropriate cells
                    for(i = keys.x1; i <= keys.x2; i++)for(j = keys.y1; j <= keys.y2; j++){
                        cell = this.map[i << 16 ^ j];
                        if (cell) {
                            n = cell.length;
                            //loop over objs in cell and delete
                            for(m = 0; m < n; m++)if (cell[m] && cell[m][0] === obj[0]) cell.splice(m, 1);
                        }
                    }
                    //update keys
                    HashMap.key(obj, keys);
                    //insert into all rows and columns
                    for(i = keys.x1; i <= keys.x2; i++)for(j = keys.y1; j <= keys.y2; j++){
                        cell = this.map[i << 16 ^ j];
                        if (!cell) cell = this.map[i << 16 ^ j] = [];
                        cell.push(obj);
                    }
                    //mark map boundaries as dirty
                    this.boundsDirty = true;
                    return entry;
                },
                /**@
     * #Crafty.map.boundaries
     * @comp Crafty.map
     * @kind Method
     *
     * @sign public Object Crafty.map.boundaries()
     * @returns An object with the following structure, which represents an MBR which contains all entities
     *
     * Return a copy of the minimum bounding rectangle encompassing all entities.
     *
     * ~~~
     * {
     *   min: {
     *     x: val_x,
     *     y: val_y
     *   },
     *   max: {
     *     x: val_x,
     *     y: val_y
     *   }
     * }
     * ~~~
     */ boundaries: function() {
                    // TODO: flatten output, likewise do it for Crafty.viewport.bounds
                    // TODO: accept optional parameter to save result in
                    this._updateBoundaries();
                    var bounds = this.boundsCoords;
                    return {
                        min: {
                            x: bounds.minX,
                            y: bounds.minY
                        },
                        max: {
                            x: bounds.maxX,
                            y: bounds.maxY
                        }
                    };
                },
                /**
     * #Crafty.map._keyBoundaries
     * @comp Crafty.map
     * @kind Method
     *
     * @sign private Object Crafty.map._keyBoundaries()
     * @returns An object with the following structure, which represents an MBR which contains all hash keys
     *
     * Find boundaries of row/col cell grid keys instead of actual x/y pixel coordinates.
     *
     * ~~~
     * {
     *   minX: val_x,
     *   minY: val_y,
     *   maxX: val_x,
     *   maxY: val_y
     * }
     * ~~~
     */ _keyBoundaries: function() {
                    this._updateBoundaries();
                    return this.boundsHash;
                },
                _updateBoundaries: function() {
                    // update map boundaries if they were changed
                    if (!this.boundsDirty && !this.coordBoundsDirty) return;
                    var hash = this.boundsHash;
                    // Optimization: if no entities have moved cells,
                    // we don't need to recalculate the hash boundaries
                    if (this.boundsDirty) {
                        hash.maxX = -Infinity;
                        hash.maxY = -Infinity;
                        hash.minX = Infinity;
                        hash.minY = Infinity;
                    }
                    var coords = this.boundsCoords;
                    coords.maxX = -Infinity;
                    coords.maxY = -Infinity;
                    coords.minX = Infinity;
                    coords.minY = Infinity;
                    var k, ent, cell;
                    //Using broad phase hash to speed up the computation of boundaries.
                    for(var h in this.map){
                        cell = this.map[h];
                        if (!cell.length) continue;
                        //broad phase coordinate
                        var i = h >> 16, j = h << 16 >> 16;
                        if (j < 0) i = ~i; // i ^ -1
                        if (i >= hash.maxX) {
                            hash.maxX = i;
                            for(k in cell){
                                ent = cell[k];
                                //TODO: remove these checks introduced by 25e7c88f61f64525adc32f7fd776099413cb1567?
                                //make sure that this is a Crafty entity
                                if (typeof ent === "object" && "requires" in ent) coords.maxX = Math.max(coords.maxX, ent.x + ent.w);
                            }
                        }
                        if (i <= hash.minX) {
                            hash.minX = i;
                            for(k in cell){
                                ent = cell[k];
                                if (typeof ent === "object" && "requires" in ent) coords.minX = Math.min(coords.minX, ent.x);
                            }
                        }
                        if (j >= hash.maxY) {
                            hash.maxY = j;
                            for(k in cell){
                                ent = cell[k];
                                if (typeof ent === "object" && "requires" in ent) coords.maxY = Math.max(coords.maxY, ent.y + ent.h);
                            }
                        }
                        if (j <= hash.minY) {
                            hash.minY = j;
                            for(k in cell){
                                ent = cell[k];
                                if (typeof ent === "object" && "requires" in ent) coords.minY = Math.min(coords.minY, ent.y);
                            }
                        }
                    }
                    // mark map boundaries as clean
                    this.boundsDirty = false;
                    this.coordBoundsDirty = false;
                },
                /**@
     * #Crafty.map.traverseRay
     * @comp Crafty.map
     * @kind Method
     *
     * @sign public void Crafty.map.traverseRay(Object origin, Object direction, Function callback)
     * @param origin - the point of origin from which the ray will be cast. The object must contain the properties `_x` and `_y`.
     * @param direction - the direction the ray will be cast. It must be normalized. The object must contain the properties `x` and `y`.
     * @param callback - a callback that will be called for each object that is encountered along the ray.
     *                   This function is called with two arguments: The first one represents the object encountered;
     *                   the second one represents the distance up to which all objects have been reported so far.
     *                   The callback can return a truthy value in order to stop the traversal early.
     *
     * Traverse the spatial map in the direction of the supplied ray.
     *
     * Given the `origin` and `direction` the ray is cast and the `callback` is called
     * for each object encountered in map cells traversed by the ray.
     *
     * The callback is called for each object that may be intersected by the ray.
     * Whether an actual intersection occurs shall be determined by the callback's implementation.
     *
     * @example
     * ~~~
     * Crafty.e("2D")
     *       .setName('First entity')
     *       .attr({x: 0, y: 0, w: 10, h: 10});
     *
     * Crafty.e("2D")
     *       .setName('Second entity')
     *       .attr({x: 20, y: 20, w: 10, h: 10});
     *
     * var origin = {_x: -25, _y: -25};
     * var direction = new Crafty.math.Vector2D(1, 1).normalize();
     *
     * Crafty.map.traverseRay(origin, direction, function(ent, processedDistance) {
     *   Crafty.log('Encountered entity named', ent.getName()); // logs 'First entity'
     *   Crafty.log('All entities up to', processedDistance, 'px away have been reported thus far.');
     *   Crafty.log('Stopping traversal after encountering the first entity.');
     *   return true;
     * });
     * ~~~
     */ // See [this tutorial](http://www.flipcode.com/archives/Raytracing_Topics_Techniques-Part_4_Spatial_Subdivisions.shtml) and linked materials
                // Segment-segment intersection is described here: http://stackoverflow.com/a/565282/3041008
                //
                // origin = {_x, _y}
                // direction = {x, y}, must be normalized
                //
                //
                // # Let
                //  edge = end - start
                //  edge x edge == 0
                //
                // # Segment - segment intersection equation
                //  origin + d * direction = start + e * edge
                //
                // # Solving for d
                //  (origin + d * direction) x edge = (start + e * edge) x edge
                //  d = (start − origin) × edge / (direction × edge)
                //
                //      (start.x - origin.x) * edge.y - (start.y - origin.y) * edge.x
                //  d = --------------------------------------------------------------
                //               direction.x * edge.y - direction.y * edge.x
                //
                //
                // # In case ray intersects vertical cell grid edge
                // start = (x, 0)
                // edge = (0, 1)
                //
                //      start.x - origin.x
                //  d = -------------------
                //         direction.x
                //
                // # In case ray intersects horizontal cell grid edge
                // start = (0, y)
                // edge = (1, 0)
                //
                //      start.y - origin.y
                //  d = -------------------
                //         direction.y
                //
                traverseRay: function(origin, direction, callback) {
                    var dirX = direction.x, dirY = direction.y;
                    // copy input data
                    // TODO maybe allow HashMap.key search with point only
                    origin = {
                        _x: origin._x,
                        _y: origin._y,
                        _w: 0,
                        _h: 0
                    };
                    var keyBounds = this._keyBoundaries();
                    var keys = HashMap.key(origin, keyHolder);
                    // calculate col & row cell indices
                    var currentCol = keys.x1, currentRow = keys.y1;
                    var minCol = keyBounds.minX, minRow = keyBounds.minY, maxCol = keyBounds.maxX, maxRow = keyBounds.maxY;
                    // direction to traverse cells
                    var stepCol = dirX > 0 ? 1 : dirX < 0 ? -1 : 0, stepRow = dirY > 0 ? 1 : dirY < 0 ? -1 : 0;
                    // first, next cell edge in absolute coordinates
                    var firstCellEdgeX = dirX >= 0 ? (currentCol + 1) * cellsize : currentCol * cellsize, firstCellEdgeY = dirY >= 0 ? (currentRow + 1) * cellsize : currentRow * cellsize;
                    // distance from origin to previous cell edge
                    var previousDistance = -Infinity;
                    // distances to next horizontal and vertical cell edge
                    var deltaDistanceX = 0, deltaDistanceY = 0, nextDistanceX = Infinity, nextDistanceY = Infinity; // distance we can advance(increase magnitude) ray until we advance to next vertical cell
                    var norm;
                    if (dirX !== 0) {
                        norm = 1.0 / dirX;
                        nextDistanceX = (firstCellEdgeX - origin._x) * norm;
                        deltaDistanceX = cellsize * stepCol * norm;
                    }
                    if (dirY !== 0) {
                        norm = 1.0 / dirY;
                        nextDistanceY = (firstCellEdgeY - origin._y) * norm;
                        deltaDistanceY = cellsize * stepRow * norm;
                    }
                    // advance starting cell to be inside of map bounds
                    while(stepCol === 1 && currentCol < minCol && minCol !== Infinity || stepCol === -1 && currentCol > maxCol && maxCol !== -Infinity || stepRow === 1 && currentRow < minRow && minRow !== Infinity || stepRow === -1 && currentRow > maxRow && maxRow !== -Infinity)// advance to closest cell
                    if (nextDistanceX < nextDistanceY) {
                        previousDistance = nextDistanceX;
                        currentCol += stepCol;
                        nextDistanceX += deltaDistanceX;
                    } else {
                        previousDistance = nextDistanceY;
                        currentRow += stepRow;
                        nextDistanceY += deltaDistanceY;
                    }
                    var cell;
                    // traverse over cells
                    // TODO: maybe change condition to `while (currentCol !== endX) || (currentRow !== endY)`
                    while(minCol <= currentCol && currentCol <= maxCol && minRow <= currentRow && currentRow <= maxRow){
                        // process cell
                        if (cell = this.map[currentCol << 16 ^ currentRow]) // check each object inside this cell
                        for(var k = 0; k < cell.length; k++){
                            // if supplied callback returns true, abort traversal
                            if (callback(cell[k], previousDistance)) return;
                        }
                        // advance to closest cell
                        if (nextDistanceX < nextDistanceY) {
                            previousDistance = nextDistanceX;
                            currentCol += stepCol;
                            nextDistanceX += deltaDistanceX;
                        } else {
                            previousDistance = nextDistanceY;
                            currentRow += stepRow;
                            nextDistanceY += deltaDistanceY;
                        }
                    }
                }
            };
            function Entry(keys, obj, map) {
                this.keys = keys;
                this.map = map;
                this.obj = obj;
            }
            Entry.prototype = {
                update: function(rect) {
                    //check if buckets change
                    if (HashMap.hash(HashMap.key(rect, keyHolder)) !== HashMap.hash(this.keys)) this.map.refresh(this);
                    else //mark map coordinate boundaries as dirty
                    this.map.coordBoundsDirty = true;
                }
            };
            module.exports = HashMap;
        },
        {}
    ]
}, {}, [
    22
]);


const $4b79ca39d0e487fc$var$Crafty = window.Crafty;
delete window["Crafty"];
$4b79ca39d0e487fc$var$Crafty.fn.forEach = function(iterator) {
    this.each(function(index) {
        iterator(this, index);
    });
};
var $4b79ca39d0e487fc$export$2e2bcd8739ae039 = $4b79ca39d0e487fc$var$Crafty;



const $d53208c4f003cab6$export$157708fdd1496efa = (x)=>(x < 0 ? -180 : 180) - x;
const $d53208c4f003cab6$export$29e4e862bebba87f = (deg)=>deg / 180 * Math.PI;
const $d53208c4f003cab6$var$cache = {};
const $d53208c4f003cab6$export$ea6eb6c1eb68d20f = (angle)=>{
    if ($d53208c4f003cab6$var$cache[angle]) return $d53208c4f003cab6$var$cache[angle];
    const rads = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).math.degToRad(angle);
    const nCos = Math.cos(rads);
    const nSin = Math.sin(rads);
    const normVector = {
        x: nCos,
        y: nSin
    };
    $d53208c4f003cab6$var$cache[angle] = normVector;
    return normVector;
};
const $d53208c4f003cab6$export$fa9f800d0752b887 = (ent, length)=>{
    const vec = $d53208c4f003cab6$export$ea6eb6c1eb68d20f(ent.rotation);
    return [
        vec.x * length,
        vec.y * length
    ];
};
const $d53208c4f003cab6$export$d4dbf6597d59367 = (ent, length)=>{
    const vec = $d53208c4f003cab6$export$ea6eb6c1eb68d20f(ent.rotation + 90);
    return [
        vec.x * length,
        vec.y * length
    ];
};


const $5fcfaea6d3682c11$var$Component = "Flipable";
const $5fcfaea6d3682c11$var$mirrorParticles = (entity)=>{
    if (!entity.emitter) return;
    const angle = entity.angle || 0;
    entity.emitter.xFlipped = !entity.emitter.xFlipped;
    entity.angle = (0, $d53208c4f003cab6$export$157708fdd1496efa)(angle);
    entity.trigger("Change", {
        angle: entity.angle
    });
};
const $5fcfaea6d3682c11$var$flipChildren = (entity)=>{
    Array.from(entity._children).forEach((child)=>{
        if (typeof child.attr === "function") child.attr({
            x: entity.x + (entity.w - child.w) - (child.x - entity.x)
        });
        if (child._dx !== undefined) child._dx = -child._dx;
        if (typeof child.flip === "function") {
            if (child._flipX) child.unflip("X");
            else child.flip("X");
        }
        $5fcfaea6d3682c11$var$mirrorParticles(child);
        if (child._children) $5fcfaea6d3682c11$var$flipChildren(child);
    });
};
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($5fcfaea6d3682c11$var$Component, {
    flipX () {
        if (this.xFlipped) return;
        this.xFlipped = true;
        const rot = this._rotation;
        this.rotation = 0;
        try {
            if (typeof this.flip === "function") {
                if (this._flipX) this.unflip("X");
                else this.flip("X");
            }
            $5fcfaea6d3682c11$var$flipChildren(this);
        } catch (e) {
            console.log(e);
        }
        this._mirrorCollision();
        this._mirrorRotationPoints();
        this._mirrorStretchPoints();
        this.rotation = -rot;
        return this;
    },
    unflipX () {
        if (!this.xFlipped) return;
        this.xFlipped = false;
        const rot = this._rotation;
        this.rotation = 0;
        try {
            if (typeof this.unflip === "function") {
                if (this._flipX) this.unflip("X");
                else this.flip("X");
            }
            $5fcfaea6d3682c11$var$flipChildren(this);
        } catch (e) {
            console.log(e);
        }
        this._mirrorCollision();
        this._mirrorRotationPoints();
        this._mirrorStretchPoints();
        this.rotation = -rot;
        return this;
    },
    _mirrorCollision () {
        if (!this.map || !this.map.points) return;
        for(let i = 0; i < this.map.points.length; i++){
            const p = this.map.points[i];
            if (i % 2 === 0) {
                const dx = p - this.x;
                this.map.points[i] = this.x + (this.w - dx);
            }
        }
    },
    _mirrorStretchPoints () {
        const updateChildren = (entity)=>{
            Array.from(entity._children).forEach((child)=>{
                if (child.stretch !== undefined && child.stretch[1] === child.stretch[3]) {
                    child.stretch[1] = 1 - child.stretch[1];
                    child.stretch[3] = 1 - child.stretch[3];
                    if (child._children) updateChildren(child);
                }
            });
        };
        if (this.stretch !== undefined && this.stretch[1] === this.stretch[3]) {
            this.stretch[1] = 1 - this.stretch[1];
            this.stretch[3] = 1 - this.stretch[3];
        }
        updateChildren(this);
    },
    _mirrorRotationPoints () {
        const updateChildren = (entity)=>{
            Array.from(entity._children).forEach((child)=>{
                if (typeof child.attr === "function") {
                    if (child.origin !== null) child._origin.x = child.w - child._origin.x;
                    if (child._children) updateChildren(child);
                }
            });
        };
        this._origin.x = this.w - this._origin.x;
        updateChildren(this);
    }
});
var $5fcfaea6d3682c11$export$2e2bcd8739ae039 = $5fcfaea6d3682c11$var$Component;



var $38ff99188d059d52$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $38ff99188d059d52$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$38ff99188d059d52$exports = $38ff99188d059d52$var$isObject;



const $11b8e266696d15ba$var$Component = "ColorEffects";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($11b8e266696d15ba$var$Component, {
    init () {
        this.attr({
            overrideColor: {
                _red: 0,
                _green: 0,
                _blue: 0
            },
            overrideColorMode: "none",
            overrideColorStrength: 0
        });
    },
    colorDesaturation (color) {
        if (color === null) return this;
        this.attr({
            desaturationColor: {
                _red: color._red / 255,
                _green: color._green / 255,
                _blue: color._blue / 255
            }
        });
        this.trigger("Invalidate");
        return this;
    },
    // mode: 'all', 'partial'
    colorOverride (color, mode = "all", strength = 1.0) {
        if (color == null) return this;
        let c = {};
        if ((0, (/*@__PURE__*/$parcel$interopDefault($38ff99188d059d52$exports)))(color)) c = color;
        else (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).assignColor(color, c);
        this.attr({
            overrideColor: {
                _red: c._red / 255,
                _green: c._green / 255,
                _blue: c._blue / 255
            },
            overrideColorMode: mode,
            overrideColorStrength: strength
        });
        this.trigger("Invalidate");
        return this;
    },
    clearColorOverride () {
        this.attr({
            overrideColorMode: "none"
        });
        this.trigger("Invalidate");
        return this;
    },
    saturationGradient (start, end) {
        this.attr({
            topDesaturation: start,
            bottomDesaturation: end
        });
        return this;
    }
});
var $11b8e266696d15ba$export$2e2bcd8739ae039 = $11b8e266696d15ba$var$Component;


(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c("Hideable", {
    _hidden: false,
    properties: {
        hidden: {
            set (v) {
                this._updateHidden(v);
            },
            get () {
                return this._hidden;
            },
            configurable: true,
            enumerable: true
        },
        _hidden: {
            enumerable: false
        }
    },
    init () {
        this.requires((0, $11b8e266696d15ba$export$2e2bcd8739ae039));
    },
    sendToBackground (scale, z) {
        this._originalZ = this.z;
        this.attr({
            scale: scale,
            z: z
        });
        Array.from(this._children).filter((child)=>child.attr).forEach((child)=>{
            const zOff = child.z - this._originalZ;
            child.attr({
                z: z + zOff
            });
        });
        this.hidden = true;
        return this;
    },
    _updateHidden (newHidden) {
        if (this._hidden === newHidden) return;
        this._hidden = newHidden;
        if (newHidden) this.trigger("Hiding", this);
        else this.trigger("Revealing", this);
    },
    hide (hideMarker, options) {
        this.hideMarker = hideMarker;
        if (options.below && this.has("Sprite") && this.rotation === 0) {
            this.hideAt = options.below;
            Array.from(this._children).filter((child)=>child.attr).forEach((child)=>child.attr({
                    hideAt: options.below
                }));
        } else {
            this.attr({
                alpha: 0.0
            });
            Array.from(this._children).filter((child)=>child.attr).forEach((child)=>child.attr({
                    alpha: 0.0
                }));
        }
        this.hidden = true;
        return this;
    },
    hideBelow (yValue) {
        this.hideAt = yValue;
        Array.from(this._children).filter((child)=>child.attr).forEach((child)=>child.attr({
                hideAt: yValue
            }));
    },
    reveal () {
        if (this.hideMarker != null) this.hideMarker.destroy();
        const scale = 1.0;
        Array.from(this._children).filter((child)=>child.attr).forEach((child)=>{
            const zOff = child.z - this.z;
            child.attr({
                z: this._originalZ + zOff
            });
        });
        this.attr({
            scale: scale,
            alpha: 1.0,
            z: this._originalZ,
            hideAt: null
        });
        Array.from(this._children).filter((child)=>child.attr).forEach((child)=>child.attr({
                alpha: 1.0,
                hideAt: null
            }));
        this.hidden = false;
        return this;
    },
    remove () {
        if (this.hideMarker) {
            if (this.hideMarker.hasPool) this.hideMarker.recycle();
            else this.hideMarker.destroy();
        }
    }
});



const $c5a6dfafafffbebd$var$Scalable = "Scalable";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($c5a6dfafafffbebd$var$Scalable, {
    properties: {
        scaleX: {
            set (v) {
                if (v === this._scaleX) return;
                this._updateScaleX(v);
            },
            get () {
                return this._scaleX;
            },
            configurable: true,
            enumerable: true
        },
        _scaleX: {
            value: 1.0,
            writable: true,
            enumerable: false,
            configurable: false
        },
        scaleY: {
            set (v) {
                if (v === this._scaleY) return;
                this._updateScaleY(v);
            },
            get () {
                return this._scaleY;
            },
            configurable: true,
            enumerable: true
        },
        _scaleY: {
            value: 1.0,
            writable: true,
            enumerable: false,
            configurable: false
        },
        scale: {
            set (v) {
                if (v === this._scale) return;
                this._updateScale(v);
            },
            get () {
                return this._scale;
            },
            configurable: true,
            enumerable: true
        },
        _scale: {
            value: 1.0,
            writable: true,
            enumerable: false,
            configurable: false
        }
    },
    _updateScaleX (newScale) {
        const oldScale = this._scaleX;
        this._scaleX = newScale;
        const oldW = this.w;
        this.w = this.w / oldScale * newScale;
        this.x = this.x + (oldW - this.w) / 2;
        this._children.filter((child)=>child.attr).forEach((child)=>{
            const relX = child.x - this.x;
            child.attr({
                x: this.x + relX / oldScale * newScale,
                w: (child.w + oldW - this.w) / oldScale * newScale
            });
        });
        // Scale collision shape
        if (this.map && this.map.points) this.map.points = this.map.points.map((point, i)=>{
            if (i % 2 === 1) return this.y;
            const origin = i % 2 === 0 ? this.x : this.y;
            return origin + (point - origin) / oldScale * newScale;
        });
    },
    _updateScaleY (newScale) {
        const oldScale = this._scaleY;
        this._scaleY = newScale;
        const oldH = this.h;
        this.h = this.h / oldScale * newScale;
        this.y = this.y + (oldH - this.h) / 2;
        this._children.filter((child)=>child.attr).forEach((child)=>{
            const relY = child.y - this.y;
            child.attr({
                y: this.y + relY / oldScale * newScale,
                h: (child.h + oldH - this.h) / oldScale * newScale
            });
        });
        // Scale collision shape
        if (this.map && this.map.points) this.map.points = this.map.points.map((point, i)=>{
            if (i % 2 === 0) return this.y;
            const origin = i % 2 === 0 ? this.x : this.y;
            return origin + (point - origin) / oldScale * newScale;
        });
    },
    _updateScale (newScale) {
        const oldScale = this._scale;
        this._scale = newScale;
        const oldW = this.w;
        const oldH = this.h;
        this.w = this.w / oldScale * newScale;
        this.x = this.x + (oldW - this.w) / 2;
        this.h = this.h / oldScale * newScale;
        this.y = this.y + (oldH - this.h) / 2;
        this._children.filter((child)=>child.attr).forEach((child)=>{
            const relX = child.x - this.x;
            const relY = child.y - this.y;
            child.attr({
                x: this.x + relX / oldScale * newScale,
                y: this.y + relY / oldScale * newScale,
                w: (child.w + oldW - this.w) / oldScale * newScale,
                h: (child.h + oldH - this.h) / oldScale * newScale
            });
        });
        // Scale collision shape
        if (this.map && this.map.points) this.map.points = this.map.points.map((point, i)=>{
            const origin = i % 2 === 0 ? this.x : this.y;
            return origin + (point - origin) / oldScale * newScale;
        });
    }
});
var $c5a6dfafafffbebd$export$2e2bcd8739ae039 = $c5a6dfafafffbebd$var$Scalable;




const $21d6fb1fc143defa$export$c36ab4b6f6b3ac37 = "easeInOutQuad";
const $21d6fb1fc143defa$export$f590991ffe484603 = "easeInQuad";
const $21d6fb1fc143defa$export$7c0c5615d5b4a96b = "easeOutQuad";
const $21d6fb1fc143defa$export$8244104593af74a6 = "linear";
const $21d6fb1fc143defa$export$742424a10dd87ed1 = {
    // no easing, no acceleration
    linear: (t)=>t,
    // smooth step; starts and ends with v=0
    smoothStep: (t)=>(3 - 2 * t) * t * t,
    // smootherstep; starts and ends with v, a=0
    smootherStep: (t)=>(6 * t * t - 15 * t + 10) * t * t * t,
    // quadratic curve; starts with v=0
    easeInQuad: (t)=>t * t,
    // quadratic curve; ends with v=0
    easeOutQuad: (t)=>t * (2 - t),
    // quadratic curve; starts and ends with v=0
    easeInOutQuad: (t)=>t < 0.5 ? 2 * t * t : (4 - 2 * t) * t - 1
};





const $b27380253b0dbcca$var$Animator = "Animator";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($b27380253b0dbcca$var$Animator, {
    events: {
        Freeze () {
            this.animations = [];
            this.animating = false;
            this.unbind("GameLoop", this._animateTick);
        }
    },
    init () {
        this.animations = [];
    },
    remove () {
        this.unbind("GameLoop", this._animateTick);
    },
    animate (transitionFn, duration, easing = "linear") {
        if (!transitionFn) return Promise.resolve();
        if (duration === 0) {
            transitionFn(1);
            return Promise.resolve();
        }
        return new Promise((resolve)=>{
            const animation = {
                transition: transitionFn,
                timer: new (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).easing(duration, easing),
                resolver: resolve
            };
            this.animations.push(animation);
            if (!this.animating) {
                this.animating = true;
                this.uniqueBind("GameLoop", this._animateTick);
            }
        });
    },
    _animateTick ({ dt: dt }) {
        const toRemove = [];
        this.animations.forEach((animation, i)=>{
            const { timer: timer, transition: transition, resolver: resolver } = animation;
            timer.tick(dt);
            transition(timer.value());
            if (timer.complete) {
                transition(1);
                toRemove.push(i);
                resolver();
            }
        });
        toRemove.reverse().forEach((i)=>this.animations.splice(i, 1));
        if (this.animations.length === 0) {
            this.animating = false;
            this.unbind("GameLoop", this._animateTick);
        }
    }
});
var $b27380253b0dbcca$export$2e2bcd8739ae039 = $b27380253b0dbcca$var$Animator;


const $efc499a22346529b$export$d4775187212d9f53 = (entity, next, current)=>{
    const c = current ? current : entity;
    const transitions = Object.entries(next).reduce((acc, [key, newValue])=>Object.prototype.hasOwnProperty.call(c, key) && c[key] !== newValue ? acc.concat({
            key: key,
            current: c[key],
            newValue: newValue
        }) : acc, []);
    if (transitions.length == 0) return false;
    return (t)=>{
        transitions.forEach(({ key: key, current: current, newValue: newValue })=>{
            if (key === "overrideColor") entity[key] = {
                _red: (1 - t) * current._red + t * newValue._red,
                _green: (1 - t) * current._green + t * newValue._green,
                _blue: (1 - t) * current._blue + t * newValue._blue
            };
            else entity[key] = (1 - t) * current + t * newValue;
        });
    };
};
const $efc499a22346529b$export$213c308ab5de2230 = "TweenPromise";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($efc499a22346529b$export$213c308ab5de2230, {
    required: (0, $b27380253b0dbcca$export$2e2bcd8739ae039),
    async tweenPromise (props, duration, easing) {
        const tweenFunc = $efc499a22346529b$export$d4775187212d9f53(this, props);
        return this.animate(tweenFunc, duration, easing);
    }
});
var $efc499a22346529b$export$2e2bcd8739ae039 = $efc499a22346529b$export$213c308ab5de2230;


const $98fbc581d16d5b09$var$DEFAULT_AIM_SPEED = 100;
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c("Aimable", {
    init () {
        this.aim = this.aim.bind(this);
        this.resetAim = this.resetAim.bind(this);
    },
    async aim ({ target: target, speed: speed = $98fbc581d16d5b09$var$DEFAULT_AIM_SPEED, easing: easing = (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37) }) {
        if (!target) return;
        const tweens = [];
        const aimingParts = this.aimParts || [];
        this.forEachPart((item, index)=>{
            const options = this.spriteOptions(index);
            if (aimingParts.includes(options.key)) {
                const parent = item._parent;
                const aimCoord = [
                    parent.x + options.ro[0],
                    parent.y + options.ro[1]
                ];
                const targetCoord = [
                    target.x + target.w / 2,
                    target.y + target.h / 2
                ];
                const dx = aimCoord[0] - targetCoord[0];
                const dy = aimCoord[1] - targetCoord[1];
                const angle = Math.atan2(dy, dx) * 180 / Math.PI;
                item.addComponent((0, $efc499a22346529b$export$2e2bcd8739ae039));
                const angleDelta = Math.abs(item.rotation - angle);
                const duration = 1000 / speed * angleDelta;
                tweens.push(item.tweenPromise({
                    rotation: angle
                }, duration, easing));
            }
        });
        await Promise.all(tweens);
    },
    async resetAim ({ speed: speed = $98fbc581d16d5b09$var$DEFAULT_AIM_SPEED, easing: easing = (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37) } = {}) {
        const tweens = [];
        const aimingParts = this.aimParts || [];
        this.forEachPart((item, index)=>{
            const options = this.spriteOptions(index);
            if (aimingParts.includes(options.key)) {
                item.addComponent((0, $efc499a22346529b$export$2e2bcd8739ae039));
                const angleDelta = Math.abs(item.rotation);
                const duration = 1000 / speed * angleDelta;
                tweens.push(item.tweenPromise({
                    rotation: 0
                }, duration, easing));
            }
        });
        await Promise.all(tweens);
    }
});



(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c("BezierMove", {
    events: {
        GameLoop: "_moveBezierTick",
        Freeze: "remove"
    },
    remove () {
        if (this.bezierTimer.complete) return;
        this.trigger("BezierMoveEnd");
    },
    bezierMove (path, settings) {
        const speed = settings.speed || this.defaultSpeed;
        const duration = path.length / speed * 1000;
        this.bezierTimer = new (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).easing(duration, settings.easing || "linear");
        this.bezierPath = path;
    },
    _moveBezierTick (fd) {
        if (this.bezierTimer.complete) return;
        this.bezierTimer.tick(fd.dt);
        this._doMove(this.bezierTimer.value(), fd);
        if (this.bezierTimer.complete) this.trigger("BezierMoveEnd");
    },
    _doMove (pt, fd) {
        const point = this.bezierPath.get(pt);
        const dx = point.x - this.x;
        const dy = point.y - this.y;
        if (this.updateMovementVisuals) {
            const rotation = this.bezierPath.rotationAt(pt);
            this.updateMovementVisuals(rotation, dx, dy, fd.dt);
        }
        this.shift(dx, dy);
    }
});



const $1b6c3ee66e2e3a50$export$eb192d84eb65661d = (text, { color: color = "#FFFFFF", sup: sup = null } = {})=>{
    const createTextEntity = (text, color, size, y)=>(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(" 2D, Text, Tween, UILayerDOM, Delay").attr({
            w: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width,
            z: 1,
            alpha: 0,
            baseText: text
        }).textAlign("center").text(text).attr({
            y: y
        }).textColor(color).textFont({
            size: size,
            weight: "bold",
            family: "Press Start 2P"
        });
    const entity = createTextEntity(text, color, "30px", 240);
    let items = [
        entity
    ];
    if (sup) {
        const supScript = createTextEntity(sup, color, "16px", 200);
        items = items.concat(supScript);
    }
    return {
        fadeIn: (duration)=>new Promise((resolve)=>{
                items[0].one("TweenEnd", resolve);
                items.forEach((e)=>e.tween({
                        alpha: 1
                    }, duration));
            }),
        fadeOut: (duration)=>new Promise((resolve)=>{
                items[0].one("TweenEnd", resolve);
                items.forEach((e)=>e.tween({
                        alpha: 0
                    }, duration));
            }),
        show: ()=>{
            items.forEach((e)=>e.attr({
                    alpha: 1
                }));
        },
        hide: ()=>{
            items.forEach((e)=>e.attr({
                    alpha: 0
                }));
        },
        zoomOut: (duration)=>new Promise((resolve)=>{
                items.forEach((e)=>e.attr({
                        alpha: 1,
                        scale: 1,
                        avoidCss3dTransforms: true
                    }).text(()=>{
                        e.css({
                            transform: `scale(${e.scale})`,
                            transformOrigin: "center center"
                        });
                        return e.baseText;
                    }).dynamicTextGeneration(true));
                items[0].one("TweenEnd", ()=>{
                    items.forEach((e)=>{
                        e.attr({
                            alpha: 0,
                            scale: 1,
                            avoidCss3dTransforms: false
                        }).text(e.baseText).dynamicTextGeneration(false);
                    });
                    resolve();
                });
                items.forEach((e)=>e.tween({
                        alpha: 0,
                        scale: 3
                    }, duration));
            }),
        remove: ()=>{
            items.forEach((e)=>e.destroy());
        },
        blink: (delay, repeats = 4)=>new Promise((resolve)=>{
                const f = ()=>items.forEach((e)=>e.attr({
                            alpha: (e.alpha + 1) % 2
                        }));
                items[0].delay(f, delay, repeats * 2 - 1, resolve);
            })
    };
};


var $7c4fed6a490671be$exports = {};
$7c4fed6a490671be$exports = "#define GLSLIFY 1\nattribute vec2 aPosition;\nattribute vec3 aOrientation;\nattribute vec2 aLayer;\nattribute vec4 aColor;\nattribute vec4 aDesaturation;\nattribute vec2 aGradient;\n\nvarying lowp vec4 vColor;\nvarying lowp vec4 vDesaturation;\nvarying lowp vec2 vGradient;\nvarying lowp vec2 vLayer;\nuniform  vec4 uViewport;\n\nmat4 viewportScale = mat4(2.0 / uViewport.z, 0, 0, 0,    0, -2.0 / uViewport.w, 0,0,    0, 0,1,0,    -1,+1,0,1);\nvec4 viewportTranslation = vec4(uViewport.xy, 0, 0);\n\nvoid main() {\n  vec2 pos = aPosition;\n  vec2 entityOrigin = aOrientation.xy;\n  mat2 entityRotationMatrix = mat2(cos(aOrientation.z), sin(aOrientation.z), -sin(aOrientation.z), cos(aOrientation.z));\n\n  pos = entityRotationMatrix * (pos - entityOrigin) + entityOrigin;\n  gl_Position = viewportScale * (viewportTranslation + vec4(pos, 1.0/(1.0+exp(aLayer.x) ), 1) );\n\n  vColor = aColor;\n  vDesaturation = aDesaturation;\n  vGradient = aGradient;\n  vLayer = aLayer;\n}\n\n";


var $312e0d529ebb2ac2$exports = {};
$312e0d529ebb2ac2$exports = "precision mediump float;\n#define GLSLIFY 1\nvarying lowp vec4 vColor;\nvarying lowp vec2 vGradient;\nvarying lowp vec4 vDesaturation;\nvarying lowp vec2 vLayer;\nvoid main(void) {\n\n  //gl_FragColor = vec4(vColor.rgb*vColor.a*vLayer.y, vColor.a*vLayer.y);\n\n  mediump float mixFactor = vGradient.x;\n\n  mediump float lightness = (0.2126*vColor.r + 0.7152*vColor.g + 0.0722*vColor.b);\n  mediump float lightnessBase = (0.2126*vDesaturation.r + 0.7152*vDesaturation.g + 0.0722*vDesaturation.b);\n  mediump vec4 baseColor = vec4(vDesaturation.rgb, vColor.a) * (1.0 + (lightness - lightnessBase));\n  mediump vec4 mixColor = vec4(\n      (baseColor.rgba * mixFactor) + (vColor.rgba * (1.0 - mixFactor))\n      );\n\n  gl_FragColor = vec4(\n      mixColor.rgb * vColor.a * vLayer.y,\n      vColor.a * vLayer.y\n      );\n}\n\n";



(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).defaultShader("Color", new (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).WebGLShader((0, (/*@__PURE__*/$parcel$interopDefault($7c4fed6a490671be$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($312e0d529ebb2ac2$exports))), [
    {
        name: "aPosition",
        width: 2
    },
    {
        name: "aOrientation",
        width: 3
    },
    {
        name: "aLayer",
        width: 2
    },
    {
        name: "aColor",
        width: 4
    },
    {
        name: "aDesaturation",
        width: 4
    },
    {
        name: "aGradient",
        width: 2
    }
], function(e, ent) {
    const color = ent.desaturationColor != null ? ent.desaturationColor : {
        _red: 0,
        _green: 0,
        _blue: 0
    };
    e.program.writeVector("aColor", ent._red / 255, ent._green / 255, ent._blue / 255, ent._strength);
    e.program.writeVector("aDesaturation", color._red / 255, color._green / 255, color._blue / 255, 1.0);
    const s = ent.scale != null ? ent.scale : 1;
    const tds = ent.topDesaturation != null ? ent.topDesaturation : 0;
    const bds = ent.bottomDesaturation != null ? ent.bottomDesaturation : 0;
    return e.program.writeVector("aGradient", tds + (1 - s) * 1.15, bds + (1 - s) * 1.15);
}));





let $8c0d474e6a2e6236$var$currentBackground = {
    _red: 0,
    _green: 0,
    _blue: 0,
    _strength: 1
};
const $8c0d474e6a2e6236$var$Component = "Horizon";
const $8c0d474e6a2e6236$export$4420ac7a34197e42 = ()=>$8c0d474e6a2e6236$var$currentBackground;
const $8c0d474e6a2e6236$export$398bd3ed8b98188b = (color)=>{
    let c = {};
    if ((0, (/*@__PURE__*/$parcel$interopDefault($38ff99188d059d52$exports)))(color)) c = color;
    else (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).assignColor(color, c);
    if ($8c0d474e6a2e6236$var$currentBackground._red === c._red && $8c0d474e6a2e6236$var$currentBackground._green === c._green && $8c0d474e6a2e6236$var$currentBackground._blue === c._blue) return;
    $8c0d474e6a2e6236$var$currentBackground = c;
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)($8c0d474e6a2e6236$var$Component).forEach((entity)=>entity.colorDesaturation(c));
};
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($8c0d474e6a2e6236$var$Component, {
    required: [
        (0, $11b8e266696d15ba$export$2e2bcd8739ae039)
    ].join(","),
    init () {
        this.colorDesaturation($8c0d474e6a2e6236$var$currentBackground);
    }
});
var $8c0d474e6a2e6236$export$2e2bcd8739ae039 = $8c0d474e6a2e6236$var$Component;




(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c("HideBelow", {
    properties: {
        hideBelow: {
            set (v) {
                this._hideBelow = v;
                this.trigger("Invalidate");
            },
            get () {
                return this._hideBelow;
            },
            configurable: true,
            enumerable: true
        },
        _hideBelow: {
            writable: true,
            enumerable: false,
            configurable: false
        },
        hideAbove: {
            set (v) {
                this._hideAbove = v;
                this.trigger("Invalidate");
            },
            get () {
                return this._hideAbove;
            },
            configurable: true,
            enumerable: true
        },
        _hideAbove: {
            writable: true,
            enumerable: false,
            configurable: false
        }
    }
});





var $61180287eca951ab$exports = {};
$61180287eca951ab$exports = "#define GLSLIFY 1\nattribute vec2 aPosition;\nattribute vec3 aOrientation;\nattribute vec2 aLayer;\nattribute vec4 aColor;\n\nvarying lowp vec4 vColor;\nvarying lowp vec2 vLayer;\nuniform vec4 uViewport;\n\nmat4 viewportScale = mat4(2.0 / uViewport.z, 0, 0, 0,    0, -2.0 / uViewport.w, 0,0,    0, 0,1,0,    -1,+1,0,1);\nvec4 viewportTranslation = vec4(uViewport.xy, 0, 0);\n\nvoid main() {\n  vec2 pos = aPosition;\n  vec2 entityOrigin = aOrientation.xy;\n  mat2 entityRotationMatrix = mat2(cos(aOrientation.z), sin(aOrientation.z), -sin(aOrientation.z), cos(aOrientation.z));\n\n  pos = entityRotationMatrix * (pos - entityOrigin) + entityOrigin;\n  gl_Position = viewportScale * (viewportTranslation + vec4(pos, 1.0/(1.0+exp(aLayer.x) ), 1) );\n\n  vColor = aColor;\n  vLayer = aLayer;\n}\n\n";


var $89ebc0d5b74744b4$exports = {};
$89ebc0d5b74744b4$exports = "precision mediump float;\n#define GLSLIFY 1\nvarying lowp vec4 vColor;\nvarying lowp vec2 vLayer;\nvoid main(void) {\n  gl_FragColor = vec4(vColor.rgb*vColor.a*vLayer.y, vColor.a*vLayer.y);\n}\n";



(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).extend({
    defaultGradientShader (shader) {
        if (!shader) {
            if (this._defaultGradientShader === undefined) this._defaultGradientShader = new (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).WebGLShader((0, (/*@__PURE__*/$parcel$interopDefault($61180287eca951ab$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($89ebc0d5b74744b4$exports))), [
                {
                    name: "aPosition",
                    width: 2
                },
                {
                    name: "aOrientation",
                    width: 3
                },
                {
                    name: "aLayer",
                    width: 2
                },
                {
                    name: "aColor",
                    width: 4
                }
            ], function(e, entity) {
                e.program.writeVector("aColor", entity._topColor._red / 255, entity._topColor._green / 255, entity._topColor._blue / 255, entity._topColor._strength, entity._bottomColor._red / 255, entity._bottomColor._green / 255, entity._bottomColor._blue / 255, entity._bottomColor._strength);
            });
            return this._defaultGradientShader;
        }
        return this._defaultGradientShader = shader;
    }
});
const $68215c666a453acc$var$Gradient = "Gradient";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($68215c666a453acc$var$Gradient, {
    events: {
        LayerAttached: "_setupGradient"
    },
    init () {
        // Declaring the vars here instead as class attributes
        // make them unique for each instance
        this._topColor = {
            _red: 0,
            _green: 0,
            _blue: 0,
            _strength: 1.0
        };
        this._bottomColor = {
            _red: 0,
            _green: 0,
            _blue: 0,
            _strength: 1.0
        };
        this.ready = true;
        this.bind("Draw", this._drawGradient);
        if (this._drawLayer) this._setupGradient(this._drawLayer);
        this.trigger("Invalidate");
    },
    remove () {
        this.unbind("Draw", this._drawGradient);
        if (this.has("DOM")) this._element.style.backgroundColor = "transparent";
        this.trigger("Invalidate");
    },
    _setupGradient (layer) {
        if (layer.type === "WebGL") this._establishShader("Gradient", (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).defaultGradientShader());
    },
    _drawGradient (e) {
        if (e.type === "webgl") e.program.draw(e, this);
    },
    topColor (color, strength) {
        if (color) {
            this._setColor(this._topColor, color, strength);
            return this;
        }
        return this._topColor;
    },
    bottomColor (color, strength) {
        if (color) {
            this._setColor(this._bottomColor, color, strength);
            return this;
        }
        return this._bottomColor;
    },
    _setColor (varColor, color, strength) {
        if (typeof color === "string") (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).assignColor(color, varColor);
        else {
            varColor._red = color[0];
            varColor._green = color[1];
            varColor._blue = color[2];
        }
        if (strength !== undefined) varColor._strength = strength;
        this.trigger("Invalidate");
    }
});
var $68215c666a453acc$export$2e2bcd8739ae039 = $68215c666a453acc$var$Gradient;



const $60cfab0448e82384$export$2c9e8a9632a706b2 = (v, from, to)=>({
        _red: Math.round(from._red * (1 - v) + to._red * v),
        _green: Math.round(from._green * (1 - v) + to._green * v),
        _blue: Math.round(from._blue * (1 - v) + to._blue * v),
        _strength: from._strength * (1 - v) + to._strength * v
    });
const $60cfab0448e82384$export$837e48ddf1fe387b = ([string, alpha])=>({
        _red: parseInt(string.slice(1, 3), 16),
        _green: parseInt(string.slice(3, 5), 16),
        _blue: parseInt(string.slice(5, 7), 16),
        _strength: alpha
    });
const $60cfab0448e82384$var$toColor = (a)=>a && a.length === 2 && typeof a[0] === "string" ? $60cfab0448e82384$export$837e48ddf1fe387b(a) : a;
const $60cfab0448e82384$export$c8c553e0f1af1c56 = (entity, nextTopColor, nextBottomColor, currentTopColor, currentBottomColor)=>{
    const colorFade = {
        nextTopColor: $60cfab0448e82384$var$toColor(nextTopColor),
        nextBottomColor: $60cfab0448e82384$var$toColor(nextBottomColor),
        startTopColor: currentTopColor ? $60cfab0448e82384$var$toColor(currentTopColor) : entity.topColor(),
        startBottomColor: currentBottomColor ? $60cfab0448e82384$var$toColor(currentBottomColor) : entity.bottomColor()
    };
    return (t)=>{
        entity._topColor = $60cfab0448e82384$export$2c9e8a9632a706b2(t, colorFade.startTopColor, colorFade.nextTopColor);
        entity._bottomColor = $60cfab0448e82384$export$2c9e8a9632a706b2(t, colorFade.startBottomColor, colorFade.nextBottomColor);
        entity.trigger("Invalidate");
    };
};
const $60cfab0448e82384$export$e888796b816d63b8 = "ColorFade";
const $60cfab0448e82384$var$getFader = ()=>(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("ScreenFader").get(0) || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(`WebGL, 2D, ScreenFader, ${$60cfab0448e82384$export$e888796b816d63b8}`).attr({
        z: 5000,
        x: 0,
        y: 0,
        w: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width,
        h: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height
    });
const $60cfab0448e82384$export$82e6205b15e6c637 = (color = "#000000")=>{
    const fader = $60cfab0448e82384$var$getFader();
    fader.topColor(color, 1.0);
    fader.bottomColor(color, 1.0);
    return {
        start: async (duration)=>{
            await fader.colorFade([
                color,
                1.0
            ], [
                color,
                0.0
            ], duration / 2);
            await fader.colorFade([
                color,
                0.0
            ], [
                color,
                0.0
            ], duration / 2);
            fader.destroy();
        }
    };
};
const $60cfab0448e82384$export$c091916f1530334c = (color = "#000000")=>{
    const fader = $60cfab0448e82384$var$getFader();
    fader.topColor(color, 0.0);
    fader.bottomColor(color, 0.0);
    return {
        start: async (duration)=>{
            await fader.colorFade([
                color,
                1.0
            ], [
                color,
                0.0
            ], duration / 2);
            await fader.colorFade([
                color,
                1.0
            ], [
                color,
                1.0
            ], duration / 2);
        }
    };
};
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($60cfab0448e82384$export$e888796b816d63b8, {
    required: [
        (0, $b27380253b0dbcca$export$2e2bcd8739ae039),
        (0, $68215c666a453acc$export$2e2bcd8739ae039)
    ].join(","),
    colorFade (topColor, bottomColor, duration, easing) {
        const fadeFunc = $60cfab0448e82384$export$c8c553e0f1af1c56(this, topColor, bottomColor);
        return this.animate(fadeFunc, duration, easing);
    }
});
var $60cfab0448e82384$export$2e2bcd8739ae039 = $60cfab0448e82384$export$e888796b816d63b8;




const $ab6babeceb13821a$var$Delta2D = "Delta2D";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($ab6babeceb13821a$var$Delta2D, {
    required: "2D",
    properties: {
        drx: {
            set: function(value) {
                const drx = value - this._drx;
                const [x, y] = (0, $d53208c4f003cab6$export$fa9f800d0752b887)(this, drx);
                this.shift(x, y);
                this._drx = value;
            },
            // getter for the `drx` property
            get: function() {
                // return the cached dx value
                return this._drx;
            },
            // make the property show up in property enumerations
            enumerable: true,
            // property shouldn't be deletable
            configurable: false
        },
        _drx: {
            // set the initial value to 0
            value: 0,
            // it's a mutable property
            writable: true,
            // hide the property from property enumerations
            enumerable: false,
            // property shouldn't be deletable
            configurable: false
        },
        dry: {
            set: function(value) {
                const dry = value - this._dry;
                const [x, y] = (0, $d53208c4f003cab6$export$d4dbf6597d59367)(this, dry);
                this.shift(x, y);
                this._dry = value;
            },
            // getter for the `dy` property
            get: function() {
                // return the cached dy value
                return this._dry;
            },
            // make the property show up in property enumerations
            enumerable: true,
            // property shouldn't be deletable
            configurable: false
        },
        _dry: {
            // set the initial value to 0
            value: 0,
            // it's a mutable property
            writable: true,
            // hide the property from property enumerations
            enumerable: false,
            // property shouldn't be deletable
            configurable: false
        },
        dx: {
            set: function(value) {
                this.shift(value - this._dx, 0);
                this._dx = value;
            },
            // getter for the `dx` property
            get: function() {
                // return the cached dx value
                return this._dx;
            },
            // make the property show up in property enumerations
            enumerable: true,
            // property shouldn't be deletable
            configurable: false
        },
        _dx: {
            // set the initial value to 0
            value: 0,
            // it's a mutable property
            writable: true,
            // hide the property from property enumerations
            enumerable: false,
            // property shouldn't be deletable
            configurable: false
        },
        dy: {
            set: function(value) {
                this.shift(0, value - this._dy);
                this._dy = value;
            },
            // getter for the `dy` property
            get: function() {
                // return the cached dy value
                return this._dy;
            },
            // make the property show up in property enumerations
            enumerable: true,
            // property shouldn't be deletable
            configurable: false
        },
        _dy: {
            // set the initial value to 0
            value: 0,
            // it's a mutable property
            writable: true,
            // hide the property from property enumerations
            enumerable: false,
            // property shouldn't be deletable
            configurable: false
        }
    }
});
var $ab6babeceb13821a$export$2e2bcd8739ae039 = $ab6babeceb13821a$var$Delta2D;







const $47ac9e977e9352cf$export$c33fc2cad0ee87c0 = "Stretchable";
const $47ac9e977e9352cf$export$99630c140ecf063f = "Stretcher";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($47ac9e977e9352cf$export$c33fc2cad0ee87c0, {
    properties: {
        sw: {
            set (v) {
                if (v === this._w) return;
                this._stretch(v, this._h, "w");
            },
            get () {
                return this._w;
            },
            configurable: true,
            enumerable: true
        },
        sh: {
            set (v) {
                if (v === this._h) return;
                this._stretch(this._w, v, "h");
            },
            get () {
                return this._h;
            },
            configurable: true,
            enumerable: true
        }
    },
    _stretch (_w, _h, axis) {
        this.trigger("Stretch", {
            dw: _w - this._w,
            dh: _h - this._h
        });
        const resizeData = {
            axis: axis,
            amount: axis === "w" ? _w - this._w : _h - this._h
        };
        this._w = _w;
        this._h = _h;
        this._calculateMBR();
        this.trigger("Resize", resizeData);
        this.trigger("Invalidate");
    }
});
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($47ac9e977e9352cf$export$99630c140ecf063f, {
    init () {
        this._handleStretch = this._handleStretch.bind(this);
    },
    _handleStretch (s) {
        const xShift = this.stretch[3] * s.dw;
        const widthShift = this.stretch[1] * s.dw - xShift;
        const yShift = this.stretch[0] * s.dh;
        const heightShift = this.stretch[2] * s.dh - yShift;
        this._w += widthShift;
        this._h += heightShift;
        const [xRotShift, yRotShift] = (0, $d53208c4f003cab6$export$fa9f800d0752b887)(this, xShift);
        this._x += xRotShift;
        this._y += yRotShift;
        this.trigger("Invalidate");
    },
    activateStretch (source) {
        source.uniqueBind("Stretch", this._handleStretch);
    }
});
var $47ac9e977e9352cf$export$2e2bcd8739ae039 = $47ac9e977e9352cf$export$c33fc2cad0ee87c0;


const $3cd0f3499d493eb4$var$startTime = +new Date();
const $3cd0f3499d493eb4$export$c2e8e32465a0cbd6 = ()=>$3cd0f3499d493eb4$var$startTime;




const $13ccfc3fcea30f5e$var$colorCache = {};
const $13ccfc3fcea30f5e$export$6d1b0a04fee90d44 = (str)=>{
    const cache = $13ccfc3fcea30f5e$var$colorCache[str];
    if (cache) return cache;
    const color = {};
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).assignColor(str, color);
    const result = {
        _red: color._red / 255,
        _green: color._green / 255,
        _blue: color._blue / 255
    };
    $13ccfc3fcea30f5e$var$colorCache[str] = result;
    return result;
};



const $5fd20eb0995a8d9f$var$definitionStructure = {
    sprites: [],
    gradients: [],
    attachHooks: [],
    attributes: {},
    frames: {},
    animations: {},
    hitbox: []
};
const $5fd20eb0995a8d9f$var$heightFactor = {
    top: 0,
    center: 0.5,
    bottom: 1
};
const $5fd20eb0995a8d9f$var$widthFactor = {
    left: 0,
    center: 0.5,
    right: 1
};
const $5fd20eb0995a8d9f$var$TWEEN_WHITELIST = [
    "x",
    "y",
    "z",
    "w",
    "h",
    "rx",
    "ry",
    "rotation",
    "alpha",
    "maxAlpha",
    "overrideColor",
    "overrideColorStrength",
    "horizon",
    "scale",
    "scaleX",
    "scaleY"
];
const $5fd20eb0995a8d9f$var$entityDeltaSettings = (entity)=>(settings)=>Object.entries(settings).filter(([name])=>$5fd20eb0995a8d9f$var$TWEEN_WHITELIST.includes(name)).reduce((result, [key, value])=>{
            switch(key){
                case "x":
                    result["dx"] = entity.xFlipped ? -value : value;
                    break;
                case "y":
                    result["dy"] = value;
                    break;
                case "z":
                    result["z"] = entity.z + value;
                    break;
                case "rx":
                    result["drx"] = entity.xFlipped ? -value : value;
                    break;
                case "ry":
                    result["dry"] = value;
                    break;
                case "w":
                    result["sw"] = value;
                    break;
                case "overrideColor":
                    if (value === null) result["overrideColorStrength"] = 0.0;
                    else {
                        result["overrideColor"] = (0, $13ccfc3fcea30f5e$export$6d1b0a04fee90d44)(value);
                        result["overrideColorStrength"] = 1.0;
                    }
                    break;
                case "horizon":
                    result["topDesaturation"] = value[1];
                    result["bottomDesaturation"] = value[0];
                    break;
                default:
                    result[key] = value;
            }
            return result;
        }, {});
const $5fd20eb0995a8d9f$var$orDefault = (v, def)=>v === undefined ? def : v;
const $5fd20eb0995a8d9f$var$generateDefaultFrame = (entity, definition)=>{
    const result = {};
    (definition.sprites || []).filter(([, settings])=>settings.key).map(([sprite, settings])=>result[settings.key] = {
            z: 0,
            rotation: 0,
            alpha: 1,
            scale: 1,
            topDesaturation: 0,
            bottomDesaturation: 0,
            overrideColorStrength: settings.overrideColor || settings.accentColor ? 1 : 0,
            sprite: sprite,
            ...settings,
            x: 0,
            y: 0
        });
    (definition.gradients || []).filter((settings)=>settings.key).map((settings)=>result[settings.key] = {
            z: 0,
            rotation: 0,
            ...settings,
            x: 0,
            y: 0
        });
    result.attributes = {
        w: definition.attributes.width,
        h: definition.attributes.height,
        rotation: $5fd20eb0995a8d9f$var$orDefault(definition.attributes.rotation, 0),
        scale: $5fd20eb0995a8d9f$var$orDefault(definition.attributes.scale, 1)
    };
    if (entity.xFlipped === true) result.flipX = true;
    return result;
};
const $5fd20eb0995a8d9f$var$getSpriteByKey = (entity, key)=>{
    let index = null;
    entity.appliedDefinition.sprites.forEach((def, idx)=>{
        if (def[1].key === key) index = idx;
    });
    if (index === null) return null;
    return entity.composableParts[index];
};
const $5fd20eb0995a8d9f$var$getHookSettings = (definition, name)=>(definition.attachHooks.find(([hookName])=>hookName === name) || [])[1] || {};
const $5fd20eb0995a8d9f$var$getFrameData = (entity, frameName)=>frameName === "default" ? $5fd20eb0995a8d9f$var$generateDefaultFrame(entity, entity.appliedDefinition) : frameName && entity.appliedDefinition.frames[frameName];
const $5fd20eb0995a8d9f$var$displayFrameFn = (entity, targetFrame, sourceFrame)=>{
    const targetFrameData = $5fd20eb0995a8d9f$var$getFrameData(entity, targetFrame);
    if (!targetFrameData) return ()=>{};
    const sourceFrameData = $5fd20eb0995a8d9f$var$getFrameData(entity, sourceFrame);
    const deltaSettings = $5fd20eb0995a8d9f$var$entityDeltaSettings(entity);
    const fns = Object.entries(targetFrameData).reduce((acc, [keyName, settings])=>{
        if (keyName === "attributes") {
            const fixedSettings = {};
            if (entity.scale !== undefined || settings.scale !== undefined) {
                if (settings.w) fixedSettings.w = settings.w * (settings.scale || entity.scale);
                if (settings.h) fixedSettings.h = settings.h * (settings.scale || entity.scale);
            }
            const tweenSettings = deltaSettings({
                ...settings,
                ...fixedSettings
            });
            if (tweenSettings.sw !== undefined) entity.addComponent((0, $47ac9e977e9352cf$export$c33fc2cad0ee87c0));
            const sourceTweenSettings = sourceFrameData && deltaSettings({
                ...sourceFrameData[keyName]
            });
            return acc.concat((0, $efc499a22346529b$export$d4775187212d9f53)(entity, tweenSettings, sourceTweenSettings));
        }
        if (keyName === "flipX") {
            entity.addComponent((0, $5fcfaea6d3682c11$export$2e2bcd8739ae039));
            const xFlipped = entity.xFlipped;
            return acc.concat(()=>{
                if (xFlipped === entity.xFlipped) entity.xFlipped ? entity.unflipX() : entity.flipX();
            });
        }
        const sprite = entity.composableParts.find((part)=>part.attr("key") === keyName);
        if (sprite) {
            const originalSettings = entity.appliedDefinition.sprites.find(([, startSettings])=>startSettings.key === keyName);
            const defaultSettings = {
                z: 0,
                alpha: 1,
                scaleX: 1,
                scaleY: 1,
                horizon: [
                    0,
                    0
                ],
                ...originalSettings && originalSettings[1],
                x: 0,
                y: 0
            };
            if (defaultSettings.w && entity.scale !== undefined) defaultSettings.w = defaultSettings.w * entity.scale;
            if (defaultSettings.h && entity.scale !== undefined) defaultSettings.h = defaultSettings.h * entity.scale;
            const tweenSettings = deltaSettings({
                ...defaultSettings,
                ...settings,
                ...settings.rotation !== undefined && {
                    rotation: sprite._parent.rotation + settings.rotation
                }
            });
            const sourceTweenSettings = sourceFrameData && deltaSettings({
                ...defaultSettings,
                ...sourceFrameData[keyName]
            });
            if (tweenSettings.overrideColor) {
                sprite.addComponent((0, $11b8e266696d15ba$export$2e2bcd8739ae039));
                sprite["overrideColorMode"] = "all";
            }
            if (tweenSettings.topDesaturation !== 0) sprite.addComponent((0, $8c0d474e6a2e6236$export$2e2bcd8739ae039));
            const newSpriteName = settings.sprite;
            return acc.concat([
                (0, $efc499a22346529b$export$d4775187212d9f53)(sprite, tweenSettings, sourceTweenSettings),
                newSpriteName && (()=>{
                    if (sprite._spriteName === newSpriteName) return;
                    sprite.sprite(newSpriteName);
                    sprite._spriteName = newSpriteName;
                })
            ]);
        }
        const gradient = entity.gradientParts.find((part)=>part.attr("key") === keyName);
        if (gradient) {
            const defaultSettings = {
                z: 0,
                w: gradient.originalSize.w,
                h: gradient.originalSize.h,
                ...entity.appliedDefinition.gradients.find((startSettings)=>startSettings.key === keyName) || {},
                x: 0,
                y: 0
            };
            const tweenSettings = deltaSettings({
                ...defaultSettings,
                ...settings
            });
            const sourceTweenSettings = sourceFrameData && deltaSettings({
                ...defaultSettings,
                ...sourceFrameData[keyName]
            });
            return acc.concat((0, $efc499a22346529b$export$d4775187212d9f53)(gradient, tweenSettings, sourceTweenSettings), (0, $60cfab0448e82384$export$c8c553e0f1af1c56)(gradient, settings.topColor, settings.bottomColor));
        }
        const hook = entity.currentAttachHooks[keyName];
        if (hook) {
            hook.addComponent((0, $ab6babeceb13821a$export$2e2bcd8739ae039));
            const defaultSettings = {
                x: 0,
                y: 0
            };
            const tweenSettings = deltaSettings({
                ...defaultSettings,
                ...settings
            });
            return acc.concat([
                (0, $efc499a22346529b$export$d4775187212d9f53)(hook, tweenSettings)
            ]);
        }
        return acc;
    }, []).filter(Boolean);
    return (t)=>fns.forEach((f)=>f(t));
};
const $5fd20eb0995a8d9f$var$displaySpriteAnimationFn = (entity, animationDefinition)=>{
    const sprite = entity.composableParts.find((part)=>part.attr("key") === animationDefinition.key);
    if (!sprite) return ()=>{};
    return (t)=>{
        const spriteIndex = Math.min(Math.floor(t * animationDefinition.sprites.length), animationDefinition.sprites.length - 1);
        const name = animationDefinition.sprites[spriteIndex];
        sprite.sprite(name);
        sprite._spriteName = name;
    };
};
const $5fd20eb0995a8d9f$var$Hook = "ComposableHook";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($5fd20eb0995a8d9f$var$Hook, {
    events: {
        Freeze () {
            this._children.forEach((child)=>child.freeze && child.freeze());
        },
        Unfreeze () {
            this._children.forEach((child)=>child.unfreeze && child.unfreeze());
        }
    }
});
const $5fd20eb0995a8d9f$var$Composable = "Composable";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($5fd20eb0995a8d9f$var$Composable, {
    required: (0, $b27380253b0dbcca$export$2e2bcd8739ae039),
    events: {
        Reorder () {
            const zDelta = this.z - this.currentZ;
            this.forEachPart((part)=>{
                part.z += zDelta;
            });
            Object.values(this.currentAttachHooks).forEach((hook)=>{
                hook.z += zDelta;
                hook.currentAttachment && (hook.currentAttachment.z += zDelta);
            });
            this.currentZ = this.z;
        },
        Freeze () {
            this.stopAnimation();
            this._children.forEach((child)=>child.freeze && child.freeze());
        },
        Unfreeze () {
            this._children.forEach((child)=>child.unfreeze && child.unfreeze());
            if (this.getAnimation("default")) this.playAnimation("default");
            else if (this.appliedEntityDefinition && this.appliedEntityDefinition.structure && this.appliedEntityDefinition.structure.frame) this.displayFrame(this.appliedEntityDefinition.structure.frame);
            else this.displayFrame("default");
        }
    },
    init () {
        this.appliedDefinition = $5fd20eb0995a8d9f$var$definitionStructure;
        this.composableParts = [];
        this.collisionComponents = [];
        this.gradientParts = [];
        this.currentAttachHooks = {};
        this.currentZ = this.z;
        this.animationListeners = [];
        this.displayFrame = this.displayFrame.bind(this);
        this.playAnimation = this.playAnimation.bind(this);
    },
    compose (proposedDefinition, { autoStartAnimation: autoStartAnimation = true } = {}) {
        if (this.appliedDefinition === proposedDefinition) return;
        const definition = {
            ...$5fd20eb0995a8d9f$var$definitionStructure,
            ...proposedDefinition
        };
        this.setOwnAttributes(definition.attributes);
        this.buildSprites(definition.sprites, definition.spriteAttributes);
        this.buildGradients(definition.gradients);
        this.appliedDefinition = proposedDefinition;
        this.forEachPart((entity, index)=>{
            const definition = this.spriteOptions(index);
            if (!definition.attachTo) return;
            const attachTarget = $5fd20eb0995a8d9f$var$getSpriteByKey(this, definition.attachTo);
            attachTarget && attachTarget.attach(entity);
        });
        this.buildAttachHooks(definition.attachHooks);
        if (definition.hitbox.length > 0) {
            this.addComponent("Collision");
            this.collision(definition.hitbox);
        }
        if (definition.attributes.scale) {
            this.addComponent((0, $c5a6dfafafffbebd$export$2e2bcd8739ae039));
            this.attr({
                scale: definition.attributes.scale
            });
        }
        if (this.getAnimation("default") && autoStartAnimation) this.playAnimation("default");
        return this;
    },
    getAnimation (animationName) {
        return this.appliedDefinition.animations && this.appliedDefinition.animations[animationName];
    },
    async playAnimation (animationName) {
        const animationData = this.getAnimation(animationName);
        if (!animationData) throw new Error(`Animation ${animationName} not found in playAnimation`);
        if (animationData.startEase) {
            const firstFrame = animationData.timeline[0].startFrame;
            await this.displayFrame(firstFrame, animationData.startEase.duration, animationData.startEase.easing);
        }
        this.activeAnimation = {
            name: animationName,
            data: animationData,
            easing: (0, $21d6fb1fc143defa$export$742424a10dd87ed1)[animationData.easing || "linear"],
            timeline: animationData.timeline.map((e)=>({
                    ...e
                }))
        };
        this.animationStart = animationData.timer && animationData.timer === "global" ? (0, $3cd0f3499d493eb4$export$c2e8e32465a0cbd6)() : +new Date();
        this.bind("GameLoop", this.updateAnimationFrame);
        await new Promise((resolve)=>this.animationListeners.push(resolve));
    },
    animationPlaying () {
        return this.activeAnimation !== null;
    },
    stopAnimation () {
        this.unbind("GameLoop", this.updateAnimationFrame);
        this.activeAnimation = null;
        this.animationListeners.forEach((listener)=>listener());
        this.animationListeners = [];
    },
    updateAnimationFrame ({ inGameTime: inGameTime }) {
        // When pausing the game is introduced, this will
        // need some special care
        if (inGameTime < this.animationStart) this.animationStart = inGameTime;
        const timeElapsed = inGameTime - this.animationStart;
        const timeInIteration = this.activeAnimation.data.repeat ? timeElapsed % this.activeAnimation.data.duration : timeElapsed;
        const t = timeInIteration / this.activeAnimation.data.duration;
        const v = this.activeAnimation.easing(t);
        this.activeAnimation.timeline.forEach((event)=>{
            if (event.start > v || v > event.end) return;
            if (!event.animateFn) event.animateFn = event.startFrame && event.endFrame && $5fd20eb0995a8d9f$var$displayFrameFn(this, event.endFrame, event.startFrame) || event.spriteAnimation && $5fd20eb0995a8d9f$var$displaySpriteAnimationFn(this, event.spriteAnimation) || (()=>{});
            const localV = (v - event.start) / (event.end - event.start);
            event.animateFn(localV);
        });
        if (t >= 1.0 && !this.activeAnimation.data.repeat) {
            const after = this.activeAnimation.data.after;
            this.stopAnimation();
            if (after && after.animation) this.playAnimation(after.animation);
        }
    },
    setOwnAttributes (attributes) {
        if (!attributes) return;
        const attrs = {};
        if (attributes.width) attrs.w = attributes.width;
        if (attributes.height) attrs.h = attributes.height;
        if (attributes.ro) {
            const [rx, ry] = attributes.ro;
            this.origin(rx, ry);
        }
        this.attr(attrs);
    },
    buildSprites (spriteList, spriteAttributes) {
        const additions = [];
        const currentlyApplied = this.appliedDefinition.sprites;
        let currentPointer = 0;
        spriteList.forEach((sprite, index, list)=>{
            const current = currentlyApplied[currentPointer];
            if (!current) additions.push(sprite);
            else if (sprite[0] !== current[0]) {
                // replace
                const nextSprite = list[index + 1];
                if (nextSprite && nextSprite[0] === current[0]) {
                    // maybe we are inserted.
                    this.composableParts.splice(currentPointer, 0, this.createAndAttachSprite(sprite, spriteAttributes));
                    currentPointer++;
                    return;
                }
                // clear old
                const toReplace = this.composableParts[currentPointer];
                this.detach(toReplace);
                toReplace.destroy();
                this.composableParts.splice(currentPointer, 1, this.createAndAttachSprite(sprite, spriteAttributes));
                currentPointer++;
            } else if (sprite[0] === current[0]) {
                // same sprite
                const toUpdate = this.composableParts[currentPointer];
                this.applySpriteOptions(toUpdate, {
                    ...spriteAttributes,
                    ...sprite[1]
                });
                currentPointer++;
            }
        });
        const deletions = this.composableParts.slice(currentPointer);
        deletions.forEach((deletion)=>{
            this.detach(deletion);
            deletion.destroy();
        });
        this.composableParts = this.composableParts.slice(0, currentPointer).concat(additions.map((spriteData)=>this.createAndAttachSprite(spriteData, spriteAttributes)));
    },
    buildGradients (gradientList) {
        const additions = [];
        const currentlyApplied = this.appliedDefinition.gradients;
        let currentPointer = 0;
        gradientList.forEach((gradient)=>{
            const current = currentlyApplied[currentPointer];
            if (!current) additions.push(gradient);
            else {
                const toUpdate = this.composableParts[currentPointer];
                this.applySpriteOptions(toUpdate, gradient);
                currentPointer++;
            }
        });
        const deletions = this.gradientParts.slice(currentPointer);
        deletions.forEach((deletion)=>{
            this.detach(deletion);
            deletion.destroy();
        });
        this.gradientParts = this.gradientParts.slice(0, currentPointer).concat(additions.map((gradientData)=>this.createAndAttachGradient(gradientData)));
    },
    createAndAttachGradient (options) {
        const renderLayer = this._drawLayer ? this._drawLayer.name : "WebGL";
        const subElem = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e([
            renderLayer,
            "2D",
            (0, $68215c666a453acc$export$2e2bcd8739ae039),
            (0, $ab6babeceb13821a$export$2e2bcd8739ae039)
        ].join(", "));
        this.applyGradientOptions(subElem, options);
        subElem.attr({
            originalSize: {
                w: subElem.w,
                h: subElem.h
            }
        });
        this.attach(subElem);
        return subElem;
    },
    applyGradientOptions (elem, options) {
        elem.attr({
            x: this.x + (options.x || 0),
            y: this.y + (options.y || 0),
            z: this.z + (options.z || 0)
        });
        if (options.key) elem.attr({
            key: options.key
        });
        elem.attr({
            w: options.w || elem.w,
            h: options.h || elem.h,
            alpha: options.alpha === undefined ? 1 : options.alpha
        });
        if (options.topColor) elem.topColor(options.topColor[0], options.topColor[1]);
        if (options.bottomColor) elem.bottomColor(options.bottomColor[0], options.bottomColor[1]);
        if (options.ro) {
            const [rx, ry] = options.ro;
            elem.origin(rx, ry);
            if (options.rotation) elem.attr({
                rotation: options.rotation
            });
        }
        if (options.hitbox) {
            elem.addComponent("Collision");
            elem.collision(options.hitbox);
        }
        if (options.hideBelow) elem.addComponent("HideBelow").attr({
            hideBelow: options.hideBelow
        });
        if (options.hideAbove) elem.addComponent("HideBelow").attr({
            hideAbove: options.hideAbove
        });
    },
    createAndAttachSprite ([spriteName, options], spriteAttributes) {
        const renderLayer = this._drawLayer ? this._drawLayer.name : "WebGL";
        const subElem = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e([
            renderLayer,
            "2D",
            (0, $ab6babeceb13821a$export$2e2bcd8739ae039),
            (0, $c5a6dfafafffbebd$export$2e2bcd8739ae039),
            spriteName
        ].join(", "));
        subElem._spriteName = spriteName;
        const opts = {
            ...spriteAttributes,
            ...options
        };
        this.applySpriteOptions(subElem, opts);
        subElem.attr({
            originalSize: {
                w: subElem.w,
                h: subElem.h
            }
        });
        subElem.root = this;
        this.attach(subElem);
        if (opts.stretch) subElem.activateStretch(this);
        return subElem;
    },
    applySpriteOptions (elem, options) {
        elem.attr({
            x: this.x + (options.x || 0),
            y: this.y + (options.y || 0),
            z: this.z + (options.z || 0)
        });
        if (options.key) elem.attr({
            key: options.key
        });
        if (options.crop) {
            // input: Top, Right, Bottom, Left (clockwise)
            // output: left, top, width, height
            const [top, right, bottom, left] = options.crop;
            elem.crop(left, top, elem.w - right - left, elem.h - bottom - top);
        }
        if (options.scale) elem.attr({
            scale: options.scale
        });
        if (options.scaleX) elem.attr({
            scale: options.scaleX
        });
        if (options.scaleY) elem.attr({
            scale: options.scaleY
        });
        if (options.stretch) {
            elem.addComponent((0, $47ac9e977e9352cf$export$99630c140ecf063f));
            elem.attr({
                stretch: options.stretch
            });
        }
        if (options.overrideColor) {
            elem.addComponent((0, $11b8e266696d15ba$export$2e2bcd8739ae039));
            elem.colorOverride(options.overrideColor);
        }
        if (options.accentColor) {
            elem.addComponent((0, $11b8e266696d15ba$export$2e2bcd8739ae039));
            elem.colorOverride(options.accentColor, "partial");
        }
        if (options.lightness) {
            elem.addComponent((0, $11b8e266696d15ba$export$2e2bcd8739ae039));
            elem.attr({
                lightness: options.lightness
            });
        }
        elem.attr({
            w: options.w || elem.w,
            h: options.h || elem.h,
            alpha: options.alpha === undefined ? 1 : options.alpha,
            maxAlpha: options.maxAlpha === undefined ? 1 : options.maxAlpha
        });
        if (options.flipX) elem.flip("X");
        if (options.ro) {
            const [rx, ry] = options.ro;
            elem.origin(rx, ry);
            if (options.rotation) elem.attr({
                rotation: options.rotation
            });
        }
        if (options.hitbox) {
            elem.addComponent("Collision");
            elem.collision(options.hitbox);
        }
        if (options.hideBelow) elem.addComponent("HideBelow").attr({
            hideBelow: options.hideBelow
        });
        if (options.hideAbove) elem.addComponent("HideBelow").attr({
            hideAbove: options.hideAbove
        });
        if (options.horizon) {
            const [bottom, top] = options.horizon;
            elem.addComponent((0, $8c0d474e6a2e6236$export$2e2bcd8739ae039)).saturationGradient(bottom, top);
        }
    },
    forEachPart (callback) {
        this.composableParts.forEach((elem, idx, list)=>callback(elem, idx, list));
    },
    spriteOptions (index) {
        return this.appliedDefinition.sprites[index][1];
    },
    attachHookSettings (targetHookName) {
        return $5fd20eb0995a8d9f$var$getHookSettings(this.appliedDefinition, targetHookName);
    },
    attachEntity (targetHookName, entity) {
        const hookSettings = this.attachHookSettings(targetHookName);
        const hook = this.currentAttachHooks[targetHookName];
        if (!hook) return;
        if (hook.currentAttachment && hook.currentAttachment !== entity) hook.currentAttachment.destroy();
        if (!entity) {
            hook.attr({
                currentAttachment: null
            });
            return;
        }
        const alignment = hookSettings.attachAlign || [
            "top",
            "left"
        ];
        const targetX = hook.x - $5fd20eb0995a8d9f$var$widthFactor[alignment[1]] * entity.w;
        const targetY = hook.y - $5fd20eb0995a8d9f$var$heightFactor[alignment[0]] * entity.h;
        entity.attr({
            x: targetX,
            y: targetY,
            z: hook.z
        });
        entity.detachFromParent = ()=>{
            hook.detach(entity);
            hook.attr({
                currentAttachment: null
            });
        };
        hook.attach(entity);
        hook.attr({
            currentAttachment: entity
        });
    },
    clearAttachment (targetHookName) {
        this.attachEntity(targetHookName, null);
    },
    buildAttachHooks (attachHooks) {
        attachHooks.forEach(([label, options])=>{
            const hook = this.currentAttachHooks[label] || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(`2D, ${$5fd20eb0995a8d9f$var$Hook}`);
            hook.attr({
                x: this.x + (options.x || 0),
                y: this.y + (options.y || 0),
                z: this.z + (options.z || 0),
                w: 1,
                h: 1,
                currentAttachment: hook.currentAttachment || null
            });
            if (options.attachTo) {
                const elem = $5fd20eb0995a8d9f$var$getSpriteByKey(this, options.attachTo);
                elem ? elem.attach(hook) : this.attach(hook);
            } else this.attach(hook);
            this.currentAttachHooks[label] = hook;
        });
    },
    getElementByKey (key) {
        return $5fd20eb0995a8d9f$var$getSpriteByKey(this, key);
    },
    addCollisionComponent (c, passthrough = []) {
        this.collisionComponents.push(c);
        if (this.has("Collision") || passthrough.length > 0) this.addComponent(c);
        this.composableParts.forEach((p)=>p.has("Collision") && (passthrough.length > 0 ? passthrough.forEach((fName)=>p[fName] = function(...args) {
                    this.root[fName](...args);
                }) : p.addComponent(c)));
        return this;
    },
    clearCollisionComponents () {
        this.collisionComponents.forEach((c)=>this.removeComponent(c));
        this.composableParts.forEach((p)=>this.collisionComponents.forEach((c)=>p.removeComponent(c)));
        this.collisionComponents = [];
        return this;
    },
    async displayFrame (frameName, duration = 0, easing) {
        const frameData = $5fd20eb0995a8d9f$var$getFrameData(this, frameName);
        if (!frameData) return;
        const frameFunc = $5fd20eb0995a8d9f$var$displayFrameFn(this, frameName);
        return this.animate(frameFunc, duration, easing);
    }
});
var $5fd20eb0995a8d9f$export$2e2bcd8739ae039 = $5fd20eb0995a8d9f$var$Composable;


//import StackableCoordinates from "./StackableCoordinates";


let $2e5c1713fb068b10$var$gameSpeed = 1.0;
const $2e5c1713fb068b10$export$ad7a301ff9ed764b = ()=>$2e5c1713fb068b10$var$gameSpeed;
const $2e5c1713fb068b10$export$ea1f1c9e80b89b51 = (speed)=>{
    $2e5c1713fb068b10$var$gameSpeed = speed;
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("SpriteAnimation").each(function() {
        if (this.has("TimeManager")) return;
        return this.animationSpeed = speed;
    });
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Delay").each(function() {
        if (this.has("TimeManager")) return;
        return this.delaySpeed = speed;
    });
    return (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Tween").each(function() {
        if (this.has("TimeManager")) return;
        return this.tweenSpeed = speed;
    });
};
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).bind("NewEntity", (data)=>{
    const entity = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(data.id);
    if (entity.has("TimeManager")) return;
    if (entity.has("SpriteAnimation")) entity.animationSpeed = $2e5c1713fb068b10$var$gameSpeed;
    if (entity.has("Delay")) entity.delaySpeed = $2e5c1713fb068b10$var$gameSpeed;
    if (entity.has("Tween")) entity.tweenSpeed = $2e5c1713fb068b10$var$gameSpeed;
});


var $d1695771f6eb02d3$exports = {};
$d1695771f6eb02d3$exports = "#define GLSLIFY 1\nattribute vec2 aPosition;\nattribute vec3 aVelocity;\nattribute vec3 aOrientation;\nattribute vec2 aLayer;\nattribute vec2 aSize;\nattribute vec4 aLife;\nattribute vec4 aColor1;\nattribute vec4 aColor2;\n\nvarying lowp vec4 vColor;\nvarying lowp vec2 vLayer;\nvarying lowp vec2 vLife;\n\nuniform  vec4 uViewport;\nuniform  vec4 uTimeOffset;\nuniform  vec2 uCoordOffset;\n\nmat4 viewportScale = mat4(2.0 / uViewport.z, 0, 0, 0,    0, -2.0 / uViewport.w, 0,0,    0, 0,1,0,    -1,+1,0,1);\nvec4 viewportTranslation = vec4(uViewport.xy, 0, 0);\n\nfloat gravity(float accelleration, float duration) {\n  // https://www.vcalc.com/equation/?uuid=e6ccc22d-da27-11e2-8e97-bc764e04d25f\n  return 0.5 * accelleration * (duration / 1000.0) * (duration / 1000.0);\n}\n\nvoid main() {\n  vec2 pos = aPosition.xy;\n  vec2 entityOrigin = aOrientation.xy;\n  mat2 entityRotationMatrix = mat2(cos(aOrientation.z), sin(aOrientation.z), -sin(aOrientation.z), cos(aOrientation.z));\n\n  mat2 entityAngleMatrix = mat2(cos(aVelocity.y), sin(aVelocity.y), -sin(aVelocity.y), cos(aVelocity.y));\n  pos = entityRotationMatrix * (pos - entityOrigin) + entityOrigin;\n\n  float duration = uTimeOffset.x - aLife.x;\n  if (aVelocity.z == -1.0) {\n    duration = aLife.y - duration;\n  }\n  float durationScale = duration / aLife.y;\n\n  float dist = aVelocity.x * (duration / 1000.0);\n\n  vec2 movement = vec2(cos(aVelocity.y) * dist, sin(aVelocity.y) * dist);\n  vec2 gravityDisplacement = vec2(gravity(aLife.z, duration), gravity(aLife.a, duration));\n\n  pos = pos + movement + gravityDisplacement + uCoordOffset;\n\n  gl_Position = viewportScale * (viewportTranslation + vec4(pos, 1.0/(1.0+exp(aLayer.x) ), 1) );\n	gl_PointSize = (1.0 - durationScale) * aSize.x + durationScale * aSize.y;\n\n  vColor = mix(aColor1, aColor2, durationScale);\n  vLayer = aLayer;\n  vLife = vec2(duration, aLife.y);\n}\n\n";


var $4e4c9b1855a48739$exports = {};
$4e4c9b1855a48739$exports = "precision mediump float;\n#define GLSLIFY 1\nvarying lowp vec4 vColor;\nvarying lowp vec2 vLife;\n\nuniform sampler2D uSampler;\nuniform mediump vec2 uTextureDimensions;\nuniform highp vec4 uSpriteCoords;\n\nvoid main(void) {\n  if (vLife.x > vLife.y || vLife.x < 0.0) {\n    discard;\n  }\n\n  if (uSpriteCoords.b == 0.0) {\n    gl_FragColor = vColor;\n    return;\n  }\n\n  highp vec2 coord = (uSpriteCoords.xy + (gl_PointCoord * uSpriteCoords.ba)) / uTextureDimensions;\n  mediump vec4 texelColor = texture2D(uSampler, coord);\n  mediump float lightness = (0.2126*texelColor.r + 0.7152*texelColor.g + 0.0722*texelColor.b);\n\n  mediump vec3 mixedColor = vColor.rgb * (lightness * 1.3);\n  gl_FragColor = vec4(mixedColor * texelColor.a * vColor.a, texelColor.a * vColor.a);\n}\n";



const $93e81aced5728835$var$WebGLParticles = "WebGLParticles";
let $93e81aced5728835$var$particleShader = null;
const $93e81aced5728835$var$compileParticleShader = (shader, drawLayer)=>{
    const gl = drawLayer.context;
    if ($93e81aced5728835$var$particleShader && $93e81aced5728835$var$particleShader.gl === gl) return [
        $93e81aced5728835$var$particleShader.fragmentShader,
        $93e81aced5728835$var$particleShader.vertexShader
    ];
    const fragmentShader = drawLayer._compileShader(shader.fragmentCode, gl.FRAGMENT_SHADER);
    const vertexShader = drawLayer._compileShader(shader.vertexCode, gl.VERTEX_SHADER);
    $93e81aced5728835$var$particleShader = {
        gl: gl,
        fragmentShader: fragmentShader,
        vertexShader: vertexShader
    };
    return [
        fragmentShader,
        vertexShader
    ];
};
const $93e81aced5728835$var$removeProgram = (program)=>{
    const gl = program.context;
    gl.deleteBuffer(program._indexBuffer);
    gl.deleteBuffer(program._attributeBuffer);
    gl.detachShader(program.shader, program.shader.vertexShader);
    gl.detachShader(program.shader, program.shader.fragmentShader);
    gl.deleteProgram(program.shader);
};
class $93e81aced5728835$var$ParticleBuffer {
    constructor(context, stride, attributes){
        this.context = context;
        this.attributes = attributes;
        this.stride = stride;
        this.array_size = 16;
        this.max_size = 4096;
        this.render_size = 0;
        this._attributeArray = new Float32Array(this.array_size * this.stride);
        this._attributeBuffer = this.context.createBuffer();
        this.active = true;
    }
    reactivate() {
        this.active = true;
        this.render_size = 0;
    }
    deactivate() {
        this.active = false;
    }
    growArrays(size) {
        this.render_size = Math.min(size, this.max_size);
        if (this.array_size >= this.max_size) return;
        if (this.array_size >= size) return;
        const newsize = Math.min(size, this.max_size);
        const newAttributeArray = new Float32Array(newsize * this.stride);
        newAttributeArray.set(this._attributeArray);
        this._attributeArray = newAttributeArray;
        this.array_size = newsize;
    }
    writeParticle(pi, particle) {
        const attributes = this.attributes;
        let offset = pi * this.stride;
        for(let ai = 0; ai < attributes.length; ai++)for(let api = 0; api < attributes[ai].width; api++){
            this._attributeArray[offset] = particle[attributes[ai].name][api];
            offset++;
        }
    }
    draw() {
        const gl = this.context;
        gl.bindBuffer(gl.ARRAY_BUFFER, this._attributeBuffer);
        const attributes = this.attributes;
        // Process every attribute
        for(var i = 0; i < attributes.length; i++){
            let a = attributes[i];
            gl.vertexAttribPointer(a.location, a.width, a.type, false, this.stride * a.bytes, a.offset * a.bytes);
        }
        gl.bufferData(gl.ARRAY_BUFFER, this._attributeArray, gl.STATIC_DRAW);
        gl.drawArrays(gl.POINTS, 0, this.render_size);
    }
}
class $93e81aced5728835$var$RenderProgramWrapper {
    constructor(layer, shader){
        this.shader = shader;
        this.layer = layer;
        this.context = layer.context;
        this.draw = function() {};
        this.array_size = 0;
        this.max_size = 96;
    }
    // Takes an array of attributes; see WebGLLayer's getProgramWrapper method
    initAttributes(attributes) {
        this.attributes = attributes;
        this._attribute_table = {};
        var offset = 0;
        for(var i = 0; i < attributes.length; i++){
            var a = attributes[i];
            this._attribute_table[a.name] = a;
            a.bytes = a.bytes || Float32Array.BYTES_PER_ELEMENT;
            a.type = a.type || this.context.FLOAT;
            a.offset = offset;
            a.location = this.context.getAttribLocation(this.shader, a.name);
            this.context.enableVertexAttribArray(a.location);
            offset += a.width;
        }
        // Stride is the full width including the last set
        this.stride = offset;
        // Create attribute array of correct size to hold max elements
        this.buffers = [];
    }
    // Add an entity that needs to be rendered by this program
    // Needs to be assigned an index in the buffer
    registerEntity(e) {
        const staleBuffer = this.buffers.find((b)=>b.active === false);
        if (staleBuffer === undefined) {
            if (this.buffers.length >= this.max_size) throw "Number of entities exceeds maximum limit.";
            const newBuffer = new $93e81aced5728835$var$ParticleBuffer(this.context, this.stride, this.attributes);
            this.buffers.push(newBuffer);
            e.particleBuffer = newBuffer;
        } else {
            staleBuffer.reactivate();
            e.particleBuffer = staleBuffer;
        }
    }
    // remove an entity; allow its buffer index to be reused
    unregisterEntity(e) {
        e.particleBuffer.deactivate();
        e.particleBuffer = null;
    }
    resetRegistry() {
        this.buffers = [];
    }
    setCurrentEntity(ent) {
        this.drawBuffers.push(ent.particleBuffer);
    }
    // Called before a batch of entities is prepped for rendering
    switchTo() {
        var gl = this.context;
        gl.useProgram(this.shader);
        this.drawBuffers = [];
        this.hasTime = false;
    }
    // Sets a texture
    setTexture(texture_obj) {
        // Only needs to be done once
        if (this.texture_obj !== undefined) return;
        // Set the texture buffer to use
        texture_obj.setToProgram(this.shader, "uSampler", "uTextureDimensions");
        this.texture_obj = texture_obj;
    }
    // Writes data from the attribute and index arrays to the appropriate buffers, and then calls drawElements.
    renderBatch() {
        // For now, special case the need for texture objects
        var t = this.texture_obj;
        if (t && t.unit === null) this.layer.texture_manager.bindTexture(t);
        for(let i = 0; i < this.drawBuffers.length; i++)if (this.drawBuffers[i].active) this.drawBuffers[i].draw();
    }
    setViewportUniforms(viewport) {
        var gl = this.context;
        gl.useProgram(this.shader);
        gl.uniform4f(this.shader.viewport, -viewport._x, -viewport._y, viewport._w, viewport._h);
    }
}
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($93e81aced5728835$var$WebGLParticles, {
    /**@
   * #.context
   * @comp WebGL
   * @kind Property
   *
   * The webgl context this entity will be rendered to.
   */ init: function() {
        this.requires("Renderable");
        // Attach to webgl layer
        if (!this._customLayer) this._attachToLayer((0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).s("DefaultWebGLLayer"));
    },
    remove: function() {
        // remove shader program
        $93e81aced5728835$var$removeProgram(this.program);
        delete this.program;
        this._detachFromLayer();
    },
    // Cache the various objects and arrays used in draw
    drawVars: {
        type: "webgl",
        pos: {},
        ctx: null,
        coord: [
            0,
            0,
            0,
            0
        ],
        co: {
            x: 0,
            y: 0,
            w: 0,
            h: 0
        }
    },
    /**@
   * #.draw
   * @comp WebGL
   * @kind Method
   * @private
   *
   * @sign public this .draw()
   *
   * An internal method to draw the entity on the webgl canvas element. Rather then rendering directly, it writes relevent information into a buffer to allow batch rendering.
   */ draw: function() {
        if (!this.ready) return;
        var pos = this.drawVars.pos;
        pos._x = this._x;
        pos._y = this._y;
        pos._w = this._w;
        pos._h = this._h;
        var coord = this.__coord || [
            0,
            0,
            0,
            0
        ];
        var co = this.drawVars.co;
        co.x = coord[0];
        co.y = coord[1];
        co.w = coord[2];
        co.h = coord[3];
        // Handle flipX, flipY
        // (Just swap the positions of e.g. x and x+w)
        if (this._flipX) {
            co.x = co.x + co.w;
            co.w = -co.w;
        }
        if (this._flipY) {
            co.y = co.y + co.h;
            co.h = -co.h;
        }
        //Draw entity
        var gl = this._drawContext;
        this.drawVars.gl = gl;
        var prog = this.drawVars.program = this.program;
        // The program might need to refer to the current element's index
        prog.setCurrentEntity(this);
        // This should only need to handle *specific* attributes!
        this.trigger("Draw", this.drawVars);
        return this;
    },
    _makeProgram: function(shader) {
        var gl = this._drawLayer.context;
        const [fragmentShader, vertexShader] = $93e81aced5728835$var$compileParticleShader(shader, this._drawLayer);
        var shaderProgram = gl.createProgram();
        gl.attachShader(shaderProgram, vertexShader);
        gl.attachShader(shaderProgram, fragmentShader);
        gl.linkProgram(shaderProgram);
        if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) throw "Could not initialise shaders";
        shaderProgram.viewport = gl.getUniformLocation(shaderProgram, "uViewport");
        shaderProgram.vertexShader = vertexShader;
        shaderProgram.fragmentShader = fragmentShader;
        return shaderProgram;
    },
    _establishShader: function(compName, shader) {
        const compiledShader = this._makeProgram(shader);
        var gl = this._drawContext;
        compiledShader.time = gl.getUniformLocation(compiledShader, "uTimeOffset");
        compiledShader.coordOffset = gl.getUniformLocation(compiledShader, "uCoordOffset");
        compiledShader.spriteCoords = gl.getUniformLocation(compiledShader, "uSpriteCoords");
        const program = new $93e81aced5728835$var$RenderProgramWrapper(this._drawLayer, compiledShader);
        program.name = compName;
        program.initAttributes(shader.attributeList);
        program.draw = shader.drawCallback;
        program.setViewportUniforms(this._drawLayer._viewportRect());
        this.program = program;
        // Needs to know where in the big array we are!
        this.program.registerEntity(this);
        // Shader program means ready
        this.ready = true;
    }
});
var $93e81aced5728835$export$2e2bcd8739ae039 = $93e81aced5728835$var$WebGLParticles;


var $fbd39d42b4ec86c5$exports = {};
$fbd39d42b4ec86c5$exports = JSON.parse('{"scenery":true,"particles":true,"music":true,"wordDelay":0.25,"tags":["sint"],"lives":8}');



const $767c35cd7f31dfa2$var$randM1to1 = ()=>Math.random() * 2 - 1;
const $767c35cd7f31dfa2$var$spriteMap = {};
const $767c35cd7f31dfa2$var$PARTICLES_ENABLED = (0, (/*@__PURE__*/$parcel$interopDefault($fbd39d42b4ec86c5$exports))).particles;
const $767c35cd7f31dfa2$var$setParticleSprite = (entity, spriteName)=>{
    const map = $767c35cd7f31dfa2$var$spriteMap[spriteName];
    if (map) {
        entity.__image = map.image;
        if (entity.program && entity._drawLayer) entity.program.setTexture(entity._drawLayer.makeTexture(entity.__image, entity.img, false));
        return;
    }
    const sprite = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(`WebGL, ${spriteName}`).attr({
        x: 5000,
        y: 5000
    });
    entity.__image = sprite.__image;
    if (entity.program && entity._drawLayer) entity.program.setTexture(entity._drawLayer.makeTexture(entity.__image, entity.img, false));
    $767c35cd7f31dfa2$var$spriteMap[spriteName] = {
        index: Object.keys($767c35cd7f31dfa2$var$spriteMap).length,
        coords: sprite.__coord,
        image: sprite.__image
    };
    sprite.destroy();
};
const $767c35cd7f31dfa2$var$getSpriteCoords = (spriteName)=>$767c35cd7f31dfa2$var$spriteMap[spriteName].coords;
const $767c35cd7f31dfa2$var$spawnParticle = (entity, settings)=>{
    const source = entity.attachTo || entity;
    const locked = entity.particleSettings.motionLocked;
    const x = (locked ? 0 : source.x) + Math.random() * entity.w;
    const y = (locked ? 0 : source.y) + Math.random() * entity.h;
    const speed = settings.velocity + $767c35cd7f31dfa2$var$randM1to1() * settings.velocityRandom;
    const angle = settings.currentAngle + $767c35cd7f31dfa2$var$randM1to1() * settings.angleRandom;
    const life = settings.duration + $767c35cd7f31dfa2$var$randM1to1() * settings.durationRandom;
    const startSize = settings.startSize + $767c35cd7f31dfa2$var$randM1to1() * settings.startSizeRandom;
    const endSize = settings.endSize + $767c35cd7f31dfa2$var$randM1to1() * settings.endSizeRandom;
    const startColor = settings.startColor.map((a, i)=>a + $767c35cd7f31dfa2$var$randM1to1() * settings.startColorRandom[i]);
    const endColor = settings.endColor.map((a, i)=>a + $767c35cd7f31dfa2$var$randM1to1() * settings.endColorRandom[i]);
    const start = entity.timeFrame - (settings.expired || 0.0) * life;
    return {
        aPosition: [
            x,
            y
        ],
        aVelocity: [
            speed,
            angle * Math.PI / 180,
            settings.emitterReverse ? -1 : 1
        ],
        aOrientation: [
            x,
            y,
            0
        ],
        aSize: [
            startSize,
            endSize
        ],
        aLife: [
            start,
            life,
            settings.gravity[0],
            settings.gravity[1]
        ],
        expire: start + life,
        aLayer: [
            entity._globalZ,
            entity._alpha
        ],
        aColor1: startColor,
        aColor2: endColor
    };
};
let $767c35cd7f31dfa2$var$startRender = null;
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).defaultShader("Particle", new (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).WebGLShader((0, (/*@__PURE__*/$parcel$interopDefault($d1695771f6eb02d3$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($4e4c9b1855a48739$exports))), [
    {
        name: "aPosition",
        width: 2
    },
    {
        name: "aVelocity",
        width: 3
    },
    {
        name: "aOrientation",
        width: 3
    },
    {
        name: "aLayer",
        width: 2
    },
    {
        name: "aSize",
        width: 2
    },
    {
        name: "aLife",
        width: 4
    },
    {
        name: "aColor1",
        width: 4
    },
    {
        name: "aColor2",
        width: 4
    }
], function(e, entity) {
    const gl = e.program.context;
    if (entity.particleSettings.motionLocked) gl.uniform2f(e.program.shader.coordOffset, entity._deltaX, entity._deltaY);
    if ($767c35cd7f31dfa2$var$startRender && !e.program.hasTime) {
        gl.uniform4f(e.program.shader.time, entity.timeFrame, 0, 0, 0);
        e.program.hasTime = entity.timeFrame;
        gl.uniform4f(e.program.shader.spriteCoords, ...$767c35cd7f31dfa2$var$getSpriteCoords(entity.particleSettings.sprite));
        if (!entity.particleSettings.motionLocked) gl.uniform2f(e.program.shader.coordOffset, 0, 0);
    }
}));
const $767c35cd7f31dfa2$var$ParticleEmitter = "ParticleEmitter";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($767c35cd7f31dfa2$var$ParticleEmitter, {
    required: `2D, ${(0, $93e81aced5728835$export$2e2bcd8739ae039)}`,
    ready: true,
    __image: "",
    img: null,
    events: {
        LayerAttached: "_setupParticles",
        GameLoop: "_renderParticles",
        Move: function({ _x: prevX, _y: prevY }) {
            if (this.particleSettings && this.particleSettings.motionLocked) {
                this._deltaX += this._x - prevX;
                this._deltaY += this._y - prevY;
            }
        }
    },
    init: function() {
        this._particlesPaused = false;
        this._deltaX = this.x;
        this._deltaY = this.y;
        // Necessary for some rendering layers
        this.bind("Draw", this._drawParticles);
        if (this._drawLayer) this._setupParticles(this._drawLayer);
        this.initialDraw = true;
        // Fake large collission shape, to allow rendering when emitter is offscreen
        this._mbr = {
            _x: 0,
            _y: 0,
            _w: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width,
            _h: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height
        };
        this.trigger("Invalidate");
        this.bind("Freeze", ()=>{
            this.stopEmission();
        });
        this.bind("Unfreeze", ()=>{
            this.startEmission();
        });
        this.bind("Change", (changes)=>{
            if (Object.prototype.hasOwnProperty.call(changes, "angle")) this.particleSettings.currentAngle = this.particleSettings.angle + changes.angle;
        });
    },
    remove () {
        this.initialDraw = true;
        this.unbind("Draw", this._drawParticles);
        this.trigger("Invalidate");
    },
    pauseParticles () {
        this._particlesPaused = true;
    },
    resumeParticles () {
        this._particlesPaused = false;
    },
    _setupParticles (layer) {
        if (layer.type === "WebGL") {
            this._establishShader("Particle", (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).defaultShader("Particle"));
            if (this.__image !== "") this.program.setTexture(layer.makeTexture(this.__image, this.img, false));
        }
    },
    _drawParticles (e) {
        // The expensive draw
        if (this.initialDraw === true) {
            this.particleBuffer.growArrays(this._particles.length);
            for(let pi = 0; pi < this._particles.length; pi++)this._writeParticle(pi, this._particles[pi]);
            this.initialDraw = false;
        }
        e.program.draw(e, this);
    },
    _writeParticle (pi, particle) {
        this.particleBuffer.writeParticle(pi, particle);
    },
    attachToEntity (entity) {
        this.attachedTo = entity;
        this.z = entity.z;
        entity.bind("Reorder", ()=>{
            this.z = entity.z;
        });
        entity.bind("Change", (changes)=>{
            if (Object.prototype.hasOwnProperty.call(changes, "angle")) this.particleSettings.currentAngle = this.particleSettings.angle + changes.angle;
        });
        this.particleSettings.currentAngle = this.particleSettings.angle + (entity.angle || 0);
        this.x = entity.x;
        this.y = entity.y;
        entity.bind("Move", ()=>{
            this.x = entity.x;
            this.y = entity.y;
            // Keep mbr static
            this._mbr = {
                _x: 0,
                _y: 0,
                _w: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width,
                _h: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height
            };
        });
        entity.bind("Freeze", ()=>{
            this.stopEmission();
        });
        entity.bind("Unfreeze", ()=>{
            this.startEmission();
        });
        entity.bind("Remove", ()=>{
            this.stopEmission();
            this.attachedTo = null;
            this.autoDestruct = true;
        });
    },
    particles ({ emitter: { amount: amount = 150, w: w = 10, h: h = 10, duration: emitterDuration = Infinity, warmed: warmed = false, reverse: emitterReverse = false, fidelity: fidelity = "low", motionLocked: motionLocked = true } = {}, gravity: gravity = [
        0,
        0
    ], particle: { velocity: velocity = 80, velocityRandom: velocityRandom = 20, angle: angle = 0, angleRandom: angleRandom = 360, duration: duration = 2000, durationRandom: durationRandom = 500, startSize: startSize = 12, startSizeRandom: startSizeRandom = 2, endSize: endSize = 24, endSizeRandom: endSizeRandom = 8, sprite: sprite = null, startColor: startColor = [
        1,
        1,
        1,
        1
    ], startColorRandom: startColorRandom = [
        0,
        0,
        0,
        0
    ], endColor: endColor = [
        0,
        0,
        0,
        1
    ], endColorRandom: endColorRandom = [
        0,
        0,
        0,
        0
    ] } = {} } = {}, attachTo = null) {
        if (!$767c35cd7f31dfa2$var$PARTICLES_ENABLED) amount = 1;
        if (motionLocked) {
            this._deltaX = this._x;
            this._deltaY = this._y;
        }
        this.particleSettings = {
            amount: amount,
            gravity: gravity,
            velocity: velocity,
            velocityRandom: velocityRandom,
            angle: angle,
            currentAngle: angle,
            angleRandom: angleRandom,
            duration: duration,
            durationRandom: durationRandom,
            startSize: startSize,
            startSizeRandom: startSizeRandom,
            endSize: endSize,
            endSizeRandom: endSizeRandom,
            sprite: sprite,
            startColor: startColor,
            startColorRandom: startColorRandom,
            endColor: endColor,
            endColorRandom: endColorRandom,
            emitterDuration: emitterDuration,
            emitterReverse: emitterReverse,
            emitterFidelity: fidelity,
            motionLocked: motionLocked
        };
        if (attachTo) this.attachToEntity(attachTo);
        this.attr({
            w: w,
            h: h
        });
        this.timeFrame = 0;
        this.startEmission({
            warmed: warmed
        });
        if (this.particleSettings.sprite) $767c35cd7f31dfa2$var$setParticleSprite(this, this.particleSettings.sprite);
        this._particles = Array(amount).fill(0).map(()=>$767c35cd7f31dfa2$var$spawnParticle(this, {
                ...this.particleSettings,
                duration: 0,
                durationRandom: 0
            }));
        this.lastExpired = this._particles.reduce((a, p)=>p.expire > a ? p.expire : a, 0);
        this.nextExpireRatio = fidelity === "low" ? 140 : duration / amount;
        this.nextExpireCheck = duration / amount;
        this.trigger("Invalidate");
        return this;
    },
    stopEmission () {
        this.emissionRate = 0;
        this.shouldHaveEmitted = 0;
    },
    startEmission ({ warmed: warmed = false } = {}) {
        this.emissionRate = this.particleSettings.amount / this.particleSettings.duration;
        this.startTime = warmed ? -1 : 0;
        this.shouldHaveEmitted = warmed ? this.particleSettings.amount : Math.min(this.startTime / 1000.0 * this.emissionRate, 1) * this.particleSettings.amount;
    },
    _renderParticles ({ dt: dt, inGameTime: inGameTime }) {
        if (!this.particleSettings) return;
        if (this._particlesPaused) return;
        $767c35cd7f31dfa2$var$startRender = $767c35cd7f31dfa2$var$startRender || inGameTime;
        this.timeFrame = inGameTime - $767c35cd7f31dfa2$var$startRender;
        if (this.startTime !== -1) {
            this.startTime += dt;
            this.shouldHaveEmitted = Math.min(this.startTime / 1000.0 * this.emissionRate, 1) * this.particleSettings.amount;
        }
        if (this.timeFrame >= this.nextExpireCheck && this.startTime < this.particleSettings.emitterDuration && $767c35cd7f31dfa2$var$PARTICLES_ENABLED) {
            this.nextExpireCheck = this.timeFrame + this.nextExpireRatio;
            const warmingUp = this.startTime === -1;
            for(let i = 0; i < this.shouldHaveEmitted; i++)if (this._particles[i].expire < this.timeFrame + 20) {
                const p = $767c35cd7f31dfa2$var$spawnParticle(this, warmingUp ? {
                    ...this.particleSettings,
                    expired: Math.random() * 0.9
                } : this.particleSettings);
                if (p.expire > this.lastExpired) this.lastExpired = p.expire;
                this._particles[i] = p;
                this._writeParticle(i, p);
            }
            if (warmingUp) this.startTime = 0;
        }
        if (this.autoDestruct && this.timeFrame > this.lastExpired) this.destroy();
    }
});
var $767c35cd7f31dfa2$export$2e2bcd8739ae039 = $767c35cd7f31dfa2$var$ParticleEmitter;



const $d4d953306f5c187b$export$a0fc405c67ba8782 = ()=>{
    const audioData = {};
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    const context = new AudioContext();
    const playingPool = {
        music: null,
        effectsGain: context.createGain(),
        musicGain: context.createGain()
    };
    playingPool.effectsGain.connect(context.destination);
    playingPool.musicGain.connect(context.destination);
    const convertAudioMap = (map)=>map.reduce((acc, entry, i, l)=>{
            const previous = i > 0 && acc[l[i - 1].name];
            const start = i === 0 ? 0 : previous.end;
            return {
                ...acc,
                [entry.name]: {
                    type: entry.type,
                    start: start,
                    end: start + entry.duration,
                    duration: entry.duration,
                    loopStart: entry.loopStart,
                    loopEnd: entry.loopEnd,
                    volume: entry.volume,
                    loop: entry.loop
                }
            };
        }, {});
    const assignAudioBuffer = (audioMap, decodedData)=>{
        audioData[audioMap.name] = {
            audioData: decodedData,
            map: convertAudioMap(audioMap.map)
        };
    };
    const currentMusic = ()=>{
        if (playingPool.music !== null) return playingPool.music.sampleName;
    };
    let audioPaused = false;
    const stopMusic = ()=>{
        if (playingPool.music !== null) {
            playingPool.music.source.stop();
            playingPool.music.source.disconnect();
            playingPool.music = null;
        }
    };
    let effectsVolume = 1.0;
    let musicVolume = 1.0;
    const api = {
        pauseAudio: ()=>{
            audioPaused = true;
            context.suspend();
        },
        resumeAudio: ()=>{
            audioPaused = false;
            context.resume();
        },
        setEffectVolume: (volume)=>{
            playingPool.effectsGain.gain.setValueAtTime(volume, context.currentTime);
            effectsVolume = volume;
        },
        setMusicVolume: (volume)=>{
            playingPool.musicGain.gain.setValueAtTime(volume, context.currentTime);
            musicVolume = volume;
        },
        getEffectsVolume: ()=>effectsVolume,
        getMusicVolume: ()=>musicVolume,
        loadAudio: async (audioMap)=>{
            const name = audioMap.name;
            if (audioData[name]) return audioData[name];
            const file = await window.fetch(audioMap.file);
            const buffer = await file.arrayBuffer();
            const decodedData = await context.decodeAudioData(buffer);
            assignAudioBuffer(audioMap, decodedData);
            return audioData[name];
        },
        stopMusic: stopMusic,
        fadeMusicVolume: (volume = 0, duration = 1000)=>{
            if (playingPool.music !== null) return playingPool.music.setVolume(volume, duration);
        },
        playAudio: (sampleName, { volume: volume = 1.0 } = {})=>{
            const map = Object.values(audioData).find((e)=>e.map[sampleName]);
            const sampleData = map.map[sampleName];
            if (sampleData.type === "music") {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($fbd39d42b4ec86c5$exports))).music === false) return;
                if (currentMusic() === sampleName) return;
                // Cross fade if track is already playing??
                stopMusic();
                const baseVolume = sampleData.volume === undefined ? 1.0 : sampleData.volume;
                const sampleVolume = volume * baseVolume;
                const source = context.createBufferSource();
                source.buffer = map.audioData;
                const trackGain = context.createGain();
                trackGain.connect(playingPool.musicGain);
                trackGain.gain.setValueAtTime(sampleVolume === 0 ? 0.01 : sampleVolume, context.currentTime);
                source.connect(trackGain);
                if (sampleData.loop) {
                    source.loop = true;
                    if (sampleData.loopStart) source.loopStart = sampleData.loopStart;
                    if (sampleData.loopEnd) source.loopEnd = sampleData.loopEnd;
                }
                source.start();
                const process = new Promise((resolve)=>source.onended = resolve);
                const setVolume = async (value, duration = 0)=>{
                    const newVolume = value * baseVolume;
                    trackGain.gain.exponentialRampToValueAtTime(newVolume === 0 ? 0.01 : newVolume, context.currentTime + duration / 1000.0);
                };
                playingPool.music = {
                    source: source,
                    sampleName: sampleName,
                    setVolume: setVolume
                };
                return {
                    stop: ()=>source.stop(),
                    setVolume: setVolume,
                    process: process
                };
            } else {
                const source = context.createBufferSource();
                source.buffer = map.audioData;
                const baseVolume = sampleData.volume === undefined ? 1.0 : sampleData.volume;
                const sampleVolume = volume * baseVolume;
                if (sampleData.loop) {
                    source.loop = true;
                    source.loopStart = sampleData.start / 1000.0;
                    source.loopEnd = sampleData.end / 1000.0;
                }
                const sampleGain = context.createGain();
                sampleGain.connect(playingPool.effectsGain);
                sampleGain.gain.setValueAtTime(sampleVolume === 0 ? 0.01 : sampleVolume, context.currentTime);
                source.connect(sampleGain);
                source.start(context.currentTime, sampleData.start / 1000.0, source.loop ? undefined : sampleData.duration / 1000.0);
                const process = new Promise((resolve)=>source.onended = resolve);
                return {
                    stop: ()=>source.stop(),
                    setVolume: async (value, duration = 0)=>{
                        const newVolume = value * baseVolume;
                        sampleGain.gain.exponentialRampToValueAtTime(newVolume === 0 ? 0.01 : newVolume, context.currentTime + duration / 1000.0);
                    },
                    process: process
                };
            }
        }
    };
    document.addEventListener("visibilitychange", ()=>{
        if (audioPaused) return;
        if (document["hidden"]) context.suspend();
        else context.resume();
    }, false);
    return api;
};
const $d4d953306f5c187b$var$defaultAudio = $d4d953306f5c187b$export$a0fc405c67ba8782();
var $d4d953306f5c187b$export$2e2bcd8739ae039 = $d4d953306f5c187b$var$defaultAudio;



let $925b104f0bb9b62a$var$paused = false;
const $925b104f0bb9b62a$export$1232c5f90e8c2039 = ()=>$925b104f0bb9b62a$var$paused;
const $925b104f0bb9b62a$export$8b09b726120a992d = ()=>{
    $925b104f0bb9b62a$var$paused = !$925b104f0bb9b62a$var$paused;
    if ($925b104f0bb9b62a$var$paused) {
        (0, $2e5c1713fb068b10$export$ea1f1c9e80b89b51)(0.0);
        (0, $d4d953306f5c187b$export$2e2bcd8739ae039).pauseAudio();
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Delay").each(function() {
            return this.pauseDelays();
        });
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Tween").each(function() {
            return this.pauseTweens();
        });
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)((0, $767c35cd7f31dfa2$export$2e2bcd8739ae039)).each(function() {
            return this.pauseParticles();
        });
    } else {
        (0, $d4d953306f5c187b$export$2e2bcd8739ae039).resumeAudio();
        (0, $2e5c1713fb068b10$export$ea1f1c9e80b89b51)(1.0);
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Delay").each(function() {
            return this.resumeDelays();
        });
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Tween").each(function() {
            return this.resumeTweens();
        });
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)((0, $767c35cd7f31dfa2$export$2e2bcd8739ae039)).each(function() {
            return this.resumeParticles();
        });
    }
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).trigger("GamePause", $925b104f0bb9b62a$var$paused);
};


const $813919f632c73548$export$9f17032d917177de = (x1, y1, x2, y2)=>Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
const $813919f632c73548$export$a3295358bff77e = (x1, y1, x2, y2)=>{
    const dist = $813919f632c73548$export$9f17032d917177de(x1, y1, x2, y2);
    return [
        (x2 - x1) / dist,
        (y2 - y1) / dist
    ];
};
const $813919f632c73548$export$3866278e849dab4e = (target, { affects: affects, duration: duration = 1, velocity: velocity = 0, accelleration: accelleration = 0, upperBounds: upperBounds = Infinity, lowerBounds: lowerBounds = -Infinity, origin: origin, speed: speed, name: name = "Impact" })=>{
    target.effects = (target.effects || []).concat({
        affects: affects,
        duration: duration,
        velocity: velocity,
        accelleration: accelleration,
        upperBounds: upperBounds,
        lowerBounds: lowerBounds,
        active: 0,
        origin: origin,
        speed: speed,
        name: name
    });
    return target;
};
const $813919f632c73548$export$52b935a48281cadd = (worldRules = {})=>(target, duration)=>{
        if (target.effects === undefined || target.effects.length === 0) return false;
        const { mutations: mutations, effects: effects } = target.effects.reduce((acc, effect)=>{
            let travelDuration = Infinity;
            if (effect.origin && effect.speed && target.x !== undefined && target.y !== undefined) {
                const dist = $813919f632c73548$export$9f17032d917177de(target.x, target.y, effect.origin.x, effect.origin.y);
                const traveled = (effect.active + duration) / 1000 * effect.speed;
                if (dist < traveled) travelDuration = (traveled - dist) / effect.speed * 1000;
                else travelDuration = 0;
            }
            const calcDuration = Math.min(duration, travelDuration, effect.duration) / 1000;
            const worldEffect = (prop, amount)=>{
                if (worldRules[prop]) return worldRules[prop](amount, effect, target);
                return {
                    [prop]: amount
                };
            };
            const delta = effect.velocity * calcDuration + 0.5 * effect.accelleration * calcDuration * calcDuration;
            const clippedDelta = delta > effect.upperBounds ? effect.upperBounds : delta < effect.lowerBounds ? effect.lowerBounds : delta;
            const mutations = clippedDelta !== 0 ? acc.mutations.concat([].concat(effect.affects).reduce((acc, prop)=>acc.concat(Object.entries(worldEffect(prop, clippedDelta)).reduce((acc, [prop, amount])=>acc.concat([
                        [
                            prop,
                            (e)=>e + amount
                        ]
                    ]), [])), [])) : acc.mutations;
            return acc.mutations !== mutations ? {
                ...acc,
                mutations: mutations
            } : acc;
        }, {
            mutations: [],
            effects: target.effects.reduce((acc, effect)=>effect.duration > duration ? acc.concat({
                    ...effect,
                    duration: effect.duration - duration,
                    active: effect.active + duration,
                    velocity: effect.velocity + effect.accelleration * duration / 1000
                }) : acc, [])
        });
        return mutations.reduce((acc, [prop, f])=>{
            const startValue = acc[prop] !== undefined ? acc[prop] : target[prop];
            acc[prop] = f(startValue);
            return acc;
        }, {
            effects: effects
        });
    };
const $813919f632c73548$var$clamp = (num)=>num > 1 ? 1 : num < 0 ? 0 : num;
const $813919f632c73548$export$da81038170e85b8c = (prevForce, currentForce, mass)=>$813919f632c73548$var$clamp(prevForce * 0.8 + currentForce / mass);


const $372adea96c125b8d$var$applyHitFlash = (entity, onOff)=>{
    if (!onOff && entity._isFlashing < 1) return;
    if (onOff && entity._isFlashing < 1) entity._isFlashing = onOff ? 3 : 0;
    entity._isFlashing--;
    const bool = entity._isFlashing > 1;
    entity.forEachPart ? entity.forEachPart((part)=>part.attr({
            hitFlash: bool ? {
                _red: 0.9,
                _green: 0.9,
                _blue: 0.9
            } : false
        })) : entity.attr({
        hitFlash: bool ? {
            _red: 0.9,
            _green: 0.9,
            _blue: 0.9
        } : false
    });
};
const $372adea96c125b8d$var$processor = (0, $813919f632c73548$export$52b935a48281cadd)({
    health: (amount, effect, target)=>{
        const resistanceEffect = 1.0 - (effect.name === "Bullet" && target.bulletResistance || 0.0);
        return {
            health: Math.ceil(amount) * resistanceEffect
        };
    },
    position: (amount, effect, target)=>{
        if (target.weight === undefined) return {};
        const [normX, normY] = (0, $813919f632c73548$export$a3295358bff77e)(effect.origin.x, effect.origin.y, target.x, target.y);
        return {
            xForce: normX,
            yForce: normY
        };
    }
});
const $372adea96c125b8d$var$DamageSupport = "DamageSupport";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($372adea96c125b8d$var$DamageSupport, {
    events: {
        EnterFrame: "_handleEffects"
    },
    init () {
        this.attr({
            health: 0,
            vulnerable: false
        });
        this._isFlashing = 0;
        this.allowDamage = this.allowDamage.bind(this);
        this.hasHealth = this.hasHealth.bind(this);
    },
    allowDamage (attr) {
        this.attr({
            vulnerable: true,
            ...attr
        });
    },
    stopDamage () {
        this.attr({
            vulnerable: false
        });
        $372adea96c125b8d$var$applyHitFlash(this, false);
    },
    hasHealth () {
        const health = this.attr("health");
        return health > 0;
    },
    processDamage (damage) {
        if ((0, $925b104f0bb9b62a$export$1232c5f90e8c2039)()) return;
        if (this.hidden) return;
        if (this.vulnerable) {
            const target = this;
            [].concat(damage).forEach((d)=>(0, $813919f632c73548$export$3866278e849dab4e)(target, d));
        }
    },
    _handleEffects ({ dt: dt }) {
        if (!this.effects || this.effects.length === 0) {
            $372adea96c125b8d$var$applyHitFlash(this, false);
            return;
        }
        const changes = $372adea96c125b8d$var$processor(this, dt);
        if (changes === false) {
            $372adea96c125b8d$var$applyHitFlash(this, false);
            return;
        }
        if (changes.health && changes.health !== this.health) this.trigger("HealthChange", changes.health);
        $372adea96c125b8d$var$applyHitFlash(this, changes.health && changes.health < this.health);
        Object.assign(this, changes);
        if (this.health <= 0) {
            this.stopDamage();
            this.trigger("Dead");
            this.trigger("HealthChange", 0);
        }
    }
});
var $372adea96c125b8d$export$2e2bcd8739ae039 = $372adea96c125b8d$var$DamageSupport;



const $02980c526b97a9ac$var$ViewportLocked = "ViewportLocked";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($02980c526b97a9ac$var$ViewportLocked, {
    events: {
        Move: "checkMotion"
    },
    checkMotion () {
        if (this._x < 0) {
            this.x = 0;
            if (this.vx < 0) this.vx = 0;
        }
        if (this._y < 0) {
            this.y = 0;
            if (this.vy < 0) this.vy = 0;
        }
        const maxX = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width - this.w;
        if (this._x > maxX) {
            this.x = maxX;
            if (this.vx > 0) this.vx = 0;
        }
        const maxY = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height - this.h;
        if (this._y > maxY) {
            this.y = maxY;
            if (this.vy > 0) this.vy = 0;
        }
    }
});
var $02980c526b97a9ac$export$2e2bcd8739ae039 = $02980c526b97a9ac$var$ViewportLocked;





const $6477623efad0c52d$var$PausableMotion = "PausableMotion";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($6477623efad0c52d$var$PausableMotion, {
    required: "Motion",
    init () {
        this.unbind("UpdateFrame", this._linearMotionTick);
        this.bind("GameLoop", this._linearMotionTick);
    }
});
var $6477623efad0c52d$export$2e2bcd8739ae039 = $6477623efad0c52d$var$PausableMotion;


var $fe9d63158457675d$exports = {};
var $bdcc910e7d20e8d5$exports = {};

$parcel$defineInteropFlag($bdcc910e7d20e8d5$exports);

$parcel$export($bdcc910e7d20e8d5$exports, "default", () => $bdcc910e7d20e8d5$export$2e2bcd8739ae039);
var $bdcc910e7d20e8d5$export$2e2bcd8739ae039 = {
    "city.Intro": {
        checkpoints: [
            {
                entities: [
                    [
                        "IntroShip",
                        {
                            key: "ship",
                            relativeX: -0.3,
                            relativeY: 0.8
                        }
                    ]
                ],
                timeline: {
                    defaultDuration: 3000,
                    transitions: [
                        {
                            key: "ship",
                            start: 0.0,
                            end: 1.0,
                            path: {
                                data: [
                                    {
                                        x: -0.3,
                                        y: 0.8
                                    },
                                    {
                                        x: -0.2,
                                        y: 0.8
                                    }
                                ]
                            }
                        },
                        {
                            start: 0.4,
                            end: 0.6,
                            key: "ship",
                            targetState: "t2o"
                        },
                        {
                            start: 0.6,
                            end: 1.0,
                            key: "ship",
                            targetState: "t2r"
                        }
                    ]
                }
            },
            {
                entities: [
                    [
                        "IntroShip",
                        {
                            key: "ship",
                            relativeX: -0.2,
                            relativeY: 0.8
                        }
                    ]
                ],
                timeline: {
                    defaultDuration: 500,
                    transitions: [
                        {
                            key: "ship",
                            start: 0.8,
                            targetState: "heliStart"
                        }
                    ]
                }
            },
            {
                entities: [
                    [
                        "IntroShip",
                        {
                            key: "ship",
                            state: "heliStart",
                            relativeX: -0.2,
                            relativeY: 0.8
                        }
                    ],
                    [
                        "IntroHeli",
                        {
                            key: "heli",
                            detach: true
                        }
                    ]
                ],
                timeline: {
                    defaultDuration: 500,
                    transitions: [
                        {
                            start: 0.2,
                            end: 1.0,
                            key: "heli",
                            targetState: "flying"
                        },
                        {
                            start: 0.0,
                            end: 0.8,
                            key: "ship",
                            targetState: "shipStart"
                        },
                        {
                            start: 0.8,
                            end: 1.0,
                            key: "ship",
                            targetState: "shipLiftOff"
                        }
                    ]
                }
            },
            {
                entities: [
                    [
                        "IntroShip",
                        {
                            key: "ship",
                            state: "shipLiftOff",
                            relativeX: -0.2,
                            relativeY: 0.8
                        }
                    ],
                    [
                        "IntroHeli",
                        {
                            key: "heli",
                            state: "flying",
                            detach: true
                        }
                    ],
                    [
                        "PlayerShip",
                        {
                            key: "player",
                            detach: true,
                            state: "flying"
                        }
                    ]
                ],
                timeline: {
                    defaultDuration: 1500,
                    transitions: [
                        {
                            start: 0.0,
                            end: 0.5,
                            key: "player",
                            path: {
                                name: "playerLiftOff",
                                start: 0.0,
                                end: 1
                            },
                            attributes: {
                                z: 10
                            }
                        },
                        {
                            start: 0.0,
                            end: 1.0,
                            key: "heli",
                            path: {
                                name: "intro.HeliLiftOff",
                                start: 0.0,
                                end: 0.2
                            },
                            attributes: {
                                z: 14
                            }
                        },
                        {
                            start: 0.0,
                            end: 1,
                            key: "ship",
                            targetState: "closed",
                            path: {
                                data: [
                                    {
                                        x: -0.2,
                                        y: 0.8
                                    },
                                    {
                                        x: -0.1,
                                        y: 0.8
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                entities: [
                    [
                        "IntroShip",
                        {
                            key: "ship",
                            relativeX: -0.1,
                            relativeY: 0.8
                        }
                    ],
                    [
                        "IntroHeli",
                        {
                            key: "heli",
                            state: "flying",
                            relativeX: 0.466,
                            relativeY: 0.458,
                            z: 10,
                            detach: true
                        }
                    ]
                ],
                timeline: {
                    defaultDuration: 8000,
                    transitions: [
                        {
                            start: 0.0,
                            end: 0.35,
                            key: "heli",
                            path: {
                                name: "intro.HeliLiftOff",
                                start: 0.2,
                                end: 1.0
                            }
                        },
                        {
                            key: "ship",
                            start: 0.1,
                            end: 1.0,
                            path: {
                                data: [
                                    {
                                        x: -0.1,
                                        y: 0.8
                                    },
                                    {
                                        x: -1,
                                        y: 0.8
                                    }
                                ]
                            }
                        },
                        {
                            key: "ship",
                            start: 1.0,
                            end: 1.0,
                            remove: true
                        },
                        {
                            key: "heli",
                            start: 1.0,
                            end: 1.0,
                            remove: true
                        }
                    ]
                }
            }
        ],
        habitat: {
            scenery: "city.Ocean",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                0
            ]
        }
    }
};


var $c660d2f4fefd29b8$exports = {};

$parcel$defineInteropFlag($c660d2f4fefd29b8$exports);

$parcel$export($c660d2f4fefd29b8$exports, "default", () => $c660d2f4fefd29b8$export$2e2bcd8739ae039);
var $c660d2f4fefd29b8$export$2e2bcd8739ae039 = {
    "city.Sunrise": {
        checkpoints: [
            {
                composables: [
                    [
                        "background.night",
                        {
                            key: "night"
                        }
                    ],
                    [
                        "background.sky",
                        {
                            key: "sky",
                            frame: "default",
                            relativeX: -0.1
                        }
                    ]
                ],
                backgroundColor: "#000010",
                timeline: {
                    defaultDuration: 45000,
                    transitions: [
                        {
                            key: "night",
                            start: 0.0,
                            end: 1.0,
                            targetFrame: "middle"
                        },
                        {
                            key: "sky",
                            start: 0.0,
                            end: 0.5,
                            targetFrame: "dawn"
                        },
                        {
                            key: "sky",
                            start: 0.5,
                            end: 1.0,
                            targetFrame: "dawn2"
                        },
                        {
                            start: 0.0,
                            end: 0.5,
                            targetBackgroundColor: "#030820"
                        },
                        {
                            start: 0.5,
                            end: 1.0,
                            targetBackgroundColor: "#0f1630"
                        }
                    ]
                }
            },
            {
                composables: [
                    [
                        "background.night",
                        {
                            key: "night",
                            frame: "middle"
                        }
                    ],
                    [
                        "background.sky",
                        {
                            key: "sky",
                            frame: "dawn2",
                            relativeX: -0.1
                        }
                    ],
                    [
                        "background.horizon",
                        {
                            key: "stripe",
                            frame: "default",
                            relativeY: 0.49,
                            relativeX: -0.1
                        }
                    ]
                ],
                entities: [
                    [
                        "Sun",
                        {
                            key: "sun",
                            state: "large",
                            relativeX: 0.9,
                            relativeY: 0.7
                        }
                    ]
                ],
                backgroundColor: "#0f1630",
                timeline: {
                    defaultDuration: 60000,
                    transitions: [
                        {
                            key: "night",
                            start: 0.0,
                            end: 1.0,
                            targetFrame: "end"
                        },
                        {
                            key: "sky",
                            start: 0.0,
                            end: 0.3,
                            targetFrame: "dawn3"
                        },
                        {
                            key: "sky",
                            start: 0.3,
                            end: 0.7,
                            targetFrame: "dawn4"
                        },
                        {
                            key: "sky",
                            start: 0.7,
                            end: 1.0,
                            targetFrame: "dawn5"
                        },
                        {
                            start: 0.0,
                            end: 0.3,
                            targetBackgroundColor: "#191f3d"
                        },
                        {
                            start: 0.3,
                            end: 0.85,
                            targetBackgroundColor: "#27273d"
                        },
                        {
                            start: 0.85,
                            end: 1.0,
                            targetBackgroundColor: "#fd7321"
                        },
                        {
                            key: "stripe",
                            start: 0.1,
                            end: 0.6,
                            path: {
                                data: [
                                    {
                                        x: 0,
                                        y: 0.49
                                    },
                                    {
                                        x: 0,
                                        y: 0.46
                                    }
                                ]
                            }
                        },
                        {
                            key: "sun",
                            start: 0.5,
                            end: 1.0,
                            path: {
                                name: "sunrise",
                                start: 0.0,
                                end: 0.2
                            }
                        }
                    ]
                }
            },
            {
                composables: [
                    [
                        "background.night",
                        {
                            key: "night",
                            frame: "end"
                        }
                    ],
                    [
                        "background.sky",
                        {
                            key: "sky",
                            frame: "dawn5",
                            relativeX: -0.1
                        }
                    ],
                    [
                        "background.horizon",
                        {
                            key: "stripe",
                            frame: "default",
                            relativeY: 0.46,
                            relativeX: -0.1
                        }
                    ]
                ],
                entities: [
                    [
                        "Sun",
                        {
                            key: "sun",
                            state: "large",
                            relativeX: 0.848,
                            relativeY: 0.42
                        }
                    ]
                ],
                backgroundColor: "#fd7321",
                timeline: {
                    defaultDuration: 150000,
                    transitions: [
                        {
                            key: "sky",
                            start: 0.0,
                            end: 0.5,
                            targetFrame: "dawn6"
                        },
                        {
                            key: "sky",
                            start: 0.5,
                            end: 1.0,
                            targetFrame: "dawn7"
                        },
                        {
                            start: 0.0,
                            end: 0.5,
                            targetBackgroundColor: "#fdab3a"
                        },
                        {
                            start: 0.5,
                            end: 1.0,
                            targetBackgroundColor: "#fcc67b"
                        },
                        {
                            start: 0.0,
                            end: 1.0,
                            key: "sun",
                            targetState: "full"
                        },
                        {
                            key: "sun",
                            start: 0.0,
                            end: 1.0,
                            path: {
                                name: "sunrise",
                                start: 0.2,
                                end: 0.4
                            }
                        },
                        {
                            key: "stripe",
                            targetFrame: "dawn",
                            start: 0.0,
                            end: 0.2,
                            path: {
                                data: [
                                    {
                                        x: 0,
                                        y: 0.46
                                    },
                                    {
                                        x: 0,
                                        y: 0.43
                                    }
                                ]
                            }
                        },
                        {
                            key: "stripe",
                            start: 0.7,
                            end: 1.0,
                            path: {
                                data: [
                                    {
                                        x: 0,
                                        y: 0.43
                                    },
                                    {
                                        x: 0,
                                        y: 0.8
                                    }
                                ]
                            }
                        },
                        {
                            key: "night",
                            start: 1.0,
                            remove: true
                        },
                        {
                            key: "stripe",
                            start: 1.0,
                            remove: true
                        }
                    ]
                }
            },
            {
                composables: [
                    [
                        "background.sky",
                        {
                            key: "sky",
                            frame: "dawn7",
                            relativeX: -0.1
                        }
                    ]
                ],
                entities: [
                    [
                        "Sun",
                        {
                            key: "sun",
                            state: "full",
                            relativeX: 0.8,
                            relativeY: 0.3
                        }
                    ]
                ],
                backgroundColor: "#fcc67b",
                timeline: {
                    defaultDuration: 120000,
                    transitions: [
                        {
                            key: "sky",
                            start: 0.0,
                            end: 0.5,
                            targetFrame: "dawn8"
                        },
                        {
                            key: "sky",
                            start: 0.5,
                            end: 1.0,
                            targetFrame: "dawn9"
                        },
                        {
                            start: 0.0,
                            end: 0.5,
                            targetBackgroundColor: "#f3d7b1"
                        },
                        {
                            start: 0.5,
                            end: 1.0,
                            targetBackgroundColor: "#babcd9"
                        },
                        {
                            start: 0.0,
                            end: 1.0,
                            key: "sun",
                            targetState: "default"
                        },
                        {
                            key: "sun",
                            start: 0.0,
                            end: 1.0,
                            path: {
                                name: "sunrise",
                                start: 0.4,
                                end: 1.0
                            }
                        }
                    ]
                }
            },
            {
                composables: [
                    [
                        "background.sky",
                        {
                            key: "sky",
                            frame: "dawn9",
                            relativeX: -0.1
                        }
                    ]
                ],
                entities: [
                    [
                        "Sun",
                        {
                            key: "sun",
                            state: "default",
                            relativeX: 0.4,
                            relativeY: 0.1
                        }
                    ]
                ],
                backgroundColor: "#babcd9",
                timeline: {
                    defaultDuration: 1000,
                    transitions: []
                }
            }
        ],
        habitat: {
            isBackground: true,
            scenery: "city.Ocean",
            scrollSpeed: {
                vx: -100,
                vy: 0
            }
        }
    }
};


var $366da04854dee200$exports = {};

$parcel$defineInteropFlag($366da04854dee200$exports);

$parcel$export($366da04854dee200$exports, "default", () => $366da04854dee200$export$2e2bcd8739ae039);
var $366da04854dee200$export$2e2bcd8739ae039 = {
    "city.Sunset": {
        checkpoints: [
            {
                composables: [
                    [
                        "background.sky",
                        {
                            key: "sky",
                            frame: "dawn9",
                            relativeX: -0.1
                        }
                    ]
                ],
                entities: [
                    [
                        "Sun",
                        {
                            key: "sun",
                            state: "default",
                            relativeX: 0.4,
                            relativeY: 0.1
                        }
                    ]
                ],
                backgroundColor: "#babcd9",
                timeline: {
                    defaultDuration: 60000,
                    transitions: [
                        {
                            key: "sky",
                            start: 0.0,
                            end: 0.5,
                            targetFrame: "dawn8"
                        },
                        {
                            key: "sky",
                            start: 0.5,
                            end: 1.0,
                            targetFrame: "dawn7"
                        },
                        {
                            start: 0.0,
                            end: 0.5,
                            targetBackgroundColor: "#f3d7b1"
                        },
                        {
                            start: 0.5,
                            end: 1.0,
                            targetBackgroundColor: "#fcc67b"
                        },
                        {
                            start: 0.0,
                            end: 1.0,
                            key: "sun",
                            targetState: "full"
                        },
                        {
                            key: "sun",
                            start: 0.0,
                            end: 1.0,
                            path: {
                                name: "sunset",
                                start: 0.0,
                                end: 0.6
                            }
                        }
                    ]
                }
            },
            {
                composables: [
                    [
                        "background.sky",
                        {
                            key: "sky",
                            frame: "dawn7",
                            relativeX: -0.1
                        }
                    ]
                ],
                entities: [
                    [
                        "Sun",
                        {
                            key: "sun",
                            state: "full",
                            relativeX: 0.8,
                            relativeY: 0.3
                        }
                    ],
                    [
                        "Moon",
                        {
                            key: "moon",
                            state: "default",
                            relativeX: 0.2,
                            relativeY: 0.7
                        }
                    ]
                ],
                backgroundColor: "#fcc67b",
                timeline: {
                    defaultDuration: 30000,
                    transitions: [
                        {
                            key: "sky",
                            start: 0.0,
                            end: 0.5,
                            targetFrame: "dawn6"
                        },
                        {
                            key: "sky",
                            start: 0.5,
                            end: 1.0,
                            targetFrame: "dawn5"
                        },
                        {
                            start: 0.0,
                            end: 0.5,
                            targetBackgroundColor: "#fdab3a"
                        },
                        {
                            start: 0.5,
                            end: 1.0,
                            targetBackgroundColor: "#fd7321"
                        },
                        {
                            start: 0.0,
                            end: 1.0,
                            key: "sun",
                            targetState: "large"
                        },
                        {
                            key: "moon",
                            start: 0.0,
                            end: 1.0,
                            path: {
                                name: "moonrise",
                                start: 0.0,
                                end: 0.25
                            }
                        },
                        {
                            key: "sun",
                            start: 0.0,
                            end: 1.0,
                            path: {
                                name: "sunset",
                                start: 0.6,
                                end: 0.75
                            }
                        }
                    ]
                }
            },
            {
                composables: [
                    [
                        "background.night",
                        {
                            key: "night",
                            frame: "end"
                        }
                    ],
                    [
                        "background.sky",
                        {
                            key: "sky",
                            frame: "dawn5",
                            relativeX: -0.1
                        }
                    ]
                ],
                entities: [
                    [
                        "Sun",
                        {
                            key: "sun",
                            state: "large",
                            relativeX: 0.848,
                            relativeY: 0.42
                        }
                    ],
                    [
                        "Moon",
                        {
                            key: "moon",
                            state: "default",
                            relativeX: 0.3,
                            relativeY: 0.4
                        }
                    ]
                ],
                backgroundColor: "#fd7321",
                timeline: {
                    defaultDuration: 30000,
                    transitions: [
                        {
                            key: "night",
                            start: 0.0,
                            end: 1.0,
                            targetFrame: "middle"
                        },
                        {
                            key: "sky",
                            start: 0.0,
                            end: 0.3,
                            targetFrame: "dawn4"
                        },
                        {
                            key: "sky",
                            start: 0.3,
                            end: 0.7,
                            targetFrame: "dawn3"
                        },
                        {
                            key: "sky",
                            start: 0.7,
                            end: 1.0,
                            targetFrame: "dawn2"
                        },
                        {
                            start: 0.0,
                            end: 0.15,
                            targetBackgroundColor: "#27273d"
                        },
                        {
                            start: 0.15,
                            end: 0.7,
                            targetBackgroundColor: "#191f3d"
                        },
                        {
                            start: 0.7,
                            end: 1.0,
                            targetBackgroundColor: "#0f1630"
                        },
                        {
                            key: "moon",
                            start: 0.0,
                            end: 1.0,
                            path: {
                                name: "moonrise",
                                start: 0.25,
                                end: 0.45
                            }
                        },
                        {
                            key: "sun",
                            start: 0.0,
                            end: 0.5,
                            path: {
                                name: "sunset",
                                start: 0.75,
                                end: 1.0
                            }
                        },
                        {
                            key: "sun",
                            start: 1.0,
                            remove: true
                        }
                    ]
                }
            },
            {
                composables: [
                    [
                        "background.night",
                        {
                            key: "night",
                            frame: "middle"
                        }
                    ],
                    [
                        "background.sky",
                        {
                            key: "sky",
                            frame: "dawn2",
                            relativeX: -0.1
                        }
                    ]
                ],
                entities: [
                    [
                        "Moon",
                        {
                            key: "moon",
                            state: "default",
                            relativeX: 0.2,
                            relativeY: 0.4
                        }
                    ]
                ],
                backgroundColor: "#0f1630",
                timeline: {
                    defaultDuration: 30000,
                    transitions: [
                        {
                            key: "night",
                            start: 0.0,
                            end: 1.0,
                            targetFrame: "default"
                        },
                        {
                            key: "sky",
                            start: 0.0,
                            end: 0.5,
                            targetFrame: "dawn"
                        },
                        {
                            key: "sky",
                            start: 0.5,
                            end: 1.0,
                            targetFrame: "default"
                        },
                        {
                            start: 0.0,
                            end: 0.5,
                            targetBackgroundColor: "#030820"
                        },
                        {
                            start: 0.5,
                            end: 1.0,
                            targetBackgroundColor: "#000010"
                        },
                        {
                            key: "moon",
                            start: 0.0,
                            end: 1.0,
                            targetFrame: "large",
                            path: {
                                name: "moonrise",
                                start: 0.45,
                                end: 1.0
                            }
                        }
                    ]
                }
            },
            {
                composables: [
                    [
                        "background.night",
                        {
                            key: "night"
                        }
                    ],
                    [
                        "background.sky",
                        {
                            key: "sky",
                            frame: "default",
                            relativeX: -0.1
                        }
                    ]
                ],
                entities: [
                    [
                        "Moon",
                        {
                            key: "moon",
                            state: "large",
                            relativeX: 0.3,
                            relativeY: 0.2
                        }
                    ]
                ],
                backgroundColor: "#000010",
                timeline: {
                    defaultDuration: 1000,
                    transitions: []
                }
            }
        ],
        habitat: {
            isBackground: true,
            scenery: "town.RoofTops",
            scrollSpeed: {
                vx: -100,
                vy: 0
            }
        }
    }
};


var $a37c879b01551c60$exports = {};

$parcel$defineInteropFlag($a37c879b01551c60$exports);

$parcel$export($a37c879b01551c60$exports, "default", () => $a37c879b01551c60$export$2e2bcd8739ae039);
var $a37c879b01551c60$export$2e2bcd8739ae039 = {
    "city.Bridge": {
        checkpoints: [
            {
                particles: [
                    [
                        "dust.bridge",
                        {
                            key: "dust"
                        }
                    ]
                ],
                timeline: {
                    defaultDuration: 1000,
                    transitions: [
                        {
                            key: "dust",
                            start: 0.9,
                            end: 1.0,
                            remove: true
                        }
                    ]
                }
            },
            {
                entities: [
                    [
                        "BridgeCeiling",
                        {
                            key: "ceiling"
                        }
                    ],
                    [
                        "BridgeFrontDeck",
                        {
                            key: "front"
                        }
                    ],
                    [
                        "BridgeCeilingBackground",
                        {
                            key: "back"
                        }
                    ],
                    [
                        "PillarRight",
                        {
                            key: "pillarRight"
                        }
                    ],
                    [
                        "PillarLeft",
                        {
                            key: "pillarLeft"
                        }
                    ]
                ],
                timeline: {
                    defaultDuration: 500,
                    transitions: [
                        {
                            key: "back",
                            start: 0.3,
                            end: 1.0,
                            targetFrame: "damaged",
                            path: {
                                data: [
                                    {
                                        x: -0.1,
                                        y: 0.3
                                    },
                                    {
                                        x: -0.1,
                                        y: 0.29
                                    }
                                ]
                            }
                        },
                        {
                            key: "pillarRight",
                            start: 0.2,
                            end: 1.0,
                            targetFrame: "rotateSmall"
                        },
                        {
                            key: "pillarLeft",
                            start: 0.2,
                            end: 1.0,
                            targetFrame: "rotateSmall"
                        },
                        {
                            key: "front",
                            start: 0.7,
                            end: 1.0,
                            targetFrame: "rotateSmall",
                            path: {
                                data: [
                                    {
                                        x: -0.1,
                                        y: 0.29
                                    },
                                    {
                                        x: -0.1,
                                        y: 0.3
                                    }
                                ]
                            }
                        },
                        {
                            key: "ceiling",
                            start: 0.0,
                            end: 1.0,
                            targetFrame: "rotateSmall",
                            path: {
                                data: [
                                    {
                                        x: -0.1,
                                        y: 0.3
                                    },
                                    {
                                        x: -0.1,
                                        y: 0.28
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                entities: [
                    [
                        "BridgeCeiling",
                        {
                            key: "ceiling"
                        }
                    ],
                    [
                        "BridgeFrontDeck",
                        {
                            key: "front"
                        }
                    ],
                    [
                        "BridgeCeilingBackground",
                        {
                            key: "back"
                        }
                    ],
                    [
                        "PillarRight",
                        {
                            key: "pillarRight"
                        }
                    ],
                    [
                        "PillarLeft",
                        {
                            key: "pillarLeft"
                        }
                    ]
                ],
                timeline: {
                    defaultDuration: 500,
                    transitions: [
                        {
                            key: "back",
                            start: 0.3,
                            end: 1.0,
                            targetFrame: "damaged",
                            path: {
                                data: [
                                    {
                                        x: -0.1,
                                        y: 0.3
                                    },
                                    {
                                        x: -0.1,
                                        y: 0.29
                                    }
                                ]
                            }
                        },
                        {
                            key: "pillarRight",
                            start: 0.2,
                            end: 1.0,
                            targetFrame: "rotateMedium"
                        },
                        {
                            key: "pillarLeft",
                            start: 0.2,
                            end: 1.0,
                            targetFrame: "rotateMedium"
                        },
                        {
                            key: "front",
                            start: 0.7,
                            end: 1.0,
                            targetFrame: "rotateMedium",
                            path: {
                                data: [
                                    {
                                        x: -0.1,
                                        y: 0.29
                                    },
                                    {
                                        x: -0.1,
                                        y: 0.3
                                    }
                                ]
                            }
                        },
                        {
                            key: "ceiling",
                            start: 0.0,
                            end: 1.0,
                            components: [
                                "PlayerEnemy"
                            ],
                            targetFrame: "rotateMedium",
                            path: {
                                data: [
                                    {
                                        x: -0.1,
                                        y: 0.3
                                    },
                                    {
                                        x: -0.1,
                                        y: 0.28
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                particles: [
                    [
                        "dust.bridge",
                        {
                            key: "dust"
                        }
                    ]
                ],
                entities: [
                    [
                        "BridgeCeiling",
                        {
                            key: "ceiling"
                        }
                    ],
                    [
                        "BridgeCeilingBackground",
                        {
                            key: "back"
                        }
                    ],
                    [
                        "BridgeFrontDeck",
                        {
                            key: "front"
                        }
                    ],
                    [
                        "PillarRight",
                        {
                            key: "pillarRight"
                        }
                    ],
                    [
                        "PillarLeft",
                        {
                            key: "pillarLeft"
                        }
                    ]
                ],
                timeline: {
                    defaultDuration: 6000,
                    transitions: [
                        {
                            key: "dust",
                            start: 0.7,
                            end: 1.0,
                            remove: true
                        },
                        {
                            key: "ceiling",
                            start: 0.2,
                            end: 0.6,
                            targetFrame: "rotateDown",
                            path: {
                                data: [
                                    {
                                        x: -0.1,
                                        y: 0.28
                                    },
                                    {
                                        x: -0.1,
                                        y: 1.2
                                    }
                                ]
                            }
                        },
                        {
                            key: "front",
                            start: 0.7,
                            end: 1.0,
                            path: {
                                data: [
                                    {
                                        x: -0.1,
                                        y: 0.1
                                    },
                                    {
                                        x: -0.1,
                                        y: 1.3
                                    }
                                ]
                            }
                        },
                        {
                            key: "back",
                            start: 0.0,
                            end: 0.5,
                            targetFrame: "rotateDown",
                            path: {
                                data: [
                                    {
                                        x: -0.1,
                                        y: 0.28
                                    },
                                    {
                                        x: -0.1,
                                        y: 0.9
                                    }
                                ]
                            }
                        },
                        {
                            key: "pillarLeft",
                            start: 0.7,
                            end: 1.0,
                            targetFrame: "rotateDown"
                        },
                        {
                            key: "pillarRight",
                            start: 0.4,
                            end: 1.0,
                            targetFrame: "rotateDown"
                        }
                    ]
                }
            }
        ],
        habitat: {
            scenery: "city.Bridge",
            scrollSpeed: {
                vx: 0,
                vy: 0
            },
            background: [
                "city.Sunrise",
                3
            ]
        }
    }
};


var $e6d9b3289158fdbc$exports = {};

$parcel$defineInteropFlag($e6d9b3289158fdbc$exports);

$parcel$export($e6d9b3289158fdbc$exports, "default", () => $e6d9b3289158fdbc$export$2e2bcd8739ae039);
var $e6d9b3289158fdbc$export$2e2bcd8739ae039 = {
    "title.Intro": {
        checkpoints: [
            {
                composables: [
                    [
                        "background.night",
                        {
                            key: "stars"
                        }
                    ],
                    [
                        "title.gradient",
                        {
                            key: "fadeIn"
                        }
                    ],
                    [
                        "title.jinte",
                        {
                            key: "jinte",
                            relativeX: 0.35,
                            relativeY: 0.45,
                            frame: "far"
                        }
                    ]
                ],
                backgroundColor: "#606060",
                timeline: {
                    defaultDuration: 3000,
                    transitions: [
                        {
                            key: "jinte",
                            start: 0.0,
                            end: 1.0,
                            path: {
                                data: [
                                    {
                                        x: 0.0,
                                        y: 0.8
                                    },
                                    {
                                        x: 0.1,
                                        y: 0.7
                                    },
                                    {
                                        x: -0.05,
                                        y: 0.45
                                    }
                                ]
                            }
                        },
                        {
                            key: "jinte",
                            start: 0.2,
                            end: 1.0,
                            targetFrame: "close"
                        },
                        {
                            key: "fadeIn",
                            start: 0.0,
                            end: 0.2,
                            targetFrame: "reveal"
                        }
                    ]
                }
            }
        ]
    }
};


$fe9d63158457675d$exports = {
    "intro": {
        "intro": {
            "js": $bdcc910e7d20e8d5$exports
        }
    },
    "scenery": {
        "sunrise": {
            "js": $c660d2f4fefd29b8$exports
        },
        "sunset": {
            "js": $366da04854dee200$exports
        },
        "bridge": {
            "bridge": {
                "js": $a37c879b01551c60$exports
            }
        }
    },
    "title": {
        "title": {
            "js": $e6d9b3289158fdbc$exports
        }
    }
};


var $bc92bf97bbd67eaa$exports = {};
var $ba4e91107864d203$exports = {};

$parcel$defineInteropFlag($ba4e91107864d203$exports);

$parcel$export($ba4e91107864d203$exports, "default", () => $ba4e91107864d203$export$2e2bcd8739ae039);
const $ba4e91107864d203$var$scale = 0.8;
var $ba4e91107864d203$export$2e2bcd8739ae039 = {
    "player.ship": {
        attributes: {
            width: 80 * $ba4e91107864d203$var$scale,
            height: 38 * $ba4e91107864d203$var$scale
        },
        sprites: [
            [
                "playerShip",
                {
                    flipX: true,
                    key: "main",
                    accentColor: "#ff0000",
                    w: 80 * $ba4e91107864d203$var$scale,
                    h: 50 * $ba4e91107864d203$var$scale
                }
            ]
        ],
        hitbox: [
            10 * $ba4e91107864d203$var$scale,
            14 * $ba4e91107864d203$var$scale,
            64 * $ba4e91107864d203$var$scale,
            18 * $ba4e91107864d203$var$scale,
            75 * $ba4e91107864d203$var$scale,
            38 * $ba4e91107864d203$var$scale,
            20 * $ba4e91107864d203$var$scale,
            38 * $ba4e91107864d203$var$scale
        ],
        attachHooks: [
            [
                "explosion",
                {
                    x: 26 * $ba4e91107864d203$var$scale,
                    y: 18 * $ba4e91107864d203$var$scale,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "mainWeapon",
                {
                    x: 48 * $ba4e91107864d203$var$scale,
                    y: 36 * $ba4e91107864d203$var$scale,
                    z: 1,
                    attachAlign: [
                        "center",
                        "right"
                    ]
                }
            ],
            [
                "laserWeapon",
                {
                    x: 48 * $ba4e91107864d203$var$scale,
                    y: 36 * $ba4e91107864d203$var$scale,
                    z: 4,
                    attachAlign: [
                        "center",
                        "right"
                    ]
                }
            ],
            [
                "laserCharge",
                {
                    x: 48 * $ba4e91107864d203$var$scale,
                    y: 36 * $ba4e91107864d203$var$scale,
                    z: 4,
                    attachAlign: [
                        "center",
                        "right"
                    ]
                }
            ],
            [
                "trail",
                {
                    x: 0 * $ba4e91107864d203$var$scale,
                    y: 22 * $ba4e91107864d203$var$scale,
                    z: 4,
                    attachAlign: [
                        "center",
                        "left"
                    ]
                }
            ],
            [
                "reverseTrail",
                {
                    x: 38 * $ba4e91107864d203$var$scale,
                    y: 42 * $ba4e91107864d203$var$scale,
                    z: 1,
                    attachAlign: [
                        "center",
                        "right"
                    ]
                }
            ],
            [
                "reverseTrail2",
                {
                    x: 38 * $ba4e91107864d203$var$scale,
                    y: 32 * $ba4e91107864d203$var$scale,
                    z: -3,
                    attachAlign: [
                        "center",
                        "right"
                    ]
                }
            ]
        ],
        frames: {
            normal: {
                main: {
                    sprite: "playerShip"
                }
            },
            turn: {
                main: {
                    sprite: "playerShipTurning"
                }
            },
            front: {
                main: {
                    sprite: "playerShipFront"
                }
            },
            damaged: {
                main: {
                    sprite: "playerShipDamaged"
                }
            },
            turnDamaged: {
                main: {
                    sprite: "playerShipDamagedTurning"
                }
            },
            hidden: {
                main: {
                    hidden: true,
                    alpha: 0
                }
            },
            turned: {
                flipX: true
            }
        },
        animations: {
            turnAround: {
                easing: "linear",
                duration: 500,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.33,
                        startFrame: "normal",
                        endFrame: "turn"
                    },
                    {
                        start: 0.33,
                        end: 0.6,
                        startFrame: "front",
                        endFrame: "front"
                    },
                    {
                        start: 0.6,
                        end: 0.66,
                        startFrame: "front",
                        endFrame: "turned"
                    },
                    {
                        start: 0.66,
                        end: 0.95,
                        startFrame: "turn",
                        endFrame: "turn"
                    },
                    {
                        start: 0.95,
                        end: 1,
                        startFrame: "turn",
                        endFrame: "normal"
                    }
                ]
            },
            turnAroundDamaged: {
                easing: "linear",
                duration: 500,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.33,
                        startFrame: "damaged",
                        endFrame: "turnDamaged"
                    },
                    {
                        start: 0.33,
                        end: 0.6,
                        startFrame: "front",
                        endFrame: "front"
                    },
                    {
                        start: 0.6,
                        end: 0.66,
                        startFrame: "front",
                        endFrame: "turned"
                    },
                    {
                        start: 0.66,
                        end: 0.95,
                        startFrame: "turnDamaged",
                        endFrame: "turnDamaged"
                    },
                    {
                        start: 0.95,
                        end: 1,
                        startFrame: "turnDamaged",
                        endFrame: "damaged"
                    }
                ]
            }
        }
    }
};


var $f5132a8f9dae1e53$exports = {};

$parcel$defineInteropFlag($f5132a8f9dae1e53$exports);

$parcel$export($f5132a8f9dae1e53$exports, "default", () => $f5132a8f9dae1e53$export$2e2bcd8739ae039);
var $f5132a8f9dae1e53$export$2e2bcd8739ae039 = {
    "portraits.pilot": {
        attributes: {
            width: 128,
            height: 128
        },
        sprites: [
            [
                "pilot1",
                {
                    key: "pilot"
                }
            ]
        ],
        frames: {
            idle: {
                pilot: {
                    sprite: "pilot1"
                }
            },
            talk: {
                pilot: {
                    sprite: "pilot2"
                }
            }
        },
        animations: {
            talking: {
                repeat: true,
                easing: "linear",
                duration: 500,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.5,
                        startFrame: "idle",
                        endFrame: "talk"
                    },
                    {
                        start: 0.5,
                        end: 1.0,
                        startFrame: "talk",
                        endFrame: "idle"
                    }
                ]
            }
        }
    },
    "portraits.general": {
        attributes: {
            width: 128,
            height: 128
        },
        sprites: [
            [
                "general2",
                {
                    key: "main"
                }
            ]
        ],
        frames: {
            idle: {
                main: {
                    sprite: "general2"
                }
            },
            talk: {
                main: {
                    sprite: "general1"
                }
            }
        },
        animations: {
            talking: {
                repeat: true,
                easing: "linear",
                duration: 500,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.5,
                        startFrame: "idle",
                        endFrame: "talk"
                    },
                    {
                        start: 0.5,
                        end: 1.0,
                        startFrame: "talk",
                        endFrame: "idle"
                    }
                ]
            }
        }
    },
    "portraits.drone": {
        attributes: {
            width: 90,
            height: 68
        },
        sprites: [
            [
                "standardLargeDrone",
                {
                    key: "portrait",
                    w: 90,
                    h: 58,
                    crop: [
                        20,
                        60,
                        50,
                        0
                    ]
                }
            ],
            [
                "sphere2",
                {
                    z: 1,
                    x: 5,
                    y: 25,
                    w: 20,
                    h: 20,
                    crop: [
                        0,
                        0,
                        17,
                        21
                    ],
                    key: "eye"
                }
            ]
        ],
        frames: {
            idle: {
                eye: {
                    x: 0,
                    y: 0,
                    alpha: 1
                }
            },
            eyeMove: {
                eye: {
                    x: 24,
                    y: -16,
                    alpha: 0.6
                }
            },
            eyeDisappear: {
                eye: {
                    x: 24,
                    y: -16,
                    alpha: 0.0
                }
            },
            eyeReset: {
                eye: {
                    x: 0,
                    y: 0,
                    alpha: 0.0
                }
            },
            eyeAppear: {
                eye: {
                    x: 0,
                    y: 0,
                    alpha: 1.0
                }
            }
        },
        animations: {
            talking: {
                repeat: true,
                easing: "linear",
                duration: 800,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.7,
                        startFrame: "eyeAppear",
                        endFrame: "eyeMove"
                    },
                    {
                        start: 0.7,
                        end: 0.8,
                        startFrame: "eyeMove",
                        endFrame: "eyeDisappear"
                    },
                    {
                        start: 0.8,
                        end: 0.9,
                        startFrame: "eyeDisappear",
                        endFrame: "eyeReset"
                    },
                    {
                        start: 0.9,
                        end: 1,
                        startFrame: "eyeReset",
                        endFrame: "eyeAppear"
                    }
                ]
            }
        }
    }
};


var $317abb0c1da52c2a$exports = {};

$parcel$defineInteropFlag($317abb0c1da52c2a$exports);

$parcel$export($317abb0c1da52c2a$exports, "default", () => $317abb0c1da52c2a$export$2e2bcd8739ae039);
var $317abb0c1da52c2a$export$2e2bcd8739ae039 = {
    cloth: {
        attributes: {
            width: 128,
            height: 96
        },
        sprites: [
            [
                "clothBottom",
                {
                    x: 0,
                    y: 69
                }
            ],
            [
                "cloth",
                {
                    x: 0,
                    y: 0,
                    z: 4,
                    hideBelow: 88,
                    key: "cloth"
                }
            ]
        ],
        frames: {
            up: {
                cloth: {
                    y: 0
                }
            },
            medium: {
                cloth: {
                    y: 10
                }
            },
            down: {
                cloth: {
                    y: 100
                }
            }
        }
    }
};


var $70cac90371b91d75$exports = {};

$parcel$defineInteropFlag($70cac90371b91d75$exports);

$parcel$export($70cac90371b91d75$exports, "default", () => $70cac90371b91d75$export$2e2bcd8739ae039);
var $70cac90371b91d75$export$2e2bcd8739ae039 = {
    shipHatch: {
        attributes: {
            width: 128,
            height: 32
        },
        sprites: [
            [
                "aircraftCarrierOpenHatch",
                {
                    y: -4,
                    x: 0
                }
            ],
            [
                "aircraftCarrierHatchLid",
                {
                    y: -2,
                    x: 0,
                    key: "lid",
                    crop: [
                        2,
                        0,
                        0,
                        0
                    ],
                    z: 1
                }
            ],
            [
                "aircraftCarrierWires",
                {
                    x: 68,
                    y: -20,
                    z: -1
                }
            ],
            [
                "aircraftCarrierHatchLid",
                {
                    x: 3,
                    y: 80,
                    z: 1,
                    key: "floor",
                    crop: [
                        18,
                        3,
                        0,
                        0
                    ],
                    hideBelow: 28
                }
            ]
        ],
        attachHooks: [
            [
                "payload",
                {
                    x: 64,
                    y: 86,
                    z: 6,
                    attachAlign: [
                        "bottom",
                        "center"
                    ],
                    attachTo: "floor"
                }
            ]
        ],
        frames: {
            open: {
                lid: {
                    x: -30,
                    y: 16
                },
                floor: {
                    x: 0,
                    y: 0
                }
            },
            closed: {
                lid: {
                    x: 0,
                    y: 0
                },
                floor: {
                    x: 0,
                    y: 0
                }
            },
            risen: {
                lid: {
                    x: -30,
                    y: 16
                },
                floor: {
                    y: -65
                }
            }
        }
    }
};


var $1b63d9d25a7c6dbd$exports = {};

$parcel$defineInteropFlag($1b63d9d25a7c6dbd$exports);

$parcel$export($1b63d9d25a7c6dbd$exports, "default", () => $1b63d9d25a7c6dbd$export$2e2bcd8739ae039);
var $1b63d9d25a7c6dbd$export$2e2bcd8739ae039 = {
    "weapons.bullet": {
        attributes: {
            width: 26,
            height: 16,
            ro: [
                4,
                8
            ]
        },
        hitbox: [
            2,
            3,
            14,
            3,
            14,
            12,
            2,
            12
        ],
        sprites: [
            [
                "sphere1",
                {
                    z: -2,
                    crop: [
                        17,
                        6,
                        0,
                        0
                    ],
                    flipX: true
                }
            ]
        ]
    },
    "weapons.lightBullet": {
        attributes: {
            width: 32,
            height: 32,
            ro: [
                4,
                14
            ]
        },
        hitbox: [
            2,
            12,
            28,
            12,
            28,
            18,
            2,
            18
        ],
        sprites: [
            [
                "lightBullet",
                {
                    z: -2
                }
            ]
        ]
    },
    "weapons.laser": {
        attributes: {
            width: 20,
            height: 5,
            ro: [
                2,
                3
            ]
        },
        sprites: [
            [
                "lightBullet",
                {
                    alpha: 1,
                    x: 0,
                    y: -7,
                    h: 20,
                    w: 5,
                    z: -2,
                    stretch: [
                        0,
                        0,
                        0,
                        0
                    ],
                    crop: [
                        0,
                        15,
                        0,
                        0
                    ],
                    key: "beam1"
                }
            ],
            [
                "lightBullet",
                {
                    alpha: 1,
                    x: 5,
                    y: -7,
                    h: 20,
                    w: 10,
                    z: -2,
                    stretch: [
                        0,
                        1,
                        0,
                        0
                    ],
                    crop: [
                        0,
                        15,
                        0,
                        15
                    ],
                    key: "beam2"
                }
            ],
            [
                "lightBullet",
                {
                    alpha: 1,
                    x: 15,
                    y: -7,
                    h: 20,
                    w: 5,
                    z: -2,
                    stretch: [
                        0,
                        1,
                        0,
                        1
                    ],
                    crop: [
                        0,
                        0,
                        0,
                        15
                    ],
                    key: "beam3"
                }
            ]
        ],
        frames: {
            short: {
                attributes: {
                    w: 200
                }
            },
            reset: {
                beam1: {
                    alpha: 1
                },
                beam2: {
                    alpha: 1
                },
                beam3: {
                    alpha: 1
                }
            },
            disappear: {
                beam1: {
                    alpha: 0
                },
                beam2: {
                    alpha: 0
                },
                beam3: {
                    alpha: 0
                }
            },
            long: {
                attributes: {
                    w: 500
                }
            },
            rotate: {
                attributes: {
                    rotation: 10
                }
            },
            rotate2: {
                attributes: {
                    rotation: -50
                }
            },
            flipped: {
                flipX: true
            }
        }
    },
    "player.bullet": {
        attributes: {
            width: 52,
            height: 8,
            ro: [
                4,
                4
            ]
        },
        hitbox: [
            2,
            3,
            14,
            3,
            14,
            12,
            2,
            12
        ],
        sprites: [
            [
                "sphere1",
                {
                    z: -2,
                    crop: [
                        17,
                        6,
                        0,
                        0
                    ],
                    flipX: true,
                    w: 52,
                    h: 8,
                    overrideColor: "#ff8080"
                }
            ]
        ]
    },
    "weapons.sphere": {
        attributes: {
            width: 16,
            height: 16,
            ro: [
                8,
                8
            ]
        },
        sprites: [
            [
                "sphere1",
                {
                    z: -2,
                    crop: [
                        0,
                        17,
                        17,
                        0
                    ],
                    key: "main"
                }
            ]
        ],
        animations: {
            default: {
                repeat: true,
                duration: 300,
                timeline: [
                    {
                        start: 0.0,
                        end: 1.0,
                        spriteAnimation: {
                            key: "main",
                            sprites: [
                                "sphere1",
                                "sphere2"
                            ]
                        }
                    }
                ]
            }
        }
    },
    "weapons.rocket": {
        attributes: {
            width: 47,
            height: 16,
            ro: [
                4,
                8
            ],
            scale: 1
        },
        hitbox: [
            2,
            3,
            45,
            3,
            45,
            12,
            2,
            12
        ],
        sprites: [
            [
                "standardRocket",
                {
                    z: 1,
                    key: "main"
                }
            ]
        ],
        attachHooks: [
            [
                "trail",
                {
                    x: 47,
                    y: 8,
                    z: -1,
                    attachAlign: [
                        "center",
                        "left"
                    ]
                }
            ],
            [
                "tip",
                {
                    x: 0,
                    y: 8,
                    z: 1,
                    attachAlign: [
                        "center",
                        "left"
                    ]
                }
            ]
        ],
        frames: {
            hidden: {
                main: {
                    hidden: true,
                    alpha: 0
                }
            },
            small: {
                attributes: {
                    scale: 0.8
                }
            }
        }
    },
    "weapons.explosion": {
        attributes: {
            width: 96,
            height: 96,
            ro: [
                48,
                48
            ]
        },
        sprites: [
            [
                "explosion1",
                {
                    scale: 1,
                    x: 0,
                    y: 0,
                    key: "main"
                }
            ]
        ],
        animations: {
            default: {
                duration: 350,
                timeline: [
                    {
                        start: 0.0,
                        end: 1.0,
                        spriteAnimation: {
                            key: "main",
                            sprites: [
                                "explosion1",
                                "explosion2",
                                "explosion3",
                                "explosion4",
                                "explosion5",
                                "explosion6",
                                "explosion7",
                                "explosion8",
                                "explosion9",
                                "explosion10",
                                "explosion11",
                                "explosion12",
                                "explosion13",
                                "explosion14",
                                "explosion15",
                                "explosion16",
                                "explosion17",
                                "explosion18",
                                "explosion19",
                                "explosion20"
                            ]
                        }
                    }
                ]
            }
        }
    },
    "weapons.largeExplosion": {
        attributes: {
            width: 96,
            height: 96,
            scale: 1.75,
            ro: [
                84,
                84
            ]
        },
        sprites: [
            [
                "explosion1",
                {
                    scale: 1,
                    x: 0,
                    y: 0,
                    key: "main"
                }
            ]
        ],
        animations: {
            default: {
                duration: 350,
                timeline: [
                    {
                        start: 0.0,
                        end: 1.0,
                        spriteAnimation: {
                            key: "main",
                            sprites: [
                                "explosion1",
                                "explosion2",
                                "explosion3",
                                "explosion4",
                                "explosion5",
                                "explosion6",
                                "explosion7",
                                "explosion8",
                                "explosion9",
                                "explosion10",
                                "explosion11",
                                "explosion12",
                                "explosion13",
                                "explosion14",
                                "explosion15",
                                "explosion16",
                                "explosion17",
                                "explosion18",
                                "explosion19",
                                "explosion20"
                            ]
                        }
                    }
                ]
            }
        }
    },
    "weapons.solidHit": {
        attributes: {
            width: 8,
            height: 8
        },
        sprites: [
            [
                "explosion1",
                {
                    scale: 0.25,
                    x: -45,
                    y: -45,
                    key: "main"
                }
            ]
        ],
        animations: {
            default: {
                duration: 100,
                timeline: [
                    {
                        start: 0.0,
                        end: 1.0,
                        spriteAnimation: {
                            key: "main",
                            sprites: [
                                "explosion1",
                                "explosion3",
                                "explosion5",
                                "explosion7",
                                "explosion9",
                                "explosion11",
                                "explosion13",
                                "explosion15",
                                "explosion17"
                            ]
                        }
                    }
                ]
            }
        }
    },
    "weapons.waterHit": {
        attributes: {
            width: 8,
            height: 8
        },
        sprites: [
            [
                "explosion5",
                {
                    scaleX: 0.25,
                    scaleY: 0.25,
                    x: -45,
                    y: -45,
                    overrideColor: "#ffffff",
                    key: "main"
                }
            ]
        ],
        frames: {
            high: {
                main: {
                    scaleX: 0.25,
                    scaleY: 0.75,
                    y: -27
                }
            },
            end: {
                main: {
                    scaleX: 0.25,
                    scaleY: 0.25,
                    y: -45,
                    alpha: 0
                }
            }
        },
        animations: {
            default: {
                duration: 300,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.3,
                        startFrame: "default",
                        endFrame: "high"
                    },
                    {
                        start: 0.6,
                        end: 1.0,
                        startFrame: "high",
                        endFrame: "end"
                    }
                ]
            }
        }
    },
    "weapons.muzzleFlash": {
        attributes: {
            width: 32,
            height: 32,
            ro: [
                28,
                16
            ]
        },
        sprites: [
            [
                "muzzleFlash",
                {
                    z: 20,
                    flipX: true,
                    key: "flash"
                }
            ]
        ],
        frames: {
            normal: {
                flash: {
                    alpha: 1.0
                }
            },
            end: {
                flash: {
                    alpha: 0
                }
            }
        },
        animations: {
            default: {
                repeat: false,
                easing: "linear",
                duration: 300,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.3,
                        startFrame: "end",
                        endFrame: "normal"
                    },
                    {
                        start: 0.7,
                        end: 1.0,
                        startFrame: "normal",
                        endFrame: "end"
                    }
                ]
            }
        }
    }
};


var $6fe7ba75bdbfb6ac$exports = {};

$parcel$defineInteropFlag($6fe7ba75bdbfb6ac$exports);

$parcel$export($6fe7ba75bdbfb6ac$exports, "default", () => $6fe7ba75bdbfb6ac$export$2e2bcd8739ae039);
var $6fe7ba75bdbfb6ac$export$2e2bcd8739ae039 = {
    "powerups.life": {
        attributes: {
            width: 32,
            height: 32
        },
        sprites: [
            [
                "powerUpBox",
                {
                    key: "main",
                    accentColor: "#900000"
                }
            ],
            [
                "heart",
                {
                    z: 1,
                    scale: 0.7,
                    accentColor: "#ff9999",
                    key: "symbol"
                }
            ],
            [
                "bigGlare",
                {
                    z: -1,
                    scale: 0.15,
                    x: -84,
                    y: -84,
                    crop: [
                        0,
                        24,
                        24,
                        0
                    ],
                    overrideColor: "#ff9999",
                    alpha: 0.4,
                    key: "glow"
                }
            ]
        ],
        hitbox: [
            0,
            0,
            32,
            0,
            32,
            32,
            0,
            32
        ],
        attachHooks: [
            [
                "explosion",
                {
                    x: 16,
                    y: 16,
                    z: -2,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ]
        ],
        frames: {
            startGlow: {
                glow: {
                    alpha: 0.4,
                    scale: 0.15
                }
            },
            endGlow: {
                glow: {
                    alpha: 0.0,
                    scale: 0.4
                }
            },
            pickedUp: {
                glow: {
                    alpha: 0.0,
                    scale: 0.4
                },
                main: {
                    alpha: 0.0
                },
                symbol: {
                    alpha: 0.0,
                    scale: 1.2
                }
            },
            disappear: {
                glow: {
                    alpha: 0.0
                },
                main: {
                    alpha: 0.0,
                    scale: 0.2
                },
                symbol: {
                    alpha: 0.0,
                    scale: 0.2
                }
            }
        },
        animations: {
            default: {
                duration: 2000,
                repeat: true,
                timeline: [
                    {
                        start: 0.0,
                        end: 1.0,
                        spriteAnimation: {
                            key: "main",
                            sprites: [
                                "powerUpBox",
                                "powerUpBox2",
                                "powerUpBox3",
                                "powerUpBox2"
                            ]
                        }
                    },
                    {
                        start: 0.0,
                        end: 1.0,
                        startFrame: "startGlow",
                        endFrame: "endGlow"
                    }
                ]
            }
        }
    },
    "powerups.bonus": {
        attributes: {
            width: 32,
            height: 32
        },
        sprites: [
            [
                "powerUpBox",
                {
                    key: "main",
                    accentColor: "#a67c00"
                }
            ],
            [
                "star",
                {
                    z: 1,
                    scale: 0.7,
                    accentColor: "#ffdc73",
                    key: "symbol"
                }
            ],
            [
                "bigGlare",
                {
                    z: -1,
                    scale: 0.15,
                    x: -84,
                    y: -84,
                    crop: [
                        0,
                        24,
                        24,
                        0
                    ],
                    overrideColor: "#ffdc73",
                    alpha: 0.4,
                    key: "glow"
                }
            ]
        ],
        hitbox: [
            0,
            0,
            32,
            0,
            32,
            32,
            0,
            32
        ],
        attachHooks: [
            [
                "explosion",
                {
                    x: 16,
                    y: 16,
                    z: -2,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ]
        ],
        frames: {
            startGlow: {
                glow: {
                    alpha: 0.4,
                    scale: 0.15
                }
            },
            endGlow: {
                glow: {
                    alpha: 0.0,
                    scale: 0.4
                }
            },
            pickedUp: {
                glow: {
                    alpha: 0.0,
                    scale: 0.4
                },
                main: {
                    alpha: 0.0
                },
                symbol: {
                    alpha: 0.0,
                    scale: 1.2
                }
            },
            disappear: {
                glow: {
                    alpha: 0.0
                },
                main: {
                    alpha: 0.0,
                    scale: 0.2
                },
                symbol: {
                    alpha: 0.0,
                    scale: 0.2
                }
            }
        },
        animations: {
            default: {
                duration: 2000,
                repeat: true,
                timeline: [
                    {
                        start: 0.0,
                        end: 1.0,
                        spriteAnimation: {
                            key: "main",
                            sprites: [
                                "powerUpBox",
                                "powerUpBox2",
                                "powerUpBox3",
                                "powerUpBox2"
                            ]
                        }
                    },
                    {
                        start: 0.0,
                        end: 1.0,
                        startFrame: "startGlow",
                        endFrame: "endGlow"
                    }
                ]
            }
        }
    },
    "powerups.upgrade": {
        attributes: {
            width: 32,
            height: 32
        },
        sprites: [
            [
                "powerUpBox",
                {
                    key: "main",
                    accentColor: "#009000"
                }
            ],
            [
                "upgrade",
                {
                    z: 1,
                    scale: 0.7,
                    accentColor: "#99ff99",
                    key: "symbol"
                }
            ],
            [
                "bigGlare",
                {
                    z: -1,
                    scale: 0.15,
                    x: -84,
                    y: -84,
                    crop: [
                        0,
                        24,
                        24,
                        0
                    ],
                    overrideColor: "#99ff99",
                    alpha: 0.4,
                    key: "glow"
                }
            ]
        ],
        hitbox: [
            0,
            0,
            32,
            0,
            32,
            32,
            0,
            32
        ],
        attachHooks: [
            [
                "explosion",
                {
                    x: 16,
                    y: 16,
                    z: -2,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ]
        ],
        frames: {
            startGlow: {
                glow: {
                    alpha: 0.4,
                    scale: 0.15
                }
            },
            endGlow: {
                glow: {
                    alpha: 0.0,
                    scale: 0.4
                }
            },
            pickedUp: {
                glow: {
                    alpha: 0.0,
                    scale: 0.4
                },
                main: {
                    alpha: 0.0
                },
                symbol: {
                    alpha: 0.0,
                    scale: 1.2
                }
            },
            disappear: {
                glow: {
                    alpha: 0.0
                },
                main: {
                    alpha: 0.0,
                    scale: 0.2
                },
                symbol: {
                    alpha: 0.0,
                    scale: 0.2
                }
            }
        },
        animations: {
            default: {
                duration: 2000,
                repeat: true,
                timeline: [
                    {
                        start: 0.0,
                        end: 1.0,
                        spriteAnimation: {
                            key: "main",
                            sprites: [
                                "powerUpBox",
                                "powerUpBox2",
                                "powerUpBox3",
                                "powerUpBox2"
                            ]
                        }
                    },
                    {
                        start: 0.0,
                        end: 1.0,
                        startFrame: "startGlow",
                        endFrame: "endGlow"
                    }
                ]
            }
        }
    }
};


var $ab4dabc059bdc9d0$exports = {};

$parcel$defineInteropFlag($ab4dabc059bdc9d0$exports);

$parcel$export($ab4dabc059bdc9d0$exports, "default", () => $ab4dabc059bdc9d0$export$2e2bcd8739ae039);
var $ab4dabc059bdc9d0$export$2e2bcd8739ae039 = {
    "intro.ship": {
        attributes: {
            width: 800,
            height: 108
        },
        sprites: [
            [
                "aircraftCarrierBottomFlat",
                {
                    x: -64,
                    y: 10
                }
            ],
            [
                "aircraftCarrierBottomSpace",
                {
                    x: 64,
                    y: 10
                }
            ],
            [
                "aircraftCarrierBottomFlat",
                {
                    x: 192,
                    y: 10
                }
            ],
            [
                "aircraftCarrierBottomFlat",
                {
                    x: 320,
                    y: 10
                }
            ],
            [
                "aircraftCarrierBottomFlat",
                {
                    x: 448,
                    y: 10
                }
            ],
            [
                "aircraftCarrierBottomFlat",
                {
                    x: 576,
                    y: 10
                }
            ],
            [
                "aircraftCarrierEnd",
                {
                    x: 704,
                    y: -54
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: -64,
                    y: -54
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 64,
                    y: -54
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 192,
                    y: -54
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 320,
                    y: -54
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 448,
                    y: -54
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 576,
                    y: -54
                }
            ],
            [
                "boxes",
                {
                    x: 622,
                    y: -64,
                    z: 5
                }
            ],
            [
                "aircraftCarrierCabinStart",
                {
                    x: 96,
                    y: -178,
                    z: 6
                }
            ],
            [
                "aircraftCarrierCabinRadar",
                {
                    x: 128,
                    y: -178,
                    z: 6
                }
            ],
            [
                "aircraftCarrierCabin",
                {
                    x: 192,
                    y: -178,
                    z: 6
                }
            ],
            [
                "aircraftCarrierCabinRadar",
                {
                    x: 256,
                    y: -178,
                    z: 6
                }
            ],
            [
                "aircraftCarrierCabin",
                {
                    x: 320,
                    y: -178,
                    z: 6
                }
            ],
            [
                "aircraftCarrierCabinEnd",
                {
                    x: 384,
                    y: -178,
                    z: 6
                }
            ],
            [
                "aircraftCarrierRadar",
                {
                    x: 232,
                    y: -185,
                    z: 6
                }
            ],
            [
                "aircraftCarrierAntenna",
                {
                    x: 316,
                    y: -227,
                    z: 6
                }
            ],
            [
                "aircraftCarrierAntenna",
                {
                    x: 158,
                    y: -227,
                    z: 6
                }
            ],
            [
                "aircraftCarrier7",
                {
                    x: 192,
                    y: -116,
                    z: 6
                }
            ],
            [
                "aircraftCarrier7",
                {
                    x: 320,
                    y: -116,
                    z: 6
                }
            ]
        ],
        attachHooks: [
            [
                "boxLocation1",
                {
                    x: 650,
                    y: -10,
                    z: 23
                }
            ],
            [
                "boxLocation2",
                {
                    x: 714,
                    y: -16,
                    z: 23
                }
            ],
            [
                "hatch1",
                {
                    x: 220,
                    y: -20,
                    z: 2,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ],
            [
                "heliStart",
                {
                    x: 612,
                    y: -20,
                    z: 6,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "hatch2",
                {
                    x: 412,
                    y: -20,
                    z: 2,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ],
            [
                "bottom",
                {
                    x: -64,
                    y: 70,
                    z: 21,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ]
        ]
    },
    "intro.boxes": {
        attributes: {
            width: 32,
            height: 32
        },
        hitbox: [
            0,
            7,
            32,
            7,
            32,
            32,
            0,
            32
        ],
        sprites: [
            [
                "boxes",
                {
                    x: 0,
                    y: 0,
                    key: "main"
                }
            ]
        ],
        frames: {
            falling: {
                main: {
                    sprite: "boxesFalling"
                }
            }
        }
    },
    "intro.parachute": {
        attributes: {
            width: 32,
            height: 32,
            rotation: 0,
            ro: [
                14,
                2
            ]
        },
        sprites: [
            [
                "chute",
                {
                    x: 0,
                    y: 0,
                    horizon: [
                        0.6,
                        0.6
                    ]
                }
            ]
        ],
        frames: {
            left: {
                attributes: {
                    rotation: 20
                }
            },
            right: {
                attributes: {
                    rotation: -20
                }
            }
        },
        animations: {
            default: {
                repeat: true,
                easing: "linear",
                duration: 5000,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.5,
                        startFrame: "left",
                        endFrame: "right"
                    },
                    {
                        start: 0.5,
                        end: 1,
                        startFrame: "right",
                        endFrame: "left"
                    }
                ]
            }
        }
    }
};


var $c68cf0c65316759e$exports = {};

$parcel$defineInteropFlag($c68cf0c65316759e$exports);

$parcel$export($c68cf0c65316759e$exports, "default", () => $c68cf0c65316759e$export$2e2bcd8739ae039);
var $c68cf0c65316759e$export$2e2bcd8739ae039 = {
    "city.horizon": {
        attributes: {
            width: 256,
            height: 160
        },
        sprites: [
            [
                "coast",
                {
                    z: -598,
                    horizon: [
                        0.9,
                        0.8
                    ]
                }
            ]
        ]
    },
    "city.cloud": {
        attributes: {
            width: 256,
            height: 960
        },
        sprites: [
            [
                "cloud",
                {
                    z: -398,
                    horizon: [
                        0.95,
                        0.9
                    ],
                    alpha: 0.9,
                    scale: 0.5,
                    key: "main"
                }
            ]
        ],
        frames: {
            close: {
                main: {
                    scale: 0.8,
                    horizon: [
                        0.85,
                        0.85
                    ]
                }
            }
        }
    },
    "city.horizonStart": {
        attributes: {
            width: 256,
            height: 160
        },
        sprites: [
            [
                "coastStart",
                {
                    z: -598,
                    horizon: [
                        0.9,
                        0.8
                    ]
                }
            ]
        ],
        frames: {
            flipped: {
                flipX: true
            }
        }
    },
    "city.cityStart": {
        attributes: {
            width: 512,
            height: 288
        },
        sprites: [
            [
                "cityStart",
                {
                    z: -305,
                    horizon: [
                        0.4,
                        0.4
                    ]
                }
            ]
        ],
        frames: {
            flipped: {
                flipX: true
            }
        }
    },
    "city.city": {
        attributes: {
            width: 512,
            height: 288
        },
        sprites: [
            [
                "city",
                {
                    z: -305,
                    horizon: [
                        0.4,
                        0.4
                    ]
                }
            ]
        ]
    },
    "city.cityDistance": {
        attributes: {
            width: 256,
            height: 224
        },
        sprites: [
            [
                "cityDistance",
                {
                    z: -598,
                    horizon: [
                        0.9,
                        0.7
                    ]
                }
            ]
        ]
    },
    "city.layer2": {
        attributes: {
            width: 384,
            height: 256
        },
        hitbox: [
            240,
            120,
            240,
            0,
            295,
            0,
            295,
            120
        ],
        sprites: [
            [
                "cityLayer2",
                {
                    z: -505,
                    horizon: [
                        0.6,
                        0.6
                    ]
                }
            ],
            [
                "cityLayer2",
                {
                    z: -505,
                    y: 256,
                    h: 80,
                    crop: [
                        254,
                        0,
                        0,
                        0
                    ],
                    horizon: [
                        0.6,
                        0.6
                    ]
                }
            ]
        ]
    },
    explosion: {
        attributes: {
            width: 96,
            height: 96
        },
        sprites: [
            [
                "explosion1",
                {
                    key: "main"
                }
            ]
        ],
        animations: {
            default: {
                duration: 350,
                timeline: [
                    {
                        start: 0.0,
                        end: 1.0,
                        spriteAnimation: {
                            key: "main",
                            sprites: [
                                "explosion1",
                                "explosion2",
                                "explosion3",
                                "explosion4",
                                "explosion5",
                                "explosion6",
                                "explosion7",
                                "explosion8",
                                "explosion9",
                                "explosion10",
                                "explosion11",
                                "explosion12",
                                "explosion13",
                                "explosion14",
                                "explosion15",
                                "explosion16",
                                "explosion17",
                                "explosion18",
                                "explosion19",
                                "explosion20"
                            ]
                        }
                    }
                ]
            }
        }
    }
};


var $e57fbf288493eb94$exports = {};

$parcel$defineInteropFlag($e57fbf288493eb94$exports);

$parcel$export($e57fbf288493eb94$exports, "default", () => $e57fbf288493eb94$export$2e2bcd8739ae039);
var $e57fbf288493eb94$export$2e2bcd8739ae039 = {
    "ocean.front": {
        attributes: {
            width: 1024,
            height: 96
        },
        sprites: [
            [
                "waterFront1",
                {
                    z: -20,
                    key: "left",
                    horizon: [
                        0.4,
                        0.0
                    ]
                }
            ],
            [
                "waterFront2",
                {
                    x: 512,
                    z: -20,
                    key: "right",
                    horizon: [
                        0.4,
                        0.0
                    ]
                }
            ]
        ],
        frames: {
            waveR: {
                left: {
                    scaleX: 1.125,
                    x: 32,
                    scaleY: 0.95,
                    y: 5
                },
                right: {
                    scaleX: 0.875,
                    x: 32,
                    scaleY: 0.95,
                    y: 5
                }
            },
            waveL: {
                left: {
                    scaleX: 0.875,
                    x: -32,
                    scaleY: 1.05,
                    y: -5
                },
                right: {
                    scaleX: 1.125,
                    x: -32,
                    scaleY: 1.05,
                    y: -5
                }
            }
        },
        animations: {
            default: {
                repeat: true,
                easing: "linear",
                duration: 20000,
                timer: "global",
                timeline: [
                    {
                        start: 0.0,
                        end: 0.2,
                        startFrame: "default",
                        endFrame: "waveL"
                    },
                    {
                        start: 0.2,
                        end: 0.5,
                        startFrame: "waveL",
                        endFrame: "default"
                    },
                    {
                        start: 0.5,
                        end: 0.8,
                        startFrame: "default",
                        endFrame: "waveR"
                    },
                    {
                        start: 0.8,
                        end: 1,
                        startFrame: "waveR",
                        endFrame: "default"
                    }
                ]
            }
        }
    },
    "ocean.middle": {
        attributes: {
            width: 512,
            height: 192
        },
        sprites: [
            [
                "waterMiddle",
                {
                    z: -500,
                    w: 513,
                    key: "middle",
                    horizon: [
                        0.8,
                        0.1
                    ]
                }
            ]
        ],
        frames: {
            wave: {
                middle: {
                    y: 4
                }
            }
        },
        animations: {
            default: {
                repeat: true,
                easing: "linear",
                duration: 10000,
                timer: "global",
                timeline: [
                    {
                        start: 0.0,
                        end: 0.5,
                        startFrame: "default",
                        endFrame: "wave"
                    },
                    {
                        start: 0.5,
                        end: 1.0,
                        startFrame: "wave",
                        endFrame: "default"
                    }
                ]
            }
        }
    },
    "ocean.horizon": {
        attributes: {
            width: 260,
            height: 160
        },
        sprites: [
            [
                "waterHorizon",
                {
                    z: -600,
                    w: 260,
                    horizon: [
                        1.0,
                        0.4
                    ]
                }
            ]
        ]
    }
};


var $e287e11099e02ed2$exports = {};

$parcel$defineInteropFlag($e287e11099e02ed2$exports);

$parcel$export($e287e11099e02ed2$exports, "default", () => $e287e11099e02ed2$export$2e2bcd8739ae039);
var $e287e11099e02ed2$export$2e2bcd8739ae039 = {
    "background.night": {
        attributes: {
            width: 1024,
            height: 576
        },
        sprites: [
            [
                "stars",
                {
                    z: 0,
                    y: -100,
                    w: 672,
                    h: 288,
                    key: "topleft",
                    ro: [
                        672,
                        288
                    ]
                }
            ],
            [
                "stars",
                {
                    z: 0,
                    w: 672,
                    h: 288,
                    x: 672,
                    y: -100,
                    key: "topright",
                    attachTo: "topleft"
                }
            ],
            [
                "stars",
                {
                    z: 0,
                    w: 672,
                    h: 288,
                    x: 0,
                    y: 188,
                    key: "bottomleft",
                    attachTo: "topleft"
                }
            ],
            [
                "stars",
                {
                    z: 0,
                    w: 672,
                    h: 288,
                    x: 672,
                    y: 188,
                    key: "bottomright",
                    attachTo: "topleft"
                }
            ]
        ],
        frames: {
            middle: {
                topleft: {
                    rotation: -3
                }
            },
            end: {
                topleft: {
                    alpha: 0.5,
                    rotation: -6
                },
                topright: {
                    alpha: 0.5
                },
                bottomleft: {
                    alpha: 0.5
                },
                bottomright: {
                    alpha: 0.5
                }
            }
        }
    },
    "background.horizon": {
        attributes: {
            width: 1230,
            height: 50
        },
        gradients: [
            {
                z: 4,
                w: 1230,
                h: 50,
                key: "sky",
                topColor: [
                    "#dddd00",
                    0
                ],
                bottomColor: [
                    "#dddd00",
                    1
                ]
            }
        ],
        frames: {
            start: {
                sky: {
                    h: 50,
                    topColor: [
                        "#dddd00",
                        0.0
                    ],
                    bottomColor: [
                        "#dddd00",
                        1
                    ]
                }
            },
            dawn: {
                sky: {
                    h: 80,
                    topColor: [
                        "#dddd00",
                        0.0
                    ],
                    bottomColor: [
                        "#dddd00",
                        0.6
                    ]
                }
            }
        }
    },
    "background.sky": {
        attributes: {
            width: 1230,
            height: 576
        },
        gradients: [
            {
                z: 4,
                w: 1230,
                h: 400,
                key: "sky",
                topColor: [
                    "#000000",
                    0
                ],
                bottomColor: [
                    "#000000",
                    0
                ]
            }
        ],
        frames: {
            dawn: {
                sky: {
                    topColor: [
                        "#000020",
                        0.3
                    ],
                    bottomColor: [
                        "#213a9e",
                        0.6
                    ]
                }
            },
            dawn2: {
                sky: {
                    topColor: [
                        "#0f1630",
                        0.5
                    ],
                    bottomColor: [
                        "#5e6d9f",
                        0.8
                    ]
                }
            },
            dawn3: {
                sky: {
                    topColor: [
                        "#191f3d",
                        0.8
                    ],
                    bottomColor: [
                        "#8b8289",
                        1.0
                    ]
                }
            },
            dawn4: {
                //sky: { topColor: ["#27273d", 1.0], bottomColor: ["#cb8946", 1.0] }
                sky: {
                    topColor: [
                        "#27273d",
                        1.0
                    ],
                    bottomColor: [
                        "#a73e02",
                        1.0
                    ]
                }
            },
            dawn5: {
                sky: {
                    topColor: [
                        "#3e2d30",
                        1.0
                    ],
                    bottomColor: [
                        "#fd7321",
                        1.0
                    ]
                }
            },
            dawn6: {
                sky: {
                    topColor: [
                        "#383b65",
                        1.0
                    ],
                    bottomColor: [
                        "#fdab3a",
                        1.0
                    ]
                }
            },
            dawn7: {
                sky: {
                    topColor: [
                        "#354898",
                        1.0
                    ],
                    bottomColor: [
                        "#fcc67b",
                        1.0
                    ]
                }
            },
            dawn8: {
                sky: {
                    topColor: [
                        "#3856c1",
                        1.0
                    ],
                    bottomColor: [
                        "#f3d7b1",
                        1.0
                    ]
                }
            },
            dawn9: {
                sky: {
                    topColor: [
                        "#477cfc",
                        1.0
                    ],
                    bottomColor: [
                        "#babcd9",
                        1.0
                    ]
                }
            }
        }
    },
    "background.sun": {
        attributes: {
            width: 96,
            height: 96,
            scale: 0.8
        },
        sprites: [
            [
                "sun",
                {
                    x: 0,
                    y: 0,
                    z: 4,
                    crop: [
                        1,
                        1,
                        1,
                        1
                    ]
                }
            ],
            [
                "directGlare",
                {
                    x: -40,
                    y: -40,
                    z: 2000,
                    crop: [
                        1,
                        1,
                        1,
                        1
                    ],
                    alpha: 0,
                    key: "glare"
                }
            ]
        ],
        frames: {
            noGlare: {
                glare: {
                    maxAlpha: 0
                }
            },
            full: {
                // attributes: { scale: 1.0 },
                glare: {
                    maxAlpha: 1
                }
            },
            large: {
                // attributes: { scale: 1.2 },
                glare: {
                    maxAlpha: 0
                }
            }
        }
    },
    "background.moon": {
        attributes: {
            width: 96,
            height: 96,
            scale: 0.6
        },
        sprites: [
            [
                "moon",
                {
                    x: 0,
                    y: 0,
                    z: 2,
                    crop: [
                        1,
                        1,
                        1,
                        1
                    ]
                }
            ]
        ],
        frames: {
            full: {
                attributes: {
                    scale: 1.0
                }
            },
            large: {
                attributes: {
                    scale: 1.2
                }
            }
        }
    }
};


var $cd591da72b1b2478$exports = {};

$parcel$defineInteropFlag($cd591da72b1b2478$exports);

$parcel$export($cd591da72b1b2478$exports, "default", () => $cd591da72b1b2478$export$2e2bcd8739ae039);
var $cd591da72b1b2478$export$2e2bcd8739ae039 = {
    "city.bridge.foot": {
        attributes: {
            width: 512,
            height: 288
        },
        sprites: [
            [
                "cityBridge",
                {
                    z: -305,
                    horizon: [
                        0.4,
                        0.4
                    ]
                }
            ]
        ]
    },
    "city.bridge.deck": {
        attributes: {
            width: 1024,
            height: 128,
            ro: [
                934,
                90
            ]
        },
        hitbox: [
            0,
            0,
            1024,
            0,
            1024,
            40,
            0,
            40
        ],
        spriteAttributes: {
            accentColor: "#2ba04c"
        },
        sprites: [
            [
                "bridgeDeck",
                {
                    z: 0,
                    x: 4,
                    key: "deck"
                }
            ],
            [
                "bridgeDeck",
                {
                    z: 1,
                    x: 512,
                    flipX: true,
                    key: "deck2"
                }
            ]
        ],
        frames: {
            damaged: {
                deck: {
                    sprite: "damagedBridgeDeck"
                },
                deck2: {
                    sprite: "damagedBridgeDeck"
                }
            },
            rotateSmall: {
                deck: {
                    sprite: "damagedBridgeDeck"
                },
                deck2: {
                    sprite: "damagedBridgeDeck"
                },
                attributes: {
                    rotation: -1
                }
            },
            rotateMedium: {
                deck: {
                    sprite: "damagedBridgeDeck"
                },
                deck2: {
                    sprite: "damagedBridgeDeck"
                },
                attributes: {
                    rotation: -2
                }
            },
            rotateDown: {
                deck: {
                    sprite: "damagedBridgeDeck"
                },
                deck2: {
                    sprite: "damagedBridgeDeck"
                },
                attributes: {
                    rotation: -10
                }
            }
        }
    },
    "city.bridge.pillar": {
        attributes: {
            width: 192,
            height: 544,
            ro: [
                96,
                544
            ]
        },
        sprites: [
            [
                "bridgePillar",
                {
                    z: 0,
                    key: "pillar"
                }
            ]
        ],
        frames: {
            damaged: {
                pillar: {
                    sprite: "bridgePillarBroken"
                }
            },
            rotateSmall: {
                attributes: {
                    rotation: -1
                },
                pillar: {
                    sprite: "bridgePillarBroken"
                }
            },
            rotateMedium: {
                attributes: {
                    rotation: -3
                },
                pillar: {
                    sprite: "bridgePillarBroken"
                }
            },
            rotateDown: {
                attributes: {
                    rotation: 80
                },
                pillar: {
                    sprite: "bridgePillarBroken",
                    y: 200
                }
            }
        }
    },
    "city.bridge.smallPillar": {
        attributes: {
            width: 192,
            height: 189
        },
        sprites: [
            [
                "bridgePillar",
                {
                    z: 0,
                    crop: [
                        300,
                        0,
                        55,
                        0
                    ]
                }
            ]
        ]
    }
};


var $884dfd8a072eb563$exports = {};

$parcel$defineInteropFlag($884dfd8a072eb563$exports);

$parcel$export($884dfd8a072eb563$exports, "default", () => $884dfd8a072eb563$export$2e2bcd8739ae039);
var $884dfd8a072eb563$export$2e2bcd8739ae039 = {
    "grass.front": {
        attributes: {
            width: 1024,
            height: 96
        },
        sprites: [
            [
                "grassFront",
                {
                    z: -20,
                    key: "left",
                    horizon: [
                        0.2,
                        0.0
                    ]
                }
            ]
        ]
    },
    "grass.middle": {
        attributes: {
            width: 768,
            height: 288
        },
        sprites: [
            [
                "grassMiddle",
                {
                    z: -100,
                    w: 768,
                    key: "middle",
                    horizon: [
                        0.6,
                        0.1
                    ]
                }
            ]
        ]
    },
    "grass.pond": {
        attributes: {
            width: 769,
            height: 288
        },
        sprites: [
            [
                "pond",
                {
                    z: -100,
                    w: 768,
                    key: "middle",
                    horizon: [
                        0.6,
                        0.1
                    ]
                }
            ]
        ]
    },
    "grass.pondStart": {
        attributes: {
            width: 769,
            height: 288
        },
        sprites: [
            [
                "pondStart",
                {
                    z: -100,
                    w: 768,
                    key: "middle",
                    horizon: [
                        0.6,
                        0.1
                    ]
                }
            ]
        ]
    },
    "grass.hedge": {
        attributes: {
            width: 384,
            height: 160
        },
        sprites: [
            [
                "hedge",
                {
                    z: -200,
                    w: 666,
                    horizon: [
                        0.3,
                        0.3
                    ]
                }
            ]
        ]
    },
    "town.roof": {
        attributes: {
            width: 460,
            height: 460
        },
        sprites: [
            [
                "roof",
                {
                    z: -10,
                    horizon: [
                        0.2,
                        0.0
                    ]
                }
            ]
        ],
        hitbox: [
            50,
            450,
            50,
            145,
            65,
            145,
            230,
            10,
            400,
            145,
            410,
            145,
            410,
            450
        ],
        attachHooks: [
            [
                "chimneyLoc",
                {
                    x: 92,
                    y: 166,
                    z: -5,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "explosionLoc",
                {
                    x: 92,
                    y: 126,
                    z: -5,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ]
        ]
    },
    "town.chimney": {
        attributes: {
            width: 32,
            height: 128
        },
        hitbox: [
            3,
            17,
            30,
            17,
            30,
            80,
            3,
            105
        ],
        sprites: [
            [
                "chimney",
                {
                    key: "chimney",
                    z: -15,
                    horizon: [
                        0.2,
                        0.2
                    ]
                }
            ]
        ],
        attachHooks: [
            [
                "smokeLoc",
                {
                    x: 14,
                    y: 16,
                    z: -5,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "gunLoc",
                {
                    x: 4,
                    y: -16,
                    z: -5,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ]
        ],
        frames: {
            dead: {
                chimney: {
                    alpha: 0
                }
            },
            shootStart: {
                chimney: {
                    scaleX: 1.2,
                    scaleY: 0.8
                }
            },
            shootEnd: {
                chimney: {
                    scaleX: 0.9,
                    scaleY: 1.1
                }
            }
        },
        animations: {
            shoot: {
                duration: 400,
                repeat: true,
                startEase: {
                    duration: 1,
                    easing: "easeOutQuad"
                },
                easing: "easeInQuad",
                timeline: [
                    {
                        start: 0,
                        end: 0.2,
                        startFrame: "default",
                        endFrame: "shootStart"
                    },
                    {
                        start: 0.2,
                        end: 0.4,
                        startFrame: "shootStart",
                        endFrame: "shootEnd"
                    },
                    {
                        start: 0.6,
                        end: 0.7,
                        startFrame: "shootEnd",
                        endFrame: "default"
                    }
                ]
            }
        }
    },
    "town.middle": {
        attributes: {
            width: 512,
            height: 256
        },
        sprites: [
            [
                "villageSkyline",
                {
                    z: -300,
                    horizon: [
                        0.4,
                        0.2
                    ]
                }
            ]
        ]
    },
    "town.middleFull": {
        attributes: {
            width: 512,
            height: 608
        },
        sprites: [
            [
                "villageSkylineFull",
                {
                    z: -550,
                    horizon: [
                        0.4,
                        0.2
                    ]
                }
            ]
        ]
    },
    "town.skyline": {
        attributes: {
            width: 256,
            height: 128
        },
        sprites: [
            [
                "villageDistantSkyline",
                {
                    z: -550,
                    horizon: [
                        0.5,
                        0.7
                    ]
                }
            ]
        ]
    },
    "hills.horizon": {
        attributes: {
            width: 512,
            height: 96
        },
        sprites: [
            [
                "hillSkyline",
                {
                    z: -600,
                    horizon: [
                        0.8,
                        0.6
                    ]
                }
            ]
        ]
    },
    "sinterklaas.present": {
        attributes: {
            width: 32,
            height: 32
        },
        hitbox: [
            0,
            8,
            16,
            4,
            32,
            8,
            30,
            25,
            16,
            30,
            2,
            25
        ],
        sprites: [
            [
                "present",
                {}
            ]
        ]
    },
    "city.skyScraper": {
        attributes: {
            width: 512,
            height: 640,
            scale: 2
        },
        sprites: [
            [
                "bigBuildingTop",
                {}
            ],
            [
                "bigBuildingLayer",
                {
                    y: 192
                }
            ],
            [
                "bigBuildingLayer",
                {
                    y: 256
                }
            ],
            [
                "bigBuildingLayer",
                {
                    y: 384
                }
            ],
            [
                "bigBuildingLayer",
                {
                    y: 512
                }
            ]
        ]
    },
    "town.chimneyMini": {
        attributes: {
            width: 32,
            height: 94
        },
        hitbox: [
            3,
            17,
            30,
            17,
            30,
            94,
            3,
            94
        ],
        sprites: [
            [
                "chimney",
                {
                    key: "chimney",
                    z: 0,
                    crop: [
                        1,
                        1,
                        32,
                        1
                    ]
                }
            ],
            [
                "present",
                {
                    key: "present",
                    z: 2,
                    y: 70,
                    x: 5,
                    scale: 0.9
                }
            ]
        ],
        attachHooks: [
            [
                "smokeLoc",
                {
                    x: 14,
                    y: 16,
                    z: -5,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "explosionLoc",
                {
                    x: 14,
                    y: 86,
                    z: 2,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "gunLoc",
                {
                    x: 4,
                    y: -16,
                    z: -5,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ]
        ],
        frames: {
            dead: {
                chimney: {
                    alpha: 0
                }
            },
            shootStart: {
                chimney: {
                    scaleX: 1.2,
                    scaleY: 0.8
                }
            },
            shootEnd: {
                chimney: {
                    scaleX: 0.9,
                    scaleY: 1.1
                }
            }
        },
        animations: {
            shoot: {
                duration: 400,
                repeat: true,
                startEase: {
                    duration: 1,
                    easing: "easeOutQuad"
                },
                easing: "easeInQuad",
                timeline: [
                    {
                        start: 0,
                        end: 0.2,
                        startFrame: "default",
                        endFrame: "shootStart"
                    },
                    {
                        start: 0.2,
                        end: 0.4,
                        startFrame: "shootStart",
                        endFrame: "shootEnd"
                    },
                    {
                        start: 0.6,
                        end: 0.7,
                        startFrame: "shootEnd",
                        endFrame: "default"
                    }
                ]
            }
        }
    }
};


var $3c79767ec3d7f214$exports = {};

$parcel$defineInteropFlag($3c79767ec3d7f214$exports);

$parcel$export($3c79767ec3d7f214$exports, "default", () => $3c79767ec3d7f214$export$2e2bcd8739ae039);
var $3c79767ec3d7f214$export$2e2bcd8739ae039 = {
    bird: {
        attributes: {
            width: 60,
            height: 50
        },
        hitbox: [
            0,
            17,
            50,
            15,
            40,
            40,
            0,
            25
        ],
        sprites: [
            [
                "bird",
                {
                    x: -2,
                    y: -11,
                    key: "main"
                }
            ]
        ],
        attachHooks: [
            [
                "trail",
                {
                    x: 32,
                    y: 18,
                    z: -2,
                    attachAlign: [
                        "center",
                        "right"
                    ],
                    attachTo: "main"
                }
            ],
            [
                "explosion",
                {
                    x: 22,
                    y: 18,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ],
            [
                "smoke",
                {
                    x: 22,
                    y: 18,
                    z: -5,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ]
        ],
        frames: {
            damaged: {
                main: {
                    sprite: "bird"
                }
            },
            turned: {
                flipX: true
            },
            hidden: {
                main: {
                    hidden: true,
                    alpha: 0
                }
            }
        }
    }
};


var $3d389ef96ea53877$exports = {};

$parcel$defineInteropFlag($3d389ef96ea53877$exports);

$parcel$export($3d389ef96ea53877$exports, "default", () => $3d389ef96ea53877$export$2e2bcd8739ae039);
var $3d389ef96ea53877$export$2e2bcd8739ae039 = {
    fish: {
        attributes: {
            width: 64,
            height: 64
        },
        hitbox: [
            0,
            5,
            32,
            0,
            64,
            32,
            50,
            40,
            0,
            20
        ],
        sprites: [
            [
                "fish",
                {
                    x: -2,
                    y: -11,
                    z: -80,
                    key: "main"
                }
            ]
        ],
        attachHooks: [
            [
                "trail",
                {
                    x: 54,
                    y: 28,
                    z: -82,
                    attachAlign: [
                        "center",
                        "right"
                    ],
                    attachTo: "main"
                }
            ],
            [
                "explosion",
                {
                    x: 22,
                    y: 18,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ],
            [
                "smoke",
                {
                    x: 22,
                    y: 18,
                    z: -5,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ]
        ],
        frames: {
            damaged: {
                main: {
                    sprite: "fish"
                }
            },
            turned: {
                flipX: true
            },
            hidden: {
                main: {
                    hidden: true,
                    alpha: 0
                }
            }
        }
    }
};


var $4cbd64c8dcd2549e$exports = {};

$parcel$defineInteropFlag($4cbd64c8dcd2549e$exports);

$parcel$export($4cbd64c8dcd2549e$exports, "default", () => $4cbd64c8dcd2549e$export$2e2bcd8739ae039);
const $4cbd64c8dcd2549e$var$compositions = {
    jinte: {
        attributes: {
            width: 160,
            height: 192
        },
        hitbox: [
            80,
            32,
            92,
            32,
            140,
            90,
            150,
            108,
            120,
            128,
            105,
            143,
            105,
            166,
            40,
            166,
            28,
            128,
            28,
            100,
            65,
            80
        ],
        sprites: [
            [
                "playerTop",
                {
                    x: 0,
                    y: 0,
                    key: "upper",
                    w: 160,
                    h: 128
                }
            ],
            [
                "playerBottom1",
                {
                    x: 0,
                    y: 128,
                    key: "lower",
                    w: 160,
                    h: 64
                }
            ]
        ],
        frames: {
            fly1: {
                lower: {
                    sprite: "playerBottom1"
                }
            },
            fly2: {
                lower: {
                    sprite: "playerBottom2"
                }
            },
            hidden: {
                upper: {
                    hidden: true,
                    alpha: 0
                },
                lower: {
                    hidden: true,
                    alpha: 0
                }
            }
        },
        attachHooks: [
            [
                "gun",
                {
                    x: 84,
                    y: 82,
                    attachAlign: [
                        "center",
                        "right"
                    ]
                }
            ],
            [
                "frontFoot",
                {
                    x: 102,
                    y: 162,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "backFoot",
                {
                    x: 32,
                    y: 162,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "center",
                {
                    x: 70,
                    y: 110,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ]
        ],
        animations: {
            flying: {
                repeat: true,
                easing: "linear",
                startEase: {
                    easing: "linear",
                    duration: 250
                },
                duration: 500,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.5,
                        startFrame: "fly1",
                        endFrame: "fly2"
                    },
                    {
                        start: 0.5,
                        end: 1.0,
                        startFrame: "fly2",
                        endFrame: "fly1"
                    }
                ]
            }
        }
    },
    "portraits.jinte": {
        attributes: {
            width: 128,
            height: 128
        },
        sprites: [
            [
                "portraitJinte1",
                {
                    key: "face"
                }
            ]
        ],
        frames: {
            idle: {
                face: {
                    sprite: "portraitJinte1"
                }
            },
            talk: {
                face: {
                    sprite: "portraitJinte2"
                }
            }
        },
        animations: {
            talking: {
                repeat: true,
                easing: "linear",
                duration: 500,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.5,
                        startFrame: "idle",
                        endFrame: "talk"
                    },
                    {
                        start: 0.5,
                        end: 1.0,
                        startFrame: "talk",
                        endFrame: "idle"
                    }
                ]
            }
        }
    },
    "portraits.jonas": {
        attributes: {
            width: 128,
            height: 224
        },
        sprites: [
            [
                "portraitJonas",
                {
                    key: "face"
                }
            ]
        ],
        frames: {
            idle: {
                face: {}
            },
            talk: {
                face: {}
            }
        },
        animations: {
            talking: {
                repeat: true,
                easing: "linear",
                duration: 500,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.5,
                        startFrame: "idle",
                        endFrame: "talk"
                    },
                    {
                        start: 0.5,
                        end: 1.0,
                        startFrame: "talk",
                        endFrame: "idle"
                    }
                ]
            }
        }
    },
    "portraits.sint": {
        attributes: {
            width: 160,
            height: 192
        },
        sprites: [
            [
                "portraitSint",
                {
                    key: "face"
                }
            ]
        ],
        frames: {
            idle: {
                face: {}
            },
            talk: {
                face: {}
            }
        },
        animations: {
            talking: {
                repeat: true,
                easing: "linear",
                duration: 500,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.5,
                        startFrame: "idle",
                        endFrame: "talk"
                    },
                    {
                        start: 0.5,
                        end: 1.0,
                        startFrame: "talk",
                        endFrame: "idle"
                    }
                ]
            }
        }
    },
    "weapons.carrot": {
        attributes: {
            width: 32,
            height: 32,
            ro: [
                4,
                14
            ]
        },
        hitbox: [
            2,
            12,
            28,
            12,
            28,
            22,
            2,
            22
        ],
        sprites: [
            [
                "carrot",
                {
                    z: -2
                }
            ]
        ]
    },
    "title.jinte": {
        attributes: {
            width: 416,
            height: 480,
            ro: [
                208,
                240
            ]
        },
        sprites: [
            [
                "title",
                {
                    z: 0,
                    key: "jinte"
                }
            ]
        ],
        frames: {
            close: {
                jinte: {
                    scale: 1.0
                }
            },
            far: {
                jinte: {
                    scale: 0.3
                }
            }
        }
    }
};
var $4cbd64c8dcd2549e$export$2e2bcd8739ae039 = $4cbd64c8dcd2549e$var$compositions;


var $31e21447f47c1b59$exports = {};

$parcel$defineInteropFlag($31e21447f47c1b59$exports);

$parcel$export($31e21447f47c1b59$exports, "default", () => $31e21447f47c1b59$export$2e2bcd8739ae039);
var $31e21447f47c1b59$export$2e2bcd8739ae039 = {
    seagull: {
        attributes: {
            width: 96,
            height: 80
        },
        hitbox: [
            19,
            37,
            50,
            15,
            80,
            50,
            40,
            60,
            5,
            45
        ],
        sprites: [
            [
                "seagull",
                {
                    x: -2,
                    y: -11,
                    key: "main"
                }
            ]
        ],
        attachHooks: [
            [
                "gun",
                {
                    x: 65,
                    y: 53,
                    z: -2,
                    attachAlign: [
                        "center",
                        "right"
                    ],
                    attachTo: "main"
                }
            ],
            [
                "explosion",
                {
                    x: 42,
                    y: 38,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ],
            [
                "smoke",
                {
                    x: 42,
                    y: 38,
                    z: -5,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ]
        ],
        frames: {
            damaged: {
                main: {
                    sprite: "seagull"
                }
            },
            turned: {
                flipX: true
            },
            hidden: {
                main: {
                    hidden: true,
                    alpha: 0
                }
            }
        }
    },
    flats: {
        attributes: {
            width: 32,
            height: 32,
            ro: [
                28,
                4
            ]
        },
        hitbox: [
            26,
            2,
            0,
            20,
            5,
            30,
            16,
            26,
            28,
            4
        ],
        sprites: [
            [
                "flats",
                {
                    key: "main",
                    scale: 0.7
                }
            ]
        ]
    }
};


var $c7ae14cbda4c00e2$exports = {};

$parcel$defineInteropFlag($c7ae14cbda4c00e2$exports);

$parcel$export($c7ae14cbda4c00e2$exports, "default", () => $c7ae14cbda4c00e2$export$2e2bcd8739ae039);
var $c7ae14cbda4c00e2$export$2e2bcd8739ae039 = {
    "test.dino": {
        attributes: {
            width: 200,
            height: 153
        },
        sprites: [
            [
                "dinoBody",
                {
                    z: 2,
                    ro: [
                        82,
                        24
                    ],
                    key: "body"
                }
            ],
            [
                "dinoTentacles",
                {
                    x: 26,
                    y: 37,
                    z: 2,
                    ro: [
                        16,
                        16
                    ],
                    attachTo: "body"
                }
            ],
            [
                "dinoArm",
                {
                    x: 16,
                    y: 82,
                    z: 3,
                    ro: [
                        34,
                        16
                    ],
                    key: "arm",
                    attachTo: "body"
                }
            ],
            [
                "dinoNeck",
                {
                    x: -32,
                    y: 42,
                    z: 1,
                    ro: [
                        50,
                        16
                    ],
                    key: "neck",
                    attachTo: "body"
                }
            ],
            [
                "dinoJaw",
                {
                    x: -89,
                    y: 52,
                    z: 1,
                    ro: [
                        70,
                        16
                    ],
                    key: "jaw",
                    attachTo: "neck"
                }
            ],
            [
                "dinoTongue",
                {
                    x: -39,
                    y: 52,
                    z: -1,
                    ro: [
                        70,
                        16
                    ],
                    attachTo: "neck",
                    key: "tongue"
                }
            ],
            [
                "dinoHead",
                {
                    x: -94,
                    y: 23,
                    z: 2,
                    ro: [
                        70,
                        37
                    ],
                    key: "head",
                    attachTo: "neck"
                }
            ],
            [
                "dinoTail",
                {
                    x: 124,
                    y: 24,
                    z: 1,
                    ro: [
                        10,
                        22
                    ],
                    attachTo: "body"
                }
            ],
            [
                "dinoUpperLeg",
                {
                    x: 116,
                    y: 46,
                    z: 3,
                    ro: [
                        32,
                        16
                    ],
                    key: "upperLeg",
                    attachTo: "body"
                }
            ],
            [
                "dinoLowerLeg",
                {
                    x: 144,
                    y: 86,
                    z: 5,
                    rotation: -55,
                    ro: [
                        16,
                        16
                    ],
                    key: "lowerLeg",
                    attachTo: "upperLeg"
                }
            ],
            [
                "dinoFeet",
                {
                    x: 172,
                    y: 114,
                    z: 6,
                    ro: [
                        26,
                        8
                    ],
                    key: "feet",
                    attachTo: "lowerLeg"
                }
            ],
            [
                "dinoToes",
                {
                    x: 157,
                    y: 118,
                    z: 7,
                    ro: [
                        22,
                        20
                    ],
                    attachTo: "feet"
                }
            ],
            [
                "dinoBackUpperLeg",
                {
                    x: 114,
                    y: 36,
                    z: -3,
                    ro: [
                        22,
                        20
                    ],
                    key: "backUpperLeg",
                    attachTo: "body"
                }
            ],
            [
                "dinoBackLowerLeg",
                {
                    x: 114,
                    y: 63,
                    z: -2,
                    ro: [
                        16,
                        20
                    ],
                    key: "backLowerLeg",
                    attachTo: "backUpperLeg"
                }
            ],
            [
                "dinoBackFeet",
                {
                    x: 98,
                    y: 95,
                    z: -1,
                    ro: [
                        24,
                        16
                    ],
                    key: "backFeet",
                    attachTo: "backLowerLeg"
                }
            ],
            [
                "dinoBackToes",
                {
                    x: 82,
                    y: 95,
                    z: 0,
                    ro: [
                        26,
                        11
                    ],
                    key: "backToes",
                    attachTo: "backFeet"
                }
            ]
        ],
        frames: {
            roar1: {
                head: {
                    rotation: 40
                },
                jaw: {
                    rotation: -42,
                    x: -8
                },
                tongue: {
                    x: -20
                },
                neck: {
                    rotation: 0
                },
                body: {
                    rotation: 20
                },
                arm: {
                    rotation: -40
                },
                tail: {
                    rotation: -10
                },
                topLeg: {
                    rotation: 25
                },
                bottomLeg: {
                    rotation: -50
                },
                feet: {
                    rotation: -10
                },
                toes: {
                    rotation: -10
                },
                upperLegBack: {
                    rotation: 10
                },
                lowerLegBack: {
                    rotation: -60
                },
                feetBack: {
                    rotation: -80
                },
                toesBack: {
                    rotation: 0
                }
            }
        }
    }
};


var $6994f3b876a92e60$exports = {};

$parcel$defineInteropFlag($6994f3b876a92e60$exports);

$parcel$export($6994f3b876a92e60$exports, "default", () => $6994f3b876a92e60$export$2e2bcd8739ae039);
var $6994f3b876a92e60$export$2e2bcd8739ae039 = {
    "test.wall": {
        attributes: {
            width: 40,
            height: 150
        },
        gradients: [
            {
                w: 40,
                h: 150,
                topColor: [
                    "#606060",
                    1
                ],
                bottomColor: [
                    "#606060",
                    1
                ]
            }
        ]
    }
};


var $8a2d2a7caa42e361$exports = {};

$parcel$defineInteropFlag($8a2d2a7caa42e361$exports);

$parcel$export($8a2d2a7caa42e361$exports, "default", () => $8a2d2a7caa42e361$export$2e2bcd8739ae039);
var $8a2d2a7caa42e361$export$2e2bcd8739ae039 = {
    "title.ship": {
        attributes: {
            width: 288,
            height: 160,
            scale: 1.0,
            ro: [
                144,
                110
            ]
        },
        sprites: [
            [
                "titleShip",
                {
                    key: "main",
                    accentColor: "#ff0000",
                    horizon: [
                        0.0,
                        0.0
                    ],
                    z: 200
                }
            ]
        ],
        frames: {
            far: {
                attributes: {
                    scale: 0.1,
                    rotation: 0
                },
                main: {
                    horizon: [
                        1.0,
                        1.0
                    ]
                }
            },
            close: {
                attributes: {
                    scale: 1.5,
                    rotation: 20
                },
                main: {
                    horizon: [
                        0.0,
                        0.0
                    ]
                }
            }
        }
    },
    "title.gradient": {
        attributes: {
            width: 1230,
            height: 576
        },
        gradients: [
            {
                y: 300,
                z: 2,
                w: 1230,
                h: 300,
                key: "sky",
                topColor: [
                    "#000000",
                    1
                ],
                bottomColor: [
                    "#000000",
                    1
                ]
            }
        ],
        frames: {
            reveal: {
                sky: {
                    topColor: [
                        "#000000",
                        0.0
                    ],
                    bottomColor: [
                        "#000000",
                        1.0
                    ]
                }
            }
        }
    }
};


var $82291d8c90004f4c$exports = {};

$parcel$defineInteropFlag($82291d8c90004f4c$exports);

$parcel$export($82291d8c90004f4c$exports, "default", () => $82291d8c90004f4c$export$2e2bcd8739ae039);
var $82291d8c90004f4c$export$2e2bcd8739ae039 = {
    "battleship.deck": {
        attributes: {
            width: 1390,
            height: 170
        },
        hitbox: [
            20,
            60,
            1280,
            60,
            1280,
            188,
            20,
            188
        ],
        sprites: [
            [
                "aircraftCarrierStart",
                {
                    x: 0
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 192
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 320
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 448
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 576
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 704
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 832
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 960
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 1088
                }
            ],
            [
                "aircraftCarrierEnd",
                {
                    x: 1216
                }
            ],
            [
                "aircraftCarrierBottomFlat",
                {
                    x: 192,
                    y: 64
                }
            ],
            [
                "aircraftCarrierBottomSpace",
                {
                    x: 320,
                    y: 64
                }
            ],
            [
                "aircraftCarrierBottomFlat",
                {
                    x: 448,
                    y: 64
                }
            ],
            [
                "aircraftCarrierBottomFlat",
                {
                    x: 576,
                    y: 64
                }
            ],
            [
                "aircraftCarrierBottomFlat",
                {
                    x: 704,
                    y: 64
                }
            ],
            [
                "aircraftCarrierBottomSpace",
                {
                    x: 832,
                    y: 64
                }
            ],
            [
                "aircraftCarrierBottomFlat",
                {
                    x: 960,
                    y: 64
                }
            ],
            [
                "aircraftCarrierBottomFlat",
                {
                    x: 1088,
                    y: 64
                }
            ],
            [
                "aircraftCarrierWires",
                {
                    x: 1052,
                    y: 20,
                    z: 1
                }
            ],
            [
                "aircraftCarrierHole",
                {
                    x: 220,
                    y: 120,
                    z: 1
                }
            ],
            [
                "aircraftCarrierHole",
                {
                    x: 310,
                    y: 120,
                    z: 1
                }
            ],
            [
                "aircraftCarrierHole",
                {
                    x: 450,
                    y: 120,
                    z: 1
                }
            ],
            [
                "aircraftCarrierHole",
                {
                    x: 540,
                    y: 120,
                    z: 1
                }
            ],
            [
                "aircraftCarrierHole",
                {
                    x: 630,
                    y: 120,
                    z: 1
                }
            ],
            [
                "aircraftCarrierHole",
                {
                    x: 720,
                    y: 120,
                    z: 1
                }
            ],
            [
                "aircraftCarrierHole",
                {
                    x: 810,
                    y: 120,
                    z: 1
                }
            ],
            [
                "aircraftCarrierHole",
                {
                    x: 960,
                    y: 120,
                    z: 1
                }
            ],
            [
                "aircraftCarrierHole",
                {
                    x: 1050,
                    y: 120,
                    z: 1
                }
            ]
        ],
        attachHooks: [
            [
                "mineCannon",
                {
                    x: 120,
                    y: 48,
                    z: 8,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "deckGun1",
                {
                    x: 356,
                    y: 90,
                    z: 20,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "deckGun2",
                {
                    x: 866,
                    y: 90,
                    z: 20,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "deckGun3",
                {
                    x: 1120,
                    y: 70,
                    z: 7,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "package",
                {
                    x: 1100,
                    y: 86,
                    z: 3,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "laserField",
                {
                    x: 1120,
                    y: 86,
                    z: 8,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "boxLocation1",
                {
                    x: 1020,
                    y: 73,
                    z: 8,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "boxLocation2",
                {
                    x: 1230,
                    y: 80,
                    z: 8,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "boxLocation3",
                {
                    x: 1133,
                    y: 37,
                    z: 1,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "cabin1",
                {
                    x: 294,
                    y: 24,
                    z: 6,
                    attachAlign: [
                        "bottom",
                        "left"
                    ]
                }
            ],
            [
                "heliPlace1",
                {
                    x: 540,
                    y: 24,
                    z: 2,
                    attachAlign: [
                        "bottom",
                        "left"
                    ]
                }
            ],
            [
                "heliPlace2",
                {
                    x: 700,
                    y: 24,
                    z: 1,
                    attachAlign: [
                        "bottom",
                        "left"
                    ]
                }
            ],
            [
                "cabin2",
                {
                    x: 832,
                    y: 24,
                    z: 3,
                    attachAlign: [
                        "bottom",
                        "left"
                    ]
                }
            ],
            [
                "engineCore",
                {
                    x: 960,
                    y: -62,
                    z: 4.5,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ],
            [
                "hatch1",
                {
                    x: 420,
                    y: 32,
                    z: 2,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ],
            [
                "hatch2",
                {
                    x: 612,
                    y: 32,
                    z: 2,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ],
            [
                "hatch3",
                {
                    x: 804,
                    y: 32,
                    z: 0.5,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ],
            [
                "bottom",
                {
                    x: 10,
                    y: 135,
                    z: 21,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ],
            [
                "cabin1burn",
                {
                    x: 314,
                    y: -16,
                    z: 2,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ],
            [
                "cabin1burn2",
                {
                    x: 314,
                    y: 0,
                    z: 2,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ],
            [
                "cabin2burn",
                {
                    x: 850,
                    y: -16,
                    z: 2,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ],
            [
                "cabin2burn2",
                {
                    x: 850,
                    y: 0,
                    z: 2,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ],
            [
                "cabin1explode",
                {
                    x: 360,
                    y: -56,
                    z: 10,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "cabin2explode",
                {
                    x: 950,
                    y: -56,
                    z: 14,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ]
        ],
        frames: {
            risen: {
                bottom: {
                    y: 25
                }
            },
            lowered: {
                bottom: {
                    y: 0
                }
            },
            sinking: {
                bottom: {
                    y: -100
                }
            }
        }
    },
    "battleship.firstCabin": {
        attributes: {
            width: 192,
            height: 130
        },
        hitbox: [
            0,
            128,
            0,
            50,
            32,
            32,
            32,
            0,
            193,
            0,
            193,
            128
        ],
        sprites: [
            [
                "aircraftCarrierCabinEnd",
                {
                    x: -12,
                    y: -15,
                    flipX: true,
                    crop: [
                        0,
                        4,
                        0,
                        0
                    ]
                }
            ],
            [
                "aircraftCarrierCabinRadar",
                {
                    x: 48,
                    y: -15,
                    flipX: true
                }
            ],
            [
                "aircraftCarrierCabin",
                {
                    x: 112,
                    y: -15
                }
            ],
            [
                "aircraftCarrierCabinStart",
                {
                    x: 176,
                    y: -15,
                    flipX: true
                }
            ],
            [
                "aircraftCarrierAntenna",
                {
                    x: 128,
                    y: -65,
                    z: 1,
                    flipX: true
                }
            ],
            [
                "aircraftCarrier5",
                {
                    x: 128,
                    y: 55,
                    z: 1
                }
            ]
        ],
        attachHooks: [
            [
                "radar",
                {
                    x: 72,
                    y: 11,
                    z: 1,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ]
        ]
    },
    "battleship.firstCabinDestroyed": {
        attributes: {
            width: 192,
            height: 66
        },
        sprites: [
            [
                "aircraftCarrierCabinEndBroken",
                {
                    x: -16,
                    y: -15,
                    flipX: true
                }
            ],
            [
                "aircraftCarrierCabinRadarBroken",
                {
                    x: 48,
                    y: -15,
                    flipX: true
                }
            ],
            [
                "aircraftCarrierCabinBroken",
                {
                    x: 112,
                    y: -15
                }
            ],
            [
                "aircraftCarrierCabinStartBroken",
                {
                    x: 176,
                    y: -15,
                    flipX: true
                }
            ]
        ]
    },
    "battleship.secondCabin": {
        attributes: {
            width: 256,
            height: 130
        },
        hitbox: [
            0,
            55,
            32,
            40,
            32,
            0,
            260,
            0,
            260,
            128,
            0,
            128
        ],
        sprites: [
            [
                "aircraftCarrierCabinEnd",
                {
                    x: -12,
                    y: -15,
                    flipX: true,
                    crop: [
                        0,
                        4,
                        0,
                        0
                    ]
                }
            ],
            [
                "aircraftCarrierCabinRadar",
                {
                    x: 48,
                    y: -15,
                    flipX: true
                }
            ],
            [
                "aircraftCarrierCabin",
                {
                    x: 112,
                    y: -15
                }
            ],
            [
                "aircraftCarrierCabin",
                {
                    x: 176,
                    y: -15
                }
            ],
            [
                "aircraftCarrierCabinStart",
                {
                    x: 240,
                    y: -15,
                    flipX: true
                }
            ],
            [
                "aircraftCarrierAntenna",
                {
                    x: 64,
                    y: -63,
                    z: 0.5,
                    flipX: true
                }
            ],
            [
                "aircraftCarrierAntenna",
                {
                    x: 160,
                    y: -63,
                    z: 0.5,
                    flipX: true
                }
            ],
            [
                "aircraftCarrierClosed",
                {
                    x: 128,
                    y: 50,
                    z: 0.1
                }
            ],
            [
                "aircraftCarrierDoor",
                {
                    x: 134,
                    y: 56,
                    w: 84,
                    z: 2.5,
                    key: "door",
                    hideAbove: 56
                }
            ],
            [
                "aircraftCarrier5",
                {
                    x: 76,
                    y: 40,
                    z: 0.5
                }
            ]
        ],
        frames: {
            open: {
                door: {
                    y: -68
                }
            }
        }
    },
    "battleship.secondCabinDestroyed": {
        attributes: {
            width: 256,
            height: 66
        },
        sprites: [
            [
                "aircraftCarrierCabinEndBroken",
                {
                    x: -16,
                    y: -15,
                    flipX: true
                }
            ],
            [
                "aircraftCarrierCabinRadarBroken",
                {
                    x: 48,
                    y: -15,
                    flipX: true
                }
            ],
            [
                "aircraftCarrierCabinBroken",
                {
                    x: 112,
                    y: -15
                }
            ],
            [
                "aircraftCarrierCabinBroken",
                {
                    x: 176,
                    y: -15
                }
            ],
            [
                "aircraftCarrierCabinStartBroken",
                {
                    x: 240,
                    y: -15,
                    flipX: true
                }
            ]
        ]
    },
    "battleship.engine": {
        attributes: {
            width: 96,
            height: 96
        },
        hitbox: [
            16,
            16,
            80,
            16,
            80,
            80,
            16,
            80
        ],
        sprites: [
            [
                "aircraftCarrierEngine",
                {
                    x: 0,
                    y: 0,
                    key: "cabin"
                }
            ],
            [
                "aircraftCarrierEngineMeter",
                {
                    x: 32,
                    y: 26,
                    ro: [
                        16,
                        22
                    ],
                    key: "meter",
                    attachTo: "cabin"
                }
            ]
        ],
        attachHooks: [
            [
                "smoke",
                {
                    x: 36,
                    y: 52,
                    z: -1
                }
            ],
            [
                "explosion",
                {
                    x: 36,
                    y: 52,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ]
        ],
        frames: {
            perc0: {
                meter: {
                    rotation: -90
                }
            },
            perc25: {
                meter: {
                    rotation: -45
                }
            },
            perc50: {
                meter: {
                    rotation: 0
                }
            },
            perc75: {
                meter: {
                    rotation: 45
                }
            },
            perc100: {
                meter: {
                    rotation: 90
                }
            },
            shake1: {
                cabin: {
                    x: 2,
                    y: -1
                },
                meter: {
                    rotation: 90
                }
            },
            shake2: {
                cabin: {
                    x: -2,
                    y: 1
                },
                meter: {
                    rotation: 85
                }
            },
            shake3: {
                cabin: {
                    x: 1
                }
            },
            shake4: {
                cabin: {
                    x: -1
                }
            },
            destroyed: {
                meter: {
                    alpha: 0
                },
                cabin: {
                    sprite: "aircraftCarrierEngineDestroyed"
                }
            }
        },
        animations: {
            shake: {
                repeat: true,
                duration: 500,
                timeline: [
                    {
                        start: 0,
                        end: 0.5,
                        startFrame: "shake3",
                        endFrame: "shake4"
                    },
                    {
                        start: 0.5,
                        end: 1,
                        startFrame: "shake4",
                        endFrame: "shake3"
                    }
                ]
            },
            heavyShake: {
                repeat: true,
                duration: 100,
                timeline: [
                    {
                        start: 0,
                        end: 0.5,
                        startFrame: "shake1",
                        endFrame: "shake2"
                    },
                    {
                        start: 0,
                        end: 1,
                        startFrame: "shake1",
                        endFrame: "shake2"
                    }
                ]
            }
        }
    }
};


var $5764ee7959541d57$exports = {};

$parcel$defineInteropFlag($5764ee7959541d57$exports);

$parcel$export($5764ee7959541d57$exports, "default", () => $5764ee7959541d57$export$2e2bcd8739ae039);
var $5764ee7959541d57$export$2e2bcd8739ae039 = {
    bulletCannon: {
        attributes: {
            width: 100,
            height: 42
        },
        hitbox: [
            64,
            24,
            96,
            24,
            96,
            45,
            64,
            45
        ],
        sprites: [
            [
                "turretFoot",
                {
                    x: 64,
                    y: 24,
                    key: "foot"
                }
            ],
            [
                "bulletCannon",
                {
                    x: 0,
                    y: 0,
                    key: "barrel",
                    ro: [
                        82,
                        24
                    ],
                    hitbox: [
                        5,
                        10,
                        94,
                        10,
                        94,
                        28,
                        5,
                        28
                    ]
                }
            ]
        ],
        attachHooks: [
            [
                "gun",
                {
                    x: 0,
                    y: 18,
                    z: 2,
                    attachAlign: [
                        "center",
                        "left"
                    ],
                    attachTo: "barrel"
                }
            ],
            [
                "smoke",
                {
                    x: 80,
                    y: 32,
                    z: -1,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "explosion",
                {
                    x: 80,
                    y: 16,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ],
            [
                "fire",
                {
                    x: 80,
                    y: 32,
                    z: 1,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "smoke2",
                {
                    x: 80,
                    y: 29,
                    z: 0,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ]
        ],
        frames: {
            dead: {
                barrel: {
                    alpha: 0
                }
            },
            up: {
                barrel: {
                    rotation: 90
                }
            },
            dead1: {
                barrel: {
                    rotation: -90,
                    y: -100,
                    x: 0
                }
            },
            dead2: {
                barrel: {
                    rotation: -180,
                    y: -5,
                    x: -40,
                    z: -2
                }
            },
            dead3: {
                barrel: {
                    rotation: -180,
                    y: -15,
                    x: -40,
                    z: -3
                }
            },
            mirrored: {
                flipX: true
            }
        },
        animations: {
            dead: {
                duration: 1000,
                startEase: {
                    duration: 250,
                    easing: "easeOutQuad"
                },
                easing: "easeInQuad",
                timeline: [
                    {
                        start: 0,
                        end: 0.5,
                        startFrame: "dead1",
                        endFrame: "dead2"
                    },
                    {
                        start: 0.5,
                        end: 0.75,
                        startFrame: "dead2",
                        endFrame: "dead3"
                    },
                    {
                        start: 0.75,
                        end: 1.0,
                        startFrame: "dead3",
                        endFrame: "dead2"
                    }
                ]
            }
        }
    }
};


var $09aafa564fd606f1$exports = {};

$parcel$defineInteropFlag($09aafa564fd606f1$exports);

$parcel$export($09aafa564fd606f1$exports, "default", () => $09aafa564fd606f1$export$2e2bcd8739ae039);
var $09aafa564fd606f1$export$2e2bcd8739ae039 = {
    bulletDrone: {
        attributes: {
            width: 53,
            height: 32
        },
        hitbox: [
            0,
            20,
            20,
            0,
            50,
            5,
            50,
            32,
            5,
            30
        ],
        sprites: [
            [
                "bulletDrone",
                {
                    x: -7,
                    key: "main"
                }
            ],
            [
                "helicopterGun",
                {
                    x: 25,
                    y: 15,
                    z: -1,
                    key: "barrel",
                    ro: [
                        20,
                        10
                    ]
                }
            ]
        ],
        attachHooks: [
            [
                "gun",
                {
                    x: 25,
                    y: 32,
                    z: 1,
                    attachAlign: [
                        "center",
                        "left"
                    ],
                    attachTo: "barrel"
                }
            ],
            [
                "trail",
                {
                    x: 55,
                    y: 12,
                    z: -2,
                    attachAlign: [
                        "center",
                        "right"
                    ],
                    attachTo: "main"
                }
            ],
            [
                "explosion",
                {
                    x: 22,
                    y: 15,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ],
            [
                "smoke",
                {
                    x: 22,
                    y: 15,
                    z: -5,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ]
        ],
        frames: {
            damaged: {
                main: {
                    sprite: "standardDroneDamage"
                }
            },
            turned: {
                flipX: true
            },
            hidden: {
                main: {
                    hidden: true,
                    alpha: 0
                },
                gun: {
                    hidden: true,
                    alpha: 0
                }
            }
        }
    }
};


var $cf5eaad6431281fd$exports = {};

$parcel$defineInteropFlag($cf5eaad6431281fd$exports);

$parcel$export($cf5eaad6431281fd$exports, "default", () => $cf5eaad6431281fd$export$2e2bcd8739ae039);
var $cf5eaad6431281fd$export$2e2bcd8739ae039 = {
    drone: {
        attributes: {
            width: 60,
            height: 50,
            scale: 0.7
        },
        hitbox: [
            0,
            20,
            50,
            0,
            60,
            40,
            0,
            50
        ],
        sprites: [
            [
                "standardDrone",
                {
                    x: -2,
                    y: -11,
                    key: "main"
                }
            ]
        ],
        attachHooks: [
            [
                "trail",
                {
                    x: 42,
                    y: 12,
                    z: -2,
                    attachAlign: [
                        "center",
                        "right"
                    ],
                    attachTo: "main"
                }
            ],
            [
                "explosion",
                {
                    x: 22,
                    y: 18,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ],
            [
                "smoke",
                {
                    x: 22,
                    y: 18,
                    z: -5,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ]
        ],
        frames: {
            damaged: {
                main: {
                    sprite: "standardDroneDamage"
                }
            },
            turned: {
                flipX: true
            },
            hidden: {
                main: {
                    hidden: true,
                    alpha: 0
                }
            }
        }
    }
};


var $3c9fd3b6ccb70c88$exports = {};

$parcel$defineInteropFlag($3c9fd3b6ccb70c88$exports);

$parcel$export($3c9fd3b6ccb70c88$exports, "default", () => $3c9fd3b6ccb70c88$export$2e2bcd8739ae039);
var $3c9fd3b6ccb70c88$export$2e2bcd8739ae039 = {
    "droneShip.main": {
        attributes: {
            width: 600,
            height: 160
        },
        hitbox: [
            10,
            60,
            525,
            60,
            525,
            188,
            10,
            188
        ],
        sprites: [
            [
                "aircraftCarrierStart",
                {
                    x: 0
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 192
                }
            ],
            [
                "aircraftCarrierTopFlat",
                {
                    x: 320
                }
            ],
            [
                "aircraftCarrierBottomFlat",
                {
                    x: 192,
                    y: 64
                }
            ],
            [
                "aircraftCarrierBottomSpace",
                {
                    x: 320,
                    y: 64
                }
            ],
            [
                "aircraftCarrierEnd",
                {
                    x: 448,
                    y: 0
                }
            ],
            [
                "aircraftCarrierLowCabinStart",
                {
                    x: 168,
                    y: -28,
                    flipX: true
                }
            ],
            [
                "aircraftCarrierLowCabin",
                {
                    x: 200,
                    y: -28
                }
            ],
            [
                "aircraftCarrierLowCabin",
                {
                    x: 232,
                    y: -28
                }
            ],
            [
                "aircraftCarrierLowCabinStart",
                {
                    x: 264,
                    y: -28
                }
            ]
        ],
        attachHooks: [
            [
                "boxLocation1",
                {
                    x: 420,
                    y: 30,
                    z: 13
                }
            ],
            [
                "radar",
                {
                    x: 228,
                    y: -6,
                    z: 1,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ],
            [
                "hatch1",
                {
                    x: 220,
                    y: 32,
                    z: 2,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ],
            [
                "bottom",
                {
                    x: 10,
                    y: 130,
                    z: 2,
                    attachAlign: [
                        "top",
                        "left"
                    ]
                }
            ],
            [
                "gun",
                {
                    x: 360,
                    y: 90,
                    z: 22,
                    attachAlign: [
                        "bottom",
                        "center"
                    ]
                }
            ]
        ]
    },
    "droneShip.radar": {
        attributes: {
            width: 64,
            height: 28
        },
        hitbox: [
            4,
            24,
            32,
            0,
            60,
            24,
            32,
            42
        ],
        sprites: [
            [
                "aircraftCarrierRadar",
                {
                    x: 0,
                    y: -6,
                    key: "main"
                }
            ],
            [
                "aircraftCarrierRadarEmit",
                {
                    x: 0,
                    y: 0,
                    z: -1,
                    key: "emit",
                    scale: 0.9
                }
            ]
        ],
        attachHooks: [
            [
                "smoke",
                {
                    x: 32,
                    y: 28,
                    z: 1,
                    attachAlign: [
                        "center",
                        "left"
                    ]
                }
            ],
            [
                "explosion",
                {
                    x: 32,
                    y: 28,
                    z: 1,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ]
        ],
        frames: {
            emitStart: {
                emit: {
                    x: 0,
                    y: 0,
                    alpha: 1,
                    scale: 0.9
                }
            },
            emitEnd: {
                emit: {
                    x: 0,
                    y: -32,
                    alpha: 0.0,
                    scale: 3.0
                }
            },
            broken: {
                emit: {
                    x: 0,
                    y: -32,
                    alpha: 0.0,
                    scale: 3.0
                },
                main: {
                    hidden: true,
                    sprite: "aircraftCarrierRadarBroken"
                }
            }
        },
        animations: {
            pulse: {
                repeat: true,
                easing: "linear",
                duration: 1500,
                timeline: [
                    {
                        start: 0.0,
                        end: 1.0,
                        startFrame: "emitStart",
                        endFrame: "emitEnd"
                    }
                ]
            }
        }
    }
};


var $1e0e1c26fcec90db$exports = {};

$parcel$defineInteropFlag($1e0e1c26fcec90db$exports);

$parcel$export($1e0e1c26fcec90db$exports, "default", () => $1e0e1c26fcec90db$export$2e2bcd8739ae039);
var $1e0e1c26fcec90db$export$2e2bcd8739ae039 = {
    helicopter: {
        attributes: {
            width: 128,
            height: 64,
            scale: 1
        },
        hitbox: [
            10,
            45,
            50,
            10,
            125,
            20,
            110,
            50,
            13,
            57
        ],
        sprites: [
            [
                "helicopterLanded",
                {
                    x: 0,
                    y: 0,
                    key: "heli",
                    w: 128,
                    h: 64,
                    horizon: [
                        0,
                        0
                    ]
                }
            ],
            [
                "helicopterGun",
                {
                    x: -5,
                    y: 43,
                    z: -1,
                    key: "barrel",
                    w: 32,
                    h: 32,
                    ro: [
                        20,
                        10
                    ],
                    horizon: [
                        0,
                        0
                    ]
                }
            ]
        ],
        attachHooks: [
            [
                "gun",
                {
                    x: 2,
                    y: 62,
                    z: 1,
                    attachAlign: [
                        "center",
                        "left"
                    ],
                    attachTo: "barrel"
                }
            ],
            [
                "rockets",
                {
                    x: 60,
                    y: 42,
                    z: 1,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "sparks",
                {
                    x: 60,
                    y: 42,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "smoke",
                {
                    x: 60,
                    y: 52,
                    z: -1,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "fire",
                {
                    x: 80,
                    y: 32,
                    z: 1,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "smoke2",
                {
                    x: 80,
                    y: 29,
                    z: 0,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ]
        ],
        frames: {
            landed: {
                attributes: {
                    scale: 0.8,
                    z: -100
                }
            },
            foreground: {
                attributes: {
                    scale: 1.0,
                    z: 100
                }
            },
            background: {
                flipX: true,
                attributes: {
                    scale: 0.7,
                    z: -300
                },
                heli: {
                    horizon: [
                        0.7,
                        0.7
                    ]
                },
                barrel: {
                    horizon: [
                        0.7,
                        0.7
                    ]
                }
            },
            flyBackground1: {
                attributes: {
                    scale: 0.7
                },
                heli: {
                    sprite: "helicopter",
                    horizon: [
                        0.7,
                        0.7
                    ]
                },
                barrel: {
                    alpha: 1,
                    horizon: [
                        0.7,
                        0.7
                    ]
                }
            },
            flyBackground2: {
                attributes: {
                    scale: 0.7
                },
                heli: {
                    sprite: "helicopter2",
                    horizon: [
                        0.7,
                        0.7
                    ]
                },
                barrel: {
                    alpha: 1,
                    horizon: [
                        0.7,
                        0.7
                    ]
                }
            },
            fly1: {
                heli: {
                    sprite: "helicopter"
                },
                barrel: {
                    alpha: 1
                }
            },
            fly2: {
                heli: {
                    sprite: "helicopter2"
                },
                barrel: {
                    alpha: 1
                }
            },
            damaged: {
                heli: {
                    sprite: "heliDamaged"
                },
                barrel: {
                    alpha: 1
                }
            },
            gunRotate1: {
                barrel: {
                    rotation: 10
                }
            },
            gunRotate2: {
                barrel: {
                    rotation: -50
                }
            },
            turn1: {
                heli: {
                    sprite: "helicopterTurning1",
                    scaleX: 0.5
                },
                barrel: {
                    alpha: 0
                }
            },
            turn2: {
                heli: {
                    sprite: "helicopterTurning2",
                    scaleX: 0.5
                },
                barrel: {
                    alpha: 0
                }
            },
            turned: {
                flipX: true
            },
            tilted: {
                attributes: {
                    rotation: -10
                }
            },
            leveled: {
                attributes: {
                    rotation: 0
                }
            }
        },
        animations: {
            flying: {
                repeat: true,
                easing: "linear",
                startEase: {
                    easing: "linear",
                    duration: 250
                },
                duration: 500,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.5,
                        startFrame: "fly1",
                        endFrame: "fly2"
                    },
                    {
                        start: 0.5,
                        end: 1,
                        startFrame: "fly2",
                        endFrame: "fly1"
                    }
                ]
            },
            flyingBackground: {
                repeat: true,
                easing: "linear",
                startEase: {
                    easing: "linear",
                    duration: 250
                },
                duration: 500,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.5,
                        startFrame: "flyBackground1",
                        endFrame: "flyBackground2"
                    },
                    {
                        start: 0.5,
                        end: 1,
                        startFrame: "flyBackground2",
                        endFrame: "flyBackground1"
                    }
                ]
            },
            turning: {
                repeat: true,
                easing: "linear",
                startEase: {
                    easing: "linear",
                    duration: 250
                },
                duration: 500,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.5,
                        startFrame: "turn1",
                        endFrame: "turn2"
                    },
                    {
                        start: 0.5,
                        end: 1,
                        startFrame: "turn2",
                        endFrame: "turn1"
                    }
                ]
            },
            turnAround: {
                easing: "linear",
                duration: 500,
                after: {
                    animation: "flying"
                },
                timeline: [
                    {
                        start: 0.0,
                        end: 0.05,
                        startFrame: "fly1",
                        endFrame: "turn2"
                    },
                    {
                        start: 0.25,
                        end: 0.5,
                        startFrame: "turn2",
                        endFrame: "turn1"
                    },
                    {
                        start: 0.52,
                        end: 0.55,
                        startFrame: "turn1",
                        endFrame: "turned"
                    },
                    {
                        start: 0.75,
                        end: 0.9,
                        startFrame: "turn1",
                        endFrame: "turn2"
                    },
                    {
                        start: 0.95,
                        end: 1,
                        startFrame: "turn2",
                        endFrame: "fly1"
                    }
                ]
            }
        }
    }
};


var $d4ea5c50a8620f57$exports = {};

$parcel$defineInteropFlag($d4ea5c50a8620f57$exports);

$parcel$export($d4ea5c50a8620f57$exports, "default", () => $d4ea5c50a8620f57$export$2e2bcd8739ae039);
var $d4ea5c50a8620f57$export$2e2bcd8739ae039 = {
    largeDrone: {
        attributes: {
            width: 90,
            height: 70,
            scale: 1,
            ro: [
                45,
                35
            ]
        },
        hitbox: [
            0,
            20,
            80,
            0,
            50,
            60,
            20,
            67,
            0,
            50
        ],
        sprites: [
            [
                "standardLargeDrone",
                {
                    x: 0,
                    y: 0,
                    key: "main",
                    horizon: [
                        0,
                        0
                    ]
                }
            ],
            [
                "standardRocket",
                {
                    x: 22,
                    y: 33,
                    z: 1,
                    key: "rocket",
                    horizon: [
                        0,
                        0
                    ]
                }
            ],
            [
                "standardLargeDrone",
                {
                    x: 36,
                    y: 10,
                    z: 3,
                    key: "wing",
                    horizon: [
                        0,
                        0
                    ],
                    crop: [
                        10,
                        10,
                        47,
                        36
                    ]
                }
            ],
            [
                "sphere2",
                {
                    z: 1,
                    x: 1,
                    y: 27,
                    crop: [
                        0,
                        0,
                        17,
                        21
                    ],
                    key: "eye"
                }
            ]
        ],
        attachHooks: [
            [
                "trail",
                {
                    x: 55,
                    y: 20,
                    z: -2,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "explosion",
                {
                    x: 22,
                    y: 18,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "smoke",
                {
                    x: 22,
                    y: 18,
                    z: -5,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "gun",
                {
                    x: 2,
                    y: 38,
                    z: 2,
                    attachAlign: [
                        "center",
                        "left"
                    ]
                }
            ],
            [
                "rockets",
                {
                    x: 45,
                    y: 40,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "rockets2",
                {
                    x: 45,
                    y: 40,
                    z: 1,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ]
        ],
        frames: {
            background: {
                attributes: {
                    scale: 0.7
                },
                main: {
                    horizon: [
                        0.7,
                        0.7
                    ]
                },
                wing: {
                    horizon: [
                        0.7,
                        0.7
                    ]
                },
                rocket: {
                    horizon: [
                        0.7,
                        0.7
                    ]
                }
            },
            rocketShow: {
                rocket: {
                    y: -10,
                    scale: 0.6,
                    alpha: 1
                }
            },
            rocketReset: {
                rocket: {
                    y: -10,
                    scale: 0.6,
                    alpha: 0
                }
            },
            rocketLoaded: {
                rocket: {
                    y: 0,
                    scale: 1.0,
                    alpha: 1
                }
            },
            rocketShot: {
                rocket: {
                    y: 0,
                    scale: 1.0,
                    alpha: 0
                }
            },
            eyeMove: {
                eye: {
                    x: 10,
                    y: -6,
                    alpha: 0.6
                }
            },
            eyeDisappear: {
                eye: {
                    x: 10,
                    y: -6,
                    alpha: 0.0
                }
            },
            eyeReset: {
                eye: {
                    alpha: 0.0
                }
            },
            eyeAppear: {
                eye: {
                    alpha: 1.0
                }
            },
            damaged1: {
                main: {
                    sprite: "standardLargeDroneDamage1"
                }
            },
            damaged2: {
                main: {
                    sprite: "standardLargeDroneDamage2"
                }
            },
            damaged3: {
                main: {
                    sprite: "standardLargeDroneDamage3"
                }
            },
            turned: {
                flipX: true
            },
            laugh1: {
                attributes: {
                    rotation: 15
                }
            },
            laugh2: {
                attributes: {
                    rotation: 0
                }
            },
            hidden: {
                main: {
                    hidden: true,
                    alpha: 0
                },
                eye: {
                    hidden: true,
                    alpha: 0
                }
            }
        },
        animations: {
            eye: {
                repeat: true,
                easing: "linear",
                duration: 1000,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.7,
                        startFrame: "eyeAppear",
                        endFrame: "eyeMove"
                    },
                    {
                        start: 0.7,
                        end: 0.8,
                        startFrame: "eyeMove",
                        endFrame: "eyeDisappear"
                    },
                    {
                        start: 0.8,
                        end: 0.9,
                        startFrame: "eyeDisappear",
                        endFrame: "eyeReset"
                    },
                    {
                        start: 0.9,
                        end: 1,
                        startFrame: "eyeReset",
                        endFrame: "eyeAppear"
                    }
                ]
            },
            laugh: {
                easing: "linear",
                duration: 1800,
                after: {
                    animation: "eye"
                },
                startEase: {
                    duration: 10,
                    easing: "linear"
                },
                timeline: [
                    {
                        start: 0.0,
                        end: 0.05,
                        startFrame: "eyeAppear",
                        endFrame: "laugh2"
                    },
                    {
                        start: 0.05,
                        end: 0.25,
                        startFrame: "laugh2",
                        endFrame: "laugh1"
                    },
                    {
                        start: 0.25,
                        end: 0.5,
                        startFrame: "laugh1",
                        endFrame: "laugh2"
                    },
                    {
                        start: 0.5,
                        end: 0.75,
                        startFrame: "laugh2",
                        endFrame: "laugh1"
                    },
                    {
                        start: 0.75,
                        end: 1,
                        startFrame: "laugh1",
                        endFrame: "laugh2"
                    }
                ]
            },
            rocketShot: {
                easing: "linear",
                duration: 200,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.2,
                        startFrame: "rocketLoaded",
                        endFrame: "rocketShot"
                    },
                    {
                        start: 0.2,
                        end: 0.5,
                        startFrame: "rocketShot",
                        endFrame: "rocketReset"
                    },
                    {
                        start: 0.5,
                        end: 1.0,
                        startFrame: "rocketReset",
                        endFrame: "rocketShow"
                    }
                ]
            },
            rocketReload: {
                easing: "linear",
                duration: 300,
                after: {
                    animation: "eye"
                },
                timeline: [
                    {
                        start: 0.0,
                        end: 1.0,
                        startFrame: "rocketShow",
                        endFrame: "rocketLoaded"
                    }
                ]
            }
        }
    }
};


var $75318fc9f5439491$exports = {};

$parcel$defineInteropFlag($75318fc9f5439491$exports);

$parcel$export($75318fc9f5439491$exports, "default", () => $75318fc9f5439491$export$2e2bcd8739ae039);
var $75318fc9f5439491$export$2e2bcd8739ae039 = {
    laserCannon: {
        attributes: {
            width: 100,
            height: 42
        },
        hitbox: [
            64,
            24,
            96,
            24,
            96,
            45,
            64,
            45
        ],
        sprites: [
            [
                "turretFoot",
                {
                    x: 64,
                    y: 24,
                    key: "foot"
                }
            ],
            [
                "laserGunCore",
                {
                    x: 35,
                    y: 0,
                    z: 0,
                    crop: [
                        0,
                        13,
                        0,
                        0
                    ],
                    key: "core1",
                    attachTo: "barrel"
                }
            ],
            [
                "laserGunCore",
                {
                    x: 6,
                    y: 0,
                    z: 0,
                    crop: [
                        0,
                        13,
                        0,
                        0
                    ],
                    key: "core2",
                    attachTo: "core1"
                }
            ],
            [
                "laserGunHandle",
                {
                    x: 54,
                    y: 0,
                    key: "barrel",
                    ro: [
                        23,
                        15
                    ],
                    hitbox: [
                        -49,
                        10,
                        40,
                        0,
                        40,
                        28,
                        -49,
                        28
                    ],
                    crop: [
                        0,
                        0,
                        0,
                        22
                    ]
                }
            ],
            [
                "laserGunBarrel",
                {
                    x: 0,
                    y: 0,
                    key: "top",
                    attachTo: "barrel",
                    ro: [
                        30,
                        8
                    ],
                    crop: [
                        0,
                        0,
                        16,
                        0
                    ]
                }
            ],
            [
                "laserGunBarrel",
                {
                    x: 0,
                    y: 15,
                    key: "bottom",
                    attachTo: "barrel",
                    ro: [
                        30,
                        8
                    ],
                    crop: [
                        14,
                        0,
                        0,
                        0
                    ]
                }
            ]
        ],
        attachHooks: [
            [
                "gun",
                {
                    x: 5,
                    y: 15,
                    z: -1,
                    attachAlign: [
                        "center",
                        "left"
                    ],
                    attachTo: "barrel"
                }
            ],
            [
                "charge",
                {
                    x: 62,
                    y: 15,
                    z: 2,
                    attachAlign: [
                        "center",
                        "left"
                    ],
                    attachTo: "barrel"
                }
            ],
            [
                "discharge",
                {
                    x: 62,
                    y: 15,
                    z: -10,
                    attachAlign: [
                        "center",
                        "left"
                    ],
                    attachTo: "barrel"
                }
            ],
            [
                "smoke",
                {
                    x: 80,
                    y: 32,
                    z: 4,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "explosion",
                {
                    x: 80,
                    y: 16,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ]
        ],
        frames: {
            down: {
                barrel: {
                    rotation: 0
                }
            },
            half: {
                barrel: {
                    rotation: 45
                }
            },
            up: {
                barrel: {
                    rotation: 90
                }
            },
            open: {
                top: {
                    rotation: -2,
                    ry: -5
                },
                bottom: {
                    rotation: 2,
                    ry: 5
                },
                core1: {
                    rx: -6
                },
                core2: {
                    overrideColor: null
                }
            },
            charge: {
                core1: {
                    rx: -6,
                    overrideColor: "#ff8040"
                },
                core2: {
                    overrideColor: "#ff8040"
                }
            },
            done: {
                core1: {
                    overrideColor: null
                },
                core2: {
                    overrideColor: null
                }
            },
            close: {
                top: {
                    rotation: 0,
                    ry: 0
                },
                bottom: {
                    rotation: 0,
                    ry: 0
                },
                core1: {
                    rx: 0
                }
            },
            dead1: {
                foot: {
                    z: 5
                },
                barrel: {
                    rotation: -90,
                    y: -100,
                    x: 0,
                    overrideColor: "#606060"
                },
                core1: {
                    x: -3,
                    overrideColor: "#505050"
                },
                core2: {
                    overrideColor: "#505050"
                },
                top: {
                    overrideColor: "#606060"
                },
                bottom: {
                    overrideColor: "#606060"
                }
            },
            dead2: {
                foot: {
                    z: 5
                },
                core1: {
                    x: -3,
                    overrideColor: "#505050"
                },
                core2: {
                    overrideColor: "#505050"
                },
                barrel: {
                    rotation: -180,
                    y: -5,
                    x: -40,
                    overrideColor: "#606060"
                }
            },
            dead3: {
                foot: {
                    z: 5
                },
                core1: {
                    x: -3,
                    overrideColor: "#505050"
                },
                core2: {
                    overrideColor: "#505050"
                },
                barrel: {
                    rotation: -180,
                    y: -9,
                    x: -40,
                    overrideColor: "#606060"
                }
            },
            mirrored: {
                flipX: true
            }
        },
        animations: {
            dead: {
                duration: 1000,
                startEase: {
                    duration: 250,
                    easing: "easeOutQuad"
                },
                easing: "easeInQuad",
                timeline: [
                    {
                        start: 0,
                        end: 0.5,
                        startFrame: "dead1",
                        endFrame: "dead2"
                    },
                    {
                        start: 0.5,
                        end: 0.75,
                        startFrame: "dead2",
                        endFrame: "dead3"
                    },
                    {
                        start: 0.75,
                        end: 1.0,
                        startFrame: "dead3",
                        endFrame: "dead2"
                    }
                ]
            }
        }
    }
};


var $2136d7f40e3f1b71$exports = {};

$parcel$defineInteropFlag($2136d7f40e3f1b71$exports);

$parcel$export($2136d7f40e3f1b71$exports, "default", () => $2136d7f40e3f1b71$export$2e2bcd8739ae039);
var $2136d7f40e3f1b71$export$2e2bcd8739ae039 = {
    mine: {
        attributes: {
            width: 32,
            height: 32,
            ro: [
                16,
                16
            ]
        },
        hitbox: [
            4,
            16,
            16,
            4,
            28,
            16,
            16,
            28
        ],
        sprites: [
            [
                "present",
                {
                    key: "main"
                }
            ]
        ],
        frames: {
            opening: {
                main: {
                    sprite: "present"
                }
            },
            open: {
                main: {
                    sprite: "present"
                }
            },
            blink: {
                main: {
                    sprite: "present"
                }
            },
            hidden: {
                main: {
                    hidden: true,
                    alpha: 0
                }
            }
        },
        animations: {
            opening: {
                easing: "linear",
                duration: 200,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.5,
                        startFrame: "default",
                        endFrame: "opening"
                    },
                    {
                        start: 0.5,
                        end: 1.0,
                        startFrame: "opening",
                        endFrame: "open"
                    }
                ]
            },
            blinking: {
                repeat: true,
                easing: "linear",
                duration: 400,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.5,
                        startFrame: "open",
                        endFrame: "blink"
                    },
                    {
                        start: 0.5,
                        end: 1.0,
                        startFrame: "blink",
                        endFrame: "open"
                    }
                ]
            }
        },
        attachHooks: [
            [
                "explosion",
                {
                    x: 16,
                    y: 16,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ],
            [
                "smoke",
                {
                    x: 16,
                    y: 16,
                    z: -5,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ]
        ]
    }
};


var $a638e2400d2dd800$exports = {};

$parcel$defineInteropFlag($a638e2400d2dd800$exports);

$parcel$export($a638e2400d2dd800$exports, "default", () => $a638e2400d2dd800$export$2e2bcd8739ae039);
var $a638e2400d2dd800$export$2e2bcd8739ae039 = {
    mineCannon: {
        attributes: {
            width: 64,
            height: 42
        },
        hitbox: [
            32,
            24,
            64,
            24,
            64,
            45,
            32,
            45
        ],
        sprites: [
            [
                "turretFoot",
                {
                    x: 32,
                    y: 24,
                    key: "foot"
                }
            ],
            [
                "mineCannon",
                {
                    x: 0,
                    y: 0,
                    key: "barrel",
                    ro: [
                        52,
                        24
                    ],
                    hitbox: [
                        5,
                        10,
                        64,
                        10,
                        64,
                        28,
                        5,
                        28
                    ]
                }
            ],
            [
                "muzzleFlash",
                {
                    x: -20,
                    y: 5,
                    z: -1,
                    alpha: 0,
                    scaleY: 1.5,
                    key: "flash",
                    flipX: true,
                    attachTo: "barrel"
                }
            ]
        ],
        attachHooks: [
            [
                "gun",
                {
                    x: 0,
                    y: 8,
                    z: -20,
                    attachAlign: [
                        "center",
                        "left"
                    ],
                    attachTo: "barrel"
                }
            ],
            [
                "smoke",
                {
                    x: 48,
                    y: 32,
                    z: -1,
                    attachAlign: [
                        "center",
                        "center"
                    ]
                }
            ],
            [
                "explosion",
                {
                    x: 48,
                    y: 16,
                    z: 2,
                    attachAlign: [
                        "center",
                        "center"
                    ],
                    attachTo: "main"
                }
            ]
        ],
        frames: {
            dead: {
                flash: {
                    alpha: 0
                },
                barrel: {
                    alpha: 0
                }
            },
            aimHigh: {
                barrel: {
                    rotation: 50
                }
            },
            aimLow: {
                barrel: {
                    rotation: 10
                }
            },
            shotVis: {
                flash: {
                    alpha: 1
                }
            },
            shotHid: {
                flash: {
                    alpha: 0
                }
            }
        },
        animations: {
            blinking: {
                repeat: false,
                easing: "linear",
                duration: 450,
                timeline: [
                    {
                        start: 0.0,
                        end: 0.1,
                        startFrame: "shotHid",
                        endFrame: "shotVis"
                    },
                    {
                        start: 0.3,
                        end: 1.0,
                        startFrame: "shotVis",
                        endFrame: "shotHid"
                    }
                ]
            }
        }
    }
};


$bc92bf97bbd67eaa$exports = {
    "PlayerShip": {
        "PlayerShip": {
            "js": $ba4e91107864d203$exports
        },
        "portraits": {
            "js": $f5132a8f9dae1e53$exports
        }
    },
    "common": {
        "Cloth": {
            "js": $317abb0c1da52c2a$exports
        },
        "ShipHatch": {
            "js": $70cac90371b91d75$exports
        },
        "weapons": {
            "js": $1b63d9d25a7c6dbd$exports
        },
        "powerups": {
            "powerups": {
                "js": $6fe7ba75bdbfb6ac$exports
            }
        }
    },
    "intro": {
        "IntroShip": {
            "js": $ab4dabc059bdc9d0$exports
        }
    },
    "scenery": {
        "City": {
            "js": $c68cf0c65316759e$exports
        },
        "Ocean": {
            "js": $e57fbf288493eb94$exports
        },
        "backgrounds": {
            "js": $e287e11099e02ed2$exports
        },
        "bridge": {
            "bridge": {
                "js": $cd591da72b1b2478$exports
            }
        }
    },
    "sinterklaas": {
        "garden": {
            "js": $884dfd8a072eb563$exports
        },
        "Bird": {
            "Bird": {
                "js": $3c79767ec3d7f214$exports
            }
        },
        "Fish": {
            "Fish": {
                "js": $3d389ef96ea53877$exports
            }
        },
        "Jinte": {
            "Jinte": {
                "js": $4cbd64c8dcd2549e$exports
            }
        },
        "Seagull": {
            "Seagull": {
                "js": $31e21447f47c1b59$exports
            }
        }
    },
    "test": {
        "Dino": {
            "js": $c7ae14cbda4c00e2$exports
        },
        "test": {
            "js": $6994f3b876a92e60$exports
        }
    },
    "title": {
        "items": {
            "js": $8a2d2a7caa42e361$exports
        }
    },
    "enemies": {
        "BattleShip": {
            "BattleShip": {
                "js": $82291d8c90004f4c$exports
            }
        },
        "BulletCannon": {
            "BulletCannon": {
                "js": $5764ee7959541d57$exports
            }
        },
        "BulletDrone": {
            "bulletDrone": {
                "js": $09aafa564fd606f1$exports
            }
        },
        "Drone": {
            "Drone": {
                "js": $cf5eaad6431281fd$exports
            }
        },
        "DroneShip": {
            "DroneShip": {
                "js": $3c9fd3b6ccb70c88$exports
            }
        },
        "Helicopter": {
            "Helicopter": {
                "js": $1e0e1c26fcec90db$exports
            }
        },
        "LargeDrone": {
            "LargeDrone": {
                "js": $d4ea5c50a8620f57$exports
            }
        },
        "LaserCannon": {
            "LaserCannon": {
                "js": $75318fc9f5439491$exports
            }
        },
        "Mine": {
            "Mine": {
                "js": $2136d7f40e3f1b71$exports
            }
        },
        "MineCannon": {
            "MineCannon": {
                "js": $a638e2400d2dd800$exports
            }
        }
    }
};


var $ce33a8d361355ff3$exports = {};
var $3ec8e97f689d92dd$exports = {};

$parcel$defineInteropFlag($3ec8e97f689d92dd$exports);

$parcel$export($3ec8e97f689d92dd$exports, "default", () => $3ec8e97f689d92dd$export$2e2bcd8739ae039);
var $3ec8e97f689d92dd$export$2e2bcd8739ae039 = {
    PlayerShip: {
        structure: {
            composition: "player.ship",
            components: [
                "ViewportLocked",
                "DamageSupport",
                "SunBlock",
                "LaserSolid"
            ],
            animation: null,
            attachments: {
                mainWeapon: {
                    weapon: {
                        pattern: "player.bullets",
                        target: "PlayerEnemy",
                        angle: 180
                    }
                },
                laserWeapon: {
                    weapon: {
                        pattern: "player.laser",
                        target: "PlayerEnemy",
                        angle: 180
                    }
                },
                trail: null,
                reverseTrail: null,
                reverseTrail2: null
            }
        },
        states: {
            dead: {
                frame: "hidden",
                audio: "explosion",
                attachments: {
                    trail: null,
                    reverseTrail: null,
                    reverseTrail2: null,
                    mainWeapon: null,
                    explosion: {
                        composition: "weapons.largeExplosion",
                        animation: "default"
                    }
                }
            },
            damaged: {
                frame: "damaged"
            },
            shooting: {
                attachments: {
                    mainWeapon: {
                        weapon: {
                            active: true
                        }
                    }
                }
            },
            noShooting: {
                attachments: {
                    mainWeapon: {
                        weapon: {
                            active: false
                        }
                    }
                }
            },
            laserShooting: {
                attachments: {
                    laserWeapon: {
                        weapon: {
                            active: true
                        }
                    }
                }
            },
            noLaserShooting: {
                attachments: {
                    laserCharge: null,
                    laserWeapon: {
                        weapon: {
                            active: false
                        }
                    }
                }
            },
            laserCharge: {
                attachments: {
                    laserCharge: {
                        particles: {
                            emitter: "player.laserCharge"
                        }
                    }
                }
            },
            stopLaserCharge: {
                attachments: {
                    laserCharge: null
                }
            },
            starting: {
                attachments: {
                    trail: {
                        particles: {
                            emitter: [
                                "player.trail",
                                {
                                    particle: {
                                        velocity: 50,
                                        startSize: 10
                                    },
                                    emitter: {
                                        amount: 100
                                    }
                                }
                            ]
                        }
                    },
                    reverseTrail: null,
                    reverseTrail2: null
                }
            },
            flying: {
                attachments: {
                    trail: {
                        particles: {
                            emitter: "player.trail"
                        }
                    },
                    reverseTrail: null,
                    reverseTrail2: null
                }
            },
            reverse: {
                attachments: {
                    trail: null,
                    reverseTrail: {
                        particles: {
                            emitter: "player.reverse"
                        }
                    },
                    reverseTrail2: {
                        particles: {
                            emitter: "player.reverse"
                        }
                    }
                }
            },
            turned: {
                frame: "turned"
            },
            turning: {
                animation: "turnAround"
            },
            turningDamaged: {
                animation: "turnAroundDamaged"
            }
        },
        habitats: [
            {
                name: "Ocean",
                scenery: "City.Ocean",
                position: {
                    x: 200,
                    y: 380
                },
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "City.Sunrise",
                    3
                ]
            }
        ]
    }
};


var $19ff37831358374a$exports = {};

$parcel$defineInteropFlag($19ff37831358374a$exports);

$parcel$export($19ff37831358374a$exports, "default", () => $19ff37831358374a$export$2e2bcd8739ae039);
var $19ff37831358374a$export$2e2bcd8739ae039 = {
    Radar: {
        structure: {
            composition: "droneShip.radar",
            frame: "emitEnd"
        },
        states: {
            pulse: {
                animation: "pulse"
            },
            stopPulse: {
                animation: null,
                frame: "emitEnd"
            },
            dead: {
                animation: null,
                audio: "explosion",
                removeComponents: [
                    "SolidCollision",
                    "PlayerEnemy"
                ],
                frame: "broken",
                attachments: {
                    explosion: {
                        composition: "explosion",
                        animation: "default"
                    },
                    smoke: {
                        particles: {
                            emitter: [
                                "smoke",
                                {
                                    emitter: {
                                        w: 10,
                                        h: 2,
                                        amount: 100,
                                        duration: 6000
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }
    }
};


var $9b163658a808c8ec$exports = {};

$parcel$defineInteropFlag($9b163658a808c8ec$exports);

$parcel$export($9b163658a808c8ec$exports, "default", () => $9b163658a808c8ec$export$2e2bcd8739ae039);
var $9b163658a808c8ec$export$2e2bcd8739ae039 = {
    HeliRocket: {
        structure: {
            composition: "weapons.rocket",
            components: [
                "PlayerHit"
            ],
            frame: "small",
            attachments: {
                trail: {
                    particles: {
                        emitter: "missile.trail"
                    }
                },
                tip: null
            }
        },
        states: {
            hide: {
                attachments: {
                    trail: null,
                    tip: null
                }
            },
            explode: {
                frame: "hidden",
                attachments: {
                    trail: null,
                    tip: {
                        weapon: {
                            pattern: "mine.explosion",
                            target: "PlayerShip",
                            angle: 0,
                            active: true
                        }
                    }
                }
            },
            waterHit: {
                attachments: {
                    trail: null,
                    tip: {
                        particles: {
                            emitter: [
                                "fountain",
                                {
                                    emitter: {
                                        w: 60,
                                        duration: 1000
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "Ocean",
                scenery: "City.Ocean",
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "City.Sunrise",
                    2
                ]
            }
        ]
    }
};


var $dc8264a84b35278b$exports = {};

$parcel$defineInteropFlag($dc8264a84b35278b$exports);

$parcel$export($dc8264a84b35278b$exports, "default", () => $dc8264a84b35278b$export$2e2bcd8739ae039);
var $dc8264a84b35278b$export$2e2bcd8739ae039 = {
    ExtraLife: {
        structure: {
            composition: "powerups.life",
            animation: "default",
            components: [
                "DamageSupport",
                "PlayerHit"
            ]
        },
        states: {
            pickedUp: {
                frame: [
                    "pickedUp",
                    {
                        duration: 300
                    }
                ],
                animation: null,
                audio: "powerup",
                attachments: {
                    explosion: {
                        particles: {
                            emitter: "powerup.pickup"
                        }
                    }
                }
            },
            disappear: {
                animation: null,
                frame: "disappear"
            }
        }
    },
    Bonus: {
        structure: {
            composition: "powerups.bonus",
            animation: "default",
            components: [
                "DamageSupport",
                "PlayerHit"
            ]
        },
        states: {
            pickedUp: {
                frame: [
                    "pickedUp",
                    {
                        duration: 300
                    }
                ],
                animation: null,
                audio: "powerup",
                attachments: {
                    explosion: {
                        particles: {
                            emitter: [
                                "powerup.pickup",
                                {
                                    particle: {
                                        startColor: [
                                            0.65,
                                            0.48,
                                            0.0,
                                            0.6
                                        ],
                                        endColor: [
                                            0.65,
                                            0.48,
                                            0.0,
                                            0
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                }
            },
            disappear: {
                animation: null,
                frame: "disappear"
            }
        }
    },
    Upgrade: {
        structure: {
            composition: "powerups.upgrade",
            animation: "default",
            components: [
                "DamageSupport",
                "PlayerHit"
            ]
        },
        states: {
            pickedUp: {
                frame: [
                    "pickedUp",
                    {
                        duration: 300
                    }
                ],
                animation: null,
                audio: "powerup",
                attachments: {
                    explosion: {
                        particles: {
                            emitter: [
                                "powerup.pickup",
                                {
                                    particle: {
                                        startColor: [
                                            0.1,
                                            0.7,
                                            0.1,
                                            0.6
                                        ],
                                        endColor: [
                                            0.3,
                                            0.7,
                                            0.3,
                                            0
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                }
            },
            disappear: {
                animation: null,
                frame: "disappear"
            }
        }
    }
};


var $d0d481627a125fdf$exports = {};

$parcel$defineInteropFlag($d0d481627a125fdf$exports);

$parcel$export($d0d481627a125fdf$exports, "default", () => $d0d481627a125fdf$export$2e2bcd8739ae039);
var $d0d481627a125fdf$export$2e2bcd8739ae039 = {
    IntroShip: {
        structure: {
            composition: "intro.ship",
            components: [
                "ShipSolid",
                "GravitySolid",
                [
                    "HideBelow",
                    {
                        hideBelow: 540,
                        z: -12
                    }
                ]
            ],
            attachments: {
                bottom: {
                    particles: {
                        emitter: [
                            "waterSplashes",
                            {
                                emitter: {
                                    w: 850,
                                    amount: 300,
                                    warmed: true
                                }
                            }
                        ]
                    }
                },
                hatch1: {
                    composition: "shipHatch"
                },
                hatch2: {
                    composition: "shipHatch",
                    attachments: {
                        payload: {
                            name: "player1",
                            entity: "PlayerShip"
                        }
                    }
                },
                boxLocation1: {
                    entity: "ShipBoxes"
                },
                boxLocation2: {
                    entity: "ShipBoxes"
                },
                heliStart: {
                    entity: "IntroHeli"
                }
            }
        },
        states: {
            t1o: {
                attachments: {
                    hatch1: {
                        frame: "open"
                    }
                }
            },
            t1r: {
                attachments: {
                    hatch1: {
                        frame: "risen"
                    }
                }
            },
            t2o: {
                attachments: {
                    hatch2: {
                        frame: "open"
                    }
                }
            },
            closed: {
                attachments: {
                    hatch2: {
                        frame: "closed"
                    }
                }
            },
            t2r: {
                attachments: {
                    hatch2: {
                        frame: "risen"
                    }
                }
            },
            heliStart: {
                attachments: {
                    heliStart: {
                        state: "liftOff"
                    }
                }
            },
            shipStart: {
                attachments: {
                    hatch2: {
                        frame: "risen",
                        attachments: {
                            player1: {
                                state: "starting"
                            }
                        }
                    }
                }
            },
            shipLiftOff: {
                attachments: {
                    hatch2: {
                        frame: "risen",
                        attachments: {
                            player1: {
                                state: "flying"
                            }
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "Ocean",
                scenery: "City.Ocean",
                position: {
                    rx: -0.3,
                    ry: 0.8
                },
                scrollSpeed: {
                    vx: -40,
                    vy: 0
                },
                background: [
                    "City.Sunrise",
                    0
                ]
            }
        ]
    },
    IntroHeli: {
        structure: {
            composition: "helicopter",
            attributes: {
                scale: 0.8
            }
        },
        states: {
            start: {
                frame: "default",
                animation: false
            },
            liftOff: {
                animation: "flying"
            },
            flying: {
                frame: "tilted",
                animation: "flying"
            }
        }
    },
    IntroHeliBackground: {
        structure: {
            composition: "helicopter",
            frame: "background",
            components: [
                "DamageSupport"
            ]
        },
        states: {
            flying: {
                animation: "flyingBackground"
            },
            shot: {
                animation: "flyingBackground",
                attachments: {
                    sparks: {
                        particles: {
                            emitter: "electric"
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "Ocean",
                scenery: "City.Ocean",
                position: {
                    rx: 0.3,
                    ry: 0.3
                },
                scrollSpeed: {
                    vx: -80,
                    vy: 0
                },
                background: [
                    "City.Sunrise",
                    0
                ]
            }
        ]
    },
    IntroParachute: {
        structure: {
            composition: "intro.parachute"
        },
        habitats: [
            {
                name: "Ocean",
                scenery: "City.Ocean",
                position: {
                    rx: 0.3,
                    ry: 0.3
                },
                scrollSpeed: {
                    vx: -80,
                    vy: 0
                },
                background: [
                    "City.Sunrise",
                    0
                ]
            }
        ]
    },
    ShipBoxes: {
        structure: {
            composition: "intro.boxes",
            components: [
                "GravitySupport",
                "PlayerHit"
            ]
        },
        states: {
            falling: {
                frame: "falling"
            }
        }
    }
};


var $a27c1abf258a97cf$exports = {};

$parcel$defineInteropFlag($a27c1abf258a97cf$exports);

$parcel$export($a27c1abf258a97cf$exports, "default", () => $a27c1abf258a97cf$export$2e2bcd8739ae039);
var $a27c1abf258a97cf$export$2e2bcd8739ae039 = {
    Sun: {
        structure: {
            composition: "background.sun",
            components: [
                [
                    "LightGlare",
                    {
                        glareAlphaLink: "glare"
                    }
                ],
                [
                    "Overlap",
                    {
                        checkCollission: "SunBlock",
                        applyAlphaTo: "glare"
                    }
                ]
            ]
        },
        states: {
            full: {
                frame: "full"
            },
            large: {
                frame: "large"
            }
        },
        habitats: []
    },
    Moon: {
        structure: {
            composition: "background.moon"
        },
        states: {
            full: {
                frame: "full"
            },
            large: {
                frame: "large"
            }
        },
        habitats: []
    }
};


var $a91c0a2cc47332d2$exports = {};

$parcel$defineInteropFlag($a91c0a2cc47332d2$exports);

$parcel$export($a91c0a2cc47332d2$exports, "default", () => $a91c0a2cc47332d2$export$2e2bcd8739ae039);
var $a91c0a2cc47332d2$export$2e2bcd8739ae039 = {
    BattleShip: {
        structure: {
            composition: "battleship.deck",
            components: [
                "ShipSolid",
                "GravitySolid",
                [
                    "HideBelow",
                    {
                        hideBelow: 540,
                        z: -12
                    }
                ]
            ],
            attachments: {
                bottom: {
                    particles: {
                        emitter: [
                            "waterSplashes",
                            {
                                emitter: {
                                    warmed: true
                                }
                            }
                        ]
                    }
                },
                cabin1: {
                    composition: "battleship.firstCabin",
                    attachments: {
                        radar: {
                            entity: "Radar"
                        }
                    }
                },
                cabin1burn: null,
                cabin2burn: null,
                cabin2: {
                    composition: "battleship.secondCabin",
                    components: [
                        "DamageSupport"
                    ]
                },
                mineCannon: {
                    entity: "MineCannon"
                },
                // deckGun1: {
                //   entity: "BulletCannon"
                // },
                // deckGun2: {
                //   entity: "BulletCannon"
                // },
                // deckGun3: {
                //   entity: "LaserCannon",
                //   state: "mirrored"
                // },
                package: {
                    composition: "cloth",
                    frame: "medium"
                },
                boxLocation1: {
                    entity: "ShipBoxes"
                },
                boxLocation2: {
                    entity: "ShipBoxes"
                },
                boxLocation3: {
                    composition: "intro.boxes"
                },
                hatch1: {
                    composition: "shipHatch",
                    frame: "open",
                    attachments: {
                        payload: {
                            entity: "PresentGun"
                        }
                    }
                },
                // hatch2: {
                //   composition: "shipHatch",
                //   attachments: {
                //     payload: {
                //       entity: "PresentGun",
                //     },
                //   },
                // },
                hatch3: {
                    composition: "shipHatch",
                    frame: "open",
                    attachments: {
                        payload: {
                            entity: "PresentGun"
                        }
                    }
                },
                // heliPlace1: {
                //   entity: "Helicopter",
                //   state: "landed",
                // },
                // heliPlace2: {
                //   entity: "Helicopter",
                //   state: "landed",
                // },
                engineCore: {
                    composition: "battleship.engine",
                    frame: "perc0"
                }
            }
        },
        states: {
            risen: {
                frame: "risen"
            },
            lowered: {
                frame: "lowered"
            },
            sinking: {
                frame: "sinking"
            },
            t1o: {
                attachments: {
                    hatch1: {
                        frame: "open"
                    }
                }
            },
            t1r: {
                attachments: {
                    hatch1: {
                        frame: "risen"
                    }
                }
            },
            t2o: {
                attachments: {
                    hatch2: {
                        frame: "open"
                    }
                }
            },
            t2r: {
                attachments: {
                    hatch2: {
                        frame: "risen"
                    }
                }
            },
            t3o: {
                attachments: {
                    hatch3: {
                        frame: "open"
                    }
                }
            },
            t3r: {
                attachments: {
                    hatch3: {
                        frame: "risen"
                    }
                }
            },
            engineDoorOpen: {
                audio: "hatch-open",
                attachments: {
                    cabin1: {
                        composition: "battleship.firstCabin"
                    },
                    cabin1burn: null,
                    cabin2burn: null,
                    cabin2: {
                        composition: "battleship.secondCabin",
                        frame: [
                            "open",
                            {
                                easing: "easeInOutQuad",
                                duration: 2000
                            }
                        ]
                    }
                }
            },
            engineTilt: {
                attachments: {
                    cabin1: {
                        composition: "battleship.firstCabin"
                    },
                    cabin1burn: null,
                    cabin2burn: null,
                    cabin2: {
                        composition: "battleship.secondCabin",
                        frame: [
                            "open",
                            {
                                easing: "easeInOutQuad",
                                duration: 2000
                            }
                        ]
                    },
                    engineCore: {
                        composition: "battleship.engine",
                        animation: "heavyShake",
                        attachments: {
                            smoke: {
                                particles: {
                                    emitter: [
                                        "smoke",
                                        {
                                            emitter: {
                                                w: 60,
                                                amount: 50
                                            }
                                        }
                                    ]
                                }
                            }
                        }
                    }
                }
            },
            engineDestroyed: {
                audio: "explosion",
                attachments: {
                    engineCore: {
                        frame: "destroyed",
                        animation: null,
                        attachments: {
                            explosion: {
                                composition: "weapons.largeExplosion",
                                animation: "default"
                            }
                        }
                    }
                }
            },
            packageOpen: {
                attachments: {
                    package: {
                        frame: "down"
                    },
                    laserField: {
                        entity: "LaserCannonForceField"
                    }
                }
            },
            cabin1Explode: {
                attachments: {
                    cabin1explode: {
                        weapon: {
                            pattern: "building.explosion",
                            target: "PlayerShip",
                            angle: 0,
                            active: true
                        }
                    },
                    cabin1burn: {
                        particles: {
                            emitter: [
                                "smoke",
                                {
                                    emitter: {
                                        w: 160
                                    }
                                }
                            ]
                        }
                    },
                    cabin1burn2: {
                        particles: {
                            emitter: [
                                "largeFire",
                                {
                                    emitter: {
                                        w: 160
                                    }
                                }
                            ]
                        }
                    }
                }
            },
            cabin1Smoke: {
                attachments: {
                    cabin1: {
                        composition: "battleship.firstCabinDestroyed"
                    },
                    cabin1burn: {
                        particles: {
                            emitter: [
                                "smoke",
                                {
                                    emitter: {
                                        w: 160
                                    }
                                }
                            ]
                        }
                    },
                    cabin1burn2: {
                        particles: {
                            emitter: [
                                "largeFire",
                                {
                                    emitter: {
                                        w: 160
                                    }
                                }
                            ]
                        }
                    }
                }
            },
            cabin2Explode: {
                attachments: {
                    cabin2explode: {
                        weapon: {
                            pattern: "building.explosion2",
                            target: "PlayerShip",
                            angle: 0,
                            active: true
                        }
                    },
                    cabin2burn: {
                        particles: {
                            emitter: [
                                "smoke",
                                {
                                    emitter: {
                                        w: 220
                                    }
                                }
                            ]
                        }
                    },
                    cabin2burn2: {
                        particles: {
                            emitter: [
                                "largeFire",
                                {
                                    emitter: {
                                        w: 220
                                    }
                                }
                            ]
                        }
                    }
                }
            },
            cabin2Smoke: {
                attachments: {
                    cabin2: {
                        composition: "battleship.secondCabinDestroyed"
                    },
                    cabin2burn: {
                        particles: {
                            emitter: [
                                "smoke",
                                {
                                    emitter: {
                                        w: 220
                                    }
                                }
                            ]
                        }
                    },
                    cabin2burn2: {
                        particles: {
                            emitter: [
                                "largeFire",
                                {
                                    emitter: {
                                        w: 220
                                    }
                                }
                            ]
                        }
                    },
                    engineCore: null
                }
            }
        },
        habitats: [
            {
                name: "Start",
                scenery: "city.Coast",
                position: {
                    rx: 0.8,
                    ry: 0.7
                },
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    2
                ]
            },
            {
                name: "Fase 1",
                scenery: "city.Coast",
                position: {
                    rx: 0.5,
                    ry: 0.7
                },
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    2
                ]
            },
            {
                name: "Fase 2",
                scenery: "city.Coast",
                position: {
                    rx: -0.17,
                    ry: 0.65
                },
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    2
                ]
            },
            {
                name: "Fase 3",
                scenery: "city.Coast",
                position: {
                    rx: -0.7,
                    ry: 0.7
                },
                scrollSpeed: {
                    vx: 100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    2
                ]
            },
            {
                name: "Sunk",
                scenery: "city.Coast",
                position: {
                    rx: -0.2,
                    ry: 0.85
                },
                scrollSpeed: {
                    vx: 100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    2
                ]
            }
        ]
    }
};


var $d4bc6ae95874281d$exports = {};

$parcel$defineInteropFlag($d4bc6ae95874281d$exports);

$parcel$export($d4bc6ae95874281d$exports, "default", () => $d4bc6ae95874281d$export$2e2bcd8739ae039);
var $d4bc6ae95874281d$export$2e2bcd8739ae039 = {
    BulletCannon: {
        structure: {
            composition: "bulletCannon",
            attachments: {
                gun: {
                    weapon: {
                        pattern: "cannon.gun",
                        target: "PlayerShip",
                        angle: 0,
                        barrel: "barrel"
                    }
                },
                smoke: null
            }
        },
        states: {
            mirrored: {
                frame: "mirrored"
            },
            dead: {
                animation: "dead",
                audio: "explosion",
                removeComponents: [
                    "SolidCollision",
                    "PlayerEnemy"
                ],
                attachments: {
                    smoke: {
                        particles: {
                            emitter: [
                                "smoke",
                                {
                                    emitter: {
                                        w: 10,
                                        h: 2,
                                        amount: 100,
                                        duration: 6000
                                    }
                                }
                            ]
                        }
                    },
                    smoke2: {
                        particles: {
                            emitter: "smokePlume"
                        }
                    },
                    fire: {
                        particles: {
                            emitter: "smallFire"
                        }
                    },
                    gun: null,
                    explosion: {
                        composition: "explosion",
                        animation: "default"
                    }
                }
            },
            shells: {
                attachments: {
                    explosion: {
                        particles: {
                            emitter: [
                                "shells",
                                {
                                    emitter: {
                                        w: 10,
                                        h: 10,
                                        amount: 170,
                                        duration: 200
                                    }
                                }
                            ]
                        }
                    }
                }
            },
            noshells: {
                attachments: {
                    explosion: null
                }
            },
            shooting: {
                attachments: {
                    gun: {
                        weapon: {
                            active: true
                        }
                    }
                }
            }
        }
    }
};


var $2a3727f752eb8912$exports = {};

$parcel$defineInteropFlag($2a3727f752eb8912$exports);

$parcel$export($2a3727f752eb8912$exports, "default", () => $2a3727f752eb8912$export$2e2bcd8739ae039);
var $2a3727f752eb8912$export$2e2bcd8739ae039 = {
    BulletDrone: {
        structure: {
            composition: "bulletDrone",
            components: [
                "DamageSupport",
                "SolidCollision",
                "PlayerEnemy",
                "PlayerHit"
            ],
            attachments: {
                gun: {
                    weapon: {
                        pattern: "bulletDrone.gun",
                        target: "PlayerShip",
                        angle: -5,
                        barrel: "barrel"
                    }
                },
                trail: {
                    particles: {
                        emitter: "bulletDrone.trail"
                    }
                }
            }
        },
        states: {
            turned: {
                frame: "turned"
            },
            dead: {
                frame: "hidden",
                audio: "explosion",
                removeComponents: [
                    "SolidCollision",
                    "PlayerEnemy"
                ],
                attachments: {
                    trail: null,
                    explosion: {
                        composition: "explosion",
                        animation: "default"
                    },
                    smoke: {
                        particles: {
                            emitter: "drone.smoke"
                        }
                    }
                }
            },
            shooting: {
                attachments: {
                    gun: {
                        weapon: {
                            active: true
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "Bay",
                scenery: "city.Bay",
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    3
                ]
            }
        ]
    }
};


var $8b9119bea6f1adc8$exports = {};

$parcel$defineInteropFlag($8b9119bea6f1adc8$exports);

$parcel$export($8b9119bea6f1adc8$exports, "default", () => $8b9119bea6f1adc8$export$2e2bcd8739ae039);
var $8b9119bea6f1adc8$export$2e2bcd8739ae039 = {
    WarDrone: {
        structure: {
            composition: "drone",
            components: [
                "DamageSupport",
                "GravitySupport",
                "SolidCollision",
                "PlayerEnemy",
                "PlayerHit"
            ],
            attachments: {
                trail: {
                    particles: {
                        emitter: "drone.trail"
                    }
                }
            }
        },
        states: {
            damaged: {
                frame: "damaged",
                attachments: {
                    trail: null
                }
            },
            turned: {
                frame: "turned"
            },
            dead: {
                frame: "hidden",
                audio: "explosion",
                removeComponents: [
                    "SolidCollision",
                    "PlayerEnemy"
                ],
                attachments: {
                    trail: null,
                    explosion: {
                        composition: "explosion",
                        animation: "default"
                    },
                    smoke: {
                        particles: {
                            emitter: "drone.smoke"
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "Ocean",
                scenery: "city.Ocean",
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    2
                ]
            },
            {
                name: "Bay",
                scenery: "city.Bay",
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    3
                ]
            }
        ]
    }
};


var $d5152e87f92b65f1$exports = {};

$parcel$defineInteropFlag($d5152e87f92b65f1$exports);

$parcel$export($d5152e87f92b65f1$exports, "default", () => $d5152e87f92b65f1$export$2e2bcd8739ae039);
var $d5152e87f92b65f1$export$2e2bcd8739ae039 = {
    DroneShip: {
        structure: {
            composition: "droneShip.main",
            components: [
                "ShipSolid",
                [
                    "HideBelow",
                    {
                        hideBelow: 540,
                        z: -12
                    }
                ]
            ],
            attachments: {
                bottom: {
                    particles: {
                        emitter: [
                            "waterSplashes",
                            {
                                emitter: {
                                    w: 550,
                                    amount: 300,
                                    warmed: true
                                }
                            }
                        ]
                    }
                },
                hatch1: {
                    composition: "shipHatch"
                },
                gun: {
                    entity: "BulletCannon"
                },
                boxLocation1: {
                    entity: "ShipBoxes"
                },
                radar: {
                    entity: "Radar",
                    state: "stopPulse"
                }
            }
        },
        states: {
            t1o: {
                attachments: {
                    hatch1: {
                        frame: "open"
                    }
                }
            },
            t1r: {
                attachments: {
                    hatch1: {
                        frame: "risen"
                    }
                }
            },
            activateGun: {
                attachments: {
                    gun: {
                        state: "shooting"
                    }
                }
            },
            deactivateGun: {
                attachments: {
                    gun: {
                        state: "default"
                    }
                }
            },
            gunDestroyed: {
                attachments: {
                    gun: {
                        state: "dead"
                    }
                }
            },
            radarPulse: {
                attachments: {
                    radar: {
                        state: "pulse"
                    }
                }
            },
            radarStopPulse: {
                attachments: {
                    radar: {
                        state: "stopPulse"
                    }
                }
            },
            radarDestroyed: {
                attachments: {
                    radar: {
                        state: "dead"
                    }
                }
            }
        },
        habitats: [
            {
                name: "Ocean",
                scenery: "city.Ocean",
                position: {
                    rx: 0.3,
                    ry: 0.7
                },
                scrollSpeed: {
                    vx: -40,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    1
                ]
            }
        ]
    }
};


var $7d5b81f324f2d76b$exports = {};

$parcel$defineInteropFlag($7d5b81f324f2d76b$exports);

$parcel$export($7d5b81f324f2d76b$exports, "default", () => $7d5b81f324f2d76b$export$2e2bcd8739ae039);
var $7d5b81f324f2d76b$export$2e2bcd8739ae039 = {
    Helicopter: {
        structure: {
            composition: "helicopter",
            components: [
                "DamageSupport",
                "GravitySupport",
                "SunBlock"
            ],
            attachments: {
                gun: {
                    weapon: {
                        pattern: "heli.gun",
                        target: "PlayerShip",
                        angle: -5,
                        barrel: "barrel"
                    }
                },
                rockets: {
                    weapon: {
                        pattern: "heli.rocket",
                        target: "PlayerShip"
                    }
                },
                smoke: null
            }
        },
        states: {
            damaged: {
                frame: "damaged"
            },
            fire: {
                attachments: {
                    fire: {
                        particles: {
                            emitter: "smallFire"
                        }
                    },
                    smoke2: {
                        particles: {
                            emitter: "smokePlume"
                        }
                    }
                }
            },
            crashed: {
                frame: "damaged",
                attachments: {
                    smoke: {
                        particles: {
                            emitter: [
                                "smoke",
                                {
                                    emitter: {
                                        w: 50,
                                        h: 10,
                                        amount: 100,
                                        duration: 2000
                                    }
                                }
                            ]
                        }
                    }
                }
            },
            landed: {
                frame: "landed"
            },
            foreground: {
                frame: "foreground"
            },
            dead: {
                frame: "damaged",
                animation: null,
                audio: "explosion",
                removeComponents: [
                    "SolidCollision",
                    "PlayerEnemy"
                ],
                attachments: {
                    rockets: {
                        weapon: {
                            active: false
                        },
                        composition: "explosion",
                        animation: "default"
                    },
                    smoke: {
                        particles: {
                            emitter: [
                                "smoke",
                                {
                                    emitter: {
                                        w: 50,
                                        h: 10,
                                        amount: 100
                                    }
                                }
                            ]
                        }
                    },
                    gun: null
                }
            },
            flying: {
                animation: "flying"
            },
            toForeground: {
                animation: "turning"
            },
            tilted: {
                frame: "tilted"
            },
            leveled: {
                frame: "leveled"
            },
            turning: {
                animation: "turnAround",
                gun: {
                    weapon: {
                        active: false
                    }
                },
                rockets: {
                    weapon: {
                        active: false
                    }
                }
            },
            shooting: {
                animation: "flying",
                attachments: {
                    gun: {
                        weapon: {
                            active: true
                        }
                    },
                    rockets: {
                        weapon: {
                            active: true
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "Ocean",
                scenery: "city.Ocean",
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    1
                ]
            }
        ]
    }
};


var $d3ba333e7b91281f$exports = {};

$parcel$defineInteropFlag($d3ba333e7b91281f$exports);

$parcel$export($d3ba333e7b91281f$exports, "default", () => $d3ba333e7b91281f$export$2e2bcd8739ae039);
var $d3ba333e7b91281f$export$2e2bcd8739ae039 = {
    LargeDrone: {
        structure: {
            composition: "largeDrone",
            components: [
                "DamageSupport",
                "GravitySupport",
                "SolidCollision",
                "PlayerEnemy"
            ],
            attachments: {
                trail: {
                    particles: {
                        emitter: "largeDrone.trail"
                    }
                },
                rockets: {
                    weapon: {
                        pattern: "largeDrone.homingRocket",
                        target: "PlayerShip"
                    }
                },
                rockets2: {
                    weapon: {
                        pattern: "largeDrone.rockets",
                        target: "PlayerShip"
                    }
                }
            }
        },
        states: {
            eyeMove: {
                animation: "eye"
            },
            laugh: {
                animation: "laugh",
                audio: "laugh"
            },
            reload: {
                animation: "rocketReload"
            },
            shootRockets: {
                attachments: {
                    rockets: {
                        weapon: {
                            active: true,
                            maxBursts: 1
                        }
                    }
                }
            },
            rocketStrike: {
                attachments: {
                    rockets2: {
                        weapon: {
                            active: true,
                            maxBursts: 1
                        }
                    }
                }
            },
            fireRocket: {
                animation: "rocketShot"
            },
            reloadRocket: {
                animation: "rocketReload"
            },
            damaged: {
                frame: "damaged",
                attachments: {
                    trail: null
                }
            },
            turned: {
                frame: "turned"
            },
            dead: {
                frame: "hidden",
                audio: "explosion",
                removeComponents: [
                    "SolidCollision",
                    "PlayerEnemy"
                ],
                attachments: {
                    trail: null,
                    explosion: {
                        composition: "explosion",
                        animation: "default"
                    },
                    smoke: {
                        particles: {
                            emitter: "drone.smoke"
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "Bridge",
                scenery: "city.Bridge",
                scrollSpeed: {
                    vx: 0,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    3
                ]
            }
        ]
    },
    LargeBackgroundDrone: {
        structure: {
            composition: "largeDrone",
            frame: "background",
            components: [],
            attachments: {
                trail: {
                    particles: {
                        emitter: [
                            "largeDrone.trail",
                            {
                                gravity: [
                                    200,
                                    50
                                ],
                                particle: {
                                    velocity: 15,
                                    startSize: 15,
                                    endSize: 8
                                }
                            }
                        ]
                    }
                },
                gun: {
                    weapon: {
                        pattern: "largeDrone.takeover",
                        target: "IntroHeliBackground"
                    }
                }
            }
        },
        states: {
            eyeMove: {
                animation: "eye"
            },
            turned: {
                frame: "turned"
            },
            shoot: {
                attachments: {
                    gun: {
                        weapon: {
                            active: true
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "Ocean",
                scenery: "city.Ocean",
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    1
                ]
            }
        ]
    }
};


var $b2530249e772abcc$exports = {};

$parcel$defineInteropFlag($b2530249e772abcc$exports);

$parcel$export($b2530249e772abcc$exports, "default", () => $b2530249e772abcc$export$2e2bcd8739ae039);
var $b2530249e772abcc$export$2e2bcd8739ae039 = {
    LaserCannon: {
        structure: {
            composition: "laserCannon",
            attachments: {
                gun: {
                    weapon: {
                        pattern: "cannon.laser",
                        target: "PlayerShip",
                        angle: 0,
                        barrel: "barrel"
                    }
                },
                smoke: null
            }
        },
        states: {
            mirrored: {
                frame: "mirrored"
            },
            close: {
                frame: [
                    "close",
                    {
                        duration: 300
                    }
                ],
                attachments: {
                    gun: null,
                    charge: null
                }
            },
            open: {
                frame: [
                    "open",
                    {
                        duration: 300
                    }
                ]
            },
            charge: {
                attachments: {
                    charge: {
                        particles: {
                            emitter: "laserCharge"
                        }
                    }
                }
            },
            charged: {
                frame: "charge",
                attachments: {
                    charge: null
                }
            },
            discharge: {
                frame: "done",
                attachments: {
                    charge: null,
                    discharge: {
                        particles: {
                            emitter: [
                                "smoke",
                                {
                                    emitter: {
                                        w: 10,
                                        h: 2,
                                        amount: 200,
                                        duration: 300
                                    }
                                }
                            ]
                        }
                    }
                }
            },
            dead: {
                animation: "dead",
                audio: "explosion",
                removeComponents: [
                    "SolidCollision",
                    "PlayerEnemy"
                ],
                attachments: {
                    smoke: {
                        particles: {
                            emitter: [
                                "smoke",
                                {
                                    emitter: {
                                        w: 10,
                                        h: 2,
                                        amount: 100,
                                        duration: 3000
                                    }
                                }
                            ]
                        }
                    },
                    charge: null,
                    gun: null,
                    explosion: {
                        composition: "explosion",
                        animation: "default"
                    }
                }
            },
            shooting: {
                attachments: {
                    gun: {
                        weapon: {
                            active: true
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "test walls",
                scenery: "test.Walls",
                position: {
                    rx: 0.4,
                    ry: 0.6
                },
                scrollSpeed: {
                    vx: 0,
                    vy: 0
                }
            }
        ]
    },
    LaserCannonForceField: {
        structure: {
            particles: {
                emitter: [
                    "forceField",
                    {
                        emitter: {
                            w: 140,
                            h: 75,
                            amount: 200
                        }
                    }
                ]
            },
            components: [
                "SolidCollision"
            ]
        },
        states: {
            stopped: {
                particles: {
                    emitter: [
                        "forceFieldDisperse",
                        {
                            emitter: {
                                w: 140,
                                h: 75,
                                amount: 200,
                                warmed: true
                            }
                        }
                    ]
                }
            },
            started: {
                particles: {
                    active: true
                }
            }
        }
    }
};


var $bc7b9a7902d8f674$exports = {};

$parcel$defineInteropFlag($bc7b9a7902d8f674$exports);

$parcel$export($bc7b9a7902d8f674$exports, "default", () => $bc7b9a7902d8f674$export$2e2bcd8739ae039);
var $bc7b9a7902d8f674$export$2e2bcd8739ae039 = {
    Mine: {
        structure: {
            composition: "mine",
            components: [
                [
                    "DamageSupport",
                    {
                        weight: 20
                    }
                ],
                "SolidCollision",
                [
                    "SubmergeSupport",
                    {
                        submergeSprite: "shadow"
                    }
                ],
                "PlayerEnemy",
                [
                    "Rotating",
                    {
                        vr: 0
                    }
                ]
            ],
            attachments: {
                explosion: {}
            }
        },
        states: {
            rotate: {
                components: [
                    [
                        "Rotating",
                        {
                            vr: 40
                        }
                    ]
                ]
            },
            open: {
                animation: "opening"
            },
            blinking: {
                components: [
                    [
                        "Rotating",
                        {
                            vr: 120
                        }
                    ]
                ],
                animation: "blinking"
            },
            dead: {
                components: [
                    [
                        "Rotating",
                        {
                            vr: 0
                        }
                    ]
                ],
                frame: "hidden",
                removeComponents: [
                    "SolidCollision",
                    "PlayerEnemy"
                ],
                attachments: {
                    explosion: {
                        weapon: {
                            pattern: "mine.explosion",
                            target: "Jinte",
                            angle: 0,
                            active: true
                        }
                    },
                    smoke: {
                        particles: {
                            emitter: [
                                "drone.smoke",
                                {
                                    emitter: {
                                        w: 60,
                                        h: 60,
                                        amount: 450,
                                        duration: 600
                                    },
                                    particle: {
                                        startSize: 30,
                                        endSize: 20
                                    }
                                }
                            ]
                        }
                    }
                }
            },
            explode: {
                components: [
                    [
                        "Rotating",
                        {
                            vr: 0
                        }
                    ]
                ],
                frame: "hidden",
                removeComponents: [
                    "SolidCollision",
                    "PlayerEnemy"
                ],
                attachments: {
                    explosion: {
                        weapon: {
                            pattern: "mine.blast",
                            target: "Jinte",
                            angle: 0,
                            active: true
                        }
                    },
                    smoke: {
                        particles: {
                            emitter: [
                                "drone.smoke",
                                {
                                    emitter: {
                                        w: 60,
                                        h: 60,
                                        amount: 450,
                                        duration: 600
                                    },
                                    particle: {
                                        startSize: 30,
                                        endSize: 20
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "Ocean",
                scenery: "city.Ocean",
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    2
                ]
            },
            {
                name: "Bay",
                scenery: "city.Bay",
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    3
                ]
            }
        ]
    }
};


var $942e1f6f8bb728ca$exports = {};

$parcel$defineInteropFlag($942e1f6f8bb728ca$exports);

$parcel$export($942e1f6f8bb728ca$exports, "default", () => $942e1f6f8bb728ca$export$2e2bcd8739ae039);
var $942e1f6f8bb728ca$export$2e2bcd8739ae039 = {
    MineCannon: {
        structure: {
            composition: "mineCannon",
            attachments: {
                smoke: null
            }
        },
        states: {
            dead: {
                frame: [
                    "dead",
                    {
                        duration: 0
                    }
                ],
                animation: null,
                audio: "explosion",
                removeComponents: [
                    "SolidCollision",
                    "PlayerEnemy"
                ],
                attachments: {
                    smoke: {
                        particles: {
                            emitter: [
                                "smoke",
                                {
                                    emitter: {
                                        w: 10,
                                        h: 2,
                                        amount: 100,
                                        duration: 3000
                                    }
                                }
                            ]
                        }
                    },
                    gun: null,
                    explosion: {
                        composition: "explosion",
                        animation: "default"
                    }
                }
            },
            aimLow: {
                frame: [
                    "aimLow",
                    {
                        duration: 1500
                    }
                ]
            },
            aimHigh: {
                frame: [
                    "aimHigh",
                    {
                        duration: 1500
                    }
                ]
            },
            shoot: {
                animation: "blinking",
                audio: "explosion"
            }
        }
    }
};


var $4b2cd588be957667$exports = {};

$parcel$defineInteropFlag($4b2cd588be957667$exports);

$parcel$export($4b2cd588be957667$exports, "default", () => $4b2cd588be957667$export$2e2bcd8739ae039);
var $4b2cd588be957667$export$2e2bcd8739ae039 = {
    WarBird: {
        structure: {
            composition: "bird",
            components: [
                "DamageSupport",
                "GravitySupport",
                "SolidCollision",
                "SunBlock",
                "PlayerEnemy",
                "PlayerHit"
            ],
            attachments: {
                trail: {
                    particles: {
                        emitter: "bird.trail"
                    }
                }
            }
        },
        states: {
            damaged: {
                frame: "damaged",
                attachments: {
                    trail: null
                }
            },
            turned: {
                frame: "turned"
            },
            dead: {
                frame: "hidden",
                audio: "explosion",
                removeComponents: [
                    "SolidCollision",
                    "PlayerEnemy"
                ],
                attachments: {
                    trail: null,
                    explosion: {
                        composition: "explosion",
                        animation: "default"
                    },
                    smoke: {
                        particles: {
                            emitter: "drone.smoke"
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "Garden",
                scenery: "garden.Grass",
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    2
                ]
            },
            {
                name: "Bay",
                scenery: "city.Bay",
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    3
                ]
            }
        ]
    }
};


var $a2625097cf22687b$exports = {};

$parcel$defineInteropFlag($a2625097cf22687b$exports);

$parcel$export($a2625097cf22687b$exports, "default", () => $a2625097cf22687b$export$2e2bcd8739ae039);
var $a2625097cf22687b$export$2e2bcd8739ae039 = {
    WarFish: {
        structure: {
            composition: "fish",
            components: [
                "DamageSupport",
                "GravitySupport",
                "SolidCollision",
                "SunBlock",
                "PlayerEnemy",
                "PlayerHit"
            ],
            attachments: {
                trail: {
                    particles: {
                        emitter: "fish.trail"
                    }
                }
            }
        },
        states: {
            damaged: {
                frame: "damaged"
            },
            turned: {
                frame: "turned"
            },
            dead: {
                frame: "hidden",
                audio: "explosion",
                removeComponents: [
                    "SolidCollision",
                    "PlayerEnemy"
                ],
                attachments: {
                    trail: null,
                    explosion: {
                        composition: "explosion",
                        animation: "default"
                    },
                    smoke: {
                        particles: {
                            emitter: "drone.smoke"
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "Garden",
                scenery: "garden.Pond",
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunset",
                    1
                ]
            },
            {
                name: "Bay",
                scenery: "city.Bay",
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    3
                ]
            }
        ]
    }
};


var $4391112ce0d201dd$exports = {};

$parcel$defineInteropFlag($4391112ce0d201dd$exports);

$parcel$export($4391112ce0d201dd$exports, "default", () => $4391112ce0d201dd$export$2e2bcd8739ae039);
var $4391112ce0d201dd$export$2e2bcd8739ae039 = {
    House: {
        structure: {
            composition: "town.roof",
            components: [
                "ShipSolid"
            ],
            attachments: {
                chimneyLoc: {
                    composition: "town.chimney",
                    attachments: {
                        smokeLoc: {
                            particles: {
                                emitter: [
                                    "smokePlume",
                                    {
                                        emitter: {
                                            warmed: true
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        },
        states: {
            dead: {
                animation: null,
                audio: "explosion",
                attachments: {
                    explosionLoc: {
                        composition: "explosion",
                        animation: "default"
                    },
                    chimneyLoc: null
                }
            }
        },
        habitats: [
            {
                name: "Town",
                scenery: "town.RoofTops",
                position: {
                    rx: 0.3,
                    ry: 0.6
                },
                scrollSpeed: {
                    vx: -40,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    4
                ]
            }
        ]
    },
    PresentGun: {
        structure: {
            composition: "town.chimneyMini",
            attachments: {
                gunLoc: {
                    weapon: {
                        pattern: "chimney.presents",
                        target: "Jinte"
                    }
                }
            }
        },
        states: {
            shooting: {
                animation: "shoot",
                attachments: {
                    gunLoc: {
                        weapon: {
                            active: true
                        }
                    }
                }
            },
            dead: {
                animation: null,
                frame: "dead",
                audio: "explosion",
                attachments: {
                    explosionLoc: {
                        composition: "explosion",
                        animation: "default"
                    },
                    gunLoc: null
                }
            }
        }
    },
    HouseHostile: {
        structure: {
            composition: "town.roof",
            components: [
                "ShipSolid"
            ],
            attachments: {
                chimneyLoc: {
                    composition: "town.chimney",
                    attachments: {
                        gunLoc: {
                            weapon: {
                                pattern: "chimney.presents",
                                target: "Jinte"
                            }
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "Town",
                scenery: "town.RoofTops",
                position: {
                    rx: 0.3,
                    ry: 0.6
                },
                scrollSpeed: {
                    vx: -40,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    4
                ]
            }
        ],
        states: {
            shooting: {
                attachments: {
                    chimneyLoc: {
                        animation: "shoot",
                        attachments: {
                            gunLoc: {
                                weapon: {
                                    active: true
                                }
                            }
                        }
                    }
                }
            },
            dead: {
                animation: null,
                audio: "explosion",
                attachments: {
                    explosionLoc: {
                        composition: "explosion",
                        animation: "default"
                    },
                    chimneyLoc: null
                }
            }
        }
    }
};


var $3fb7c1330f1bae53$exports = {};

$parcel$defineInteropFlag($3fb7c1330f1bae53$exports);

$parcel$export($3fb7c1330f1bae53$exports, "default", () => $3fb7c1330f1bae53$export$2e2bcd8739ae039);
var $3fb7c1330f1bae53$export$2e2bcd8739ae039 = {
    Jinte: {
        structure: {
            composition: "jinte",
            components: [
                "ViewportLocked",
                "DamageSupport",
                "SunBlock",
                "LaserSolid"
            ],
            animation: null,
            attachments: {
                gun: {
                    weapon: {
                        pattern: "player.carrots",
                        target: "PlayerEnemy",
                        angle: 180
                    }
                },
                frontFoot: null,
                backFoot: null
            }
        },
        states: {
            dead: {
                frame: "hidden",
                audio: "explosion",
                attachments: {
                    frontFoot: null,
                    backFoot: null,
                    gun: null,
                    center: {
                        composition: "weapons.largeExplosion",
                        animation: "default"
                    }
                }
            },
            damaged: {
                frame: "damaged"
            },
            shooting: {
                attachments: {
                    gun: {
                        weapon: {
                            active: true
                        }
                    }
                }
            },
            noShooting: {
                attachments: {
                    gun: {
                        weapon: {
                            active: false
                        }
                    }
                }
            },
            starting: {
                animation: "flying",
                attachments: {
                    frontFoot: {
                        particles: {
                            emitter: [
                                "jinte.trail",
                                {
                                    particle: {
                                        velocity: 50,
                                        startSize: 10
                                    },
                                    emitter: {
                                        amount: 100
                                    }
                                }
                            ]
                        }
                    },
                    backFoot: {
                        particles: {
                            emitter: [
                                "jinte.trail",
                                {
                                    particle: {
                                        velocity: 50,
                                        startSize: 10
                                    },
                                    emitter: {
                                        amount: 100
                                    }
                                }
                            ]
                        }
                    }
                }
            },
            flying: {
                animation: "flying",
                attachments: {
                    frontFoot: {
                        particles: {
                            emitter: "jinte.trail"
                        }
                    },
                    backFoot: {
                        particles: {
                            emitter: "jinte.trail"
                        }
                    }
                }
            },
            reverse: {
                attachments: {}
            },
            turned: {
                frame: "turned"
            },
            turning: {
                animation: "turnAround"
            },
            turningDamaged: {
                animation: "turnAroundDamaged"
            }
        },
        habitats: [
            {
                name: "Ocean",
                scenery: "City.Ocean",
                position: {
                    x: 200,
                    y: 380
                },
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "City.Sunrise",
                    3
                ]
            }
        ]
    }
};


var $c80127b12be5a001$exports = {};

$parcel$defineInteropFlag($c80127b12be5a001$exports);

$parcel$export($c80127b12be5a001$exports, "default", () => $c80127b12be5a001$export$2e2bcd8739ae039);
var $c80127b12be5a001$export$2e2bcd8739ae039 = {
    Seagull: {
        structure: {
            composition: "seagull",
            components: [
                "DamageSupport",
                "GravitySupport",
                "SolidCollision",
                "SunBlock",
                "PlayerEnemy",
                "PlayerHit"
            ],
            attachments: {
                gun: {
                    weapon: {
                        pattern: "seagull.flatsCannon",
                        target: "Jinte"
                    }
                }
            }
        },
        states: {
            shooting: {
                attachments: {
                    gun: {
                        weapon: {
                            active: true
                        }
                    }
                }
            },
            damaged: {
                frame: "damaged"
            },
            turned: {
                frame: "turned"
            },
            dead: {
                frame: "hidden",
                audio: "explosion",
                removeComponents: [
                    "SolidCollision",
                    "PlayerEnemy"
                ],
                attachments: {
                    gun: null,
                    explosion: {
                        composition: "explosion",
                        animation: "default"
                    },
                    smoke: {
                        particles: {
                            emitter: "drone.smoke"
                        }
                    }
                }
            }
        },
        habitats: [
            {
                name: "Bay",
                scenery: "city.Bay",
                scrollSpeed: {
                    vx: -100,
                    vy: 0
                },
                background: [
                    "city.Sunrise",
                    3
                ]
            }
        ]
    }
};


$ce33a8d361355ff3$exports = {
    "PlayerShip": {
        "PlayerShip": {
            "js": $3ec8e97f689d92dd$exports
        }
    },
    "common": {
        "Radar": {
            "js": $19ff37831358374a$exports
        },
        "Weapons": {
            "js": $9b163658a808c8ec$exports
        },
        "powerups": {
            "Powerups": {
                "js": $dc8264a84b35278b$exports
            }
        }
    },
    "intro": {
        "IntroShip": {
            "js": $d0d481627a125fdf$exports
        }
    },
    "scenery": {
        "Sun": {
            "js": $a27c1abf258a97cf$exports
        }
    },
    "enemies": {
        "BattleShip": {
            "BattleShip": {
                "js": $a91c0a2cc47332d2$exports
            }
        },
        "BulletCannon": {
            "BulletCannon": {
                "js": $d4bc6ae95874281d$exports
            }
        },
        "BulletDrone": {
            "BulletDrone": {
                "js": $2a3727f752eb8912$exports
            }
        },
        "Drone": {
            "Drone": {
                "js": $8b9119bea6f1adc8$exports
            }
        },
        "DroneShip": {
            "DroneShip": {
                "js": $d5152e87f92b65f1$exports
            }
        },
        "Helicopter": {
            "Helicopter": {
                "js": $7d5b81f324f2d76b$exports
            }
        },
        "LargeDrone": {
            "LargeDrone": {
                "js": $d3ba333e7b91281f$exports
            }
        },
        "LaserCannon": {
            "LaserCannon": {
                "js": $b2530249e772abcc$exports
            }
        },
        "Mine": {
            "Mine": {
                "js": $bc7b9a7902d8f674$exports
            }
        },
        "MineCannon": {
            "MineCannon": {
                "js": $942e1f6f8bb728ca$exports
            }
        }
    },
    "sinterklaas": {
        "Bird": {
            "Bird": {
                "js": $4b2cd588be957667$exports
            }
        },
        "Fish": {
            "Fish": {
                "js": $a2625097cf22687b$exports
            }
        },
        "House": {
            "House": {
                "js": $4391112ce0d201dd$exports
            }
        },
        "Jinte": {
            "Jinte": {
                "js": $3fb7c1330f1bae53$exports
            }
        },
        "Seagull": {
            "Seagull": {
                "js": $c80127b12be5a001$exports
            }
        }
    }
};


var $88803c0bdfcac99c$exports = {};
var $986497750596b661$exports = {};

$parcel$defineInteropFlag($986497750596b661$exports);

$parcel$export($986497750596b661$exports, "default", () => $986497750596b661$export$2e2bcd8739ae039);
var $986497750596b661$export$2e2bcd8739ae039 = {
    "player.trail": {
        emitter: {
            w: 2,
            h: 2,
            amount: 200,
            fidelity: "high",
            motionLocked: false
        },
        particle: {
            sprite: "explosion7",
            angle: 180,
            angleRandom: 0,
            duration: 500,
            durationRandom: 0,
            velocity: 200,
            velocityRandom: 10,
            startSize: 12,
            endSize: 1,
            startColor: [
                1.0,
                0.8,
                0.5,
                0.6
            ],
            startColorRandom: [
                0,
                0.05,
                0,
                0
            ],
            endColor: [
                0.9,
                0.2,
                0.2,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    "player.trail2": {
        emitter: {
            w: 2,
            h: 2,
            amount: 200,
            fidelity: "high",
            motionLocked: false
        },
        particle: {
            sprite: "explosion7",
            angle: 180,
            angleRandom: 0,
            duration: 500,
            durationRandom: 0,
            velocity: 200,
            velocityRandom: 10,
            startSize: 8,
            endSize: 1,
            startColor: [
                1.0,
                0.8,
                0.5,
                0.6
            ],
            startColorRandom: [
                0,
                0.05,
                0,
                0
            ],
            endColor: [
                0.9,
                0.2,
                0.2,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    "player.reverse": {
        emitter: {
            w: 2,
            h: 2,
            amount: 200,
            fidelity: "high",
            motionLocked: false
        },
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 0,
            duration: 500,
            durationRandom: 0,
            velocity: 200,
            velocityRandom: 10,
            startSize: 5,
            endSize: 1,
            startColor: [
                1.0,
                0.8,
                0.5,
                0.6
            ],
            startColorRandom: [
                0,
                0.05,
                0,
                0
            ],
            endColor: [
                0.9,
                0.2,
                0.2,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    "player.laserCharge": {
        emitter: {
            w: 2,
            h: 2,
            amount: 70,
            reverse: true
        },
        gravity: [
            0,
            10
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 60,
            duration: 500,
            durationRandom: 0,
            velocity: 100,
            velocityRandom: 15,
            startSize: 6,
            startSizeRandom: 1,
            endSize: 1,
            endSizeRandom: 0,
            startColor: [
                1.0,
                0.2,
                0.0,
                0.8
            ],
            startColorRandom: [
                0.9,
                0,
                0,
                0
            ],
            endColor: [
                1.0,
                1.0,
                0.3,
                0.2
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    }
};


var $44a0cb61d8c9492a$exports = {};

$parcel$defineInteropFlag($44a0cb61d8c9492a$exports);

$parcel$export($44a0cb61d8c9492a$exports, "default", () => $44a0cb61d8c9492a$export$2e2bcd8739ae039);
var $44a0cb61d8c9492a$export$2e2bcd8739ae039 = {
    "dust.bridge": {
        emitter: {
            w: 1024,
            h: 10,
            amount: 300,
            fidelity: "low",
            duration: 3000
        },
        gravity: [
            0,
            95
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            duration: 4000,
            angleRandom: 20,
            velocity: 10,
            startSize: 40,
            startSizeRandom: 15,
            endSize: 20,
            endSizeRandom: 5,
            startColor: [
                0.17,
                0.17,
                0.17,
                0.4
            ],
            endColor: [
                0.17,
                0.17,
                0.17,
                0.0
            ]
        }
    }
};


var $642ceac27091f93f$exports = {};

$parcel$defineInteropFlag($642ceac27091f93f$exports);

$parcel$export($642ceac27091f93f$exports, "default", () => $642ceac27091f93f$export$2e2bcd8739ae039);
var $642ceac27091f93f$export$2e2bcd8739ae039 = {
    waterSplashes: {
        emitter: {
            w: 1300,
            h: 10,
            amount: 500,
            fidelity: "low"
        },
        gravity: [
            -80,
            5
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 20,
            velocity: 10,
            startSize: 30,
            endSize: 30,
            startColor: [
                1.0,
                1.0,
                1.0,
                0.8
            ],
            endColor: [
                0.8,
                0.8,
                0.8,
                0
            ],
            endColorRandom: [
                0.1,
                0.1,
                0,
                0.2
            ]
        }
    },
    "missile.trail": {
        emitter: {
            w: 2,
            h: 2,
            amount: 200,
            fidelity: "high",
            motionLocked: false
        },
        gravity: [
            0,
            0
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 0,
            duration: 1300,
            durationRandom: 0,
            velocity: 0,
            velocityRandom: 0,
            startSize: 10,
            endSize: 1,
            startColor: [
                0.7,
                0.7,
                0.5,
                0.6
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.3,
                0.3,
                0.3,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    explosion: {
        emitter: {
            w: 2,
            h: 2,
            amount: 200,
            duration: 500
        },
        gravity: [
            0,
            40
        ],
        particle: {
            sprite: "explosion7",
            angles: [
                0,
                20,
                100,
                180,
                230,
                330
            ],
            duration: 1000,
            durationRandom: 0,
            velocity: 50,
            velocityRandom: 10,
            startSize: 30,
            endSize: 1,
            startColor: [
                0.3,
                0.2,
                0.1,
                1
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.1,
                0.1,
                0.1,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    electric: {
        emitter: {
            w: 70,
            h: 15,
            amount: 150,
            duration: 1500
        },
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 20,
            duration: 800,
            durationRandom: 0,
            velocity: 20,
            velocityRandom: 0,
            startSize: 4,
            startSizeRandom: 2,
            endSize: 2,
            endSizeRandom: 1,
            startColor: [
                1.0,
                1.0,
                0.0,
                0.4
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.2,
                0.5,
                1.0,
                0.1
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    sparks: {
        emitter: {
            w: 2,
            h: 2,
            amount: 200,
            duration: 350
        },
        gravity: [
            0,
            200
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 70,
            duration: 500,
            durationRandom: 0,
            velocity: 90,
            velocityRandom: 0,
            startSize: 2,
            startSizeRandom: 0,
            endSize: 3,
            endSizeRandom: 2,
            startColor: [
                1.0,
                1.0,
                0.0,
                0.6
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                1.0,
                1.0,
                0.0,
                0.2
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    laserHit: {
        emitter: {
            w: 4,
            h: 4,
            amount: 200,
            duration: 500
        },
        gravity: [
            0,
            100
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 70,
            duration: 500,
            durationRandom: 0,
            velocity: 50,
            velocityRandom: 0,
            startSize: 10,
            startSizeRandom: 4,
            endSize: 4,
            endSizeRandom: 2,
            startColor: [
                1.0,
                0.4,
                0.0,
                0.8
            ],
            startColorRandom: [
                0.2,
                0.1,
                0.0,
                0
            ],
            endColor: [
                1.0,
                0.4,
                0.0,
                0.2
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    smoke: {
        emitter: {
            w: 160,
            h: 20,
            amount: 300
        },
        gravity: [
            20,
            -60
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 20,
            duration: 2500,
            durationRandom: 500,
            velocity: 10,
            startSize: 30,
            endSize: 80,
            startColor: [
                0.1,
                0.1,
                0.1,
                1
            ],
            startColorRandom: [
                0,
                0,
                0,
                0.2
            ],
            endColor: [
                0.1,
                0.1,
                0.1,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    largeFire: {
        emitter: {
            w: 200,
            h: 2,
            amount: 70,
            fidelity: "high"
        },
        gravity: [
            0,
            -300
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 200,
            duration: 750,
            durationRandom: 300,
            velocity: 20,
            velocityRandom: 20,
            startSize: 30,
            endSize: 3,
            startColor: [
                0.8,
                0.7,
                0.1,
                0.6
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.8,
                0.7,
                0.1,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    "test.fountain": {
        emitter: {
            w: 10,
            h: 10,
            amount: 300
        },
        gravity: [
            0,
            90
        ],
        particle: {
            sprite: "explosion7",
            angle: -90,
            angleRandom: 50,
            velocity: 120,
            startSize: 10,
            endSize: 10,
            startColor: [
                1,
                1.0,
                1.0,
                0.8
            ],
            startColorRandom: [
                0,
                0.1,
                0,
                0.2
            ],
            endColor: [
                0.1,
                0.1,
                0.1,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0.2
            ]
        }
    },
    forceField: {
        emitter: {
            w: 200,
            h: 150,
            amount: 170
        },
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 180,
            duration: 800,
            velocity: 2,
            startSize: 2,
            endSize: 4,
            startColor: [
                0.7,
                0.7,
                1.0,
                0.8
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.2,
                0.2,
                0.4,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    forceFieldDisperse: {
        emitter: {
            w: 200,
            h: 150,
            amount: 170,
            duration: 1000
        },
        gravity: [
            0,
            -50
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 180,
            duration: 800,
            velocity: 8,
            startSize: 2,
            endSize: 2,
            startColor: [
                0.7,
                0.7,
                1.0,
                0.8
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.8,
                0.9,
                0.3,
                1.0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    smallFire: {
        emitter: {
            w: 2,
            h: 2,
            amount: 50,
            fidelity: "high"
        },
        gravity: [
            0,
            -600
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 200,
            duration: 250,
            durationRandom: 0,
            velocity: 20,
            velocityRandom: 10,
            startSize: 10,
            endSize: 3,
            startColor: [
                0.8,
                0.7,
                0.1,
                0.6
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.8,
                0.7,
                0.1,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    smokePlume: {
        emitter: {
            w: 2,
            h: 2,
            amount: 50,
            fidelity: "high"
        },
        gravity: [
            0,
            -80
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 10,
            duration: 1500,
            durationRandom: 100,
            velocity: 10,
            startSize: 10,
            endSize: 30,
            startColor: [
                0.1,
                0.1,
                0.1,
                0.5
            ],
            startColorRandom: [
                0,
                0,
                0,
                0.1
            ],
            endColor: [
                0.1,
                0.1,
                0.1,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    }
};


var $8a2308f24b99a250$exports = {};

$parcel$defineInteropFlag($8a2308f24b99a250$exports);

$parcel$export($8a2308f24b99a250$exports, "default", () => $8a2308f24b99a250$export$2e2bcd8739ae039);
var $8a2308f24b99a250$export$2e2bcd8739ae039 = {
    "powerup.pickup": {
        emitter: {
            w: 2,
            h: 2,
            amount: 600,
            duration: 200
        },
        gravity: [
            0,
            -50
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 360,
            duration: 1000,
            durationRandom: 0,
            velocity: 120,
            velocityRandom: 40,
            startSize: 15,
            endSize: 5,
            startColor: [
                0.7,
                0.1,
                0.1,
                0.6
            ],
            endColor: [
                0.7,
                0.3,
                0.3,
                0
            ]
        }
    }
};


var $5927e2b7f11cf5b6$exports = {};

$parcel$defineInteropFlag($5927e2b7f11cf5b6$exports);

$parcel$export($5927e2b7f11cf5b6$exports, "default", () => $5927e2b7f11cf5b6$export$2e2bcd8739ae039);
var $5927e2b7f11cf5b6$export$2e2bcd8739ae039 = {
    shells: {
        emitter: {
            w: 10,
            h: 10,
            amount: 170,
            duration: 200
        },
        gravity: [
            0,
            160
        ],
        particle: {
            sprite: "bulletShell",
            angle: -50,
            angleRandom: 20,
            duration: 1200,
            velocity: 120,
            startSize: 20,
            endSize: 20,
            startColor: [
                0.5,
                0.6,
                0.2,
                1.0
            ],
            endColor: [
                0.5,
                0.6,
                0.2,
                0.3
            ]
        }
    }
};


var $9fb277d423f8a41f$exports = {};

$parcel$defineInteropFlag($9fb277d423f8a41f$exports);

$parcel$export($9fb277d423f8a41f$exports, "default", () => $9fb277d423f8a41f$export$2e2bcd8739ae039);
var $9fb277d423f8a41f$export$2e2bcd8739ae039 = {
    "bulletDrone.trail": {
        emitter: {
            w: 2,
            h: 2,
            amount: 50,
            fidelity: "high",
            motionLocked: false
        },
        gravity: [
            0,
            0
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 0,
            duration: 250,
            durationRandom: 0,
            velocity: 0,
            velocityRandom: 10,
            startSize: 10,
            endSize: 1,
            startColor: [
                0.5,
                0.9,
                0.5,
                0.6
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.2,
                0.9,
                0.2,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    "drone.smoke": {
        emitter: {
            w: 2,
            h: 2,
            amount: 400,
            duration: 300
        },
        gravity: [
            -100,
            0
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 360,
            duration: 1800,
            durationRandom: 0,
            velocity: 10,
            velocityRandom: 5,
            startSize: 15,
            endSize: 5,
            startColor: [
                0.05,
                0.05,
                0.05,
                0.6
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.05,
                0.05,
                0.05,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    }
};


var $87ad8fd06141783d$exports = {};

$parcel$defineInteropFlag($87ad8fd06141783d$exports);

$parcel$export($87ad8fd06141783d$exports, "default", () => $87ad8fd06141783d$export$2e2bcd8739ae039);
var $87ad8fd06141783d$export$2e2bcd8739ae039 = {
    "drone.trail": {
        emitter: {
            w: 2,
            h: 2,
            amount: 50,
            fidelity: "high",
            motionLocked: false
        },
        gravity: [
            0,
            0
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 0,
            duration: 250,
            durationRandom: 0,
            velocity: 0,
            velocityRandom: 10,
            startSize: 10,
            endSize: 1,
            startColor: [
                0.5,
                0.5,
                0.9,
                0.6
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.2,
                0.2,
                0.9,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    "drone.smoke": {
        emitter: {
            w: 2,
            h: 2,
            amount: 400,
            duration: 300
        },
        gravity: [
            -100,
            0
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 360,
            duration: 1800,
            durationRandom: 0,
            velocity: 10,
            velocityRandom: 5,
            startSize: 15,
            endSize: 5,
            startColor: [
                0.05,
                0.05,
                0.05,
                0.6
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.05,
                0.05,
                0.05,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    }
};


var $545f5153f097c7a8$exports = {};

$parcel$defineInteropFlag($545f5153f097c7a8$exports);

$parcel$export($545f5153f097c7a8$exports, "default", () => $545f5153f097c7a8$export$2e2bcd8739ae039);
var $545f5153f097c7a8$export$2e2bcd8739ae039 = {
    "largeDrone.trail": {
        emitter: {
            w: 2,
            h: 2,
            amount: 50,
            fidelity: "high"
        },
        gravity: [
            0,
            0
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 0,
            duration: 150,
            durationRandom: 0,
            velocity: 100,
            velocityRandom: 10,
            startSize: 30,
            endSize: 15,
            startColor: [
                0.7,
                0.7,
                0.9,
                0.5
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.35,
                0.35,
                0.45,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    }
};


var $9056151741b58f80$exports = {};

$parcel$defineInteropFlag($9056151741b58f80$exports);

$parcel$export($9056151741b58f80$exports, "default", () => $9056151741b58f80$export$2e2bcd8739ae039);
var $9056151741b58f80$export$2e2bcd8739ae039 = {
    laserCharge: {
        emitter: {
            w: 2,
            h: 2,
            amount: 70,
            reverse: true
        },
        gravity: [
            0,
            10
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 360,
            duration: 800,
            durationRandom: 0,
            velocity: 100,
            velocityRandom: 15,
            startSize: 6,
            startSizeRandom: 1,
            endSize: 1,
            endSizeRandom: 0,
            startColor: [
                1.0,
                0.2,
                0.0,
                0.8
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                1.0,
                1.0,
                0.0,
                0.2
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    }
};


var $ad7932089b142015$exports = {};

$parcel$defineInteropFlag($ad7932089b142015$exports);

$parcel$export($ad7932089b142015$exports, "default", () => $ad7932089b142015$export$2e2bcd8739ae039);
var $ad7932089b142015$export$2e2bcd8739ae039 = {
    "bird.trail": {
        emitter: {
            w: 2,
            h: 2,
            amount: 50,
            fidelity: "high",
            motionLocked: false
        },
        gravity: [
            0,
            0
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 0,
            duration: 350,
            durationRandom: 0,
            velocity: 30,
            velocityRandom: 10,
            startSize: 10,
            endSize: 1,
            startColor: [
                0.9,
                0.9,
                0.5,
                0.6
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.9,
                0.9,
                0.9,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    },
    "drone.smoke": {
        emitter: {
            w: 2,
            h: 2,
            amount: 400,
            duration: 300
        },
        gravity: [
            -100,
            0
        ],
        particle: {
            sprite: "explosion7",
            angle: 0,
            angleRandom: 360,
            duration: 1800,
            durationRandom: 0,
            velocity: 10,
            velocityRandom: 5,
            startSize: 15,
            endSize: 5,
            startColor: [
                0.05,
                0.05,
                0.05,
                0.6
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                0.05,
                0.05,
                0.05,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    }
};


var $549651c09a9170d1$exports = {};

$parcel$defineInteropFlag($549651c09a9170d1$exports);

$parcel$export($549651c09a9170d1$exports, "default", () => $549651c09a9170d1$export$2e2bcd8739ae039);
var $549651c09a9170d1$export$2e2bcd8739ae039 = {
    "fish.trail": {
        emitter: {
            w: 2,
            h: 2,
            amount: 100,
            duration: 6000,
            fidelity: "high",
            motionLocked: false
        },
        gravity: [
            0,
            160
        ],
        particle: {
            sprite: "explosion7",
            angle: 20,
            angleRandom: 0,
            duration: 1550,
            durationRandom: 0,
            velocity: 100,
            velocityRandom: 10,
            startSize: 30,
            endSize: 1,
            startColor: [
                1.0,
                1.0,
                1.0,
                0.6
            ],
            startColorRandom: [
                0,
                0,
                0,
                0
            ],
            endColor: [
                1.0,
                1.0,
                1.0,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    }
};


var $0e8be35fb3631ce8$exports = {};

$parcel$defineInteropFlag($0e8be35fb3631ce8$exports);

$parcel$export($0e8be35fb3631ce8$exports, "default", () => $0e8be35fb3631ce8$export$2e2bcd8739ae039);
var $0e8be35fb3631ce8$export$2e2bcd8739ae039 = {
    "jinte.trail": {
        emitter: {
            w: 2,
            h: 2,
            amount: 100,
            fidelity: "high",
            motionLocked: false
        },
        particle: {
            sprite: "explosion7",
            angle: 180,
            angleRandom: 0,
            duration: 1500,
            durationRandom: 0,
            velocity: 80,
            velocityRandom: 10,
            startSize: 12,
            endSize: 7,
            startColor: [
                0.9,
                0.9,
                0.9,
                0.6
            ],
            startColorRandom: [
                0,
                0.05,
                0,
                0
            ],
            endColor: [
                0.7,
                0.7,
                0.7,
                0
            ],
            endColorRandom: [
                0,
                0,
                0,
                0
            ]
        }
    }
};


$88803c0bdfcac99c$exports = {
    "PlayerShip": {
        "player": {
            "js": $986497750596b661$exports
        }
    },
    "common": {
        "dust": {
            "js": $44a0cb61d8c9492a$exports
        },
        "unsorted": {
            "js": $642ceac27091f93f$exports
        },
        "powerups": {
            "powerups": {
                "js": $8a2308f24b99a250$exports
            }
        }
    },
    "enemies": {
        "BulletCannon": {
            "bulletCannon": {
                "js": $5927e2b7f11cf5b6$exports
            }
        },
        "BulletDrone": {
            "bulletDrone": {
                "js": $9fb277d423f8a41f$exports
            }
        },
        "Drone": {
            "drone": {
                "js": $87ad8fd06141783d$exports
            }
        },
        "LargeDrone": {
            "largeDrone": {
                "js": $545f5153f097c7a8$exports
            }
        },
        "LaserCannon": {
            "laserCannon": {
                "js": $9056151741b58f80$exports
            }
        }
    },
    "sinterklaas": {
        "Bird": {
            "bird": {
                "js": $ad7932089b142015$exports
            }
        },
        "Fish": {
            "fish": {
                "js": $549651c09a9170d1$exports
            }
        },
        "Jinte": {
            "jinte": {
                "js": $0e8be35fb3631ce8$exports
            }
        }
    }
};


var $ee654c5ed655ef01$exports = {};
var $6913c360227a5718$exports = {};

$parcel$defineInteropFlag($6913c360227a5718$exports);

$parcel$export($6913c360227a5718$exports, "default", () => $6913c360227a5718$export$2e2bcd8739ae039);
var $6913c360227a5718$export$2e2bcd8739ae039 = {
    "mineCannon.lowShot": {
        path: [
            {
                x: 0.8,
                y: 0.6,
                events: [
                    [
                        0.8,
                        {
                            event: "Loose"
                        }
                    ]
                ]
            },
            {
                x: 0.7,
                y: 0.6
            },
            {
                x: 0.6,
                y: 0.9
            }
        ]
    },
    "mineCannon.highShot": {
        path: [
            {
                x: 0.8,
                y: 0.6,
                events: [
                    [
                        0.8,
                        {
                            event: "Loose"
                        }
                    ]
                ]
            },
            {
                x: 0.6,
                y: 0.3
            },
            {
                x: 0.3,
                y: 0.5
            },
            {
                x: 0.1,
                y: 0.9
            }
        ]
    },
    sunset: {
        path: [
            {
                x: 0.4,
                y: 0.1
            },
            {
                x: 0.8,
                y: 0.3
            },
            {
                x: 0.9,
                y: 0.7
            }
        ]
    },
    sunrise: {
        path: [
            {
                x: 0.9,
                y: 0.7
            },
            {
                x: 0.8,
                y: 0.3
            },
            {
                x: 0.4,
                y: 0.1
            }
        ]
    },
    moonrise: {
        path: [
            {
                x: 0.1,
                y: 0.7
            },
            {
                x: 0.2,
                y: 0.3
            },
            {
                x: 0.3,
                y: 0.1
            }
        ]
    },
    evadePattern: {
        path: [
            {
                x: 0.5,
                y: 0.5
            },
            {
                x: 0.9,
                y: 0.2
            },
            {
                x: 0.7,
                y: 0.8
            },
            {
                x: 0.5,
                y: 0.2
            },
            {
                x: 0.3,
                y: 0.8
            },
            {
                x: 0.1,
                y: 0.5
            },
            {
                x: 0.3,
                y: 0.2
            },
            {
                x: 0.9,
                y: 0.5
            },
            {
                x: 0.4,
                y: 0.9
            },
            {
                x: 0.5,
                y: 0.5
            }
        ]
    }
};


var $18e74a4be61d55d0$exports = {};

$parcel$defineInteropFlag($18e74a4be61d55d0$exports);

$parcel$export($18e74a4be61d55d0$exports, "default", () => $18e74a4be61d55d0$export$2e2bcd8739ae039);
var $18e74a4be61d55d0$export$2e2bcd8739ae039 = {
    "powerup.circles": {
        path: [
            {
                x: 0.5,
                y: 0.5
            },
            {
                x: 0.51,
                y: 0.51
            },
            {
                x: 0.48,
                y: 0.52
            },
            {
                x: 0.47,
                y: 0.47
            },
            {
                x: 0.55,
                y: 0.45
            },
            {
                x: 0.57,
                y: 0.57
            },
            {
                x: 0.41,
                y: 0.59
            },
            {
                x: 0.39,
                y: 0.39
            },
            {
                x: 0.5,
                y: 0.5
            }
        ]
    },
    "powerup.short": {
        path: [
            {
                x: 0.51,
                y: 0.51
            },
            {
                x: 0.48,
                y: 0.52
            },
            {
                x: 0.47,
                y: 0.47
            },
            {
                x: 0.5,
                y: 0.45
            },
            {
                x: 0.51,
                y: 0.51
            }
        ]
    }
};


var $42c3ab91d19ca50a$exports = {};

$parcel$defineInteropFlag($42c3ab91d19ca50a$exports);

$parcel$export($42c3ab91d19ca50a$exports, "default", () => $42c3ab91d19ca50a$export$2e2bcd8739ae039);
var $42c3ab91d19ca50a$export$2e2bcd8739ae039 = {
    playerLiftOff: {
        path: [
            {
                x: 0.2,
                y: 0.6
            },
            {
                x: 0.19,
                y: 0.56
            },
            {
                x: 0.2,
                y: 0.55
            }
        ]
    },
    "intro.HeliLiftOff": {
        path: [
            {
                x: 0.3,
                y: 0.6
            },
            {
                x: 0.32,
                y: 0.46
            },
            {
                x: 0.3,
                y: 0.35
            },
            {
                x: 0.15,
                y: 0.4
            },
            {
                x: -0.25,
                y: 0.35
            }
        ]
    },
    "intro.HeliBackground": {
        path: [
            {
                x: -0.3,
                y: 0.3
            },
            {
                x: 0.1,
                y: 0.37
            },
            {
                x: 0.4,
                y: 0.3
            }
        ]
    },
    "intro.HeliBackgroundCrash": {
        path: [
            {
                x: 0.4,
                y: 0.3
            },
            {
                x: 0.35,
                y: 0.35,
                events: [
                    [
                        0.9,
                        {
                            event: "Escape1"
                        }
                    ]
                ]
            },
            {
                x: 0.45,
                y: 0.4
            },
            {
                x: 0.5,
                y: 0.3
            },
            {
                x: 0.45,
                y: 0.2,
                events: [
                    [
                        0.5,
                        {
                            event: "Escape2"
                        }
                    ]
                ]
            },
            {
                x: 0.4,
                y: 0.25,
                events: [
                    [
                        0.8,
                        {
                            event: "Escape3"
                        }
                    ]
                ]
            },
            {
                x: 1.2,
                y: 0.2
            }
        ]
    },
    "intro.DroneBackground": {
        path: [
            {
                x: 1.1,
                y: 0.3
            },
            {
                x: 0.9,
                y: 0.2
            },
            {
                x: 0.7,
                y: 0.3,
                events: [
                    [
                        0,
                        {
                            setState: [
                                "shoot",
                                0
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.7,
                y: 0.47,
                events: [
                    [
                        0.6,
                        {
                            setState: [
                                "turned",
                                0
                            ]
                        }
                    ],
                    [
                        0.7,
                        {
                            setState: [
                                "eyeMove",
                                0
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.8,
                y: 0.3
            },
            {
                x: 0.95,
                y: 0.15
            },
            {
                x: 1.2,
                y: 0.1
            }
        ]
    }
};


var $3996eab84b5c2c2e$exports = {};

$parcel$defineInteropFlag($3996eab84b5c2c2e$exports);

$parcel$export($3996eab84b5c2c2e$exports, "default", () => $3996eab84b5c2c2e$export$2e2bcd8739ae039);
var $3996eab84b5c2c2e$export$2e2bcd8739ae039 = {
    "bulletDrone.straight": {
        habitat: {
            scenery: "city.Bay",
            scrollSpeed: {
                vx: -150,
                vy: 0
            },
            background: [
                "city.Sunrise",
                3
            ],
            entity: "BulletDrone"
        },
        path: [
            {
                x: 1.1,
                y: 0.5,
                events: [
                    [
                        0.1,
                        {
                            setState: [
                                "shooting",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: -0.1,
                y: 0.5
            }
        ]
    },
    "bulletDrone.pattern1": {
        path: [
            {
                x: 1.1,
                y: 0.5
            },
            {
                x: 0.9,
                y: 0.2
            },
            {
                x: 0.7,
                y: 0.8
            },
            {
                x: 0.5,
                y: 0.2
            },
            {
                x: 0.3,
                y: 0.8
            },
            {
                x: 0.1,
                y: 0.5,
                events: [
                    [
                        0.2,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.3,
                y: 0.2,
                events: [
                    [
                        0.9,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.9,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.6
            }
        ]
    },
    "bulletDrone.pattern2": {
        path: [
            {
                x: 1.1,
                y: 0.5
            },
            {
                x: 0.5,
                y: 0.7
            },
            {
                x: 0.1,
                y: 0.5,
                events: [
                    [
                        0.1,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.3,
                y: 0.2
            },
            {
                x: 0.8,
                y: 0.2,
                events: [
                    [
                        0.6,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.9,
                y: 0.4
            },
            {
                x: 0.4,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.2
            }
        ]
    }
};


var $5b391998c77a905b$exports = {};

$parcel$defineInteropFlag($5b391998c77a905b$exports);

$parcel$export($5b391998c77a905b$exports, "default", () => $5b391998c77a905b$export$2e2bcd8739ae039);
var $5b391998c77a905b$export$2e2bcd8739ae039 = {
    "drone.straight": {
        habitat: {
            scenery: "city.Ocean",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarDrone"
        },
        path: [
            {
                x: 1.1,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.5
            }
        ]
    },
    "drone.pattern1": {
        habitat: {
            scenery: "city.Ocean",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarDrone"
        },
        path: [
            {
                x: 1.1,
                y: 0.5
            },
            {
                x: 0.9,
                y: 0.2
            },
            {
                x: 0.7,
                y: 0.8
            },
            {
                x: 0.5,
                y: 0.2
            },
            {
                x: 0.3,
                y: 0.8
            },
            {
                x: 0.1,
                y: 0.5,
                events: [
                    [
                        0.2,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.3,
                y: 0.2,
                events: [
                    [
                        0.9,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.9,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.6
            }
        ]
    },
    "drone.pattern2": {
        habitat: {
            scenery: "city.Ocean",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarDrone"
        },
        path: [
            {
                x: 1.1,
                y: 0.5
            },
            {
                x: 0.5,
                y: 0.7
            },
            {
                x: 0.1,
                y: 0.5,
                events: [
                    [
                        0.1,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.3,
                y: 0.2
            },
            {
                x: 0.8,
                y: 0.2,
                events: [
                    [
                        0.6,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.9,
                y: 0.4
            },
            {
                x: 0.4,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.2
            }
        ]
    },
    "drone.pattern3": {
        habitat: {
            scenery: "city.Ocean",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarDrone"
        },
        path: [
            {
                x: 0.5,
                y: -0.1
            },
            {
                x: 0.5,
                y: 0.2
            },
            {
                x: 0.7,
                y: 0.31
            },
            {
                x: 0.8,
                y: 0.5
            },
            {
                x: 0.5,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.3
            }
        ]
    },
    "drone.pattern4": {
        habitat: {
            scenery: "city.Ocean",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarDrone"
        },
        path: [
            {
                x: 0.5,
                y: 1.11
            },
            {
                x: 0.5,
                y: 0.8
            },
            {
                x: 0.7,
                y: 0.8
            },
            {
                x: 0.93,
                y: 0.69
            },
            {
                x: 0.8,
                y: 0.5
            },
            {
                x: 0.5,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.7
            }
        ]
    },
    "drone.pattern5": {
        habitat: {
            scenery: "city.Ocean",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarDrone"
        },
        path: [
            {
                x: -0.2,
                y: 0.5,
                events: [
                    [
                        0.0,
                        {
                            setState: [
                                "turned",
                                0
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.5,
                y: 0.8
            },
            {
                x: 0.93,
                y: 0.69,
                events: [
                    [
                        0.0,
                        {
                            setState: [
                                "turned",
                                0
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.8,
                y: 0.5
            },
            {
                x: 0.5,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.7
            }
        ]
    },
    "drone.pattern6": {
        habitat: {
            scenery: "city.Ocean",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarDrone"
        },
        path: [
            {
                x: 1.1,
                y: 0.2
            },
            {
                x: 0.2,
                y: 0.4,
                events: [
                    [
                        0.0,
                        {
                            setState: [
                                "turned",
                                0
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.6,
                y: 0.2
            },
            {
                x: 1.1,
                y: 0.2
            }
        ]
    }
};


var $23c9343492270d58$exports = {};

$parcel$defineInteropFlag($23c9343492270d58$exports);

$parcel$export($23c9343492270d58$exports, "default", () => $23c9343492270d58$export$2e2bcd8739ae039);
var $23c9343492270d58$export$2e2bcd8739ae039 = {
    "heli.pattern1": {
        habitat: {
            scenery: "city.Ocean",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "Helicopter",
            entityState: "flying"
        },
        path: [
            {
                x: 1.1,
                y: 0.5
            },
            {
                x: 0.9,
                y: 0.4
            },
            {
                x: 0.8,
                y: 0.2
            },
            {
                x: 0.9,
                y: 0.1
            },
            {
                x: 0.9,
                y: 0.3
            },
            {
                x: 0.5,
                y: 0.3
            },
            {
                x: 0.5,
                y: 0.1
            },
            {
                x: 0.6,
                y: 0.3
            },
            {
                x: 0.7,
                y: 0.7
            },
            {
                x: 0.8,
                y: 0.5
            }
        ]
    },
    "heli.repeat1": {
        path: [
            {
                x: 0.8,
                y: 0.5
            },
            {
                x: 0.9,
                y: 0.3
            },
            {
                x: 0.8,
                y: 0.2
            },
            {
                x: 0.7,
                y: 0.4
            },
            {
                x: 0.8,
                y: 0.5
            }
        ]
    },
    "heli.repeat2": {
        path: [
            {
                x: 0.8,
                y: 0.5
            },
            {
                x: 0.9,
                y: 0.4
            },
            {
                x: 0.8,
                y: 0.3
            },
            {
                x: 0.7,
                y: 0.4
            },
            {
                x: 0.9,
                y: 0.6
            },
            {
                x: 0.7,
                y: 0.7
            },
            {
                x: 0.8,
                y: 0.5
            }
        ]
    },
    "heli.battleship1": {
        path: [
            {
                x: 0.38,
                y: 0.73,
                events: [
                    [
                        0.5,
                        {
                            event: "detach"
                        }
                    ],
                    [
                        0.8,
                        {
                            setState: [
                                "leveled",
                                1000
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.38,
                y: 0.5
            },
            {
                x: 0.2,
                y: 0.4,
                events: [
                    [
                        0.1,
                        {
                            setState: [
                                "turning",
                                1000
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.3,
                y: 0.3
            },
            {
                x: 0.7,
                y: 0.4,
                events: [
                    [
                        0,
                        {
                            setState: [
                                "turning",
                                1000
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.7,
                y: 0.2,
                events: [
                    [
                        0,
                        {
                            setState: [
                                "toForeground",
                                1000
                            ]
                        }
                    ],
                    [
                        0.1,
                        {
                            setState: [
                                "foreground",
                                1000
                            ]
                        }
                    ],
                    [
                        0.8,
                        {
                            setState: [
                                "flying",
                                1000
                            ]
                        }
                    ],
                    [
                        0.8,
                        {
                            setState: [
                                "shooting",
                                1000
                            ]
                        }
                    ],
                    [
                        0.8,
                        {
                            event: "active"
                        }
                    ]
                ]
            },
            {
                x: 0.6,
                y: 0.4
            },
            {
                x: 0.7,
                y: 0.4
            },
            {
                x: 0.6,
                y: 0.2
            }
        ]
    },
    "heli.battleship2a": {
        path: [
            {
                x: 0.38,
                y: 0.73,
                events: [
                    [
                        0.5,
                        {
                            event: "detach"
                        }
                    ],
                    [
                        0.8,
                        {
                            setState: [
                                "leveled",
                                1000
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.38,
                y: 0.5
            },
            {
                x: 0.2,
                y: 0.4,
                events: [
                    [
                        0.1,
                        {
                            setState: [
                                "turning",
                                1000
                            ]
                        }
                    ],
                    [
                        0.7,
                        {
                            event: "moveShip"
                        }
                    ]
                ]
            },
            {
                x: 0.3,
                y: 0.3
            },
            {
                x: 0.6,
                y: 0.2
            }
        ]
    },
    "heli.battleship2b": {
        path: [
            {
                x: 0.6,
                y: 0.2
            },
            {
                x: 0.7,
                y: 0.4,
                events: [
                    [
                        0,
                        {
                            setState: [
                                "turning",
                                1000
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.7,
                y: 0.2,
                events: [
                    [
                        0,
                        {
                            setState: [
                                "toForeground",
                                1000
                            ]
                        }
                    ],
                    [
                        0.1,
                        {
                            setState: [
                                "foreground",
                                1000
                            ]
                        }
                    ],
                    [
                        0.8,
                        {
                            setState: [
                                "flying",
                                1000
                            ]
                        }
                    ],
                    [
                        0.8,
                        {
                            setState: [
                                "shooting",
                                1000
                            ]
                        }
                    ],
                    [
                        0.8,
                        {
                            event: "active"
                        }
                    ]
                ]
            },
            {
                x: 0.6,
                y: 0.4
            },
            {
                x: 0.65,
                y: 0.4
            },
            {
                x: 0.7,
                y: 0.3
            }
        ]
    },
    "heli.battleship2c": {
        path: [
            {
                x: 0.8,
                y: 0.3
            },
            {
                x: 0.7,
                y: 0.4
            },
            {
                x: 0.8,
                y: 0.5
            },
            {
                x: 0.85,
                y: 0.4
            },
            {
                x: 0.8,
                y: 0.3
            }
        ]
    }
};


var $79f62778ad068753$exports = {};

$parcel$defineInteropFlag($79f62778ad068753$exports);

$parcel$export($79f62778ad068753$exports, "default", () => $79f62778ad068753$export$2e2bcd8739ae039);
var $79f62778ad068753$export$2e2bcd8739ae039 = {
    "largeDrone.intro": {
        habitat: {
            scenery: "city.Bridge",
            scrollSpeed: {
                vx: 0,
                vy: 0
            },
            background: [
                "city.Sunrise",
                3
            ],
            entity: "LargeDrone"
        },
        path: [
            {
                x: 1.1,
                y: 0.2
            },
            {
                x: 0.8,
                y: 0.5
            },
            {
                x: 0.7,
                y: 0.4
            }
        ]
    },
    "largeDrone.eight": {
        path: [
            {
                x: 0.7,
                y: 0.4
            },
            {
                x: 0.65,
                y: 0.3
            },
            {
                x: 0.7,
                y: 0.2
            },
            {
                x: 0.75,
                y: 0.3
            },
            {
                x: 0.65,
                y: 0.5
            },
            {
                x: 0.7,
                y: 0.6
            },
            {
                x: 0.75,
                y: 0.5
            },
            {
                x: 0.7,
                y: 0.4
            }
        ]
    },
    "largeDrone.eight2": {
        path: [
            {
                x: 0.8,
                y: 0.4
            },
            {
                x: 0.65,
                y: 0.2
            },
            {
                x: 0.7,
                y: 0.1
            },
            {
                x: 0.85,
                y: 0.2
            },
            {
                x: 0.65,
                y: 0.5
            },
            {
                x: 0.8,
                y: 0.7
            },
            {
                x: 0.85,
                y: 0.5
            },
            {
                x: 0.8,
                y: 0.4
            }
        ]
    }
};


var $ebd9ffb6cc140e2f$exports = {};

$parcel$defineInteropFlag($ebd9ffb6cc140e2f$exports);

$parcel$export($ebd9ffb6cc140e2f$exports, "default", () => $ebd9ffb6cc140e2f$export$2e2bcd8739ae039);
var $ebd9ffb6cc140e2f$export$2e2bcd8739ae039 = {
    "bird.straight": {
        habitat: {
            scenery: "garden.Grass",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarBird"
        },
        path: [
            {
                x: 1.1,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.5
            }
        ]
    },
    "bird.pattern1": {
        habitat: {
            scenery: "garden.Grass",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarBird"
        },
        path: [
            {
                x: 1.1,
                y: 0.5
            },
            {
                x: 0.9,
                y: 0.2
            },
            {
                x: 0.7,
                y: 0.8
            },
            {
                x: 0.5,
                y: 0.2
            },
            {
                x: 0.3,
                y: 0.8
            },
            {
                x: 0.1,
                y: 0.5,
                events: [
                    [
                        0.2,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.3,
                y: 0.2,
                events: [
                    [
                        0.9,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.9,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.6
            }
        ]
    },
    "bird.pattern2": {
        habitat: {
            scenery: "garden.Grass",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarBird"
        },
        path: [
            {
                x: 1.1,
                y: 0.5
            },
            {
                x: 0.5,
                y: 0.7
            },
            {
                x: 0.1,
                y: 0.5,
                events: [
                    [
                        0.1,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.3,
                y: 0.2
            },
            {
                x: 0.8,
                y: 0.2,
                events: [
                    [
                        0.6,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.9,
                y: 0.4
            },
            {
                x: 0.4,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.2
            }
        ]
    },
    "bird.pattern3": {
        habitat: {
            scenery: "garden.Grass",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarBird"
        },
        path: [
            {
                x: 0.5,
                y: -0.1
            },
            {
                x: 0.5,
                y: 0.2
            },
            {
                x: 0.7,
                y: 0.31
            },
            {
                x: 0.8,
                y: 0.5
            },
            {
                x: 0.5,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.3
            }
        ]
    },
    "bird.pattern4": {
        habitat: {
            scenery: "garden.Grass",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarBird"
        },
        path: [
            {
                x: 0.5,
                y: 1.11
            },
            {
                x: 0.5,
                y: 0.8
            },
            {
                x: 0.7,
                y: 0.8
            },
            {
                x: 0.93,
                y: 0.69
            },
            {
                x: 0.8,
                y: 0.5
            },
            {
                x: 0.5,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.7
            }
        ]
    },
    "bird.pattern5": {
        habitat: {
            scenery: "garden.Grass",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarBird"
        },
        path: [
            {
                x: -0.2,
                y: 0.5,
                events: [
                    [
                        0.0,
                        {
                            setState: [
                                "turned",
                                0
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.5,
                y: 0.8
            },
            {
                x: 0.93,
                y: 0.69,
                events: [
                    [
                        0.0,
                        {
                            setState: [
                                "turned",
                                0
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.8,
                y: 0.5
            },
            {
                x: 0.5,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.7
            }
        ]
    },
    "bird.pattern6": {
        habitat: {
            scenery: "garden.Grass",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "WarBird"
        },
        path: [
            {
                x: 1.1,
                y: 0.2
            },
            {
                x: 0.2,
                y: 0.4,
                events: [
                    [
                        0.0,
                        {
                            setState: [
                                "turned",
                                0
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.6,
                y: 0.2
            },
            {
                x: 1.1,
                y: 0.2
            }
        ]
    }
};


var $b1db21ce14645922$exports = {};

$parcel$defineInteropFlag($b1db21ce14645922$exports);

$parcel$export($b1db21ce14645922$exports, "default", () => $b1db21ce14645922$export$2e2bcd8739ae039);
var $b1db21ce14645922$export$2e2bcd8739ae039 = {
    "fish.pattern1": {
        habitat: {
            scenery: "garden.Pond",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunset",
                1
            ],
            entity: "WarFish"
        },
        path: [
            {
                x: 0.8,
                y: 0.95
            },
            {
                x: 0.6,
                y: 0.4
            },
            {
                x: 0.3,
                y: 1.1
            }
        ]
    },
    "fish.pattern2": {
        habitat: {
            scenery: "garden.Pond",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunset",
                1
            ],
            entity: "WarFish"
        },
        path: [
            {
                x: 0.1,
                y: 0.95,
                events: [
                    [
                        0.0,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.4,
                y: 0.1
            },
            {
                x: 0.8,
                y: 1.1
            }
        ]
    }
};


var $bbd05e27b2e441aa$exports = {};

$parcel$defineInteropFlag($bbd05e27b2e441aa$exports);

$parcel$export($bbd05e27b2e441aa$exports, "default", () => $bbd05e27b2e441aa$export$2e2bcd8739ae039);
var $bbd05e27b2e441aa$export$2e2bcd8739ae039 = {
    "house.straight": {
        habitat: {
            scenery: "town.RoofTops",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                4
            ],
            entity: "HouseHostile"
        },
        path: [
            {
                x: 1.1,
                y: 0.5
            },
            {
                x: -0.6,
                y: 0.5
            }
        ]
    }
};


var $09be507f64f4afc4$exports = {};

$parcel$defineInteropFlag($09be507f64f4afc4$exports);

$parcel$export($09be507f64f4afc4$exports, "default", () => $09be507f64f4afc4$export$2e2bcd8739ae039);
var $09be507f64f4afc4$export$2e2bcd8739ae039 = {
    "seagull.pattern1": {
        habitat: {
            scenery: "garden.Grass",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "Seagull"
        },
        path: [
            {
                x: 1.1,
                y: 0.5
            },
            {
                x: 0.9,
                y: 0.2
            },
            {
                x: 0.7,
                y: 0.8
            },
            {
                x: 0.5,
                y: 0.2
            },
            {
                x: 0.3,
                y: 0.8
            },
            {
                x: 0.1,
                y: 0.5,
                events: [
                    [
                        0.2,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.3,
                y: 0.2,
                events: [
                    [
                        0.9,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.9,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.6
            }
        ]
    },
    "seagull.pattern2": {
        habitat: {
            scenery: "garden.Grass",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "Seagull"
        },
        path: [
            {
                x: 1.1,
                y: 0.5
            },
            {
                x: 0.5,
                y: 0.7
            },
            {
                x: 0.1,
                y: 0.5,
                events: [
                    [
                        0.1,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.3,
                y: 0.2
            },
            {
                x: 0.8,
                y: 0.2,
                events: [
                    [
                        0.6,
                        {
                            setState: [
                                "turned",
                                500
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.9,
                y: 0.4
            },
            {
                x: 0.4,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.2
            }
        ]
    },
    "seagull.pattern3": {
        habitat: {
            scenery: "garden.Grass",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "Seagull"
        },
        path: [
            {
                x: 0.5,
                y: -0.1
            },
            {
                x: 0.5,
                y: 0.2
            },
            {
                x: 0.7,
                y: 0.31
            },
            {
                x: 0.8,
                y: 0.5
            },
            {
                x: 0.5,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.3
            }
        ]
    },
    "seagull.pattern4": {
        habitat: {
            scenery: "garden.Grass",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "Seagull"
        },
        path: [
            {
                x: 0.5,
                y: 1.11
            },
            {
                x: 0.5,
                y: 0.8
            },
            {
                x: 0.7,
                y: 0.8
            },
            {
                x: 0.93,
                y: 0.69
            },
            {
                x: 0.8,
                y: 0.5
            },
            {
                x: 0.5,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.7
            }
        ]
    },
    "seagull.pattern5": {
        habitat: {
            scenery: "garden.Grass",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "Seagull"
        },
        path: [
            {
                x: -0.2,
                y: 0.5,
                events: [
                    [
                        0.0,
                        {
                            setState: [
                                "turned",
                                0
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.5,
                y: 0.8
            },
            {
                x: 0.93,
                y: 0.69,
                events: [
                    [
                        0.0,
                        {
                            setState: [
                                "turned",
                                0
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.8,
                y: 0.5
            },
            {
                x: 0.5,
                y: 0.5
            },
            {
                x: -0.1,
                y: 0.7
            }
        ]
    },
    "seagull.pattern6": {
        habitat: {
            scenery: "garden.Grass",
            scrollSpeed: {
                vx: -100,
                vy: 0
            },
            background: [
                "city.Sunrise",
                2
            ],
            entity: "Seagull"
        },
        path: [
            {
                x: 1.1,
                y: 0.2
            },
            {
                x: 0.2,
                y: 0.4,
                events: [
                    [
                        0.0,
                        {
                            setState: [
                                "turned",
                                0
                            ]
                        }
                    ]
                ]
            },
            {
                x: 0.6,
                y: 0.2
            },
            {
                x: 1.1,
                y: 0.2
            }
        ]
    }
};


$ee654c5ed655ef01$exports = {
    "common": {
        "unsorted": {
            "js": $6913c360227a5718$exports
        },
        "powerups": {
            "powerups": {
                "js": $18e74a4be61d55d0$exports
            }
        }
    },
    "intro": {
        "intro": {
            "js": $42c3ab91d19ca50a$exports
        }
    },
    "enemies": {
        "BulletDrone": {
            "bulletDrone": {
                "js": $3996eab84b5c2c2e$exports
            }
        },
        "Drone": {
            "drone": {
                "js": $5b391998c77a905b$exports
            }
        },
        "Helicopter": {
            "helicopter": {
                "js": $23c9343492270d58$exports
            }
        },
        "LargeDrone": {
            "largeDrone": {
                "js": $79f62778ad068753$exports
            }
        }
    },
    "sinterklaas": {
        "Bird": {
            "bird": {
                "js": $ebd9ffb6cc140e2f$exports
            }
        },
        "Fish": {
            "fish": {
                "js": $b1db21ce14645922$exports
            }
        },
        "House": {
            "House": {
                "js": $bbd05e27b2e441aa$exports
            }
        },
        "Seagull": {
            "seagull": {
                "js": $09be507f64f4afc4$exports
            }
        }
    }
};


var $a2ebbc43638d9a84$exports = {};
var $9295cd6c505d502c$exports = {};

$parcel$defineInteropFlag($9295cd6c505d502c$exports);

$parcel$export($9295cd6c505d502c$exports, "default", () => $9295cd6c505d502c$export$2e2bcd8739ae039);
const $9295cd6c505d502c$var$sceneries = {
    "city.CoastWithCloud": {
        width: 1023,
        height: 576,
        right: "city.Coast",
        left: "city.Coast",
        backgrounds: [
            [
                "city.Sunrise",
                2
            ]
        ],
        altitudes: [
            0,
            100
        ],
        elements: [
            {
                x: 0,
                y: -85,
                composition: "ocean.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "GravityLiquid"
                ],
                w: 1024,
                h: 45,
                attributes: {
                    liquidParticles: "waterSplashes",
                    liquidDensity: 8
                }
            },
            {
                x: 0,
                y: -165,
                composition: "city.cloud",
                distance: 0.1,
                frame: "default"
            },
            {
                x: 0,
                y: 5,
                composition: "ocean.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: -30,
                composition: "ocean.horizon",
                distance: 0.25
            },
            {
                x: 0,
                y: -46,
                composition: "city.horizon",
                distance: 0.25
            }
        ]
    },
    "city.CoastWithCloud2": {
        width: 1023,
        height: 576,
        right: "city.Coast",
        left: "city.Coast",
        backgrounds: [
            [
                "city.Sunrise",
                2
            ]
        ],
        altitudes: [
            0,
            100
        ],
        elements: [
            {
                x: 0,
                y: -85,
                composition: "ocean.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "GravityLiquid"
                ],
                w: 1024,
                h: 45,
                attributes: {
                    liquidParticles: "waterSplashes",
                    liquidDensity: 8
                }
            },
            {
                x: 0,
                y: -265,
                composition: "city.cloud",
                distance: 0.2,
                frame: "close"
            },
            {
                x: 0,
                y: 5,
                composition: "ocean.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: -30,
                composition: "ocean.horizon",
                distance: 0.25
            },
            {
                x: 0,
                y: -46,
                composition: "city.horizon",
                distance: 0.25
            }
        ]
    },
    "city.Coast": {
        width: 1023,
        height: 576,
        right: {
            "city.CoastWithCloud": 0.1,
            "city.CoastWithCloud2": 0.1,
            "city.Coast": 0.8
        },
        left: {
            "city.CoastWithCloud": 0.1,
            "city.CoastWithCloud2": 0.1,
            "city.Coast": 0.8
        },
        backgrounds: [
            [
                "city.Sunrise",
                2
            ]
        ],
        altitudes: [
            0,
            100
        ],
        elements: [
            {
                x: 0,
                y: -85,
                composition: "ocean.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "GravityLiquid"
                ],
                w: 1024,
                h: 45,
                attributes: {
                    liquidParticles: "waterSplashes",
                    liquidDensity: 8
                }
            },
            {
                x: 0,
                y: 5,
                composition: "ocean.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: -30,
                composition: "ocean.horizon",
                distance: 0.25
            },
            {
                x: 0,
                y: -46,
                composition: "city.horizon",
                distance: 0.25
            }
        ]
    },
    "city.CoastStart": {
        width: 1023,
        height: 576,
        right: "city.Coast",
        left: "city.Ocean",
        backgrounds: [
            [
                "city.Sunrise",
                1
            ]
        ],
        altitudes: [
            0,
            250
        ],
        elements: [
            {
                x: 0,
                y: -85,
                composition: "ocean.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "GravityLiquid"
                ],
                w: 1024,
                h: 45,
                attributes: {
                    liquidParticles: "waterSplashes",
                    liquidDensity: 8
                }
            },
            {
                x: 0,
                y: 5,
                composition: "ocean.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: -30,
                composition: "ocean.horizon",
                distance: 0.25
            },
            {
                x: 0,
                y: -46,
                composition: "city.horizonStart",
                distance: 0.25
            }
        ]
    },
    "city.CoastEnd": {
        width: 1023,
        height: 576,
        right: "city.Ocean",
        left: "city.Coast",
        backgrounds: [
            [
                "city.Sunset",
                3
            ]
        ],
        altitudes: [
            0,
            250
        ],
        elements: [
            {
                x: 0,
                y: -85,
                composition: "ocean.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "GravityLiquid"
                ],
                w: 1024,
                h: 45,
                attributes: {
                    liquidParticles: "waterSplashes",
                    liquidDensity: 8
                }
            },
            {
                x: 0,
                y: 5,
                composition: "ocean.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: -30,
                composition: "ocean.horizon",
                distance: 0.25
            },
            {
                x: 0,
                y: -46,
                composition: "city.horizonStart",
                frame: "flipped",
                distance: 0.25
            }
        ]
    },
    "city.OceanWithCloud": {
        width: 1023,
        height: 576,
        right: "city.Ocean",
        left: "city.Ocean",
        backgrounds: [
            [
                "city.Sunrise",
                0
            ]
        ],
        altitudes: [
            0,
            250
        ],
        elements: [
            {
                x: 0,
                y: -85,
                composition: "ocean.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "GravityLiquid"
                ],
                w: 1024,
                h: 45,
                attributes: {
                    liquidParticles: "waterSplashes",
                    liquidDensity: 8
                }
            },
            {
                x: 0,
                y: -165,
                composition: "city.cloud",
                distance: 0.1,
                frame: "default"
            },
            {
                x: 0,
                y: 5,
                composition: "ocean.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: -30,
                composition: "ocean.horizon",
                distance: 0.25
            }
        ]
    },
    "city.OceanWithCloud2": {
        width: 1023,
        height: 576,
        right: "city.Ocean",
        left: "city.Ocean",
        backgrounds: [
            [
                "city.Sunrise",
                0
            ]
        ],
        altitudes: [
            0,
            250
        ],
        elements: [
            {
                x: 0,
                y: -85,
                composition: "ocean.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "GravityLiquid"
                ],
                w: 1024,
                h: 45,
                attributes: {
                    liquidParticles: "waterSplashes",
                    liquidDensity: 8
                }
            },
            {
                x: 0,
                y: -265,
                composition: "city.cloud",
                distance: 0.2,
                frame: "close"
            },
            {
                x: 0,
                y: 5,
                composition: "ocean.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: -30,
                composition: "ocean.horizon",
                distance: 0.25
            }
        ]
    },
    "city.Ocean": {
        width: 1023,
        height: 576,
        right: {
            "city.OceanWithCloud": 0.1,
            "city.OceanWithCloud2": 0.1,
            "city.Ocean": 0.8
        },
        left: {
            "city.OceanWithCloud": 0.1,
            "city.OceanWithCloud2": 0.1,
            "city.Ocean": 0.8
        },
        backgrounds: [
            [
                "city.Sunrise",
                0
            ]
        ],
        altitudes: [
            0,
            250
        ],
        elements: [
            {
                x: 0,
                y: -85,
                composition: "ocean.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "GravityLiquid"
                ],
                w: 1024,
                h: 45,
                attributes: {
                    liquidParticles: "waterSplashes",
                    liquidDensity: 8
                }
            },
            {
                x: 0,
                y: 5,
                composition: "ocean.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: -30,
                composition: "ocean.horizon",
                distance: 0.25
            }
        ]
    },
    "city.BayStart": {
        width: 1023,
        height: 576,
        right: "city.Bay",
        left: "city.Coast",
        backgrounds: [
            [
                "city.Sunrise",
                2
            ]
        ],
        altitudes: [
            0,
            250
        ],
        elements: [
            {
                x: 0,
                y: -85,
                composition: "ocean.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "GravityLiquid"
                ],
                w: 1024,
                h: 45,
                attributes: {
                    liquidParticles: "waterSplashes",
                    liquidDensity: 8
                }
            },
            {
                x: 0,
                y: 5,
                composition: "ocean.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: -30,
                composition: "ocean.horizon",
                distance: 0.25
            },
            {
                x: 0,
                y: -46,
                composition: "city.horizon",
                distance: 0.25
            },
            {
                x: 0,
                y: -148,
                composition: "city.cityStart",
                distance: 0.5
            }
        ]
    },
    "city.BayEnd": {
        width: 1023,
        height: 576,
        right: "city.Coast",
        left: "city.Bay",
        backgrounds: [
            [
                "city.Sunset",
                3
            ]
        ],
        altitudes: [
            0,
            250
        ],
        elements: [
            {
                x: 0,
                y: -85,
                composition: "ocean.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "GravityLiquid"
                ],
                w: 1024,
                h: 45,
                attributes: {
                    liquidParticles: "waterSplashes",
                    liquidDensity: 8
                }
            },
            {
                x: 0,
                y: 5,
                composition: "ocean.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: -30,
                composition: "ocean.horizon",
                distance: 0.25
            },
            {
                x: 0,
                y: -46,
                composition: "city.horizon",
                distance: 0.25
            },
            {
                x: 0,
                y: -148,
                composition: "city.cityStart",
                frame: "flipped",
                distance: 0.5
            }
        ]
    },
    "city.Bay": {
        width: 1023,
        height: 576,
        left: "city.Bay",
        right: "city.Bay",
        backgrounds: [
            [
                "city.Sunrise",
                3
            ]
        ],
        altitudes: [
            0,
            250
        ],
        elements: [
            {
                x: 0,
                y: -85,
                z: -20,
                composition: "ocean.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "GravityLiquid"
                ],
                w: 1024,
                h: 45,
                attributes: {
                    liquidParticles: "waterSplashes",
                    liquidDensity: 8
                }
            },
            {
                x: 0,
                y: 5,
                composition: "ocean.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: -30,
                composition: "ocean.horizon",
                distance: 0.25
            },
            {
                x: 0,
                y: -46,
                composition: "city.horizon",
                distance: 0.25
            },
            {
                x: 0,
                y: -148,
                composition: "city.city",
                distance: 0.5
            },
            {
                x: 0,
                y: -180,
                composition: "city.layer2",
                distance: 0.375
            },
            {
                x: 240,
                y: -180,
                w: 60,
                h: 105,
                components: [
                    "SunBlock"
                ],
                distance: 0.375
            }
        ]
    },
    "city.BayFull": {
        width: 1023,
        height: 576,
        left: "city.BayFull",
        right: "city.BayFull",
        backgrounds: [
            [
                "city.Sunrise",
                3
            ]
        ],
        altitudes: [
            0,
            250,
            500,
            700,
            900
        ],
        elements: [
            {
                x: 0,
                y: -85,
                z: -20,
                composition: "ocean.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "GravityLiquid"
                ],
                w: 1024,
                h: 45,
                attributes: {
                    liquidParticles: "waterSplashes",
                    liquidDensity: 8
                }
            },
            {
                x: 0,
                y: 5,
                composition: "ocean.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: -45,
                composition: "city.cityDistance",
                distance: 0.25
            },
            {
                x: 0,
                y: -148,
                composition: "city.city",
                distance: 0.5
            },
            {
                x: 0,
                y: -180,
                composition: "city.layer2",
                distance: 0.375
            },
            {
                x: 240,
                y: -180,
                w: 60,
                h: 105,
                components: [
                    "SunBlock"
                ],
                distance: 0.375
            }
        ]
    }
};
var $9295cd6c505d502c$export$2e2bcd8739ae039 = $9295cd6c505d502c$var$sceneries;


var $16154c917c3e5424$exports = {};

$parcel$defineInteropFlag($16154c917c3e5424$exports);

$parcel$export($16154c917c3e5424$exports, "default", () => $16154c917c3e5424$export$2e2bcd8739ae039);
const $16154c917c3e5424$var$sceneries = {
    "city.Bridge": {
        width: 1023,
        height: 576,
        left: "city.Bay",
        right: "city.BayFull",
        backgrounds: [
            [
                "city.Sunrise",
                3
            ]
        ],
        elements: [
            {
                x: 0,
                y: -85,
                z: -20,
                composition: "ocean.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "GravityLiquid"
                ],
                w: 1024,
                h: 45,
                attributes: {
                    liquidParticles: "waterSplashes",
                    liquidDensity: 8
                }
            },
            {
                x: 0,
                y: 5,
                composition: "ocean.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: -45,
                composition: "city.cityDistance",
                distance: 0.25
            },
            {
                x: 0,
                y: -20,
                composition: "city.bridge.foot",
                distance: 0.5
            },
            {
                x: 0,
                y: -710,
                z: 300,
                components: [
                    "SunBlock",
                    "BridgeFrontDeck"
                ],
                composition: [
                    "city.bridge.deck",
                    {
                        attributes: {
                            scale: 1.1
                        },
                        spriteAttributes: {
                            accentColor: "#b15a5a",
                            lightness: 0.6
                        }
                    }
                ],
                distance: 1.1
            },
            {
                x: 0,
                y: -590,
                z: 299,
                components: [
                    "PillarLeft"
                ],
                composition: [
                    "city.bridge.pillar",
                    {
                        attributes: {
                            scale: 1.1
                        },
                        spriteAttributes: {
                            lightness: 0.6
                        }
                    }
                ],
                distance: 1.1
            },
            {
                x: 920,
                y: -590,
                z: 299,
                components: [
                    "PillarRight"
                ],
                composition: [
                    "city.bridge.pillar",
                    {
                        attributes: {
                            scale: 1.1
                        },
                        spriteAttributes: {
                            lightness: 0.6,
                            flipX: true
                        }
                    }
                ],
                distance: 1.1
            },
            {
                x: 0,
                y: -580,
                z: -40,
                components: [
                    "SunBlock",
                    "BridgeCeiling",
                    "ShipSolid"
                ],
                composition: [
                    "city.bridge.deck",
                    {
                        spriteAttributes: {
                            accentColor: "#2ba04c"
                        }
                    }
                ],
                distance: 1.0
            },
            {
                x: 0,
                y: -460,
                z: -42,
                components: [
                    "SunBlock",
                    "BridgeCeilingBackground"
                ],
                composition: [
                    "city.bridge.deck",
                    {
                        attributes: {
                            scale: 0.9
                        },
                        spriteAttributes: {
                            accentColor: "#b15a5a"
                        }
                    }
                ],
                distance: 0.9
            },
            {
                x: 0,
                y: -345,
                z: -44,
                components: [
                    "SunBlock"
                ],
                composition: [
                    "city.bridge.deck",
                    {
                        attributes: {
                            scale: 0.8
                        },
                        spriteAttributes: {
                            accentColor: "#2ba04c"
                        }
                    }
                ],
                distance: 0.8
            },
            {
                x: 0,
                y: -240,
                z: -46,
                composition: [
                    "city.bridge.deck",
                    {
                        attributes: {
                            scale: 0.7
                        },
                        spriteAttributes: {
                            accentColor: "#b15a5a",
                            horizon: [
                                0.2,
                                0.2
                            ]
                        }
                    }
                ],
                distance: 0.7
            },
            {
                x: 20,
                y: -190,
                z: -47,
                composition: [
                    "city.bridge.pillar",
                    {
                        attributes: {
                            scale: 0.5
                        },
                        spriteAttributes: {
                            horizon: [
                                0.2,
                                0.2
                            ]
                        }
                    }
                ],
                distance: 0.7
            },
            {
                x: 600,
                y: -190,
                z: -46,
                composition: [
                    "city.bridge.pillar",
                    {
                        attributes: {
                            scale: 0.5
                        },
                        spriteAttributes: {
                            horizon: [
                                0.2,
                                0.2
                            ],
                            flipX: true
                        }
                    }
                ],
                distance: 0.7
            },
            {
                x: 0,
                y: -160,
                z: -48,
                composition: [
                    "city.bridge.deck",
                    {
                        attributes: {
                            scale: 0.62
                        },
                        spriteAttributes: {
                            accentColor: "#2ba04c",
                            horizon: [
                                0.3,
                                0.3
                            ]
                        }
                    }
                ],
                distance: 0.62
            },
            {
                x: 0,
                y: -90,
                z: -50,
                composition: [
                    "city.bridge.deck",
                    {
                        attributes: {
                            scale: 0.55
                        },
                        spriteAttributes: {
                            accentColor: "#b15a5a",
                            horizon: [
                                0.3,
                                0.3
                            ]
                        }
                    }
                ],
                distance: 0.55
            },
            {
                x: 0,
                y: -40,
                z: -52,
                composition: [
                    "city.bridge.deck",
                    {
                        attributes: {
                            scale: 0.5
                        },
                        spriteAttributes: {
                            accentColor: "#2ba04c",
                            horizon: [
                                0.4,
                                0.4
                            ]
                        }
                    }
                ],
                distance: 0.5
            },
            {
                x: 20,
                y: 3,
                z: -54,
                composition: [
                    "city.bridge.smallPillar",
                    {
                        attributes: {
                            scale: 0.3
                        },
                        spriteAttributes: {
                            horizon: [
                                0.4,
                                0.4
                            ]
                        }
                    }
                ],
                distance: 0.5
            },
            {
                x: 430,
                y: 3,
                z: -54,
                composition: [
                    "city.bridge.smallPillar",
                    {
                        attributes: {
                            scale: 0.3
                        },
                        spriteAttributes: {
                            horizon: [
                                0.4,
                                0.4
                            ],
                            flipX: true
                        }
                    }
                ],
                distance: 0.5
            }
        ]
    }
};
var $16154c917c3e5424$export$2e2bcd8739ae039 = $16154c917c3e5424$var$sceneries;


var $38705560eca4e100$exports = {};

$parcel$defineInteropFlag($38705560eca4e100$exports);

$parcel$export($38705560eca4e100$exports, "sceneries", () => $38705560eca4e100$export$b1a32131569ed891);
$parcel$export($38705560eca4e100$exports, "default", () => $38705560eca4e100$export$2e2bcd8739ae039);
const $38705560eca4e100$export$b1a32131569ed891 = {
    "garden.Grass": {
        width: 1023,
        height: 576,
        left: "garden.Grass",
        right: "garden.Grass",
        backgrounds: [
            [
                "city.Sunrise",
                4
            ]
        ],
        altitudes: [
            0,
            250,
            400,
            700
        ],
        elements: [
            {
                x: 0,
                y: -65,
                composition: "grass.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid"
                ],
                w: 1024,
                h: 45
            },
            {
                x: 0,
                y: -50,
                composition: "grass.middle",
                distance: 0.75
            },
            {
                x: 0,
                y: -100,
                composition: "grass.hedge",
                distance: 0.65
            },
            {
                x: 0,
                y: 65,
                z: -80,
                composition: "hills.horizon",
                distance: 0.1875
            }
        ]
    },
    "garden.PondStart": {
        width: 1023,
        height: 576,
        left: "garden.Grass",
        right: "garden.Pond",
        backgrounds: [
            [
                "city.Sunrise",
                4
            ]
        ],
        altitudes: [
            0,
            250,
            400,
            700
        ],
        elements: [
            {
                x: 0,
                y: -65,
                composition: "grass.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid"
                ],
                w: 1024,
                h: 45
            },
            {
                x: 0,
                y: -50,
                composition: "grass.pondStart",
                distance: 0.75
            },
            {
                x: 0,
                y: -100,
                composition: "grass.hedge",
                distance: 0.65
            },
            {
                x: 0,
                y: 65,
                z: -80,
                composition: "hills.horizon",
                distance: 0.1875
            }
        ]
    },
    "garden.Pond": {
        width: 1023,
        height: 576,
        right: "garden.Pond",
        left: "garden.Pond",
        backgrounds: [
            [
                "city.Sunrise",
                4
            ]
        ],
        altitudes: [
            0,
            250,
            400,
            700
        ],
        elements: [
            {
                x: 0,
                y: -65,
                composition: "grass.front"
            },
            {
                x: 0,
                y: -45,
                components: [
                    "ShipSolid",
                    "BulletSolid"
                ],
                w: 1024,
                h: 45
            },
            {
                x: 0,
                y: -50,
                composition: "grass.pond",
                distance: 0.75
            },
            {
                x: 0,
                y: -100,
                composition: "grass.hedge",
                distance: 0.65
            },
            {
                x: 0,
                y: -165,
                z: -30,
                composition: "town.middle",
                distance: 0.5
            },
            {
                x: 0,
                y: 35,
                z: -70,
                composition: "town.skyline",
                distance: 0.25
            },
            {
                x: 0,
                y: 65,
                z: -80,
                composition: "hills.horizon",
                distance: 0.1875
            }
        ]
    }
};
var $38705560eca4e100$export$2e2bcd8739ae039 = $38705560eca4e100$export$b1a32131569ed891;


var $f9cd610a4f781df2$exports = {};

$parcel$defineInteropFlag($f9cd610a4f781df2$exports);

$parcel$export($f9cd610a4f781df2$exports, "default", () => $f9cd610a4f781df2$export$2e2bcd8739ae039);
const $f9cd610a4f781df2$var$sceneries = {
    "town.RoofTops": {
        width: 1023,
        height: 576,
        left: "town.RoofTops",
        right: "town.RoofTops",
        backgrounds: [
            [
                "city.Sunset",
                1
            ]
        ],
        altitudes: [
            0,
            250,
            400,
            700
        ],
        elements: [
            {
                x: 0,
                y: -165,
                z: -30,
                composition: "town.middleFull",
                distance: 0.5
            },
            {
                x: 0,
                y: 35,
                z: -70,
                composition: "town.skyline",
                distance: 0.25
            },
            {
                x: 0,
                y: 65,
                z: -80,
                composition: "hills.horizon",
                distance: 0.1875
            }
        ]
    },
    "town.Rasberg": {
        width: 1023,
        height: 576,
        left: "town.RoofTops",
        right: "city.BayFull",
        backgrounds: [
            [
                "city.Sunset",
                2
            ]
        ],
        altitudes: [
            0,
            250,
            400,
            700
        ],
        elements: [
            {
                x: -800,
                y: -865,
                z: 300,
                composition: "city.skyScraper",
                distance: 1.0
            },
            {
                x: -300,
                y: -1100,
                z: -200,
                composition: "city.skyScraper",
                distance: 0.7
            },
            {
                x: -1700,
                y: -1300,
                z: 150,
                composition: "city.skyScraper",
                distance: 1.1
            },
            {
                x: 0,
                y: -165,
                z: -30,
                composition: "town.middleFull",
                distance: 0.5
            },
            {
                x: 0,
                y: 35,
                z: -70,
                composition: "town.skyline",
                distance: 0.25
            },
            {
                x: 0,
                y: 65,
                z: -80,
                composition: "hills.horizon",
                distance: 0.1875
            }
        ]
    }
};
var $f9cd610a4f781df2$export$2e2bcd8739ae039 = $f9cd610a4f781df2$var$sceneries;


var $94c87e8b257614b9$exports = {};

$parcel$defineInteropFlag($94c87e8b257614b9$exports);

$parcel$export($94c87e8b257614b9$exports, "default", () => $94c87e8b257614b9$export$2e2bcd8739ae039);
var $94c87e8b257614b9$export$2e2bcd8739ae039 = {
    "test.Walls": {
        width: 1023,
        height: 576,
        right: "test.Walls",
        left: "test.Walls",
        elements: [
            {
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "LaserSolid",
                    "SolidCollision",
                    "Collision"
                ],
                x: 100,
                y: -385,
                composition: "test.wall"
            },
            {
                components: [
                    "ShipSolid",
                    "BulletSolid",
                    "LaserSolid",
                    "SolidCollision",
                    "Collision"
                ],
                x: 700,
                y: -485,
                composition: "test.wall"
            }
        ]
    }
};


$a2ebbc43638d9a84$exports = {
    "scenery": {
        "city": {
            "ts": $9295cd6c505d502c$exports
        },
        "bridge": {
            "bridge": {
                "ts": $16154c917c3e5424$exports
            }
        }
    },
    "sinterklaas": {
        "garden": {
            "ts": $38705560eca4e100$exports
        },
        "town": {
            "ts": $f9cd610a4f781df2$exports
        }
    },
    "test": {
        "test": {
            "js": $94c87e8b257614b9$exports
        }
    }
};


var $740634799fad42f8$exports = {};
var $442238fe74d4d319$exports = {};

$parcel$defineInteropFlag($442238fe74d4d319$exports);

$parcel$export($442238fe74d4d319$exports, "default", () => $442238fe74d4d319$export$2e2bcd8739ae039);
var $442238fe74d4d319$export$2e2bcd8739ae039 = {
    "player.bullets": {
        spawnRhythm: {
            initialDelay: 1,
            burst: 1,
            shotDelay: [
                120,
                60
            ],
            burstDelay: 1,
            spawns: [
                [
                    "bullet",
                    {
                        angleRange: {
                            from: [
                                0,
                                -5
                            ],
                            to: [
                                1,
                                5
                            ],
                            step: 3
                        }
                    }
                ],
                [
                    "muzzleFlash",
                    {}
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    1050,
                    1200
                ],
                composition: "weapons.lightBullet",
                damage: [
                    {
                        velocity: [
                            -20000,
                            -30000
                        ],
                        affects: "health",
                        duration: [
                            2,
                            4
                        ],
                        name: "Bullet"
                    }
                ],
                queue: [
                    {
                        cleanOutOfScreen: true
                    },
                    {
                        duration: 4000
                    }
                ],
                collisions: {
                    SolidCollision: {
                        spawns: [
                            [
                                "sparkHit",
                                {}
                            ],
                            [
                                "sparks",
                                {
                                    emitter: {
                                        duration: 100
                                    }
                                }
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            muzzleFlash: {
                spawnPosition: [
                    0,
                    0.5
                ],
                attached: true,
                velocity: 0,
                composition: "weapons.muzzleFlash",
                queue: [
                    {
                        duration: 120,
                        audio: "laser-shot"
                    }
                ]
            },
            sparkHit: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100,
                        audio: "laser-hit"
                    }
                ]
            },
            sparks: {
                spawnPosition: "outside",
                velocity: 0,
                particles: "sparks",
                queue: [
                    {
                        duration: 500
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    },
    "player.laser": {
        spawnRhythm: {
            initialDelay: 1,
            burst: 1,
            shotDelay: 3000,
            burstDelay: 1,
            shot: [
                {
                    state: "laserCharge",
                    audio: "laser-charge",
                    duration: [
                        1500,
                        750
                    ]
                },
                {
                    state: "stopLaserCharge",
                    duration: 300
                },
                {
                    spawn: true,
                    duration: 100,
                    audio: "laser-fire"
                }
            ],
            spawns: [
                [
                    "laser",
                    {
                        angleRange: {
                            from: [
                                180,
                                175
                            ],
                            to: [
                                181,
                                186
                            ],
                            step: 3
                        }
                    }
                ]
            ]
        },
        spawnables: {
            laser: {
                spawnPosition: [
                    0,
                    0.5
                ],
                attached: true,
                beam: true,
                velocity: 2800,
                composition: "weapons.laser",
                queue: [
                    {
                        duration: 340
                    },
                    {
                        velocity: 0
                    },
                    {
                        duration: 300
                    },
                    {
                        duration: 300,
                        frame: "disappear"
                    }
                ],
                damage: [
                    {
                        velocity: [
                            -500,
                            -1000
                        ],
                        affects: "health",
                        duration: [
                            80,
                            160
                        ],
                        name: "Laser"
                    }
                ],
                collisions: {
                    SolidCollision: {
                        cooldown: 10,
                        spawns: [
                            [
                                "sparks",
                                {
                                    angle: 180
                                }
                            ]
                        ],
                        remove: false
                    }
                }
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            },
            sparks: {
                attached: true,
                spawnPosition: "outside",
                velocity: 0,
                particles: "laserHit",
                queue: [
                    {
                        duration: 150
                    }
                ]
            }
        }
    }
};


var $aae7f8a1bf9a67b1$exports = {};

$parcel$defineInteropFlag($aae7f8a1bf9a67b1$exports);

$parcel$export($aae7f8a1bf9a67b1$exports, "default", () => $aae7f8a1bf9a67b1$export$2e2bcd8739ae039);
const $aae7f8a1bf9a67b1$var$weapons = {
    "chimney.presents": {
        aiming: {
            offsetAimAngle: 0,
            sight: 95,
            resetOnDeactivation: true,
            rotateSpeed: 0,
            range: [
                70,
                -2
            ]
        },
        spawnRhythm: {
            initialDelay: [
                1,
                1
            ],
            burst: [
                5,
                5
            ],
            shotDelay: [
                400,
                400
            ],
            burstDelay: [
                800,
                400
            ],
            shot: [
                {
                    spawn: true,
                    duration: 50
                }
            ],
            spawns: [
                [
                    "bullet",
                    {
                        angle: 90
                    }
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    200,
                    300
                ],
                composition: "sinterklaas.present",
                queue: [
                    // { cleanOutOfScreen: true },
                    {
                        duration: 4000,
                        audio: [
                            "gun-shot",
                            {
                                volume: 0.8
                            }
                        ]
                    }
                ],
                damage: [
                    {
                        velocity: [
                            -15000,
                            -45000
                        ],
                        affects: "health",
                        duration: [
                            4,
                            4
                        ],
                        name: "Laser"
                    }
                ],
                collisions: {
                    Jinte: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                },
                autoRotate: false
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100,
                        audio: "laser-hit"
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    },
    "seagull.flatsCannon": {
        aiming: {
            offsetAimAngle: -5,
            sight: 0,
            resetOnDeactivation: true,
            rotateSpeed: 90,
            range: [
                -30,
                150
            ]
        },
        spawnRhythm: {
            initialDelay: 100,
            burst: 2,
            shotDelay: 300,
            burstDelay: 1000,
            spawns: [
                [
                    "flats",
                    {
                        angle: 30,
                        autoRotate: true
                    }
                ]
            ]
        },
        spawnables: {
            flats: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    350,
                    500
                ],
                composition: "flats",
                queue: [
                    {
                        cleanOutOfScreen: true
                    },
                    {
                        aimOnTarget: true,
                        duration: 0
                    },
                    {
                        duration: 4000,
                        audio: [
                            "gun-shot",
                            {
                                volume: 0.8
                            }
                        ]
                    }
                ],
                damage: [
                    {
                        velocity: [
                            -2000,
                            -15000
                        ],
                        affects: "health",
                        duration: [
                            2,
                            4
                        ],
                        name: "Laser"
                    }
                ],
                collisions: {
                    Jinte: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100,
                        audio: "laser-hit"
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    }
};
var $aae7f8a1bf9a67b1$export$2e2bcd8739ae039 = $aae7f8a1bf9a67b1$var$weapons;


var $98817f2b9880f0de$exports = {};

$parcel$defineInteropFlag($98817f2b9880f0de$exports);

$parcel$export($98817f2b9880f0de$exports, "default", () => $98817f2b9880f0de$export$2e2bcd8739ae039);
var $98817f2b9880f0de$export$2e2bcd8739ae039 = {
    "player.carrots": {
        spawnRhythm: {
            initialDelay: 1,
            burst: 1,
            shotDelay: [
                120,
                60
            ],
            burstDelay: 1,
            spawns: [
                [
                    "bullet",
                    {
                        angleRange: {
                            from: [
                                0,
                                -5
                            ],
                            to: [
                                1,
                                5
                            ],
                            step: 3
                        }
                    }
                ],
                [
                    "muzzleFlash",
                    {}
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    1050,
                    1200
                ],
                composition: "weapons.carrot",
                damage: [
                    {
                        velocity: [
                            -20000,
                            -30000
                        ],
                        affects: "health",
                        duration: [
                            2,
                            4
                        ],
                        name: "Bullet"
                    }
                ],
                queue: [
                    {
                        cleanOutOfScreen: true
                    },
                    {
                        duration: 4000
                    }
                ],
                collisions: {
                    SolidCollision: {
                        spawns: [
                            [
                                "sparkHit",
                                {}
                            ],
                            [
                                "sparks",
                                {
                                    emitter: {
                                        duration: 100
                                    }
                                }
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            muzzleFlash: {
                spawnPosition: [
                    0,
                    0.5
                ],
                attached: true,
                velocity: 0,
                composition: "weapons.muzzleFlash",
                queue: [
                    {
                        duration: 120,
                        audio: "laser-shot"
                    }
                ]
            },
            sparkHit: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100,
                        audio: "laser-hit"
                    }
                ]
            },
            sparks: {
                spawnPosition: "outside",
                velocity: 0,
                particles: "sparks",
                queue: [
                    {
                        duration: 500
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    }
};


var $03e9279d09725ec2$exports = {};

$parcel$defineInteropFlag($03e9279d09725ec2$exports);

$parcel$export($03e9279d09725ec2$exports, "default", () => $03e9279d09725ec2$export$2e2bcd8739ae039);
var $03e9279d09725ec2$export$2e2bcd8739ae039 = {
    "boss.searchBullet": {
        spawnRhythm: {
            initialDelay: [
                1500,
                150
            ],
            burst: 1,
            shotDelay: [
                150,
                90
            ],
            burstDelay: [
                3000,
                800
            ],
            spawns: [
                [
                    "bullet",
                    {
                        angle: 0
                    }
                ],
                [
                    "bullet",
                    {
                        angle: 20
                    }
                ],
                [
                    "bullet",
                    {
                        angle: -20
                    }
                ],
                [
                    "bullet",
                    {
                        angle: 40
                    }
                ],
                [
                    "bullet",
                    {
                        angle: -40
                    }
                ],
                [
                    "muzzleFlash",
                    {}
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    200,
                    600
                ],
                composition: "weapons.bullet",
                queue: [
                    {
                        duration: [
                            2000,
                            800
                        ],
                        velocity: [
                            0,
                            100
                        ],
                        easing: "easeOutQuad"
                    },
                    {
                        velocity: [
                            900,
                            1200
                        ],
                        aimOnTarget: true
                    },
                    {
                        duration: 3000
                    }
                ],
                collisions: {
                    SolidCollision: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            muzzleFlash: {
                spawnPosition: [
                    0,
                    0.5
                ],
                attached: true,
                velocity: 0,
                composition: "weapons.muzzleFlash",
                queue: [
                    {
                        duration: 400
                    }
                ]
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    },
    "boss.extreme-search": {
        spawnRhythm: {
            initialDelay: [
                1500,
                150
            ],
            burst: 1,
            shotDelay: 4000,
            burstDelay: [
                1500,
                500
            ],
            spawns: [
                [
                    "bullet",
                    {
                        angleRange: {
                            from: 0,
                            to: 360,
                            step: 8
                        }
                    }
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: 200,
                composition: "weapons.bullet",
                queue: [
                    {
                        cleanOutOfScreen: true
                    },
                    {
                        duration: 200
                    },
                    {
                        duration: 500,
                        velocity: 0
                    },
                    {
                        velocity: [
                            900,
                            1200
                        ],
                        aimOnTarget: true
                    },
                    {
                        duration: 3000
                    }
                ],
                collisions: {
                    SolidCollision: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    },
    "boss.extreme-test": {
        spawnRhythm: {
            initialDelay: [
                1500,
                150
            ],
            burst: [
                5,
                30
            ],
            shotDelay: 200,
            burstDelay: [
                2000,
                10
            ],
            spawns: [
                [
                    "bullet",
                    {
                        angleRange: {
                            from: 0,
                            to: 360,
                            step: 8
                        }
                    }
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: 200,
                composition: "weapons.bullet",
                queue: [
                    {
                        cleanOutOfScreen: true
                    },
                    {
                        duration: 13000
                    }
                ],
                collisions: {
                    SolidCollision: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    },
    "boss.spawn": {
        spawnRhythm: {
            initialDelay: [
                1500,
                150
            ],
            burst: [
                3,
                5
            ],
            shotDelay: [
                350,
                250
            ],
            burstDelay: [
                3000,
                400
            ],
            spawns: [
                [
                    "bullet",
                    {}
                ],
                [
                    "muzzleFlash",
                    {}
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    250,
                    300
                ],
                composition: "weapons.sphere",
                queue: [
                    {
                        duration: 1500,
                        velocity: 20
                    },
                    {
                        duration: 4000
                    }
                ],
                collisions: {
                    SolidCollision: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            subSpawn: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    250,
                    300
                ],
                composition: "weapons.bullet",
                queue: [
                    {
                        duration: 1500
                    }
                ],
                collisions: {
                    SolidCollision: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            muzzleFlash: {
                spawnPosition: [
                    0,
                    0.5
                ],
                attached: true,
                velocity: 0,
                composition: "weapons.muzzleFlash",
                queue: [
                    {
                        duration: 400
                    }
                ]
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    },
    "building.explosion": {
        spawnRhythm: {
            initialDelay: 1,
            maxBursts: 1,
            burst: 14,
            shotDelay: 200,
            burstDelay: 0,
            spawns: [
                [
                    "explosion",
                    {
                        spawnBox: {
                            w: 150,
                            h: 100
                        }
                    }
                ]
            ]
        },
        spawnables: {
            explosion: {
                spawnPosition: [
                    0.5,
                    0.5
                ],
                velocity: [
                    0,
                    0
                ],
                composition: "weapons.largeExplosion",
                emitDamage: [
                    {
                        targets: [
                            "PlayerShip"
                        ],
                        velocity: -1000,
                        accelleration: 50,
                        upperBounds: 0,
                        speed: 1200,
                        affects: [
                            "health"
                        ],
                        duration: 100,
                        name: "Explosion"
                    }
                ],
                queue: [
                    {
                        duration: 100,
                        audio: "explosion"
                    },
                    {
                        duration: 1000
                    }
                ]
            }
        }
    },
    "building.explosion2": {
        spawnRhythm: {
            maxBursts: 1,
            initialDelay: 1,
            burst: 18,
            shotDelay: 180,
            burstDelay: 0,
            spawns: [
                [
                    "explosion",
                    {
                        spawnBox: {
                            w: 250,
                            h: 100
                        }
                    }
                ]
            ]
        },
        spawnables: {
            explosion: {
                spawnPosition: [
                    0.5,
                    0.5
                ],
                velocity: [
                    0,
                    0
                ],
                composition: "weapons.largeExplosion",
                emitDamage: [
                    {
                        targets: [
                            "PlayerShip"
                        ],
                        velocity: -1000,
                        accelleration: 50,
                        upperBounds: 0,
                        speed: 2000,
                        affects: [
                            "health"
                        ],
                        duration: 100,
                        name: "Explosion"
                    }
                ],
                queue: [
                    {
                        duration: 100,
                        audio: "explosion"
                    },
                    {
                        duration: 1000
                    }
                ]
            }
        }
    }
};


var $16c19c43ad68c3b1$exports = {};

$parcel$defineInteropFlag($16c19c43ad68c3b1$exports);

$parcel$export($16c19c43ad68c3b1$exports, "default", () => $16c19c43ad68c3b1$export$2e2bcd8739ae039);
var $16c19c43ad68c3b1$export$2e2bcd8739ae039 = {
    "turret.bullet": {
        spawnRhythm: {
            initialDelay: [
                1500,
                150
            ],
            burst: [
                3,
                9
            ],
            shotDelay: [
                150,
                90
            ],
            burstDelay: [
                3000,
                400
            ],
            spawns: [
                [
                    "bullet",
                    {}
                ],
                [
                    "muzzleFlash",
                    {}
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    250,
                    300
                ],
                composition: "weapons.bullet",
                queue: [
                    {
                        duration: 4000
                    }
                ],
                collisions: {
                    SolidCollision: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            muzzleFlash: {
                spawnPosition: [
                    0,
                    0.5
                ],
                attached: true,
                velocity: 0,
                composition: "weapons.muzzleFlash",
                queue: [
                    {
                        duration: 400
                    }
                ]
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    },
    "turret.doubleBullet": {
        spawnRhythm: {
            initialDelay: [
                1500,
                150
            ],
            burst: [
                3,
                9
            ],
            shotDelay: [
                150,
                90
            ],
            burstDelay: [
                3000,
                400
            ],
            spawns: [
                [
                    "bullet",
                    {
                        angle: -2
                    }
                ],
                [
                    "bullet",
                    {
                        angle: 2
                    }
                ],
                [
                    "muzzleFlash",
                    {}
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    250,
                    300
                ],
                composition: "weapons.bullet",
                queue: [
                    {
                        duration: 4000
                    }
                ],
                collisions: {
                    SolidCollision: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            muzzleFlash: {
                spawnPosition: [
                    0,
                    0.5
                ],
                attached: true,
                velocity: 0,
                composition: "weapons.muzzleFlash",
                queue: [
                    {
                        duration: 400
                    }
                ]
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    }
};


var $a06a023076b48099$exports = {};

$parcel$defineInteropFlag($a06a023076b48099$exports);

$parcel$export($a06a023076b48099$exports, "default", () => $a06a023076b48099$export$2e2bcd8739ae039);
var $a06a023076b48099$export$2e2bcd8739ae039 = {
    "cannon.gun": {
        aiming: {
            offsetAimAngle: 0,
            sight: 95,
            resetOnDeactivation: true,
            rotateSpeed: 60,
            range: [
                70,
                -2
            ]
        },
        spawnRhythm: {
            initialDelay: [
                500,
                150
            ],
            burst: [
                3,
                7
            ],
            shotDelay: [
                150,
                100
            ],
            burstDelay: [
                1000,
                400
            ],
            shot: [
                {
                    state: "shells",
                    duration: 0
                },
                {
                    spawn: true,
                    duration: 50
                },
                {
                    state: "noshells",
                    duration: 0
                }
            ],
            spawns: [
                [
                    "bullet",
                    {}
                ],
                [
                    "muzzleFlash",
                    {}
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    400,
                    500
                ],
                composition: "weapons.bullet",
                queue: [
                    {
                        duration: 4000,
                        audio: [
                            "gun-shot",
                            {
                                volume: 0.8
                            }
                        ]
                    }
                ],
                damage: [
                    {
                        velocity: [
                            -3000,
                            -15000
                        ],
                        affects: "health",
                        duration: [
                            2,
                            4
                        ],
                        name: "Laser"
                    }
                ],
                collisions: {
                    PlayerShip: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            muzzleFlash: {
                spawnPosition: [
                    0,
                    0.5
                ],
                attached: true,
                velocity: 0,
                composition: "weapons.muzzleFlash",
                queue: [
                    {
                        duration: 400
                    }
                ]
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100,
                        audio: "laser-hit"
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    },
    "cannon.laser": {
        aiming: {
            offsetAimAngle: 0,
            sight: 95,
            resetOnDeactivation: true,
            rotateSpeed: 60,
            range: [
                70,
                -2
            ]
        },
        spawnRhythm: {
            initialDelay: [
                500,
                150
            ],
            burst: 1,
            shotDelay: 1,
            burstDelay: 1000,
            shot: [
                {
                    state: "charge",
                    audio: "laser-charge",
                    duration: 1200
                },
                {
                    stopAiming: true,
                    state: "charged",
                    duration: 500
                },
                {
                    duration: 100
                },
                {
                    spawn: true,
                    duration: 100,
                    audio: "laser-fire"
                },
                {
                    state: "discharge",
                    duration: 500
                },
                {
                    duration: 500
                },
                {
                    stopAiming: false,
                    duration: 0
                }
            ],
            spawns: [
                [
                    "laser",
                    {
                        angle: 180
                    }
                ],
                [
                    "laser",
                    {
                        angle: 200
                    }
                ],
                [
                    "laser",
                    {
                        angle: 160
                    }
                ],
                [
                    "laser",
                    {
                        angle: 220
                    }
                ],
                [
                    "laser",
                    {
                        angle: 140
                    }
                ]
            ]
        },
        spawnables: {
            laser: {
                spawnPosition: [
                    0,
                    0.5
                ],
                beam: true,
                attached: true,
                velocity: 2500,
                composition: "weapons.laser",
                queue: [
                    {
                        duration: 350
                    },
                    {
                        velocity: 0
                    },
                    {
                        duration: 150
                    },
                    {
                        duration: 300,
                        frame: "disappear"
                    }
                ],
                damage: [
                    {
                        velocity: [
                            -2000,
                            -4000
                        ],
                        affects: "health",
                        duration: [
                            2,
                            4
                        ],
                        name: "Laser"
                    }
                ],
                collisions: {
                    LaserSolid: {
                        cooldown: 10,
                        spawns: [
                            [
                                "sparks",
                                {
                                    angle: 180
                                }
                            ]
                        ],
                        remove: false
                    },
                    PlayerShip: {
                        cooldown: 10,
                        spawns: [
                            [
                                "sparks",
                                {
                                    angle: 180
                                }
                            ]
                        ],
                        remove: false
                    }
                }
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            },
            sparks: {
                attached: true,
                spawnPosition: "outside",
                velocity: 0,
                particles: "laserHit",
                queue: [
                    {
                        duration: 50
                    }
                ]
            }
        }
    },
    "turret.bullet": {
        spawnRhythm: {
            initialDelay: [
                1500,
                150
            ],
            burst: [
                3,
                9
            ],
            shotDelay: [
                150,
                90
            ],
            burstDelay: [
                3000,
                400
            ],
            spawns: [
                [
                    "bullet",
                    {}
                ],
                [
                    "muzzleFlash",
                    {}
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    250,
                    300
                ],
                composition: "weapons.bullet",
                queue: [
                    {
                        duration: 4000
                    }
                ],
                collisions: {
                    SolidCollision: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            muzzleFlash: {
                spawnPosition: [
                    0,
                    0.5
                ],
                attached: true,
                velocity: 0,
                composition: "weapons.muzzleFlash",
                queue: [
                    {
                        duration: 400
                    }
                ]
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    },
    "turret.doubleBullet": {
        spawnRhythm: {
            initialDelay: [
                1500,
                150
            ],
            burst: [
                3,
                9
            ],
            shotDelay: [
                150,
                90
            ],
            burstDelay: [
                3000,
                400
            ],
            spawns: [
                [
                    "bullet",
                    {
                        angle: -2
                    }
                ],
                [
                    "bullet",
                    {
                        angle: 2
                    }
                ],
                [
                    "muzzleFlash",
                    {}
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    250,
                    300
                ],
                composition: "weapons.bullet",
                queue: [
                    {
                        duration: 4000
                    }
                ],
                collisions: {
                    SolidCollision: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            muzzleFlash: {
                spawnPosition: [
                    0,
                    0.5
                ],
                attached: true,
                velocity: 0,
                composition: "weapons.muzzleFlash",
                queue: [
                    {
                        duration: 400
                    }
                ]
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    }
};


var $6f1af0f404f89de0$exports = {};

$parcel$defineInteropFlag($6f1af0f404f89de0$exports);

$parcel$export($6f1af0f404f89de0$exports, "default", () => $6f1af0f404f89de0$export$2e2bcd8739ae039);
var $6f1af0f404f89de0$export$2e2bcd8739ae039 = {
    "bulletDrone.gun": {
        aiming: {
            offsetAimAngle: -5,
            sight: 25,
            resetOnDeactivation: true,
            rotateSpeed: 60,
            range: [
                10,
                -50
            ]
        },
        spawnRhythm: {
            initialDelay: [
                1500,
                150
            ],
            burst: [
                3,
                6
            ],
            shotDelay: [
                200,
                160
            ],
            burstDelay: [
                2000,
                400
            ],
            spawns: [
                [
                    "bullet",
                    {}
                ],
                [
                    "muzzleFlash",
                    {}
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    250,
                    300
                ],
                composition: "weapons.bullet",
                queue: [
                    {
                        duration: 4000,
                        audio: [
                            "gun-shot",
                            {
                                volume: 0.8
                            }
                        ]
                    }
                ],
                damage: [
                    {
                        velocity: [
                            -2000,
                            -15000
                        ],
                        affects: "health",
                        duration: [
                            2,
                            4
                        ],
                        name: "Laser"
                    }
                ],
                collisions: {
                    PlayerShip: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            muzzleFlash: {
                spawnPosition: [
                    0,
                    0.5
                ],
                attached: true,
                velocity: 0,
                composition: "weapons.muzzleFlash",
                queue: [
                    {
                        duration: 400
                    }
                ]
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100,
                        audio: "laser-hit"
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    }
};


var $9dd0436a757978c9$exports = {};

$parcel$defineInteropFlag($9dd0436a757978c9$exports);

$parcel$export($9dd0436a757978c9$exports, "default", () => $9dd0436a757978c9$export$2e2bcd8739ae039);
var $9dd0436a757978c9$export$2e2bcd8739ae039 = {
    "heli.rocket": {
        spawnRhythm: {
            initialDelay: [
                2000,
                1000
            ],
            burst: 1,
            shotDelay: [
                500,
                250
            ],
            burstDelay: [
                3000,
                2000
            ],
            spawns: [
                [
                    "rocket",
                    {
                        angle: -90,
                        autoRotate: false
                    }
                ]
            ]
        },
        spawnables: {
            rocket: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    400,
                    500
                ],
                entity: "HeliRocket",
                damage: [
                    {
                        velocity: [
                            -10000,
                            -30000
                        ],
                        affects: "health",
                        duration: [
                            4,
                            8
                        ],
                        name: "Blast"
                    }
                ],
                queue: [
                    {
                        duration: 130
                    },
                    {
                        velocity: 0,
                        angle: 0,
                        autoRotate: true
                    },
                    {
                        duration: 500
                    },
                    {
                        velocity: [
                            450,
                            500
                        ],
                        steering: 80,
                        sight: 25
                    },
                    {
                        duration: 6000
                    }
                ],
                collisions: {
                    PlayerShip: {
                        state: "hide",
                        spawns: [
                            [
                                "hit",
                                {}
                            ]
                        ]
                    },
                    GravityLiquid: {
                        state: "waterHit",
                        spawns: [
                            [
                                "hit",
                                {}
                            ]
                        ]
                    }
                }
            },
            hit: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.explosion",
                queue: [
                    {
                        duration: 100,
                        audio: "explosion"
                    },
                    {
                        duration: 2000
                    }
                ]
            }
        }
    },
    "heli.gun": {
        aiming: {
            offsetAimAngle: -5,
            sight: 25,
            resetOnDeactivation: true,
            rotateSpeed: 60,
            range: [
                10,
                -50
            ]
        },
        spawnRhythm: {
            initialDelay: [
                1500,
                150
            ],
            burst: [
                5,
                9
            ],
            shotDelay: [
                100,
                60
            ],
            burstDelay: [
                3000,
                400
            ],
            spawns: [
                [
                    "bullet",
                    {}
                ],
                [
                    "muzzleFlash",
                    {}
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: [
                    350,
                    500
                ],
                composition: "weapons.bullet",
                queue: [
                    {
                        duration: 4000,
                        audio: [
                            "gun-shot",
                            {
                                volume: 0.8
                            }
                        ]
                    }
                ],
                damage: [
                    {
                        velocity: [
                            -2000,
                            -15000
                        ],
                        affects: "health",
                        duration: [
                            2,
                            4
                        ],
                        name: "Laser"
                    }
                ],
                collisions: {
                    PlayerShip: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    },
                    WaterCollision: {
                        spawns: [
                            [
                                "splash",
                                {}
                            ]
                        ]
                    }
                }
            },
            muzzleFlash: {
                spawnPosition: [
                    0,
                    0.5
                ],
                attached: true,
                velocity: 0,
                composition: "weapons.muzzleFlash",
                queue: [
                    {
                        duration: 400
                    }
                ]
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100,
                        audio: "laser-hit"
                    }
                ]
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            }
        }
    }
};


var $ce2deba7ad628237$exports = {};

$parcel$defineInteropFlag($ce2deba7ad628237$exports);

$parcel$export($ce2deba7ad628237$exports, "default", () => $ce2deba7ad628237$export$2e2bcd8739ae039);
var $ce2deba7ad628237$export$2e2bcd8739ae039 = {
    "largeDrone.takeover": {
        spawnRhythm: {
            maxBursts: 1,
            initialDelay: 10,
            burst: 2,
            shotDelay: 200,
            burstDelay: 8000,
            spawns: [
                [
                    "bullet",
                    {}
                ],
                [
                    "muzzleFlash",
                    {}
                ]
            ]
        },
        spawnables: {
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: 400,
                composition: "weapons.sphere",
                damage: [
                    {
                        velocity: [
                            -20000,
                            -30000
                        ],
                        affects: "health",
                        duration: [
                            2,
                            4
                        ],
                        name: "Laser"
                    }
                ],
                queue: [
                    {
                        cleanOutOfScreen: true
                    },
                    {
                        aimOnTarget: true,
                        duration: 0
                    },
                    {
                        duration: 4000
                    }
                ],
                collisions: {
                    IntroHeliBackground: {
                        spawns: [
                            [
                                "sparks",
                                {}
                            ],
                            [
                                "sparkHit",
                                {}
                            ]
                        ]
                    }
                }
            },
            muzzleFlash: {
                spawnPosition: [
                    0,
                    0.5
                ],
                attached: true,
                velocity: 0,
                composition: "weapons.muzzleFlash",
                queue: [
                    {
                        duration: 400,
                        audio: "laser-shot"
                    }
                ]
            },
            sparks: {
                spawnPosition: "outside",
                velocity: 0,
                particles: "sparks",
                queue: [
                    {
                        duration: 500
                    }
                ]
            },
            sparkHit: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100,
                        audio: "laser-hit"
                    }
                ]
            }
        }
    },
    "largeDrone.rockets": {
        spawnRhythm: {
            initialDelay: 500,
            burst: 16,
            shotDelay: 10,
            burstDelay: 1000,
            shot: [
                {
                    spawn: true,
                    duration: 100
                },
                {
                    state: "fireRocket",
                    duration: 200
                },
                {
                    duration: 20
                },
                {
                    state: "reloadRocket",
                    duration: 300
                }
            ],
            spawns: [
                [
                    "rocket",
                    {
                        angle: 0,
                        autoRotate: false
                    }
                ]
            ]
        },
        spawnables: {
            rocket: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: 250,
                entity: "HeliRocket",
                damage: [
                    {
                        velocity: [
                            -10000,
                            -30000
                        ],
                        affects: "health",
                        duration: [
                            4,
                            8
                        ],
                        name: "Blast"
                    }
                ],
                queue: [
                    {
                        cleanOutOfScreen: true
                    },
                    {
                        velocity: [
                            450,
                            500
                        ]
                    },
                    {
                        duration: 4000
                    },
                    {
                        collide: "PlayerShip"
                    }
                ],
                collisions: {
                    PlayerShip: {
                        state: "hide",
                        spawns: [
                            [
                                "hit",
                                {}
                            ]
                        ]
                    },
                    GravityLiquid: {
                        state: "waterHit",
                        spawns: [
                            [
                                "hit",
                                {}
                            ]
                        ]
                    }
                }
            },
            hit: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.explosion",
                queue: [
                    {
                        duration: 100,
                        audio: "explosion"
                    },
                    {
                        duration: 2000
                    }
                ]
            }
        }
    },
    "largeDrone.homingRocket": {
        spawnRhythm: {
            initialDelay: 1000,
            burst: 3,
            shotDelay: 500,
            burstDelay: 1000,
            shot: [
                {
                    spawn: true,
                    duration: 100
                },
                {
                    state: "fireRocket",
                    duration: 200
                },
                {
                    duration: 1000
                },
                {
                    state: "reloadRocket",
                    duration: 1500
                }
            ],
            spawns: [
                [
                    "rocket",
                    {
                        angle: -90,
                        autoRotate: false
                    }
                ],
                [
                    "rocket",
                    {
                        angle: 90,
                        autoRotate: false
                    }
                ],
                [
                    "wideRocket",
                    {
                        angle: -120,
                        autoRotate: false
                    }
                ],
                [
                    "wideRocket",
                    {
                        angle: 120,
                        autoRotate: false
                    }
                ]
            ]
        },
        spawnables: {
            rocket: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: 250,
                entity: "HeliRocket",
                damage: [
                    {
                        velocity: [
                            -10000,
                            -30000
                        ],
                        affects: "health",
                        duration: [
                            4,
                            8
                        ],
                        name: "Blast"
                    }
                ],
                queue: [
                    {
                        duration: 220
                    },
                    {
                        velocity: 0,
                        angle: 0,
                        autoRotate: true
                    },
                    {
                        duration: 500
                    },
                    {
                        velocity: [
                            450,
                            500
                        ],
                        steering: 180,
                        sight: 360
                    },
                    {
                        duration: 3000
                    },
                    {
                        collide: "PlayerShip"
                    }
                ],
                collisions: {
                    PlayerShip: {
                        state: "hide",
                        spawns: [
                            [
                                "hit",
                                {}
                            ]
                        ]
                    },
                    GravityLiquid: {
                        state: "waterHit",
                        spawns: [
                            [
                                "hit",
                                {}
                            ]
                        ]
                    }
                }
            },
            wideRocket: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: 250,
                entity: "HeliRocket",
                damage: [
                    {
                        velocity: [
                            -10000,
                            -30000
                        ],
                        affects: "health",
                        duration: [
                            4,
                            8
                        ],
                        name: "Blast"
                    }
                ],
                queue: [
                    {
                        cleanOutOfScreen: true
                    },
                    {
                        duration: 550
                    },
                    {
                        velocity: 0,
                        angle: 0
                    },
                    {
                        duration: 170
                    },
                    {
                        velocity: [
                            450,
                            500
                        ]
                    },
                    {
                        duration: 4000
                    },
                    {
                        collide: "PlayerShip"
                    }
                ],
                collisions: {
                    PlayerShip: {
                        state: "hide",
                        spawns: [
                            [
                                "hit",
                                {}
                            ]
                        ]
                    },
                    GravityLiquid: {
                        state: "waterHit",
                        spawns: [
                            [
                                "hit",
                                {}
                            ]
                        ]
                    }
                }
            },
            hit: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.explosion",
                queue: [
                    {
                        duration: 100,
                        audio: "explosion"
                    },
                    {
                        duration: 2000
                    }
                ]
            }
        }
    }
};


var $e34966fbc6a5f084$exports = {};

$parcel$defineInteropFlag($e34966fbc6a5f084$exports);

$parcel$export($e34966fbc6a5f084$exports, "default", () => $e34966fbc6a5f084$export$2e2bcd8739ae039);
var $e34966fbc6a5f084$export$2e2bcd8739ae039 = {
    "cannon.laser": {
        aiming: {
            offsetAimAngle: 0,
            sight: 95,
            resetOnDeactivation: true,
            rotateSpeed: 60,
            range: [
                70,
                -2
            ]
        },
        spawnRhythm: {
            initialDelay: [
                500,
                150
            ],
            burst: 1,
            shotDelay: 1,
            burstDelay: 1000,
            shot: [
                {
                    state: "charge",
                    audio: "laser-charge",
                    duration: 1200
                },
                {
                    stopAiming: true,
                    state: "charged",
                    duration: 500
                },
                {
                    duration: 100
                },
                {
                    spawn: true,
                    duration: 100,
                    audio: "laser-fire"
                },
                {
                    state: "discharge",
                    duration: 500
                },
                {
                    duration: 500
                },
                {
                    stopAiming: false,
                    duration: 0
                }
            ],
            spawns: [
                [
                    "laser",
                    {
                        angle: 180
                    }
                ],
                [
                    "laser",
                    {
                        angle: 200
                    }
                ],
                [
                    "laser",
                    {
                        angle: 160
                    }
                ],
                [
                    "laser",
                    {
                        angle: 220
                    }
                ],
                [
                    "laser",
                    {
                        angle: 140
                    }
                ]
            ]
        },
        spawnables: {
            laser: {
                spawnPosition: [
                    0,
                    0.5
                ],
                beam: true,
                attached: true,
                velocity: 2500,
                composition: "weapons.laser",
                queue: [
                    {
                        duration: 350
                    },
                    {
                        velocity: 0
                    },
                    {
                        duration: 150
                    },
                    {
                        duration: 300,
                        frame: "disappear"
                    }
                ],
                damage: [
                    {
                        velocity: [
                            -2000,
                            -4000
                        ],
                        affects: "health",
                        duration: [
                            2,
                            4
                        ],
                        name: "Laser"
                    }
                ],
                collisions: {
                    LaserSolid: {
                        cooldown: 10,
                        spawns: [
                            [
                                "sparks",
                                {
                                    angle: 180
                                }
                            ]
                        ],
                        remove: false
                    },
                    PlayerShip: {
                        cooldown: 10,
                        spawns: [
                            [
                                "sparks",
                                {
                                    angle: 180
                                }
                            ]
                        ],
                        remove: false
                    }
                }
            },
            splash: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.waterHit",
                queue: [
                    {
                        duration: 305
                    }
                ]
            },
            sparks: {
                attached: true,
                spawnPosition: "outside",
                velocity: 0,
                particles: "laserHit",
                queue: [
                    {
                        duration: 50
                    }
                ]
            }
        }
    }
};


var $0c34d7629d2b928e$exports = {};

$parcel$defineInteropFlag($0c34d7629d2b928e$exports);

$parcel$export($0c34d7629d2b928e$exports, "default", () => $0c34d7629d2b928e$export$2e2bcd8739ae039);
var $0c34d7629d2b928e$export$2e2bcd8739ae039 = {
    "mine.blast": {
        spawnRhythm: {
            maxBursts: 1,
            initialDelay: 1,
            burst: 1,
            shotDelay: 0,
            burstDelay: 0,
            spawns: [
                [
                    "explosion",
                    {}
                ],
                [
                    "bullet",
                    {
                        angleRange: {
                            from: 45,
                            to: 405,
                            step: 45
                        }
                    }
                ]
            ]
        },
        spawnables: {
            explosion: {
                spawnPosition: [
                    0.5,
                    0.5
                ],
                velocity: [
                    0,
                    0
                ],
                composition: "weapons.largeExplosion",
                emitDamage: [
                    {
                        targets: [
                            "Mine",
                            "PlayerShip"
                        ],
                        velocity: -1000,
                        accelleration: 50,
                        upperBounds: 0,
                        speed: 1200,
                        affects: [
                            "health"
                        ],
                        duration: 100,
                        name: "Explosion"
                    }
                ],
                queue: [
                    {
                        duration: 100,
                        audio: "explosion"
                    },
                    {
                        duration: 2000
                    }
                ]
            },
            bullet: {
                spawnPosition: [
                    0,
                    0.5
                ],
                velocity: 100,
                composition: "weapons.bullet",
                damage: [
                    {
                        velocity: [
                            -3000,
                            -20000
                        ],
                        affects: "health",
                        duration: [
                            2,
                            4
                        ],
                        name: "Laser"
                    }
                ],
                queue: [
                    {
                        cleanOutOfScreen: true
                    },
                    {
                        duration: 500,
                        velocity: 500
                    },
                    {
                        duration: 11000
                    }
                ],
                collisions: {
                    PlayerShip: {
                        spawns: [
                            [
                                "spark",
                                {}
                            ]
                        ]
                    }
                }
            },
            spark: {
                spawnPosition: "outside",
                velocity: 0,
                composition: "weapons.solidHit",
                queue: [
                    {
                        duration: 100
                    }
                ]
            }
        }
    },
    "mine.explosion": {
        spawnRhythm: {
            maxBursts: 1,
            initialDelay: 1,
            burst: 1,
            shotDelay: 0,
            burstDelay: 0,
            spawns: [
                [
                    "explosion",
                    {}
                ]
            ]
        },
        spawnables: {
            explosion: {
                spawnPosition: [
                    0.5,
                    0.5
                ],
                velocity: [
                    0,
                    0
                ],
                composition: "weapons.largeExplosion",
                emitDamage: [
                    {
                        targets: [
                            "Mine",
                            "PlayerShip"
                        ],
                        velocity: -1000,
                        accelleration: 50,
                        upperBounds: 0,
                        speed: 1200,
                        affects: [
                            "health"
                        ],
                        duration: 100,
                        name: "Explosion"
                    }
                ],
                queue: [
                    {
                        duration: 100,
                        audio: "explosion"
                    },
                    {
                        duration: 2000
                    }
                ]
            }
        }
    }
};


$740634799fad42f8$exports = {
    "PlayerShip": {
        "player": {
            "js": $442238fe74d4d319$exports
        }
    },
    "sinterklaas": {
        "sintWeapons": {
            "ts": $aae7f8a1bf9a67b1$exports
        },
        "Jinte": {
            "player": {
                "js": $98817f2b9880f0de$exports
            }
        }
    },
    "test": {
        "test": {
            "js": $03e9279d09725ec2$exports
        },
        "turret": {
            "js": $16c19c43ad68c3b1$exports
        }
    },
    "enemies": {
        "BulletCannon": {
            "bulletCannon": {
                "js": $a06a023076b48099$exports
            }
        },
        "BulletDrone": {
            "bulletDrone": {
                "js": $6f1af0f404f89de0$exports
            }
        },
        "Helicopter": {
            "helicopter": {
                "js": $9dd0436a757978c9$exports
            }
        },
        "LargeDrone": {
            "largeDrone": {
                "js": $ce2deba7ad628237$exports
            }
        },
        "LaserCannon": {
            "laserCannon": {
                "js": $e34966fbc6a5f084$exports
            }
        },
        "Mine": {
            "mine": {
                "js": $0c34d7629d2b928e$exports
            }
        }
    }
};


const $4a464ac9ac54fc86$var$dataFlattener = (obj)=>{
    const entries = {};
    const getDefault = (object)=>{
        if (typeof object !== "object" || Array.isArray(object)) return;
        Object.entries(object).forEach(([key, value])=>{
            if (key === "default") Object.entries(value).forEach(([k, v])=>{
                entries[k] = v;
            });
            else getDefault(value);
        });
    };
    getDefault(obj);
    return entries;
};
const $4a464ac9ac54fc86$var$flatAnimationData = $4a464ac9ac54fc86$var$dataFlattener($fe9d63158457675d$exports);
const $4a464ac9ac54fc86$var$flatCompositionData = $4a464ac9ac54fc86$var$dataFlattener($bc92bf97bbd67eaa$exports);
const $4a464ac9ac54fc86$var$flatEntityData = $4a464ac9ac54fc86$var$dataFlattener($ce33a8d361355ff3$exports);
const $4a464ac9ac54fc86$var$flatParticleData = $4a464ac9ac54fc86$var$dataFlattener($88803c0bdfcac99c$exports);
const $4a464ac9ac54fc86$var$flatPathData = $4a464ac9ac54fc86$var$dataFlattener($ee654c5ed655ef01$exports);
const $4a464ac9ac54fc86$var$flatSceneryData = $4a464ac9ac54fc86$var$dataFlattener($a2ebbc43638d9a84$exports);
const $4a464ac9ac54fc86$var$flatWeaponData = $4a464ac9ac54fc86$var$dataFlattener($740634799fad42f8$exports);
const $4a464ac9ac54fc86$var$dataLoader = (entries)=>{
    return (key)=>entries[key];
};
const $4a464ac9ac54fc86$export$7f9953c70dacfd7f = $4a464ac9ac54fc86$var$dataLoader($4a464ac9ac54fc86$var$flatAnimationData);
const $4a464ac9ac54fc86$export$80766d2842af6389 = $4a464ac9ac54fc86$var$dataLoader($4a464ac9ac54fc86$var$flatCompositionData);
const $4a464ac9ac54fc86$export$5345fd892b40e1f6 = $4a464ac9ac54fc86$var$dataLoader($4a464ac9ac54fc86$var$flatEntityData);
const $4a464ac9ac54fc86$export$2096b54ada1e6fa4 = $4a464ac9ac54fc86$var$dataLoader($4a464ac9ac54fc86$var$flatParticleData);
const $4a464ac9ac54fc86$export$595447059867920 = $4a464ac9ac54fc86$var$dataLoader($4a464ac9ac54fc86$var$flatPathData);
const $4a464ac9ac54fc86$export$b1a32131569ed891 = $4a464ac9ac54fc86$var$dataLoader($4a464ac9ac54fc86$var$flatSceneryData);
const $4a464ac9ac54fc86$export$b7ef0e847c99a1c7 = $4a464ac9ac54fc86$var$dataLoader($4a464ac9ac54fc86$var$flatWeaponData);
var $4a464ac9ac54fc86$export$2e2bcd8739ae039 = {
    animations: $4a464ac9ac54fc86$var$flatAnimationData,
    compositions: $4a464ac9ac54fc86$var$flatCompositionData,
    entities: $4a464ac9ac54fc86$var$flatEntityData,
    particles: $4a464ac9ac54fc86$var$flatParticleData,
    paths: $4a464ac9ac54fc86$var$flatPathData,
    sceneries: $4a464ac9ac54fc86$var$flatSceneryData,
    weapons: $4a464ac9ac54fc86$var$flatWeaponData
};


var $89aeca5d4d27357e$exports = {};
var $353b0f796da2df31$exports = {};
var $d1833597dde236cc$exports = {};
var $4c9496debf2dfab7$exports = {};
var $81ef565610c44066$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $81ef565610c44066$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$81ef565610c44066$exports = $81ef565610c44066$var$listCacheClear;


var $c1997fcf228f3e88$exports = {};
var $410f5f1cc08bb802$exports = {};
var $ccd1dfea300b5fbe$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $ccd1dfea300b5fbe$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$ccd1dfea300b5fbe$exports = $ccd1dfea300b5fbe$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $410f5f1cc08bb802$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($ccd1dfea300b5fbe$exports(array[length][0], key)) return length;
    }
    return -1;
}
$410f5f1cc08bb802$exports = $410f5f1cc08bb802$var$assocIndexOf;


/** Used for built-in method references. */ var $c1997fcf228f3e88$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $c1997fcf228f3e88$var$splice = $c1997fcf228f3e88$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c1997fcf228f3e88$var$listCacheDelete(key) {
    var data = this.__data__, index = $410f5f1cc08bb802$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $c1997fcf228f3e88$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$c1997fcf228f3e88$exports = $c1997fcf228f3e88$var$listCacheDelete;


var $b463b4ba4c87ba26$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b463b4ba4c87ba26$var$listCacheGet(key) {
    var data = this.__data__, index = $410f5f1cc08bb802$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$b463b4ba4c87ba26$exports = $b463b4ba4c87ba26$var$listCacheGet;


var $13b24b19adc0dc4b$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $13b24b19adc0dc4b$var$listCacheHas(key) {
    return $410f5f1cc08bb802$exports(this.__data__, key) > -1;
}
$13b24b19adc0dc4b$exports = $13b24b19adc0dc4b$var$listCacheHas;


var $2cf8c67c009b7225$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $2cf8c67c009b7225$var$listCacheSet(key, value) {
    var data = this.__data__, index = $410f5f1cc08bb802$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$2cf8c67c009b7225$exports = $2cf8c67c009b7225$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4c9496debf2dfab7$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$4c9496debf2dfab7$var$ListCache.prototype.clear = $81ef565610c44066$exports;
$4c9496debf2dfab7$var$ListCache.prototype["delete"] = $c1997fcf228f3e88$exports;
$4c9496debf2dfab7$var$ListCache.prototype.get = $b463b4ba4c87ba26$exports;
$4c9496debf2dfab7$var$ListCache.prototype.has = $13b24b19adc0dc4b$exports;
$4c9496debf2dfab7$var$ListCache.prototype.set = $2cf8c67c009b7225$exports;
$4c9496debf2dfab7$exports = $4c9496debf2dfab7$var$ListCache;


var $cafeb82426cf1ce3$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $cafeb82426cf1ce3$var$stackClear() {
    this.__data__ = new $4c9496debf2dfab7$exports;
    this.size = 0;
}
$cafeb82426cf1ce3$exports = $cafeb82426cf1ce3$var$stackClear;


var $b544cdcc094d557f$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b544cdcc094d557f$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$b544cdcc094d557f$exports = $b544cdcc094d557f$var$stackDelete;


var $68e3204183c46092$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $68e3204183c46092$var$stackGet(key) {
    return this.__data__.get(key);
}
$68e3204183c46092$exports = $68e3204183c46092$var$stackGet;


var $98cf7dd9f2d799fd$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $98cf7dd9f2d799fd$var$stackHas(key) {
    return this.__data__.has(key);
}
$98cf7dd9f2d799fd$exports = $98cf7dd9f2d799fd$var$stackHas;


var $4a59027aadc0f3fd$exports = {};

var $512a082725507343$exports = {};
var $e6dba3193c9726c4$exports = {};
var $1a71d5040d0a3ca0$exports = {};
var $077e1638d43d8cee$exports = {};
var $79796df0d07208ef$exports = {};
var $4745131536d797ac$exports = {};

var $fNJVo = parcelRequire("fNJVo");
/** Built-in value references. */ var $4745131536d797ac$var$Symbol = $fNJVo.Symbol;
$4745131536d797ac$exports = $4745131536d797ac$var$Symbol;


var $03b373bc2991e0a0$exports = {};

/** Used for built-in method references. */ var $03b373bc2991e0a0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $03b373bc2991e0a0$var$hasOwnProperty = $03b373bc2991e0a0$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $03b373bc2991e0a0$var$nativeObjectToString = $03b373bc2991e0a0$var$objectProto.toString;
/** Built-in value references. */ var $03b373bc2991e0a0$var$symToStringTag = $4745131536d797ac$exports ? $4745131536d797ac$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $03b373bc2991e0a0$var$getRawTag(value) {
    var isOwn = $03b373bc2991e0a0$var$hasOwnProperty.call(value, $03b373bc2991e0a0$var$symToStringTag), tag = value[$03b373bc2991e0a0$var$symToStringTag];
    try {
        value[$03b373bc2991e0a0$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $03b373bc2991e0a0$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$03b373bc2991e0a0$var$symToStringTag] = tag;
        else delete value[$03b373bc2991e0a0$var$symToStringTag];
    }
    return result;
}
$03b373bc2991e0a0$exports = $03b373bc2991e0a0$var$getRawTag;


var $ebd9e00bb680c01f$exports = {};
/** Used for built-in method references. */ var $ebd9e00bb680c01f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ebd9e00bb680c01f$var$nativeObjectToString = $ebd9e00bb680c01f$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $ebd9e00bb680c01f$var$objectToString(value) {
    return $ebd9e00bb680c01f$var$nativeObjectToString.call(value);
}
$ebd9e00bb680c01f$exports = $ebd9e00bb680c01f$var$objectToString;


/** `Object#toString` result references. */ var $79796df0d07208ef$var$nullTag = "[object Null]", $79796df0d07208ef$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $79796df0d07208ef$var$symToStringTag = $4745131536d797ac$exports ? $4745131536d797ac$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $79796df0d07208ef$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $79796df0d07208ef$var$undefinedTag : $79796df0d07208ef$var$nullTag;
    return $79796df0d07208ef$var$symToStringTag && $79796df0d07208ef$var$symToStringTag in Object(value) ? $03b373bc2991e0a0$exports(value) : $ebd9e00bb680c01f$exports(value);
}
$79796df0d07208ef$exports = $79796df0d07208ef$var$baseGetTag;



/** `Object#toString` result references. */ var $077e1638d43d8cee$var$asyncTag = "[object AsyncFunction]", $077e1638d43d8cee$var$funcTag = "[object Function]", $077e1638d43d8cee$var$genTag = "[object GeneratorFunction]", $077e1638d43d8cee$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $077e1638d43d8cee$var$isFunction(value) {
    if (!$38ff99188d059d52$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $79796df0d07208ef$exports(value);
    return tag == $077e1638d43d8cee$var$funcTag || tag == $077e1638d43d8cee$var$genTag || tag == $077e1638d43d8cee$var$asyncTag || tag == $077e1638d43d8cee$var$proxyTag;
}
$077e1638d43d8cee$exports = $077e1638d43d8cee$var$isFunction;


var $6e75a547422239e7$exports = {};
var $9b17375e9aaa9a43$exports = {};

var $fNJVo = parcelRequire("fNJVo");
/** Used to detect overreaching core-js shims. */ var $9b17375e9aaa9a43$var$coreJsData = $fNJVo["__core-js_shared__"];
$9b17375e9aaa9a43$exports = $9b17375e9aaa9a43$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $6e75a547422239e7$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($9b17375e9aaa9a43$exports && $9b17375e9aaa9a43$exports.keys && $9b17375e9aaa9a43$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $6e75a547422239e7$var$isMasked(func) {
    return !!$6e75a547422239e7$var$maskSrcKey && $6e75a547422239e7$var$maskSrcKey in func;
}
$6e75a547422239e7$exports = $6e75a547422239e7$var$isMasked;



var $5239300eb73938e8$exports = {};
/** Used for built-in method references. */ var $5239300eb73938e8$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $5239300eb73938e8$var$funcToString = $5239300eb73938e8$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $5239300eb73938e8$var$toSource(func) {
    if (func != null) {
        try {
            return $5239300eb73938e8$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$5239300eb73938e8$exports = $5239300eb73938e8$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $1a71d5040d0a3ca0$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $1a71d5040d0a3ca0$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $1a71d5040d0a3ca0$var$funcProto = Function.prototype, $1a71d5040d0a3ca0$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $1a71d5040d0a3ca0$var$funcToString = $1a71d5040d0a3ca0$var$funcProto.toString;
/** Used to check objects for own properties. */ var $1a71d5040d0a3ca0$var$hasOwnProperty = $1a71d5040d0a3ca0$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $1a71d5040d0a3ca0$var$reIsNative = RegExp("^" + $1a71d5040d0a3ca0$var$funcToString.call($1a71d5040d0a3ca0$var$hasOwnProperty).replace($1a71d5040d0a3ca0$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $1a71d5040d0a3ca0$var$baseIsNative(value) {
    if (!$38ff99188d059d52$exports(value) || $6e75a547422239e7$exports(value)) return false;
    var pattern = $077e1638d43d8cee$exports(value) ? $1a71d5040d0a3ca0$var$reIsNative : $1a71d5040d0a3ca0$var$reIsHostCtor;
    return pattern.test($5239300eb73938e8$exports(value));
}
$1a71d5040d0a3ca0$exports = $1a71d5040d0a3ca0$var$baseIsNative;


var $adb7acbcc73ddc26$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $adb7acbcc73ddc26$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$adb7acbcc73ddc26$exports = $adb7acbcc73ddc26$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e6dba3193c9726c4$var$getNative(object, key) {
    var value = $adb7acbcc73ddc26$exports(object, key);
    return $1a71d5040d0a3ca0$exports(value) ? value : undefined;
}
$e6dba3193c9726c4$exports = $e6dba3193c9726c4$var$getNative;



var $fNJVo = parcelRequire("fNJVo");
/* Built-in method references that are verified to be native. */ var $512a082725507343$var$Map = $e6dba3193c9726c4$exports($fNJVo, "Map");
$512a082725507343$exports = $512a082725507343$var$Map;


var $04f8b00d118f0f6d$exports = {};
var $eea8634c86531942$exports = {};
var $21d936c9fec79d9d$exports = {};
var $c90c20adae151f9f$exports = {};
var $73252879e44224f4$exports = {};

/* Built-in method references that are verified to be native. */ var $73252879e44224f4$var$nativeCreate = $e6dba3193c9726c4$exports(Object, "create");
$73252879e44224f4$exports = $73252879e44224f4$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $c90c20adae151f9f$var$hashClear() {
    this.__data__ = $73252879e44224f4$exports ? $73252879e44224f4$exports(null) : {};
    this.size = 0;
}
$c90c20adae151f9f$exports = $c90c20adae151f9f$var$hashClear;


var $f53bacee6e81de2b$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f53bacee6e81de2b$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$f53bacee6e81de2b$exports = $f53bacee6e81de2b$var$hashDelete;


var $7471e66401d112a7$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $7471e66401d112a7$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $7471e66401d112a7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7471e66401d112a7$var$hasOwnProperty = $7471e66401d112a7$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7471e66401d112a7$var$hashGet(key) {
    var data = this.__data__;
    if ($73252879e44224f4$exports) {
        var result = data[key];
        return result === $7471e66401d112a7$var$HASH_UNDEFINED ? undefined : result;
    }
    return $7471e66401d112a7$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$7471e66401d112a7$exports = $7471e66401d112a7$var$hashGet;


var $f932d333ae7112ff$exports = {};

/** Used for built-in method references. */ var $f932d333ae7112ff$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f932d333ae7112ff$var$hasOwnProperty = $f932d333ae7112ff$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f932d333ae7112ff$var$hashHas(key) {
    var data = this.__data__;
    return $73252879e44224f4$exports ? data[key] !== undefined : $f932d333ae7112ff$var$hasOwnProperty.call(data, key);
}
$f932d333ae7112ff$exports = $f932d333ae7112ff$var$hashHas;


var $4f95f75935edb5a0$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $4f95f75935edb5a0$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $4f95f75935edb5a0$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $73252879e44224f4$exports && value === undefined ? $4f95f75935edb5a0$var$HASH_UNDEFINED : value;
    return this;
}
$4f95f75935edb5a0$exports = $4f95f75935edb5a0$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $21d936c9fec79d9d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$21d936c9fec79d9d$var$Hash.prototype.clear = $c90c20adae151f9f$exports;
$21d936c9fec79d9d$var$Hash.prototype["delete"] = $f53bacee6e81de2b$exports;
$21d936c9fec79d9d$var$Hash.prototype.get = $7471e66401d112a7$exports;
$21d936c9fec79d9d$var$Hash.prototype.has = $f932d333ae7112ff$exports;
$21d936c9fec79d9d$var$Hash.prototype.set = $4f95f75935edb5a0$exports;
$21d936c9fec79d9d$exports = $21d936c9fec79d9d$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $eea8634c86531942$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $21d936c9fec79d9d$exports,
        "map": new ($512a082725507343$exports || $4c9496debf2dfab7$exports),
        "string": new $21d936c9fec79d9d$exports
    };
}
$eea8634c86531942$exports = $eea8634c86531942$var$mapCacheClear;


var $904e09c42bd5303f$exports = {};
var $69bc06d6b678de83$exports = {};
var $de7a75878c53e3bd$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $de7a75878c53e3bd$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$de7a75878c53e3bd$exports = $de7a75878c53e3bd$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $69bc06d6b678de83$var$getMapData(map, key) {
    var data = map.__data__;
    return $de7a75878c53e3bd$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$69bc06d6b678de83$exports = $69bc06d6b678de83$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $904e09c42bd5303f$var$mapCacheDelete(key) {
    var result = $69bc06d6b678de83$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$904e09c42bd5303f$exports = $904e09c42bd5303f$var$mapCacheDelete;


var $88d3393941a7d1af$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $88d3393941a7d1af$var$mapCacheGet(key) {
    return $69bc06d6b678de83$exports(this, key).get(key);
}
$88d3393941a7d1af$exports = $88d3393941a7d1af$var$mapCacheGet;


var $d3b8efc9069f7f6d$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3b8efc9069f7f6d$var$mapCacheHas(key) {
    return $69bc06d6b678de83$exports(this, key).has(key);
}
$d3b8efc9069f7f6d$exports = $d3b8efc9069f7f6d$var$mapCacheHas;


var $13709600424c2257$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $13709600424c2257$var$mapCacheSet(key, value) {
    var data = $69bc06d6b678de83$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$13709600424c2257$exports = $13709600424c2257$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $04f8b00d118f0f6d$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$04f8b00d118f0f6d$var$MapCache.prototype.clear = $eea8634c86531942$exports;
$04f8b00d118f0f6d$var$MapCache.prototype["delete"] = $904e09c42bd5303f$exports;
$04f8b00d118f0f6d$var$MapCache.prototype.get = $88d3393941a7d1af$exports;
$04f8b00d118f0f6d$var$MapCache.prototype.has = $d3b8efc9069f7f6d$exports;
$04f8b00d118f0f6d$var$MapCache.prototype.set = $13709600424c2257$exports;
$04f8b00d118f0f6d$exports = $04f8b00d118f0f6d$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $4a59027aadc0f3fd$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $4a59027aadc0f3fd$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $4c9496debf2dfab7$exports) {
        var pairs = data.__data__;
        if (!$512a082725507343$exports || pairs.length < $4a59027aadc0f3fd$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $04f8b00d118f0f6d$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$4a59027aadc0f3fd$exports = $4a59027aadc0f3fd$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d1833597dde236cc$var$Stack(entries) {
    var data = this.__data__ = new $4c9496debf2dfab7$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$d1833597dde236cc$var$Stack.prototype.clear = $cafeb82426cf1ce3$exports;
$d1833597dde236cc$var$Stack.prototype["delete"] = $b544cdcc094d557f$exports;
$d1833597dde236cc$var$Stack.prototype.get = $68e3204183c46092$exports;
$d1833597dde236cc$var$Stack.prototype.has = $98cf7dd9f2d799fd$exports;
$d1833597dde236cc$var$Stack.prototype.set = $4a59027aadc0f3fd$exports;
$d1833597dde236cc$exports = $d1833597dde236cc$var$Stack;


var $a480959943e85be3$exports = {};
var $aa48a6b2501aa483$exports = {};
var $786c95866aad6f15$exports = {};

var $786c95866aad6f15$var$defineProperty = function() {
    try {
        var func = $e6dba3193c9726c4$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$786c95866aad6f15$exports = $786c95866aad6f15$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $aa48a6b2501aa483$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $786c95866aad6f15$exports) $786c95866aad6f15$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$aa48a6b2501aa483$exports = $aa48a6b2501aa483$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a480959943e85be3$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$ccd1dfea300b5fbe$exports(object[key], value) || value === undefined && !(key in object)) $aa48a6b2501aa483$exports(object, key, value);
}
$a480959943e85be3$exports = $a480959943e85be3$var$assignMergeValue;


var $cdd21b77adaff744$exports = {};
var $2b227f9a04fdd17b$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $2b227f9a04fdd17b$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$2b227f9a04fdd17b$exports = $2b227f9a04fdd17b$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $cdd21b77adaff744$var$baseFor = $2b227f9a04fdd17b$exports();
$cdd21b77adaff744$exports = $cdd21b77adaff744$var$baseFor;


var $f0438055f14e9687$exports = {};


var $lNdKa = parcelRequire("lNdKa");
var $f24f8918ebad94ff$exports = {};
var $7cf2017d5dbf9c1e$exports = {};
var $7212f36cc885c70d$exports = {};

var $fNJVo = parcelRequire("fNJVo");
/** Built-in value references. */ var $7212f36cc885c70d$var$Uint8Array = $fNJVo.Uint8Array;
$7212f36cc885c70d$exports = $7212f36cc885c70d$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $7cf2017d5dbf9c1e$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $7212f36cc885c70d$exports(result).set(new $7212f36cc885c70d$exports(arrayBuffer));
    return result;
}
$7cf2017d5dbf9c1e$exports = $7cf2017d5dbf9c1e$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $f24f8918ebad94ff$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $7cf2017d5dbf9c1e$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$f24f8918ebad94ff$exports = $f24f8918ebad94ff$var$cloneTypedArray;


var $892d74bc47a6142a$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $892d74bc47a6142a$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$892d74bc47a6142a$exports = $892d74bc47a6142a$var$copyArray;


var $4218bcdeaf011a19$exports = {};
var $f63a9f44e44b9b0e$exports = {};

/** Built-in value references. */ var $f63a9f44e44b9b0e$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $f63a9f44e44b9b0e$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$38ff99188d059d52$exports(proto)) return {};
        if ($f63a9f44e44b9b0e$var$objectCreate) return $f63a9f44e44b9b0e$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$f63a9f44e44b9b0e$exports = $f63a9f44e44b9b0e$var$baseCreate;


var $6225d8b6a0e5a410$exports = {};
var $c993c2296a98087c$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $c993c2296a98087c$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$c993c2296a98087c$exports = $c993c2296a98087c$var$overArg;


/** Built-in value references. */ var $6225d8b6a0e5a410$var$getPrototype = $c993c2296a98087c$exports(Object.getPrototypeOf, Object);
$6225d8b6a0e5a410$exports = $6225d8b6a0e5a410$var$getPrototype;


var $ba0eec54535e4b27$exports = {};
/** Used for built-in method references. */ var $ba0eec54535e4b27$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $ba0eec54535e4b27$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $ba0eec54535e4b27$var$objectProto;
    return value === proto;
}
$ba0eec54535e4b27$exports = $ba0eec54535e4b27$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $4218bcdeaf011a19$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$ba0eec54535e4b27$exports(object) ? $f63a9f44e44b9b0e$exports($6225d8b6a0e5a410$exports(object)) : {};
}
$4218bcdeaf011a19$exports = $4218bcdeaf011a19$var$initCloneObject;


var $b7af7320b985fe40$exports = {};
var $c3b46d74622bb4df$exports = {};

var $8e31d76e9d05173f$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $8e31d76e9d05173f$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$8e31d76e9d05173f$exports = $8e31d76e9d05173f$var$isObjectLike;


/** `Object#toString` result references. */ var $c3b46d74622bb4df$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $c3b46d74622bb4df$var$baseIsArguments(value) {
    return $8e31d76e9d05173f$exports(value) && $79796df0d07208ef$exports(value) == $c3b46d74622bb4df$var$argsTag;
}
$c3b46d74622bb4df$exports = $c3b46d74622bb4df$var$baseIsArguments;



/** Used for built-in method references. */ var $b7af7320b985fe40$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b7af7320b985fe40$var$hasOwnProperty = $b7af7320b985fe40$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $b7af7320b985fe40$var$propertyIsEnumerable = $b7af7320b985fe40$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $b7af7320b985fe40$var$isArguments = $c3b46d74622bb4df$exports(function() {
    return arguments;
}()) ? $c3b46d74622bb4df$exports : function(value) {
    return $8e31d76e9d05173f$exports(value) && $b7af7320b985fe40$var$hasOwnProperty.call(value, "callee") && !$b7af7320b985fe40$var$propertyIsEnumerable.call(value, "callee");
};
$b7af7320b985fe40$exports = $b7af7320b985fe40$var$isArguments;


var $b879a56dcf4bb3c4$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $b879a56dcf4bb3c4$var$isArray = Array.isArray;
$b879a56dcf4bb3c4$exports = $b879a56dcf4bb3c4$var$isArray;


var $afe5fe26f21315bc$exports = {};
var $5e84ab26893f9442$exports = {};

var $17cb4c1810bfad24$exports = {};
/** Used as references for various `Number` constants. */ var $17cb4c1810bfad24$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $17cb4c1810bfad24$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $17cb4c1810bfad24$var$MAX_SAFE_INTEGER;
}
$17cb4c1810bfad24$exports = $17cb4c1810bfad24$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $5e84ab26893f9442$var$isArrayLike(value) {
    return value != null && $17cb4c1810bfad24$exports(value.length) && !$077e1638d43d8cee$exports(value);
}
$5e84ab26893f9442$exports = $5e84ab26893f9442$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $afe5fe26f21315bc$var$isArrayLikeObject(value) {
    return $8e31d76e9d05173f$exports(value) && $5e84ab26893f9442$exports(value);
}
$afe5fe26f21315bc$exports = $afe5fe26f21315bc$var$isArrayLikeObject;



var $2W9As = parcelRequire("2W9As");


var $f54bf580f04ba371$exports = {};



/** `Object#toString` result references. */ var $f54bf580f04ba371$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $f54bf580f04ba371$var$funcProto = Function.prototype, $f54bf580f04ba371$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $f54bf580f04ba371$var$funcToString = $f54bf580f04ba371$var$funcProto.toString;
/** Used to check objects for own properties. */ var $f54bf580f04ba371$var$hasOwnProperty = $f54bf580f04ba371$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $f54bf580f04ba371$var$objectCtorString = $f54bf580f04ba371$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $f54bf580f04ba371$var$isPlainObject(value) {
    if (!$8e31d76e9d05173f$exports(value) || $79796df0d07208ef$exports(value) != $f54bf580f04ba371$var$objectTag) return false;
    var proto = $6225d8b6a0e5a410$exports(value);
    if (proto === null) return true;
    var Ctor = $f54bf580f04ba371$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $f54bf580f04ba371$var$funcToString.call(Ctor) == $f54bf580f04ba371$var$objectCtorString;
}
$f54bf580f04ba371$exports = $f54bf580f04ba371$var$isPlainObject;


var $ee624536fbb2e003$exports = {};
var $6f2fd9d84a0bb6d4$exports = {};



/** `Object#toString` result references. */ var $6f2fd9d84a0bb6d4$var$argsTag = "[object Arguments]", $6f2fd9d84a0bb6d4$var$arrayTag = "[object Array]", $6f2fd9d84a0bb6d4$var$boolTag = "[object Boolean]", $6f2fd9d84a0bb6d4$var$dateTag = "[object Date]", $6f2fd9d84a0bb6d4$var$errorTag = "[object Error]", $6f2fd9d84a0bb6d4$var$funcTag = "[object Function]", $6f2fd9d84a0bb6d4$var$mapTag = "[object Map]", $6f2fd9d84a0bb6d4$var$numberTag = "[object Number]", $6f2fd9d84a0bb6d4$var$objectTag = "[object Object]", $6f2fd9d84a0bb6d4$var$regexpTag = "[object RegExp]", $6f2fd9d84a0bb6d4$var$setTag = "[object Set]", $6f2fd9d84a0bb6d4$var$stringTag = "[object String]", $6f2fd9d84a0bb6d4$var$weakMapTag = "[object WeakMap]";
var $6f2fd9d84a0bb6d4$var$arrayBufferTag = "[object ArrayBuffer]", $6f2fd9d84a0bb6d4$var$dataViewTag = "[object DataView]", $6f2fd9d84a0bb6d4$var$float32Tag = "[object Float32Array]", $6f2fd9d84a0bb6d4$var$float64Tag = "[object Float64Array]", $6f2fd9d84a0bb6d4$var$int8Tag = "[object Int8Array]", $6f2fd9d84a0bb6d4$var$int16Tag = "[object Int16Array]", $6f2fd9d84a0bb6d4$var$int32Tag = "[object Int32Array]", $6f2fd9d84a0bb6d4$var$uint8Tag = "[object Uint8Array]", $6f2fd9d84a0bb6d4$var$uint8ClampedTag = "[object Uint8ClampedArray]", $6f2fd9d84a0bb6d4$var$uint16Tag = "[object Uint16Array]", $6f2fd9d84a0bb6d4$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $6f2fd9d84a0bb6d4$var$typedArrayTags = {};
$6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$float32Tag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$float64Tag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$int8Tag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$int16Tag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$int32Tag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$uint8Tag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$uint8ClampedTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$uint16Tag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$uint32Tag] = true;
$6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$argsTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$arrayTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$arrayBufferTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$boolTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$dataViewTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$dateTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$errorTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$funcTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$mapTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$numberTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$objectTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$regexpTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$setTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$stringTag] = $6f2fd9d84a0bb6d4$var$typedArrayTags[$6f2fd9d84a0bb6d4$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $6f2fd9d84a0bb6d4$var$baseIsTypedArray(value) {
    return $8e31d76e9d05173f$exports(value) && $17cb4c1810bfad24$exports(value.length) && !!$6f2fd9d84a0bb6d4$var$typedArrayTags[$79796df0d07208ef$exports(value)];
}
$6f2fd9d84a0bb6d4$exports = $6f2fd9d84a0bb6d4$var$baseIsTypedArray;


var $d26adae8a43490ae$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $d26adae8a43490ae$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$d26adae8a43490ae$exports = $d26adae8a43490ae$var$baseUnary;



var $74qZ6 = parcelRequire("74qZ6");
/* Node.js helper references. */ var $ee624536fbb2e003$var$nodeIsTypedArray = $74qZ6 && $74qZ6.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $ee624536fbb2e003$var$isTypedArray = $ee624536fbb2e003$var$nodeIsTypedArray ? $d26adae8a43490ae$exports($ee624536fbb2e003$var$nodeIsTypedArray) : $6f2fd9d84a0bb6d4$exports;
$ee624536fbb2e003$exports = $ee624536fbb2e003$var$isTypedArray;


var $fcc06076688a7f74$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $fcc06076688a7f74$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
$fcc06076688a7f74$exports = $fcc06076688a7f74$var$safeGet;


var $02456100df7b1d58$exports = {};
var $c91289edf5ee1498$exports = {};
var $abb25edc9a61a733$exports = {};


/** Used for built-in method references. */ var $abb25edc9a61a733$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $abb25edc9a61a733$var$hasOwnProperty = $abb25edc9a61a733$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $abb25edc9a61a733$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($abb25edc9a61a733$var$hasOwnProperty.call(object, key) && $ccd1dfea300b5fbe$exports(objValue, value)) || value === undefined && !(key in object)) $aa48a6b2501aa483$exports(object, key, value);
}
$abb25edc9a61a733$exports = $abb25edc9a61a733$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $c91289edf5ee1498$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $aa48a6b2501aa483$exports(object, key, newValue);
        else $abb25edc9a61a733$exports(object, key, newValue);
    }
    return object;
}
$c91289edf5ee1498$exports = $c91289edf5ee1498$var$copyObject;


var $f7d4c3ae5541f253$exports = {};
var $3de354bcd8e0f1db$exports = {};
var $3428e1de16d7022f$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $3428e1de16d7022f$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$3428e1de16d7022f$exports = $3428e1de16d7022f$var$baseTimes;





var $2W9As = parcelRequire("2W9As");
var $df68d5fc40e11af3$exports = {};
/** Used as references for various `Number` constants. */ var $df68d5fc40e11af3$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $df68d5fc40e11af3$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $df68d5fc40e11af3$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $df68d5fc40e11af3$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $df68d5fc40e11af3$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$df68d5fc40e11af3$exports = $df68d5fc40e11af3$var$isIndex;



/** Used for built-in method references. */ var $3de354bcd8e0f1db$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3de354bcd8e0f1db$var$hasOwnProperty = $3de354bcd8e0f1db$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $3de354bcd8e0f1db$var$arrayLikeKeys(value, inherited) {
    var isArr = $b879a56dcf4bb3c4$exports(value), isArg = !isArr && $b7af7320b985fe40$exports(value), isBuff = !isArr && !isArg && $2W9As(value), isType = !isArr && !isArg && !isBuff && $ee624536fbb2e003$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $3428e1de16d7022f$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $3de354bcd8e0f1db$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $df68d5fc40e11af3$exports(key, length)))) result.push(key);
    return result;
}
$3de354bcd8e0f1db$exports = $3de354bcd8e0f1db$var$arrayLikeKeys;


var $00bb8af4f869c8c2$exports = {};


var $aac1d15b5dd2a044$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $aac1d15b5dd2a044$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$aac1d15b5dd2a044$exports = $aac1d15b5dd2a044$var$nativeKeysIn;


/** Used for built-in method references. */ var $00bb8af4f869c8c2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $00bb8af4f869c8c2$var$hasOwnProperty = $00bb8af4f869c8c2$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $00bb8af4f869c8c2$var$baseKeysIn(object) {
    if (!$38ff99188d059d52$exports(object)) return $aac1d15b5dd2a044$exports(object);
    var isProto = $ba0eec54535e4b27$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$00bb8af4f869c8c2$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$00bb8af4f869c8c2$exports = $00bb8af4f869c8c2$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $f7d4c3ae5541f253$var$keysIn(object) {
    return $5e84ab26893f9442$exports(object) ? $3de354bcd8e0f1db$exports(object, true) : $00bb8af4f869c8c2$exports(object);
}
$f7d4c3ae5541f253$exports = $f7d4c3ae5541f253$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $02456100df7b1d58$var$toPlainObject(value) {
    return $c91289edf5ee1498$exports(value, $f7d4c3ae5541f253$exports(value));
}
$02456100df7b1d58$exports = $02456100df7b1d58$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $f0438055f14e9687$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $fcc06076688a7f74$exports(object, key), srcValue = $fcc06076688a7f74$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $a480959943e85be3$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $b879a56dcf4bb3c4$exports(srcValue), isBuff = !isArr && $2W9As(srcValue), isTyped = !isArr && !isBuff && $ee624536fbb2e003$exports(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($b879a56dcf4bb3c4$exports(objValue)) newValue = objValue;
            else if ($afe5fe26f21315bc$exports(objValue)) newValue = $892d74bc47a6142a$exports(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $lNdKa(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $f24f8918ebad94ff$exports(srcValue, true);
            } else newValue = [];
        } else if ($f54bf580f04ba371$exports(srcValue) || $b7af7320b985fe40$exports(srcValue)) {
            newValue = objValue;
            if ($b7af7320b985fe40$exports(objValue)) newValue = $02456100df7b1d58$exports(objValue);
            else if (!$38ff99188d059d52$exports(objValue) || $077e1638d43d8cee$exports(objValue)) newValue = $4218bcdeaf011a19$exports(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $a480959943e85be3$exports(object, key, newValue);
}
$f0438055f14e9687$exports = $f0438055f14e9687$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $353b0f796da2df31$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $cdd21b77adaff744$exports(source, function(srcValue, key) {
        stack || (stack = new $d1833597dde236cc$exports);
        if ($38ff99188d059d52$exports(srcValue)) $f0438055f14e9687$exports(object, source, key, srcIndex, $353b0f796da2df31$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($fcc06076688a7f74$exports(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $a480959943e85be3$exports(object, key, newValue);
        }
    }, $f7d4c3ae5541f253$exports);
}
$353b0f796da2df31$exports = $353b0f796da2df31$var$baseMerge;


var $ec0f9f2d9576f5b3$exports = {};
var $4b4070981097ce01$exports = {};
var $4a86c58530eeea0e$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $4a86c58530eeea0e$var$identity(value) {
    return value;
}
$4a86c58530eeea0e$exports = $4a86c58530eeea0e$var$identity;


var $b3b8e54ddb4f64b9$exports = {};
var $2b30d7e45ce37523$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $2b30d7e45ce37523$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$2b30d7e45ce37523$exports = $2b30d7e45ce37523$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $b3b8e54ddb4f64b9$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $b3b8e54ddb4f64b9$var$overRest(func, start, transform) {
    start = $b3b8e54ddb4f64b9$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $b3b8e54ddb4f64b9$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $2b30d7e45ce37523$exports(func, this, otherArgs);
    };
}
$b3b8e54ddb4f64b9$exports = $b3b8e54ddb4f64b9$var$overRest;


var $dff9a6829bf74c43$exports = {};
var $f35cad1372c8601e$exports = {};
var $dc4e7f385e915a5b$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $dc4e7f385e915a5b$var$constant(value) {
    return function() {
        return value;
    };
}
$dc4e7f385e915a5b$exports = $dc4e7f385e915a5b$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $f35cad1372c8601e$var$baseSetToString = !$786c95866aad6f15$exports ? $4a86c58530eeea0e$exports : function(func, string) {
    return $786c95866aad6f15$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $dc4e7f385e915a5b$exports(string),
        "writable": true
    });
};
$f35cad1372c8601e$exports = $f35cad1372c8601e$var$baseSetToString;


var $ade6dfae0c54fda7$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $ade6dfae0c54fda7$var$HOT_COUNT = 800, $ade6dfae0c54fda7$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ade6dfae0c54fda7$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $ade6dfae0c54fda7$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $ade6dfae0c54fda7$var$nativeNow(), remaining = $ade6dfae0c54fda7$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $ade6dfae0c54fda7$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$ade6dfae0c54fda7$exports = $ade6dfae0c54fda7$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $dff9a6829bf74c43$var$setToString = $ade6dfae0c54fda7$exports($f35cad1372c8601e$exports);
$dff9a6829bf74c43$exports = $dff9a6829bf74c43$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $4b4070981097ce01$var$baseRest(func, start) {
    return $dff9a6829bf74c43$exports($b3b8e54ddb4f64b9$exports(func, start, $4a86c58530eeea0e$exports), func + "");
}
$4b4070981097ce01$exports = $4b4070981097ce01$var$baseRest;


var $528771e5e3ed80e6$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $528771e5e3ed80e6$var$isIterateeCall(value, index, object) {
    if (!$38ff99188d059d52$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $5e84ab26893f9442$exports(object) && $df68d5fc40e11af3$exports(index, object.length) : type == "string" && index in object) return $ccd1dfea300b5fbe$exports(object[index], value);
    return false;
}
$528771e5e3ed80e6$exports = $528771e5e3ed80e6$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $ec0f9f2d9576f5b3$var$createAssigner(assigner) {
    return $4b4070981097ce01$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $528771e5e3ed80e6$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$ec0f9f2d9576f5b3$exports = $ec0f9f2d9576f5b3$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $89aeca5d4d27357e$var$merge = $ec0f9f2d9576f5b3$exports(function(object, source, srcIndex) {
    $353b0f796da2df31$exports(object, source, srcIndex);
});
$89aeca5d4d27357e$exports = $89aeca5d4d27357e$var$merge;



(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c("GravitySupport", {
    init () {
        this.activateGravity = this.activateGravity.bind(this);
        this._onGravityCollisionHit = this._onGravityCollisionHit.bind(this);
    },
    activateGravity (surfaces = [
        "GravitySolid",
        "GravityLiquid"
    ]) {
        this.addComponent("Motion", "Collision", (0, $6477623efad0c52d$export$2e2bcd8739ae039));
        this.ay = 400;
        this.bind("HitOn", this._onGravityCollisionHit);
        this.checkHits(...surfaces);
    },
    _onGravityCollisionHit (collisions) {
        let groundType = "none";
        let surfaceEntity = null;
        collisions.forEach((e)=>{
            const surface = e.obj;
            if (surface.has("GravitySolid")) {
                groundType = "solid";
                surfaceEntity = surface;
            }
            if (surface.has("GravityLiquid")) {
                groundType = "liquid";
                surfaceEntity = surface;
            }
        });
        if (groundType === "solid") {
            if (this.vy > 200) // little bounce
            this.attr({
                vy: -this.vy / 4
            });
            else {
                this.attr({
                    ay: 0,
                    ax: 0,
                    vx: 0,
                    vy: 0
                });
                this.showState && this.showState("crashed");
                // TODO: Destroy if surface is destroyed or frozen
                surfaceEntity.attach(this);
            }
        }
        if (groundType === "liquid") {
            this.attr({
                ax: 0,
                ay: 0,
                vx: 0,
                vy: this.vy / surfaceEntity.liquidDensity,
                hideBelow: surfaceEntity.y + 30,
                surfaceLevel: surfaceEntity.y
            });
            if (surfaceEntity.liquidParticles) {
                const settings = [].concat(surfaceEntity.liquidParticles, {
                    emitter: {
                        w: this.w,
                        h: 10,
                        amount: this.w * 1.5
                    }
                });
                const emitter = (0, (/*@__PURE__*/$parcel$interopDefault($89aeca5d4d27357e$exports)))({}, (0, $4a464ac9ac54fc86$export$2096b54ada1e6fa4)(settings[0]), settings[1]);
                this.liquidEmitter = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e((0, $767c35cd7f31dfa2$export$2e2bcd8739ae039)).attr({
                    x: this.x,
                    y: surfaceEntity.y + 20
                }).particles(emitter);
            }
            this.uniqueBind("GameLoop", this._sinkAway);
        }
    },
    _sinkAway () {
        const sunk = this.y > this.hideBelow;
        Object.values(this.currentAttachHooks).forEach((hook)=>{
            if (hook.currentAttachment && hook.currentAttachment.emitter && hook.currentAttachment.emitter.emissionRate > 0 && hook.y > this.hideBelow) hook.currentAttachment.emitter.stopEmission();
        });
        if (sunk) {
            this.liquidEmitter.stopEmission();
            this.liquidEmitter.autoDestruct = true;
            this.destroy();
            this.unbind("GameLoop", this._sinkAway);
        }
    }
});






(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c("SubmergeSupport", {
    init () {
        this._onGravityCollisionHit = this._onGravityCollisionHit.bind(this);
        this.addComponent("Motion", "Collision");
        this.bind("HitOn", this._onGravityCollisionHit);
        this.checkHits("GravityLiquid");
        this.clearShadow = this.clearShadow.bind(this);
    },
    events: {
        Freeze () {
            if (this.liquidEmitter) {
                this.liquidEmitter.stopEmission();
                this.liquidEmitter.autoDestruct = true;
                this.liquidEmitter = null;
            }
            if (this.shadow) {
                this.shadow.destroy();
                this.shadow = null;
            }
        },
        Remove () {
            if (this.liquidEmitter) {
                this.liquidEmitter.stopEmission();
                this.liquidEmitter.autoDestruct = true;
                this.liquidEmitter = null;
            }
            if (this.shadow) {
                this.shadow.destroy();
                this.shadow = null;
            }
        }
    },
    _onGravityCollisionHit (collisions) {
        if (this.surface) return;
        let surfaceEntity = null;
        collisions.forEach((e)=>{
            const surface = e.obj;
            if (surface.has("GravityLiquid")) surfaceEntity = surface;
        });
        this.attr({
            hideBelow: surfaceEntity.y + 30,
            surface: surfaceEntity
        });
        if (surfaceEntity.liquidParticles) {
            const settings = [].concat(surfaceEntity.liquidParticles, {
                emitter: {
                    w: this.w,
                    h: 10,
                    amount: Math.min(Math.max(this.w * 1.5, 100), 500)
                }
            });
            const emitter = (0, (/*@__PURE__*/$parcel$interopDefault($89aeca5d4d27357e$exports)))({}, (0, $4a464ac9ac54fc86$export$2096b54ada1e6fa4)(settings[0]), settings[1]);
            this.liquidEmitter = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e((0, $767c35cd7f31dfa2$export$2e2bcd8739ae039)).attr({
                x: this.x,
                y: surfaceEntity.y + 20
            }).particles(emitter);
        }
        this.uniqueBind("EnterFrame", this._sinkAway);
    },
    clearShadow () {
        if (this.shadow) {
            this.shadow.destroy();
            this.shadow = null;
        }
    },
    _sinkAway () {
        const sunk = this.y > this.hideBelow;
        const risen = this.y + this.h < this.hideBelow - 30;
        Object.values(this.currentAttachHooks).forEach((hook)=>{
            if (hook.currentAttachment && hook.currentAttachment.emitter && hook.currentAttachment.emitter.emissionRate > 0 && hook.y > this.hideBelow) hook.currentAttachment.emitter.stopEmission();
        });
        if (this.shadow) {
            this.shadow.x = this.x;
            this.shadow.alpha = 1 - (this.y - this.hideBelow) / 200;
        }
        if ((sunk || risen) && this.liquidEmitter) {
            this.liquidEmitter.stopEmission();
            this.liquidEmitter.autoDestruct = true;
            this.liquidEmitter = null;
            // Render shadow
            if (sunk) {
                this.shadow = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(`2D, WebGL, ${this.submergeSprite}`).attr({
                    w: this.w,
                    x: this.x,
                    y: this.hideBelow - 20
                });
                this.uniqueBind("Remove", this.clearShadow);
            }
        } else if (this.liquidEmitter === null && !sunk && !risen) {
            if (this.shadow) {
                this.shadow.destroy();
                this.shadow = null;
            }
            // Render shadow
            const settings = [].concat(this.surface.liquidParticles, {
                emitter: {
                    w: this.w,
                    h: 10,
                    amount: Math.min(Math.max(this.w * 1.5, 100), 500)
                }
            });
            const emitter = (0, (/*@__PURE__*/$parcel$interopDefault($89aeca5d4d27357e$exports)))({}, (0, $4a464ac9ac54fc86$export$2096b54ada1e6fa4)(settings[0]), settings[1]);
            this.liquidEmitter = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e((0, $767c35cd7f31dfa2$export$2e2bcd8739ae039)).attr({
                x: this.x,
                y: this.surface.y + 20
            }).particles(emitter);
        }
    }
});




(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c("Invincible", {
    init () {
        this.requires("Delay");
        this.blinkOn = true;
    },
    _blink () {
        this.blinkOn = !this.blinkOn;
        this.alpha = this.blinkOn ? 0.5 : 1.0;
    },
    remove () {
        this.cancelDelay(this._blink);
        this.alpha = 1.0;
    },
    invincibleDuration (duration) {
        this.delay(this._blink, 250, -1);
        if (duration !== -1) this.delay(()=>this.removeComponent("Invincible"), duration, 0);
        return this;
    }
});



const $1694be6dff51cc24$var$Listener = "Listener";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($1694be6dff51cc24$var$Listener, {
    init () {
        this.listeners = [];
    },
    remove () {
        this.listeners.forEach(({ object: object, event: event, callback: callback })=>{
            object.unbind(event, callback);
        });
        this.listeners = [];
    },
    listenTo (object, event, callback, context) {
        if (context == null) context = this;
        const realCallback = (...args)=>{
            callback.apply(context, args);
        };
        this.listeners.push({
            object: object,
            event: event,
            callback: realCallback
        });
        object.uniqueBind(event, realCallback);
    }
});
var $1694be6dff51cc24$export$2e2bcd8739ae039 = $1694be6dff51cc24$var$Listener;



const $f62344210ab4fe80$var$ControlScheme = "ControlScheme";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($f62344210ab4fe80$var$ControlScheme, {
    init () {
        if (!this.has("Cheats")) this.addComponent("Cheats");
        this.trigger("Activated");
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).trigger("PlayerActivated");
    },
    remove () {
        if (this.has("Cheats")) this.removeComponent("Cheats");
        this.trigger("Deactivated");
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).trigger("PlayerDeactivated");
    }
});
var $f62344210ab4fe80$export$2e2bcd8739ae039 = $f62344210ab4fe80$var$ControlScheme;



const $98f23f39d831b128$var$ShipControls = "ShipControls";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($98f23f39d831b128$var$ShipControls, {
    init () {
        this.bind("NewDirection", (direction)=>{
            if (this.disableControls) return;
            if (direction.x === -1 && !this.xFlipped || direction.x === 1 && this.xFlipped) {
                if (this.appliedEntityState === "dead") return;
                if (this.appliedEntityState !== "reverse") this.showState("reverse");
            } else if (this.appliedEntityState !== "flying") this.showState("flying");
        });
    },
    buttonPressed (name, onOff) {
        if (this.disableControls) return;
        if (this.appliedEntityState === "dead") return;
        this.trigger(onOff ? "ButtonPressed" : "ButtonReleased", name);
    }
});
var $98f23f39d831b128$export$2e2bcd8739ae039 = $98f23f39d831b128$var$ShipControls;




const $5cbb878e064c643c$var$ShipCollision = "ShipCollision";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($5cbb878e064c643c$var$ShipCollision, {
    required: `Collision, ${(0, $372adea96c125b8d$export$2e2bcd8739ae039)}`,
    init () {
        this.onHit("ShipSolid", (hits)=>{
            const delta = this.motionDelta();
            let xCorrection = 0;
            let yCorrection = 0;
            let xDir = 0;
            let yDir = 0;
            hits.map((hitData)=>{
                let xHitCorrection = 0;
                let yHitCorrection = 0;
                if (hitData.type === "SAT") {
                    xHitCorrection -= hitData.overlap * hitData.nx;
                    yHitCorrection -= hitData.overlap * hitData.ny;
                } else {
                    // MBR
                    const { obj: obj } = hitData;
                    const d = {
                        x: 0,
                        y: 0
                    };
                    if (obj.intersect(this.x - delta.x + d.x, this.y + d.y, this.w, this.h)) yHitCorrection -= delta.y - d.y;
                    if (obj.intersect(this.x + d.y, this.y - delta.y + d.y, this.w, this.h)) xHitCorrection -= delta.x - d.x;
                }
                if (xHitCorrection !== 0) {
                    if (xHitCorrection > 0) {
                        if (xDir < 0) this._squashShip();
                        xDir = 1;
                        xCorrection = Math.max(xCorrection, xHitCorrection);
                    } else {
                        if (xDir > 0) this._squashShip();
                        xDir = -1;
                        xCorrection = Math.min(xCorrection, xHitCorrection);
                    }
                }
                if (yHitCorrection !== 0) {
                    if (yHitCorrection < 0) {
                        if (yDir > 0) this._squashShip();
                        yDir = -1;
                        return yCorrection = Math.min(yCorrection, yHitCorrection);
                    } else {
                        if (yDir < 0) this._squashShip();
                        yDir = 1;
                        return yCorrection = Math.max(yCorrection, yHitCorrection);
                    }
                }
            });
            const x = this.x;
            const y = this.y;
            this.shift(xCorrection, yCorrection);
            if (x === this.x && xCorrection || y === this.y && yCorrection) // some force (ViewportLocked) pushed ship back.
            this._squashShip();
        });
        this.onHit("PlayerEnemy", ()=>{
            const damage = {
                velocity: -8000,
                affects: "health",
                name: "Impact"
            };
            this.processDamage(damage);
        });
        this.onHit("PlayerHit", (hits)=>{
            if (this.health <= 0) return;
            hits.map((hitData)=>{
                const source = hitData.obj;
                const damage = {
                    velocity: -13000,
                    affects: "health",
                    name: "Impact"
                };
                source.processDamage && source.processDamage(damage);
            });
        });
    },
    _squashShip () {
        const damage = {
            velocity: -25000,
            affects: "health",
            name: "Impact"
        };
        this.processDamage(damage);
    }
});
var $5cbb878e064c643c$export$2e2bcd8739ae039 = $5cbb878e064c643c$var$ShipCollision;









const $6a27ecc58ed31669$var$AngleMotion = "AngleMotion";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($6a27ecc58ed31669$var$AngleMotion, {
    properties: {
        velocity: {
            set: function(value) {
                this._velocity = value;
                this._setAngleAndVelocity(this._angle, this._velocity);
            },
            get: function() {
                return this._velocity;
            },
            configurable: true,
            enumerable: true
        },
        _velocity: {
            value: 0,
            writable: true,
            enumerable: false
        },
        angle: {
            set: function(value) {
                this._angle = value;
                this._setAngleAndVelocity(this._angle, this._velocity);
            },
            get: function() {
                return this._angle;
            },
            configurable: true,
            enumerable: true
        },
        _angle: {
            value: 0,
            writable: true,
            enumerable: false
        }
    },
    _setAngleAndVelocity (angle, velocity) {
        if (velocity === 0) {
            this.attr({
                vy: 0,
                vx: 0
            });
            return;
        }
        this.attr({
            vy: -Math.sin(angle / 180 * Math.PI) * velocity,
            vx: -Math.cos(angle / 180 * Math.PI) * velocity
        });
    }
});
var $6a27ecc58ed31669$export$2e2bcd8739ae039 = $6a27ecc58ed31669$var$AngleMotion;




const $ffecfc5e040b7ea8$var$Beam = "Beam";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($ffecfc5e040b7ea8$var$Beam, {
    required: (0, $47ac9e977e9352cf$export$c33fc2cad0ee87c0),
    properties: {
        beamVelocity: {
            set: function(value) {
                this._beamVelocity = value;
                this._setBeamVelocity(this._beamVelocity);
            },
            get: function() {
                return this._beamVelocity;
            },
            configurable: true,
            enumerable: true
        },
        _beamVelocity: {
            value: 0,
            writable: true,
            enumerable: false
        }
    },
    events: {
        Freeze () {
            this._beamVelocity = 0;
            this.beamBlocked = false;
        }
    },
    _setBeamVelocity (beamVelocity) {
        if (beamVelocity === 0) {
            this.unbind("EnterFrame", this._updateBeam);
            return;
        }
        this.beamLength = this.sw;
        this.uniqueBind("EnterFrame", this._updateBeam);
    },
    _updateBeam ({ dt: dt }) {
        const add = this._beamVelocity * (dt / 1000);
        if (!this.beamBlocked) this.sw += add;
        this.beamLength += add;
    }
});
var $ffecfc5e040b7ea8$export$2e2bcd8739ae039 = $ffecfc5e040b7ea8$var$Beam;



const $6ae618afe67991d1$var$Steering = "Steering";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($6ae618afe67991d1$var$Steering, {
    properties: {
        steering: {
            set: function(value) {
                if (this._steering !== value) {
                    this._steering = value;
                    if (value === 0) this.unbind("GameLoop", this._updateSteering);
                    else {
                        this._updateSteering({
                            dt: 1
                        });
                        this.uniqueBind("GameLoop", this._updateSteering);
                    }
                }
            },
            get: function() {
                return this._steering;
            },
            configurable: true,
            enumerable: true
        },
        _steering: {
            value: 0,
            writable: true,
            enumerable: false
        }
    },
    events: {
        Freeze () {
            this.currentTarget = null;
        }
    },
    _updateSteering ({ dt: dt }) {
        if (!this.currentTarget && this.target) {
            const potentialTargets = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(this.target);
            if (potentialTargets.length > 0) this.currentTarget = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(potentialTargets[Math.floor(Math.random() * potentialTargets.length)]);
        }
        if (!this.currentTarget) return;
        const targetLocation = {
            x: this.currentTarget.x + this.currentTarget.w / 2,
            y: this.currentTarget.y + this.currentTarget.h / 2
        };
        const aimVector = {
            x: this.x - targetLocation.x,
            y: this.y - targetLocation.y
        };
        const radians = Math.atan2(aimVector.y, aimVector.x);
        const aimAngle = radians / Math.PI * 180;
        const steering = this._steering / 1000 * dt;
        const diffA = (aimAngle - this.angle - 360) % 360;
        const diffB = (aimAngle - this.angle + 360) % 360;
        const diff = Math.abs(diffA) < Math.abs(diffB) ? diffA : diffB;
        if (this.sight && (diff > this.sight || diff < -this.sight)) return;
        if (diff > steering) this.attr({
            angle: (360 + this.angle + steering) % 360,
            rotation: this.autoRotate ? this.rotation : (360 + this.rotation + steering) % 360
        });
        else if (diff < -steering) this.attr({
            angle: (360 + this.angle - steering) % 360,
            rotation: this.autoRotate ? this.rotation : (360 + this.rotation - steering) % 360
        });
        else this.attr({
            angle: (360 + aimAngle) % 360,
            rotation: this.autoRotate ? this.rotation : (360 + aimAngle) % 360
        });
    }
});
var $6ae618afe67991d1$export$2e2bcd8739ae039 = $6ae618afe67991d1$var$Steering;









/**
 * Fire rhythm:
 *
 * - Initial Delay
 * - Shot
 * - Shot delay / Burst delay
 * - Shot
 * - Shot delay / Burst delay
 * - Shot
 *
 */ const $4bca2c06de869f61$var$flipAngle = (xFlipped, angle)=>xFlipped ? (0, $d53208c4f003cab6$export$157708fdd1496efa)(angle) : angle;
const $4bca2c06de869f61$var$numArray = (e)=>Array.isArray(e) && e.length === 2 && e.every((i)=>typeof i === "number");
const $4bca2c06de869f61$var$adjustForDifficulty = (difficulty, numberOrArray, defaultValue = 0)=>numberOrArray === undefined ? defaultValue : $4bca2c06de869f61$var$numArray(numberOrArray) ? numberOrArray[0] + (numberOrArray[1] - numberOrArray[0]) * difficulty : numberOrArray;
const $4bca2c06de869f61$var$applyDifficultyToObj = (difficulty, obj)=>obj && Object.entries(obj).reduce((a, [k, v])=>({
            ...a,
            [k]: $4bca2c06de869f61$var$adjustForDifficulty(difficulty, v)
        }), {});
const $4bca2c06de869f61$var$ScreenBound = "ScreenBound";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($4bca2c06de869f61$var$ScreenBound, {
    required: "2D",
    init () {
        this.bind("GameLoop", this._checkBounds);
    },
    _checkBounds () {
        const maxX = -(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._x + (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._width / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._scale + 10;
        const minX = -(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._x - 50;
        const maxY = -(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._y + (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._height / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._scale + 10;
        const minY = -(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._y - 50;
        if (this.x > maxX || minX > this.x || minY > this.y || this.y > maxY) this.freeze();
    }
});
const $4bca2c06de869f61$var$calcHitPosition = (objA, hit)=>{
    let x = null;
    let y = null;
    if (hit.type === "SAT") {
        const [rx, ry] = (0, $d53208c4f003cab6$export$fa9f800d0752b887)(objA, objA.w);
        const addX = objA.bulletSettings.attached ? rx : -hit.overlap;
        x = objA.x + addX - hit.overlap * hit.nx;
        y = objA.y + ry + objA.h / 2 - hit.overlap * hit.ny;
    } else {
        const objB = hit.obj;
        const xLeftOverlap = objA.x < objB.x && objA.w + objA.x > objB.x || objA.vx !== undefined && objA.vx > 0;
        const xRightOverlap = objA.x < objB.x + objB.w && objA.x + objA.w > objB.x || objA.vx !== undefined && objA.vx < 0;
        const yTopOverlap = objA.y < objB.y && objA.h + objA.y > objB.y;
        const yBottomOverlap = objA.y < objB.w + objB.h && objA.y + objA.h > objB.y;
        if (xLeftOverlap && !yTopOverlap && !yBottomOverlap) {
            x = objB.x;
            y = objA.y + objA.h / 2;
        } else if (xRightOverlap && !yTopOverlap && !yBottomOverlap) {
            x = objB.x + objB.w;
            y = objA.y + objA.h / 2;
        } else if (yTopOverlap) {
            x = objA.x + objA.w / 2;
            y = objB.y;
        } else if (yBottomOverlap) {
            x = objA.x + objA.w / 2;
            y = objB.y + objB.h;
        }
    }
    return {
        x: x,
        y: y,
        angle: objA.angle
    };
};
const $4bca2c06de869f61$var$Bullet = "Bullet";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($4bca2c06de869f61$var$Bullet, {
    required: `2D, Motion, WebGL, ${(0, $6a27ecc58ed31669$export$2e2bcd8739ae039)}, ${(0, $ffecfc5e040b7ea8$export$2e2bcd8739ae039)}, ${(0, $5fcfaea6d3682c11$export$2e2bcd8739ae039)}, ${(0, $6477623efad0c52d$export$2e2bcd8739ae039)}`,
    events: {
        Freeze () {
            this.cooldowns = {};
            if (this._parent) this._parent.detach(this);
        }
    },
    init () {
        this.cooldowns = {};
    },
    _targetHit (obj, position, collisionType) {
        const collisionConfig = this.bulletSettings.collisions[collisionType];
        this.cooldowns[collisionType] = 30;
        if (obj && obj.processDamage && this.bulletSettings.damage && (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).rectManager.overlap(obj, (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.rect())) {
            obj.processDamage(this.bulletSettings.damage);
            this.spawner.mainEntity.trigger("DealtDamage", {
                damage: this.bulletSettings.damage,
                target: obj
            });
        }
        if (collisionConfig.state) this.showState(collisionConfig.state);
        (collisionConfig.spawns || []).forEach(([name, settings])=>{
            $4bca2c06de869f61$var$spawnItem(this.weaponDefinition, name, settings, this, position, this.target);
        });
        if (collisionConfig.remove !== false) {
            this.unbind("GameLoop", this._updateBullet);
            this.bulletTime = 0;
            this.freeze();
        }
    },
    _bulletHitOn (collisionType, hitData) {
        const firstObj = hitData[0].obj;
        const position = $4bca2c06de869f61$var$calcHitPosition(this, hitData[0]);
        this._targetHit(firstObj, position, collisionType);
    },
    bullet (weaponDefinition, settings, target) {
        this.weaponDefinition = weaponDefinition;
        this.bulletSettings = {
            ...settings
        };
        this.bulletSettings.queue = (this.bulletSettings.queue || []).map((event)=>({
                duration: 0,
                delay: 0,
                ...$4bca2c06de869f61$var$applyDifficultyToObj(this.difficulty, event)
            }));
        this.bulletSettings.damage = settings.damage && settings.damage.map((damage)=>$4bca2c06de869f61$var$applyDifficultyToObj(this.difficulty, damage));
        const initialVelocity = $4bca2c06de869f61$var$adjustForDifficulty(this.difficulty, settings.velocity);
        this.attr({
            angle: settings.angle,
            velocity: this.bulletSettings.attached ? 0 : initialVelocity,
            beamVelocity: this.bulletSettings.attached ? initialVelocity : 0,
            target: target
        });
        // add lifecycle stuff, bullet entity pools, etc.
        this.bulletTime = 0;
        this.maxBulletTime = this.bulletSettings.queue.reduce((max, item)=>max + $4bca2c06de869f61$var$adjustForDifficulty(this.difficulty, item.duration), 0);
        this.uniqueBind("GameLoop", this._updateBullet);
    },
    _updateBullet ({ dt: dt }) {
        this.bulletTime += dt;
        if (this.bulletSettings.collisions) {
            Object.keys(this.bulletSettings.collisions).forEach((c)=>{
                const v = this.cooldowns[c];
                if (v !== undefined && v > 0) this.cooldowns[c] = v - dt;
            });
            if (this.bulletSettings.beam) {
                let beamDistance = Infinity;
                let beamCollide = null;
                let collisionType = null;
                const nVec = (0, $d53208c4f003cab6$export$ea6eb6c1eb68d20f)(this.angle);
                Object.keys(this.bulletSettings.collisions).forEach((c)=>{
                    const results = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).raycast(this, nVec, -1, c);
                    if (results[0] && results[0].distance < beamDistance) {
                        beamDistance = results[0].distance;
                        beamCollide = results[0];
                        collisionType = c;
                    }
                });
                if (beamCollide) {
                    this.beamBlocked = true;
                    this.sw = beamCollide.distance + 6;
                    this._targetHit(beamCollide.obj, {
                        x: beamCollide.x,
                        y: beamCollide.y
                    }, collisionType);
                } else {
                    this.beamBlocked = false;
                    this.sw = this.beamLength;
                }
            }
        }
        const upcoming = this.bulletSettings.queue[0];
        if (upcoming) {
            upcoming.delay = (upcoming.delay || 0) - dt;
            const localV = upcoming.duration === 0 ? 1 : (upcoming.duration - (upcoming.duration + upcoming.delay)) / upcoming.duration;
            if (upcoming.delay <= 0 && upcoming.duration === 0) {
                if (upcoming.velocity !== undefined) this.bulletSettings.attached ? this.attr({
                    beamVelocity: upcoming.velocity
                }) : this.attr({
                    velocity: upcoming.velocity
                });
                if (upcoming.angle !== undefined) this.attr({
                    angle: $4bca2c06de869f61$var$flipAngle(this.xFlipped, upcoming.angle)
                });
                if (upcoming.cleanOutOfScreen !== undefined) this.addComponent($4bca2c06de869f61$var$ScreenBound);
                if (upcoming.collide !== undefined) {
                    this._targetHit(undefined, {
                        x: this.ox,
                        y: this.oy
                    }, upcoming.collide);
                    upcoming.collide = undefined;
                }
                if (upcoming.steering !== undefined) this.addComponent((0, $6ae618afe67991d1$export$2e2bcd8739ae039)).attr({
                    steering: upcoming.steering,
                    sight: upcoming.sight
                });
                if (upcoming.aimOnTarget !== undefined) {
                    const potentialTargets = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(this.target);
                    if (potentialTargets.length > 0) {
                        const target = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(potentialTargets[Math.floor(Math.random() * potentialTargets.length)]);
                        const targetLocation = {
                            x: target.x + target.w / 2,
                            y: target.y + target.h / 2
                        };
                        const aimVector = {
                            x: this.x - targetLocation.x,
                            y: this.y - targetLocation.y
                        };
                        const radians = Math.atan2(aimVector.y, aimVector.x);
                        const angle = radians / Math.PI * 180;
                        this.attr({
                            angle: angle,
                            rotation: angle
                        });
                    }
                }
            }
            if (upcoming.duration > 0) {
                if (upcoming.audio) {
                    const [sample, settings] = [].concat(upcoming.audio);
                    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio(sample, settings);
                    upcoming.audio = null;
                }
                if (upcoming.frame !== undefined) {
                    this.displayFrame(upcoming.frame, upcoming.duration);
                    upcoming.frame = null;
                }
                if (!upcoming.animateFn && upcoming.velocity !== undefined) {
                    const animateFn = (0, $efc499a22346529b$export$d4775187212d9f53)(this, this.bulletSettings.attached ? {
                        beamVelocity: upcoming.velocity
                    } : {
                        velocity: upcoming.velocity
                    });
                    const easing = (0, $21d6fb1fc143defa$export$742424a10dd87ed1)[upcoming.easing || "linear"];
                    upcoming.animateFn = (t)=>animateFn(easing(t));
                }
                if (upcoming.animateFn) upcoming.animateFn(localV);
            }
            if (localV >= 1) this.bulletSettings.queue.shift();
        }
        if (this.bulletTime > this.maxBulletTime && this.bulletSettings.queue.length === 0) {
            this.unbind("GameLoop", this._updateBullet);
            if (this._parent) this._parent.detach(this);
            this.bulletTime = 0;
            this.freeze();
        }
    }
});
let $4bca2c06de869f61$var$pool = [];
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).bind("SceneDestroy", ()=>$4bca2c06de869f61$var$pool = []);
const $4bca2c06de869f61$var$getItemFromPool = (itemDefinition)=>{
    const available = $4bca2c06de869f61$var$pool.find((e)=>e.__frozen && e.bulletDefinition === itemDefinition);
    if (available) {
        if (itemDefinition.entity) available.showState("default");
        available.unfreeze();
        available.attr({
            x: 3000,
            y: 3000,
            angle: 0,
            rotation: 0
        });
        return available;
    }
    const spawn = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e($4bca2c06de869f61$var$Bullet).attr({
        x: 3000,
        y: 3000,
        angle: 0,
        rotation: 0
    });
    spawn.bulletDefinition = itemDefinition;
    if (itemDefinition.sprite) spawn.addComponent(itemDefinition.sprite);
    if (itemDefinition.composition) {
        const composeData = (0, $4a464ac9ac54fc86$export$80766d2842af6389)(itemDefinition.composition);
        spawn.addComponent((0, $5fd20eb0995a8d9f$export$2e2bcd8739ae039)).compose(composeData);
    }
    if (itemDefinition.particles) {
        const particleData = (0, $4a464ac9ac54fc86$export$2096b54ada1e6fa4)(itemDefinition.particles);
        spawn.addComponent((0, $767c35cd7f31dfa2$export$2e2bcd8739ae039)).particles(particleData);
    }
    if (itemDefinition.entity) spawn.addComponent((0, $89ad5169d85cb0bf$export$3f1f0ed417cc9c63)).applyDefinition(itemDefinition.entity);
    const projectile = itemDefinition.beam ? false : true;
    if (projectile) {
        const collisionChecks = Object.keys(itemDefinition.collisions || {});
        if (collisionChecks.length > 0) {
            if (!spawn.has("Collision")) spawn.addComponent("Collision");
            collisionChecks.forEach((collisionType)=>{
                spawn.onHit(collisionType, (hitDatas)=>spawn._bulletHitOn(collisionType, hitDatas));
            });
        }
    }
    $4bca2c06de869f61$var$pool = $4bca2c06de869f61$var$pool.concat(spawn);
    return spawn;
};
const $4bca2c06de869f61$var$generator = (itemDef, itemSettings, position, difficulty, f)=>{
    const settings = {
        ...itemDef,
        ...itemSettings
    };
    if (settings.angleRange) for(let spawnAngle = $4bca2c06de869f61$var$adjustForDifficulty(difficulty, settings.angleRange.from); spawnAngle <= $4bca2c06de869f61$var$adjustForDifficulty(difficulty, settings.angleRange.to); spawnAngle += $4bca2c06de869f61$var$adjustForDifficulty(difficulty, settings.angleRange.step)){
        const angle = position.angle + spawnAngle;
        f({
            ...settings,
            angle: angle
        });
    }
    else {
        const angle = (position.angle || 0) + (({
            ...settings,
            ...itemSettings
        }).angle || 0);
        f({
            ...settings,
            angle: angle
        });
    }
};
const $4bca2c06de869f61$var$spawnItem = (definition, itemName, itemSettings, spawner, position, target)=>{
    const itemDef = definition.spawnables[itemName];
    if (!itemDef) throw new Error(`Spawn ${itemName} not defined`);
    $4bca2c06de869f61$var$generator(itemDef, itemSettings, position, spawner.difficulty, (settings)=>{
        const spawn = $4bca2c06de869f61$var$getItemFromPool(itemDef);
        const autoRotate = settings.autoRotate !== false;
        const angle = $4bca2c06de869f61$var$flipAngle(spawner.xFlipped, settings.angle || 0);
        const rotValue = autoRotate ? angle : 0;
        const rotation = $4bca2c06de869f61$var$flipAngle(spawner.xFlipped, rotValue);
        spawn.attr({
            itemName: itemName,
            spawner: spawner,
            difficulty: spawner.difficulty,
            x: position.x - spawn.w / 2,
            y: position.y - spawn.h / 2,
            z: spawner.z,
            autoRotate: autoRotate,
            angle: angle,
            steering: 0,
            rotation: rotation
        });
        if (typeof settings.spawnPosition === "object") {
            const { w: w = 0, h: h = 0 } = settings.spawnBox || {};
            const randX = -(w / 2) + Math.random() * w;
            const randY = -(h / 2) + Math.random() * h;
            spawn.attr({
                x: position.x - spawn._origin.x + randX,
                y: position.y - spawn._origin.y + randY
            });
        }
        if (itemDef.attached) spawner.attach(spawn);
        if (itemDef.emitDamage) itemDef.emitDamage.forEach((damage)=>{
            const damageObj = {
                ...$4bca2c06de869f61$var$applyDifficultyToObj(spawner.difficulty, damage),
                origin: {
                    ...position
                }
            };
            const ownId = spawner.sourceEntity && spawner.sourceEntity[0];
            const result = damage.targets.reduce((a, t)=>a.concat(Array.from((0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(t))), []).filter((id, i, l)=>l.indexOf(id) === i && id !== ownId);
            result.forEach((id)=>{
                const ent = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(id);
                if (ent.processDamage) ent.processDamage(damageObj);
            });
        });
        spawn.bullet(definition, settings, target);
    });
};
const $4bca2c06de869f61$var$Weapon = "Weapon";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($4bca2c06de869f61$var$Weapon, {
    init () {
        this.xFlipped = false;
        this.spawnQueue = [];
        this.burstsFired = 0;
    },
    weapon (definition) {
        this.definition = definition;
        this.active = false;
        this.aimingEnabled = true;
        return this;
    },
    flip (axis) {
        if (axis !== "X") return;
        this.xFlipped = !this.xFlipped;
        if (this.definition.angle !== undefined) this.definition.angle = (0, $d53208c4f003cab6$export$157708fdd1496efa)(this.definition.angle || 0);
    },
    unflip (axis) {
        if (axis !== "X") return;
        this.xFlipped = !this.xFlipped;
        if (this.definition.angle !== undefined) this.definition.angle = (0, $d53208c4f003cab6$export$157708fdd1496efa)(this.definition.angle || 0);
    },
    async activate (bursts) {
        if (!this.definition.pattern) return;
        this.active = true;
        this.burstsFired = 0;
        this.activatedAt = new Date() * 1;
        const spawnRhythm = this.definition.pattern.spawnRhythm;
        this.maxBursts = bursts || spawnRhythm.maxBursts || Infinity;
        this.initialDelay = $4bca2c06de869f61$var$adjustForDifficulty(this.difficulty, spawnRhythm.initialDelay);
        this._makeQueue();
        this.uniqueBind("GameLoop", this._updateSpawnFrame);
        return new Promise((resolve)=>{
            this.one("WeaponFireComplete", ()=>resolve(this));
        });
    },
    _makeQueue () {
        const spawnRhythm = this.definition.pattern.spawnRhythm;
        this.shotQueue = (spawnRhythm.shot || [
            {
                spawn: true,
                duration: 0
            }
        ]).map((qItem)=>({
                ...qItem,
                duration: $4bca2c06de869f61$var$adjustForDifficulty(this.difficulty, qItem.duration || 0)
            }));
        this.shotQueueLength = this.shotQueue.reduce((acc, i)=>acc + i.duration, 0);
    },
    async deactivate () {
        this.active = false;
        this.unbind("GameLoop", this._updateSpawnFrame);
        this.trigger("WeaponFireComplete");
        return this;
    },
    _weaponSpawn (spawnRhythm, angle = 0) {
        spawnRhythm.spawns.forEach(([name, overrideSettings])=>{
            $4bca2c06de869f61$var$spawnItem(this.definition.pattern, name, overrideSettings, this, {
                x: this.x + (this.definition.x || 0),
                y: this.y + (this.definition.y || 0),
                angle: this.definition.angle + angle
            }, this.definition.target);
        });
    },
    _aimBarrel ({ dt: dt }) {
        const aimSettings = this.definition.pattern.aiming;
        let angle = 0;
        if (aimSettings && this.barrel) {
            if (!this.aimingEnabled) return this.barrel.rotation;
            const potentialTargets = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(this.definition.target);
            if (potentialTargets.length > 0) {
                const target = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(potentialTargets[Math.floor(Math.random() * potentialTargets.length)]);
                const targetLocation = {
                    x: target.x + target.w / 2,
                    y: target.y + target.h / 2
                };
                const aimVector = {
                    x: this.barrel.ox - targetLocation.x,
                    y: this.barrel.oy - targetLocation.y
                };
                const radians = Math.atan2(aimVector.y, aimVector.x);
                if (this.barrel.root.xFlipped) {
                    const targetAngle = radians / Math.PI * 180 - 180;
                    const possibleRotation = (0, $d53208c4f003cab6$export$157708fdd1496efa)((0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).math.clamp((0, $d53208c4f003cab6$export$157708fdd1496efa)(targetAngle < 0 ? targetAngle + 180 : targetAngle), aimSettings.range[1], aimSettings.range[0]));
                    const corrected = (possibleRotation < 0 ? possibleRotation + 360 : possibleRotation) - 180;
                    const maxRotate = aimSettings.rotateSpeed * 0.001 * dt;
                    const delta = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).math.clamp(corrected - this.barrel.rotation, -maxRotate, maxRotate);
                    const rotation = this.barrel.rotation + delta;
                    angle = rotation + (aimSettings.offsetAimAngle || 0);
                    this.barrel.attr({
                        rotation: rotation
                    });
                } else {
                    const targetAngle = radians / Math.PI * 180;
                    const possibleRotation = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).math.clamp(targetAngle, aimSettings.range[1], aimSettings.range[0]);
                    const maxRotate = aimSettings.rotateSpeed * 0.001 * dt;
                    const delta = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).math.clamp(possibleRotation - this.barrel.rotation, -maxRotate, maxRotate);
                    const rotation = this.barrel.rotation + delta;
                    angle = rotation - (aimSettings.offsetAimAngle || 0);
                    this.barrel.attr({
                        rotation: rotation
                    });
                }
            }
        }
        return angle;
    },
    _updateSpawnFrame ({ dt: dt }) {
        const spawnRhythm = this.definition.pattern.spawnRhythm;
        const angle = this._aimBarrel({
            dt: dt
        });
        if (this.initialDelay > 0) {
            this.initialDelay -= dt;
            if (this.initialDelay <= 0) {
                this.shotIndex = 0;
                this.shotDelay = 0;
            } else return;
        }
        if (this.shotDelay <= 0) {
            const qPos = 0 - this.shotDelay;
            const entity = this.mainEntity;
            const upcoming = this.shotQueue[0];
            if (upcoming) {
                upcoming.delay = (upcoming.delay || 0) - dt;
                const localV = upcoming.duration === 0 ? 1 : (upcoming.duration - (upcoming.duration + upcoming.delay)) / upcoming.duration;
                if (upcoming.state && entity) {
                    entity.showState(upcoming.state, upcoming.duration);
                    upcoming.state = undefined;
                }
                if (upcoming.stopAiming === true) {
                    this.aimingEnabled = false;
                    upcoming.stopAiming = undefined;
                }
                if (upcoming.audio) {
                    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio(upcoming.audio);
                    upcoming.audio = undefined;
                }
                if (upcoming.stopAiming === false) {
                    this.aimingEnabled = true;
                    upcoming.stopAiming = undefined;
                }
                if (upcoming.spawn) {
                    this._weaponSpawn(spawnRhythm, angle);
                    upcoming.spawn = false;
                }
                if (localV >= 1) this.shotQueue.shift();
            }
            if (qPos > this.shotQueueLength && this.shotQueue.length === 0) {
                this.shotIndex++;
                if (this.shotIndex >= $4bca2c06de869f61$var$adjustForDifficulty(this.difficulty, spawnRhythm.burst)) {
                    const burstDelay = $4bca2c06de869f61$var$adjustForDifficulty(this.difficulty, spawnRhythm.burstDelay);
                    this.burstsFired += 1;
                    this.initialDelay = burstDelay + $4bca2c06de869f61$var$adjustForDifficulty(this.difficulty, spawnRhythm.shotDelay);
                    const maxBursts = $4bca2c06de869f61$var$adjustForDifficulty(this.difficulty, this.maxBursts);
                    if (maxBursts <= this.burstsFired) this.deactivate();
                    else this._makeQueue();
                    return;
                } else {
                    this.shotDelay = $4bca2c06de869f61$var$adjustForDifficulty(this.difficulty, spawnRhythm.shotDelay);
                    if (this.shotDelay > 0) this._makeQueue();
                }
            }
        }
        this.shotDelay -= dt;
    }
});
var $4bca2c06de869f61$export$2e2bcd8739ae039 = $4bca2c06de869f61$var$Weapon;







const $89ad5169d85cb0bf$var$convertLocation = (location)=>{
    if (!location) return {};
    let x = location.x;
    let y = location.y;
    if (location.rx) x = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width * location.rx;
    if (location.ry) y = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height * location.ry;
    return {
        x: x,
        y: y
    };
};
const $89ad5169d85cb0bf$export$1fe0dcec7c33c489 = (entityName, options = {})=>{
    const { location: location, ...settings } = options;
    return (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, WebGL, EntityDefinition").attr({
        x: 0,
        y: 0
    }).applyDefinition(entityName).attr({
        ...$89ad5169d85cb0bf$var$convertLocation(location),
        ...settings
    });
};
const $89ad5169d85cb0bf$export$3f1f0ed417cc9c63 = "EntityDefinition";
const $89ad5169d85cb0bf$var$setEntityStructure = (root, entity, state, duration)=>{
    const tasks = [];
    if (state.composition) {
        const composition = (0, $4a464ac9ac54fc86$export$80766d2842af6389)(state.composition);
        entity.addComponent((0, $5fd20eb0995a8d9f$export$2e2bcd8739ae039)).compose(composition);
        if (!state.frame) {
            if (entity.getAnimation("default")) tasks.push(entity.playAnimation("default"));
            else tasks.push(entity.displayFrame("default", duration));
        }
        if (!state.animation) entity.stopAnimation();
    }
    if (state.animation !== undefined && entity.has((0, $5fd20eb0995a8d9f$export$2e2bcd8739ae039))) tasks.push(state.animation ? entity.playAnimation(state.animation) : entity.stopAnimation());
    if (state.frame && entity.has((0, $5fd20eb0995a8d9f$export$2e2bcd8739ae039))) {
        const [frame, settings] = typeof state.frame === "string" ? [
            state.frame,
            {
                duration: duration
            }
        ] : state.frame;
        tasks.push(entity.displayFrame(frame, settings.duration || duration, settings.easing));
    }
    if (state.audio) (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio(state.audio);
    if (state.entity) entity.addComponent($89ad5169d85cb0bf$export$3f1f0ed417cc9c63).applyDefinition(state.entity);
    if (state.state) tasks.push(entity.showState(state.state, duration));
    if (state.particles) {
        if (state.particles.emitter) {
            const particleEmitter = state.particles.emitter;
            if (Array.isArray(particleEmitter)) {
                const emitter = (0, (/*@__PURE__*/$parcel$interopDefault($89aeca5d4d27357e$exports)))({}, (0, $4a464ac9ac54fc86$export$2096b54ada1e6fa4)(particleEmitter[0]), particleEmitter[1]);
                if (!entity.emitter) {
                    const e = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e((0, $767c35cd7f31dfa2$export$2e2bcd8739ae039)).particles(emitter, entity);
                    entity.attr({
                        w: emitter.emitter.w,
                        h: emitter.emitter.h
                    });
                    entity.emitter = e;
                    entity.emitting = particleEmitter[0];
                } else entity.emitter.particles(emitter, entity);
            } else {
                const emitter = (0, $4a464ac9ac54fc86$export$2096b54ada1e6fa4)(particleEmitter);
                if (!entity.emitter) {
                    const e = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e((0, $767c35cd7f31dfa2$export$2e2bcd8739ae039)).particles(emitter, entity);
                    entity.attr({
                        w: emitter.emitter.w,
                        h: emitter.emitter.h
                    });
                    entity.emitter = e;
                    entity.emitting = particleEmitter;
                } else entity.emitter.particles(emitter, entity);
            }
            if (!!root.xFlipped !== !!entity.emitter.xFlipped) {
                const angle = entity.angle || 0;
                const delta = angle - entity.emitter.particleSettings.currentAngle;
                entity.emitter.xFlipped = !entity.emitter.xFlipped;
                entity.angle = (0, $d53208c4f003cab6$export$157708fdd1496efa)(entity.emitter.particleSettings.currentAngle) + delta;
                entity.trigger("Change", {
                    angle: entity.angle
                });
            }
        }
        if (state.particles.active === true) entity.emitter.startEmission();
        if (state.particles.active === false) entity.emitter.stopEmission();
    }
    if (state.components) state.components.forEach((compDefinition)=>{
        if (typeof compDefinition === "string") entity.addComponent(compDefinition);
        else {
            const [compName, config] = compDefinition;
            entity.addComponent(compName).attr(config);
        }
    });
    if (state.removeComponents) state.removeComponents.forEach((comp)=>entity.removeComponent(comp));
    if (state.weapon) {
        if (state.weapon.pattern) {
            const pattern = (0, $4a464ac9ac54fc86$export$b7ef0e847c99a1c7)(state.weapon.pattern);
            if (!entity.has((0, $4bca2c06de869f61$export$2e2bcd8739ae039)) || entity.definition && entity.definition.pattern !== pattern) {
                if (state.weapon.barrel) {
                    const barrel = root.getElementByKey(state.weapon.barrel);
                    entity.barrel = barrel;
                } else entity.barrel = null;
                entity.attr({
                    difficulty: 0,
                    mainEntity: root
                }).addComponent((0, $4bca2c06de869f61$export$2e2bcd8739ae039)).weapon({
                    ...state.weapon,
                    pattern: pattern
                });
            }
        }
        tasks.push(state.weapon.active ? entity.activate(state.weapon.maxBursts) : entity.deactivate());
    }
    if (state.attachments && typeof entity.attachEntity === "function") Object.entries(state.attachments).forEach(([attachPoint, attachDefinition])=>{
        if (attachDefinition) {
            const itemName = attachDefinition.name || attachPoint;
            const attachment = entity[itemName] || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D").attr({
                w: 1,
                h: 1,
                sourceEntity: root
            });
            tasks.push($89ad5169d85cb0bf$var$setEntityStructure(root, attachment, attachDefinition, duration));
            entity.attachEntity(attachPoint, attachment);
            entity[itemName] = attachment;
        } else {
            entity.clearAttachment(attachPoint);
            entity[attachPoint] = null;
        }
    });
    return Promise.all(tasks);
};
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($89ad5169d85cb0bf$export$3f1f0ed417cc9c63, {
    init () {
        this.appliedEntityDefinition = null;
        this.appliedEntityName = null;
        this.appliedEntityState = "default";
        this.showState = this.showState.bind(this);
    },
    applyDefinition (entityName) {
        const definition = (0, $4a464ac9ac54fc86$export$5345fd892b40e1f6)(entityName);
        this.addComponent(entityName);
        const structure = definition.structure;
        $89ad5169d85cb0bf$var$setEntityStructure(this, this, structure, 0);
        this.appliedEntityDefinition = definition;
        this.appliedEntityName = entityName;
        return this;
    },
    showState (stateName, duration = 0) {
        const stateDefinition = stateName === "default" ? this.appliedEntityDefinition.structure : this.appliedEntityDefinition.states[stateName];
        if (!stateDefinition) return;
        this.appliedEntityState = stateName;
        return $89ad5169d85cb0bf$var$setEntityStructure(this, this, stateDefinition, duration);
    }
});



(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c("ShipSpawnable", {
    required: (0, $1694be6dff51cc24$export$2e2bcd8739ae039),
    events: {
        Activated: "spawnShip"
    },
    spawnPosition (spawnPosition) {
        this.spawnPosition = spawnPosition;
        if (this.spawnPosition == null) this.spawnPosition = ()=>({
                x: this.x,
                y: this.y
            });
        return this;
    },
    spawnShip ({ existing: existing = false }) {
        if (!this.has((0, $f62344210ab4fe80$export$2e2bcd8739ae039))) return;
        if (!(this.lives > 0)) return;
        let pos = this.spawnPosition();
        if (pos.x < 10) pos.x = 10;
        if (this.ship != null) {
            pos = {
                x: this.ship.x,
                y: this.ship.y
            };
            this.ship.destroy();
            this.ship = null;
        }
        this.ship = existing ? (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(this.shipType).get(0) || (0, $89ad5169d85cb0bf$export$1fe0dcec7c33c489)(this.shipType, {
            location: pos
        }) : (0, $89ad5169d85cb0bf$export$1fe0dcec7c33c489)(this.shipType, {
            location: pos
        });
        this.ship.addComponent((0, $98f23f39d831b128$export$2e2bcd8739ae039), (0, $5cbb878e064c643c$export$2e2bcd8739ae039));
        this.ship.allowDamage({
            health: 50
        });
        if (this.has((0, $f62344210ab4fe80$export$2e2bcd8739ae039))) this.assignControls(this.ship);
        this.trigger("ShipSpawned", this.ship);
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).trigger("ShipSpawned", this.ship);
        // We start it after the spawned event, so that listeners can
        // reposition it before
        return this.ship;
    }
});



const $da6b254a4b5a7dc9$var$component = "Rotating";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($da6b254a4b5a7dc9$var$component, {
    required: "2D",
    events: {
        GameLoop ({ dt: dt }) {
            // vr = velocity of rotation
            if (this.vr !== 0) this.rotation = (this.rotation + this.vr * dt / 1000) % 360;
        }
    }
});
var $da6b254a4b5a7dc9$export$2e2bcd8739ae039 = $da6b254a4b5a7dc9$var$component;


var $3189818cc877cea3$exports = {};
$3189818cc877cea3$exports = "#define GLSLIFY 1\nattribute vec2 aPosition;\nattribute vec4 aSpriteDimensions;\nattribute vec3 aOrientation;\nattribute vec2 aLayer;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\nattribute vec4 aOverrideColor;\nattribute vec4 aGradient;\n\nvarying mediump vec3 vTextureCoord;\nvarying lowp vec4 vColor;\nvarying lowp vec4 vOverrideColor;\nvarying lowp vec4 vGradient;\nvarying lowp vec4 vSpriteDimensions;\n\nuniform vec4 uViewport;\n\nmat4 viewportScale = mat4(2.0 / uViewport.z, 0, 0, 0,    0, -2.0 / uViewport.w, 0,0,    0, 0,1,0,    -1,+1,0,1);\nvec4 viewportTranslation = vec4(uViewport.xy, 0, 0);\n\nvoid main() {\n  vec2 pos = aPosition;\n  vec2 entityOrigin = aOrientation.xy;\n  mat2 entityRotationMatrix = mat2(cos(aOrientation.z), sin(aOrientation.z), -sin(aOrientation.z), cos(aOrientation.z));\n\n  pos = entityRotationMatrix * (pos - entityOrigin) + entityOrigin ;\n  gl_Position = viewportScale * (viewportTranslation + vec4(pos, 1.0/(1.0+exp(aLayer.x) ), 1) );\n  vTextureCoord = vec3(aTextureCoord, aLayer.y);\n  vColor = aColor;\n  vOverrideColor = aOverrideColor;\n  vGradient = aGradient;\n  vSpriteDimensions = aSpriteDimensions;\n}\n\n";


var $8309209a29e44701$exports = {};
$8309209a29e44701$exports = "precision mediump float;\n#define GLSLIFY 1\nvarying mediump vec3 vTextureCoord;\nvarying mediump vec4 vColor;\nvarying mediump vec4 vOverrideColor;\nvarying mediump vec4 vGradient;\nvarying mediump vec4 vSpriteDimensions;\n\nuniform sampler2D uSampler;\nuniform mediump vec2 uTextureDimensions;\n\nfloat random(vec3 scale, float seed) {\n  // use the fragment position for a different seed per-pixel\n  return fract(sin(dot(gl_FragCoord.xyz + seed, scale)) * 43758.5453 + seed);\n}\n\nvec3 rgb2hsv(vec3 c) {\n  vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);\n  vec4 p = c.g < c.b ? vec4(c.bg, K.wz) : vec4(c.gb, K.xy);\n  vec4 q = c.r < p.x ? vec4(p.xyw, c.r) : vec4(c.r, p.yzx);\n\n  float d = q.x - min(q.w, q.y);\n  float e = 1.0e-10;\n  return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);\n}\n\nvec3 hsv2rgb(vec3 c) {\n  vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\n  vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n  return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);\n}\n\nvoid main() {\n  highp vec2 coord = vTextureCoord.xy / uTextureDimensions;\n\n  if ((vGradient.a >= 0.0) && (vTextureCoord.y >= vGradient.a)) {\n    gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);\n    return;\n  }\n\n  if ((vGradient.z >= 0.0) && (vTextureCoord.y <= vGradient.z)) {\n    gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);\n    return;\n  }\n\n  mediump vec4 texelColor = texture2D(uSampler, coord);\n  mediump float yCoord = (vTextureCoord.y - vSpriteDimensions.y) / vSpriteDimensions.a;\n  mediump float mixFactor = (vGradient.x * (1.0 - yCoord)) + (vGradient.y * yCoord);\n\n  mediump float lightness = (0.2126 * texelColor.r + 0.7152 * texelColor.g + 0.0722 * texelColor.b);\n  if (vOverrideColor.a >= 1.0 && vOverrideColor.a <= 2.0) {\n    mediump float overrideLightness = (0.2126 * vOverrideColor.r + 0.7152 * vOverrideColor.g + 0.0722 * vOverrideColor.b);\n    texelColor = mix(texelColor, vec4(vOverrideColor.rgb * (lightness + overrideLightness), texelColor.a), vOverrideColor.a - 1.0);\n  }\n  if (vOverrideColor.a == 6.0) {\n    texelColor = vec4(vOverrideColor.rgb, texelColor.a);\n  }\n  if (vOverrideColor.a >= 4.0 && vOverrideColor.a <= 5.0) {\n    vec3 texelHSV = rgb2hsv(texelColor.rgb);\n    if ((texelHSV.x < .84) && (texelHSV.x > .82)) {\n      vec3 overrideHSV = rgb2hsv(vOverrideColor.rgb);\n      texelHSV.x = overrideHSV.x;\n      texelHSV.y *= overrideHSV.y;\n      texelHSV.z *= overrideHSV.z;\n      vec3 texelRGB = hsv2rgb(texelHSV);\n      texelColor = mix(texelColor, vec4(texelRGB.rgb, texelColor.a), vOverrideColor.a - 4.0);\n    }\n  }\n\n  mediump float lightnessBase = (0.2126*vColor.r + 0.7152*vColor.g + 0.0722*vColor.b);\n  mediump vec4 baseColor = vec4(vColor.rgb, texelColor.a) * (1.0 + (lightness - lightnessBase));\n  mediump vec4 mixColor = vec4(\n    (baseColor.rgba * mixFactor) + (texelColor.rgba * (1.0 - mixFactor))\n  );\n\n  if (vColor.a > 1.0) {\n    mixColor.rgb = vColor.rgb;\n  }\n\n  gl_FragColor = vec4(\n    mixColor.rgb * vColor.a * texelColor.a * vTextureCoord.z,\n    texelColor.a * vTextureCoord.z\n  );\n}\n\n";



const $d831ac9942327b63$var$collectHideBelow = (entity)=>{
    if (entity._parent) {
        const result = [];
        if (entity.hideBelow) {
            const hideBelow = entity._parent.y + entity.hideBelow;
            result.push(hideBelow);
        }
        return result.concat($d831ac9942327b63$var$collectHideBelow(entity._parent));
    } else return entity.hideBelow ? [
        entity.hideBelow
    ] : [];
};
const $d831ac9942327b63$var$collectHideAbove = (entity)=>{
    if (entity._parent) {
        const result = [];
        if (entity.hideAbove) {
            const hideAbove = entity._parent.y + entity.hideAbove;
            result.push(hideAbove);
        }
        return result.concat($d831ac9942327b63$var$collectHideAbove(entity._parent));
    } else return entity.hideAbove ? [
        entity.hideAbove
    ] : [];
};
const $d831ac9942327b63$var$findHideBelow = (entity)=>{
    const belows = $d831ac9942327b63$var$collectHideBelow(entity);
    return belows.length === 0 ? null : Math.min(...belows);
};
const $d831ac9942327b63$var$findHideAbove = (entity)=>{
    const aboves = $d831ac9942327b63$var$collectHideAbove(entity);
    return aboves.length === 0 ? null : Math.min(...aboves);
};
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).defaultShader("Sprite", new (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).WebGLShader((0, (/*@__PURE__*/$parcel$interopDefault($3189818cc877cea3$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($8309209a29e44701$exports))), [
    {
        name: "aPosition",
        width: 2
    },
    {
        name: "aOrientation",
        width: 3
    },
    {
        name: "aLayer",
        width: 2
    },
    {
        name: "aTextureCoord",
        width: 2
    },
    {
        name: "aColor",
        width: 4
    },
    {
        name: "aOverrideColor",
        width: 4
    },
    {
        name: "aGradient",
        width: 4
    },
    {
        name: "aSpriteDimensions",
        width: 4
    }
], function(e, ent) {
    let s;
    const { co: co } = e;
    // Write texture coordinates
    //e.program.max_size = 2000;
    e.program.writeVector("aTextureCoord", co.x + 1, co.y + 1, co.x + 1, co.y + co.h - 1, co.x + co.w - 1, co.y + 1, co.x + co.w - 1, co.y + co.h - 1);
    e.program.writeVector("aSpriteDimensions", co.x, co.y, co.w, co.h);
    const color = ent.desaturationColor != null ? ent.desaturationColor : {
        _red: 0,
        _green: 0,
        _blue: 0
    };
    let ocolor = ent.overrideColor != null ? ent.overrideColor : {
        _red: 0,
        _green: 0,
        _blue: 0
    };
    let lightness = ent.lightness != null ? ent.lightness : 1.0;
    if (ent.hidden) s = ent.scale != null ? ent.scale : 1;
    else s = 1;
    const tds = ent.topDesaturation != null ? ent.topDesaturation : 0;
    const bds = ent.bottomDesaturation != null ? ent.bottomDesaturation : 0;
    let topSaturation = tds + (1 - s) * 1.15;
    let bottomSaturation = bds + (1 - s) * 1.15;
    if (ent.hitFlash) {
        ocolor = ent.hitFlash;
        topSaturation = 0.0;
        bottomSaturation = 0.0;
    }
    e.program.writeVector("aColor", color._red, color._green, color._blue, lightness);
    let overrideMode = 0.0;
    if (ent.overrideColor != null) overrideMode = 1.0 + ent.overrideColorStrength;
    if (ent.overrideColorMode === "partial") overrideMode = 4.0 + ent.overrideColorStrength;
    if (ent.overrideColorMode === "none") overrideMode = 0.0;
    if (ent.hitFlash) overrideMode = 6.0;
    e.program.writeVector("aOverrideColor", ocolor._red, ocolor._green, ocolor._blue, overrideMode);
    let hideAt = -1;
    if (ent.hideAt) hideAt = Math.max(0, co.y + (ent.hideAt - ent.y) / ent.h * co.h);
    const hideBelow = $d831ac9942327b63$var$findHideBelow(ent);
    if (hideBelow !== null) hideAt = Math.max(0, co.y + (hideBelow - ent.y) / ent.h * co.h);
    let hideTopAt = -1;
    const hideAbove = $d831ac9942327b63$var$findHideAbove(ent);
    if (hideAbove !== null) hideTopAt = Math.max(0, co.y + (hideAbove - ent.y) / ent.h * co.h);
    e.program.writeVector("aGradient", topSaturation, bottomSaturation, hideTopAt, hideAt);
}));



(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c("TextInput", {
    init () {
        this.requires("2D, DOM, Text");
    },
    remove () {},
    textInput (player, length) {
        return new Promise((resolve)=>{
            let name = "A  ";
            let index = 0;
            this.text(name);
            player.bind("Up", ()=>{
                name = this._updateText(name, index, 1);
                this.text(name);
            });
            player.bind("Down", ()=>{
                name = this._updateText(name, index, -1);
                this.text(name);
            });
            player.bind("Left", ()=>{
                index = Math.max(index - 1, 0);
                return this._updateCursor(index);
            });
            player.bind("Right", ()=>{
                index = Math.min(index + 1, length - 1);
                this._updateCursor(index);
            });
            player.bind("Fire", ()=>{
                const oldIndex = index;
                index = Math.min(index + 1, length - 1);
                this._updateCursor(index);
                if (index === oldIndex && index === length - 1) {
                    player.unbind("Up");
                    player.unbind("Down");
                    player.unbind("Left");
                    player.unbind("Right");
                    player.unbind("Fire");
                    resolve(name);
                }
            });
            this.cursor = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text").attr({
                x: this.x,
                y: this.y,
                w: this.w
            }).text("_  ").textColor("#0000FF").textAlign("left").textFont({
                size: "20px",
                weight: "bold",
                family: "Press Start 2P"
            });
            this.attach(this.cursor);
        });
    },
    _updateCursor (index) {
        const c = Array(index + 1).join("&nbsp;") + "_";
        this.cursor.text(c);
    },
    _updateText (name, index, movement) {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-_.=!$& ";
        const letter = name[index];
        const lindex = chars.indexOf(letter) + chars.length;
        const nletter = chars[(lindex + movement) % chars.length];
        return name.slice(0, index) + nletter + name.slice(index + 1);
    }
});



const $12692480874906fc$var$LightGlare = "LightGlare";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($12692480874906fc$var$LightGlare, {
    required: "2D, WebGL",
    events: {
        EnterFrame () {
            const hw = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width / 2;
            const hh = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height / 2;
            const dx = this.x + this.w / 2 - hw;
            const dy = this.y + this.h / 2 - hh;
            const glareLink = this.glareLink || this.getElementByKey(this.glareAlphaLink);
            const alphaFactor = glareLink ? glareLink.alpha : 1.0;
            const updatePosition = (factor, item)=>{
                item.attr({
                    x: this.x + this.w / 2 - item.w / 2 + (-dx - dx) * factor,
                    y: this.y + this.h / 2 - item.h / 2 + (-dy - dy) * factor,
                    alpha: item.baseAlpha * alphaFactor
                });
            };
            updatePosition(1.1, this.bigGlare);
            updatePosition(0.9, this.blueGlare);
            updatePosition(0.8, this.redGlare);
        }
    },
    init () {
        this.bigGlare = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, WebGL, Glare, bigGlare, Horizon").crop(0, 0, 200, 200).attr({
            w: 200,
            h: 200,
            z: 91,
            baseAlpha: 0.3,
            alpha: 0
        }).origin("center").saturationGradient(0.1, 0.1);
        this.blueGlare = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, WebGL, Glare, bigGlare, Horizon").crop(0, 0, 200, 200).attr({
            w: 80,
            h: 80,
            z: 91,
            baseAlpha: 0.5,
            alpha: 0
        }).origin("center").saturationGradient(1, 1);
        this.redGlare = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, WebGL, Glare, bigGlare, ColorEffects").crop(0, 0, 200, 200).attr({
            w: 20,
            h: 20,
            z: 91,
            baseAlpha: 0.7,
            alpha: 0
        }).colorOverride("#fd6565").origin("center");
    }
});
var $12692480874906fc$export$2e2bcd8739ae039 = $12692480874906fc$var$LightGlare;



const $d80975df2cc832da$var$component = "Overlap";
var $d80975df2cc832da$export$2e2bcd8739ae039 = $d80975df2cc832da$var$component;
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($d80975df2cc832da$var$component, {
    required: "2D,  Collision",
    events: {
        UpdateFrame () {
            const covered = [
                0
            ];
            const sunArea = this.area();
            const collisions = this.hit(this.checkCollission);
            if (collisions) collisions.forEach((o)=>{
                const e = o.obj;
                const xMin = Math.max(this.x, e.x);
                const xMax = Math.min(this.x + this.w, e.x + e.w);
                const w = xMax - xMin;
                const yMin = Math.max(this.y, e.y);
                const yMax = Math.min(this.y + this.h, e.y + e.h);
                const h = yMax - yMin;
                covered.push(w * h * 1.7);
            });
            const maxCoverage = Math.max(...covered) * 1.7;
            const perc = maxCoverage > sunArea ? 1 : maxCoverage / sunArea;
            const glareLink = this.glareLink || this.getElementByKey(this.applyAlphaTo);
            glareLink.alpha = (1 - perc) * glareLink.maxAlpha;
        }
    }
});




var $e86ef82f63d64a93$exports = {};
$e86ef82f63d64a93$exports = new URL("symsonic-hero.826b0761.mp3", import.meta.url).toString();


var $27b28c611fa56aa4$exports = {};
$27b28c611fa56aa4$exports = new URL("zak-120bpm.f1ef8ffb.mp3", import.meta.url).toString();


var $db155dc5858a9421$exports = {};
$db155dc5858a9421$exports = new URL("stoomboot-210bpm.fc071f2f.mp3", import.meta.url).toString();


var $533b94fcb86fff36$exports = {};
$533b94fcb86fff36$exports = new URL("effects.fbcc1da6.ogg", import.meta.url).toString();


const $544f5fb9bc744499$var$audiosheets = [
    {
        name: "effects",
        file: (0, (/*@__PURE__*/$parcel$interopDefault($533b94fcb86fff36$exports))),
        map: [
            {
                name: "explosion",
                type: "sfx",
                duration: 629
            },
            {
                name: "gun-shot",
                type: "sfx",
                duration: 295
            },
            {
                name: "hatch-open",
                type: "sfx",
                duration: 1126,
                volume: 0.4
            },
            {
                name: "helicopter",
                type: "sfx",
                duration: 409,
                loop: true,
                volume: 0.4
            },
            {
                name: "laser-charge",
                type: "sfx",
                duration: 1674,
                volume: 0.3
            },
            {
                name: "laser-fire",
                type: "sfx",
                duration: 1725,
                volume: 1.2
            },
            {
                name: "laser-hit",
                type: "sfx",
                duration: 267
            },
            {
                name: "laser-shot",
                type: "sfx",
                duration: 453,
                volume: 0.2
            },
            {
                name: "laugh",
                type: "sfx",
                duration: 1695
            },
            {
                name: "powerup",
                type: "sfx",
                duration: 906
            }
        ]
    },
    {
        name: "hero",
        file: (0, (/*@__PURE__*/$parcel$interopDefault($e86ef82f63d64a93$exports))),
        map: [
            {
                name: "hero",
                type: "music",
                loop: true,
                loopEnd: 180 + 55.682,
                loopStart: 69.862
            }
        ]
    },
    {
        name: "sint",
        file: (0, (/*@__PURE__*/$parcel$interopDefault($27b28c611fa56aa4$exports))),
        map: [
            {
                name: "sint",
                type: "music",
                loop: true
            }
        ]
    },
    {
        name: "boss",
        file: (0, (/*@__PURE__*/$parcel$interopDefault($db155dc5858a9421$exports))),
        map: [
            {
                name: "boss",
                type: "music",
                loop: true
            }
        ]
    }
];
var $544f5fb9bc744499$export$2e2bcd8739ae039 = $544f5fb9bc744499$var$audiosheets;




var $a66cbe78b04b4f60$exports = {};
$a66cbe78b04b4f60$exports = new URL("dino.f265853a.png", import.meta.url).toString();


var $948a9d9c55acdcd9$exports = {};
$948a9d9c55acdcd9$exports = JSON.parse('{"tile":32,"tileh":32,"map":{"backgroundPlanet":[10,0,8,8],"dinoHead":[0,0,3,2],"dinoBody":[3,0,5,4],"dinoArm":[1,4,2,2],"dinoNeck":[3,4,2,2],"dinoJaw":[0,2,3,2],"dinoTail":[2,6,4,2],"dinoUpperLeg":[5,4,2,2],"dinoLowerLeg":[1,6,1,2],"dinoFeet":[0,6,1,1],"dinoToes":[0,5,1,1],"dinoTongue":[0,4,1,1],"dinoBackFeet":[0,7,1,1],"dinoBackUpperLeg":[6,6,2,2],"dinoBackLowerLeg":[7,4,1,2],"dinoBackToes":[8,4,1,1],"dinoTentacles":[8,0,2,1]}}');


var $d84dab081687f248$exports = {};
$d84dab081687f248$exports = new URL("mega-texture.85bd0e29.png", import.meta.url).toString();


var $6ab2211e2b1450e9$exports = {};
$6ab2211e2b1450e9$exports = JSON.parse('{"tile":32,"tileh":32,"map":{"waterHorizon":[0,17,8,5],"waterMiddle":[32,0,16,6],"waterFront1":[0,29,16,3],"waterFront2":[16,29,16,3],"coastStart":[18,12,8,1],"coast":[8,17,8,1],"cityBridge":[0,24,16,5],"cityStart":[0,0,16,9],"city":[16,0,16,9],"cityLayer2":[0,9,12,8],"cityDistance":[32,6,8,7],"cityDistanceBaseBottom":[32,9,8,4],"cityDistanceBaseTop":[40,6,8,7],"grassFront":[50,13,32,3],"grassMiddle":[50,7,16,6],"pond":[55,0,16,6],"pondStart":[72,0,16,6],"hedge":[67,8,12,5],"roof":[67,17,14,14],"chimney":[58,33,1,4],"present":[57,34,1,1],"villageSkyline":[49,39,16,8],"villageSkylineFull":[49,39,16,19],"villageDistantSkyline":[49,33,8,4],"hillSkyline":[49,38,6,1],"playerTop":[0,63,5,4],"playerBottom1":[0,67,5,2],"playerBottom2":[5,67,5,2],"portraitJinte1":[16,59,4,4],"portraitJinte2":[20,59,4,4],"portraitJonas":[16,64,4,7],"portraitSint":[22,64,5,6],"fish":[10,59,2,2],"bird":[12,59,2,2],"seagull":[11,63,3,3],"flats":[10,61,1,1],"carrot":[8,61,1,1],"moon":[12,61,2,2],"title":[51,59,13,15],"bigBuildingTop":[16,13,13,6],"bigBuildingBrokenTop":[30,13,13,6],"bigBuildingLayer":[16,19,13,4],"bigBuildingBottom":[16,23,13,6],"bigBuildingBottom2":[30,23,13,6],"glass":[12,9,4,3],"cloud":[16,9,8,3],"shadow":[16,12,2,1],"bridgeDeck":[0,32,16,4],"damagedBridgeDeck":[16,32,16,4],"bridgePillar":[36,29,6,17],"bridgePillarBroken":[42,29,6,17],"bigGlare":[0,38,7,7],"sun":[12,13,3,3],"chute":[12,12,1,1],"directGlare":[8,18,6,6],"aircraftCarrierEnd":[30,43,6,5],"aircraftCarrierStart":[19,43,6,5],"aircraftCarrierBottomFlat":[22,45,4,3],"aircraftCarrierBottomSpace":[26,45,4,3],"aircraftCarrierTopFlat":[26,43,4,2],"aircraftCarrierClosed":[8,44,3,3],"aircraftCarrierDoor":[11,44,1,3],"aircraftCarrier5":[14,42,1,1],"aircraftCarrier7":[14,41,1,1],"aircraftCarrierEngine":[15,41,3,3],"aircraftCarrierEngineDestroyed":[15,38,3,3],"aircraftCarrierEngineMeter":[14,43,1,1],"aircraftCarrierOpenHatch":[31,38,4,1],"aircraftCarrierHatchLid":[31,39,4,1],"aircraftCarrierLowCabin":[17,46,1,2],"aircraftCarrierLowCabinStart":[18,46,1,2],"aircraftCarrierCabinStart":[7,38,1,6],"aircraftCarrierCabinRadar":[8,38,2,6],"aircraftCarrierCabin":[10,38,2,6],"aircraftCarrierCabinEnd":[12,38,2,6],"aircraftCarrierCabinStartBroken":[18,39,1,4],"aircraftCarrierCabinRadarBroken":[19,39,2,4],"aircraftCarrierCabinBroken":[21,39,2,4],"aircraftCarrierCabinEndBroken":[23,39,2,4],"aircraftCarrierRadar":[26,38,2,2],"aircraftCarrierRadarBroken":[26,40,2,2],"aircraftCarrierRadarEmit":[23,38,2,1],"aircraftCarrierAntenna":[29,38,2,3],"aircraftCarrierWires":[25,38,1,1],"aircraftCarrierHole":[22,38,1,1],"boxes":[28,39,1,1],"boxesFalling":[28,38,1,1],"debris1":[44,13,4,4],"stars":[44,17,21,9],"playerShip":[0,48,3,2],"playerShipTurning":[0,46,3,2],"playerShipDamaged":[0,50,3,2],"playerShipDamagedTurning":[3,46,3,2],"playerShipFront":[6,49,3,2],"muzzleFlash":[10,48,1,1],"shipEngineFire":[4,53,3,1],"freddie":[3,49,3,2],"standardMine":[3,51,1,1],"mineOpening1":[4,51,1,1],"mineOpening2":[5,51,1,1],"mineBlink":[6,51,1,1],"standardDrone":[0,52,2,2],"standardDroneDamage":[2,52,2,2],"standardRocket":[4,52,2,1],"bulletDrone":[0,36,2,1],"helicopter":[0,54,4,2],"helicopter2":[4,54,4,2],"heliDamaged":[8,54,4,2],"helicopterLanded":[12,56,4,2],"helicopterTurning1":[16,56,2,2],"helicopterTurning2":[18,56,2,2],"helicopterGun":[12,54,1,1],"standardLargeDrone":[0,56,3,3],"standardLargeDroneDamage1":[3,56,3,3],"standardLargeDroneDamage2":[6,56,3,3],"standardLargeDroneDamage3":[9,56,3,3],"rapidFireBoost":[11,48,1,1],"speedBoost":[12,48,1,1],"damageBoost":[13,48,1,1],"aimBoost":[14,48,1,1],"heart":[13,49,1,1],"star":[14,49,1,1],"upgrade":[15,49,1,1],"powerUpBox":[10,49,1,1],"powerUpBox2":[11,49,1,1],"powerUpBox3":[12,49,1,1],"sphere1":[7,51,1,1],"sphere2":[8,51,1,1],"lightBullet":[9,51,1,1],"laserTank":[0,59,6,3],"laserTankBarrel":[6,59,4,2],"bulletCannon":[13,55,3,1],"mineCannon":[11,51,2,1],"turretFoot":[12,55,1,1],"general1":[16,48,4,4],"general2":[20,48,4,4],"pilot1":[16,52,4,4],"pilot2":[20,52,4,4],"explosion1":[24,48,3,3],"explosion2":[27,48,3,3],"explosion3":[30,48,3,3],"explosion4":[33,48,3,3],"explosion5":[36,48,3,3],"explosion6":[24,51,3,3],"explosion7":[27,51,3,3],"explosion8":[30,51,3,3],"explosion9":[33,51,3,3],"explosion10":[36,51,3,3],"explosion11":[24,54,3,3],"explosion12":[27,54,3,3],"explosion13":[30,54,3,3],"explosion14":[33,54,3,3],"explosion15":[36,54,3,3],"explosion16":[24,57,3,3],"explosion17":[27,57,3,3],"explosion18":[30,57,3,3],"explosion19":[33,57,3,3],"explosion20":[36,57,3,3],"laserGunCore":[10,50,2,1],"laserGunHandle":[11,50,2,1],"laserGunBarrel":[13,50,3,1],"bulletShell":[13,12,1,1],"clothBottom":[12,47,5,1],"cloth":[12,44,5,3],"titleShip":[47,26,9,5],"burstRing":[48,0,6,6]}}');


const $da33dabb3ca1ceee$var$spritesheets = [
    {
        name: "mega-texture",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($d84dab081687f248$exports))),
        map: (0, (/*@__PURE__*/$parcel$interopDefault($6ab2211e2b1450e9$exports)))
    },
    {
        name: "dino",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($a66cbe78b04b4f60$exports))),
        map: (0, (/*@__PURE__*/$parcel$interopDefault($948a9d9c55acdcd9$exports)))
    }
];
var $da33dabb3ca1ceee$export$2e2bcd8739ae039 = $da33dabb3ca1ceee$var$spritesheets;


const $d941c95fb300496e$export$1267480aba04282d = async (sheetNames)=>new Promise((resolve)=>{
        const loader = {
            sprites: {}
        };
        (0, $da33dabb3ca1ceee$export$2e2bcd8739ae039).filter((sheet)=>sheetNames.includes(sheet.name)).forEach((sheet)=>{
            loader.sprites[sheet.image.split("?").at(0)] = sheet.map;
        });
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).load(loader, resolve);
    });


const $55198199b302d82f$var$dataFunctions = ()=>({
        loadSpriteSheets: $d941c95fb300496e$export$1267480aba04282d,
        loadAudio: async (audioMaps)=>Promise.all(audioMaps.map((mapName)=>(0, $544f5fb9bc744499$export$2e2bcd8739ae039).find((e)=>e.name === mapName)).filter(Boolean).map((map)=>(0, $d4d953306f5c187b$export$2e2bcd8739ae039).loadAudio(map)))
    });
var $55198199b302d82f$export$2e2bcd8739ae039 = $55198199b302d82f$var$dataFunctions;



const $d886ebc26f8c43dc$var$flowFunctions = (dsl, state)=>{
    const call = (fn, ...args)=>fn(...args);
    const exec = async (script, ...args)=>{
        // Make a pool to collect running promises
        await script(dsl, ...args);
    // reject all open promises
    };
    const parallel = (list)=>Promise.all(list.map((l)=>l()));
    const race = (list)=>Promise.race(list.map((l)=>l()));
    const wait = (duration)=>{
        const parts = Math.floor(duration / 40);
        return new Promise((resolve, reject)=>(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Delay").delay(()=>{
                if (!dsl.currentScript()) resolve(undefined);
                if (state.gameEnded === true) reject(new Error("Game Over"));
            }, 40, parts, function() {
                resolve(undefined);
                this.destroy();
            }));
    };
    const waitWhile = async (fn, ...args)=>{
        let waiting = await call(fn, ...args);
        while(waiting){
            await wait(50);
            waiting = await call(fn, ...args);
        }
    };
    // Resolve on event, reject on kill
    const waitForEvent = (entity, event, callback)=>new Promise((resolve, reject)=>{
            const removeHandler = ()=>{
                resolve();
            };
            entity.one("Remove", removeHandler);
            entity.one("GameOver", removeHandler);
            entity.one(event, async ()=>{
                entity.unbind("Remove", removeHandler);
                entity.unbind("GameOver", removeHandler);
                try {
                    await callback();
                } catch (e) {
                    // script needs to abort
                    reject(e);
                    return;
                }
                resolve();
            });
        });
    const until = async (actionInProgress, repeatAction)=>{
        let actionCompleted = false;
        let counter = 0;
        actionInProgress(dsl).then(()=>{
            actionCompleted = true;
        });
        while(!actionCompleted){
            await repeatAction(dsl, counter);
            counter++;
        }
    };
    return {
        until: until,
        waitWhile: waitWhile,
        waitForEvent: waitForEvent,
        wait: wait,
        exec: exec,
        parallel: parallel,
        race: race,
        call: call
    };
};
var $d886ebc26f8c43dc$export$2e2bcd8739ae039 = $d886ebc26f8c43dc$var$flowFunctions;


var $423d54a57f94df96$exports = {};
/*
 * A speed-improved perlin and simplex noise algorithms for 2D.
 *
 * Based on example code by Stefan Gustavson (stegu@itn.liu.se).
 * Optimisations by Peter Eastman (peastman@drizzle.stanford.edu).
 * Better rank ordering method by Stefan Gustavson in 2012.
 * Converted to Javascript by Joseph Gentle.
 *
 * Version 2012-03-09
 *
 * This code was placed in the public domain by its original author,
 * Stefan Gustavson. You may use it as you see fit, but
 * attribution is appreciated.
 *
 */ (function(global) {
    // Passing in seed will seed this Noise instance
    function Noise(seed) {
        function Grad(x, y, z) {
            this.x = x;
            this.y = y;
            this.z = z;
        }
        Grad.prototype.dot2 = function(x, y) {
            return this.x * x + this.y * y;
        };
        Grad.prototype.dot3 = function(x, y, z) {
            return this.x * x + this.y * y + this.z * z;
        };
        this.grad3 = [
            new Grad(1, 1, 0),
            new Grad(-1, 1, 0),
            new Grad(1, -1, 0),
            new Grad(-1, -1, 0),
            new Grad(1, 0, 1),
            new Grad(-1, 0, 1),
            new Grad(1, 0, -1),
            new Grad(-1, 0, -1),
            new Grad(0, 1, 1),
            new Grad(0, -1, 1),
            new Grad(0, 1, -1),
            new Grad(0, -1, -1)
        ];
        this.p = [
            151,
            160,
            137,
            91,
            90,
            15,
            131,
            13,
            201,
            95,
            96,
            53,
            194,
            233,
            7,
            225,
            140,
            36,
            103,
            30,
            69,
            142,
            8,
            99,
            37,
            240,
            21,
            10,
            23,
            190,
            6,
            148,
            247,
            120,
            234,
            75,
            0,
            26,
            197,
            62,
            94,
            252,
            219,
            203,
            117,
            35,
            11,
            32,
            57,
            177,
            33,
            88,
            237,
            149,
            56,
            87,
            174,
            20,
            125,
            136,
            171,
            168,
            68,
            175,
            74,
            165,
            71,
            134,
            139,
            48,
            27,
            166,
            77,
            146,
            158,
            231,
            83,
            111,
            229,
            122,
            60,
            211,
            133,
            230,
            220,
            105,
            92,
            41,
            55,
            46,
            245,
            40,
            244,
            102,
            143,
            54,
            65,
            25,
            63,
            161,
            1,
            216,
            80,
            73,
            209,
            76,
            132,
            187,
            208,
            89,
            18,
            169,
            200,
            196,
            135,
            130,
            116,
            188,
            159,
            86,
            164,
            100,
            109,
            198,
            173,
            186,
            3,
            64,
            52,
            217,
            226,
            250,
            124,
            123,
            5,
            202,
            38,
            147,
            118,
            126,
            255,
            82,
            85,
            212,
            207,
            206,
            59,
            227,
            47,
            16,
            58,
            17,
            182,
            189,
            28,
            42,
            223,
            183,
            170,
            213,
            119,
            248,
            152,
            2,
            44,
            154,
            163,
            70,
            221,
            153,
            101,
            155,
            167,
            43,
            172,
            9,
            129,
            22,
            39,
            253,
            19,
            98,
            108,
            110,
            79,
            113,
            224,
            232,
            178,
            185,
            112,
            104,
            218,
            246,
            97,
            228,
            251,
            34,
            242,
            193,
            238,
            210,
            144,
            12,
            191,
            179,
            162,
            241,
            81,
            51,
            145,
            235,
            249,
            14,
            239,
            107,
            49,
            192,
            214,
            31,
            181,
            199,
            106,
            157,
            184,
            84,
            204,
            176,
            115,
            121,
            50,
            45,
            127,
            4,
            150,
            254,
            138,
            236,
            205,
            93,
            222,
            114,
            67,
            29,
            24,
            72,
            243,
            141,
            128,
            195,
            78,
            66,
            215,
            61,
            156,
            180
        ];
        // To remove the need for index wrapping, double the permutation table length
        this.perm = new Array(512);
        this.gradP = new Array(512);
        this.seed(seed || 0);
    }
    // This isn't a very good seeding function, but it works ok. It supports 2^16
    // different seed values. Write something better if you need more seeds.
    Noise.prototype.seed = function(seed) {
        if (seed > 0 && seed < 1) // Scale the seed out
        seed *= 65536;
        seed = Math.floor(seed);
        if (seed < 256) seed |= seed << 8;
        var p = this.p;
        for(var i = 0; i < 256; i++){
            var v;
            if (i & 1) v = p[i] ^ seed & 255;
            else v = p[i] ^ seed >> 8 & 255;
            var perm = this.perm;
            var gradP = this.gradP;
            perm[i] = perm[i + 256] = v;
            gradP[i] = gradP[i + 256] = this.grad3[v % 12];
        }
    };
    /*
  for(var i=0; i<256; i++) {
    perm[i] = perm[i + 256] = p[i];
    gradP[i] = gradP[i + 256] = grad3[perm[i] % 12];
  }*/ // Skewing and unskewing factors for 2, 3, and 4 dimensions
    var F2 = 0.5 * (Math.sqrt(3) - 1);
    var G2 = (3 - Math.sqrt(3)) / 6;
    var F3 = 1 / 3;
    var G3 = 1 / 6;
    // 2D simplex noise
    Noise.prototype.simplex2 = function(xin, yin) {
        var n0, n1, n2; // Noise contributions from the three corners
        // Skew the input space to determine which simplex cell we're in
        var s = (xin + yin) * F2; // Hairy factor for 2D
        var i = Math.floor(xin + s);
        var j = Math.floor(yin + s);
        var t = (i + j) * G2;
        var x0 = xin - i + t; // The x,y distances from the cell origin, unskewed.
        var y0 = yin - j + t;
        // For the 2D case, the simplex shape is an equilateral triangle.
        // Determine which simplex we are in.
        var i1, j1; // Offsets for second (middle) corner of simplex in (i,j) coords
        if (x0 > y0) {
            i1 = 1;
            j1 = 0;
        } else {
            i1 = 0;
            j1 = 1;
        }
        // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
        // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
        // c = (3-sqrt(3))/6
        var x1 = x0 - i1 + G2; // Offsets for middle corner in (x,y) unskewed coords
        var y1 = y0 - j1 + G2;
        var x2 = x0 - 1 + 2 * G2; // Offsets for last corner in (x,y) unskewed coords
        var y2 = y0 - 1 + 2 * G2;
        // Work out the hashed gradient indices of the three simplex corners
        i &= 255;
        j &= 255;
        var perm = this.perm;
        var gradP = this.gradP;
        var gi0 = gradP[i + perm[j]];
        var gi1 = gradP[i + i1 + perm[j + j1]];
        var gi2 = gradP[i + 1 + perm[j + 1]];
        // Calculate the contribution from the three corners
        var t0 = 0.5 - x0 * x0 - y0 * y0;
        if (t0 < 0) n0 = 0;
        else {
            t0 *= t0;
            n0 = t0 * t0 * gi0.dot2(x0, y0); // (x,y) of grad3 used for 2D gradient
        }
        var t1 = 0.5 - x1 * x1 - y1 * y1;
        if (t1 < 0) n1 = 0;
        else {
            t1 *= t1;
            n1 = t1 * t1 * gi1.dot2(x1, y1);
        }
        var t2 = 0.5 - x2 * x2 - y2 * y2;
        if (t2 < 0) n2 = 0;
        else {
            t2 *= t2;
            n2 = t2 * t2 * gi2.dot2(x2, y2);
        }
        // Add contributions from each corner to get the final noise value.
        // The result is scaled to return values in the interval [-1,1].
        return 70 * (n0 + n1 + n2);
    };
    // 3D simplex noise
    Noise.prototype.simplex3 = function(xin, yin, zin) {
        var n0, n1, n2, n3; // Noise contributions from the four corners
        // Skew the input space to determine which simplex cell we're in
        var s = (xin + yin + zin) * F3; // Hairy factor for 2D
        var i = Math.floor(xin + s);
        var j = Math.floor(yin + s);
        var k = Math.floor(zin + s);
        var t = (i + j + k) * G3;
        var x0 = xin - i + t; // The x,y distances from the cell origin, unskewed.
        var y0 = yin - j + t;
        var z0 = zin - k + t;
        // For the 3D case, the simplex shape is a slightly irregular tetrahedron.
        // Determine which simplex we are in.
        var i1, j1, k1; // Offsets for second corner of simplex in (i,j,k) coords
        var i2, j2, k2; // Offsets for third corner of simplex in (i,j,k) coords
        if (x0 >= y0) {
            if (y0 >= z0) {
                i1 = 1;
                j1 = 0;
                k1 = 0;
                i2 = 1;
                j2 = 1;
                k2 = 0;
            } else if (x0 >= z0) {
                i1 = 1;
                j1 = 0;
                k1 = 0;
                i2 = 1;
                j2 = 0;
                k2 = 1;
            } else {
                i1 = 0;
                j1 = 0;
                k1 = 1;
                i2 = 1;
                j2 = 0;
                k2 = 1;
            }
        } else {
            if (y0 < z0) {
                i1 = 0;
                j1 = 0;
                k1 = 1;
                i2 = 0;
                j2 = 1;
                k2 = 1;
            } else if (x0 < z0) {
                i1 = 0;
                j1 = 1;
                k1 = 0;
                i2 = 0;
                j2 = 1;
                k2 = 1;
            } else {
                i1 = 0;
                j1 = 1;
                k1 = 0;
                i2 = 1;
                j2 = 1;
                k2 = 0;
            }
        }
        // A step of (1,0,0) in (i,j,k) means a step of (1-c,-c,-c) in (x,y,z),
        // a step of (0,1,0) in (i,j,k) means a step of (-c,1-c,-c) in (x,y,z), and
        // a step of (0,0,1) in (i,j,k) means a step of (-c,-c,1-c) in (x,y,z), where
        // c = 1/6.
        var x1 = x0 - i1 + G3; // Offsets for second corner
        var y1 = y0 - j1 + G3;
        var z1 = z0 - k1 + G3;
        var x2 = x0 - i2 + 2 * G3; // Offsets for third corner
        var y2 = y0 - j2 + 2 * G3;
        var z2 = z0 - k2 + 2 * G3;
        var x3 = x0 - 1 + 3 * G3; // Offsets for fourth corner
        var y3 = y0 - 1 + 3 * G3;
        var z3 = z0 - 1 + 3 * G3;
        // Work out the hashed gradient indices of the four simplex corners
        i &= 255;
        j &= 255;
        k &= 255;
        var perm = this.perm;
        var gradP = this.gradP;
        var gi0 = gradP[i + perm[j + perm[k]]];
        var gi1 = gradP[i + i1 + perm[j + j1 + perm[k + k1]]];
        var gi2 = gradP[i + i2 + perm[j + j2 + perm[k + k2]]];
        var gi3 = gradP[i + 1 + perm[j + 1 + perm[k + 1]]];
        // Calculate the contribution from the four corners
        var t0 = 0.5 - x0 * x0 - y0 * y0 - z0 * z0;
        if (t0 < 0) n0 = 0;
        else {
            t0 *= t0;
            n0 = t0 * t0 * gi0.dot3(x0, y0, z0); // (x,y) of grad3 used for 2D gradient
        }
        var t1 = 0.5 - x1 * x1 - y1 * y1 - z1 * z1;
        if (t1 < 0) n1 = 0;
        else {
            t1 *= t1;
            n1 = t1 * t1 * gi1.dot3(x1, y1, z1);
        }
        var t2 = 0.5 - x2 * x2 - y2 * y2 - z2 * z2;
        if (t2 < 0) n2 = 0;
        else {
            t2 *= t2;
            n2 = t2 * t2 * gi2.dot3(x2, y2, z2);
        }
        var t3 = 0.5 - x3 * x3 - y3 * y3 - z3 * z3;
        if (t3 < 0) n3 = 0;
        else {
            t3 *= t3;
            n3 = t3 * t3 * gi3.dot3(x3, y3, z3);
        }
        // Add contributions from each corner to get the final noise value.
        // The result is scaled to return values in the interval [-1,1].
        return 32 * (n0 + n1 + n2 + n3);
    };
    // ##### Perlin noise stuff
    function fade(t) {
        return t * t * t * (t * (t * 6 - 15) + 10);
    }
    function lerp(a, b, t) {
        return (1 - t) * a + t * b;
    }
    // 2D Perlin Noise
    Noise.prototype.perlin2 = function(x, y) {
        // Find unit grid cell containing point
        var X = Math.floor(x), Y = Math.floor(y);
        // Get relative xy coordinates of point within that cell
        x = x - X;
        y = y - Y;
        // Wrap the integer cells at 255 (smaller integer period can be introduced here)
        X = X & 255;
        Y = Y & 255;
        // Calculate noise contributions from each of the four corners
        var perm = this.perm;
        var gradP = this.gradP;
        var n00 = gradP[X + perm[Y]].dot2(x, y);
        var n01 = gradP[X + perm[Y + 1]].dot2(x, y - 1);
        var n10 = gradP[X + 1 + perm[Y]].dot2(x - 1, y);
        var n11 = gradP[X + 1 + perm[Y + 1]].dot2(x - 1, y - 1);
        // Compute the fade curve value for x
        var u = fade(x);
        // Interpolate the four results
        return lerp(lerp(n00, n10, u), lerp(n01, n11, u), fade(y));
    };
    // 3D Perlin Noise
    Noise.prototype.perlin3 = function(x, y, z) {
        // Find unit grid cell containing point
        var X = Math.floor(x), Y = Math.floor(y), Z = Math.floor(z);
        // Get relative xyz coordinates of point within that cell
        x = x - X;
        y = y - Y;
        z = z - Z;
        // Wrap the integer cells at 255 (smaller integer period can be introduced here)
        X = X & 255;
        Y = Y & 255;
        Z = Z & 255;
        // Calculate noise contributions from each of the eight corners
        var perm = this.perm;
        var gradP = this.gradP;
        var n000 = gradP[X + perm[Y + perm[Z]]].dot3(x, y, z);
        var n001 = gradP[X + perm[Y + perm[Z + 1]]].dot3(x, y, z - 1);
        var n010 = gradP[X + perm[Y + 1 + perm[Z]]].dot3(x, y - 1, z);
        var n011 = gradP[X + perm[Y + 1 + perm[Z + 1]]].dot3(x, y - 1, z - 1);
        var n100 = gradP[X + 1 + perm[Y + perm[Z]]].dot3(x - 1, y, z);
        var n101 = gradP[X + 1 + perm[Y + perm[Z + 1]]].dot3(x - 1, y, z - 1);
        var n110 = gradP[X + 1 + perm[Y + 1 + perm[Z]]].dot3(x - 1, y - 1, z);
        var n111 = gradP[X + 1 + perm[Y + 1 + perm[Z + 1]]].dot3(x - 1, y - 1, z - 1);
        // Compute the fade curve value for x, y, z
        var u = fade(x);
        var v = fade(y);
        var w = fade(z);
        // Interpolate
        return lerp(lerp(lerp(n000, n100, u), lerp(n001, n101, u), w), lerp(lerp(n010, n110, u), lerp(n011, n111, u), w), v);
    };
    global.Noise = Noise;
})((0, $423d54a57f94df96$exports));


var $c3d59194625b5f14$exports = {};
var $2aab4ecf91103f5c$exports = {};

var $67bc04a8145c476f$exports = {};
var $a8cabcff8cdaa129$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a8cabcff8cdaa129$var$nativeFloor = Math.floor, $a8cabcff8cdaa129$var$nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $a8cabcff8cdaa129$var$baseRandom(lower, upper) {
    return lower + $a8cabcff8cdaa129$var$nativeFloor($a8cabcff8cdaa129$var$nativeRandom() * (upper - lower + 1));
}
$a8cabcff8cdaa129$exports = $a8cabcff8cdaa129$var$baseRandom;


/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */ function $67bc04a8145c476f$var$shuffleSelf(array, size) {
    var index = -1, length = array.length, lastIndex = length - 1;
    size = size === undefined ? length : size;
    while(++index < size){
        var rand = $a8cabcff8cdaa129$exports(index, lastIndex), value = array[rand];
        array[rand] = array[index];
        array[index] = value;
    }
    array.length = size;
    return array;
}
$67bc04a8145c476f$exports = $67bc04a8145c476f$var$shuffleSelf;


/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $2aab4ecf91103f5c$var$arrayShuffle(array) {
    return $67bc04a8145c476f$exports($892d74bc47a6142a$exports(array));
}
$2aab4ecf91103f5c$exports = $2aab4ecf91103f5c$var$arrayShuffle;


var $9cb2ef21493f64ec$exports = {};

var $1fe9d834cea6a71b$exports = {};
var $1579a7d785351b9f$exports = {};
var $69747cf806d0c7fb$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $69747cf806d0c7fb$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$69747cf806d0c7fb$exports = $69747cf806d0c7fb$var$arrayMap;


/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $1579a7d785351b9f$var$baseValues(object, props) {
    return $69747cf806d0c7fb$exports(props, function(key) {
        return object[key];
    });
}
$1579a7d785351b9f$exports = $1579a7d785351b9f$var$baseValues;


var $e1b1f7a0047f3f3f$exports = {};

var $3c3cc4f44653df47$exports = {};

var $fd1f0e5a7a2e8c1e$exports = {};

/* Built-in method references for those with the same name as other `lodash` methods. */ var $fd1f0e5a7a2e8c1e$var$nativeKeys = $c993c2296a98087c$exports(Object.keys, Object);
$fd1f0e5a7a2e8c1e$exports = $fd1f0e5a7a2e8c1e$var$nativeKeys;


/** Used for built-in method references. */ var $3c3cc4f44653df47$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c3cc4f44653df47$var$hasOwnProperty = $3c3cc4f44653df47$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $3c3cc4f44653df47$var$baseKeys(object) {
    if (!$ba0eec54535e4b27$exports(object)) return $fd1f0e5a7a2e8c1e$exports(object);
    var result = [];
    for(var key in Object(object))if ($3c3cc4f44653df47$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$3c3cc4f44653df47$exports = $3c3cc4f44653df47$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $e1b1f7a0047f3f3f$var$keys(object) {
    return $5e84ab26893f9442$exports(object) ? $3de354bcd8e0f1db$exports(object) : $3c3cc4f44653df47$exports(object);
}
$e1b1f7a0047f3f3f$exports = $e1b1f7a0047f3f3f$var$keys;


/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $1fe9d834cea6a71b$var$values(object) {
    return object == null ? [] : $1579a7d785351b9f$exports(object, $e1b1f7a0047f3f3f$exports(object));
}
$1fe9d834cea6a71b$exports = $1fe9d834cea6a71b$var$values;


/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $9cb2ef21493f64ec$var$baseShuffle(collection) {
    return $67bc04a8145c476f$exports($1fe9d834cea6a71b$exports(collection));
}
$9cb2ef21493f64ec$exports = $9cb2ef21493f64ec$var$baseShuffle;



/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function $c3d59194625b5f14$var$shuffle(collection) {
    var func = $b879a56dcf4bb3c4$exports(collection) ? $2aab4ecf91103f5c$exports : $9cb2ef21493f64ec$exports;
    return func(collection);
}
$c3d59194625b5f14$exports = $c3d59194625b5f14$var$shuffle;



const $ec7d2d2f6f8a6193$var$first = (list)=>list[0];
const $ec7d2d2f6f8a6193$export$f57acb6d823304cd = (list)=>$ec7d2d2f6f8a6193$var$first((0, (/*@__PURE__*/$parcel$interopDefault($c3d59194625b5f14$exports)))(list));
const $ec7d2d2f6f8a6193$export$2eb5ba9a66e42816 = (selector)=>$ec7d2d2f6f8a6193$var$first((0, (/*@__PURE__*/$parcel$interopDefault($c3d59194625b5f14$exports)))((0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(selector).get()));








const $028fd5673236b3e7$var$choose = (items)=>{
    let choice = Math.random();
    for(let k in items){
        const weight = items[k];
        if (choice > weight) choice -= weight;
        else return k;
    }
};
const $028fd5673236b3e7$var$pick = (sceneryList)=>typeof sceneryList === "string" ? sceneryList : $028fd5673236b3e7$var$choose(sceneryList);
const $028fd5673236b3e7$export$ac15e59049f4313a = (sceneryName)=>{
    const scenery = (0, $ec7d2d2f6f8a6193$export$2eb5ba9a66e42816)("Scenery") || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Scenery, 2D");
    scenery.setNextScenery(sceneryName);
};
const $028fd5673236b3e7$export$7b77fb3511e3d8f1 = ({ vx: vx, vy: vy })=>{
    const scenery = (0, $ec7d2d2f6f8a6193$export$2eb5ba9a66e42816)("Scenery") || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Scenery, 2D");
    scenery.setScrollVelocity({
        vx: vx,
        vy: vy
    });
};
const $028fd5673236b3e7$export$4aa419c702349ac0 = ()=>{
    const scenery = (0, $ec7d2d2f6f8a6193$export$2eb5ba9a66e42816)("Scenery") || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Scenery, 2D");
    return scenery.movingDirection;
};
const $028fd5673236b3e7$export$1d8b1be4a2d6d065 = (newAltitude)=>{
    const scenery = (0, $ec7d2d2f6f8a6193$export$2eb5ba9a66e42816)("Scenery") || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Scenery, 2D");
    scenery.setAltitude(newAltitude);
};
const $028fd5673236b3e7$export$47d30829676be666 = ()=>{
    const scenery = (0, $ec7d2d2f6f8a6193$export$2eb5ba9a66e42816)("Scenery") || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Scenery, 2D");
    return scenery.altitude;
};
let $028fd5673236b3e7$var$notificationName = null;
let $028fd5673236b3e7$var$notificationBuffer = 0;
let $028fd5673236b3e7$var$notificationCallback = null;
const $028fd5673236b3e7$var$notifyScenery = ()=>{
    $028fd5673236b3e7$var$notificationCallback();
    $028fd5673236b3e7$var$notificationName = null;
    $028fd5673236b3e7$var$notificationBuffer = 0;
    $028fd5673236b3e7$var$notificationCallback = null;
};
const $028fd5673236b3e7$export$693e04523164753e = (name, buffer = 0)=>new Promise((resolve)=>{
        $028fd5673236b3e7$var$notificationName = name;
        $028fd5673236b3e7$var$notificationBuffer = buffer;
        $028fd5673236b3e7$var$notificationCallback = resolve;
    });
const $028fd5673236b3e7$var$PIXEL_BUFFER = 800;
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c("SceneryBlock", {
    required: `2D, Motion, ${(0, $6477623efad0c52d$export$2e2bcd8739ae039)}`,
    events: {
        Freeze () {
            this._children.forEach((child)=>child.freeze());
        },
        Unfreeze () {
            this._children.forEach((child)=>child.unfreeze());
        }
    },
    init () {
        this.bind("Move", this.sceneryBlockMoved);
    },
    remove () {
        this.unbind("Move", this.sceneryBlockMoved);
    },
    moveScenery (dx, dy, { vx: vx, vy: vy }) {
        this.shift(dx, dy);
        const vDx = dx - vx / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).timer.FPS();
        const vDy = dy - vy / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).timer.FPS();
        this._children.forEach((child)=>{
            if (child.distance === 1) return;
            child.shift(-vDx * (1 - child.distance), -vDy * (1 - child.distance * child.distance));
        });
    },
    sceneryBlockMoved () {
        if (this.sceneryName === $028fd5673236b3e7$var$notificationName) {
            if (this.vx <= 0 && this.x < -$028fd5673236b3e7$var$notificationBuffer) $028fd5673236b3e7$var$notifyScenery();
            else if (this.vx > 0 && this.x > $028fd5673236b3e7$var$notificationBuffer) $028fd5673236b3e7$var$notifyScenery();
        }
        const sceneryVectors = {
            v1: this.x,
            v2: this.x + this.w,
            v3: Infinity,
            v4: -Infinity
        };
        const dx = this.dx;
        const dy = this.dy;
        this._children.forEach((child)=>{
            if (child.distance === 1) return;
            child.shift(-dx * (1 - child.distance), -dy * (1 - child.distance * child.distance));
            if (child.distance === this.farthestDistance) {
                if (child.x < sceneryVectors.v3) sceneryVectors.v3 = child.x;
                if (child.x + child.w > sceneryVectors.v4) sceneryVectors.v4 = child.x + child.w;
            }
        });
        this.sceneryVectors = sceneryVectors;
    }
});
const $028fd5673236b3e7$var$createBlock = (scenery, x, y)=>{
    const block = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("SceneryBlock").attr({
        x: x,
        y: y,
        w: scenery.width,
        h: scenery.height
    });
    let elementResets = [];
    block.resetPositioning = function() {
        const cameraCenter = {
            x: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width / 2,
            y: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height / 2
        };
        const halfW = this.w / 2;
        const halfH = this.h / 2;
        const blockCenter = {
            x: this.x + halfW,
            y: this.y + halfH
        };
        elementResets.forEach((f)=>f(cameraCenter, blockCenter, halfW, halfH));
    };
    let farthestDistance = 1;
    scenery.elements.forEach((element)=>{
        let entity;
        if (element.composition) {
            let def;
            if (typeof element.composition === "string") def = (0, $4a464ac9ac54fc86$export$80766d2842af6389)(element.composition);
            else def = (0, (/*@__PURE__*/$parcel$interopDefault($89aeca5d4d27357e$exports)))({}, (0, $4a464ac9ac54fc86$export$80766d2842af6389)(element.composition[0]), element.composition[1]);
            entity = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, Composable").compose(def).attr({
                z: element.z
            });
            if (element.frame) entity.displayFrame(element.frame);
        }
        if (element.components) {
            if (!entity) {
                const components = [
                    "2D"
                ].concat(element.components);
                entity = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(components.join(", ")).attr({
                    z: element.z || 0,
                    w: element.w,
                    h: element.h
                });
            } else element.components.forEach((comp)=>entity.addComponent(comp));
        }
        if (element.attributes) entity.attr(element.attributes);
        const distance = element.distance === undefined ? 1 : element.distance;
        if (distance < farthestDistance) farthestDistance = distance;
        elementResets.push((cameraCenter, blockCenter, halfW, halfH)=>{
            const elementX = (element.x < 0 ? scenery.width * distance : 0) + element.x;
            const elementY = scenery.height * (distance * distance) + element.y;
            const centerX = blockCenter.x * distance + cameraCenter.x * (1.0 - distance);
            const centerY = blockCenter.y * (distance * distance) + cameraCenter.y * (1.0 - distance * distance);
            const left = centerX - halfW * distance;
            const top = centerY - halfH * (distance * distance);
            entity.attr({
                x: left + elementX,
                y: top + elementY,
                distance: distance
            });
        });
        block.attach(entity);
    });
    block.attr({
        farthestDistance: farthestDistance
    });
    block.resetPositioning();
    return block;
};
const $028fd5673236b3e7$var$calcReach = (distance, width)=>{
    const vpw = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._scale;
    return (vpw - (vpw - width * distance) / 2) / (width * distance) * width;
};
const $028fd5673236b3e7$var$SCENERY_DIRECTIONS = {
    RIGHT: 1,
    LEFT: 2,
    ALL: 3
};
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c("Scenery", {
    init () {
        this.currentScenery = null;
        this.movingDirection = {
            vx: 0,
            vy: 0
        };
        this.altitude = 0;
        this.blocks = [];
        this.delay = null;
        this.bind("GameLoop", this.verifySceneryContent);
    },
    remove () {
        this.unbind("GameLoop", this.verifySceneryContent);
        this.blocks.forEach((b)=>b.destroy());
    },
    setNextScenery (sceneryName) {
        const scenery = (0, $4a464ac9ac54fc86$export$b1a32131569ed891)(sceneryName);
        if (!scenery) return;
        if (this.blocks.length === 0) {
            this.startScenery(sceneryName, {
                direction: $028fd5673236b3e7$var$SCENERY_DIRECTIONS.ALL
            });
            this.checkCountDown = 5;
        } else this.currentScenery = sceneryName;
    },
    startScenery (sceneryName, { startXPos: startXPos = 0, startYPos: startYPos = null, direction: direction = $028fd5673236b3e7$var$SCENERY_DIRECTIONS.RIGHT } = {}) {
        this.altitude = startYPos || this.altitude;
        const scenery = (0, $4a464ac9ac54fc86$export$b1a32131569ed891)(sceneryName);
        if (!scenery) throw new Error(`Scenery ${sceneryName} not found`);
        let block = this.blocks.find((b)=>b.__frozen && b.sceneryName === sceneryName);
        if (block) {
            block.unfreeze();
            const dx = startXPos - block.x;
            const dy = this.altitude - block.y;
            block.moveScenery(dx, dy, this.movingDirection);
            block.resetPositioning();
        } else {
            let staleBlock = this.blocks.find((b)=>b.__frozen);
            block = $028fd5673236b3e7$var$createBlock(scenery, startXPos, this.altitude);
            block.sceneryName = sceneryName;
            if (staleBlock) {
                const index = this.blocks.indexOf(staleBlock);
                staleBlock.destroy();
                this.blocks[index] = block;
            } else this.blocks.push(block);
        }
        block.attr(this.movingDirection);
        if (direction === $028fd5673236b3e7$var$SCENERY_DIRECTIONS.RIGHT || direction === $028fd5673236b3e7$var$SCENERY_DIRECTIONS.ALL) {
            const nextPos = startXPos + block.w;
            const nextBlock = this.currentScenery || $028fd5673236b3e7$var$pick(scenery.right);
            if ($028fd5673236b3e7$var$calcReach(block.farthestDistance, scenery.width) > nextPos) {
                this.currentScenery = null;
                this.startScenery(nextBlock, {
                    startXPos: nextPos,
                    startYPos: this.altitude,
                    direction: $028fd5673236b3e7$var$SCENERY_DIRECTIONS.RIGHT
                });
            }
        }
        if (direction === $028fd5673236b3e7$var$SCENERY_DIRECTIONS.LEFT || direction === $028fd5673236b3e7$var$SCENERY_DIRECTIONS.ALL) {
            const nextBlock = this.currentScenery || $028fd5673236b3e7$var$pick(scenery.left);
            const leftScenery = (0, $4a464ac9ac54fc86$export$b1a32131569ed891)(nextBlock);
            const nextPos = startXPos - leftScenery.width;
            if (-$028fd5673236b3e7$var$calcReach(block.farthestDistance, scenery.width) < nextPos) {
                this.currentScenery = null;
                this.startScenery(nextBlock, {
                    startXPos: nextPos,
                    startYPos: this.altitude,
                    direction: $028fd5673236b3e7$var$SCENERY_DIRECTIONS.LEFT
                });
            }
        }
    },
    setScrollVelocity ({ vx: vx, vy: vy }) {
        this.movingDirection = {
            vx: vx,
            vy: vy
        };
        this.blocks.forEach((block)=>block.attr({
                vx: vx,
                vy: vy
            }));
        if (this.checkCountDown > 5) this.checkCountDown = this.blocks.length === 0 ? Infinity : 5;
    },
    setAltitude (newAltitude) {
        this.blocks.forEach((block)=>!block.__frozen && block.moveScenery(0, newAltitude - this.altitude, this.movingDirection));
        this.altitude = newAltitude;
    },
    verifySceneryContent ({ dt: dt }) {
        if (dt === 0) return;
        const { vx: vx, vy: vy } = this.movingDirection;
        if (vx === 0 && vy === 0) return;
        this.checkCountDown--;
        if (this.checkCountDown > 0) return;
        const fps = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).timer.FPS();
        this.checkCountDown = Math.min($028fd5673236b3e7$var$PIXEL_BUFFER / Math.abs(vx) * fps, $028fd5673236b3e7$var$PIXEL_BUFFER / Math.abs(vy) * fps);
        const fullSceneryVector = this.blocks.reduce((acc, block)=>{
            if (block.__frozen) return acc;
            const sceneryVectors = block.sceneryVectors;
            return {
                v1: acc.v1 < sceneryVectors.v1 ? acc.v1 : sceneryVectors.v1,
                v2: acc.v2 > sceneryVectors.v2 ? acc.v2 : sceneryVectors.v2,
                v3: acc.v3 < sceneryVectors.v3 ? acc.v3 : sceneryVectors.v3,
                v4: acc.v4 > sceneryVectors.v4 ? acc.v4 : sceneryVectors.v4,
                left: acc.v1 < sceneryVectors.v1 ? acc.left : block,
                right: acc.v2 > sceneryVectors.v2 ? acc.right : block
            };
        }, {
            v1: Infinity,
            v2: -Infinity,
            v3: Infinity,
            v4: -Infinity,
            left: null,
            right: null
        });
        const vpw = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._scale;
        // Cleanup fase
        if (vx < 0 && fullSceneryVector.left.sceneryVectors.v4 < 0) {
            fullSceneryVector.left.attr({
                vx: 0,
                vy: 0
            });
            fullSceneryVector.left.freeze();
        }
        if (vx > 0 && fullSceneryVector.right.sceneryVectors.v3 > vpw) {
            fullSceneryVector.right.attr({
                vx: 0,
                vy: 0
            });
            fullSceneryVector.right.freeze();
        }
        // Build fase
        if (vx < 0 && fullSceneryVector.v4 < vpw + $028fd5673236b3e7$var$PIXEL_BUFFER) {
            // scrolling to the left, check right side if content needs to be added
            const lastBlock = fullSceneryVector.right;
            const nextBlock = this.currentScenery || $028fd5673236b3e7$var$pick((0, $4a464ac9ac54fc86$export$b1a32131569ed891)(lastBlock.sceneryName).right);
            this.currentScenery = null;
            this.startScenery(nextBlock, {
                startXPos: fullSceneryVector.v2 + vx / fps,
                startYPos: this.altitude,
                direction: $028fd5673236b3e7$var$SCENERY_DIRECTIONS.RIGHT
            });
            return;
        }
        if (vx > 0 && fullSceneryVector.v3 > -$028fd5673236b3e7$var$PIXEL_BUFFER) {
            // scrolling to the left, check right side if content needs to be added
            const firstBlock = fullSceneryVector.left;
            const nextBlock = this.currentScenery || $028fd5673236b3e7$var$pick((0, $4a464ac9ac54fc86$export$b1a32131569ed891)(firstBlock.sceneryName).left);
            this.currentScenery = null;
            const leftScenery = (0, $4a464ac9ac54fc86$export$b1a32131569ed891)(nextBlock);
            const nextPos = fullSceneryVector.v1 - leftScenery.width;
            this.startScenery(nextBlock, {
                startXPos: nextPos + vx / fps,
                startYPos: this.altitude,
                direction: $028fd5673236b3e7$var$SCENERY_DIRECTIONS.LEFT
            });
            return;
        }
    }
});










var $d192e70ce162a1c7$exports = {};

$d192e70ce162a1c7$exports = (parcelRequire("lQT0x"));


const $36a1e159616bc066$export$ef70c68662c51640 = (path)=>path.map((point)=>{
        let x, y;
        if (typeof point === "function") {
            const p = point();
            x = p.x;
            y = p.y;
        } else [x, y] = point;
        if (-1 < x && x < 2) x *= Crafty.viewport.width;
        if (-1 < y && y < 2) y *= Crafty.viewport.height;
        return {
            x: x,
            y: y
        };
    });
// Solves a tridiagonal system for one of coordinates (x or y)
// of first Bezier control points.
//
// @param rhs Right hand side vector.
// @return Solution vector
const $36a1e159616bc066$var$getFirstControlPoints = (rhs)=>{
    const n = rhs.length;
    const x = []; // Solution vector.
    const tmp = [
        null
    ]; // Temp workspace.
    let b = 2.0;
    x.push(rhs[0] / b);
    for(let i = 1; i < n; i++){
        // Decomposition and forward substitution.
        tmp.push(1 / b);
        b = i < n - 1 ? 4.0 : 3.5;
        b -= tmp[i];
        x.push((rhs[i] - x[i - 1]) / b);
    }
    for(let i = 1; i < n; i++)x[n - i - 1] -= tmp[n - i] * x[n - i];
     // Backsubstitution.
    return x;
};
const $36a1e159616bc066$export$f59523282b7bbac = (points)=>{
    const n = points.length - 1;
    if (n < 1) return [];
    let firstControlPoints, secondControlPoints;
    if (n === 1) {
        // Special case: Bezier curve should be a straight line.
        firstControlPoints = [
            {
                // 3P1 = 2P0 + P3
                x: (2.0 * points[0].x + points[1].x) / 3.0,
                y: (2.0 * points[0].y + points[1].y) / 3.0
            }
        ];
        secondControlPoints = [
            {
                // P2 = 2P1 – P0
                x: 2.0 * firstControlPoints[0].x - points[0].x,
                y: 2.0 * firstControlPoints[0].y - points[0].y
            }
        ];
        return [
            firstControlPoints,
            secondControlPoints
        ];
    }
    // Calculate first Bezier control points
    // Right hand side vector
    // Set right hand side X values
    // Set right hand side Y values
    const rhsX = [];
    const rhsY = [];
    for(let i = 1; i < n - 1; i++){
        rhsX.push(4.0 * points[i].x + 2.0 * points[i + 1].x);
        rhsY.push(4.0 * points[i].y + 2.0 * points[i + 1].y);
    }
    rhsX.unshift(points[0].x + 2.0 * points[1].x);
    rhsY.unshift(points[0].y + 2.0 * points[1].y);
    rhsX.push((8.0 * points[n - 1].x + points[n].x) / 2.0);
    rhsY.push((8.0 * points[n - 1].y + points[n].y) / 2.0);
    // Get first control points X-values
    const x = $36a1e159616bc066$var$getFirstControlPoints(rhsX);
    // Get first control points Y-values
    const y = $36a1e159616bc066$var$getFirstControlPoints(rhsY);
    // Fill output arrays.
    firstControlPoints = [];
    secondControlPoints = [];
    for(let i = 0; i < n; i++){
        // First control point
        firstControlPoints.push({
            x: x[i],
            y: y[i]
        });
        // Second control point
        if (i < n - 1) secondControlPoints.push({
            x: 2.0 * points[i + 1].x - x[i + 1],
            y: 2.0 * points[i + 1].y - y[i + 1]
        });
        else secondControlPoints.push({
            x: (points[n].x + x[n - 1]) / 2.0,
            y: (points[n].y + y[n - 1]) / 2.0
        });
    }
    return [
        firstControlPoints,
        secondControlPoints
    ];
};
class $36a1e159616bc066$export$b7f0d44472b6ef52 {
    constructor(points){
        this.points = points;
        this.curves = [];
        const controlPoints = $36a1e159616bc066$export$f59523282b7bbac(points);
        for(let i = 0; i < points.length - 1; i++){
            const p1 = points[i];
            const p2 = points[i + 1];
            const c1 = controlPoints[0][i];
            const c2 = controlPoints[1][i];
            const curve = new (0, (/*@__PURE__*/$parcel$interopDefault($d192e70ce162a1c7$exports)))(p1.x, p1.y, c1.x, c1.y, c2.x, c2.y, p2.x, p2.y);
            this.curves.push({
                curve: curve,
                length: curve.length()
            });
        }
        let length = 0;
        this.curves.forEach((c)=>{
            c.min = length / this.length;
            length += c.length;
            c.max = length / this.length;
        });
    }
    get length() {
        return this.curves.reduce((r, c)=>r + c.length, 0);
    }
    getLUT(steps) {
        const step = Math.ceil(this.length / steps);
        return this.curves.map((curve)=>{
            const csteps = Math.ceil(curve.length / step);
            return curve.curve.getLUT(csteps);
        }).reduce((r, a)=>r.concat(a), []);
    }
    get(t) {
        const c = this.curves.find((c)=>c.min <= t && c.max >= t);
        if (!c) return null;
        const localT = (t - c.min) / (c.max - c.min);
        return c.curve.get(localT);
    }
    rotationAt(t) {
        const c = this.curves.find((c)=>c.min <= t && c.max >= t);
        const localT = (t - c.min) / (c.max - c.min);
        const vector = c.curve.derivative(localT);
        const atan = Math.atan2(vector.y, vector.x);
        return atan * 180 / Math.PI;
    }
}
const $36a1e159616bc066$export$f33e5fa5d190a2a9 = (path)=>path.map((p)=>`${p.x}|${p.y}|`).join();
const $36a1e159616bc066$var$pathStorage = {};
const $36a1e159616bc066$export$b2afe50f305285f6 = (normalizedPath)=>{
    const id = $36a1e159616bc066$export$f33e5fa5d190a2a9(normalizedPath);
    $36a1e159616bc066$var$pathStorage[id] = $36a1e159616bc066$var$pathStorage[id] || new $36a1e159616bc066$export$b7f0d44472b6ef52(normalizedPath);
    return $36a1e159616bc066$var$pathStorage[id];
};



const $9a2aef001772ced0$var$StackableCoordinates = "StackableCoordinates";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($9a2aef001772ced0$var$StackableCoordinates, {
    required: "2D",
    init () {
        this.stackableProps = {};
        this.propertyStacks = {};
        this.uniqueBind("Move", this._updateBaseCoords);
    },
    createStackablePropertyFor (property, mainProperty) {
        if (this.stackableProps[property] !== undefined) return;
        if (this.propertyStacks[mainProperty]) this.propertyStacks[mainProperty] = this.propertyStacks[mainProperty].concat(property);
        else {
            this.propertyStacks[mainProperty] = [
                mainProperty,
                property
            ];
            this.stackableProps[mainProperty] = this[mainProperty];
        }
        this.stackableProps[property] = 0;
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).defineField(this, property, ()=>this.stackableProps[property], (newValue)=>{
            this.stackableProps[property] = newValue;
            this.recalculateStackableProp(mainProperty);
        });
    },
    recalculateStackableProp (mainProperty) {
        this._stackRecalc = true;
        this[mainProperty] = this.propertyStacks[mainProperty].reduce((acc, prop)=>acc + this.stackableProps[prop], 0);
        this._stackRecalc = false;
    },
    applyStackableProperty (property, mainProperty) {
        this._stackRecalc = true;
        this.stackableProps[mainProperty] += this.stackableProps[property];
        this.stackableProps[property] = 0;
        this._stackRecalc = false;
    },
    _updateBaseCoords (e) {
        if (this._stackRecalc) return;
        this.stackableProps["x"] += this.x - e._x;
        this.stackableProps["y"] += this.y - e._y;
    }
});
var $9a2aef001772ced0$export$2e2bcd8739ae039 = $9a2aef001772ced0$var$StackableCoordinates;


const $f0cc8d181f18ec0c$var$WayPointMotion = "WayPointMotion";
const $f0cc8d181f18ec0c$var$executeEvent = (event, entity)=>{
    const eventData = event.event;
    if (eventData.setState && entity.showState) entity.showState(eventData.setState[0], eventData.setState[1]);
    if (eventData.event) entity.trigger(eventData.event);
};
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($f0cc8d181f18ec0c$var$WayPointMotion, {
    required: (0, $9a2aef001772ced0$export$2e2bcd8739ae039),
    init () {
        this.createStackablePropertyFor("xPath", "x");
        this.createStackablePropertyFor("yPath", "y");
    },
    remove () {
        this.stopFlyPattern();
    },
    flyPattern (pattern, { duration: d, velocity: velocity, easing: easing = "linear", start: start = 0.0, end: end = 1.0 } = {}) {
        this.pattern = pattern;
        const vpw = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width;
        const vph = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height;
        const base = this.pattern[0];
        const normalizedPath = pattern.map(({ x: x, y: y })=>({
                x: (x - base.x) * vpw,
                y: (y - base.y) * vph
            }));
        this.bezierPath = (0, $36a1e159616bc066$export$b2afe50f305285f6)(normalizedPath);
        this.eventQueue = pattern.reduce((acc, item, index)=>{
            if (item.events === undefined) return acc;
            const part = this.bezierPath.curves[index];
            return acc.concat(item.events.map(([t, data])=>({
                    pos: part.min + part.length * t / this.bezierPath.length,
                    event: data
                })));
        }, []);
        const duration = d || this.bezierPath.length / velocity * 1000;
        const fullDuration = duration / (end - start);
        this.wayPointEasing = new (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).easing(fullDuration, easing);
        this.wayPointEasing.tick(start * fullDuration);
        this.targetPatternValue = end;
        const value = this.wayPointEasing.value();
        this.pathOffset = this.bezierPath.get(value);
        if (!this.inMotion) {
            this.inMotion = true;
            this.bind("GameLoop", this.updateAcceleration);
        }
        return this;
    },
    stopFlyPattern () {
        if (this.inMotion) {
            this.unbind("GameLoop", this.updateAcceleration);
            this.inMotion = false;
            this.trigger("PatternAborted");
        }
    },
    updateAcceleration ({ dt: dt }) {
        this.wayPointEasing.tick(dt);
        const value = this.wayPointEasing.value();
        this.eventQueue = this.eventQueue.filter((e)=>{
            if (e.pos <= value) {
                // execute Event
                $f0cc8d181f18ec0c$var$executeEvent(e, this);
                return false;
            }
            return true;
        });
        const p = this.bezierPath.get(value);
        if (p) this.attr({
            xPath: p.x - this.pathOffset.x,
            yPath: p.y - this.pathOffset.y
        });
        if (value >= this.targetPatternValue || !p) {
            this.unbind("GameLoop", this.updateAcceleration);
            // apply final path coordinates after route is finished
            this.applyStackableProperty("xPath", "x");
            this.applyStackableProperty("yPath", "y");
            this.inMotion = false;
            this.trigger("PatternCompleted", {
                patternCompleted: true
            });
        }
    }
});
var $f0cc8d181f18ec0c$export$2e2bcd8739ae039 = $f0cc8d181f18ec0c$var$WayPointMotion;








const $8c6a9ebc6fe6c24c$export$c35d437ae5945fcd = "Animation";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($8c6a9ebc6fe6c24c$export$c35d437ae5945fcd, {
    init () {
        this.elements = {};
    },
    remove () {
        this.unbind("GameLoop", this._animateTick);
    },
    setAnimation (animation, { maxCheckpoint: maxCheckpoint = 0, start: start = 0, ...options } = {}) {
        if (this.currentAnimation === animation) return;
        this.currentAnimation = animation;
        this.maxAllowedCheckpoint = maxCheckpoint;
        this.setActiveCheckpoint(start, options);
    },
    setCheckpointLimit (limit) {
        const prevLimit = this.maxAllowedCheckpoint;
        this.maxAllowedCheckpoint = limit;
        if (this.targetCheckpoint < limit && !this.playingAnimation) this.setActiveCheckpoint(this.targetCheckpoint === prevLimit ? this.targetCheckpoint : this.targetCheckpoint + 1);
    },
    setActiveCheckpoint (checkpoint, { autoStart: autoStart = true, duration: duration = null } = {}) {
        this.unbind("GameLoop", this.updateAnimation);
        const checkpointData = this.currentAnimation.checkpoints[checkpoint];
        this.playingAnimation = false;
        if (!checkpointData) return;
        this.targetCheckpoint = checkpoint;
        let toRemove = Object.keys(this.elements);
        (checkpointData.composables || []).forEach(([composable, settings])=>{
            const composition = (0, $4a464ac9ac54fc86$export$80766d2842af6389)(composable);
            const existing = this.elements[settings.key];
            toRemove = toRemove.filter((k)=>k !== settings.key);
            if (existing && existing.appliedDefinition === composition) {
                const startFrame = settings.frame || "default";
                if (existing.targetFrame !== startFrame) existing.displayFrame(startFrame);
            } else {
                existing && existing.destroy();
                const x = (settings.relativeX || 0) * (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width;
                const y = (settings.relativeY || 0) * (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height;
                const sub = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e([
                    "2D",
                    "WebGL",
                    (0, $5fd20eb0995a8d9f$export$2e2bcd8739ae039)
                ].join(",")).attr({
                    x: x,
                    y: y,
                    w: 40,
                    h: 40,
                    z: this.z || 0
                }).compose(composition);
                //this.attach(sub);
                sub.displayFrame(settings.frame || "default");
                this.elements[settings.key] = sub;
            }
        });
        (checkpointData.entities || []).forEach(([entity, settings])=>{
            const existing = this.elements[settings.key];
            toRemove = toRemove.filter((k)=>k !== settings.key);
            if (!existing) {
                const x = (settings.relativeX || 0) * (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width;
                const y = (settings.relativeY || 0) * (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height;
                const e = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(entity).get(0) || (0, $89ad5169d85cb0bf$export$1fe0dcec7c33c489)(entity, settings).attr({
                    x: x,
                    y: y,
                    z: (this.z || 0) + (settings.z || 0)
                });
                if (settings.detach && e.detachFromParent) e.detachFromParent();
                this.elements[settings.key] = e;
                if (settings.state) e.showState(settings.state);
            } else {
                this.z && existing.attr({
                    z: this.z
                });
                // const x = (settings.relativeX || 0) * Crafty.viewport.width;
                // const y = (settings.relativeY || 0) * Crafty.viewport.height;
                if (settings.state) existing.showState(settings.state);
            }
        });
        (checkpointData.particles || []).forEach(([emitterDefinition, settings])=>{
            const existing = this.elements[settings.key];
            toRemove = toRemove.filter((k)=>k !== settings.key);
            if (!existing) {
                const x = (settings.relativeX || 0) * (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width;
                const y = (settings.relativeY || 0) * (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height;
                const emitter = (0, (/*@__PURE__*/$parcel$interopDefault($89aeca5d4d27357e$exports)))({}, (0, $4a464ac9ac54fc86$export$2096b54ada1e6fa4)(emitterDefinition), settings.particles);
                const e = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e((0, $767c35cd7f31dfa2$export$2e2bcd8739ae039)).attr({
                    x: x,
                    y: y,
                    z: (this.z || 0) + (settings.z || 0)
                }).particles(emitter);
                if (settings.detach && e.detachFromParent) e.detachFromParent();
                this.elements[settings.key] = e;
            } else {
                this.z && existing.attr({
                    z: (this.z || 0) + (settings.z || 0)
                });
                if (settings.state) existing.showState(settings.state);
            }
        });
        if (checkpointData.background) (0, $8c0d474e6a2e6236$export$398bd3ed8b98188b)(checkpointData.background);
        toRemove.forEach((k)=>{
            delete this.elements[k];
        });
        if (checkpointData.backgroundColor) {
            const backgroundColor = (0, $60cfab0448e82384$export$837e48ddf1fe387b)([
                checkpointData.backgroundColor,
                1.0
            ]);
            (0, $8c0d474e6a2e6236$export$398bd3ed8b98188b)(backgroundColor);
        }
        if (autoStart && checkpointData.timeline && checkpoint < this.maxAllowedCheckpoint) {
            this.animationDuration = duration || checkpointData.timeline.defaultDuration;
            if (this.animationDuration) {
                this.animationTimer = new (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).easing(this.animationDuration, (0, $21d6fb1fc143defa$export$8244104593af74a6));
                this.timeLineEvents = checkpointData.timeline.transitions.map((t)=>({
                        ...t,
                        handled: false
                    }));
                this.playingAnimation = true;
                this.uniqueBind("GameLoop", this.updateAnimation);
            }
        }
    },
    updateAnimation ({ dt: dt }) {
        this.animationTimer.tick(dt);
        const value = this.animationTimer.value();
        this.timeLineEvents.forEach((t)=>{
            if (t.handled || t.start > value) return;
            // handle event
            if (t.targetFrame && t.key) {
                const elem = this.elements[t.key];
                t.handled = true;
                elem && elem.displayFrame(t.targetFrame, (t.end - t.start) * this.animationDuration);
            }
            if (t.targetState && t.key) {
                const elem = this.elements[t.key];
                t.handled = true;
                elem && elem.showState(t.targetState, (t.end - t.start) * this.animationDuration);
            }
            if (t.attributes && t.key) {
                const elem = this.elements[t.key];
                t.handled = true;
                if (elem) {
                    const tween = (0, $efc499a22346529b$export$d4775187212d9f53)(elem, t.attributes);
                    elem.animate(tween, (t.end - t.start) * this.animationDuration);
                }
            }
            if (t.components && t.key) {
                const elem = this.elements[t.key];
                t.handled = true;
                if (elem) t.components.forEach((c)=>elem.addComponent(c));
            }
            if (t.targetBackgroundColor) {
                if (t.sourceColor && t.ease) {
                    t.ease.tick(dt);
                    const color = (0, $60cfab0448e82384$export$2c9e8a9632a706b2)(t.ease.value(), t.sourceColor, t.targetColor);
                    (0, $8c0d474e6a2e6236$export$398bd3ed8b98188b)(color);
                    if (t.ease.value() >= 1.0) t.handled = true;
                } else {
                    t.sourceColor = (0, $8c0d474e6a2e6236$export$4420ac7a34197e42)();
                    t.targetColor = (0, $60cfab0448e82384$export$837e48ddf1fe387b)([
                        t.targetBackgroundColor,
                        1.0
                    ]);
                    t.ease = new (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).easing((t.end - t.start) * this.animationDuration, (0, $21d6fb1fc143defa$export$8244104593af74a6));
                    t.ease.tick(dt);
                    const color = (0, $60cfab0448e82384$export$2c9e8a9632a706b2)(t.ease.value(), t.sourceColor, t.targetColor);
                    (0, $8c0d474e6a2e6236$export$398bd3ed8b98188b)(color);
                }
            }
            if (t.path && t.key) {
                t.handled = true;
                const elem = this.elements[t.key];
                if (!elem) return;
                elem.addComponent((0, $f0cc8d181f18ec0c$export$2e2bcd8739ae039));
                const pathDuration = (t.end - t.start) * this.animationDuration;
                const path = t.path.data || (0, $4a464ac9ac54fc86$export$595447059867920)(t.path.name).path;
                elem.flyPattern(path, {
                    duration: pathDuration,
                    start: t.path.start || 0.0,
                    end: t.path.end || 1.0,
                    easing: t.path.easing || "linear"
                });
            }
            if (t.remove && t.key) {
                t.handled = true;
                const elem = this.elements[t.key];
                if (!elem) return;
                this.elements[t.key].destroy();
                delete this.elements[t.key];
            }
        });
        if (value >= 1.0) {
            this.unbind("GameLoop", this.updateAnimation);
            this.playingAnimation = false;
            if (this.maxAllowedCheckpoint > this.targetCheckpoint && this.currentAnimation.checkpoints.length > this.targetCheckpoint + 1) {
                this.trigger("CheckpointReached", {
                    checkpoint: this.targetCheckpoint + 1
                });
                this.setActiveCheckpoint(this.targetCheckpoint + 1);
            // Emit an event that checkpoint is updated
            } else {
                this.trigger("CheckpointReached", {
                    checkpoint: this.targetCheckpoint + 1
                });
                this.trigger("AnimationEnded", {
                    checkpoint: this.targetCheckpoint
                });
            }
        }
    }
});
var $8c6a9ebc6fe6c24c$export$2e2bcd8739ae039 = $8c6a9ebc6fe6c24c$export$c35d437ae5945fcd;
const $8c6a9ebc6fe6c24c$export$bb00580d34b43172 = (animation, { max: max = Infinity, start: start = 0, z: z = 0 } = {})=>{
    const player = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e($8c6a9ebc6fe6c24c$export$c35d437ae5945fcd).attr({
        z: z
    });
    player.setAnimation(animation, {
        maxCheckpoint: max,
        start: start
    });
    let checkpointReached = null;
    let checkpointSubscriptions = [];
    player.bind("CheckpointReached", ({ checkpoint: checkpoint })=>{
        checkpointReached = checkpoint;
        checkpointSubscriptions = checkpointSubscriptions.filter(({ checkpoint: matchCheckpoint, resolver: resolver })=>{
            if (matchCheckpoint == null) {
                resolver({
                    checkpoint: checkpoint,
                    player: player
                });
                return true;
            }
            if (matchCheckpoint <= checkpoint) {
                resolver(checkpoint);
                return false;
            }
            return true;
        });
    });
    return {
        waitTillCheckpoint: (checkpoint)=>checkpoint <= checkpointReached ? Promise.resolve() : new Promise((resolver, rejecter)=>{
                checkpointSubscriptions.push({
                    checkpoint: checkpoint,
                    resolver: resolver,
                    rejecter: rejecter
                });
            }),
        onCheckpointChange: (callback)=>{
            checkpointSubscriptions.push({
                checkpoint: null,
                resolver: callback
            });
        },
        updateCheckpoint: (start)=>{
            player.setActiveCheckpoint(start);
        },
        updateCheckpointLimit: (newLimit)=>{
            player.setCheckpointLimit(newLimit);
        },
        waitTillEnd: ()=>new Promise((resolve)=>player.one("AnimationEnded", resolve)),
        destroy: ()=>{
            checkpointSubscriptions.forEach(({ rejecter: rejecter })=>rejecter && rejecter(new Error("Animation destroyed")));
            player.destroy();
        }
    };
};


const $4bb6096cd1c626e3$export$668799e4797757a8 = "Background";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($4bb6096cd1c626e3$export$668799e4797757a8, {
    required: [
        "2D, WebGL",
        (0, $8c6a9ebc6fe6c24c$export$2e2bcd8739ae039)
    ].join(","),
    init () {
        this.attr({
            x: 0,
            y: 0,
            w: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._scale,
            h: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._scale,
            z: -1000
        });
        this.bind("ViewportScale", this.updateBackdrop);
    },
    remove () {
        Object.keys(this.elements).forEach((key)=>{
            this.elements[key].destroy();
            delete this.elements[key];
        });
    },
    updateBackdrop () {
        this.attr({
            w: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._scale,
            h: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport._scale
        });
    }
});
var $4bb6096cd1c626e3$export$2e2bcd8739ae039 = $4bb6096cd1c626e3$export$668799e4797757a8;
const $4bb6096cd1c626e3$export$2e65e79124cca55d = (background, options)=>{
    const backdrop = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)($4bb6096cd1c626e3$export$668799e4797757a8).get(0) || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e($4bb6096cd1c626e3$export$668799e4797757a8);
    backdrop.setAnimation(background, options);
};
const $4bb6096cd1c626e3$export$50a5772001eb0788 = (checkpoint)=>{
    const backdrop = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)($4bb6096cd1c626e3$export$668799e4797757a8).get(0) || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e($4bb6096cd1c626e3$export$668799e4797757a8);
    backdrop.setActiveCheckpoint(checkpoint);
};
const $4bb6096cd1c626e3$export$41abacda0bfa2ade = ()=>{
    const backdrop = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)($4bb6096cd1c626e3$export$668799e4797757a8).get(0) || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e($4bb6096cd1c626e3$export$668799e4797757a8);
    return backdrop.targetCheckpoint;
};
const $4bb6096cd1c626e3$export$639d042f0bda089c = (limit)=>{
    const backdrop = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)($4bb6096cd1c626e3$export$668799e4797757a8).get(0) || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e($4bb6096cd1c626e3$export$668799e4797757a8);
    backdrop.setCheckpointLimit(limit);
};


let $cb7717e448aed308$var$index = null;
const $cb7717e448aed308$var$lookupTable = [];
for($cb7717e448aed308$var$index = 1e6; $cb7717e448aed308$var$index--;)$cb7717e448aed308$var$lookupTable.push(Math.random());
const $cb7717e448aed308$export$dfc7155ac0343b8 = ()=>++$cb7717e448aed308$var$index >= $cb7717e448aed308$var$lookupTable.length ? $cb7717e448aed308$var$lookupTable[$cb7717e448aed308$var$index = 0] : $cb7717e448aed308$var$lookupTable[$cb7717e448aed308$var$index];






const $3b6b64fd9a604466$var$noise = new (0, $423d54a57f94df96$exports.Noise)((0, $cb7717e448aed308$export$dfc7155ac0343b8)());
const $3b6b64fd9a604466$var$MAX_X_OFFSET = 30;
const $3b6b64fd9a604466$var$MAX_Y_OFFSET = 15;
const $3b6b64fd9a604466$var$SCENERY_ACTIVE = (0, (/*@__PURE__*/$parcel$interopDefault($fbd39d42b4ec86c5$exports))).scenery;
const $3b6b64fd9a604466$var$levelFunctions = (state)=>({
        trauma: {
            value: 0,
            time: 0,
            handler: null
        },
        addScreenTrauma: (value)=>{
            state.trauma.value += value;
            if (state.trauma.value > 0 && state.trauma.handler === null) {
                state.trauma.handler = ({ dt: dt })=>{
                    const screenshake = state.trauma.value * state.trauma.value;
                    state.trauma.value = Math.max(0, state.trauma.value - 0.001 * dt);
                    let x = 0;
                    let y = 0;
                    if (screenshake > 0) {
                        state.trauma.time += dt;
                        const xn = $3b6b64fd9a604466$var$noise.perlin2(0.1, state.trauma.time / ((3 - state.trauma.value) * 360));
                        const yn = $3b6b64fd9a604466$var$noise.perlin2(state.trauma.time / ((3 - state.trauma.value) * 360), 0.3);
                        x = 0 + Math.round($3b6b64fd9a604466$var$MAX_X_OFFSET * screenshake * xn);
                        y = 0 + Math.round($3b6b64fd9a604466$var$MAX_Y_OFFSET * screenshake * yn);
                    }
                    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.x = x;
                    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.y = y;
                    if (screenshake === 0) {
                        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).unbind("GameLoop", state.trauma.handler);
                        state.trauma.handler = null;
                    }
                };
                (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).bind("GameLoop", state.trauma.handler);
            }
        },
        setScrollingSpeed: async (x, y, { speed: speed = 50, instant: instant = false } = {})=>{
            if (!$3b6b64fd9a604466$var$SCENERY_ACTIVE) return;
            const scenery = (0, $ec7d2d2f6f8a6193$export$2eb5ba9a66e42816)("Scenery") || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Scenery, 2D");
            return instant ? scenery.setScrollVelocity({
                vx: -x,
                vy: y
            }) : new Promise((resolve)=>{
                const vPSec = speed / 1000;
                const { vx: startX, vy: startY } = (0, $028fd5673236b3e7$export$4aa419c702349ac0)();
                const deltaY = Math.abs(y - startY);
                const deltaX = Math.abs(x - -startX);
                const delta = Math.max(deltaX, deltaY);
                const ease = new (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).easing(delta / vPSec, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
                const f = ({ dt: dt })=>{
                    ease.tick(dt);
                    const v = ease.value();
                    if (v >= 1.0) {
                        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).unbind("GameLoop", f);
                        resolve(undefined);
                    }
                    const vy = startY * (1 - v) + y * v;
                    const vx = -startX * (1 - v) + x * v;
                    scenery.setScrollVelocity({
                        vx: -vx,
                        vy: vy
                    });
                };
                (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).bind("GameLoop", f);
            });
        },
        setAltitude: async (y, { speed: speed = 50, instant: instant = false } = {})=>{
            if (!$3b6b64fd9a604466$var$SCENERY_ACTIVE) return;
            return instant ? (0, $028fd5673236b3e7$export$1d8b1be4a2d6d065)(y) : new Promise((resolve)=>{
                const altPSec = speed / 1000;
                const startAlt = (0, $028fd5673236b3e7$export$47d30829676be666)();
                const delta = Math.abs(y - startAlt);
                const ease = new (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).easing(delta / altPSec, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
                const f = ({ dt: dt })=>{
                    ease.tick(dt);
                    const v = ease.value();
                    if (v >= 1.0) {
                        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).unbind("GameLoop", f);
                        resolve(undefined);
                    }
                    const alt = startAlt * (1 - v) + y * v;
                    (0, $028fd5673236b3e7$export$1d8b1be4a2d6d065)(alt);
                };
                (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).bind("GameLoop", f);
            });
        },
        setScenery: async (sceneryName)=>{
            if (!$3b6b64fd9a604466$var$SCENERY_ACTIVE) return;
            return (0, $028fd5673236b3e7$export$ac15e59049f4313a)(sceneryName);
        },
        waitTillInScreen: (sceneryName, offset)=>(0, $028fd5673236b3e7$export$693e04523164753e)(sceneryName, offset),
        setBackground: async (backgroundName, checkpoint, limit)=>{
            if (!$3b6b64fd9a604466$var$SCENERY_ACTIVE) return;
            (0, $4bb6096cd1c626e3$export$2e65e79124cca55d)((0, $4a464ac9ac54fc86$export$7f9953c70dacfd7f)(backgroundName));
            if (limit !== undefined) (0, $4bb6096cd1c626e3$export$639d042f0bda089c)(limit);
            if (checkpoint !== undefined) {
                if ((0, $4bb6096cd1c626e3$export$41abacda0bfa2ade)() === 0) (0, $4bb6096cd1c626e3$export$50a5772001eb0788)(checkpoint);
            }
        },
        setGameSpeed: (0, $2e5c1713fb068b10$export$ea1f1c9e80b89b51),
        fadeIn: (0, $60cfab0448e82384$export$82e6205b15e6c637),
        fadeOut: (0, $60cfab0448e82384$export$c091916f1530334c),
        setBackgroundCheckpointLimit: async (limit)=>{
            (0, $4bb6096cd1c626e3$export$639d042f0bda089c)(limit);
        },
        setBackgroundCheckpoint: async (checkpoint)=>{
            if ((0, $4bb6096cd1c626e3$export$41abacda0bfa2ade)() < checkpoint) (0, $4bb6096cd1c626e3$export$50a5772001eb0788)(checkpoint);
        },
        playAnimation: (animation, options)=>(0, $8c6a9ebc6fe6c24c$export$bb00580d34b43172)((0, $4a464ac9ac54fc86$export$7f9953c70dacfd7f)(animation), options)
    });
var $3b6b64fd9a604466$export$2e2bcd8739ae039 = $3b6b64fd9a604466$var$levelFunctions;







const $df8ef690c26e902b$var$move = (entity, flyPattern, velocity, easing, state)=>{
    entity.addComponent("WayPointMotion");
    const v = velocity || entity.defaultVelocity;
    entity.flyPattern(flyPattern, {
        velocity: v,
        easing: easing
    });
    let completed = null;
    return {
        wasCompleted: ()=>completed,
        process: new Promise((resolve, reject)=>{
            const complete = (eventData)=>{
                completed = eventData && eventData.patternCompleted;
                entity.unbind("PatternCompleted", complete);
                entity.unbind("PatternAborted", complete);
                (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).unbind("GameOver", complete);
                if (state.gameEnded === true) reject(new Error("Game Over"));
                resolve(undefined);
            };
            entity.one("PatternCompleted", complete);
            entity.one("PatternAborted", complete);
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).one("GameOver", complete);
        }),
        abort: ()=>entity.stopFlyPattern()
    };
};
const $df8ef690c26e902b$var$entityFunctions = (_, state)=>({
        spawn: (entityName, settings)=>(0, $89ad5169d85cb0bf$export$1fe0dcec7c33c489)(entityName, settings),
        displayFrame: (entity, frameName, duration, easing = (0, $21d6fb1fc143defa$export$8244104593af74a6))=>entity.displayFrame(frameName, duration, easing),
        showState: (entity, state, duration, easing = (0, $21d6fb1fc143defa$export$8244104593af74a6))=>entity.showState(state, duration, easing),
        showAnimation: (entity, animation)=>entity.playAnimation(animation),
        allowDamage: (entity, settings)=>{
            entity.addCollisionComponent("DamageSupport", [
                "processDamage"
            ]);
            entity.allowDamage(settings);
        },
        moveWithPattern: (entity, pattern, velocity = null, easing = (0, $21d6fb1fc143defa$export$8244104593af74a6))=>{
            const flyPattern = (0, $4a464ac9ac54fc86$export$595447059867920)(pattern);
            return $df8ef690c26e902b$var$move(entity, flyPattern.path, velocity, easing, state);
        },
        moveTo: (entity, coord, velocity = null, easing = (0, $21d6fb1fc143defa$export$8244104593af74a6))=>{
            const vpw = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width;
            const vph = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height;
            const startX = entity.x / vpw;
            const startY = entity.y / vph;
            const flyPattern = [
                {
                    x: startX,
                    y: startY
                },
                {
                    x: startX,
                    y: startY,
                    ...coord
                }
            ];
            return $df8ef690c26e902b$var$move(entity, flyPattern, velocity, easing, state);
        }
    });
var $df8ef690c26e902b$export$2e2bcd8739ae039 = $df8ef690c26e902b$var$entityFunctions;




const $c5bc0c79d5cbf288$var$Component = "Health";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($c5bc0c79d5cbf288$var$Component, {
    required: "Color",
    events: {
        EnterFrame () {}
    },
    properties: {
        health: {
            set: function(value) {
                this._health = value;
                this.w = Math.min(this.maxWidth, this.maxWidth * value);
                this._green = 144 * this._health;
                this._red = 144 * (1 - this._health);
                this.trigger("Invalidate");
            },
            get: function() {
                return this._health;
            },
            configurable: true,
            enumerable: true
        },
        _health: {
            value: 1.0,
            writable: true,
            enumerable: false
        }
    },
    init () {
        this.color(0, 144, 0);
    }
});
var $c5bc0c79d5cbf288$export$2e2bcd8739ae039 = $c5bc0c79d5cbf288$var$Component;




const $fa0e59230e773a74$var$enemyThreshold = 10;
const $fa0e59230e773a74$var$baseScore = 25;
let $fa0e59230e773a74$var$scoreThreshold = 100;
let $fa0e59230e773a74$var$pointsScored = 0;
let $fa0e59230e773a74$var$enemies = 0;
let $fa0e59230e773a74$var$multiplier = 1;
const $fa0e59230e773a74$export$c66c73b8d7399369 = ()=>$fa0e59230e773a74$var$multiplier;
const $fa0e59230e773a74$export$75300c223cab5513 = (amount, x, y, dsl)=>{
    $fa0e59230e773a74$var$pointsScored += amount;
    $fa0e59230e773a74$var$enemies += 1;
    if ($fa0e59230e773a74$var$pointsScored >= $fa0e59230e773a74$var$scoreThreshold && $fa0e59230e773a74$var$enemies >= $fa0e59230e773a74$var$enemyThreshold) {
        dsl.exec($fa0e59230e773a74$var$bonusSpawn(x, y, $fa0e59230e773a74$var$multiplier * $fa0e59230e773a74$var$baseScore));
        $fa0e59230e773a74$var$pointsScored = 0;
        $fa0e59230e773a74$var$enemies = 0;
        $fa0e59230e773a74$var$scoreThreshold *= 1.1;
    }
};
const $fa0e59230e773a74$export$84bc808d79becd43 = ()=>{
    $fa0e59230e773a74$export$aad8462122ac592b();
};
const $fa0e59230e773a74$export$aad8462122ac592b = ()=>{
    $fa0e59230e773a74$var$multiplier = 1;
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).trigger("MultiplierChange", $fa0e59230e773a74$var$multiplier);
    $fa0e59230e773a74$var$scoreThreshold = 100;
    $fa0e59230e773a74$var$pointsScored = 0;
};
const $fa0e59230e773a74$var$bonusSpawn = (x, y, points)=>async ({ allowDamage: allowDamage, showState: showState, waitForEvent: waitForEvent, wait: wait, spawn: spawn, awardPoints: awardPoints, moveWithPattern: moveWithPattern })=>{
        const bonus = spawn("Bonus", {
            location: {
                x: x,
                y: y
            },
            defaultVelocity: 40
        });
        await allowDamage(bonus, {
            health: 10
        });
        waitForEvent(bonus, "Dead", async ()=>{
            awardPoints(points, x, y, false);
            $fa0e59230e773a74$var$multiplier += 1;
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).trigger("MultiplierChange", $fa0e59230e773a74$var$multiplier);
            await showState(bonus, "pickedUp");
            await wait(2000);
            bonus.destroy();
        });
        const motion = moveWithPattern(bonus, "powerup.short");
        await motion.process;
        await showState(bonus, "disappear", 1000);
        bonus.destroy();
    };


let $c086f0b8e0a2db0c$var$pointsPool = [];
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).bind("SceneDestroy", ()=>$c086f0b8e0a2db0c$var$pointsPool = []);
const $c086f0b8e0a2db0c$var$getAwardText = ()=>{
    const available = $c086f0b8e0a2db0c$var$pointsPool.find((e)=>e.__frozen);
    if (available) {
        available.unfreeze();
        return available.attr({
            alpha: 1
        });
    }
    const spawn = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(`2D, Text, DOM, ${(0, $efc499a22346529b$export$2e2bcd8739ae039)}`).attr({
        z: 400,
        alpha: 1,
        w: 300
    }).textColor("#EEEEEE").textAlign("left").textFont({
        size: "12px",
        weight: "bold",
        family: "Press Start 2P"
    });
    $c086f0b8e0a2db0c$var$pointsPool = $c086f0b8e0a2db0c$var$pointsPool.concat(spawn);
    return spawn;
};
const $c086f0b8e0a2db0c$var$stateFunctions = (dsl, state)=>{
    const lives = ((0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("HUDLives").get(0) || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(`2D, HUDLives, UILayerDOM, Text, HUD, HUDTop, ${(0, $efc499a22346529b$export$2e2bcd8739ae039)}`).attr({
        x: 20,
        y: -10,
        w: 100,
        alpha: 0
    }).textColor("#FFFF00").textAlign("left").textFont({
        size: "8px",
        weight: "bold",
        family: "Press Start 2P"
    })).text(`Lives: ${state.lives}`);
    const health = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("HUDHealth").get(0) || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(`2D, HUDHealth, UILayerWebGL, HUD, HUDTop, ${(0, $c5bc0c79d5cbf288$export$2e2bcd8739ae039)}, ${(0, $efc499a22346529b$export$2e2bcd8739ae039)}`).attr({
        x: 150,
        y: -10,
        w: 120,
        h: 5,
        alpha: 0,
        maxWidth: 120
    });
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("HUDHealthBar").get(0) || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(`2D, HUDHealthBar, UILayerWebGL, Color, HUD, HUDTop, ${(0, $efc499a22346529b$export$2e2bcd8739ae039)}`).attr({
        x: 149,
        y: -11,
        w: 122,
        h: 7,
        z: -1,
        alpha: 0,
        baseAlpha: 0.6
    }).color("#202020");
    // const energy =
    //   Crafty("HUDEnergy").get(0) ||
    //   Crafty.e(`2D, HUDEnergy, UILayerWebGL, HUD, HUDTop, Color, ${TweenPromise}`)
    //     .attr({
    //       x: 150,
    //       y: 0,
    //       w: 0,
    //       h: 5,
    //       alpha: 0,
    //       maxWidth: 120
    //     })
    //     .color("#4040dd");
    // Crafty("HUDEnergyBar").get(0) ||
    //   Crafty.e(
    //     `2D, HUDEnergyBar, UILayerWebGL, Color, HUD, HUDTop, ${TweenPromise}`
    //   )
    //     .attr({ x: 149, y: -1, w: 122, h: 7, z: -1, alpha: 0, baseAlpha: 0.6 })
    //     .color("#202020");
    const score = ((0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("HUDScore").get(0) || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(`2D, HUDScore, UILayerDOM, Text, HUD, HUDTop, ${(0, $efc499a22346529b$export$2e2bcd8739ae039)}`).attr({
        x: 800,
        y: -10,
        w: 220,
        alpha: 0,
        score: 0,
        displayScore: 0
    }).textColor("#FFFF00").textAlign("left").textFont({
        size: "8px",
        weight: "bold",
        family: "Press Start 2P"
    })).text(function() {
        if (this.score > this.displayScore + 200) {
            this.displayScore += 10;
            this.textFont({
                size: "9px"
            }).textColor("#FFFF80");
        } else if (this.score > this.displayScore + 100) {
            this.displayScore += 5;
            this.textFont({
                size: "9px"
            }).textColor("#FFFF40");
        } else if (this.score > this.displayScore) {
            this.displayScore += 1;
            this.textFont({
                size: "8px"
            });
        }
        return `Score: ${this.displayScore}`;
    }).dynamicTextGeneration(true, "GameLoop");
    const multiplier = ((0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("HUDMultiplier").get(0) || (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(`2D, HUDMultiplier, UILayerDOM, Text, HUD, HUDTop, ${(0, $efc499a22346529b$export$2e2bcd8739ae039)}`).attr({
        x: 800,
        y: 10,
        w: 220,
        alpha: 0
    }).textColor("#FFFF00").textAlign("left").textFont({
        size: "8px",
        weight: "bold",
        family: "Press Start 2P"
    })).text(`Bonus: ${(0, $fa0e59230e773a74$export$c66c73b8d7399369)()}x`);
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).bind("MultiplierChange", ()=>multiplier.text(`Bonus: ${(0, $fa0e59230e773a74$export$c66c73b8d7399369)()}x`));
    const closeScripts = [];
    const onSceneDestroy = ()=>{
        dsl.closeScript();
        (0, $fa0e59230e773a74$export$aad8462122ac592b)();
    };
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).one("SceneDestroy", onSceneDestroy);
    dsl.closeScript = ()=>{
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).unbind("SceneDestroy", onSceneDestroy);
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).unbind("MultiplierChange");
        closeScripts.forEach((c)=>c());
    };
    const awardText = async (text, x, y)=>{
        const award = $c086f0b8e0a2db0c$var$getAwardText().attr({
            x: x,
            y: y
        }).text(text);
        await award.tweenPromise({
            y: y - 40,
            alpha: 0
        }, 1000);
        award.freeze();
    };
    return {
        onScriptClose: (callback)=>{
            closeScripts.push(callback);
        },
        setHealthbar: (healthPerc)=>{
            health.attr({
                health: healthPerc
            });
        },
        setEnergybar: (energyPerc)=>{
        // energy.attr({ w: energyPerc * energy.maxWidth });
        },
        showBuff: (slot, entity, buffName, key)=>{
            const item = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(`BuffSlot${slot}`);
            if (item.length > 0) item.destroy();
            const icon = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(`2D, HUD, HUDBottom, WebGL, Color, BuffSlot${slot}, ${(0, $efc499a22346529b$export$2e2bcd8739ae039)}`).attr({
                w: 20,
                h: 20,
                x: 20 + slot * 30,
                y: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height - 28,
                z: 900,
                alpha: state.hudShown === true ? 1 : 0
            });
            const updateColor = ()=>{
                if (entity.canActivateBuff(buffName)) {
                    icon.color("#5F5");
                    return;
                }
                const status = entity.buffStatus(buffName);
                if (status.activeLeft === 0 && status.cooldown === 0) {
                    icon.color("#333");
                    return;
                }
                if (status.activeLeft > 0) {
                    icon.color("#AA0");
                    return;
                }
                if (status.cooldown > 0) {
                    icon.color("#A10");
                    return;
                }
            };
            updateColor();
            entity.uniqueBind("EnergyUpdate", ()=>{
                updateColor();
            });
            entity.uniqueBind("BuffActivated", (name)=>{
                if (name === buffName) updateColor();
            });
            entity.uniqueBind("BuffEnded", (name)=>{
                if (name === buffName) updateColor();
            });
            entity.uniqueBind("CooldownEnded", (name)=>{
                if (name === buffName) updateColor();
            });
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(`DOM, HUD, HUDBottom, 2D, Text, ${(0, $efc499a22346529b$export$2e2bcd8739ae039)}`).attr({
                w: 60,
                h: 20,
                x: 1 + 30 * slot,
                y: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height - 11,
                alpha: state.hudShown === true ? 1 : 0
            }).textColor("#111").textAlign("center").textFont({
                size: "8px",
                family: "Press Start 2P"
            }).text(`${key}`);
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e(`DOM, HUD, HUDBottom, 2D, Text, ${(0, $efc499a22346529b$export$2e2bcd8739ae039)}`).attr({
                w: 60,
                h: 20,
                x: 30 * slot,
                y: (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height - 10,
                alpha: state.hudShown === true ? 1 : 0
            }).textColor("#eee").textAlign("center").textFont({
                size: "8px",
                family: "Press Start 2P"
            }).text(`${key}`);
        },
        loseLife: ()=>{
            state.lives -= 1;
            if (state.lives < 0) {
                state.gameEnded = true;
                (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).trigger("GameOver");
                throw new Error("Game Over");
            }
            lives.text(`Lives: ${state.lives}`);
        },
        gainLife: ()=>{
            state.lives += 1;
            lives.text(`Lives: ${state.lives}`);
        },
        awardPoints: async (amount, x, y, countToBonus = true)=>{
            state.score += amount;
            score.attr({
                score: state.score
            });
            if (countToBonus) (0, $fa0e59230e773a74$export$75300c223cab5513)(amount, x, y, dsl);
            await awardText(`+${amount}`, x, y);
        },
        awardText: awardText,
        playerHit: (0, $fa0e59230e773a74$export$84bc808d79becd43),
        showHUD: ()=>{
            if (state.hudShown === true) return;
            state.hudShown = true;
            const results = [];
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("HUDTop").each(function() {
                if (this.tweenPromise) results.push(this.tweenPromise({
                    alpha: this.baseAlpha === undefined ? 1 : this.baseAlpha,
                    y: this.y + 20
                }, 500));
            });
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("HUDBottom").each(function() {
                if (this.tweenPromise) results.push(this.tweenPromise({
                    alpha: this.baseAlpha === undefined ? 1 : this.baseAlpha
                }, 500));
            });
            return Promise.all(results);
        },
        hideHUD: ()=>{
            if (state.hudShown !== true) return;
            state.hudShown = false;
            const results = [];
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("HUDTop").each(function() {
                if (this.tweenPromise) results.push(this.tweenPromise({
                    alpha: 0,
                    y: this.y - 20
                }, 500));
            });
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("HUDBottom").each(function() {
                if (this.tweenPromise) results.push(this.tweenPromise({
                    alpha: 0
                }, 500));
            });
            return Promise.all(results);
        }
    };
};
var $c086f0b8e0a2db0c$export$2e2bcd8739ae039 = $c086f0b8e0a2db0c$var$stateFunctions;



const $75d63cfcf5f29411$var$wrap = (o, s)=>Object.entries(o).reduce((a, [key, value])=>{
        a[key] = typeof value === "function" ? (...args)=>{
            if (s.gameEnded === true) throw new Error("Game Over");
            return value(...args);
        } : value;
        return a;
    }, {});
const $75d63cfcf5f29411$export$1da21c66750cbff2 = (initialState)=>{
    let activeScript;
    return async (script)=>{
        const currentScript = Math.random();
        activeScript = currentScript;
        const dsl = {
            currentScript: ()=>activeScript === currentScript
        };
        [
            (0, $55198199b302d82f$export$2e2bcd8739ae039),
            (0, $3b6b64fd9a604466$export$2e2bcd8739ae039),
            (0, $df8ef690c26e902b$export$2e2bcd8739ae039),
            (0, $d886ebc26f8c43dc$export$2e2bcd8739ae039),
            (0, $c086f0b8e0a2db0c$export$2e2bcd8739ae039)
        ].forEach((functionSet)=>Object.assign(dsl, $75d63cfcf5f29411$var$wrap(functionSet(dsl, initialState), initialState)));
        if (initialState.gameEnded === true) return;
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).one("EndGame", ()=>{
            activeScript = null;
            initialState.gameEnded = true;
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).trigger("GameOver");
        });
        try {
            return await script(dsl);
        } catch (e) {
            if (e.message !== "Game Over") {
                console.error(e.message);
                throw e;
            }
        } finally{
            dsl.closeScript();
        }
    };
};



const $f25048ca1ee971a4$var$droneFlight = (pattern, yOffset = 0, points = 0, speed = null)=>async ({ spawn: spawn, showState: showState, waitForEvent: waitForEvent, allowDamage: allowDamage, awardPoints: awardPoints, moveWithPattern: moveWithPattern })=>{
        const flyPattern = (0, $4a464ac9ac54fc86$export$595447059867920)(pattern).path;
        const drone = spawn("WarDrone", {
            location: {
                rx: flyPattern[0].x,
                ry: flyPattern[0].y + yOffset
            },
            defaultVelocity: speed || 400
        });
        await allowDamage(drone, {
            health: 30
        });
        const movement = moveWithPattern(drone, pattern);
        waitForEvent(drone, "Dead", async ()=>{
            movement.abort();
            if (points > 0) awardPoints(points, drone.x, drone.y);
            await showState(drone, "dead");
            drone.destroy();
        });
        await movement.process;
        if (movement.wasCompleted()) drone.destroy();
    };
const $f25048ca1ee971a4$export$b2223c54508e0244 = (amount, pattern, { points: points = 10, delay: delay = 500, yOffset: yOffset = 0, speed: speed = null } = {})=>async ({ exec: exec, wait: wait })=>{
        const items = Array(amount).fill().map(async (e, index)=>{
            await wait(index * delay);
            await exec($f25048ca1ee971a4$var$droneFlight(pattern, yOffset, points, speed));
        });
        await Promise.all(items);
    };




const $f31ab0b95f1c79d7$export$d63bcbe667aaeac3 = ({ existing: existing = false } = {})=>async ({ spawn: spawn, showState: showState, moveWithPattern: moveWithPattern })=>{
        const heli = existing && (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("IntroHeliBackground").get(0) || spawn("IntroHeliBackground", {
            location: {
                rx: -0.3,
                ry: 0.3
            },
            z: -300,
            defaultVelocity: 70
        });
        showState(heli, "flying");
        const movement = moveWithPattern(heli, "intro.HeliBackground");
        await movement.process;
    };
const $f31ab0b95f1c79d7$export$b74d0a0ace536c37 = ({ existing: existing = false } = {}, heliAudio)=>async ({ spawn: spawn, showState: showState, allowDamage: allowDamage, moveWithPattern: moveWithPattern, waitForEvent: waitForEvent, moveTo: moveTo, wait: wait })=>{
        const heli = existing && (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("IntroHeliBackground").get(0) || spawn("IntroHeliBackground", {
            location: {
                rx: -0.3,
                ry: 0.3
            },
            z: -300,
            defaultVelocity: 70
        });
        showState(heli, "flying");
        let heliFleeing;
        waitForEvent(heli, "Dead", async ()=>{
            showState(heli, "shot");
            const movement = moveWithPattern(heli, "intro.HeliBackgroundCrash", 150, (0, $21d6fb1fc143defa$export$f590991ffe484603));
            heliFleeing = movement.process;
        });
        waitForEvent(heli, "Escape1", async ()=>{
            const soldier = spawn("IntroParachute", {
                x: heli.x + 10,
                y: heli.y,
                z: -290,
                defaultVelocity: 20
            });
            const parachuteDrop = moveTo(soldier, {
                y: 0.6,
                x: 0.2
            }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
            await parachuteDrop.process;
            soldier.destroy();
        });
        waitForEvent(heli, "Escape2", async ()=>{
            const soldier = spawn("IntroParachute", {
                x: heli.x + 10,
                y: heli.y,
                z: -290,
                defaultVelocity: 20
            });
            const parachuteDrop = moveTo(soldier, {
                y: 0.6,
                x: 0.2
            }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
            await parachuteDrop.process;
            soldier.destroy();
        });
        waitForEvent(heli, "Escape3", async ()=>{
            heliAudio.setVolume(0, 4000);
            await wait(4000);
            heliAudio.stop();
        });
        const drone = existing && (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("LargeBackgroundDrone").get(0) || spawn("LargeBackgroundDrone", {
            location: {
                rx: 1.1,
                ry: 0.3
            },
            z: -280,
            defaultVelocity: 200
        });
        showState(drone, "eyeMove");
        await allowDamage(heli, {
            health: 10
        });
        const movement = moveWithPattern(drone, "intro.DroneBackground");
        await movement.process;
        await wait(100);
        await heliFleeing;
        heli.destroy();
        drone.destroy();
    };





const $6f2c5b88e67b3d06$var$Component = "Buffs";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($6f2c5b88e67b3d06$var$Component, {
    init () {
        this.buffs = {};
    },
    /*
   * {
   *   cost: { energy: 100 },
   *   duration: 1, // seconds
   *   cooldown: 0.8 // seconds
   * }
   */ defineBuff (name, settings) {
        const existingBuff = this.buffs[name];
        this.buffs[name] = {
            activeLeft: 0,
            cooldown: 0,
            ...existingBuff,
            settings: settings
        };
    },
    buffStatus (name) {
        return this.buffs[name];
    },
    buffActive (name) {
        return this.buffs[name].activeLeft > 0;
    },
    canActivateBuff (name) {
        const buff = this.buffs[name];
        if (!buff) return false;
        if (buff.cooldown > 0) return false;
        if (buff.activeLeft > 0) return false;
        const cost = buff.settings.cost;
        const canPay = Object.entries(cost).every(([key, amount])=>this[key] >= amount);
        if (!canPay) return false;
        return true;
    },
    activateBuff (name) {
        const buff = this.buffs[name];
        if (!this.canActivateBuff(name)) return false;
        const cost = buff.settings.cost;
        // Pay costs
        Object.entries(cost).every(([key, amount])=>this[key] -= amount);
        this.buffs[name].activeLeft = buff.settings.duration * 1000;
        this.trigger("BuffActivated", name);
        this.uniqueBind("GameLoop", this._handleBuffs);
    },
    _handleBuffs ({ dt: dt }) {
        let buffsHandled = 0;
        Object.entries(this.buffs).every(([name, data])=>{
            if (data.activeLeft > 0) {
                buffsHandled++;
                data.activeLeft = Math.max(data.activeLeft - dt, 0);
                if (data.activeLeft === 0) {
                    data.cooldown = data.settings.cooldown * 1000;
                    this.trigger("BuffEnded", name);
                }
            } else if (data.cooldown > 0) {
                buffsHandled++;
                data.cooldown = Math.max(data.cooldown - dt, 0);
                if (data.cooldown === 0) this.trigger("CooldownEnded", name);
            }
        });
        if (buffsHandled === 0) this.unbind("GameLoop", this._handleBuffs);
    }
});
var $6f2c5b88e67b3d06$export$2e2bcd8739ae039 = $6f2c5b88e67b3d06$var$Component;




const $d4d09ab16657da00$export$cf44734282cd539 = ({ existing: existing = false, hasLaser: hasLaser = false, turned: turned = false } = {})=>async ({ spawn: spawn, exec: exec, waitForEvent: waitForEvent, allowDamage: allowDamage, setHealthbar: setHealthbar, setEnergybar: setEnergybar, showState: showState, setGameSpeed: setGameSpeed, addScreenTrauma: addScreenTrauma, playerHit: playerHit, wait: wait, loseLife: loseLife })=>{
        const maxHealth = 50;
        const maxEnergy = 100;
        const player = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Player").get(0);
        const existingShip = existing && (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("PlayerShip").get(0);
        if (existingShip && existingShip.has((0, $98f23f39d831b128$export$2e2bcd8739ae039))) return;
        const ship = existingShip || spawn("PlayerShip", {
            location: {
                rx: turned ? 0.8 : 0.2,
                ry: 0.5
            },
            defaultVelocity: 400
        });
        if (!player.invincible) {
            if (ship === existingShip) {
                await allowDamage(ship, {
                    health: ship.health || maxHealth
                });
                ship.energy = ship.energy || 0;
            } else {
                ship.health = ship.health || maxHealth;
                ship.energy = 0;
                wait(2000).then(async ()=>{
                    await allowDamage(ship, {});
                });
            }
        }
        if (hasLaser) ship.hasLaser = true;
        if (ship.health < maxHealth * 0.5) ship.displayFrame("damaged");
        setHealthbar(ship.health / maxHealth);
        setEnergybar(ship.energy / maxEnergy);
        if (turned) await showState(ship, "turned");
        showState(ship, "flying");
        // TODO: Refactor adding these components to the entity definition
        ship.addComponent((0, $98f23f39d831b128$export$2e2bcd8739ae039), (0, $5cbb878e064c643c$export$2e2bcd8739ae039), (0, $6f2c5b88e67b3d06$export$2e2bcd8739ae039));
        if (player.has((0, $f62344210ab4fe80$export$2e2bcd8739ae039))) player.assignControls(ship);
        ship.defineBuff("overdrive", {
            cost: {
                energy: 25
            },
            duration: 3,
            cooldown: 3 // seconds
        });
        // showBuff(0, ship, "overdrive", ship.controlName("power1", true));
        ship.uniqueBind("ButtonPressed", (name)=>{
            if (name === "fire") {
                ship.showState("noLaserShooting");
                ship.showState("shooting");
            }
            if (name === "heavy") {
                if (!ship.hasLaser) return;
                ship.showState("noShooting");
                ship.showState("laserShooting");
            }
            if (name === "power1") {
                ship.activateBuff("overdrive");
                ship.trigger("EnergyUpdate");
                setEnergybar(ship.energy / maxEnergy);
            }
        });
        ship.uniqueBind("ButtonReleased", (name)=>{
            if (name === "fire") ship.showState("noShooting");
            if (name === "heavy") ship.showState("noLaserShooting");
        });
        // ship.uniqueBind("BuffActivated", name => {
        //   if (name === "overdrive") {
        //     ship.mainWeapon.difficulty = 0.5;
        //     ship.laserWeapon.difficulty = 0.5;
        //   }
        // });
        // ship.uniqueBind("BuffEnded", name => {
        //   if (name === "overdrive") {
        //     ship.mainWeapon.difficulty = 0.0;
        //     ship.laserWeapon.difficulty = 0.0;
        //   }
        // });
        ship.uniqueBind("DealtDamage", ({ damage: damage })=>{
            if (damage[0].name === "Bullet" && !ship.buffActive("overdrive")) {
                ship.energy = Math.min(maxEnergy, ship.energy + 1);
                ship.trigger("EnergyUpdate");
                setEnergybar(ship.energy / maxEnergy);
            }
        });
        ship.uniqueBind("HealthChange", (newHealth)=>{
            if (newHealth < ship.health) playerHit(newHealth - ship.health);
            try {
                setHealthbar(newHealth / maxHealth);
            } catch (e) {
            // player could be game over
            }
            if (newHealth < maxHealth * 0.5) {
                if (ship.appliedEntityState !== "dead") ship.displayFrame("damaged");
            }
        });
        ship.uniqueBind("turn", ()=>{
            if (ship.health < maxHealth * 0.5) showState(ship, "turningDamaged");
            else showState(ship, "turning");
        });
        waitForEvent(ship, "Dead", async ()=>{
            ship.attr({
                disableControls: true,
                vx: 0,
                vy: 0
            });
            addScreenTrauma(0.8);
            setGameSpeed(0.4);
            const state = showState(ship, "dead");
            await wait(150);
            setGameSpeed(0.7);
            await wait(600);
            addScreenTrauma(0.5);
            await state;
            const isTurned = !!ship.xFlipped;
            const hasLaser = ship.hasLaser;
            ship.destroy();
            await loseLife();
            setGameSpeed(1.0);
            await wait(1000);
            exec($d4d09ab16657da00$export$cf44734282cd539({
                turned: isTurned,
                hasLaser: hasLaser
            }));
        });
    };








const $47fe34e09c439dce$var$CHAR_WIDTH = 10;
const $47fe34e09c439dce$var$CHAR_HEIGHT = 16;
const $47fe34e09c439dce$export$91d88f71a134afea = (speaker, text, { portrait: portrait = null } = {})=>new Promise((resolve)=>{
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Dialog").each(function() {
            this.trigger("Abort");
            this.destroy();
        });
        const x = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width * 0.15;
        const w = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width * 0.7;
        const bottom = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height - 20;
        const back = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("UILayerWebGL, 2D, Color, Tween, Dialog").attr({
            w: w,
            h: 15,
            alpha: 0
        }).color("#000000").attr({
            x: x - 10,
            y: bottom + 50,
            z: 100
        });
        back.bind("Abort", resolve);
        let avatarOffset = 0;
        const portraitDef = portrait && (0, $4a464ac9ac54fc86$export$80766d2842af6389)(portrait);
        let portraitEntity = null;
        if (portraitDef) {
            portraitEntity = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e([
                "UILayerWebGL",
                "2D",
                (0, $5fd20eb0995a8d9f$export$2e2bcd8739ae039),
                "Dialog"
            ].join(", ")).attr({
                x: 0,
                y: 0,
                w: 40,
                h: 40
            }).compose(portraitDef, {
                autoStartAnimation: false
            });
            avatarOffset = portraitEntity.w + 10;
            portraitEntity.attr({
                x: back.x + 5,
                y: back.y + back.h - portraitEntity.h,
                z: back.z + 1
            });
        }
        const words = text.split(/\s+/g);
        const lineWidth = w - 10 - avatarOffset;
        const charLimit = Math.floor(lineWidth / $47fe34e09c439dce$var$CHAR_WIDTH);
        const lines = words.reduce(([current, ...lines], word)=>{
            const fitsOnLine = current.endsWith(".") ? false : word.length + 1 + current.length < charLimit;
            return fitsOnLine ? [
                `${current} ${word}`.trim(),
                ...lines
            ] : [
                word,
                current,
                ...lines
            ];
        }, [
            ""
        ]).reverse();
        const h = Math.max(4, lines.length + 1 + (speaker ? 2 : 0));
        back.attr({
            h: h * $47fe34e09c439dce$var$CHAR_HEIGHT
        });
        if (portraitEntity) {
            portraitEntity.attr({
                y: back.y + back.h - portraitEntity.h
            });
            back.attach(portraitEntity);
        }
        back.tween({
            y: bottom - h * $47fe34e09c439dce$var$CHAR_HEIGHT,
            alpha: 0.8
        }, 200);
        let offset = 15;
        if (speaker) {
            const speakerText = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("UILayerDOM, 2D, Text").attr({
                w: w - 20,
                x: back.x + 10 + avatarOffset,
                y: back.y + 10,
                z: 101,
                alpha: 1
            }).text(speaker).textColor("#707070").textFont({
                size: `${$47fe34e09c439dce$var$CHAR_WIDTH}px`,
                weight: "bold",
                family: "Press Start 2P"
            });
            back.attach(speakerText);
            offset = 30;
        }
        lines.forEach((line, i)=>{
            back.attach((0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("UILayerDOM, 2D, Text").attr({
                w: w - 20,
                x: back.x + 10 + avatarOffset,
                y: back.y + offset + i * 20,
                z: 101
            }).text(line).textColor("#909090").textFont({
                size: `${$47fe34e09c439dce$var$CHAR_WIDTH}px`,
                weight: "bold",
                family: "Press Start 2P"
            }));
        });
        const wordCount = lines.join(" ").split(" ").length;
        const repeats = lines.length + Math.ceil(wordCount * (0, (/*@__PURE__*/$parcel$interopDefault($fbd39d42b4ec86c5$exports))).wordDelay);
        let i = 0;
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Dialog, Delay").delay(function() {
            i++;
            if (portraitEntity) {
                if (i === repeats) {
                    portraitEntity.stopAnimation();
                    portraitEntity.displayFrame("idle");
                } else portraitEntity.playAnimation("talking");
            }
        }, 1000, repeats, function() {
            back.one("TweenEnd", ()=>{
                (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Dialog").each(function() {
                    this.destroy();
                });
                resolve(undefined);
            });
            back.tween({
                y: bottom + 50,
                alpha: 0
            }, 200);
        });
    });



const $db4356a818946794$export$5ea287dbb5709644 = async ({ wait: wait })=>{
    const checkpoint = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Checkpoint", {
        color: "#FFFFFF"
    });
    await checkpoint.show();
    await wait(500);
    checkpoint.fadeOut(1000).then(()=>checkpoint.remove());
};



const $c09c668b8e556ce5$var$handleBox = (box)=>async ({ showState: showState, allowDamage: allowDamage, waitForEvent: waitForEvent, call: call, awardPoints: awardPoints })=>{
        await allowDamage(box, {
            health: 30
        });
        waitForEvent(box, "Dead", async ()=>{
            awardPoints(25, box.x, box.y);
            showState(box, "falling");
            await call(box.activateGravity, "GravityLiquid");
        });
    };
const $c09c668b8e556ce5$var$part = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, setBackground: setBackground, playAnimation: playAnimation, setAltitude: setAltitude, showHUD: showHUD, parallel: parallel, exec: exec, onScriptClose: onScriptClose, fadeIn: fadeIn, wait: wait })=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects",
        "hero"
    ]);
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("hero");
    const heliAudio = (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("helicopter", {
        volume: 0
    });
    onScriptClose(()=>{
        heliAudio.stop();
    });
    await setScrollingSpeed(150, 0, {
        instant: true
    });
    await setScenery("city.Ocean");
    setBackground("city.Sunrise", 0, 2);
    const fade = fadeIn();
    text.remove();
    const introAnimation = playAnimation("city.Intro");
    const introShip = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("IntroShip").get(0);
    exec($c09c668b8e556ce5$var$handleBox(introShip.boxLocation1));
    exec($c09c668b8e556ce5$var$handleBox(introShip.boxLocation2));
    await fade.start(1000);
    await parallel([
        ()=>(0, $47fe34e09c439dce$export$91d88f71a134afea)("General", "Let us escort you to the factory to install\nthe AI controlled defence systems. You are the last ship.", {
                portrait: "portraits.general"
            }),
        async ()=>{
            await introAnimation.waitTillCheckpoint(1);
            heliAudio.setVolume(2.0, 1500);
        },
        async ()=>{
            await introAnimation.waitTillCheckpoint(3);
            heliAudio.setVolume(0.6, 3000);
            exec((0, $d4d09ab16657da00$export$cf44734282cd539)({
                existing: true
            }));
        }
    ]);
    showHUD();
    const ready = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Get ready", {
        color: "#FF0000"
    });
    const blink = ready.blink(200, 4);
    let helicopter;
    setScrollingSpeed(350, 0);
    await parallel([
        async ()=>{
            await introAnimation.waitTillEnd();
        },
        async ()=>{
            await blink;
            await ready.zoomOut(500);
            ready.remove();
            helicopter = exec((0, $f31ab0b95f1c79d7$export$d63bcbe667aaeac3)({
                existing: true
            }));
            await parallel([
                async ()=>{
                    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("General", "We send some drones for some last manual target practice", {
                        portrait: "portraits.general"
                    });
                    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("John", "Let's go!", {
                        portrait: "portraits.pilot"
                    });
                },
                async ()=>{
                    await parallel([
                        ()=>exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(2, "drone.straight", {
                                delay: 300,
                                yOffset: 0.1
                            })),
                        async ()=>{
                            await wait(1500);
                            await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(2, "drone.straight", {
                                delay: 300,
                                yOffset: -0.1
                            }));
                        },
                        async ()=>{
                            await wait(3000);
                            await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(2, "drone.straight", {
                                delay: 300,
                                yOffset: -0.3
                            }));
                        }
                    ]);
                    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(5, "drone.pattern1"));
                    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(8, "drone.pattern2"));
                }
            ]);
        }
    ]);
    introAnimation.destroy();
    setAltitude(200);
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(5, "drone.pattern1"));
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(8, "drone.pattern2"));
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("John", "Well that was fun. I will miss the manual mode..", {
        portrait: "portraits.pilot"
    });
    await helicopter;
    exec((0, $f31ab0b95f1c79d7$export$b74d0a0ace536c37)({
        existing: true
    }, heliAudio));
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("General", "What is that! Evacuate!\nNow!", {
        portrait: "portraits.general"
    });
    await wait(1000);
    const chapter1 = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Hacked", {
        color: "#FFFFFF",
        sup: "Chapter 1:"
    });
    await parallel([
        ()=>(0, $47fe34e09c439dce$export$91d88f71a134afea)("General", "The helicopter is out of control!", {
                portrait: "portraits.general"
            }),
        async ()=>{
            await wait(2000);
            await chapter1.fadeIn(500);
            await wait(2000);
            await chapter1.fadeOut(500);
        }
    ]);
    chapter1.remove();
    await parallel([
        ()=>exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(5, "drone.pattern3")),
        ()=>exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(5, "drone.pattern4"))
    ]);
    await exec((0, $db4356a818946794$export$5ea287dbb5709644));
};
var $c09c668b8e556ce5$export$2e2bcd8739ae039 = $c09c668b8e556ce5$var$part;



const $ebe5ce3265183e05$export$47d2969c031985aa = (pattern, repeatPattern)=>async ({ spawn: spawn, call: call, waitForEvent: waitForEvent, wait: wait, until: until, allowDamage: allowDamage, moveWithPattern: moveWithPattern, awardPoints: awardPoints, showState: showState })=>{
        const heli = spawn("Helicopter", {
            location: {
                rx: 1.1,
                ry: 0.5
            },
            defaultVelocity: 100
        });
        heli.addCollisionComponent("SolidCollision").addCollisionComponent("PlayerEnemy");
        const maxHealth = 900;
        await allowDamage(heli, {
            health: maxHealth
        });
        const heliAudio = (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("helicopter", {
            volume: 0.01
        });
        heliAudio.setVolume(2.0, 2000);
        await wait(2000);
        showState(heli, "shooting");
        let movement = moveWithPattern(heli, pattern);
        heli.uniqueBind("HealthChange", (newHealth)=>{
            if (newHealth < maxHealth * 0.5) {
                if (heli.appliedEntityState !== "dead") showState(heli, "fire");
            }
        });
        const killed = waitForEvent(heli, "Dead", async ()=>{
            movement.abort();
            heliAudio.stop();
            awardPoints(250, heli.x + 20, heli.y);
            await showState(heli, "dead");
            await call(heli.activateGravity);
        });
        waitForEvent(heli, "Remove", async ()=>{
            heliAudio.stop();
        });
        await movement.process;
        await until(()=>killed, async ()=>{
            if (heli.appliedEntityState === "dead") return wait(500);
            movement = moveWithPattern(heli, repeatPattern, 150);
            await movement.process;
        });
    };




const $65d3be0ce1e0394a$var$handleBox = (box)=>async ({ showState: showState, allowDamage: allowDamage, waitForEvent: waitForEvent, call: call, awardPoints: awardPoints })=>{
        await allowDamage(box, {
            health: 30
        });
        waitForEvent(box, "Dead", async ()=>{
            awardPoints(25, box.x, box.y);
            showState(box, "falling");
            await call(box.activateGravity, "GravityLiquid");
        });
    };
const $65d3be0ce1e0394a$export$be16cb16dfc1c8e2 = ()=>async ({ spawn: spawn, waitForEvent: waitForEvent, until: until, parallel: parallel, wait: wait, awardPoints: awardPoints, showState: showState, allowDamage: allowDamage, exec: exec, moveTo: moveTo })=>{
        let activeMovement = null;
        const ship = spawn("DroneShip", {
            location: {
                rx: 1.1,
                ry: 0.7
            },
            defaultVelocity: 150
        });
        exec($65d3be0ce1e0394a$var$handleBox(ship.boxLocation1));
        showState(ship, "activateGun");
        ship.gun.addCollisionComponent("SolidCollision").addCollisionComponent("PlayerEnemy");
        const gun = waitForEvent(ship.gun, "Dead", async ()=>{
            awardPoints(200, ship.gun.x + 20, ship.gun.y);
            showState(ship.gun, "dead");
            ship.gun.clearCollisionComponents();
        });
        await allowDamage(ship.gun, {
            health: 600
        });
        activeMovement = moveTo(ship, {
            x: 0.5
        }, null, (0, $21d6fb1fc143defa$export$7c0c5615d5b4a96b));
        ship.radar.addCollisionComponent("SolidCollision");
        let radarDestroyed = false;
        const radarKilled = waitForEvent(ship.radar, "Dead", async ()=>{
            radarDestroyed = true;
            awardPoints(100, ship.radar.x + 20, ship.radar.y);
            showState(ship.radar, "dead");
            ship.radar.clearCollisionComponents();
        });
        showState(ship, "radarPulse");
        await allowDamage(ship.radar, {
            health: 300
        });
        await activeMovement.process;
        activeMovement = moveTo(ship, {
            x: -0.8
        }, null, (0, $21d6fb1fc143defa$export$f590991ffe484603));
        activeMovement.process.then(()=>ship.destroy());
        let points = 10;
        await parallel([
            ()=>until(()=>radarKilled, async ({ exec: exec })=>{
                    if (radarDestroyed) {
                        await wait(1500);
                        return;
                    }
                    exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(2, "drone.pattern2", {
                        points: points
                    }));
                    points = points > 0 ? points - 5 : 0;
                    await wait(1500);
                }),
            ()=>gun
        ]);
    };







const $14b0249e47534687$var$synchroniser = ()=>{
    let listeners = 0;
    let completed = [];
    let promises = [];
    let id = 0;
    let started = false;
    return {
        addSynchronisation: ()=>{
            if (started) throw new Error("Synchronisation already started");
            listeners++;
            const listenerId = ++id;
            let resolver = null;
            const promise = new Promise((res)=>resolver = res);
            promises.push(promise);
            return async ()=>{
                started = true;
                if (completed.find((i)=>i === listenerId) === undefined) {
                    completed.push(listenerId);
                    resolver();
                }
                return Promise.allSettled(promises);
            };
        },
        get listeners () {
            return listeners;
        },
        get completed () {
            return completed.length;
        }
    };
};
var $14b0249e47534687$export$2e2bcd8739ae039 = $14b0249e47534687$var$synchroniser;



const $01d8d7bff7d89754$var$mineFlight = (index, start, coord, synchronize, moveDelay = 0)=>async ({ spawn: spawn, wait: wait, addScreenTrauma: addScreenTrauma, waitForEvent: waitForEvent, race: race, showState: showState, allowDamage: allowDamage, awardPoints: awardPoints, moveTo: moveTo })=>{
        let activeMovement = null;
        await wait(index * 50);
        const mine = spawn("Mine", {
            location: {
                rx: start.x,
                ry: start.y > 1 ? 0.9 : start.y
            },
            defaultVelocity: 200
        });
        if (start.y > 1) {
            activeMovement = moveTo(mine, {
                y: start.y
            }, null, (0, $21d6fb1fc143defa$export$7c0c5615d5b4a96b));
            await activeMovement.process;
        }
        await showState(mine, "rotate");
        await allowDamage(mine, {
            health: 40
        });
        activeMovement = moveTo(mine, {
            x: coord.x
        }, null, (0, $21d6fb1fc143defa$export$7c0c5615d5b4a96b));
        await race([
            ()=>waitForEvent(mine, "Dead", async ()=>{
                    activeMovement && activeMovement.abort();
                    synchronize();
                    if (mine.appliedEntityState === "explode") return;
                    awardPoints(100, mine.x, mine.y);
                    showState(mine, "dead");
                    addScreenTrauma(0.3);
                    await wait(500);
                    mine.destroy();
                    activeMovement && activeMovement.abort();
                }),
            async ()=>{
                await activeMovement.process;
                if (!activeMovement.wasCompleted()) return;
                await synchronize();
                await wait(moveDelay);
                if (mine.appliedEntityState === "dead") return;
                activeMovement = moveTo(mine, {
                    y: coord.y
                }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
                await activeMovement.process;
                if (!activeMovement.wasCompleted()) return;
                await wait(200 + Math.random() * 2000);
                await showState(mine, "open", 500);
                if (mine.appliedEntityState === "dead") return;
                showState(mine, "blinking");
                await wait(1000);
                if (mine.appliedEntityState === "dead") return;
                showState(mine, "explode");
                addScreenTrauma(0.3);
                await wait(500);
                mine.destroy();
            }
        ]);
    };
const $01d8d7bff7d89754$export$3b7b87c9ef4aa570 = ()=>async ({ exec: exec })=>{
        const amount = 6;
        const coords = [
            {
                x: 0.3,
                y: 0.8
            },
            {
                x: 0.5,
                y: 0.2
            },
            {
                x: 0.5,
                y: 0.4
            },
            {
                x: 0.9,
                y: 0.2
            },
            {
                x: 0.9,
                y: 0.4
            },
            {
                x: 0.9,
                y: 0.8
            }
        ];
        const synchSpace = (0, $14b0249e47534687$export$2e2bcd8739ae039)();
        const items = Array(amount).fill(null).map(async (_, index)=>{
            const mineSync = synchSpace.addSynchronisation();
            await exec($01d8d7bff7d89754$var$mineFlight(index, {
                x: 1.2,
                y: 1.1
            }, coords[index], mineSync));
        });
        await Promise.all(items);
    };
const $01d8d7bff7d89754$var$battleShipMineStrike = (index, start, coord)=>async ({ spawn: spawn, wait: wait, addScreenTrauma: addScreenTrauma, waitForEvent: waitForEvent, race: race, allowDamage: allowDamage, showState: showState, moveTo: moveTo })=>{
        let activeMovement = null;
        await wait(index * 50);
        const mine = spawn("Mine", {
            location: {
                rx: start.x,
                ry: start.y > 1 ? 0.9 : start.y
            },
            defaultVelocity: 200
        });
        await showState(mine, "rotate");
        await allowDamage(mine, {
            health: 40
        });
        showState(mine, "blinking");
        await wait(2000);
        await race([
            ()=>waitForEvent(mine, "Dead", async ()=>{
                    activeMovement && activeMovement.abort();
                    if (mine.appliedEntityState === "explode") return;
                    showState(mine, "dead");
                    addScreenTrauma(0.3);
                    await wait(1000);
                    mine.destroy();
                    activeMovement && activeMovement.abort();
                }),
            async ()=>{
                if (mine.appliedEntityState === "dead") return;
                activeMovement = moveTo(mine, {
                    y: coord.y
                }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
                await activeMovement.process;
                if (activeMovement.wasCompleted()) {
                    await showState(mine, "open", 500);
                    if (mine.appliedEntityState !== "dead") {
                        showState(mine, "dead");
                        addScreenTrauma(0.3);
                        await wait(1000);
                        mine.destroy();
                    }
                }
            }
        ]);
    };
const $01d8d7bff7d89754$export$7fdd94ec6d33a6cb = ()=>async ({ exec: exec })=>{
        const amount = 9;
        const gridX = [
            0.05,
            0.14,
            0.27,
            0.36,
            0.45,
            0.54,
            0.63,
            0.77,
            0.86
        ];
        const gridY = [
            0.25,
            0.3,
            0.4,
            0.6
        ];
        const yCoord = (0, (/*@__PURE__*/$parcel$interopDefault($c3d59194625b5f14$exports)))(gridY);
        const items = Array(amount).fill().map(async (_, index)=>{
            await exec($01d8d7bff7d89754$var$battleShipMineStrike(index, {
                x: gridX[index],
                y: 0.88
            }, {
                x: gridX[index],
                y: yCoord[index % yCoord.length]
            }));
        });
        await Promise.all(items);
    };



const $b81cf2b6f0b73d31$var$part = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, wait: wait, setAltitude: setAltitude, setBackground: setBackground, parallel: parallel, showHUD: showHUD, exec: exec })=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects",
        "hero"
    ]);
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("hero");
    await setScrollingSpeed(350, 0, {
        instant: true
    });
    setAltitude(200, {
        instant: true
    });
    setBackground("city.Sunrise", 1, 2);
    await setScenery("city.Ocean");
    showHUD();
    text.remove();
    exec((0, $d4d09ab16657da00$export$cf44734282cd539)({
        existing: true
    }));
    await parallel([
        async ()=>{
            await wait(2000);
            await setAltitude(0);
        },
        ()=>exec((0, $ebe5ce3265183e05$export$47d2969c031985aa)("heli.pattern1", "heli.repeat1"))
    ]);
    await parallel([
        ()=>exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.pattern6")),
        async ()=>{
            await wait(2000);
            await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.pattern6", {
                yOffset: 0.2
            }));
        },
        async ()=>{
            await wait(4000);
            await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.pattern6", {
                yOffset: 0.4
            }));
        }
    ]);
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.pattern5"));
    await exec((0, $65d3be0ce1e0394a$export$be16cb16dfc1c8e2)());
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.pattern1"));
    await exec((0, $01d8d7bff7d89754$export$3b7b87c9ef4aa570)());
    await setScenery("city.CoastStart");
    await exec((0, $01d8d7bff7d89754$export$3b7b87c9ef4aa570)());
    await parallel([
        ()=>exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.pattern6")),
        async ()=>{
            await wait(2000);
            await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.pattern6", {
                yOffset: 0.2
            }));
        },
        async ()=>{
            await wait(4000);
            await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.pattern6", {
                yOffset: 0.4
            }));
        }
    ]);
    await exec((0, $65d3be0ce1e0394a$export$be16cb16dfc1c8e2)());
    await exec((0, $db4356a818946794$export$5ea287dbb5709644));
};
var $b81cf2b6f0b73d31$export$2e2bcd8739ae039 = $b81cf2b6f0b73d31$var$part;









const $2f74612bff91d75e$var$shootMineCannon = (cannon, high)=>async ({ spawn: spawn, moveWithPattern: moveWithPattern, moveTo: moveTo, addScreenTrauma: addScreenTrauma, wait: wait, waitForEvent: waitForEvent, showState: showState, allowDamage: allowDamage, race: race })=>{
        await showState(cannon, high ? "aimHigh" : "aimLow");
        const spawnPoint = cannon.currentAttachHooks.gun;
        if (!cannon.hasHealth()) return;
        const mine = spawn("Mine", {
            location: {
                x: spawnPoint.x,
                y: spawnPoint.y
            },
            defaultVelocity: 350
        }).attr({
            z: spawnPoint.z
        });
        waitForEvent(mine, "Loose", async ()=>{
            mine.attr({
                z: mine.z + 30
            });
        });
        const movement = moveWithPattern(mine, high ? "mineCannon.highShot" : "mineCannon.lowShot", null, (0, $21d6fb1fc143defa$export$7c0c5615d5b4a96b));
        await showState(cannon, "shoot");
        movement.process.then(async ()=>{
            await allowDamage(mine, {
                health: 40
            });
            const ship = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("PlayerShip").get(0);
            let searchMovement;
            searchMovement = moveTo(mine, {
                y: 1
            });
            await searchMovement.process;
            searchMovement = moveTo(mine, {
                x: ship.x / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width
            });
            await searchMovement.process;
            searchMovement = moveTo(mine, {
                y: ship.y / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height
            });
            await race([
                ()=>waitForEvent(mine, "Dead", async ()=>{
                        searchMovement && searchMovement.abort();
                        if (mine.appliedEntityState === "explode") return;
                        showState(mine, "dead");
                        addScreenTrauma(0.3);
                        await wait(1000);
                        mine.destroy();
                        searchMovement && searchMovement.abort();
                    }),
                async ()=>{
                    await searchMovement.process;
                    if (searchMovement.wasCompleted()) {
                        if (mine.appliedEntityState === "dead") return;
                        await showState(mine, "open", 500);
                        showState(mine, "blinking");
                        await wait(1000);
                        if (mine.appliedEntityState !== "dead") {
                            showState(mine, "explode");
                            addScreenTrauma(0.3);
                            await wait(1000);
                            mine.destroy();
                        }
                    }
                }
            ]);
        });
    };
const $2f74612bff91d75e$var$activateGun = (gun)=>async ({ awardPoints: awardPoints, showState: showState, waitForEvent: waitForEvent, allowDamage: allowDamage })=>{
        const gunKilled = waitForEvent(gun, "Dead", async ()=>{
            awardPoints(200, gun.x + 20, gun.y);
            showState(gun, "dead");
            gun.clearCollisionComponents();
        });
        gun.addCollisionComponent("SolidCollision").addCollisionComponent("PlayerEnemy");
        allowDamage(gun, {
            health: 750
        });
        showState(gun, "shooting");
        await gunKilled;
    };
const $2f74612bff91d75e$var$part1 = (ship)=>async ({ showState: showState, waitForEvent: waitForEvent, allowDamage: allowDamage, race: race, awardPoints: awardPoints, until: until })=>{
        const mineCannon = ship.mineCannon;
        mineCannon.addCollisionComponent("SolidCollision").addCollisionComponent("PlayerEnemy");
        const killed = waitForEvent(mineCannon, "Dead", async ()=>{
            awardPoints(250, mineCannon.x, mineCannon.y);
            showState(mineCannon, "dead");
            mineCannon.clearCollisionComponents();
        });
        await race([
            async ()=>{
                await allowDamage(mineCannon, {
                    health: 1200
                });
                let high = true;
                await until(()=>killed, async ({ exec: exec })=>{
                    await exec($2f74612bff91d75e$var$shootMineCannon(mineCannon, high));
                    high = !high;
                });
            },
            ()=>killed
        ]);
    };
const $2f74612bff91d75e$var$part2 = (ship)=>async ({ exec: exec, waitForEvent: waitForEvent, parallel: parallel, until: until, showState: showState, awardPoints: awardPoints, allowDamage: allowDamage, wait: wait })=>{
        const radar = ship.cabin1.radar;
        radar.addCollisionComponent("SolidCollision");
        showState(radar, "pulse");
        await allowDamage(radar, {
            health: 500
        });
        let points = 10;
        await parallel([
            ()=>until(()=>waitForEvent(radar, "Dead", async ()=>{
                        awardPoints(100, radar.x + 20, radar.y);
                        showState(radar, "dead");
                        radar.clearCollisionComponents();
                    }), async ({ exec: exec })=>{
                    exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(2, "drone.pattern2", {
                        points: points
                    }));
                    points = points > 0 ? points - 5 : 0;
                    await wait(2000);
                }),
            ()=>exec($2f74612bff91d75e$var$activateGun(ship.deckGun1))
        ]);
    };
const $2f74612bff91d75e$var$mineAttack = (ship)=>async ({ wait: wait, showState: showState, moveTo: moveTo, exec: exec, parallel: parallel })=>{
        await parallel([
            ()=>{
                const upwards = moveTo(ship, {
                    y: 0.65
                }, 20, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
                return upwards.process;
            },
            ()=>showState(ship, "risen", 2000),
            async ()=>{
                await wait(1000);
                await exec((0, $01d8d7bff7d89754$export$7fdd94ec6d33a6cb)());
            }
        ]);
        await parallel([
            ()=>{
                const downwards = moveTo(ship, {
                    y: 0.7
                }, 20, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
                return downwards.process;
            },
            ()=>showState(ship, "lowered", 2000)
        ]);
    };
const $2f74612bff91d75e$var$helicopter1 = (ship)=>async ({ call: call, wait: wait, waitForEvent: waitForEvent, showState: showState, awardPoints: awardPoints, allowDamage: allowDamage, until: until, moveWithPattern: moveWithPattern })=>{
        const helicopter = ship.heliPlace1;
        const heliAudio = (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("helicopter", {
            volume: 0.01
        });
        heliAudio.setVolume(0.9, 1000);
        showState(helicopter, "flying");
        await wait(1000);
        await showState(helicopter, "tilted", 2000);
        let movement = moveWithPattern(helicopter, "heli.battleship1", 150, (0, $21d6fb1fc143defa$export$8244104593af74a6));
        waitForEvent(helicopter, "detach", async ()=>{
            helicopter.detachFromParent();
        });
        const maxHealth = 500;
        waitForEvent(helicopter, "active", async ()=>{
            helicopter.addCollisionComponent("SolidCollision").addCollisionComponent("PlayerEnemy");
            await allowDamage(helicopter, {
                health: maxHealth
            });
        });
        waitForEvent(helicopter, "Remove", async ()=>{
            heliAudio.stop();
        });
        helicopter.uniqueBind("HealthChange", (newHealth)=>{
            if (newHealth < maxHealth * 0.5) {
                if (helicopter.appliedEntityState !== "dead") showState(helicopter, "fire");
            }
        });
        const killed = waitForEvent(helicopter, "Dead", async ()=>{
            heliAudio.stop();
            helicopter.clearCollisionComponents();
            movement.abort();
            awardPoints(250, helicopter.x + 20, helicopter.y);
            await showState(helicopter, "dead");
            helicopter.z = ship.z + 5;
            await call(helicopter.activateGravity);
        });
        await movement.process;
        await until(()=>killed, async ()=>{
            if (helicopter.appliedEntityState === "dead") return wait(500);
            movement = moveWithPattern(helicopter, "heli.battleship2c", 150, (0, $21d6fb1fc143defa$export$8244104593af74a6));
            await movement.process;
        });
    };
const $2f74612bff91d75e$var$part3 = (ship)=>async ({ showState: showState, wait: wait, exec: exec, parallel: parallel })=>{
        await wait(1000);
        await parallel([
            async ()=>{
                await wait(1000);
                await exec($2f74612bff91d75e$var$activateGun(ship.deckGun2));
                await wait(1000);
                await showState(ship, "t3o", 2000);
                await showState(ship, "t3r", 2000);
                await exec($2f74612bff91d75e$var$activateGun(ship.hatch3.payload));
            },
            ()=>exec($2f74612bff91d75e$var$helicopter1(ship))
        ]);
        // Mines from below
        await exec($2f74612bff91d75e$var$mineAttack(ship));
        await parallel([
            async ()=>{
                await showState(ship, "t2o", 1000);
                await showState(ship, "t2r", 1000);
                await exec($2f74612bff91d75e$var$activateGun(ship.hatch2.payload));
            },
            async ()=>{
                await showState(ship, "t1o", 1000);
                await showState(ship, "t1r", 1000);
                await exec($2f74612bff91d75e$var$activateGun(ship.hatch1.payload));
            }
        ]);
        await exec($2f74612bff91d75e$var$mineAttack(ship));
    };
const $2f74612bff91d75e$var$helicopter2 = (ship)=>async ({ wait: wait, moveTo: moveTo, showState: showState, moveWithPattern: moveWithPattern, waitForEvent: waitForEvent, awardPoints: awardPoints, allowDamage: allowDamage, call: call, until: until })=>{
        const helicopter = ship.heliPlace2;
        const heliAudio = (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("helicopter", {
            volume: 0.01
        });
        heliAudio.setVolume(0.9, 1000);
        showState(helicopter, "flying");
        await wait(1000);
        await showState(helicopter, "tilted", 2000);
        let movement = moveWithPattern(helicopter, "heli.battleship2a", 150, (0, $21d6fb1fc143defa$export$8244104593af74a6));
        waitForEvent(helicopter, "detach", async ()=>{
            helicopter.detachFromParent();
        });
        const maxHealth = 500;
        waitForEvent(helicopter, "active", async ()=>{
            helicopter.addCollisionComponent("SolidCollision").addCollisionComponent("PlayerEnemy");
            await allowDamage(helicopter, {
                health: maxHealth
            });
        });
        waitForEvent(helicopter, "Remove", async ()=>{
            heliAudio.stop();
        });
        helicopter.uniqueBind("HealthChange", (newHealth)=>{
            if (newHealth < maxHealth * 0.5) {
                if (helicopter.appliedEntityState !== "dead") showState(helicopter, "fire");
            }
        });
        const killed = waitForEvent(helicopter, "Dead", async ()=>{
            heliAudio.stop();
            helicopter.clearCollisionComponents();
            movement.abort();
            awardPoints(250, helicopter.x + 20, helicopter.y);
            await showState(helicopter, "dead");
            await call(helicopter.activateGravity);
        });
        const shipMovement = waitForEvent(helicopter, "moveShip", async ()=>{
            const p = moveTo(ship, {
                x: -1
            }, 120, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
            await p.process;
        });
        await movement.process;
        movement = moveWithPattern(helicopter, "heli.battleship2b", 150, (0, $21d6fb1fc143defa$export$8244104593af74a6));
        await shipMovement;
        await movement.process;
        await until(()=>killed, async ()=>{
            if (helicopter.appliedEntityState === "dead") return wait(500);
            movement = moveWithPattern(helicopter, "heli.battleship2c", 150, (0, $21d6fb1fc143defa$export$8244104593af74a6));
            await movement.process;
        });
    };
const $2f74612bff91d75e$var$part5 = (ship)=>async ({ allowDamage: allowDamage, showState: showState, wait: wait, parallel: parallel, setScrollingSpeed: setScrollingSpeed, moveTo: moveTo, awardPoints: awardPoints, exec: exec, waitForEvent: waitForEvent })=>{
        await wait(2000);
        await showState(ship, "packageOpen", 1000, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
        await wait(1000);
        const laser = ship.deckGun3;
        await showState(laser, "open", 500, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
        const engineCore = ship.engineCore;
        engineCore.addComponent("SolidCollision");
        waitForEvent(engineCore, "Dead", async ()=>{
            engineCore.clearCollisionComponents();
            showState(ship, "engineTilt");
            waitForEvent(engineCore, "Dead", async ()=>{
                engineCore.clearCollisionComponents();
                // Add explosions and screenshakes
                awardPoints(500, engineCore.x + 20, engineCore.y);
                engineCore.removeComponent("SolidCollision");
                showState(ship.laserField, "stopped");
                allowDamage(laser, {
                    health: 500
                });
                ship.laserField.removeComponent("SolidCollision");
                showState(ship, "engineDestroyed");
            });
            await allowDamage(ship.engineCore, {
                health: 1000
            });
        });
        await allowDamage(ship.engineCore, {
            health: 500
        });
        laser.addCollisionComponent("SolidCollision");
        const killed = waitForEvent(laser, "Dead", async ()=>{
            laser.clearCollisionComponents();
            awardPoints(250, laser.x + 20, laser.y);
            showState(laser, "dead");
        });
        await allowDamage(laser, {
            health: 500
        });
        showState(laser, "shooting");
        await parallel([
            async ()=>{
                const playerShip = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("PlayerShip").get(0);
                playerShip.trigger("turn");
                await wait(1000);
                await showState(ship, "engineDoorOpen");
                setScrollingSpeed(-100, 0);
                const activeMovement = moveTo(ship, {
                    x: -0.9
                }, 85, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
                await activeMovement.process;
            },
            async ()=>{
                await killed;
                exec($2f74612bff91d75e$var$laserWeapon(laser.x + laser.w / 2, laser.y - laser.h));
            }
        ]);
    };
const $2f74612bff91d75e$var$extraLife = (x, y)=>async ({ allowDamage: allowDamage, showState: showState, waitForEvent: waitForEvent, wait: wait, spawn: spawn, gainLife: gainLife, moveWithPattern: moveWithPattern })=>{
        const extraLife = spawn("ExtraLife", {
            location: {
                x: x,
                y: y
            },
            defaultVelocity: 50
        });
        await allowDamage(extraLife, {
            health: 10
        });
        waitForEvent(extraLife, "Dead", async ()=>{
            gainLife();
            await showState(extraLife, "pickedUp");
            await wait(2000);
            extraLife.destroy();
        });
        const motion = moveWithPattern(extraLife, "powerup.circles");
        await motion.process;
        await showState(extraLife, "disappear", 1000);
        extraLife.destroy();
    };
const $2f74612bff91d75e$var$laserWeapon = (x, y)=>async ({ allowDamage: allowDamage, awardText: awardText, showState: showState, waitForEvent: waitForEvent, wait: wait, spawn: spawn, until: until })=>{
        const powerup = spawn("Upgrade", {
            location: {
                x: x,
                y: y
            },
            defaultVelocity: 50
        });
        await allowDamage(powerup, {
            health: 10
        });
        const pickedUp = waitForEvent(powerup, "Dead", async ()=>{
            const ship = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("PlayerShip").get(0);
            ship.hasLaser = true;
            awardText("Laser weapon", powerup.x, powerup.y);
            await showState(powerup, "pickedUp");
            await wait(2000);
            powerup.destroy();
            (0, $47fe34e09c439dce$export$91d88f71a134afea)(null, `You gained a new weapon! The LASER. Use the ${ship.controlName("heavy")} to shoot.`);
        });
        await until(()=>pickedUp, async ({ moveWithPattern: moveWithPattern })=>{
            const motion = moveWithPattern(powerup, "powerup.circles");
            await motion.process;
        });
        powerup.destroy();
    };
const $2f74612bff91d75e$var$part6 = (ship)=>async ({ allowDamage: allowDamage, showState: showState, waitForEvent: waitForEvent, awardPoints: awardPoints, addScreenTrauma: addScreenTrauma, exec: exec, wait: wait })=>{
        const cabin = ship.cabin1;
        cabin.addCollisionComponent("SolidCollision");
        const killed = waitForEvent(cabin, "Dead", async ()=>{
            awardPoints(2000, cabin.x + cabin.w / 2, cabin.y);
            showState(ship, "cabin1Explode");
            addScreenTrauma(0.5);
            await wait(2000);
            addScreenTrauma(0.5);
            cabin.clearCollisionComponents();
            showState(ship, "cabin1Smoke");
        });
        await allowDamage(cabin, {
            health: 500,
            bulletResistance: 0.99
        });
        await killed;
        cabin.removeComponent("SolidCollision");
        exec($2f74612bff91d75e$var$extraLife(cabin.x + cabin.w / 2, cabin.y - cabin.h));
    };
const $2f74612bff91d75e$var$part7 = (ship)=>async ({ allowDamage: allowDamage, showState: showState, addScreenTrauma: addScreenTrauma, waitForEvent: waitForEvent, awardPoints: awardPoints, wait: wait })=>{
        const cabin = ship.cabin2;
        cabin.addCollisionComponent("SolidCollision");
        const killed = waitForEvent(cabin, "Dead", async ()=>{
            awardPoints(2000, cabin.x + cabin.w / 2, cabin.y);
            showState(ship, "cabin2Explode");
            addScreenTrauma(0.5);
            await wait(2000);
            addScreenTrauma(0.5);
            cabin.clearCollisionComponents();
            showState(ship, "cabin2Smoke");
        });
        await allowDamage(cabin, {
            health: 500,
            bulletResistance: 0.99
        });
        await killed;
        cabin.removeComponent("SolidCollision");
    };
const $2f74612bff91d75e$var$handleBox = (box)=>async ({ showState: showState, allowDamage: allowDamage, waitForEvent: waitForEvent, call: call, awardPoints: awardPoints })=>{
        await allowDamage(box, {
            health: 30
        });
        waitForEvent(box, "Dead", async ()=>{
            awardPoints(25, box.x, box.y);
            showState(box, "falling");
            await call(box.activateGravity, "GravityLiquid");
        });
    };
const $2f74612bff91d75e$var$battleship = async ({ parallel: parallel, spawn: spawn, wait: wait, showState: showState, exec: exec, moveTo: moveTo, setBackgroundCheckpointLimit: setBackgroundCheckpointLimit, setScrollingSpeed: setScrollingSpeed })=>{
    let activeMovement;
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Warning!", {
        color: "#FF0000"
    });
    await parallel([
        ()=>text.blink(500, 4),
        ()=>setScrollingSpeed(150, 0),
        ()=>(0, $47fe34e09c439dce$export$91d88f71a134afea)("John", "Battleship approaching!", {
                portrait: "portraits.pilot"
            })
    ]);
    text.remove();
    // Fases:
    // - Mine cannon
    // - Cabin 2 - low stress, Single cannon, invincible
    // - Helicopters
    // - Cabin 2 - medium stress, 2 cannons, invincible
    // - Radar waves, 2 canons at same time, kill cannons
    // - Cabin 2 - destroy
    // - Sink ship
    //
    // spawn ship off screen
    const ship = spawn("BattleShip", {
        location: {
            rx: 1.1,
            ry: 0.7
        },
        defaultVelocity: 85
    });
    exec($2f74612bff91d75e$var$handleBox(ship.boxLocation1));
    exec($2f74612bff91d75e$var$handleBox(ship.boxLocation2));
    activeMovement = moveTo(ship, {
        x: 0.8
    }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
    await parallel([
        ()=>activeMovement.process,
        ()=>exec($2f74612bff91d75e$var$part1(ship))
    ]);
    await wait(1000);
    activeMovement = moveTo(ship, {
        x: 0.5
    }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
    await parallel([
        ()=>activeMovement.process,
        ()=>exec($2f74612bff91d75e$var$part2(ship))
    ]);
    setBackgroundCheckpointLimit(3);
    await wait(1000);
    activeMovement = moveTo(ship, {
        x: -0.17
    }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
    await parallel([
        ()=>activeMovement.process,
        ()=>exec($2f74612bff91d75e$var$part3(ship))
    ]);
    await exec($2f74612bff91d75e$var$helicopter2(ship));
    await exec($2f74612bff91d75e$var$part5(ship));
    await parallel([
        async ()=>{
            activeMovement = moveTo(ship, {
                x: -0.7
            }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
            await activeMovement.process;
        },
        ()=>exec($2f74612bff91d75e$var$part7(ship))
    ]);
    await parallel([
        async ()=>{
            activeMovement = moveTo(ship, {
                x: -0.2
            }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
            await activeMovement.process;
        },
        ()=>exec($2f74612bff91d75e$var$part6(ship))
    ]);
    const playerShip = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("PlayerShip").get(0);
    playerShip.trigger("turn");
    setScrollingSpeed(150, 0);
    // major explosions / sinking
    parallel([
        ()=>showState(ship, "sinking", 17000, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37)),
        async ()=>{
            activeMovement = moveTo(ship, {
                x: -1.7,
                y: 0.85
            }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
            await activeMovement.process;
            ship.destroy();
        }
    ]);
    await wait(4000);
};
var $2f74612bff91d75e$export$2e2bcd8739ae039 = $2f74612bff91d75e$var$battleship;







const $7eab18f29d7daf08$var$part = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, setBackground: setBackground, exec: exec, showHUD: showHUD })=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects",
        "hero"
    ]);
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("hero");
    await setScrollingSpeed(350, 0, {
        instant: true
    });
    await setScenery("city.Coast");
    setBackground("city.Sunrise", 2, 2);
    showHUD();
    text.remove();
    exec((0, $d4d09ab16657da00$export$cf44734282cd539)({
        existing: true
    }));
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(5, "drone.pattern2"));
    await exec((0, $2f74612bff91d75e$export$2e2bcd8739ae039));
    await exec((0, $db4356a818946794$export$5ea287dbb5709644));
};
var $7eab18f29d7daf08$export$2e2bcd8739ae039 = $7eab18f29d7daf08$var$part;








const $70bf961e23ea5183$var$part = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, parallel: parallel, setBackground: setBackground, wait: wait, exec: exec, showHUD: showHUD })=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects",
        "hero"
    ]);
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("hero");
    await setScrollingSpeed(150, 0, {
        instant: true
    });
    await setScenery("city.Coast");
    setBackground("city.Sunrise", 3, 3);
    showHUD();
    text.remove();
    exec((0, $d4d09ab16657da00$export$cf44734282cd539)({
        existing: true,
        hasLaser: true
    }));
    await setScrollingSpeed(350, 0);
    await setScenery("city.BayStart");
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("General", "I'm at a safe location now. We need to end this threat.\nHow are you holding up?", {
        portrait: "portraits.general"
    });
    await parallel([
        async ()=>{
            await (0, $47fe34e09c439dce$export$91d88f71a134afea)("John", "I'm fine. That ship had some advanced weaponry on board.\nDid you know that?", {
                portrait: "portraits.pilot"
            });
            await (0, $47fe34e09c439dce$export$91d88f71a134afea)("General", "We can not acces the computer systems anymore. But this would\nmean they also have control over our R&D division.\nThis is really bad.", {
                portrait: "portraits.general"
            });
            await (0, $47fe34e09c439dce$export$91d88f71a134afea)("John", "I will try to reach the R&D center to investigate.", {
                portrait: "portraits.pilot"
            });
        },
        ()=>exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.straight", {
                delay: 400,
                yOffset: 0.1,
                speed: 330
            })),
        async ()=>{
            await wait(4000);
            await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.straight", {
                delay: 400,
                yOffset: -0.1,
                speed: 330
            }));
        },
        async ()=>{
            await wait(8000);
            await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.straight", {
                delay: 400,
                yOffset: -0.3,
                speed: 330
            }));
        },
        async ()=>{
            await wait(10000);
            await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.straight", {
                delay: 400,
                yOffset: -0.1,
                speed: 330
            }));
        },
        async ()=>{
            await wait(12000);
            await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.straight", {
                delay: 400,
                yOffset: 0.1,
                speed: 330
            }));
        }
    ]);
    await exec((0, $db4356a818946794$export$5ea287dbb5709644));
};
var $70bf961e23ea5183$export$2e2bcd8739ae039 = $70bf961e23ea5183$var$part;









const $285f3b1e580e0a16$var$part = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, parallel: parallel, setBackground: setBackground, wait: wait, exec: exec, showHUD: showHUD })=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects",
        "hero"
    ]);
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("hero");
    await setScrollingSpeed(250, 0, {
        instant: true
    });
    await setScenery("city.Bay");
    setBackground("city.Sunrise", 3, 3);
    showHUD();
    text.remove();
    exec((0, $d4d09ab16657da00$export$cf44734282cd539)({
        existing: true,
        hasLaser: true
    }));
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(5, "drone.pattern1"));
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(8, "drone.pattern2"));
    await exec((0, $01d8d7bff7d89754$export$3b7b87c9ef4aa570)());
    await setScenery("city.Bridge");
    await exec((0, $ebe5ce3265183e05$export$47d2969c031985aa)("heli.pattern1", "heli.repeat1"));
    await parallel([
        ()=>exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(5, "drone.pattern3")),
        ()=>exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(5, "drone.pattern5"))
    ]);
    await exec((0, $01d8d7bff7d89754$export$3b7b87c9ef4aa570)());
    await parallel([
        ()=>exec((0, $ebe5ce3265183e05$export$47d2969c031985aa)("heli.pattern1", "heli.repeat2")),
        async ()=>{
            await wait(5000);
            await exec((0, $ebe5ce3265183e05$export$47d2969c031985aa)("heli.pattern1", "heli.repeat1"));
        }
    ]);
    await wait(2000);
    await parallel([
        ()=>exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(5, "drone.pattern3")),
        ()=>exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(5, "drone.pattern5"))
    ]);
    await exec((0, $db4356a818946794$export$5ea287dbb5709644));
};
var $285f3b1e580e0a16$export$2e2bcd8739ae039 = $285f3b1e580e0a16$var$part;






const $daeb0d1b54ef6b25$var$rocketFlight = (index, coord)=>async ({ spawn: spawn, wait: wait, moveTo: moveTo, allowDamage: allowDamage, showState: showState, waitForEvent: waitForEvent })=>{
        let activeMovement = null;
        await wait(index * 100);
        const rocket = spawn("HeliRocket", {
            location: {
                rx: 1.1,
                ry: coord.y
            },
            defaultVelocity: 500
        });
        waitForEvent(rocket, "Dead", async ()=>{
            activeMovement && activeMovement.abort();
            await showState(rocket, "explode");
            await wait(500);
            rocket.destroy();
        });
        await allowDamage(rocket, {
            health: 3
        });
        activeMovement = moveTo(rocket, {
            x: -0.1
        }, null, (0, $21d6fb1fc143defa$export$f590991ffe484603));
        await activeMovement.process;
        if (activeMovement.wasCompleted()) rocket.destroy();
    };
const $daeb0d1b54ef6b25$export$382ae724059145c2 = ()=>async ({ exec: exec })=>{
        const amount = 5;
        const coords = (0, (/*@__PURE__*/$parcel$interopDefault($c3d59194625b5f14$exports)))([
            {
                y: 0.8
            },
            {
                y: 0.7
            },
            {
                y: 0.6
            },
            {
                y: 0.5
            },
            {
                y: 0.4
            },
            {
                y: 0.3
            },
            {
                y: 0.2
            }
        ]);
        const items = Array(amount).fill().map(async (_, index)=>{
            await exec($daeb0d1b54ef6b25$var$rocketFlight(index, coords[index]));
        });
        await Promise.all(items);
    };




const $ed5df22b70874634$var$rocketAttack1 = (drone)=>async ({ showState: showState, until: until, moveWithPattern: moveWithPattern })=>{
        let movement = null;
        await until(()=>showState(drone, "shootRockets"), ()=>{
            movement = moveWithPattern(drone, "largeDrone.eight");
            return movement.process;
        });
    };
const $ed5df22b70874634$var$rocketAttack2 = (drone)=>async ({ showState: showState, until: until, moveWithPattern: moveWithPattern })=>{
        let movement = null;
        await until(()=>showState(drone, "rocketStrike"), ()=>{
            movement = moveWithPattern(drone, "largeDrone.eight2");
            return movement.process;
        });
    };
const $ed5df22b70874634$var$mineToTarget = (drone, target, synchronize)=>async ({ spawn: spawn, showState: showState, moveTo: moveTo, wait: wait, waitForEvent: waitForEvent, race: race, addScreenTrauma: addScreenTrauma })=>{
        const startX = drone.x + drone.w * 0.3;
        const startY = drone.y + drone.h * 0.5;
        const mine = spawn("Mine", {
            location: {
                x: startX,
                y: startY
            },
            defaultVelocity: 200
        });
        await showState(mine, "rotate");
        let movement = null;
        const motion = async ()=>{
            movement = moveTo(mine, {
                y: 1.1
            });
            await movement.process;
            if (!movement.wasCompleted()) return;
            movement = moveTo(mine, {
                x: target.x
            });
            await movement.process;
            if (!movement.wasCompleted()) return;
            movement = moveTo(mine, {
                y: target.y
            });
            await movement.process;
            if (!movement.wasCompleted()) return;
            await synchronize();
            await wait(100 + Math.random() * 1000);
            await showState(mine, "open", 500);
            if (mine.appliedEntityState === "dead") return;
            showState(mine, "blinking");
            await wait(1000);
            if (mine.appliedEntityState === "dead") return;
            showState(mine, "explode");
            addScreenTrauma(0.3);
            await wait(500);
            mine.destroy();
        };
        await race([
            ()=>waitForEvent(mine, "Dead", async ()=>{
                    movement && movement.abort();
                    if (mine.appliedEntityState === "explode") return;
                    showState(mine, "dead");
                    addScreenTrauma(0.3);
                    await wait(500);
                    mine.destroy();
                    movement && movement.abort();
                }),
            motion
        ]);
    };
const $ed5df22b70874634$var$mineAttack1 = (drone)=>async ({ exec: exec, wait: wait, moveWithPattern: moveWithPattern, parallel: parallel })=>{
        const targets = [
            {
                x: 0.2,
                y: 0.3
            },
            {
                x: 0.6,
                y: 0.3
            },
            {
                x: 0.4,
                y: 0.5
            },
            {
                x: 0.2,
                y: 0.8
            },
            {
                x: 0.6,
                y: 0.8
            }
        ];
        const syncSpace = (0, $14b0249e47534687$export$2e2bcd8739ae039)();
        const movement = moveWithPattern(drone, "largeDrone.eight");
        const mines = targets.map((target, index)=>async ()=>{
                const synchronise = syncSpace.addSynchronisation();
                await wait(200 * (index + 1));
                exec($ed5df22b70874634$var$mineToTarget(drone, target, synchronise));
            });
        parallel(mines);
        await movement.process;
    };
const $ed5df22b70874634$export$cccb0b76c66b1ed2 = ()=>async ({ moveWithPattern: moveWithPattern, playAnimation: playAnimation, setScrollingSpeed: setScrollingSpeed, showState: showState, spawn: spawn, exec: exec, parallel: parallel, wait: wait })=>{
        const drone = spawn("LargeDrone", {
            location: {
                rx: 1.1,
                ry: 0.2
            },
            defaultVelocity: 200
        });
        let movement = moveWithPattern(drone, "largeDrone.intro");
        await movement.process;
        await parallel([
            ()=>(0, $47fe34e09c439dce$export$91d88f71a134afea)("Drone", "**Bzzt** We are in control of your army now!\nJust give up!", {
                    portrait: "portraits.drone"
                }),
            ()=>showState(drone, "laugh")
        ]);
        await exec($ed5df22b70874634$var$rocketAttack1(drone));
        await exec($ed5df22b70874634$var$rocketAttack2(drone));
        await exec($ed5df22b70874634$var$mineAttack1(drone));
        console.log("mine attack!");
        await wait(10e3);
        const bridgeCrash = playAnimation("city.Bridge", {
            max: 2
        });
        await wait(10e3);
        bridgeCrash.updateCheckpointLimit(Infinity);
        await bridgeCrash.waitTillCheckpoint(3);
        await setScrollingSpeed(200, 0);
        drone.destroy();
    };



const $3b8442f9fe3a3f8d$var$part = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, setBackground: setBackground, parallel: parallel, exec: exec, waitTillInScreen: waitTillInScreen, showHUD: showHUD })=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects",
        "hero"
    ]);
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("hero");
    await setScrollingSpeed(250, 0, {
        instant: true
    });
    await setScenery("city.BayFull");
    setBackground("city.Sunrise", 3, 3);
    showHUD();
    text.remove();
    exec((0, $d4d09ab16657da00$export$cf44734282cd539)({
        existing: true,
        hasLaser: true
    }));
    const warning = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Warning!", {
        color: "#FF0000"
    });
    await warning.blink(500, 4);
    warning.remove();
    await setScenery("city.Bridge");
    await parallel([
        async ()=>{
            await waitTillInScreen("city.Bridge", -625);
            await setScrollingSpeed(0, 0);
        },
        async ()=>{
            await exec((0, $daeb0d1b54ef6b25$export$382ae724059145c2)());
            await exec((0, $daeb0d1b54ef6b25$export$382ae724059145c2)());
            await exec((0, $daeb0d1b54ef6b25$export$382ae724059145c2)());
        }
    ]);
    await exec((0, $ed5df22b70874634$export$cccb0b76c66b1ed2)());
};
var $3b8442f9fe3a3f8d$export$2e2bcd8739ae039 = $3b8442f9fe3a3f8d$var$part;






const $98a32fab4e973078$var$part = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, setBackground: setBackground, addScreenTrauma: addScreenTrauma, setAltitude: setAltitude, exec: exec, wait: wait, fadeIn: fadeIn })=>{
    const fade = fadeIn();
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects"
    ]);
    await setScrollingSpeed(100, 0, {
        instant: true
    });
    await setScenery("city.Ocean");
    setBackground("city.Sunrise", 0, 5);
    text.remove();
    await fade.start(2000);
    await wait(5e3);
    await setScrollingSpeed(500, 0);
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("General", "Let us escort you to the factory to install\nthe AI controlled defence systems. You are the last ship.", {
        portrait: "portraits.general"
    });
    addScreenTrauma(0.8);
    addScreenTrauma(0.8);
    addScreenTrauma(0.8);
    addScreenTrauma(0.8);
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("John", "Let's go!", {
        portrait: "portraits.pilot"
    });
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.straight", 500, 0.1));
    addScreenTrauma(0.8);
    addScreenTrauma(0.8);
    addScreenTrauma(0.8);
    addScreenTrauma(0.8);
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.straight", 500, -0.1));
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(4, "drone.straight", 500, -0.3));
    await setAltitude(200);
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(5, "drone.pattern1", 500));
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(8, "drone.pattern2", 500));
    await setAltitude(0);
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(5, "drone.pattern3", 500));
    await setScrollingSpeed(100, 0);
    await exec((0, $01d8d7bff7d89754$export$3b7b87c9ef4aa570)());
    await exec((0, $f25048ca1ee971a4$export$b2223c54508e0244)(5, "drone.pattern3", 500));
    await setScenery("city.CoastStart");
    await exec((0, $01d8d7bff7d89754$export$3b7b87c9ef4aa570)());
    await setScrollingSpeed(250, 0);
    await wait(20e3);
    await setScenery("city.BayStart");
    await wait(40e3);
    await setScenery("city.Bridge");
    await wait(40e3);
};
var $98a32fab4e973078$export$2e2bcd8739ae039 = $98a32fab4e973078$var$part;





const $cf297cb7a02b1069$var$part = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, showHUD: showHUD, showState: showState, wait: wait, exec: exec })=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects"
    ]);
    await setScrollingSpeed(0, 0, {
        instant: true
    });
    await setScenery("Test.Walls");
    showHUD();
    text.remove();
    exec((0, $d4d09ab16657da00$export$cf44734282cd539)({
        existing: true,
        hasLaser: true
    }));
    const player = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("PlayerShip").get(0);
    await showState(player, "turned");
    await wait(120000);
    await showState(player, "turned");
    await wait(300000);
};
var $cf297cb7a02b1069$export$2e2bcd8739ae039 = $cf297cb7a02b1069$var$part;




const $2ad3ec1bfcde72b3$var$part = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, showHUD: showHUD, wait: wait, exec: exec })=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects"
    ]);
    await setScrollingSpeed(0, 0, {
        instant: true
    });
    await setScenery("Test.Walls");
    showHUD();
    text.remove();
    let measure = +new Date();
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).bind("EnterFrame", (fd)=>{
        const now = +new Date();
        const diff = (now - measure) % 60e3;
        if (diff < 40) console.log(1000 / fd.dt, "FPS");
    });
    await wait(300000);
};
var $2ad3ec1bfcde72b3$export$2e2bcd8739ae039 = $2ad3ec1bfcde72b3$var$part;



const $210df756970e9cce$var$part = async ()=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Congratulations!", {
        sup: "The end for now..."
    });
    await text.fadeIn(5000);
    text.remove();
};
var $210df756970e9cce$export$2e2bcd8739ae039 = $210df756970e9cce$var$part;








const $47a80e99ca830ee6$export$aa32e9a06dc17353 = (pattern, yOffset = 0, points = 0, speed = null, shooting = false)=>async ({ spawn: spawn, showState: showState, waitForEvent: waitForEvent, allowDamage: allowDamage, awardPoints: awardPoints, moveWithPattern: moveWithPattern })=>{
        const flyPattern = (0, $4a464ac9ac54fc86$export$595447059867920)(pattern).path;
        const house = spawn(shooting ? "HouseHostile" : "House", {
            location: {
                rx: flyPattern[0].x,
                ry: flyPattern[0].y + yOffset
            },
            defaultVelocity: speed || 200
        });
        if (shooting) showState(house, "shooting");
        house.addCollisionComponent("SolidCollision").addCollisionComponent("PlayerEnemy");
        waitForEvent(house.chimneyLoc, "Dead", async ()=>{
            awardPoints(points, house.chimneyLoc.x + 20, house.chimneyLoc.y);
            showState(house, "dead");
            house.chimneyLoc.clearCollisionComponents();
        });
        house.chimneyLoc.addCollisionComponent("SolidCollision").addCollisionComponent("PlayerEnemy");
        await allowDamage(house.chimneyLoc, {
            health: 30
        });
        const movement = moveWithPattern(house, pattern);
        await movement.process;
        if (movement.wasCompleted()) house.destroy();
    };
const $47a80e99ca830ee6$export$f43c9d479ba3092b = (amount, pattern, { points: points = 10, delay: delay = 3500, yOffsets: yOffsets = [
    0
], speed: speed = null, shootModulo: shootModulo = 1 } = {})=>async ({ exec: exec, wait: wait })=>Promise.all(Array(amount).fill(0).map(async (e, index)=>{
            await wait(index * delay);
            const offset = yOffsets[index % yOffsets.length];
            await exec($47a80e99ca830ee6$export$aa32e9a06dc17353(pattern, offset, points, speed, index % shootModulo === 0));
        }));







const $7eb2e8bc19f19b56$export$18d5d5b816d91bf9 = ({ existing: existing = false, hasLaser: hasLaser = false, turned: turned = false } = {})=>async ({ spawn: spawn, exec: exec, waitForEvent: waitForEvent, allowDamage: allowDamage, setHealthbar: setHealthbar, setEnergybar: setEnergybar, showState: showState, setGameSpeed: setGameSpeed, addScreenTrauma: addScreenTrauma, playerHit: playerHit, wait: wait, loseLife: loseLife })=>{
        const maxHealth = 50;
        const maxEnergy = 100;
        const player = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Player").get(0);
        const existingShip = existing && (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Jinte").get(0);
        if (existingShip && existingShip.has((0, $98f23f39d831b128$export$2e2bcd8739ae039))) return;
        const ship = existingShip || spawn("Jinte", {
            location: {
                rx: turned ? 0.8 : 0.2,
                ry: 0.5
            },
            defaultVelocity: 400
        });
        if (!player.invincible) {
            if (ship === existingShip) {
                await allowDamage(ship, {
                    health: ship.health || maxHealth
                });
                ship.energy = ship.energy || 0;
            } else {
                ship.health = ship.health || maxHealth;
                ship.energy = 0;
                wait(2000).then(async ()=>{
                    await allowDamage(ship, {});
                });
            }
        }
        if (hasLaser) ship.hasLaser = true;
        if (ship.health < maxHealth * 0.5) ship.displayFrame("damaged");
        setHealthbar(ship.health / maxHealth);
        setEnergybar(ship.energy / maxEnergy);
        if (turned) await showState(ship, "turned");
        showState(ship, "flying");
        // TODO: Refactor adding these components to the entity definition
        ship.addComponent((0, $98f23f39d831b128$export$2e2bcd8739ae039), (0, $5cbb878e064c643c$export$2e2bcd8739ae039), (0, $6f2c5b88e67b3d06$export$2e2bcd8739ae039));
        if (player.has((0, $f62344210ab4fe80$export$2e2bcd8739ae039))) player.assignControls(ship);
        ship.defineBuff("overdrive", {
            cost: {
                energy: 25
            },
            duration: 3,
            cooldown: 3
        });
        // showBuff(0, ship, "overdrive", ship.controlName("power1", true));
        ship.uniqueBind("ButtonPressed", (name)=>{
            if (name === "fire") {
                ship.showState("noLaserShooting");
                ship.showState("shooting");
            }
            if (name === "heavy") {
                if (!ship.hasLaser) return;
                ship.showState("noShooting");
                ship.showState("laserShooting");
            }
            if (name === "power1") {
                ship.activateBuff("overdrive");
                ship.trigger("EnergyUpdate");
                setEnergybar(ship.energy / maxEnergy);
            }
        });
        ship.uniqueBind("ButtonReleased", (name)=>{
            if (name === "fire") ship.showState("noShooting");
            if (name === "heavy") ship.showState("noLaserShooting");
        });
        // ship.uniqueBind("BuffActivated", name => {
        //   if (name === "overdrive") {
        //     ship.mainWeapon.difficulty = 0.5;
        //     ship.laserWeapon.difficulty = 0.5;
        //   }
        // });
        // ship.uniqueBind("BuffEnded", name => {
        //   if (name === "overdrive") {
        //     ship.mainWeapon.difficulty = 0.0;
        //     ship.laserWeapon.difficulty = 0.0;
        //   }
        // });
        ship.uniqueBind("DealtDamage", ({ damage: damage })=>{
            if (damage[0].name === "Bullet" && !ship.buffActive("overdrive")) {
                ship.energy = Math.min(maxEnergy, ship.energy + 1);
                ship.trigger("EnergyUpdate");
                setEnergybar(ship.energy / maxEnergy);
            }
        });
        ship.uniqueBind("HealthChange", (newHealth)=>{
            if (newHealth < ship.health) playerHit(newHealth - ship.health);
            try {
                setHealthbar(newHealth / maxHealth);
            } catch (e) {
            // player could be game over
            }
            if (newHealth < maxHealth * 0.5) {
                if (ship.appliedEntityState !== "dead") ship.displayFrame("damaged");
            }
        });
        ship.uniqueBind("turn", ()=>{
            if (ship.health < maxHealth * 0.5) showState(ship, "turningDamaged");
            else showState(ship, "turning");
        });
        waitForEvent(ship, "Dead", async ()=>{
            ship.attr({
                disableControls: true,
                vx: 0,
                vy: 0
            });
            addScreenTrauma(0.8);
            setGameSpeed(0.4);
            const state = showState(ship, "dead");
            await wait(150);
            setGameSpeed(0.7);
            await wait(600);
            addScreenTrauma(0.5);
            await state;
            const isTurned = !!ship.xFlipped;
            const hasLaser = ship.hasLaser;
            ship.destroy();
            await loseLife();
            setGameSpeed(1.0);
            await wait(1000);
            exec($7eb2e8bc19f19b56$export$18d5d5b816d91bf9({
                turned: isTurned,
                hasLaser: hasLaser
            }));
        });
    };



const $c27429d1bc4428e1$var$birdFlight = (pattern, yOffset = 0, points = 0, speed = null, gull = false)=>async ({ spawn: spawn, showState: showState, waitForEvent: waitForEvent, allowDamage: allowDamage, awardPoints: awardPoints, moveWithPattern: moveWithPattern })=>{
        const flyPattern = (0, $4a464ac9ac54fc86$export$595447059867920)(pattern).path;
        const bird = spawn(gull ? "Seagull" : "WarBird", {
            location: {
                rx: flyPattern[0].x,
                ry: flyPattern[0].y + yOffset
            },
            defaultVelocity: speed ?? (gull ? 150 : 300)
        });
        await allowDamage(bird, {
            health: gull ? 120 : 30
        });
        const movement = moveWithPattern(bird, pattern);
        if (gull) showState(bird, "shooting");
        waitForEvent(bird, "Dead", async ()=>{
            movement.abort();
            if (points > 0) awardPoints(points, bird.x, bird.y);
            await showState(bird, "dead");
            bird.destroy();
        });
        await movement.process;
        if (movement.wasCompleted()) bird.destroy();
    };
const $c27429d1bc4428e1$export$65ca246b4b6dce86 = (amount, pattern, { points: points = 10, delay: delay = 500, yOffset: yOffset = 0, speed: speed = null, gull: gull = false } = {})=>async ({ exec: exec, wait: wait })=>Promise.all(Array(amount).fill(0).map(async (e, index)=>{
            await wait(index * delay);
            await exec($c27429d1bc4428e1$var$birdFlight(pattern, yOffset, points, speed, gull));
        }));


// const handleBox =
//   (box) =>
//   async ({ showState, allowDamage, waitForEvent, call, awardPoints }) => {
//     await allowDamage(box, { health: 30 });
//     waitForEvent(box, "Dead", async () => {
//       awardPoints(25, box.x, box.y);
//       showState(box, "falling");
//       await call(box.activateGravity, "GravityLiquid");
//     });
//   };
const $08b395f23e395468$var$intro = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, setBackground: setBackground, playAnimation: playAnimation, setAltitude: setAltitude, showHUD: showHUD, parallel: parallel, exec: exec, onScriptClose: onScriptClose, fadeIn: fadeIn, wait: wait })=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects",
        "sint"
    ]);
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("sint");
    await setScrollingSpeed(0, 0, {
        instant: true
    });
    await setScenery("garden.Grass");
    setBackground("city.Sunset", 0, 1);
    const fade = fadeIn();
    text.remove();
    await fade.start(1000);
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jinte", "Kijk Jonas, een lekkere tas vol wortels voor je", {
        portrait: "portraits.jinte"
    });
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "Dank je, dat is perfecte munitie!", {
        portrait: "portraits.jonas"
    });
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jinte", "Waaah, je praat!", {
        portrait: "portraits.jinte"
    });
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "We zitten in jouw droomwereld. Ik kan hier zelfs vliegen!", {
        portrait: "portraits.jonas"
    });
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "Maar Sinterklaas in deze wereld is op hol geslagen!", {
        portrait: "portraits.jonas"
    });
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jinte", "Is Sinterklaas hier ook!??", {
        portrait: "portraits.jinte"
    });
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "Jazeker! Maar we moeten hem stoppen, laten we gaan!", {
        portrait: "portraits.jonas"
    });
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "Daarvoor had me toch munitie gebracht?", {
        portrait: "portraits.jonas"
    });
    exec((0, $7eb2e8bc19f19b56$export$18d5d5b816d91bf9)({
        existing: true
    }));
    showHUD();
    await setScrollingSpeed(250, 0);
    const ready = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Klaar voor de start", {
        color: "#FF0000"
    });
    const blink = ready.blink(200, 4);
    await blink;
    await ready.zoomOut(500);
    ready.remove();
    await wait(2000);
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "Pas op voor de plofmussen!", {
        portrait: "portraits.jonas"
    });
    await parallel([
        ()=>exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(2, "bird.straight", {
                delay: 300,
                yOffset: 0.1
            })),
        async ()=>{
            await wait(1500);
            await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(2, "bird.straight", {
                delay: 300,
                yOffset: -0.1
            }));
        },
        async ()=>{
            await wait(3000);
            await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(2, "bird.straight", {
                delay: 300,
                yOffset: -0.3
            }));
        }
    ]);
    const chapter1 = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Strijd om de tuin", {
        color: "#FFFFFF",
        sup: "Hoofdstuk 1:"
    });
    await wait(2000);
    chapter1.remove();
    await exec((0, $db4356a818946794$export$5ea287dbb5709644));
};
var $08b395f23e395468$export$2e2bcd8739ae039 = $08b395f23e395468$var$intro;








const $d3927481c8cec6dd$var$fishFlight = (pattern, yOffset = 0, points = 0, speed = null)=>async ({ spawn: spawn, showState: showState, waitForEvent: waitForEvent, allowDamage: allowDamage, awardPoints: awardPoints, moveWithPattern: moveWithPattern })=>{
        const flyPattern = (0, $4a464ac9ac54fc86$export$595447059867920)(pattern).path;
        const fish = spawn("WarFish", {
            location: {
                rx: flyPattern[0].x,
                ry: flyPattern[0].y + yOffset
            },
            defaultVelocity: speed || 300
        });
        await allowDamage(fish, {
            health: 30
        });
        const movement = moveWithPattern(fish, pattern);
        waitForEvent(fish, "Dead", async ()=>{
            movement.abort();
            if (points > 0) awardPoints(points, fish.x, fish.y);
            await showState(fish, "dead");
            fish.destroy();
        });
        await movement.process;
        if (movement.wasCompleted()) fish.destroy();
    };
const $d3927481c8cec6dd$export$f4049d2e7080015c = (amount, pattern, { points: points = 10, delay: delay = 500, yOffset: yOffset = 0, speed: speed = null } = {})=>async ({ exec: exec, wait: wait })=>Promise.all(Array(amount).fill(0).map(async (e, index)=>{
            await wait(index * delay);
            await exec($d3927481c8cec6dd$var$fishFlight(pattern, yOffset, points, speed));
        }));


const $a1ba1da86ee95811$export$fa7f487a343107bf = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, setBackground: setBackground, playAnimation: playAnimation, setAltitude: setAltitude, showHUD: showHUD, parallel: parallel, exec: exec, onScriptClose: onScriptClose, fadeIn: fadeIn, waitTillInScreen: waitTillInScreen, wait: wait })=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects",
        "sint"
    ]);
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("sint");
    await setScrollingSpeed(250, 0, {
        instant: true
    });
    setAltitude(0, {
        instant: true
    });
    setBackground("city.Sunset", 0, 1);
    await setScenery("garden.Grass");
    showHUD();
    text.remove();
    exec((0, $7eb2e8bc19f19b56$export$18d5d5b816d91bf9)({
        existing: true
    }));
    await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(5, "bird.pattern1"));
    await setScenery("garden.PondStart");
    await parallel([
        async ()=>{
            await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(5, "bird.pattern1"));
            await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(8, "bird.pattern2"));
        },
        async ()=>{
            await waitTillInScreen("garden.PondStart", -625);
        }
    ]);
    await wait(3000);
    await exec((0, $d3927481c8cec6dd$export$f4049d2e7080015c)(4, "fish.pattern1"));
    await exec((0, $d3927481c8cec6dd$export$f4049d2e7080015c)(4, "fish.pattern2"));
    await parallel([
        async ()=>{
            await exec((0, $d3927481c8cec6dd$export$f4049d2e7080015c)(4, "fish.pattern1"));
        },
        async ()=>{
            await exec((0, $d3927481c8cec6dd$export$f4049d2e7080015c)(4, "fish.pattern2"));
        }
    ]);
    await setAltitude(700);
    await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(5, "bird.pattern1"));
    await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(8, "bird.pattern2"));
    const chapter2 = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Berg cadeautjes", {
        color: "#FFFFFF",
        sup: "Hoofdstuk 2:"
    });
    await chapter2.fadeIn(500);
    await wait(4000);
    await chapter2.fadeOut(500);
    chapter2.remove();
    await exec((0, $db4356a818946794$export$5ea287dbb5709644));
};










const $8c84af4fdab9ff86$var$extraLife = (rx, ry)=>async ({ allowDamage: allowDamage, showState: showState, waitForEvent: waitForEvent, wait: wait, spawn: spawn, gainLife: gainLife, moveWithPattern: moveWithPattern })=>{
        const extraLife = spawn("ExtraLife", {
            location: {
                rx: rx,
                ry: ry
            },
            defaultVelocity: 50
        });
        await allowDamage(extraLife, {
            health: 10
        });
        waitForEvent(extraLife, "Dead", async ()=>{
            gainLife();
            await showState(extraLife, "pickedUp");
            await wait(2000);
            extraLife.destroy();
        });
        const motion = moveWithPattern(extraLife, "powerup.circles");
        await motion.process;
        await showState(extraLife, "disappear", 1000);
        extraLife.destroy();
    };
const $8c84af4fdab9ff86$export$ba85ba33465b8135 = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, setBackground: setBackground, playAnimation: playAnimation, setAltitude: setAltitude, showHUD: showHUD, parallel: parallel, exec: exec, onScriptClose: onScriptClose, fadeIn: fadeIn, waitTillInScreen: waitTillInScreen, wait: wait })=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects",
        "sint"
    ]);
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("sint");
    setBackground("city.Sunset", 0, 2);
    await setScrollingSpeed(250, 0, {
        instant: true
    });
    setAltitude(700, {
        instant: true
    });
    await setScenery("garden.Pond");
    showHUD();
    text.remove();
    exec((0, $7eb2e8bc19f19b56$export$18d5d5b816d91bf9)({
        existing: true
    }));
    await setScenery("town.RoofTops");
    await parallel([
        async ()=>{
            await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "We moeten via Berg naar Maastricht vliegen", {
                portrait: "portraits.jonas"
            });
            await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jinte", "Zijn stoomboot ligt daar op de Maas?", {
                portrait: "portraits.jinte"
            });
            await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "Inderdaad", {
                portrait: "portraits.jonas"
            });
            await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(5, "bird.pattern4"));
        },
        async ()=>{
            await waitTillInScreen("town.RoofTops", -625);
        }
    ]);
    await parallel([
        async ()=>{
            await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(5, "bird.pattern5"));
        },
        async ()=>{
            await setAltitude(400);
        }
    ]);
    await exec((0, $47a80e99ca830ee6$export$f43c9d479ba3092b)(5, "house.straight", {
        yOffsets: [
            0,
            0.1,
            0,
            -0.1,
            0
        ],
        shootModulo: 2
    }));
    await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(5, "bird.pattern4"));
    await exec((0, $47a80e99ca830ee6$export$f43c9d479ba3092b)(5, "house.straight", {
        yOffsets: [
            0,
            0.15,
            0.5,
            -0.1,
            0
        ],
        shootModulo: 3
    }));
    exec($8c84af4fdab9ff86$var$extraLife(0.7, 0.4));
    const chapter2 = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Stedentrip", {
        color: "#FFFFFF",
        sup: "Hoofdstuk 3:"
    });
    await chapter2.fadeIn(500);
    await wait(4000);
    await chapter2.fadeOut(500);
    chapter2.remove();
    await exec((0, $db4356a818946794$export$5ea287dbb5709644));
};











const $332925ffa5f93b99$export$2ca2d1f9ad6dd18d = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, setBackground: setBackground, playAnimation: playAnimation, setAltitude: setAltitude, showHUD: showHUD, parallel: parallel, exec: exec, onScriptClose: onScriptClose, fadeIn: fadeIn, waitTillInScreen: waitTillInScreen, wait: wait })=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects",
        "sint"
    ]);
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("sint");
    setBackground("city.Sunset", 1, 3);
    await setScrollingSpeed(250, 0, {
        instant: true
    });
    setAltitude(400, {
        instant: true
    });
    await setScenery("town.RoofTops");
    showHUD();
    text.remove();
    exec((0, $7eb2e8bc19f19b56$export$18d5d5b816d91bf9)({
        existing: true
    }));
    await setScenery("town.Rasberg");
    await parallel([
        async ()=>{
            await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jinte", "Ik zie Maastricht al, we zijn er bijna!", {
                portrait: "portraits.jinte"
            });
            await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(4, "bird.pattern2"));
        },
        async ()=>{
            await waitTillInScreen("town.Rasberg", -1020);
        }
    ]);
    await wait(7000);
    // Meeuwen
    await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(1, "bird.pattern6", {
        gull: true,
        points: 30
    }));
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "Gatver! Flatsmeeuwen", {
        portrait: "portraits.jonas"
    });
    await parallel([
        ()=>exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(2, "bird.pattern2", {
                delay: 1000,
                points: 30,
                gull: true
            })),
        ()=>setAltitude(0)
    ]);
    await exec((0, $d3927481c8cec6dd$export$f4049d2e7080015c)(4, "fish.pattern1"));
    await setScenery("city.Bridge");
    await parallel([
        async ()=>{
            await exec((0, $d3927481c8cec6dd$export$f4049d2e7080015c)(4, "fish.pattern1"));
        },
        async ()=>{
            await exec((0, $d3927481c8cec6dd$export$f4049d2e7080015c)(4, "fish.pattern2"));
        }
    ]);
    await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(2, "bird.pattern2", {
        delay: 1000,
        points: 30,
        gull: true
    }));
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "Het moet nu niet ver meer zijn!", {
        portrait: "portraits.jonas"
    });
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jinte", "Ik hoop het, want ik wil mijn pakje open maken", {
        portrait: "portraits.jinte"
    });
    await waitTillInScreen("city.Bridge", 520);
    await setScenery("city.BayEnd");
    await wait(3000);
    await exec((0, $d3927481c8cec6dd$export$f4049d2e7080015c)(4, "fish.pattern1"));
    await exec((0, $d3927481c8cec6dd$export$f4049d2e7080015c)(4, "fish.pattern1"));
    await setScenery("city.CoastEnd");
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).fadeMusicVolume(0.2, 5000);
    await wait(3000);
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jinte", "Hey, wat is het ineens stil...", {
        portrait: "portraits.jinte"
    });
    await exec((0, $d3927481c8cec6dd$export$f4049d2e7080015c)(4, "fish.pattern2"));
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "Ja, dat is vast om de spanning op te bouwen", {
        portrait: "portraits.jonas"
    });
    await exec((0, $c27429d1bc4428e1$export$65ca246b4b6dce86)(3, "bird.pattern2", {
        delay: 2000,
        points: 30,
        gull: true
    }));
    const chapter2 = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Zie ginds...", {
        color: "#FFFFFF",
        sup: "Hoofdstuk 4:"
    });
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).fadeMusicVolume(0, 2000);
    await chapter2.fadeIn(500);
    await wait(4000);
    await chapter2.fadeOut(500);
    chapter2.remove();
    await exec((0, $db4356a818946794$export$5ea287dbb5709644));
};


















const $2630641a860df62b$var$shootMineCannon = (cannon, high)=>async ({ spawn: spawn, moveWithPattern: moveWithPattern, moveTo: moveTo, addScreenTrauma: addScreenTrauma, wait: wait, waitForEvent: waitForEvent, showState: showState, allowDamage: allowDamage, race: race })=>{
        await showState(cannon, high ? "aimHigh" : "aimLow");
        const spawnPoint = cannon.currentAttachHooks.gun;
        if (!cannon.hasHealth()) return;
        const mine = spawn("Mine", {
            location: {
                x: spawnPoint.x,
                y: spawnPoint.y
            },
            defaultVelocity: 350
        }).attr({
            z: spawnPoint.z
        });
        waitForEvent(mine, "Loose", async ()=>{
            mine.attr({
                z: mine.z + 30
            });
        });
        const movement = moveWithPattern(mine, high ? "mineCannon.highShot" : "mineCannon.lowShot", null, (0, $21d6fb1fc143defa$export$7c0c5615d5b4a96b));
        await showState(cannon, "shoot");
        movement.process.then(async ()=>{
            await allowDamage(mine, {
                health: 40
            });
            const ship = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Jinte").get(0);
            let searchMovement;
            searchMovement = moveTo(mine, {
                y: 1
            });
            await searchMovement.process;
            searchMovement = moveTo(mine, {
                x: ship.x / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width
            });
            await searchMovement.process;
            searchMovement = moveTo(mine, {
                y: ship.y / (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height
            });
            await race([
                ()=>waitForEvent(mine, "Dead", async ()=>{
                        searchMovement && searchMovement.abort();
                        if (mine.appliedEntityState === "explode") return;
                        showState(mine, "dead");
                        addScreenTrauma(0.3);
                        await wait(1000);
                        mine.destroy();
                        searchMovement && searchMovement.abort();
                    }),
                async ()=>{
                    await searchMovement.process;
                    if (searchMovement.wasCompleted()) {
                        if (mine.appliedEntityState === "dead") return;
                        await showState(mine, "open", 500);
                        showState(mine, "blinking");
                        await wait(1000);
                        if (mine.appliedEntityState !== "dead") {
                            showState(mine, "explode");
                            addScreenTrauma(0.3);
                            await wait(1000);
                            mine.destroy();
                        }
                    }
                }
            ]);
        });
    };
const $2630641a860df62b$var$activateGun = (gun)=>async ({ awardPoints: awardPoints, showState: showState, waitForEvent: waitForEvent, allowDamage: allowDamage })=>{
        const gunKilled = waitForEvent(gun, "Dead", async ()=>{
            awardPoints(200, gun.x + 20, gun.y);
            showState(gun, "dead");
            gun.clearCollisionComponents();
        });
        gun.addCollisionComponent("SolidCollision").addCollisionComponent("PlayerEnemy");
        allowDamage(gun, {
            health: 750
        });
        showState(gun, "shooting");
        await gunKilled;
    };
const $2630641a860df62b$var$part1 = (ship)=>async ({ showState: showState, waitForEvent: waitForEvent, allowDamage: allowDamage, race: race, awardPoints: awardPoints, until: until })=>{
        const mineCannon = ship.mineCannon;
        mineCannon.addCollisionComponent("SolidCollision").addCollisionComponent("PlayerEnemy");
        const killed = waitForEvent(mineCannon, "Dead", async ()=>{
            awardPoints(250, mineCannon.x, mineCannon.y);
            showState(mineCannon, "dead");
            mineCannon.clearCollisionComponents();
        });
        await race([
            async ()=>{
                await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Sinterklaas", "Al die jaren bezorde die pakjes mij hoofdpijn!", {
                    portrait: "portraits.sint"
                });
                await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Sinterklaas", "Nu gaan ze jullie hoofdpijn bezorgen, hahaha!", {
                    portrait: "portraits.sint"
                });
                await allowDamage(mineCannon, {
                    health: 800
                });
                let high = true;
                await until(()=>killed, async ({ exec: exec })=>{
                    await exec($2630641a860df62b$var$shootMineCannon(mineCannon, high));
                    high = !high;
                });
            },
            ()=>killed
        ]);
    };
const $2630641a860df62b$var$part2 = (ship)=>async ({ exec: exec, waitForEvent: waitForEvent, parallel: parallel, until: until, showState: showState, awardPoints: awardPoints, allowDamage: allowDamage, wait: wait })=>{
        const radar = ship.cabin1.radar;
        radar.addCollisionComponent("SolidCollision");
        showState(radar, "pulse");
        await allowDamage(radar, {
            health: 500
        });
        let points = 10;
        // await parallel([
        //   () =>
        //     until(
        //       () =>
        await waitForEvent(radar, "Dead", async ()=>{
            awardPoints(100, radar.x + 20, radar.y);
            showState(radar, "dead");
            radar.clearCollisionComponents();
        });
    //   async ({ exec }) => {
    //     // exec(droneWave(2, "drone.pattern2", { points }));
    //     // points = points > 0 ? points - 5 : 0;
    //     await wait(2000);
    //   },
    // ),
    // () => exec(activateGun(ship.deckGun1)),
    // ]);
    };
const $2630641a860df62b$var$mineAttack = (ship)=>async ({ wait: wait, showState: showState, moveTo: moveTo, exec: exec, parallel: parallel })=>{
        await parallel([
            ()=>{
                const upwards = moveTo(ship, {
                    y: 0.65
                }, 20, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
                return upwards.process;
            },
            ()=>showState(ship, "risen", 2000),
            async ()=>{
                await wait(1000);
                await exec((0, $01d8d7bff7d89754$export$7fdd94ec6d33a6cb)());
            }
        ]);
        await parallel([
            ()=>{
                const downwards = moveTo(ship, {
                    y: 0.7
                }, 20, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
                return downwards.process;
            },
            ()=>showState(ship, "lowered", 2000)
        ]);
    };
// const helicopter1 =
//   (ship) =>
//   async ({
//     call,
//     wait,
//     waitForEvent,
//     showState,
//     awardPoints,
//     allowDamage,
//     until,
//     moveWithPattern,
//   }) => {
//     const helicopter = ship.heliPlace1;
//     const heliAudio = audio.playAudio("helicopter", { volume: 0.01 });
//     heliAudio.setVolume(0.9, 1000);
//     showState(helicopter, "flying");
//     await wait(1000);
//     await showState(helicopter, "tilted", 2000);
//     let movement = moveWithPattern(helicopter, "heli.battleship1", 150, LINEAR);
//     waitForEvent(helicopter, "detach", async () => {
//       helicopter.detachFromParent();
//     });
//     const maxHealth = 500;
//     waitForEvent(helicopter, "active", async () => {
//       helicopter
//         .addCollisionComponent("SolidCollision")
//         .addCollisionComponent("PlayerEnemy");
//       await allowDamage(helicopter, { health: maxHealth });
//     });
//     waitForEvent(helicopter, "Remove", async () => {
//       heliAudio.stop();
//     });
//     helicopter.uniqueBind("HealthChange", (newHealth) => {
//       if (newHealth < maxHealth * 0.5) {
//         if (helicopter.appliedEntityState !== "dead") {
//           showState(helicopter, "fire");
//         }
//       }
//     });
//     const killed = waitForEvent(helicopter, "Dead", async () => {
//       heliAudio.stop();
//       helicopter.clearCollisionComponents();
//       movement.abort();
//       awardPoints(250, helicopter.x + 20, helicopter.y);
//       await showState(helicopter, "dead");
//       helicopter.z = ship.z + 5;
//       await call(helicopter.activateGravity);
//     });
//     await movement.process;
//     await until(
//       () => killed,
//       async () => {
//         if (helicopter.appliedEntityState === "dead") return wait(500);
//         movement = moveWithPattern(
//           helicopter,
//           "heli.battleship2c",
//           150,
//           LINEAR,
//         );
//         await movement.process;
//       },
//     );
//   };
const $2630641a860df62b$var$part3 = (ship)=>async ({ showState: showState, wait: wait, exec: exec, parallel: parallel })=>{
        await wait(1000);
        // await parallel([
        // async () => {
        //   await wait(1000);
        //   await exec(activateGun(ship.deckGun2));
        //   await wait(1000);
        //   await showState(ship, "t3o", 2000);
        //   await showState(ship, "t3r", 2000);
        //   await exec(activateGun(ship.hatch3.payload));
        // },
        // () => exec(helicopter1(ship)),
        // ]);
        await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Sinterklaas", "Tijd om mijn pakjesruim te legen!", {
            portrait: "portraits.sint"
        });
        // Mines from below
        await exec($2630641a860df62b$var$mineAttack(ship));
        await parallel([
            async ()=>{
                // await showState(ship, "t3o", 1000);
                await showState(ship, "t3r", 1000);
                await exec($2630641a860df62b$var$activateGun(ship.hatch3.payload));
            },
            async ()=>{
                // await showState(ship, "t1o", 1000);
                await showState(ship, "t1r", 1000);
                await exec($2630641a860df62b$var$activateGun(ship.hatch1.payload));
            }
        ]);
        await exec($2630641a860df62b$var$mineAttack(ship));
    };
// const helicopter2 =
//   (ship) =>
//   async ({
//     wait,
//     moveTo,
//     showState,
//     moveWithPattern,
//     waitForEvent,
//     awardPoints,
//     allowDamage,
//     call,
//     until,
//   }) => {
//     const helicopter = ship.heliPlace2;
//     const heliAudio = audio.playAudio("helicopter", { volume: 0.01 });
//     heliAudio.setVolume(0.9, 1000);
//     showState(helicopter, "flying");
//     await wait(1000);
//     await showState(helicopter, "tilted", 2000);
//     let movement = moveWithPattern(
//       helicopter,
//       "heli.battleship2a",
//       150,
//       LINEAR,
//     );
//     waitForEvent(helicopter, "detach", async () => {
//       helicopter.detachFromParent();
//     });
//     const maxHealth = 500;
//     waitForEvent(helicopter, "active", async () => {
//       helicopter
//         .addCollisionComponent("SolidCollision")
//         .addCollisionComponent("PlayerEnemy");
//       await allowDamage(helicopter, { health: maxHealth });
//     });
//     waitForEvent(helicopter, "Remove", async () => {
//       heliAudio.stop();
//     });
//     helicopter.uniqueBind("HealthChange", (newHealth) => {
//       if (newHealth < maxHealth * 0.5) {
//         if (helicopter.appliedEntityState !== "dead") {
//           showState(helicopter, "fire");
//         }
//       }
//     });
//     const killed = waitForEvent(helicopter, "Dead", async () => {
//       heliAudio.stop();
//       helicopter.clearCollisionComponents();
//       movement.abort();
//       awardPoints(250, helicopter.x + 20, helicopter.y);
//       await showState(helicopter, "dead");
//       await call(helicopter.activateGravity);
//     });
//     const shipMovement = waitForEvent(helicopter, "moveShip", async () => {
//       const p = moveTo(ship, { x: -1.0 }, 120, EASE_IN_OUT);
//       await p.process;
//     });
//     await movement.process;
//     movement = moveWithPattern(helicopter, "heli.battleship2b", 150, LINEAR);
//     await shipMovement;
//     await movement.process;
//     await until(
//       () => killed,
//       async () => {
//         if (helicopter.appliedEntityState === "dead") return wait(500);
//         movement = moveWithPattern(
//           helicopter,
//           "heli.battleship2c",
//           150,
//           LINEAR,
//         );
//         await movement.process;
//       },
//     );
//   };
const $2630641a860df62b$var$part5 = (ship)=>async ({ allowDamage: allowDamage, showState: showState, wait: wait, parallel: parallel, setScrollingSpeed: setScrollingSpeed, moveTo: moveTo, awardPoints: awardPoints, exec: exec, waitForEvent: waitForEvent })=>{
        await wait(2000);
        await showState(ship, "packageOpen", 1000, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
        await wait(1000);
        const laser = ship.deckGun3;
        await showState(laser, "open", 500, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
        const engineCore = ship.engineCore;
        engineCore.addComponent("SolidCollision");
        waitForEvent(engineCore, "Dead", async ()=>{
            engineCore.clearCollisionComponents();
            showState(ship, "engineTilt");
            waitForEvent(engineCore, "Dead", async ()=>{
                engineCore.clearCollisionComponents();
                // Add explosions and screenshakes
                awardPoints(500, engineCore.x + 20, engineCore.y);
                engineCore.removeComponent("SolidCollision");
                showState(ship.laserField, "stopped");
                allowDamage(laser, {
                    health: 500
                });
                ship.laserField.removeComponent("SolidCollision");
                showState(ship, "engineDestroyed");
            });
            await allowDamage(ship.engineCore, {
                health: 1000
            });
        });
        await allowDamage(ship.engineCore, {
            health: 500
        });
        laser.addCollisionComponent("SolidCollision");
        const killed = waitForEvent(laser, "Dead", async ()=>{
            laser.clearCollisionComponents();
            awardPoints(250, laser.x + 20, laser.y);
            showState(laser, "dead");
        });
        await allowDamage(laser, {
            health: 500
        });
        showState(laser, "shooting");
        await parallel([
            async ()=>{
                const playerShip = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Jinte").get(0);
                playerShip.trigger("turn");
                await wait(1000);
                await showState(ship, "engineDoorOpen");
                setScrollingSpeed(-100, 0);
                const activeMovement = moveTo(ship, {
                    x: -0.9
                }, 85, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
                await activeMovement.process;
            },
            async ()=>{
                await killed;
                exec($2630641a860df62b$var$laserWeapon(laser.x + laser.w / 2, laser.y - laser.h));
            }
        ]);
    };
const $2630641a860df62b$var$extraLife = (x, y)=>async ({ allowDamage: allowDamage, showState: showState, waitForEvent: waitForEvent, wait: wait, spawn: spawn, gainLife: gainLife, moveWithPattern: moveWithPattern })=>{
        const extraLife = spawn("ExtraLife", {
            location: {
                x: x,
                y: y
            },
            defaultVelocity: 50
        });
        await allowDamage(extraLife, {
            health: 10
        });
        waitForEvent(extraLife, "Dead", async ()=>{
            gainLife();
            await showState(extraLife, "pickedUp");
            await wait(2000);
            extraLife.destroy();
        });
        const motion = moveWithPattern(extraLife, "powerup.circles");
        await motion.process;
        await showState(extraLife, "disappear", 1000);
        extraLife.destroy();
    };
const $2630641a860df62b$var$laserWeapon = (x, y)=>async ({ allowDamage: allowDamage, awardText: awardText, showState: showState, waitForEvent: waitForEvent, wait: wait, spawn: spawn, until: until })=>{
        const powerup = spawn("Upgrade", {
            location: {
                x: x,
                y: y
            },
            defaultVelocity: 50
        });
        await allowDamage(powerup, {
            health: 10
        });
        const pickedUp = waitForEvent(powerup, "Dead", async ()=>{
            const ship = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Jinte").get(0);
            ship.hasLaser = true;
            awardText("Laser weapon", powerup.x, powerup.y);
            await showState(powerup, "pickedUp");
            await wait(2000);
            powerup.destroy();
            (0, $47fe34e09c439dce$export$91d88f71a134afea)(null, `You gained a new weapon! The LASER. Use the ${ship.controlName("heavy")} to shoot.`);
        });
        await until(()=>pickedUp, async ({ moveWithPattern: moveWithPattern })=>{
            const motion = moveWithPattern(powerup, "powerup.circles");
            await motion.process;
        });
        powerup.destroy();
    };
const $2630641a860df62b$var$part6 = (ship)=>async ({ allowDamage: allowDamage, showState: showState, waitForEvent: waitForEvent, awardPoints: awardPoints, addScreenTrauma: addScreenTrauma, exec: exec, wait: wait })=>{
        const cabin = ship.cabin1;
        cabin.addCollisionComponent("SolidCollision");
        const killed = waitForEvent(cabin, "Dead", async ()=>{
            awardPoints(2000, cabin.x + cabin.w / 2, cabin.y);
            showState(ship, "cabin1Explode");
            addScreenTrauma(0.5);
            await wait(2000);
            addScreenTrauma(0.5);
            cabin.clearCollisionComponents();
            showState(ship, "cabin1Smoke");
        });
        await allowDamage(cabin, {
            health: 500
        });
        await killed;
        cabin.removeComponent("SolidCollision");
        exec($2630641a860df62b$var$extraLife(cabin.x + cabin.w / 2, cabin.y - cabin.h));
    };
const $2630641a860df62b$var$part7 = (ship)=>async ({ allowDamage: allowDamage, showState: showState, addScreenTrauma: addScreenTrauma, waitForEvent: waitForEvent, awardPoints: awardPoints, wait: wait })=>{
        const cabin = ship.cabin2;
        cabin.addCollisionComponent("SolidCollision");
        const killed = waitForEvent(cabin, "Dead", async ()=>{
            awardPoints(2000, cabin.x + cabin.w / 2, cabin.y);
            showState(ship, "cabin2Explode");
            addScreenTrauma(0.5);
            await wait(2000);
            addScreenTrauma(0.5);
            cabin.clearCollisionComponents();
            showState(ship, "cabin2Smoke");
        });
        await allowDamage(cabin, {
            health: 500
        });
        await killed;
        cabin.removeComponent("SolidCollision");
    };
const $2630641a860df62b$var$handleBox = (box)=>async ({ showState: showState, allowDamage: allowDamage, waitForEvent: waitForEvent, call: call, awardPoints: awardPoints })=>{
        await allowDamage(box, {
            health: 30
        });
        waitForEvent(box, "Dead", async ()=>{
            awardPoints(25, box.x, box.y);
            showState(box, "falling");
            await call(box.activateGravity, "GravityLiquid");
        });
    };
const $2630641a860df62b$var$battleship = async ({ parallel: parallel, spawn: spawn, wait: wait, showState: showState, exec: exec, moveTo: moveTo, setBackgroundCheckpointLimit: setBackgroundCheckpointLimit, setScrollingSpeed: setScrollingSpeed })=>{
    let activeMovement;
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Pas op!", {
        color: "#FF0000"
    });
    await parallel([
        ()=>text.blink(500, 4),
        ()=>setScrollingSpeed(150, 0),
        ()=>(0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "Daar is de stoomboot!", {
                portrait: "portraits.jonas"
            })
    ]);
    text.remove();
    // Fases:
    // - Mine cannon
    // - Cabin 2 - low stress, Single cannon, invincible
    // - Helicopters
    // - Cabin 2 - medium stress, 2 cannons, invincible
    // - Radar waves, 2 canons at same time, kill cannons
    // - Cabin 2 - destroy
    // - Sink ship
    //
    // spawn ship off screen
    const ship = spawn("BattleShip", {
        location: {
            rx: 1.1,
            ry: 0.7
        },
        defaultVelocity: 85
    });
    exec($2630641a860df62b$var$handleBox(ship.boxLocation1));
    exec($2630641a860df62b$var$handleBox(ship.boxLocation2));
    activeMovement = moveTo(ship, {
        x: 0.8
    }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
    await parallel([
        ()=>activeMovement.process,
        ()=>exec($2630641a860df62b$var$part1(ship))
    ]);
    await wait(1000);
    activeMovement = moveTo(ship, {
        x: 0.5
    }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
    await activeMovement.process;
    await exec($2630641a860df62b$var$part2(ship));
    await exec($2630641a860df62b$var$part6(ship));
    // setBackgroundCheckpointLimit(3);
    await wait(1000);
    activeMovement = moveTo(ship, {
        x: -0.17
    }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
    await activeMovement.process;
    await exec($2630641a860df62b$var$part3(ship));
    // await exec(helicopter2(ship));
    // await exec(part5(ship));
    await parallel([
        async ()=>{
            activeMovement = moveTo(ship, {
                x: -0.4
            }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
            await activeMovement.process;
        },
        ()=>exec($2630641a860df62b$var$part7(ship))
    ]);
    // await parallel([
    //   async () => {
    //     activeMovement = moveTo(ship, { x: -0.2 }, null, EASE_IN_OUT);
    //     await activeMovement.process;
    //   },
    //   () => exec(part6(ship)),
    // ]);
    // const playerShip = Crafty("Jinte").get(0);
    // playerShip.trigger("turn");
    // setScrollingSpeed(150, 0);
    // major explosions / sinking
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Sinterklaas", "Neee!!!", {
        portrait: "portraits.sint"
    });
    parallel([
        ()=>showState(ship, "sinking", 17000, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37)),
        async ()=>{
            activeMovement = moveTo(ship, {
                x: -1.7,
                y: 0.85
            }, null, (0, $21d6fb1fc143defa$export$c36ab4b6f6b3ac37));
            await activeMovement.process;
            ship.destroy();
        }
    ]);
    await wait(4000);
};
var $2630641a860df62b$export$2e2bcd8739ae039 = $2630641a860df62b$var$battleship;


const $edf97e549f13fe14$export$be93c438f6efd23d = async ({ setScrollingSpeed: setScrollingSpeed, setScenery: setScenery, loadSpriteSheets: loadSpriteSheets, loadAudio: loadAudio, setBackground: setBackground, playAnimation: playAnimation, setAltitude: setAltitude, showHUD: showHUD, parallel: parallel, exec: exec, onScriptClose: onScriptClose, fadeIn: fadeIn, waitTillInScreen: waitTillInScreen, wait: wait })=>{
    const text = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Loading...");
    text.fadeIn(2000);
    await loadSpriteSheets([
        "mega-texture"
    ]);
    await loadAudio([
        "effects",
        "boss"
    ]);
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).playAudio("boss");
    setBackground("city.Sunset", 3, 4);
    await setScrollingSpeed(250, 0, {
        instant: true
    });
    setAltitude(0, {
        instant: true
    });
    await setScenery("city.Ocean");
    showHUD();
    text.remove();
    exec((0, $7eb2e8bc19f19b56$export$18d5d5b816d91bf9)({
        existing: true
    }));
    await exec((0, $2630641a860df62b$export$2e2bcd8739ae039));
    const ready = (0, $1b6c3ee66e2e3a50$export$eb192d84eb65661d)("Knockout!", {
        color: "#FFFFFF"
    });
    const blink = ready.blink(200, 4);
    await blink;
    await ready.zoomOut(500);
    ready.remove();
    await wait(2000);
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "Woohoo!! Goed gedaan!", {
        portrait: "portraits.jonas"
    });
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jinte", "Kijk, zo doen we dat!", {
        portrait: "portraits.jinte"
    });
    await (0, $47fe34e09c439dce$export$91d88f71a134afea)("Jonas", "Dan is het nu tijd om je pakje open te maken", {
        portrait: "portraits.jonas"
    });
};


const $2a3b9a29640a0dff$var$gameStructure = [
    {
        name: "sint.intro",
        script: (0, $08b395f23e395468$export$2e2bcd8739ae039),
        tags: {
            sint: true
        }
    },
    {
        name: "sint.garden",
        script: (0, $a1ba1da86ee95811$export$fa7f487a343107bf),
        tags: {
            sint: true
        }
    },
    {
        name: "sint.berg",
        script: (0, $8c84af4fdab9ff86$export$ba85ba33465b8135),
        tags: {
            sint: true
        }
    },
    {
        name: "sint.maastricht",
        script: (0, $332925ffa5f93b99$export$2ca2d1f9ad6dd18d),
        tags: {
            sint: true
        }
    },
    {
        name: "sint.stoomboot",
        script: (0, $edf97e549f13fe14$export$be93c438f6efd23d),
        tags: {
            sint: true
        }
    },
    {
        name: "stage1.intro",
        script: (0, $c09c668b8e556ce5$export$2e2bcd8739ae039),
        tags: {
            campaign: true
        }
    },
    {
        name: "stage1.hacked",
        script: (0, $b81cf2b6f0b73d31$export$2e2bcd8739ae039),
        tags: {
            campaign: true
        }
    },
    {
        name: "stage1.battleship",
        script: (0, $7eab18f29d7daf08$export$2e2bcd8739ae039),
        tags: {
            campaign: true
        }
    },
    {
        name: "stage1.battleshipEnd",
        script: (0, $70bf961e23ea5183$export$2e2bcd8739ae039),
        tags: {
            campaign: true
        }
    },
    {
        name: "stage1.bay",
        script: (0, $285f3b1e580e0a16$export$2e2bcd8739ae039),
        tags: {
            campaign: true
        }
    },
    {
        name: "stage1.bridge",
        script: (0, $3b8442f9fe3a3f8d$export$2e2bcd8739ae039),
        tags: {
            campaign: true,
            wip: true
        }
    },
    {
        name: "end",
        script: (0, $210df756970e9cce$export$2e2bcd8739ae039),
        tags: {
            campaign: true
        }
    },
    {
        name: "test.scenery",
        script: (0, $98a32fab4e973078$export$2e2bcd8739ae039),
        tags: {
            test: true
        }
    },
    {
        name: "test.laser",
        script: (0, $cf297cb7a02b1069$export$2e2bcd8739ae039),
        tags: {
            test: true
        }
    },
    {
        name: "test.composable",
        script: (0, $2ad3ec1bfcde72b3$export$2e2bcd8739ae039),
        tags: {
            test: true
        }
    }
];
var $2a3b9a29640a0dff$export$2e2bcd8739ae039 = $2a3b9a29640a0dff$var$gameStructure;



const $fa6bd5530e3b0e51$export$ce2114882f5aca2b = (text, parent, y, color = "#FFFFFF", size = "20px")=>{
    const textItem = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, UILayerDOM, Text").attr({
        x: parent.x,
        y: parent.y + y,
        w: parent.w,
        z: parent.z + 1
    }).text(text).textColor(color).textAlign("center").textFont({
        size: size,
        weight: "bold",
        family: "Press Start 2P"
    });
    parent.attach(textItem);
    return textItem;
};






const $497eea14f9d46518$var$Menu = "Menu";
const $497eea14f9d46518$var$itemColor = (selected, dangerous)=>{
    if (selected) return dangerous ? "#FF0000" : "#FFFF00";
    return dangerous ? "#FF6666" : "#999999";
};
const $497eea14f9d46518$var$itemLabel = (item)=>item.getName ? item.getName() : item.name;
const $497eea14f9d46518$var$handleInteract = (itemEntity, action)=>{
    const handler = itemEntity.item[action];
    if (!handler) return;
    handler();
    const newLabel = $497eea14f9d46518$var$itemLabel(itemEntity.item);
    itemEntity.text(newLabel);
};
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($497eea14f9d46518$var$Menu, {
    required: "2D",
    events: {
        Freeze () {
            if (this._detachController) {
                this._detachController();
                this._detachController = null;
            }
            this._children.forEach((child)=>child.freeze());
        },
        Unfreeze () {
            this._children.forEach((child)=>child.unfreeze());
        }
    },
    init () {},
    remove () {
        if (this._detachController) {
            this._detachController();
            this._detachController = null;
        }
    },
    menu (options, controller) {
        let menuHeight = 0;
        this.items = options.map((item)=>{
            if (item.spaceAbove) menuHeight += 16;
            const itemEntity = (0, $fa6bd5530e3b0e51$export$ce2114882f5aca2b)($497eea14f9d46518$var$itemLabel(item), this, menuHeight, $497eea14f9d46518$var$itemColor(false, item.dangerous), "16px");
            itemEntity.item = item;
            menuHeight += 32;
            return itemEntity;
        });
        this.attr({
            h: menuHeight
        });
        this._menuItem = 0;
        this.selectOption(null, 0);
        this.attachController(controller);
        return this;
    },
    attachController (controller) {
        if (this._detachController) {
            this._detachController();
            this._detachController = null;
        }
        const down = ()=>{
            this._menuItem = this.selectOption(this._menuItem, 1);
        };
        const up = ()=>{
            this._menuItem = this.selectOption(this._menuItem, -1);
        };
        const left = ()=>{
            const activeItem = this.items[this._menuItem];
            $497eea14f9d46518$var$handleInteract(activeItem, "left");
        };
        const right = ()=>{
            const activeItem = this.items[this._menuItem];
            $497eea14f9d46518$var$handleInteract(activeItem, "right");
        };
        const fire = ()=>{
            const activeItem = this.items[this._menuItem];
            $497eea14f9d46518$var$handleInteract(activeItem, "activate");
        };
        controller.bind("Down", down);
        controller.bind("Up", up);
        controller.bind("Left", left);
        controller.bind("Right", right);
        controller.bind("Fire", fire);
        this._detachController = ()=>{
            controller.unbind("Down", down);
            controller.unbind("Up", up);
            controller.unbind("Left", left);
            controller.unbind("Right", right);
            controller.unbind("Fire", fire);
        };
        return this;
    },
    selectOption (previousItem, delta) {
        const newItem = previousItem === null ? delta : (previousItem + this.items.length + delta) % this.items.length;
        if (previousItem !== newItem) {
            const deselect = previousItem !== null && this.items[previousItem].item.deselect;
            deselect && deselect();
            const select = this.items[newItem].item.select;
            select && select();
        }
        this.items.forEach((entity, i)=>entity.textColor($497eea14f9d46518$var$itemColor(i === newItem, entity.item.dangerous)));
        return newItem;
    }
});
var $497eea14f9d46518$export$2e2bcd8739ae039 = $497eea14f9d46518$var$Menu;


let $0d00920b13fd9802$var$settings = null;
const $0d00920b13fd9802$var$getSettings = ()=>{
    if ($0d00920b13fd9802$var$settings) return $0d00920b13fd9802$var$settings;
    const data = localStorage.getItem("SPDLZR-SET");
    if (!data) return {};
    try {
        $0d00920b13fd9802$var$settings = JSON.parse(data);
    } catch (e) {
        $0d00920b13fd9802$var$settings = null;
    }
    return $0d00920b13fd9802$var$settings || {};
};
const $0d00920b13fd9802$export$87d51fc9023e4534 = (key, value)=>{
    const updated = $0d00920b13fd9802$var$getSettings();
    updated[key] = value;
    $0d00920b13fd9802$var$settings = updated;
    localStorage.setItem("SPDLZR-SET", JSON.stringify(updated));
};
const $0d00920b13fd9802$export$60d2a73d9c319f71 = (item, defaultValue)=>{
    const settings = $0d00920b13fd9802$var$getSettings();
    const value = settings[item];
    return value === undefined ? defaultValue : value;
};
var $0d00920b13fd9802$export$2e2bcd8739ae039 = $0d00920b13fd9802$export$60d2a73d9c319f71;



const $f153070305144947$var$PauseMenu = "PauseMenu";
const $f153070305144947$var$soundLabels = {
    0: "Off",
    10: "Max"
};
const $f153070305144947$var$soundLevel = (level)=>$f153070305144947$var$soundLabels[level] || level;
const $f153070305144947$var$gameVersion = undefined;
const $f153070305144947$var$soundOption = {
    getName: ()=>{
        const soundVolumeLevel = Math.round((0, $d4d953306f5c187b$export$2e2bcd8739ae039).getEffectsVolume() * 10);
        return `Sound [${$f153070305144947$var$soundLevel(soundVolumeLevel)}]`;
    },
    left: ()=>{
        let soundVolumeLevel = Math.round((0, $d4d953306f5c187b$export$2e2bcd8739ae039).getEffectsVolume() * 10);
        soundVolumeLevel = Math.max(0, soundVolumeLevel - 1);
        (0, $d4d953306f5c187b$export$2e2bcd8739ae039).setEffectVolume(soundVolumeLevel / 10.0);
        (0, $0d00920b13fd9802$export$87d51fc9023e4534)("effectsVolume", soundVolumeLevel / 10.0);
    },
    right: ()=>{
        let soundVolumeLevel = Math.round((0, $d4d953306f5c187b$export$2e2bcd8739ae039).getEffectsVolume() * 10);
        soundVolumeLevel = Math.min(10, soundVolumeLevel + 1);
        (0, $d4d953306f5c187b$export$2e2bcd8739ae039).setEffectVolume(soundVolumeLevel / 10.0);
        (0, $0d00920b13fd9802$export$87d51fc9023e4534)("effectsVolume", soundVolumeLevel / 10.0);
    },
    select: ()=>{
    //console.log("Select");
    },
    deselect: ()=>{
    //console.log("Deselect");
    }
};
const $f153070305144947$var$musicOption = {
    getName: ()=>{
        const musicVolumeLevel = Math.round((0, $d4d953306f5c187b$export$2e2bcd8739ae039).getMusicVolume() * 10);
        return `Music [${$f153070305144947$var$soundLevel(musicVolumeLevel)}]`;
    },
    left: ()=>{
        let musicVolumeLevel = Math.round((0, $d4d953306f5c187b$export$2e2bcd8739ae039).getMusicVolume() * 10);
        musicVolumeLevel = Math.max(0, musicVolumeLevel - 1);
        (0, $d4d953306f5c187b$export$2e2bcd8739ae039).setMusicVolume(musicVolumeLevel / 10.0);
        (0, $0d00920b13fd9802$export$87d51fc9023e4534)("musicVolume", musicVolumeLevel / 10.0);
    },
    right: ()=>{
        let musicVolumeLevel = Math.round((0, $d4d953306f5c187b$export$2e2bcd8739ae039).getMusicVolume() * 10);
        musicVolumeLevel = Math.min(10, musicVolumeLevel + 1);
        (0, $d4d953306f5c187b$export$2e2bcd8739ae039).setMusicVolume(musicVolumeLevel / 10.0);
        (0, $0d00920b13fd9802$export$87d51fc9023e4534)("musicVolume", musicVolumeLevel / 10.0);
    },
    select: ()=>{
    //console.log("Select");
    },
    deselect: ()=>{
    //console.log("Deselect");
    }
};
const $f153070305144947$var$items = [
    //{ name: "Controls" },
    {
        name: "Resume",
        activate: ()=>{
            setTimeout(()=>(0, $925b104f0bb9b62a$export$8b09b726120a992d)());
        }
    },
    $f153070305144947$var$soundOption,
    $f153070305144947$var$musicOption,
    {
        name: "Restart",
        spaceAbove: true,
        dangerous: true,
        activate: ()=>{
            setTimeout(()=>{
                (0, $925b104f0bb9b62a$export$8b09b726120a992d)();
                (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).trigger("EndGame", {
                    mode: "restart"
                });
                (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("Game");
            });
        }
    },
    {
        name: "Quit",
        dangerous: true,
        activate: ()=>{
            setTimeout(()=>{
                (0, $925b104f0bb9b62a$export$8b09b726120a992d)();
                (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).trigger("EndGame", {
                    mode: "quit"
                });
                (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("Intro");
            });
        }
    }
];
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($f153070305144947$var$PauseMenu, {
    required: "UILayerDOM, 2D, Color",
    events: {
        Freeze () {
            this._children.forEach((child)=>child.freeze());
        },
        Unfreeze () {
            this._children.forEach((child)=>child.unfreeze());
        }
    },
    init () {},
    showMenu (controller) {
        if (this.menu) this.menu.attachController(controller);
        else this.menuOptions($f153070305144947$var$items, controller);
        return this;
    },
    menuOptions (options, controller) {
        const menuWidth = 400;
        this.attr({
            x: ((0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width - menuWidth) / 2,
            w: menuWidth,
            alpha: 0.8,
            z: 200
        }).color("#222222");
        let menuHeight = 70;
        (0, $fa6bd5530e3b0e51$export$ce2114882f5aca2b)("Game paused", this, 20);
        this.menu = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e((0, $497eea14f9d46518$export$2e2bcd8739ae039)).attr({
            x: this.x,
            w: this.w,
            y: this.y + 70,
            z: this.z + 1
        }).menu(options, controller);
        this.attach(this.menu);
        menuHeight += this.menu.h + 10;
        (0, $fa6bd5530e3b0e51$export$ce2114882f5aca2b)(`version: ${$f153070305144947$var$gameVersion}`, this, menuHeight, "#eeeeee", "8px");
        menuHeight += 20;
        this.attr({
            y: ((0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height - menuHeight) / 2,
            h: menuHeight
        });
        return this;
    }
});
var $f153070305144947$export$2e2bcd8739ae039 = $f153070305144947$var$PauseMenu;








const $a483b8029d48b758$var$Player = "Player";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($a483b8029d48b758$var$Player, {
    init () {
        this.reset();
    },
    reset () {
        if (this.has((0, $f62344210ab4fe80$export$2e2bcd8739ae039))) this.removeComponent((0, $f62344210ab4fe80$export$2e2bcd8739ae039));
    }
});
var $a483b8029d48b758$export$2e2bcd8739ae039 = $a483b8029d48b758$var$Player;




const $6f7d714804a7bd74$var$DEFAULT_TAGS = [
    "campaign"
];
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).defineScene("Game", async function({ start: start = null, tags: tags = $6f7d714804a7bd74$var$DEFAULT_TAGS } = {}) {
    let pauseMenu = null;
    (0, $2e5c1713fb068b10$export$ea1f1c9e80b89b51)(1.0);
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).bind("GamePause", (paused)=>{
        if (paused) {
            const player = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Player").get(0);
            if (pauseMenu === null) pauseMenu = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e((0, $f153070305144947$export$2e2bcd8739ae039)).showMenu(player);
            else {
                pauseMenu.unfreeze();
                pauseMenu.showMenu(player);
            }
        } else pauseMenu && pauseMenu.freeze();
    });
    let endMode = null;
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).one("EndGame", (event)=>{
        endMode = event.mode;
    });
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.x = 0;
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.y = 0;
    this.state = {
        lives: (0, (/*@__PURE__*/$parcel$interopDefault($fbd39d42b4ec86c5$exports))).lives,
        score: 0
    };
    const runner = (0, $75d63cfcf5f29411$export$1da21c66750cbff2)(this.state);
    let checkpoint = null;
    try {
        let started = false;
        for (const item of (0, $2a3b9a29640a0dff$export$2e2bcd8739ae039)){
            if (!started && start !== null && start !== item.name) continue;
            if (!tags.every((tag)=>item.tags[tag] === true)) continue;
            /* eslint-env node */ if (item.tags.wip === true && true) continue;
            started = true;
            if (this.state.gameEnded !== true) checkpoint = item.name;
            await runner(item.script);
        }
        const fade = (0, $60cfab0448e82384$export$c091916f1530334c)();
        (0, $d4d953306f5c187b$export$2e2bcd8739ae039).fadeMusicVolume(0, 2000);
        await fade.start(2000);
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("GameOver", {
            gameCompleted: !this.state.gameEnded,
            score: this.state.score,
            checkpoint: this.state.gameEnded === true ? checkpoint : null
        });
    } catch (e) {
        if (endMode !== null) return;
        if (e.message !== "Game Over") console.error(e);
        const fade = (0, $60cfab0448e82384$export$c091916f1530334c)();
        (0, $d4d953306f5c187b$export$2e2bcd8739ae039).fadeMusicVolume(0, 2000);
        await fade.start(2000);
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("GameOver", {
            score: this.state.score,
            checkpoint: checkpoint
        });
    }
}, function() {
    this.state.gameEnded = true;
    (0, $d4d953306f5c187b$export$2e2bcd8739ae039).stopMusic();
    // destructor
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)((0, $a483b8029d48b758$export$2e2bcd8739ae039)).each(function() {
        this.removeComponent("ShipSpawnable");
    });
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)((0, $8c6a9ebc6fe6c24c$export$2e2bcd8739ae039)).each(function() {
        this.destroy();
    });
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).unbind("GameOver");
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).unbind("ScriptFinished");
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).unbind("GamePause");
});


var $8e8207876291ad5b$exports = {};
var $d32f848f0b24628f$exports = {};

var $a10fd6bbdbeca07f$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $a10fd6bbdbeca07f$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$a10fd6bbdbeca07f$exports = $a10fd6bbdbeca07f$var$arrayEach;



var $b58b037468524cb1$exports = {};


/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b58b037468524cb1$var$baseAssign(object, source) {
    return object && $c91289edf5ee1498$exports(source, $e1b1f7a0047f3f3f$exports(source), object);
}
$b58b037468524cb1$exports = $b58b037468524cb1$var$baseAssign;


var $62e5dafa22902e7b$exports = {};


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $62e5dafa22902e7b$var$baseAssignIn(object, source) {
    return object && $c91289edf5ee1498$exports(source, $f7d4c3ae5541f253$exports(source), object);
}
$62e5dafa22902e7b$exports = $62e5dafa22902e7b$var$baseAssignIn;



var $lNdKa = parcelRequire("lNdKa");

var $fa651ded73f16f45$exports = {};

var $8316aec83928af77$exports = {};
var $8414a880822ca839$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $8414a880822ca839$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$8414a880822ca839$exports = $8414a880822ca839$var$arrayFilter;


var $eb93963cf9b9c886$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $eb93963cf9b9c886$var$stubArray() {
    return [];
}
$eb93963cf9b9c886$exports = $eb93963cf9b9c886$var$stubArray;


/** Used for built-in method references. */ var $8316aec83928af77$var$objectProto = Object.prototype;
/** Built-in value references. */ var $8316aec83928af77$var$propertyIsEnumerable = $8316aec83928af77$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8316aec83928af77$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $8316aec83928af77$var$getSymbols = !$8316aec83928af77$var$nativeGetSymbols ? $eb93963cf9b9c886$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8414a880822ca839$exports($8316aec83928af77$var$nativeGetSymbols(object), function(symbol) {
        return $8316aec83928af77$var$propertyIsEnumerable.call(object, symbol);
    });
};
$8316aec83928af77$exports = $8316aec83928af77$var$getSymbols;


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $fa651ded73f16f45$var$copySymbols(source, object) {
    return $c91289edf5ee1498$exports(source, $8316aec83928af77$exports(source), object);
}
$fa651ded73f16f45$exports = $fa651ded73f16f45$var$copySymbols;


var $82b3cd6c4cce4498$exports = {};

var $150ab8e21c24de5c$exports = {};
var $30da0614631dba82$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $30da0614631dba82$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$30da0614631dba82$exports = $30da0614631dba82$var$arrayPush;





/* Built-in method references for those with the same name as other `lodash` methods. */ var $150ab8e21c24de5c$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $150ab8e21c24de5c$var$getSymbolsIn = !$150ab8e21c24de5c$var$nativeGetSymbols ? $eb93963cf9b9c886$exports : function(object) {
    var result = [];
    while(object){
        $30da0614631dba82$exports(result, $8316aec83928af77$exports(object));
        object = $6225d8b6a0e5a410$exports(object);
    }
    return result;
};
$150ab8e21c24de5c$exports = $150ab8e21c24de5c$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $82b3cd6c4cce4498$var$copySymbolsIn(source, object) {
    return $c91289edf5ee1498$exports(source, $150ab8e21c24de5c$exports(source), object);
}
$82b3cd6c4cce4498$exports = $82b3cd6c4cce4498$var$copySymbolsIn;


var $240b6f17362122a6$exports = {};
var $3d13b9b0229ce854$exports = {};


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $3d13b9b0229ce854$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $b879a56dcf4bb3c4$exports(object) ? result : $30da0614631dba82$exports(result, symbolsFunc(object));
}
$3d13b9b0229ce854$exports = $3d13b9b0229ce854$var$baseGetAllKeys;




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $240b6f17362122a6$var$getAllKeys(object) {
    return $3d13b9b0229ce854$exports(object, $e1b1f7a0047f3f3f$exports, $8316aec83928af77$exports);
}
$240b6f17362122a6$exports = $240b6f17362122a6$var$getAllKeys;


var $c1b5b31f81200386$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c1b5b31f81200386$var$getAllKeysIn(object) {
    return $3d13b9b0229ce854$exports(object, $f7d4c3ae5541f253$exports, $150ab8e21c24de5c$exports);
}
$c1b5b31f81200386$exports = $c1b5b31f81200386$var$getAllKeysIn;


var $5148b26f310728ae$exports = {};
var $0e45db80e5d9e371$exports = {};


var $fNJVo = parcelRequire("fNJVo");
/* Built-in method references that are verified to be native. */ var $0e45db80e5d9e371$var$DataView = $e6dba3193c9726c4$exports($fNJVo, "DataView");
$0e45db80e5d9e371$exports = $0e45db80e5d9e371$var$DataView;



var $59bbfe78fe04d11c$exports = {};


var $fNJVo = parcelRequire("fNJVo");
/* Built-in method references that are verified to be native. */ var $59bbfe78fe04d11c$var$Promise = $e6dba3193c9726c4$exports($fNJVo, "Promise");
$59bbfe78fe04d11c$exports = $59bbfe78fe04d11c$var$Promise;


var $7b69fab4098db4c1$exports = {};


var $fNJVo = parcelRequire("fNJVo");
/* Built-in method references that are verified to be native. */ var $7b69fab4098db4c1$var$Set = $e6dba3193c9726c4$exports($fNJVo, "Set");
$7b69fab4098db4c1$exports = $7b69fab4098db4c1$var$Set;


var $d1cf0c2f55daf74e$exports = {};


var $fNJVo = parcelRequire("fNJVo");
/* Built-in method references that are verified to be native. */ var $d1cf0c2f55daf74e$var$WeakMap = $e6dba3193c9726c4$exports($fNJVo, "WeakMap");
$d1cf0c2f55daf74e$exports = $d1cf0c2f55daf74e$var$WeakMap;




/** `Object#toString` result references. */ var $5148b26f310728ae$var$mapTag = "[object Map]", $5148b26f310728ae$var$objectTag = "[object Object]", $5148b26f310728ae$var$promiseTag = "[object Promise]", $5148b26f310728ae$var$setTag = "[object Set]", $5148b26f310728ae$var$weakMapTag = "[object WeakMap]";
var $5148b26f310728ae$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $5148b26f310728ae$var$dataViewCtorString = $5239300eb73938e8$exports($0e45db80e5d9e371$exports), $5148b26f310728ae$var$mapCtorString = $5239300eb73938e8$exports($512a082725507343$exports), $5148b26f310728ae$var$promiseCtorString = $5239300eb73938e8$exports($59bbfe78fe04d11c$exports), $5148b26f310728ae$var$setCtorString = $5239300eb73938e8$exports($7b69fab4098db4c1$exports), $5148b26f310728ae$var$weakMapCtorString = $5239300eb73938e8$exports($d1cf0c2f55daf74e$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $5148b26f310728ae$var$getTag = $79796df0d07208ef$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($0e45db80e5d9e371$exports && $5148b26f310728ae$var$getTag(new $0e45db80e5d9e371$exports(new ArrayBuffer(1))) != $5148b26f310728ae$var$dataViewTag || $512a082725507343$exports && $5148b26f310728ae$var$getTag(new $512a082725507343$exports) != $5148b26f310728ae$var$mapTag || $59bbfe78fe04d11c$exports && $5148b26f310728ae$var$getTag($59bbfe78fe04d11c$exports.resolve()) != $5148b26f310728ae$var$promiseTag || $7b69fab4098db4c1$exports && $5148b26f310728ae$var$getTag(new $7b69fab4098db4c1$exports) != $5148b26f310728ae$var$setTag || $d1cf0c2f55daf74e$exports && $5148b26f310728ae$var$getTag(new $d1cf0c2f55daf74e$exports) != $5148b26f310728ae$var$weakMapTag) $5148b26f310728ae$var$getTag = function(value) {
    var result = $79796df0d07208ef$exports(value), Ctor = result == $5148b26f310728ae$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $5239300eb73938e8$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $5148b26f310728ae$var$dataViewCtorString:
            return $5148b26f310728ae$var$dataViewTag;
        case $5148b26f310728ae$var$mapCtorString:
            return $5148b26f310728ae$var$mapTag;
        case $5148b26f310728ae$var$promiseCtorString:
            return $5148b26f310728ae$var$promiseTag;
        case $5148b26f310728ae$var$setCtorString:
            return $5148b26f310728ae$var$setTag;
        case $5148b26f310728ae$var$weakMapCtorString:
            return $5148b26f310728ae$var$weakMapTag;
    }
    return result;
};
$5148b26f310728ae$exports = $5148b26f310728ae$var$getTag;


var $134ced534cfc8675$exports = {};
/** Used for built-in method references. */ var $134ced534cfc8675$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $134ced534cfc8675$var$hasOwnProperty = $134ced534cfc8675$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $134ced534cfc8675$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $134ced534cfc8675$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$134ced534cfc8675$exports = $134ced534cfc8675$var$initCloneArray;


var $3263bb4f1848a74c$exports = {};

var $3fa70d55e47bcd02$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $3fa70d55e47bcd02$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $7cf2017d5dbf9c1e$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$3fa70d55e47bcd02$exports = $3fa70d55e47bcd02$var$cloneDataView;


var $800885ea8b199017$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $800885ea8b199017$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $800885ea8b199017$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $800885ea8b199017$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$800885ea8b199017$exports = $800885ea8b199017$var$cloneRegExp;


var $164e8d4e8d56d9b0$exports = {};

/** Used to convert symbols to primitives and strings. */ var $164e8d4e8d56d9b0$var$symbolProto = $4745131536d797ac$exports ? $4745131536d797ac$exports.prototype : undefined, $164e8d4e8d56d9b0$var$symbolValueOf = $164e8d4e8d56d9b0$var$symbolProto ? $164e8d4e8d56d9b0$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $164e8d4e8d56d9b0$var$cloneSymbol(symbol) {
    return $164e8d4e8d56d9b0$var$symbolValueOf ? Object($164e8d4e8d56d9b0$var$symbolValueOf.call(symbol)) : {};
}
$164e8d4e8d56d9b0$exports = $164e8d4e8d56d9b0$var$cloneSymbol;



/** `Object#toString` result references. */ var $3263bb4f1848a74c$var$boolTag = "[object Boolean]", $3263bb4f1848a74c$var$dateTag = "[object Date]", $3263bb4f1848a74c$var$mapTag = "[object Map]", $3263bb4f1848a74c$var$numberTag = "[object Number]", $3263bb4f1848a74c$var$regexpTag = "[object RegExp]", $3263bb4f1848a74c$var$setTag = "[object Set]", $3263bb4f1848a74c$var$stringTag = "[object String]", $3263bb4f1848a74c$var$symbolTag = "[object Symbol]";
var $3263bb4f1848a74c$var$arrayBufferTag = "[object ArrayBuffer]", $3263bb4f1848a74c$var$dataViewTag = "[object DataView]", $3263bb4f1848a74c$var$float32Tag = "[object Float32Array]", $3263bb4f1848a74c$var$float64Tag = "[object Float64Array]", $3263bb4f1848a74c$var$int8Tag = "[object Int8Array]", $3263bb4f1848a74c$var$int16Tag = "[object Int16Array]", $3263bb4f1848a74c$var$int32Tag = "[object Int32Array]", $3263bb4f1848a74c$var$uint8Tag = "[object Uint8Array]", $3263bb4f1848a74c$var$uint8ClampedTag = "[object Uint8ClampedArray]", $3263bb4f1848a74c$var$uint16Tag = "[object Uint16Array]", $3263bb4f1848a74c$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $3263bb4f1848a74c$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $3263bb4f1848a74c$var$arrayBufferTag:
            return $7cf2017d5dbf9c1e$exports(object);
        case $3263bb4f1848a74c$var$boolTag:
        case $3263bb4f1848a74c$var$dateTag:
            return new Ctor(+object);
        case $3263bb4f1848a74c$var$dataViewTag:
            return $3fa70d55e47bcd02$exports(object, isDeep);
        case $3263bb4f1848a74c$var$float32Tag:
        case $3263bb4f1848a74c$var$float64Tag:
        case $3263bb4f1848a74c$var$int8Tag:
        case $3263bb4f1848a74c$var$int16Tag:
        case $3263bb4f1848a74c$var$int32Tag:
        case $3263bb4f1848a74c$var$uint8Tag:
        case $3263bb4f1848a74c$var$uint8ClampedTag:
        case $3263bb4f1848a74c$var$uint16Tag:
        case $3263bb4f1848a74c$var$uint32Tag:
            return $f24f8918ebad94ff$exports(object, isDeep);
        case $3263bb4f1848a74c$var$mapTag:
            return new Ctor;
        case $3263bb4f1848a74c$var$numberTag:
        case $3263bb4f1848a74c$var$stringTag:
            return new Ctor(object);
        case $3263bb4f1848a74c$var$regexpTag:
            return $800885ea8b199017$exports(object);
        case $3263bb4f1848a74c$var$setTag:
            return new Ctor;
        case $3263bb4f1848a74c$var$symbolTag:
            return $164e8d4e8d56d9b0$exports(object);
    }
}
$3263bb4f1848a74c$exports = $3263bb4f1848a74c$var$initCloneByTag;





var $2W9As = parcelRequire("2W9As");
var $78157c47107dd225$exports = {};
var $7a784a34b86b9a6f$exports = {};


/** `Object#toString` result references. */ var $7a784a34b86b9a6f$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7a784a34b86b9a6f$var$baseIsMap(value) {
    return $8e31d76e9d05173f$exports(value) && $5148b26f310728ae$exports(value) == $7a784a34b86b9a6f$var$mapTag;
}
$7a784a34b86b9a6f$exports = $7a784a34b86b9a6f$var$baseIsMap;




var $74qZ6 = parcelRequire("74qZ6");
/* Node.js helper references. */ var $78157c47107dd225$var$nodeIsMap = $74qZ6 && $74qZ6.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $78157c47107dd225$var$isMap = $78157c47107dd225$var$nodeIsMap ? $d26adae8a43490ae$exports($78157c47107dd225$var$nodeIsMap) : $7a784a34b86b9a6f$exports;
$78157c47107dd225$exports = $78157c47107dd225$var$isMap;



var $23bd6d16f36e22a4$exports = {};
var $5b8a775053d44c11$exports = {};


/** `Object#toString` result references. */ var $5b8a775053d44c11$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $5b8a775053d44c11$var$baseIsSet(value) {
    return $8e31d76e9d05173f$exports(value) && $5148b26f310728ae$exports(value) == $5b8a775053d44c11$var$setTag;
}
$5b8a775053d44c11$exports = $5b8a775053d44c11$var$baseIsSet;




var $74qZ6 = parcelRequire("74qZ6");
/* Node.js helper references. */ var $23bd6d16f36e22a4$var$nodeIsSet = $74qZ6 && $74qZ6.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $23bd6d16f36e22a4$var$isSet = $23bd6d16f36e22a4$var$nodeIsSet ? $d26adae8a43490ae$exports($23bd6d16f36e22a4$var$nodeIsSet) : $5b8a775053d44c11$exports;
$23bd6d16f36e22a4$exports = $23bd6d16f36e22a4$var$isSet;




/** Used to compose bitmasks for cloning. */ var $d32f848f0b24628f$var$CLONE_DEEP_FLAG = 1, $d32f848f0b24628f$var$CLONE_FLAT_FLAG = 2, $d32f848f0b24628f$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $d32f848f0b24628f$var$argsTag = "[object Arguments]", $d32f848f0b24628f$var$arrayTag = "[object Array]", $d32f848f0b24628f$var$boolTag = "[object Boolean]", $d32f848f0b24628f$var$dateTag = "[object Date]", $d32f848f0b24628f$var$errorTag = "[object Error]", $d32f848f0b24628f$var$funcTag = "[object Function]", $d32f848f0b24628f$var$genTag = "[object GeneratorFunction]", $d32f848f0b24628f$var$mapTag = "[object Map]", $d32f848f0b24628f$var$numberTag = "[object Number]", $d32f848f0b24628f$var$objectTag = "[object Object]", $d32f848f0b24628f$var$regexpTag = "[object RegExp]", $d32f848f0b24628f$var$setTag = "[object Set]", $d32f848f0b24628f$var$stringTag = "[object String]", $d32f848f0b24628f$var$symbolTag = "[object Symbol]", $d32f848f0b24628f$var$weakMapTag = "[object WeakMap]";
var $d32f848f0b24628f$var$arrayBufferTag = "[object ArrayBuffer]", $d32f848f0b24628f$var$dataViewTag = "[object DataView]", $d32f848f0b24628f$var$float32Tag = "[object Float32Array]", $d32f848f0b24628f$var$float64Tag = "[object Float64Array]", $d32f848f0b24628f$var$int8Tag = "[object Int8Array]", $d32f848f0b24628f$var$int16Tag = "[object Int16Array]", $d32f848f0b24628f$var$int32Tag = "[object Int32Array]", $d32f848f0b24628f$var$uint8Tag = "[object Uint8Array]", $d32f848f0b24628f$var$uint8ClampedTag = "[object Uint8ClampedArray]", $d32f848f0b24628f$var$uint16Tag = "[object Uint16Array]", $d32f848f0b24628f$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $d32f848f0b24628f$var$cloneableTags = {};
$d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$argsTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$arrayTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$arrayBufferTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$dataViewTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$boolTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$dateTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$float32Tag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$float64Tag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$int8Tag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$int16Tag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$int32Tag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$mapTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$numberTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$objectTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$regexpTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$setTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$stringTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$symbolTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$uint8Tag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$uint8ClampedTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$uint16Tag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$uint32Tag] = true;
$d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$errorTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$funcTag] = $d32f848f0b24628f$var$cloneableTags[$d32f848f0b24628f$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $d32f848f0b24628f$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $d32f848f0b24628f$var$CLONE_DEEP_FLAG, isFlat = bitmask & $d32f848f0b24628f$var$CLONE_FLAT_FLAG, isFull = bitmask & $d32f848f0b24628f$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$38ff99188d059d52$exports(value)) return value;
    var isArr = $b879a56dcf4bb3c4$exports(value);
    if (isArr) {
        result = $134ced534cfc8675$exports(value);
        if (!isDeep) return $892d74bc47a6142a$exports(value, result);
    } else {
        var tag = $5148b26f310728ae$exports(value), isFunc = tag == $d32f848f0b24628f$var$funcTag || tag == $d32f848f0b24628f$var$genTag;
        if ($2W9As(value)) return $lNdKa(value, isDeep);
        if (tag == $d32f848f0b24628f$var$objectTag || tag == $d32f848f0b24628f$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $4218bcdeaf011a19$exports(value);
            if (!isDeep) return isFlat ? $82b3cd6c4cce4498$exports(value, $62e5dafa22902e7b$exports(result, value)) : $fa651ded73f16f45$exports(value, $b58b037468524cb1$exports(result, value));
        } else {
            if (!$d32f848f0b24628f$var$cloneableTags[tag]) return object ? value : {};
            result = $3263bb4f1848a74c$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $d1833597dde236cc$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($23bd6d16f36e22a4$exports(value)) value.forEach(function(subValue) {
        result.add($d32f848f0b24628f$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($78157c47107dd225$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $d32f848f0b24628f$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $c1b5b31f81200386$exports : $240b6f17362122a6$exports : isFlat ? $f7d4c3ae5541f253$exports : $e1b1f7a0047f3f3f$exports;
    var props = isArr ? undefined : keysFunc(value);
    $a10fd6bbdbeca07f$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $abb25edc9a61a733$exports(result, key, $d32f848f0b24628f$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$d32f848f0b24628f$exports = $d32f848f0b24628f$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $8e8207876291ad5b$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $8e8207876291ad5b$var$clone(value) {
    return $d32f848f0b24628f$exports(value, $8e8207876291ad5b$var$CLONE_SYMBOLS_FLAG);
}
$8e8207876291ad5b$exports = $8e8207876291ad5b$var$clone;


var $561d1469f5af3aeb$exports = {};
var $73d95962d1d3b7d5$exports = {};

var $ebe76b94ebfe9872$exports = {};



/** Built-in value references. */ var $ebe76b94ebfe9872$var$spreadableSymbol = $4745131536d797ac$exports ? $4745131536d797ac$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $ebe76b94ebfe9872$var$isFlattenable(value) {
    return $b879a56dcf4bb3c4$exports(value) || $b7af7320b985fe40$exports(value) || !!($ebe76b94ebfe9872$var$spreadableSymbol && value && value[$ebe76b94ebfe9872$var$spreadableSymbol]);
}
$ebe76b94ebfe9872$exports = $ebe76b94ebfe9872$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $73d95962d1d3b7d5$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ebe76b94ebfe9872$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $73d95962d1d3b7d5$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $30da0614631dba82$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$73d95962d1d3b7d5$exports = $73d95962d1d3b7d5$var$baseFlatten;


var $179c70d25cc9d189$exports = {};

var $d083c95cb49e5cc8$exports = {};
var $a4bd83859dadeb3a$exports = {};

var $63c87b7887a786eb$exports = {};

var $e6cd81ba6bef786b$exports = {};


/** `Object#toString` result references. */ var $e6cd81ba6bef786b$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e6cd81ba6bef786b$var$isSymbol(value) {
    return typeof value == "symbol" || $8e31d76e9d05173f$exports(value) && $79796df0d07208ef$exports(value) == $e6cd81ba6bef786b$var$symbolTag;
}
$e6cd81ba6bef786b$exports = $e6cd81ba6bef786b$var$isSymbol;


/** Used to match property names within property paths. */ var $63c87b7887a786eb$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $63c87b7887a786eb$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $63c87b7887a786eb$var$isKey(value, object) {
    if ($b879a56dcf4bb3c4$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $e6cd81ba6bef786b$exports(value)) return true;
    return $63c87b7887a786eb$var$reIsPlainProp.test(value) || !$63c87b7887a786eb$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$63c87b7887a786eb$exports = $63c87b7887a786eb$var$isKey;


var $9d047846dc988afc$exports = {};
var $333a0913690ba65c$exports = {};
var $e9e26fde324aec97$exports = {};

/** Error message constants. */ var $e9e26fde324aec97$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $e9e26fde324aec97$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($e9e26fde324aec97$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($e9e26fde324aec97$var$memoize.Cache || $04f8b00d118f0f6d$exports);
    return memoized;
}
// Expose `MapCache`.
$e9e26fde324aec97$var$memoize.Cache = $04f8b00d118f0f6d$exports;
$e9e26fde324aec97$exports = $e9e26fde324aec97$var$memoize;


/** Used as the maximum memoize cache size. */ var $333a0913690ba65c$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $333a0913690ba65c$var$memoizeCapped(func) {
    var result = $e9e26fde324aec97$exports(func, function(key) {
        if (cache.size === $333a0913690ba65c$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$333a0913690ba65c$exports = $333a0913690ba65c$var$memoizeCapped;


/** Used to match property names within property paths. */ var $9d047846dc988afc$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $9d047846dc988afc$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $9d047846dc988afc$var$stringToPath = $333a0913690ba65c$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($9d047846dc988afc$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($9d047846dc988afc$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$9d047846dc988afc$exports = $9d047846dc988afc$var$stringToPath;


var $d3f55bf360c709f7$exports = {};
var $2280da04fc1db042$exports = {};




/** Used as references for various `Number` constants. */ var $2280da04fc1db042$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $2280da04fc1db042$var$symbolProto = $4745131536d797ac$exports ? $4745131536d797ac$exports.prototype : undefined, $2280da04fc1db042$var$symbolToString = $2280da04fc1db042$var$symbolProto ? $2280da04fc1db042$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $2280da04fc1db042$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($b879a56dcf4bb3c4$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $69747cf806d0c7fb$exports(value, $2280da04fc1db042$var$baseToString) + "";
    if ($e6cd81ba6bef786b$exports(value)) return $2280da04fc1db042$var$symbolToString ? $2280da04fc1db042$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$2280da04fc1db042$var$INFINITY ? "-0" : result;
}
$2280da04fc1db042$exports = $2280da04fc1db042$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $d3f55bf360c709f7$var$toString(value) {
    return value == null ? "" : $2280da04fc1db042$exports(value);
}
$d3f55bf360c709f7$exports = $d3f55bf360c709f7$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $a4bd83859dadeb3a$var$castPath(value, object) {
    if ($b879a56dcf4bb3c4$exports(value)) return value;
    return $63c87b7887a786eb$exports(value, object) ? [
        value
    ] : $9d047846dc988afc$exports($d3f55bf360c709f7$exports(value));
}
$a4bd83859dadeb3a$exports = $a4bd83859dadeb3a$var$castPath;


var $7fdc918f901759c0$exports = {};

/** Used as references for various `Number` constants. */ var $7fdc918f901759c0$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $7fdc918f901759c0$var$toKey(value) {
    if (typeof value == "string" || $e6cd81ba6bef786b$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$7fdc918f901759c0$var$INFINITY ? "-0" : result;
}
$7fdc918f901759c0$exports = $7fdc918f901759c0$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $d083c95cb49e5cc8$var$baseGet(object, path) {
    path = $a4bd83859dadeb3a$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$7fdc918f901759c0$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$d083c95cb49e5cc8$exports = $d083c95cb49e5cc8$var$baseGet;


var $39f94ea87b801ba3$exports = {};
var $05a505468939b9e9$exports = {};
var $6c9f9b16fc379077$exports = {};

var $0399c2acb5c79914$exports = {};
var $5046d5266df03c41$exports = {};

var $05942e38cf5705e0$exports = {};
var $a9ead1b9ff631606$exports = {};

var $061488433a832da3$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $061488433a832da3$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $061488433a832da3$var$setCacheAdd(value) {
    this.__data__.set(value, $061488433a832da3$var$HASH_UNDEFINED);
    return this;
}
$061488433a832da3$exports = $061488433a832da3$var$setCacheAdd;


var $30c8752f81ca64ba$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $30c8752f81ca64ba$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$30c8752f81ca64ba$exports = $30c8752f81ca64ba$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a9ead1b9ff631606$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $04f8b00d118f0f6d$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a9ead1b9ff631606$var$SetCache.prototype.add = $a9ead1b9ff631606$var$SetCache.prototype.push = $061488433a832da3$exports;
$a9ead1b9ff631606$var$SetCache.prototype.has = $30c8752f81ca64ba$exports;
$a9ead1b9ff631606$exports = $a9ead1b9ff631606$var$SetCache;


var $a735ea6db90b5e98$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $a735ea6db90b5e98$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$a735ea6db90b5e98$exports = $a735ea6db90b5e98$var$arraySome;


var $4fa5e84c566de471$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4fa5e84c566de471$var$cacheHas(cache, key) {
    return cache.has(key);
}
$4fa5e84c566de471$exports = $4fa5e84c566de471$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $05942e38cf5705e0$var$COMPARE_PARTIAL_FLAG = 1, $05942e38cf5705e0$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $05942e38cf5705e0$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $05942e38cf5705e0$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $05942e38cf5705e0$var$COMPARE_UNORDERED_FLAG ? new $a9ead1b9ff631606$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$a735ea6db90b5e98$exports(other, function(othValue, othIndex) {
                if (!$4fa5e84c566de471$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$05942e38cf5705e0$exports = $05942e38cf5705e0$var$equalArrays;


var $deef9fa3d0d203b4$exports = {};




var $cf70be9909d091d4$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $cf70be9909d091d4$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$cf70be9909d091d4$exports = $cf70be9909d091d4$var$mapToArray;


var $4d62faea1846faff$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $4d62faea1846faff$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$4d62faea1846faff$exports = $4d62faea1846faff$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $deef9fa3d0d203b4$var$COMPARE_PARTIAL_FLAG = 1, $deef9fa3d0d203b4$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $deef9fa3d0d203b4$var$boolTag = "[object Boolean]", $deef9fa3d0d203b4$var$dateTag = "[object Date]", $deef9fa3d0d203b4$var$errorTag = "[object Error]", $deef9fa3d0d203b4$var$mapTag = "[object Map]", $deef9fa3d0d203b4$var$numberTag = "[object Number]", $deef9fa3d0d203b4$var$regexpTag = "[object RegExp]", $deef9fa3d0d203b4$var$setTag = "[object Set]", $deef9fa3d0d203b4$var$stringTag = "[object String]", $deef9fa3d0d203b4$var$symbolTag = "[object Symbol]";
var $deef9fa3d0d203b4$var$arrayBufferTag = "[object ArrayBuffer]", $deef9fa3d0d203b4$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $deef9fa3d0d203b4$var$symbolProto = $4745131536d797ac$exports ? $4745131536d797ac$exports.prototype : undefined, $deef9fa3d0d203b4$var$symbolValueOf = $deef9fa3d0d203b4$var$symbolProto ? $deef9fa3d0d203b4$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $deef9fa3d0d203b4$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $deef9fa3d0d203b4$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $deef9fa3d0d203b4$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $7212f36cc885c70d$exports(object), new $7212f36cc885c70d$exports(other))) return false;
            return true;
        case $deef9fa3d0d203b4$var$boolTag:
        case $deef9fa3d0d203b4$var$dateTag:
        case $deef9fa3d0d203b4$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $ccd1dfea300b5fbe$exports(+object, +other);
        case $deef9fa3d0d203b4$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $deef9fa3d0d203b4$var$regexpTag:
        case $deef9fa3d0d203b4$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $deef9fa3d0d203b4$var$mapTag:
            var convert = $cf70be9909d091d4$exports;
        case $deef9fa3d0d203b4$var$setTag:
            var isPartial = bitmask & $deef9fa3d0d203b4$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $4d62faea1846faff$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $deef9fa3d0d203b4$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $05942e38cf5705e0$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $deef9fa3d0d203b4$var$symbolTag:
            if ($deef9fa3d0d203b4$var$symbolValueOf) return $deef9fa3d0d203b4$var$symbolValueOf.call(object) == $deef9fa3d0d203b4$var$symbolValueOf.call(other);
    }
    return false;
}
$deef9fa3d0d203b4$exports = $deef9fa3d0d203b4$var$equalByTag;


var $e7463e3db559fe94$exports = {};

/** Used to compose bitmasks for value comparisons. */ var $e7463e3db559fe94$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $e7463e3db559fe94$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e7463e3db559fe94$var$hasOwnProperty = $e7463e3db559fe94$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e7463e3db559fe94$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $e7463e3db559fe94$var$COMPARE_PARTIAL_FLAG, objProps = $240b6f17362122a6$exports(object), objLength = objProps.length, othProps = $240b6f17362122a6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $e7463e3db559fe94$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$e7463e3db559fe94$exports = $e7463e3db559fe94$var$equalObjects;





var $2W9As = parcelRequire("2W9As");

/** Used to compose bitmasks for value comparisons. */ var $5046d5266df03c41$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $5046d5266df03c41$var$argsTag = "[object Arguments]", $5046d5266df03c41$var$arrayTag = "[object Array]", $5046d5266df03c41$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $5046d5266df03c41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5046d5266df03c41$var$hasOwnProperty = $5046d5266df03c41$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $5046d5266df03c41$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $b879a56dcf4bb3c4$exports(object), othIsArr = $b879a56dcf4bb3c4$exports(other), objTag = objIsArr ? $5046d5266df03c41$var$arrayTag : $5148b26f310728ae$exports(object), othTag = othIsArr ? $5046d5266df03c41$var$arrayTag : $5148b26f310728ae$exports(other);
    objTag = objTag == $5046d5266df03c41$var$argsTag ? $5046d5266df03c41$var$objectTag : objTag;
    othTag = othTag == $5046d5266df03c41$var$argsTag ? $5046d5266df03c41$var$objectTag : othTag;
    var objIsObj = objTag == $5046d5266df03c41$var$objectTag, othIsObj = othTag == $5046d5266df03c41$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $2W9As(object)) {
        if (!$2W9As(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $d1833597dde236cc$exports);
        return objIsArr || $ee624536fbb2e003$exports(object) ? $05942e38cf5705e0$exports(object, other, bitmask, customizer, equalFunc, stack) : $deef9fa3d0d203b4$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $5046d5266df03c41$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $5046d5266df03c41$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $5046d5266df03c41$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $d1833597dde236cc$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $d1833597dde236cc$exports);
    return $e7463e3db559fe94$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$5046d5266df03c41$exports = $5046d5266df03c41$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $0399c2acb5c79914$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8e31d76e9d05173f$exports(value) && !$8e31d76e9d05173f$exports(other)) return value !== value && other !== other;
    return $5046d5266df03c41$exports(value, other, bitmask, customizer, $0399c2acb5c79914$var$baseIsEqual, stack);
}
$0399c2acb5c79914$exports = $0399c2acb5c79914$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $6c9f9b16fc379077$var$COMPARE_PARTIAL_FLAG = 1, $6c9f9b16fc379077$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $6c9f9b16fc379077$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $d1833597dde236cc$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $0399c2acb5c79914$exports(srcValue, objValue, $6c9f9b16fc379077$var$COMPARE_PARTIAL_FLAG | $6c9f9b16fc379077$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$6c9f9b16fc379077$exports = $6c9f9b16fc379077$var$baseIsMatch;


var $3d0593881937e7ad$exports = {};
var $064dc2e74a0d51ed$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $064dc2e74a0d51ed$var$isStrictComparable(value) {
    return value === value && !$38ff99188d059d52$exports(value);
}
$064dc2e74a0d51ed$exports = $064dc2e74a0d51ed$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $3d0593881937e7ad$var$getMatchData(object) {
    var result = $e1b1f7a0047f3f3f$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $064dc2e74a0d51ed$exports(value)
        ];
    }
    return result;
}
$3d0593881937e7ad$exports = $3d0593881937e7ad$var$getMatchData;


var $1fcbac305f3b23ae$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1fcbac305f3b23ae$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1fcbac305f3b23ae$exports = $1fcbac305f3b23ae$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $05a505468939b9e9$var$baseMatches(source) {
    var matchData = $3d0593881937e7ad$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1fcbac305f3b23ae$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $6c9f9b16fc379077$exports(object, source, matchData);
    };
}
$05a505468939b9e9$exports = $05a505468939b9e9$var$baseMatches;


var $7d5342a29dfb730d$exports = {};

var $18c6697b756f61e8$exports = {};

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $18c6697b756f61e8$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $d083c95cb49e5cc8$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$18c6697b756f61e8$exports = $18c6697b756f61e8$var$get;


var $a04732bcfd5dcb3d$exports = {};
var $ff2609063e5a8660$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $ff2609063e5a8660$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$ff2609063e5a8660$exports = $ff2609063e5a8660$var$baseHasIn;


var $84db498e33eb8ce5$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $84db498e33eb8ce5$var$hasPath(object, path, hasFunc) {
    path = $a4bd83859dadeb3a$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $7fdc918f901759c0$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $17cb4c1810bfad24$exports(length) && $df68d5fc40e11af3$exports(key, length) && ($b879a56dcf4bb3c4$exports(object) || $b7af7320b985fe40$exports(object));
}
$84db498e33eb8ce5$exports = $84db498e33eb8ce5$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $a04732bcfd5dcb3d$var$hasIn(object, path) {
    return object != null && $84db498e33eb8ce5$exports(object, path, $ff2609063e5a8660$exports);
}
$a04732bcfd5dcb3d$exports = $a04732bcfd5dcb3d$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $7d5342a29dfb730d$var$COMPARE_PARTIAL_FLAG = 1, $7d5342a29dfb730d$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $7d5342a29dfb730d$var$baseMatchesProperty(path, srcValue) {
    if ($63c87b7887a786eb$exports(path) && $064dc2e74a0d51ed$exports(srcValue)) return $1fcbac305f3b23ae$exports($7fdc918f901759c0$exports(path), srcValue);
    return function(object) {
        var objValue = $18c6697b756f61e8$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $a04732bcfd5dcb3d$exports(object, path) : $0399c2acb5c79914$exports(srcValue, objValue, $7d5342a29dfb730d$var$COMPARE_PARTIAL_FLAG | $7d5342a29dfb730d$var$COMPARE_UNORDERED_FLAG);
    };
}
$7d5342a29dfb730d$exports = $7d5342a29dfb730d$var$baseMatchesProperty;




var $6791808d6b5f7016$exports = {};
var $4636b53609afe12b$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4636b53609afe12b$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$4636b53609afe12b$exports = $4636b53609afe12b$var$baseProperty;


var $8d422cb22e5a212a$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $8d422cb22e5a212a$var$basePropertyDeep(path) {
    return function(object) {
        return $d083c95cb49e5cc8$exports(object, path);
    };
}
$8d422cb22e5a212a$exports = $8d422cb22e5a212a$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $6791808d6b5f7016$var$property(path) {
    return $63c87b7887a786eb$exports(path) ? $4636b53609afe12b$exports($7fdc918f901759c0$exports(path)) : $8d422cb22e5a212a$exports(path);
}
$6791808d6b5f7016$exports = $6791808d6b5f7016$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $39f94ea87b801ba3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $4a86c58530eeea0e$exports;
    if (typeof value == "object") return $b879a56dcf4bb3c4$exports(value) ? $7d5342a29dfb730d$exports(value[0], value[1]) : $05a505468939b9e9$exports(value);
    return $6791808d6b5f7016$exports(value);
}
$39f94ea87b801ba3$exports = $39f94ea87b801ba3$var$baseIteratee;


var $16081b84fa00ca19$exports = {};
var $29d0bf1b8fa8e286$exports = {};
var $a34f4768bfa6f3d9$exports = {};


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $a34f4768bfa6f3d9$var$baseForOwn(object, iteratee) {
    return object && $cdd21b77adaff744$exports(object, iteratee, $e1b1f7a0047f3f3f$exports);
}
$a34f4768bfa6f3d9$exports = $a34f4768bfa6f3d9$var$baseForOwn;


var $83465bb0da30253e$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $83465bb0da30253e$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$5e84ab26893f9442$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$83465bb0da30253e$exports = $83465bb0da30253e$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $29d0bf1b8fa8e286$var$baseEach = $83465bb0da30253e$exports($a34f4768bfa6f3d9$exports);
$29d0bf1b8fa8e286$exports = $29d0bf1b8fa8e286$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $16081b84fa00ca19$var$baseMap(collection, iteratee) {
    var index = -1, result = $5e84ab26893f9442$exports(collection) ? Array(collection.length) : [];
    $29d0bf1b8fa8e286$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$16081b84fa00ca19$exports = $16081b84fa00ca19$var$baseMap;


var $237588936a3e74a0$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $237588936a3e74a0$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$237588936a3e74a0$exports = $237588936a3e74a0$var$baseSortBy;



var $38432d7b4d82d0ca$exports = {};
var $0a9fd095afc25458$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $0a9fd095afc25458$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $e6cd81ba6bef786b$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $e6cd81ba6bef786b$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$0a9fd095afc25458$exports = $0a9fd095afc25458$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $38432d7b4d82d0ca$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $0a9fd095afc25458$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$38432d7b4d82d0ca$exports = $38432d7b4d82d0ca$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $179c70d25cc9d189$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $69747cf806d0c7fb$exports(iteratees, function(iteratee) {
        if ($b879a56dcf4bb3c4$exports(iteratee)) return function(value) {
            return $d083c95cb49e5cc8$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $4a86c58530eeea0e$exports
    ];
    var index = -1;
    iteratees = $69747cf806d0c7fb$exports(iteratees, $d26adae8a43490ae$exports($39f94ea87b801ba3$exports));
    var result = $16081b84fa00ca19$exports(collection, function(value, key, collection) {
        var criteria = $69747cf806d0c7fb$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $237588936a3e74a0$exports(result, function(object, other) {
        return $38432d7b4d82d0ca$exports(object, other, orders);
    });
}
$179c70d25cc9d189$exports = $179c70d25cc9d189$var$baseOrderBy;




/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $561d1469f5af3aeb$var$sortBy = $4b4070981097ce01$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $528771e5e3ed80e6$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $528771e5e3ed80e6$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $179c70d25cc9d189$exports(collection, $73d95962d1d3b7d5$exports(iteratees, 1), []);
});
$561d1469f5af3aeb$exports = $561d1469f5af3aeb$var$sortBy;



var $eC5G7 = parcelRequire("eC5G7");

var $eC5G7 = parcelRequire("eC5G7");

const $2d53608c5fc48ee9$export$3f5de6d9a9efe3ef = ()=>{
    const loadList = ()=>{
        const data = localStorage.getItem("SPDLZR");
        if (!data) return [];
        const k = data.slice(0, 20);
        const d = data.slice(20);
        const s = (0, (/*@__PURE__*/$parcel$interopDefault($eC5G7))).AES.decrypt(d, k);
        const v = s.toString((0, (/*@__PURE__*/$parcel$interopDefault($eC5G7))).enc.Utf8);
        if (!(v.length > 1)) return [];
        return JSON.parse(v);
    };
    const loadedList = loadList();
    const initials = "SPL";
    const list = [
        {
            initials: initials,
            score: 30000
        },
        {
            initials: initials,
            score: 20000
        },
        {
            initials: initials,
            score: 10000
        },
        {
            initials: initials,
            score: 5000
        },
        {
            initials: initials,
            score: 2500
        },
        {
            initials: initials,
            score: 1500
        },
        {
            initials: initials,
            score: 1000
        },
        {
            initials: initials,
            score: 5000
        },
        {
            initials: initials,
            score: 2000
        },
        {
            initials: initials,
            score: 1500
        }
    ].concat(loadedList);
    return (0, (/*@__PURE__*/$parcel$interopDefault($561d1469f5af3aeb$exports)))(list, "score").reverse();
};




(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).defineScene("GameOver", async ({ gameCompleted: gameCompleted = false, score: score = 0, checkpoint: checkpoint = null } = {})=>{
    // constructor
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).background("#000");
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.x = 0;
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.y = 0;
    const w = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width;
    const h = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height;
    const text = gameCompleted ? "Gefeliciteerd!" : "Game Over";
    console.log("checkpoint: ", checkpoint);
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text").attr({
        x: 0,
        y: h * 0.2,
        w: w
    }).text(text).textColor("#FF0000").textAlign("center").textFont({
        size: "50px",
        weight: "bold",
        family: "Press Start 2P"
    });
    const collect = [];
    let hs = (0, (/*@__PURE__*/$parcel$interopDefault($8e8207876291ad5b$exports)))((0, $2d53608c5fc48ee9$export$3f5de6d9a9efe3ef)());
    const task = (data)=>async ()=>{
            let s;
            let highScorePos = null;
            for(let i = 0; i < hs.length; i++){
                s = hs[i];
                if (s.player === data.player) highScorePos = i;
            }
            let t = `${data.name}: ${data.points}`;
            if (highScorePos < 10) {
                const rank = (()=>{
                    switch(highScorePos){
                        case 0:
                            return "ACE";
                        case 1:
                            return "2nd";
                        case 2:
                            return "3rd";
                        default:
                            return `${highScorePos + 1}th`;
                    }
                })();
                t += ` - ${rank}`;
            }
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text").attr({
                x: 0,
                y: h * 0.45 + data.index * 45,
                w: w
            }).text(t).textColor(data.color).textAlign("center").textFont({
                size: "20px",
                weight: "bold",
                family: "Press Start 2P"
            });
            if (highScorePos >= 10) return;
            const p = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text").attr({
                x: w * 0.25,
                y: h * 0.45 + (data.index + 1) * 45,
                w: w
            }).text("Enter name: ").textColor(data.color).textAlign("left").textFont({
                size: "20px",
                weight: "bold",
                family: "Press Start 2P"
            });
            const k = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("TextInput").attr({
                x: w * 0.6,
                y: h * 0.45 + (data.index + 1) * 45,
                w: w
            }).textColor(data.color).textAlign("left").textFont({
                size: "20px",
                weight: "bold",
                family: "Press Start 2P"
            });
            const name = await k.textInput(data.player, 3);
            const loadList = function() {
                const dat = localStorage.getItem("SPDLZR");
                if (!dat) return [];
                const ko = dat.slice(0, 20);
                const d = dat.slice(20);
                s = (0, (/*@__PURE__*/$parcel$interopDefault($eC5G7))).AES.decrypt(d, ko);
                const v = s.toString((0, (/*@__PURE__*/$parcel$interopDefault($eC5G7))).enc.Utf8);
                if (!(v.length > 1)) return [];
                return JSON.parse(v);
            };
            const l = loadList();
            l.push({
                initials: name,
                score: data.points,
                time: new Date().getTime()
            });
            const d = JSON.stringify(l);
            const ky = (0, (/*@__PURE__*/$parcel$interopDefault($eC5G7))).AES.encrypt(d, "secret").toString().slice(8, 28);
            const ed = (0, (/*@__PURE__*/$parcel$interopDefault($eC5G7))).AES.encrypt(d, ky).toString();
            localStorage.setItem("SPDLZR", ky + ed);
            p.destroy();
            k.destroy();
        };
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Player ControlScheme").each(function(index) {
        hs.push({
            initials: null,
            player: this,
            score: score
        });
        collect.push(task({
            index: index,
            name: this.name,
            points: score,
            player: this,
            color: this.color()
        }));
    });
    hs = (0, (/*@__PURE__*/$parcel$interopDefault($561d1469f5af3aeb$exports)))(hs, "score").reverse();
    await collect.reduce((p, t)=>p.then(t), Promise.resolve());
    // After a timeout, be able to replay
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Delay").delay(function() {
        if (!gameCompleted) {
            let time = 10;
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text").attr({
                x: 0,
                y: h * 0.8,
                w: w
            }).textColor("#FF0000").textAlign("center").textFont({
                size: "15px",
                weight: "bold",
                family: "Press Start 2P"
            }).text("Continue at last checkpoint?");
            const e = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text").attr({
                x: 0,
                y: h * 0.8 + 30,
                w: w
            }).textColor("#FF0000").textAlign("center").textFont({
                size: "15px",
                weight: "bold",
                family: "Press Start 2P"
            });
            const prefix = "Press fire to continue";
            e.text(`${prefix} ${`00${time}`.slice(-2)}`);
            this.delay(function() {
                time -= 1;
                e.text(`${prefix} ${`00${time}`.slice(-2)}`);
            }, 1000, time, ()=>(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("Scores"));
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Player").each(function() {
                this.reset();
                // add checkpoint mechanic
                this.one("Activated", ()=>(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("Game", {
                        start: checkpoint,
                        tags: (0, (/*@__PURE__*/$parcel$interopDefault($fbd39d42b4ec86c5$exports))).tags
                    }));
            });
        } else this.delay(()=>(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("Scores"), 5000);
    }, 1000, 0);
}, ()=>{
    // destructor
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Delay").each(function() {
        this.destroy();
    });
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Player").each(function() {
        this.unbind("Activated");
    });
});









(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).defineScene("Intro", async ()=>{
    // constructor
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).background("#000000");
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.x = 0;
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.y = 0;
    await (0, $d941c95fb300496e$export$1267480aba04282d)([
        "mega-texture"
    ]);
    const w = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width;
    const h = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height;
    const offset = 0.15;
    (0, $8c6a9ebc6fe6c24c$export$bb00580d34b43172)((0, $4a464ac9ac54fc86$export$7f9953c70dacfd7f)("title.Intro"), {});
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text, Tween, Delay").attr({
        x: w * (0.5 - offset),
        y: h * 0.1,
        w: 400
    }).text("Sintlazer").textColor("#ff0000").textFont({
        size: "40px",
        weight: "bold",
        family: "Press Start 2P"
    }).delay(function() {
        this.tween({
            x: w * (0.5 + offset) - 400
        }, 2000);
        this.one("TweenEnd", function() {
            this.tween({
                x: w * (0.5 - offset)
            }, 2000);
        });
    }, 4000, -1);
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text, Tween, Delay").attr({
        x: w * 0.5 - 150,
        y: h * 0.7,
        w: 300
    }).text("Press fire to start!").textColor("#FFFFFF").textFont({
        size: "15px",
        weight: "bold",
        family: "Press Start 2P"
    }).delay(function() {
        this.tween({
            alpha: 0.5
        }, 1000);
        this.one("TweenEnd", function() {
            this.tween({
                alpha: 1
            }, 1000);
        });
    }, 2000, -1);
    const entry = (0, $2d53608c5fc48ee9$export$3f5de6d9a9efe3ef)()[0];
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text").attr({
        x: 0,
        y: h * 0.85,
        w: w
    }).text(`HI SCORE: ${entry.score} ${entry.initials}`).textColor("#FFFF00").textAlign("center").textFont({
        size: "10px",
        weight: "bold",
        family: "Press Start 2P"
    });
    const gamepadConnect = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text").attr({
        x: 0,
        y: h * 0.95,
        w: w
    }).text("").textColor("#303030").textAlign("center").textFont({
        size: "10px",
        weight: "bold",
        family: "Press Start 2P"
    });
    window.addEventListener("gamepadconnected", ()=>{
        gamepadConnect.text(`Gamepad detected!`);
    });
    const pads = window.navigator.getGamepads();
    const hasGamePad = Array.from(pads).some((pad)=>pad && pad.connected);
    hasGamePad && gamepadConnect.text("Gamepad detected!");
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)((0, $a483b8029d48b758$export$2e2bcd8739ae039)).each(function() {
        this.reset();
        this.one("Activated", ()=>(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("Game", {
                tags: (0, (/*@__PURE__*/$parcel$interopDefault($fbd39d42b4ec86c5$exports))).tags
            }));
    });
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Delay").delay(()=>(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("Scores"), 20000);
}, ()=>{
    // destructor
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Delay").each(function() {
        this.destroy();
    });
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)((0, $a483b8029d48b758$export$2e2bcd8739ae039)).each(function() {
        this.unbind("Activated");
    });
});





const $a6b13267068ecea7$var$getNum = (num)=>{
    switch(num){
        case 0:
            return "ACE";
        case 1:
            return "2nd";
        case 2:
            return "3rd";
        default:
            return `${num + 1}th`;
    }
};
const $a6b13267068ecea7$var$getSize = (num)=>{
    switch(num){
        case 0:
            return "20px";
        case 1:
        case 2:
            return "18px";
        default:
            return "15px";
    }
};
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).defineScene("Scores", function() {
    // import from globals
    // constructor
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).background("#000000");
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.x = 0;
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.y = 0;
    const w = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width;
    const h = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height;
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text").attr({
        x: 0,
        y: h * 0.1,
        w: w
    }).text("Highscores").textColor("#FF0000").textAlign("center").textFont({
        size: "40px",
        weight: "bold",
        family: "Press Start 2P"
    });
    const scores = (0, $2d53608c5fc48ee9$export$3f5de6d9a9efe3ef)();
    let i = 0;
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Delay").delay(function() {
        const entry = scores[i];
        if (entry) {
            const nr = $a6b13267068ecea7$var$getNum(i);
            const size = $a6b13267068ecea7$var$getSize(i);
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text").attr({
                x: 0,
                y: h * 0.25 + 36 * i,
                w: w
            }).text(`${nr}  ${entry.score} ${entry.initials}`).textColor("#FFFF00").textAlign("center").textFont({
                size: size,
                weight: "bold",
                family: "Press Start 2P"
            });
            i += 1;
        }
    }, 500, 9);
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Player").each(function() {
        this.reset();
        this.one("Activated", ()=>(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("Game", {
                tags: (0, (/*@__PURE__*/$parcel$interopDefault($fbd39d42b4ec86c5$exports))).tags
            }));
    });
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Delay").delay(()=>(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("Credits"), 20000);
}, function() {
    // destructor
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Delay").each(function() {
        this.destroy();
    });
    return (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Player").each(function() {
        this.unbind("Activated");
    });
});




const $c065f700e997123a$var$credits = [
    [
        "Designed by",
        [
            "Matthijs Groen"
        ]
    ],
    [
        "Programming",
        [
            "Matthijs Groen"
        ]
    ],
    [
        "Graphics",
        [
            "Matthijs Groen",
            "& Midjourney"
        ]
    ],
    [
        "Music",
        [
            "Some Midis"
        ]
    ],
    [
        "Testing",
        [
            "Matthijs Groen"
        ]
    ]
];
const $c065f700e997123a$var$NAME_DURATION = 1500;
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).defineScene("Credits", function() {
    // import from globals
    // constructor
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).background("#000000");
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.x = 0;
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.y = 0;
    const w = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.width;
    const h = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).viewport.height;
    let i = 0;
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text, CreditTask").attr({
        x: 0,
        y: h * 0.4,
        w: w
    }).textColor("#FF0000").textAlign("center").textFont({
        size: "30px",
        weight: "bold",
        family: "Press Start 2P"
    });
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("2D, DOM, Text, CreditNames").attr({
        x: 0,
        y: h * 0.5,
        w: w,
        h: 300
    }).textColor("#FFFF00").textAlign("center").textFont({
        size: "20px",
        weight: "bold",
        family: "Press Start 2P"
    });
    const title = $c065f700e997123a$var$credits[i][0];
    const names = $c065f700e997123a$var$credits[i][1];
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("CreditTask").text(title);
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("CreditNames").text(names.join("\n"));
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Delay").delay(()=>{
        i += 1;
        const title = $c065f700e997123a$var$credits[i][0];
        const names = $c065f700e997123a$var$credits[i][1];
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("CreditTask").text(title);
        (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("CreditNames").text(names.join("\n"));
    }, $c065f700e997123a$var$NAME_DURATION, $c065f700e997123a$var$credits.length - 2);
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Player").each(function() {
        this.reset();
        this.one("Activated", ()=>(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("Game", {
                tags: (0, (/*@__PURE__*/$parcel$interopDefault($fbd39d42b4ec86c5$exports))).tags
            }));
    });
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e("Delay").delay(()=>(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("Intro"), $c065f700e997123a$var$credits.length * $c065f700e997123a$var$NAME_DURATION);
}, function() {
    // destructor
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Delay").each(function() {
        this.destroy();
    });
    return (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)("Player").each(function() {
        this.unbind("Activated");
    });
});








const $76b2bc40c1d09c8d$var$AnalogKeyboardControls = "AnalogKeyboardControls";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($76b2bc40c1d09c8d$var$AnalogKeyboardControls, {
    init () {
        this._player = null;
        this.requires((0, $1694be6dff51cc24$export$2e2bcd8739ae039));
        this.bind("RemoveComponent", (componentName)=>{
            if (componentName === (0, $f62344210ab4fe80$export$2e2bcd8739ae039)) this.removeComponent($76b2bc40c1d09c8d$var$AnalogKeyboardControls);
        });
    },
    remove () {
        this.unbind("KeyDown", this._keyHandling);
    },
    setupControls (player) {
        this._player = player;
        player.addComponent((0, $f62344210ab4fe80$export$2e2bcd8739ae039));
        player.assignControls = (ship)=>{
            this.assignControls(ship);
        };
    },
    controls (controlMap) {
        this.controlMap = controlMap;
        this.uniqueBind("KeyDown", this._keyHandling);
        return this;
    },
    _keyHandling (e) {
        if (this.controlMap.pause.some((key)=>key === e.key)) (0, $925b104f0bb9b62a$export$8b09b726120a992d)();
        if (this.controlMap.fire.some((key)=>key === e.key)) {
            this.trigger("Fire", e);
            this._player && this._player.trigger("Fire", e);
        }
        if (this.controlMap.up.some((key)=>key === e.key)) {
            this.trigger("Up", e);
            this._player && this._player.trigger("Up", e);
        }
        if (this.controlMap.down.some((key)=>key === e.key)) {
            this.trigger("Down", e);
            this._player && this._player.trigger("Down", e);
        }
        if (this.controlMap.left.some((key)=>key === e.key)) {
            this.trigger("Left", e);
            this._player && this._player.trigger("Left", e);
        }
        if (this.controlMap.right.some((key)=>key === e.key)) {
            this.trigger("Right", e);
            this._player && this._player.trigger("Right", e);
        }
    },
    assignControls (ship) {
        if (ship.hasPlayerControls) return;
        const { controlMap: controlMap } = this;
        const MAX_X_SPEED = 700;
        const MAX_Y_SPEED = 500;
        const ACCELERATE_Y = MAX_Y_SPEED * 6;
        const ACCELERATE_X = MAX_X_SPEED * 6;
        let yDir = 0;
        let xDir = 0;
        let pressed = {
            up: false,
            down: false,
            left: false,
            right: false
        };
        ship.hasPlayerControls = true;
        ship.addComponent("Motion").bind("GamePause", function(paused) {
            if (paused) {
                pressed = {
                    up: false,
                    down: false,
                    left: false,
                    right: false
                };
                this.disabledBeforePause = this.disableControls;
                this.disableControl();
            } else if (!this.disabledBeforePause) this.enableControl();
        }).bind("Move", function() {
            const yLimit = MAX_Y_SPEED * yDir;
            if (this.vy < yLimit && yLimit <= 0 && this.ay < 0 || this.vy > yLimit && yLimit >= 0 && this.ay > 0) {
                this.vy = yLimit;
                this.ay = 0;
            }
            const xLimit = MAX_X_SPEED * xDir;
            if (this.vx < xLimit && xLimit <= 0 && this.ax < 0 || this.vx > xLimit && xLimit >= 0 && this.ax > 0) {
                this.vx = xLimit;
                this.ax = 0;
            }
        });
        ship.controlName = (mapItem, short = false)=>{
            const keys = this.controlMap[mapItem];
            const names = keys.map((key)=>{
                switch(key){
                    case (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.SPACE:
                        return "spacebar";
                    case (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.SHIFT:
                        return "shift";
                }
                return `${String.fromCharCode(key)}${short ? "" : " key"}`;
            });
            return short ? names[0] : names.join(" or ");
        };
        ship.disableControls = false;
        ship.prevSets = {
            ax: ship.ax,
            ay: ship.ay,
            vx: ship.vx,
            vy: ship.vy
        };
        ship.disableControl = function() {
            if (this.disableControls === true) return;
            this.disableControls = true;
            this.prevSets = {
                ax: this.ax,
                ay: this.ay,
                vx: this.vx,
                vy: this.vy
            };
            this.ax = 0;
            this.ay = 0;
            this.vx = 0;
            this.vy = 0;
            xDir = 0;
            yDir = 0;
        };
        ship.enableControl = function() {
            if (this.disableControls === false) return;
            this.disableControls = false;
            this.ax = this.prevSets.ax;
            this.ay = this.prevSets.ay;
            this.vx = this.prevSets.vx;
            this.vy = this.prevSets.vy;
        };
        const updateAcceleration = ()=>{
            yDir = 0;
            if (pressed.up) yDir -= 1;
            if (pressed.down) yDir += 1;
            yDir = Math.min(1, Math.max(-1, yDir));
            ship.ay += ACCELERATE_Y * yDir;
            if (ship.vy > 0 && ship.ay === 0) // decellerate
            ship.ay -= ACCELERATE_Y * 2;
            if (ship.vy < 0 && ship.ay === 0) // decellerate
            ship.ay += ACCELERATE_Y * 2;
            xDir = 0;
            if (pressed.left) xDir -= 1;
            if (pressed.right) xDir += 1;
            xDir = Math.min(1, Math.max(-1, xDir));
            ship.ax += ACCELERATE_X * xDir;
            if (ship.vx > 0 && ship.ax === 0) // decellerate
            ship.ax -= ACCELERATE_X * 2;
            if (ship.vx < 0 && ship.ax === 0) // decellerate
            ship.ax += ACCELERATE_X * 2;
        };
        this.listenTo(ship, "KeyDown", function(e) {
            if (ship.disableControls) return;
            Object.entries(controlMap).forEach(([action, buttons])=>{
                if (buttons.some((key)=>key === e.key)) ship.buttonPressed(action, true);
            });
            if (controlMap.up.some((key)=>key === e.key)) pressed.up = true;
            if (controlMap.down.some((key)=>key === e.key)) pressed.down = true;
            if (controlMap.left.some((key)=>key === e.key)) pressed.left = true;
            if (controlMap.right.some((key)=>key === e.key)) pressed.right = true;
            updateAcceleration();
        });
        this.listenTo(ship, "KeyUp", function(e) {
            if (ship.disableControls) return;
            Object.entries(controlMap).forEach(([action, buttons])=>{
                if (buttons.some((key)=>key === e.key)) ship.buttonPressed(action, false);
            });
            if (controlMap.up.some((key)=>key === e.key)) pressed.up = false;
            if (controlMap.down.some((key)=>key === e.key)) pressed.down = false;
            if (controlMap.left.some((key)=>key === e.key)) pressed.left = false;
            if (controlMap.right.some((key)=>key === e.key)) pressed.right = false;
            updateAcceleration();
        });
    }
});
var $76b2bc40c1d09c8d$export$2e2bcd8739ae039 = $76b2bc40c1d09c8d$var$AnalogKeyboardControls;





/* Gives entities gamepad events.
 *
 * NOTE: The HTML5 Gamepad API is yet experimental and subject to change.
 *       Expect this code to break until the Gamepad API is stable.
 *       So far has only been tested with Google Chrome and Xbox 360
 *       controllers.
 *
 * Since a gamepad can have analog buttons with states between 0.0 and 1.0
 * (LT and RT on a Xbox 360 controller for example) there are no such
 * events like KeyDown or KeyUp but only GamepadKeyChange. The event object
 * contains the properties "button" (index of button) and "value".
 * Receivers of these events must decide whether a button is pressed by
 * applying a threshold, for instance.
 *
 * Same goes for axes events which are fired as GamepadAxisChange. The event
 * objects has the properties "axis" (index of axis) and "value".
 *
 * The index of the gamepad which this component is listening for has
 * to be specified when calling the constructor gamepad(index).
 *
 * Important: Gamepads will only be reported by the Gamepad API once a button
 * on the desired gamepad has been pressed.
 *
 * For a nice Gamepad API tutorial see
 * http://www.html5rocks.com/en/tutorials/doodles/gamepad/
 *
 * @version 0.0.1
 * @author Sven Jacobs <mail@svenjacobs.com>
 */ const $d32184d53307e179$var$Gamepad = "Gamepad";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($d32184d53307e179$var$Gamepad, {
    _gpEnterFrame: function() {
        var gamepad = this._getGamepad(this._gamepadIndex);
        // Only evaluate buttons/axes when we found a gamepad and there
        // have been changes according to timestamp.
        if (gamepad && gamepad.timestamp !== this._timestamp) {
            this._timestamp = gamepad.timestamp;
            this._emitGamepadEvents(gamepad);
        }
    },
    _emitGamepadEvents: function(gamepad) {
        for(var i = 0; i < gamepad.buttons.length; i++){
            if (this._buttonsState[i] !== undefined && this._buttonsState[i] !== gamepad.buttons[i].value || this._buttonsState[i] === undefined && gamepad.buttons[i].value !== 0.0) this.trigger("GamepadKeyChange", {
                button: i,
                value: gamepad.buttons[i].value,
                pressed: gamepad.buttons[i].pressed
            });
            this._buttonsState[i] = gamepad.buttons[i].value;
        }
        for(var j = 0; j < gamepad.axes.length; j++)if (this._axesState[j] !== undefined && this._axesState[j] !== gamepad.axes[j] || this._axesState[j] === undefined && gamepad.axes[j] !== 0.0) this.trigger("GamepadAxisChange", {
            axis: j,
            value: gamepad.axes[j]
        });
    },
    _getGamepad: function() {
        var gamepad = null, fun = navigator.getGamepads || navigator.webkitGetGamepads;
        if (fun) gamepad = fun.apply(navigator)[this._gamepadIndex];
        return gamepad;
    },
    /* Constructor
   *
   * Specify index of gamepad as first argument.
   */ gamepad: function(gamepadIndex) {
        this._gamepadIndex = gamepadIndex || 0;
        this._timestamp = 0;
        this._buttonsState = [];
        this._axesState = [];
        this.bind("EnterFrame", this._gpEnterFrame);
        return this;
    }
});
/* Controls an entity with a gamepad.
 *
 * The index of the gamepad and other options need to be specified
 * when calling the constructor (mandatory!), see gamepadMultiway().
 */ (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c("GamepadMultiway", {
    _AXIS_THRESHOLD: 0.75,
    _AXIS_ANALOG_THRESHOLD: 0.12,
    // Key is index of gamepad.buttons[] array for specific key,
    // value is direction in degrees.
    _BUTTONS_DIRECTION: {
        12: -90,
        13: 90,
        14: 180,
        15: 0 // pad right
    },
    // Key is index of gamepad.axes[] and value is an array where first
    // index describes degrees of value -1.0 (completely left or up)
    // and second index degrees of value 1.0 (completely right or down).
    // A threshold is applied to analog values, see above.
    _AXES_DIRECTION: {
        0: [
            180,
            0
        ],
        1: [
            -90,
            90
        ],
        2: [
            180,
            0
        ],
        3: [
            -90,
            90
        ] // right vertical
    },
    init: function() {
        this.requires("Motion, Gamepad");
    },
    _gamepadKeyChange: function(e) {
        if (this.disableControls) return;
        if (e.button in this._BUTTONS_DIRECTION) {
            if (e.value === 1.0 && this._buttonsPressed.indexOf(e.button) === -1) {
                this.vx = Math.round((this.vx + this._buttons[e.button].x) * 1000) / 1000;
                this.vy = Math.round((this.vy + this._buttons[e.button].y) * 1000) / 1000;
                this._buttonsPressed.push(e.button);
            } else if (e.value === 0.0 && this._buttonsPressed.indexOf(e.button) !== -1) {
                this.vx = Math.round((this.vx - this._buttons[e.button].x) * 1000) / 1000;
                this.vy = Math.round((this.vy - this._buttons[e.button].y) * 1000) / 1000;
                this._buttonsPressed.splice(this._buttonsPressed.indexOf(e.button), 1);
            }
        }
    },
    _gamepadAxisChange: function(e) {
        if (this.disableControls) return;
        if (e.axis in this._AXES_DIRECTION) {
            if (this._analogControl) this._analogHandling(e);
            else this._digitalHandling(e);
        }
    },
    _digitalHandling: function(e) {
        if (e.value <= -this._AXIS_THRESHOLD || e.value >= this._AXIS_THRESHOLD) {
            var dir = e.value < 0 ? 0 : 1, id = e.axis + ":" + dir;
            if (this._axesPressed.indexOf(id) !== -1) return;
            this.vx = Math.round((this.vx + this._axes[e.axis][dir].x) * 1000) / 1000;
            this.vy = Math.round((this.vy + this._axes[e.axis][dir].y) * 1000) / 1000;
            // store axes index and direction (0 = left/up, 1 = right/down)
            this._axesPressed.push(id);
        } else for(var i = 0; i < this._axesPressed.length; i++){
            var ap = this._axesPressed[i];
            // direction had been pressed before and now was released
            if (parseInt(ap.substr(0, 1), 10) === e.axis) {
                var s = ap.split(":");
                this.vx = Math.round((this.vx - this._axes[e.axis][parseInt(s[1], 10)].x) * 1000) / 1000;
                this.vy = Math.round((this.vy - this._axes[e.axis][parseInt(s[1], 10)].y) * 1000) / 1000;
                this._axesPressed.splice(this._axesPressed.indexOf(ap), 1);
            }
        }
    },
    _analogHandling: function(e) {
        if (e.value <= -this._AXIS_ANALOG_THRESHOLD || e.value >= this._AXIS_ANALOG_THRESHOLD) {
            if (e.axis === 0) // left / right
            this.vx = e.value * this._speed.x;
            if (e.axis === 1) // up / down
            this.vy = e.value * this._speed.y;
        } else {
            if (e.axis === 0) // left / right
            this.vx = 0;
            if (e.axis === 1) // up / down
            this.vy = 0;
        }
    },
    _calcSpeed: function(speed) {
        for(var b in this._BUTTONS_DIRECTION)this._buttons[b] = {
            x: Math.round(Math.cos(this._BUTTONS_DIRECTION[b] * (Math.PI / 180)) * 1000 * speed.x) / 1000,
            y: Math.round(Math.sin(this._BUTTONS_DIRECTION[b] * (Math.PI / 180)) * 1000 * speed.y) / 1000
        };
        for(var a in this._AXES_DIRECTION){
            this._axes[a] = [];
            this._axes[a][0] = {
                x: Math.round(Math.cos(this._AXES_DIRECTION[a][0] * (Math.PI / 180)) * 1000 * speed.x) / 1000,
                y: Math.round(Math.sin(this._AXES_DIRECTION[a][0] * (Math.PI / 180)) * 1000 * speed.y) / 1000
            };
            this._axes[a][1] = {
                x: Math.round(Math.cos(this._AXES_DIRECTION[a][1] * (Math.PI / 180)) * 1000 * speed.x) / 1000,
                y: Math.round(Math.sin(this._AXES_DIRECTION[a][1] * (Math.PI / 180)) * 1000 * speed.y) / 1000
            };
        }
    },
    /* Constructor
   *
   * Takes a configuration object which may contain the following
   * properties:
   *
   * speed: either a number describing the speed in pixel for both
   *        directions (x, y) or an object with properties "x" and "y"
   *        describing speed individually, e.g. "{x: 2, y: 3}"
   *
   * gamepadIndex: Index (zero-based) of gamepad to use
   */ gamepadMultiway: function(config) {
        config = config || {};
        this.requires("Gamepad");
        this.gamepad(config.gamepadIndex || 0);
        this._speed = {
            x: 150,
            y: 150
        };
        this._buttons = {};
        this._buttonsPressed = [];
        this._axes = {};
        this._axesPressed = [];
        this._speedOnAxes = {};
        this._analogControl = (0, config.analog);
        if (config.speed) {
            if (config.speed.x && config.speed.y) {
                this._speed.x = config.speed.x;
                this._speed.y = config.speed.y;
            } else {
                this._speed.x = config.speed;
                this._speed.y = config.speed;
            }
        }
        this._calcSpeed(this._speed);
        this.bind("GamepadKeyChange", this._gamepadKeyChange);
        this.bind("GamepadAxisChange", this._gamepadAxisChange);
        return this;
    },
    /**@
   * #.enableControl
   * @comp GamepadMultiway
   * @sign public this .enableControl()
   *
   * Enable the component to listen to axis events.
   *
   * @example
   * ~~~
   * this.enableControl();
   * ~~~
   */ enableControl: function() {
        this.disableControls = false;
        if (this.disabledVelocities !== undefined) {
            this.vx = this.disabledVelocities.x;
            this.vy = this.disabledVelocities.y;
        }
        this.disabledVelocities = undefined;
        return this;
    },
    /**@
   * #.disableControl
   * @comp GamepadMultiway
   * @sign public this .disableControl()
   *
   * Disable the component to listen to axis events.
   *
   * @example
   * ~~~
   * this.disableControl();
   * ~~~
   */ disableControl: function() {
        this.disableControls = true;
        this.disabledVelocities = {
            x: this.vx,
            y: this.vy
        };
        this.vx = 0;
        this.vy = 0;
        return this;
    }
});
var $d32184d53307e179$export$2e2bcd8739ae039 = $d32184d53307e179$var$Gamepad;




const $d49052e950c3d0b8$var$GamepadControls = "GamepadControls";
const $d49052e950c3d0b8$var$PS_LONG_BUTTON_NAMES = [
    "\u2716 button",
    "\u25EF button",
    "\u25A1 button",
    "\u25B3 button",
    "Left shoulder button (L1)",
    "Right shoulder button (R1)",
    "Left trigger (L2)",
    "Right trigger (R2)",
    "Share button",
    "Option button",
    "Left stick (L3)",
    "Right stick (R3)",
    "D-pad up button",
    "D-pad down button",
    "D-pad left button",
    "D-pad right button",
    "Playstation button",
    "touchpad"
];
const $d49052e950c3d0b8$var$PS_SHORT_BUTTON_NAMES = [
    "\u2716",
    "\u25EF",
    "\u25A1",
    "\u25B3",
    "L1",
    "R1",
    "L2",
    "R2",
    "Share button",
    "Option button",
    "L3",
    "R3",
    "D-pad up",
    "D-pad down",
    "D-pad left",
    "D-pad right",
    "Playstation",
    "touchpad"
];
const $d49052e950c3d0b8$var$XBOX_LONG_BUTTON_NAMES = [
    "a button",
    "b button",
    "x button",
    "y button",
    "Left bumper (LB)",
    "Right bumper (RB)",
    "Left trigger (LT)",
    "Right trigger (RT)",
    "Select button",
    "Start button",
    "Left stick (L)",
    "Right stick (R)",
    "D-pad up button",
    "D-pad down button",
    "D-pad left button",
    "D-pad right button"
];
const $d49052e950c3d0b8$var$XBOX_SHORT_BUTTON_NAMES = [
    "a",
    "b",
    "x",
    "y",
    "LB",
    "RB",
    "LT",
    "RT",
    "Select button",
    "Start button",
    "L",
    "R",
    "D-pad up",
    "D-pad down",
    "D-pad left",
    "D-pad right"
];
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($d49052e950c3d0b8$var$GamepadControls, {
    init () {
        this.requires((0, $1694be6dff51cc24$export$2e2bcd8739ae039));
        this.bind("RemoveComponent", function(componentName) {
            if (componentName === (0, $f62344210ab4fe80$export$2e2bcd8739ae039)) this.removeComponent($d49052e950c3d0b8$var$GamepadControls);
        });
        this.emits = {};
    },
    remove () {
        this.unbind("GamepadKeyChange", this._keyHandling);
    },
    setupControls (player) {
        this._player = player;
        player.addComponent((0, $f62344210ab4fe80$export$2e2bcd8739ae039));
        player.assignControls = (ship)=>{
            this.assignControls(ship);
        };
    },
    controls (controlMap) {
        this.controlMap = controlMap;
        if (controlMap.gamepadIndex == null) return;
        this.requires((0, $d32184d53307e179$export$2e2bcd8739ae039));
        this.gamepad(controlMap.gamepadIndex);
        this.bind("GamepadKeyChange", this._keyHandling);
        this.bind("GamepadAxisChange", this._stickHandling);
        return this;
    },
    _stickHandling (e) {
        // TODO: Detect start motion, start emitting 'up / down', 'left / right'
        // Detect end motion
        //
        //   axis: j,
        //   value: gamepad.axes[j]
        let direction;
        if (e.axis === 1) {
            // left stick: up / down
            direction = "vertical";
            if (e.value < -0.5) this._startEmit(direction, "Up");
            else if (e.value > 0.5) this._startEmit(direction, "Down");
            else this._stopEmit(direction);
        }
        if (e.axis === 0) {
            // left stick: left / right
            direction = "horizontal";
            if (e.value < -0.5) this._startEmit(direction, "Left");
            else if (e.value > 0.5) this._startEmit(direction, "Right");
            else this._stopEmit(direction);
        }
    },
    _startEmit (axis, value) {
        if ((this.emits[axis] && this.emits[axis].value) === value) return;
        this._stopEmit(axis);
        this.trigger(value);
        this._player && this._player.trigger(value);
        this.emits[axis] = {
            interval: setInterval(()=>{
                this.trigger(value);
                this._player && this._player.trigger(value);
            }, 200),
            value: value
        };
    },
    _stopEmit (axis) {
        clearInterval(this.emits[axis] && this.emits[axis].interval);
        return delete this.emits[axis];
    },
    _keyHandling (e) {
        if (this.lastPressed && this.lastPressed.getTime() > new Date().getTime() - 200) return;
        this.lastPressed = new Date();
        if (e.button === this.controlMap.pause && e.pressed) (0, $925b104f0bb9b62a$export$8b09b726120a992d)();
        if (e.button === this.controlMap.fire && e.pressed) {
            this.trigger("Fire", e);
            this._player && this._player.trigger("Fire", e);
        }
        if (e.button === this.controlMap.up && e.pressed) {
            this.trigger("Up", e);
            this._player && this._player.trigger("Up", e);
        }
        if (e.button === this.controlMap.down && e.pressed) {
            this.trigger("Down", e);
            this._player && this._player.trigger("Down", e);
        }
        if (e.button === this.controlMap.left && e.pressed) {
            this.trigger("Left", e);
            this._player && this._player.trigger("Left", e);
        }
        if (e.button === this.controlMap.right && e.pressed) {
            this.trigger("Right", e);
            this._player && this._player.trigger("Right", e);
        }
    },
    assignControls (ship) {
        if (ship.hasPlayerControls) return;
        ship.hasPlayerControls = true;
        ship.addComponent("GamepadMultiway").gamepadMultiway({
            speed: {
                y: 550,
                x: 750
            },
            gamepadIndex: this.controlMap.gamepadIndex,
            analog: true
        }).bind("GamePause", function(paused) {
            if (paused) {
                this.disabledBeforePause = this.disableControls;
                this.disableControl();
            } else if (!this.disabledBeforePause) this.enableControl();
        });
        const gamepad = this._getGamepad();
        const psController = [
            "sony",
            "dualshock",
            "playstation",
            "sixaxis",
            "ps3",
            "ps3",
            "ps(r)"
        ].some((name)=>gamepad.id.toLowerCase().indexOf(name) !== -1);
        const xboxController = [
            "xbox",
            "x-box"
        ].some((name)=>gamepad.id.toLowerCase().indexOf(name) !== -1);
        console.log(psController ? "Playstation controller" : xboxController ? "XBox controller" : `Generic controller ${gamepad.id}`);
        ship.controlName = (mapItem, short = false)=>{
            const gamepad = this._getGamepad();
            const button = this.controlMap[mapItem];
            if (gamepad.id) {
                if (psController) return (short ? $d49052e950c3d0b8$var$PS_SHORT_BUTTON_NAMES : $d49052e950c3d0b8$var$PS_LONG_BUTTON_NAMES)[button];
                if (xboxController) return (short ? $d49052e950c3d0b8$var$XBOX_SHORT_BUTTON_NAMES : $d49052e950c3d0b8$var$XBOX_LONG_BUTTON_NAMES)[button];
            }
            let num = "1st";
            switch(button){
                case 0:
                    num = "1st";
                    break;
                case 1:
                    num = "2nd";
                    break;
                case 2:
                    num = "3rd";
                    break;
                default:
                    num = `${button + 1}th`;
                    break;
            }
            return `${num}${short ? "" : " button"}`;
        };
        this.listenTo(ship, "GamepadKeyChange", (e)=>{
            Object.entries(this.controlMap).forEach(([action, button])=>{
                if (button === e.button) ship.buttonPressed(action, e.pressed);
            });
        });
    }
});
var $d49052e950c3d0b8$export$2e2bcd8739ae039 = $d49052e950c3d0b8$var$GamepadControls;





const $5ba36d6d58a35f3b$var$PlayerAssignable = "PlayerAssignable";
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).c($5ba36d6d58a35f3b$var$PlayerAssignable, {
    init () {
        this._attachControllerAssignTrigger();
        this.preferredPlayer = null;
    },
    _assignControls () {
        const player = this._preferredPlayer() || this._firstUnassignedPlayer();
        if (player == null) {
            // Try again next time
            this._attachControllerAssignTrigger();
            return;
        }
        this.preferredPlayer = player.getId();
        this.setupControls(player);
        player.one("Deactivated", ()=>{
            this._attachControllerAssignTrigger();
        });
    },
    _attachControllerAssignTrigger () {
        this.one("Fire", this._assignControls);
    },
    _preferredPlayer () {
        if (this.preferredPlayer !== null) {
            const player = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(this.preferredPlayer);
            if (!player.has((0, $f62344210ab4fe80$export$2e2bcd8739ae039))) return player;
        }
    },
    _firstUnassignedPlayer () {
        const players = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)((0, $a483b8029d48b758$export$2e2bcd8739ae039));
        return Array.from(players).map((playerId)=>(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039)(playerId)).find((player)=>!player.has((0, $f62344210ab4fe80$export$2e2bcd8739ae039)));
    }
});
var $5ba36d6d58a35f3b$export$2e2bcd8739ae039 = $5ba36d6d58a35f3b$var$PlayerAssignable;




const $6c1d2e7c1b3c8947$export$d3b63962eb93dd2c = ()=>{
    const player = (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e([
        (0, $a483b8029d48b758$export$2e2bcd8739ae039),
        "Color"
    ].join(", ")).attr({
        name: "Player 1",
        z: 0,
        playerNumber: 1
    }).setName("Player 1").color("#FF0000");
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e([
        (0, $76b2bc40c1d09c8d$export$2e2bcd8739ae039),
        (0, $5ba36d6d58a35f3b$export$2e2bcd8739ae039)
    ].join(", ")).controls({
        fire: [
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.SPACE
        ],
        heavy: [
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.C,
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.SHIFT
        ],
        switchWeapon: [
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.Z
        ],
        shield: [
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.X
        ],
        up: [
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.UP_ARROW,
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.W
        ],
        down: [
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.DOWN_ARROW,
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.S
        ],
        left: [
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.LEFT_ARROW,
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.A
        ],
        right: [
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.RIGHT_ARROW,
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.D
        ],
        power1: [
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys["1"]
        ],
        pause: [
            (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).keys.P
        ]
    });
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e([
        (0, $d49052e950c3d0b8$export$2e2bcd8739ae039),
        (0, $5ba36d6d58a35f3b$export$2e2bcd8739ae039)
    ].join(", ")).controls({
        gamepadIndex: 0,
        fire: 0,
        heavy: 1,
        switchWeapon: 2,
        power1: 4,
        pause: 9,
        up: 12,
        down: 13,
        left: 14,
        right: 15
    });
    return player;
};





let $2f900948fb2a01c9$var$gameTime = 0;
const $2f900948fb2a01c9$var$gameLoop = (fd)=>{
    fd.dt = fd.dt * (0, $2e5c1713fb068b10$export$ad7a301ff9ed764b)();
    if (!(0, $925b104f0bb9b62a$export$1232c5f90e8c2039)()) $2f900948fb2a01c9$var$gameTime += fd.dt;
    fd.inGameTime = $2f900948fb2a01c9$var$gameTime;
    if (fd.dt === 0) return;
    (0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).trigger("GameLoop", fd);
};
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).uniqueBind("UpdateFrame", $2f900948fb2a01c9$var$gameLoop);







(0, $d4d953306f5c187b$export$2e2bcd8739ae039).setEffectVolume((0, $0d00920b13fd9802$export$2e2bcd8739ae039)("effectsVolume", 0.4));
(0, $d4d953306f5c187b$export$2e2bcd8739ae039).setMusicVolume((0, $0d00920b13fd9802$export$2e2bcd8739ae039)("musicVolume", 0.4));
(0, $2e5c1713fb068b10$export$ea1f1c9e80b89b51)(1.0);
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).paths({
    images: "./"
});
// Start crafty and set a background color so that we can see it's working
const $c320a3655ca1a5bc$var$stage = document.getElementById("cr-stage");
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).init(1024, 576, $c320a3655ca1a5bc$var$stage); // PAL+
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).background("#000000");
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).timer.FPS(60);
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).timer.steptype("variable");
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).createLayer("UILayerDOM", "DOM", {
    scaleResponse: 0,
    yResponse: 0,
    xResponse: 0,
    z: 40
});
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).createLayer("UILayerWebGL", "WebGL", {
    scaleResponse: 0,
    yResponse: 0,
    xResponse: 0,
    z: 35
});
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).e([
    (0, $a483b8029d48b758$export$2e2bcd8739ae039),
    "Color"
].join(", ")).attr({
    name: "Player 1",
    z: 0,
    playerNumber: 1
}).setName("Player 1").color("#FF0000");
(0, $6c1d2e7c1b3c8947$export$d3b63962eb93dd2c)();
(0, $4b79ca39d0e487fc$export$2e2bcd8739ae039).enterScene("Intro");
/**
 * Screen size management
 */ const $c320a3655ca1a5bc$var$scaleGame = ()=>{
    const stage = document.getElementById("cr-stage");
    const stageHeight = stage.clientHeight;
    const stageWidth = stage.clientWidth;
    const viewportHeight = window.innerHeight - 60;
    const viewportWidth = window.innerWidth;
    const ratioY = viewportHeight / stageHeight;
    const ratioX = viewportWidth / stageWidth;
    const ratio = Math.min(ratioY, ratioX);
    stage.style.transform = `scale(${ratio})`;
    const left = Math.max(0, (viewportWidth - stageWidth * ratio) * 0.5);
    stage.style.left = `${left}px`;
    const footer = document.getElementsByTagName("footer")[0];
    if (footer) footer.style.top = `${576 * ratio}px`;
};
window.addEventListener("resize", $c320a3655ca1a5bc$var$scaleGame);
window.addEventListener("load", ()=>{
    const stage = document.getElementById("cr-stage");
    stage.addEventListener("click", ()=>{
        stage.focus();
    });
});
// Handle the fullscreen button
const $c320a3655ca1a5bc$var$button = document.querySelector("button");
if ($c320a3655ca1a5bc$var$button) $c320a3655ca1a5bc$var$button.addEventListener("click", ()=>{
    const theater = document.getElementById("theater");
    theater.requestFullscreen();
    document.body.classList.add("fullscreen");
    $c320a3655ca1a5bc$var$scaleGame();
    document.addEventListener("fullscreenchange", ()=>{
        if (!document.fullscreenElement) {
            // exit fullscreen code here
            document.body.classList.remove("fullscreen");
            $c320a3655ca1a5bc$var$scaleGame();
        }
    });
});
setTimeout($c320a3655ca1a5bc$var$scaleGame, 0);


//# sourceMappingURL=index.f8bb2aa0.js.map
